(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Worker = exports.vizReducer = exports.utils = exports.selectDailyViewData = exports.containers = exports.components = exports.actions = undefined;
	
	var _CBGDateTraceLabel = __webpack_require__(1);
	
	var _CBGDateTraceLabel2 = _interopRequireDefault(_CBGDateTraceLabel);
	
	var _FocusedRangeLabels = __webpack_require__(15);
	
	var _FocusedRangeLabels2 = _interopRequireDefault(_FocusedRangeLabels);
	
	var _FocusedSMBGPointLabel = __webpack_require__(24);
	
	var _FocusedSMBGPointLabel2 = _interopRequireDefault(_FocusedSMBGPointLabel);
	
	var _RangeSelect = __webpack_require__(29);
	
	var _RangeSelect2 = _interopRequireDefault(_RangeSelect);
	
	var _TwoOptionToggle = __webpack_require__(43);
	
	var _TwoOptionToggle2 = _interopRequireDefault(_TwoOptionToggle);
	
	var _PumpSettingsContainer = __webpack_require__(46);
	
	var _PumpSettingsContainer2 = _interopRequireDefault(_PumpSettingsContainer);
	
	var _TrendsContainer = __webpack_require__(90);
	
	var _TrendsContainer2 = _interopRequireDefault(_TrendsContainer);
	
	var _reducers = __webpack_require__(168);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _worker = __webpack_require__(37);
	
	var actions = _interopRequireWildcard(_worker);
	
	var _index = __webpack_require__(173);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _data = __webpack_require__(175);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	__webpack_require__(177);
	
	// eslint-disable-next-line import/no-unresolved
	
	// a temporary(?) export to enable "snapshot"-ing of data from blip console
	
	
	var components = {
	  CBGDateTraceLabel: _CBGDateTraceLabel2.default,
	  FocusedRangeLabels: _FocusedRangeLabels2.default,
	  FocusedSMBGPointLabel: _FocusedSMBGPointLabel2.default,
	  RangeSelect: _RangeSelect2.default,
	  TwoOptionToggle: _TwoOptionToggle2.default
	};
	
	var containers = {
	  PumpSettingsContainer: _PumpSettingsContainer2.default,
	  TrendsContainer: _TrendsContainer2.default
	};
	
	var utils = {
	  reshapeBgClassesToBgBounds: _bloodglucose.reshapeBgClassesToBgBounds
	};
	
	exports.actions = actions;
	exports.components = components;
	exports.containers = containers;
	exports.selectDailyViewData = _data.selectDailyViewData;
	exports.utils = utils;
	exports.vizReducer = _reducers2.default;
	exports.Worker = _index2.default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(components, 'components', '/Users/clintbeacock/Sites/tidepool/viz/src/index.js');
	
	  __REACT_HOT_LOADER__.register(containers, 'containers', '/Users/clintbeacock/Sites/tidepool/viz/src/index.js');
	
	  __REACT_HOT_LOADER__.register(utils, 'utils', '/Users/clintbeacock/Sites/tidepool/viz/src/index.js');
	})();

	;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(3);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _d3TimeFormat = __webpack_require__(10);
	
	var _CBGDateTraceLabel = __webpack_require__(12);
	
	var _CBGDateTraceLabel2 = _interopRequireDefault(_CBGDateTraceLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CBGDateTraceLabel = function CBGDateTraceLabel(props) {
	  if (!props.focusedDateTrace) {
	    return null;
	  }
	  var _props$focusedDateTra = props.focusedDateTrace,
	      date = _props$focusedDateTra.data.localDate,
	      position = _props$focusedDateTra.position;
	
	  var formattedDate = (0, _d3TimeFormat.utcFormat)('%A, %B %-d')(Date.parse(date));
	  return _react2.default.createElement(
	    'div',
	    { className: _CBGDateTraceLabel2.default.container },
	    _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _CBGDateTraceLabel2.default.dateLabel },
	        formattedDate
	      ),
	      borderWidth: 0,
	      position: { left: position.left, top: 2.25 * position.yPositions.topMargin },
	      side: 'bottom',
	      tail: false
	    })
	  );
	};
	
	CBGDateTraceLabel.propTypes = {
	  focusedDateTrace: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      localDate: _react.PropTypes.string.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      yPositions: _react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        topMargin: _react.PropTypes.number.isRequired
	      })
	    })
	  })
	};
	
	var _default = CBGDateTraceLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTraceLabel, 'CBGDateTraceLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceLabel.js');
	})();

	;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Tooltip = __webpack_require__(5);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Tooltip = function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = { offset: { top: 0, left: 0 } };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculateOffset(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.calculateOffset(nextProps);
	    }
	  }, {
	    key: 'calculateOffset',
	    value: function calculateOffset(currentProps) {
	      var propOffset = currentProps.offset,
	          side = currentProps.side,
	          tail = currentProps.tail;
	
	      var offset = {};
	      var tooltipRect = this.element.getBoundingClientRect();
	      var horizontalOffset = propOffset.left != null ? propOffset.left : propOffset.horizontal || 0;
	      if (side === 'left') {
	        horizontalOffset = -horizontalOffset;
	      }
	      if (tail) {
	        var tailRect = this.tailElem.getBoundingClientRect();
	        var tailCenter = {
	          top: tailRect.top + tailRect.height / 2,
	          left: tailRect.left + tailRect.width / 2
	        };
	        offset.top = -tailCenter.top + tooltipRect.top + propOffset.top;
	        offset.left = -tailCenter.left + tooltipRect.left + horizontalOffset;
	      } else {
	        var leftOffset = void 0;
	        var topOffset = void 0;
	        switch (side) {
	          case 'top':
	            leftOffset = -tooltipRect.width / 2;
	            topOffset = -tooltipRect.height;
	            break;
	          case 'bottom':
	            leftOffset = -tooltipRect.width / 2;
	            topOffset = 0;
	            break;
	          case 'right':
	            leftOffset = 0;
	            topOffset = -tooltipRect.height / 2;
	            break;
	          case 'left':
	          default:
	            leftOffset = -tooltipRect.width;
	            topOffset = -tooltipRect.height / 2;
	        }
	        offset.top = topOffset + propOffset.top;
	        offset.left = leftOffset + horizontalOffset;
	      }
	
	      this.setState({ offset: offset });
	    }
	  }, {
	    key: 'renderTail',
	    value: function renderTail() {
	      var _this2 = this;
	
	      var backgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';
	      var _props = this.props,
	          tailWidth = _props.tailWidth,
	          tailHeight = _props.tailHeight,
	          borderWidth = _props.borderWidth,
	          borderColor = _props.borderColor,
	          side = _props.side;
	
	      var tailSide = side === 'left' ? 'right' : 'left';
	      var padding = 10;
	      var marginOuterValue = void 0;
	      var marginInnerValue = void 0;
	      if (tailSide === 'left') {
	        marginOuterValue = 'calc(-100% - 2 * ' + padding + 'px)';
	        marginInnerValue = 'calc(-100% - (2 * ' + padding + 'px - ' + (borderWidth + 1) + 'px))';
	      } else {
	        marginOuterValue = 'calc(' + padding + 'px + ' + borderWidth + 'px)';
	        marginInnerValue = padding - 1 + 'px';
	      }
	      var borderSide = tailSide === 'left' ? 'right' : 'left';
	      // The two child divs form the solid color tail and the border around it by layering
	      // on one another offset by the border width adjusted slightly for the angle
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', {
	          ref: function ref(_ref2) {
	            _this2.tailElem = _ref2;
	          },
	          className: _Tooltip2.default.tail,
	          style: _defineProperty({
	            marginTop: '-' + tailHeight + 'px',
	            marginLeft: marginOuterValue,
	            borderWidth: tailHeight + 'px ' + 2 * tailWidth + 'px'
	          }, 'border' + _lodash2.default.capitalize(borderSide) + 'Color', borderColor)
	        }),
	        _react2.default.createElement('div', {
	          className: _Tooltip2.default.tail,
	          style: _defineProperty({
	            marginTop: '-' + tailHeight + 'px',
	            marginLeft: marginInnerValue,
	            borderWidth: tailHeight + 'px ' + 2 * tailWidth + 'px'
	          }, 'border' + _lodash2.default.capitalize(borderSide) + 'Color', this.props.backgroundColor || backgroundColor)
	        })
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title) {
	      var _props2 = this.props,
	          tail = _props2.tail,
	          content = _props2.content;
	
	      var renderedTitle = null;
	      if (title) {
	        renderedTitle = _react2.default.createElement(
	          'div',
	          { className: _Tooltip2.default.title },
	          _react2.default.createElement(
	            'span',
	            null,
	            title
	          ),
	          tail && !content && this.renderTail(_Tooltip2.default.tooltipTitleBg)
	        );
	      }
	      return renderedTitle;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent(content) {
	      var renderedContent = null;
	      var tail = this.props.tail;
	
	      if (content) {
	        renderedContent = _react2.default.createElement(
	          'div',
	          { className: _Tooltip2.default.content },
	          _react2.default.createElement(
	            'span',
	            null,
	            content
	          ),
	          tail && this.renderTail()
	        );
	      }
	      return renderedContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          title = _props3.title,
	          content = _props3.content,
	          position = _props3.position,
	          backgroundColor = _props3.backgroundColor,
	          borderColor = _props3.borderColor,
	          borderWidth = _props3.borderWidth;
	      var offset = this.state.offset;
	
	      var top = position.top + offset.top;
	      var left = position.left + offset.left;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: _Tooltip2.default.tooltip,
	          style: { top: top, left: left, backgroundColor: backgroundColor, borderColor: borderColor, borderWidth: borderWidth + 'px' },
	          ref: function ref(_ref4) {
	            _this3.element = _ref4;
	          }
	        },
	        title && this.renderTitle(title),
	        content && this.renderContent(content)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.propTypes = {
	  title: _react.PropTypes.node,
	  content: _react.PropTypes.node,
	  position: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  offset: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number,
	    horizontal: _react.PropTypes.number
	  }).isRequired,
	  tail: _react.PropTypes.bool.isRequired,
	  side: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	  tailWidth: _react.PropTypes.number.isRequired,
	  tailHeight: _react.PropTypes.number.isRequired,
	  backgroundColor: _react.PropTypes.string,
	  borderColor: _react.PropTypes.string.isRequired,
	  borderWidth: _react.PropTypes.number.isRequired
	};
	
	Tooltip.defaultProps = {
	  tail: true,
	  side: 'left',
	  tailWidth: 7,
	  tailHeight: 8,
	  borderColor: 'black',
	  borderWidth: 2,
	  offset: { top: 0, left: 0 }
	};
	
	var _default = Tooltip;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Tooltip, 'Tooltip', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/tooltips/Tooltip.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/tooltips/Tooltip.js');
	})();

	;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = require("lodash");

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(6);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Tooltip.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Tooltip.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".Tooltip--tooltip--11k8T{display:block;background-color:#fff;border:solid;pointer-events:none;position:absolute;border-radius:4px;opacity:.75}.Tooltip--content--3kiTD{display:flex;align-items:center;justify-content:space-between;width:100%;padding:5px 10px;box-sizing:border-box}.Tooltip--content--3kiTD span{width:100%}.Tooltip--title--3FG33{background-color:var(--tooltip-title-bg)}.Tooltip--tail--3IQ2Y{width:0;height:0;border-style:solid;border-color:transparent;position:absolute}", ""]);
	
	// exports
	exports.locals = {
		"tooltipTitleBg": "var(--tooltip-title-bg)",
		"tooltip": "Tooltip--tooltip--11k8T " + __webpack_require__(8).locals["defaultSize"] + "",
		"content": "Tooltip--content--3kiTD",
		"title": "Tooltip--title--3FG33 " + __webpack_require__(8).locals["mediumContrastText"] + " Tooltip--content--3kiTD",
		"tail": "Tooltip--tail--3IQ2Y"
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".typography--whiteText--2eeXA{color:#fff;fill:#fff}.typography--boldText--osnHv{font-weight:700}.typography--lightText--3OxWt{font-weight:300}.typography--smallSize--3N0Zi{font-size:12px}.typography--axisSize--1AWL1{font-size:14px}.typography--largeSize--2187z{font-size:17px}.typography--defaultSize--vpvHG{font-size:14px}.typography--largeSize--2187z{font-size:16px}.typography--mediumContrastText--uXnbW{color:var(--text-medium-contrast);fill:var(--text-medium-contrast)}.typography--highContrastText--3ek29{color:var(--text-high-contrast);fill:var(--text-high-contrast)}.typography--noWrap--3endD{white-space:nowrap}.typography--svgMiddleAnchored--3FWrW{text-anchor:middle}.typography--svgRightAnchored--uk3Z8{text-anchor:end}.typography--svgStartAnchored--3vZKR{text-anchor:start}.typography--svgVerticalCentered--39MGn{dominant-baseline:central}", ""]);
	
	// exports
	exports.locals = {
		"whiteText": "typography--whiteText--2eeXA",
		"boldText": "typography--boldText--osnHv",
		"lightText": "typography--lightText--3OxWt",
		"smallSize": "typography--smallSize--3N0Zi",
		"axisSize": "typography--axisSize--1AWL1",
		"largeSize": "typography--largeSize--2187z",
		"defaultSize": "typography--defaultSize--vpvHG",
		"mediumContrastText": "typography--mediumContrastText--uXnbW",
		"highContrastText": "typography--highContrastText--3ek29",
		"noWrap": "typography--noWrap--3endD",
		"svgMiddleAnchored": "typography--svgMiddleAnchored--3FWrW",
		"svgRightAnchored": "typography--svgRightAnchored--uk3Z8",
		"svgStartAnchored": "typography--svgStartAnchored--3vZKR",
		"svgVerticalCentered": "typography--svgVerticalCentered--39MGn"
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(11)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = require("d3-time");

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(13);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(14), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".CBGDateTraceLabel--container--2soV7{top:0}", ""]);
	
	// exports
	exports.locals = {
		"container": "CBGDateTraceLabel--container--2soV7 " + __webpack_require__(14).locals["absolute"] + " " + __webpack_require__(14).locals["smallHorizontalPadding"] + "",
		"dateLabel": "CBGDateTraceLabel--dateLabel--1f7xM " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " " + __webpack_require__(8).locals["defaultSize"] + ""
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".layout--absolute--8t5yq{pointer-events:none;position:absolute}.layout--smallHorizontalPadding--aaAoX{padding:0 6px}", ""]);
	
	// exports
	exports.locals = {
		"absolute": "layout--absolute--8t5yq",
		"smallHorizontalPadding": "layout--smallHorizontalPadding--aaAoX"
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(3);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constants = __webpack_require__(16);
	
	var _format = __webpack_require__(17);
	
	var _datetime = __webpack_require__(20);
	
	var _FocusedRangeLabels = __webpack_require__(22);
	
	var _FocusedRangeLabels2 = _interopRequireDefault(_FocusedRangeLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FocusedRangeLabels = function FocusedRangeLabels(props) {
	  var focusedKeys = props.focusedKeys,
	      focusedRange = props.focusedRange,
	      focusedSlice = props.focusedSlice;
	
	  if (!(focusedRange || focusedKeys && focusedSlice)) {
	    return null;
	  }
	  // no range labels when focus is the median only on cbg version
	  if (focusedKeys && focusedKeys.length === 1) {
	    return null;
	  }
	
	  var bgPrefs = props.bgPrefs,
	      dataType = props.dataType;
	
	  var isCbg = dataType === 'cbg';
	  var dataBucket = isCbg ? 'focusedSlice' : 'focusedRange';
	  var _props$dataBucket = props[dataBucket],
	      data = _props$dataBucket.data,
	      position = _props$dataBucket.position;
	
	  var timeFrom = (0, _datetime.formatClocktimeFromMsPer24)(data.msFrom);
	  var timeTo = (0, _datetime.formatClocktimeFromMsPer24)(data.msTo);
	  var top = isCbg ? focusedKeys[1] : 'max';
	  var center = isCbg ? 'median' : 'mean';
	  var bottom = isCbg ? focusedKeys[0] : 'min';
	  var topPosition = {
	    top: position.yPositions[top],
	    left: position.left
	  };
	  var bottomPosition = {
	    top: position.yPositions[bottom],
	    left: position.left
	  };
	  var centerPosition = {
	    top: position.yPositions[center],
	    left: position.left
	  };
	  var centerSide = position.tooltipLeft ? 'left' : 'right';
	  return _react2.default.createElement(
	    'div',
	    { className: _FocusedRangeLabels2.default.container },
	    isCbg ? _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.timeLabel },
	        timeFrom,
	        ' - ',
	        timeTo
	      ),
	      borderWidth: 0,
	      position: { left: position.left, top: position.yPositions.topMargin },
	      side: 'bottom',
	      tail: false
	    }) : null,
	    _react2.default.createElement(_Tooltip2.default, {
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        (0, _format.formatBgValue)(data[top], bgPrefs, data.outOfRangeThresholds)
	      ),
	      backgroundColor: 'transparent',
	      borderColor: 'transparent',
	      offset: { left: 0, top: isCbg ? props.numberOffsets.top : 0 },
	      position: topPosition,
	      side: 'top',
	      tail: false
	    }),
	    isCbg ? null : _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.explainerText },
	        timeFrom,
	        ' - ',
	        timeTo
	      ),
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        'Average ' + (0, _format.formatBgValue)(data[center], bgPrefs, data.outOfRangeThresholds)
	      ),
	      offset: { top: 0, horizontal: props.numberOffsets.horizontal },
	      position: centerPosition,
	      side: centerSide
	    }),
	    _react2.default.createElement(_Tooltip2.default, {
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedRangeLabels2.default.number },
	        (0, _format.formatBgValue)(data[bottom], bgPrefs, data.outOfRangeThresholds)
	      ),
	      backgroundColor: 'transparent',
	      borderColor: 'transparent',
	      offset: { left: 0, top: isCbg ? props.numberOffsets.bottom : 0 },
	      position: bottomPosition,
	      side: 'bottom',
	      tail: false
	    })
	  );
	};
	
	FocusedRangeLabels.defaultProps = {
	  numberOffsets: {
	    bottom: -5,
	    horizontal: 10,
	    top: 5
	  }
	};
	
	FocusedRangeLabels.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  dataType: _react.PropTypes.oneOf(['cbg', 'smbg']).isRequired,
	  focusedKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  focusedRange: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      id: _react.PropTypes.string.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      msX: _react.PropTypes.number.isRequired,
	      msFrom: _react.PropTypes.number.isRequired,
	      msTo: _react.PropTypes.number.isRequired,
	      outOfRangeThresholds: _react.PropTypes.shape({
	        low: _react.PropTypes.number,
	        high: _react.PropTypes.number
	      })
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        max: _react.PropTypes.number.isRequired,
	        mean: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      id: _react.PropTypes.string.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      msFrom: _react.PropTypes.number.isRequired,
	      msTo: _react.PropTypes.number.isRequired,
	      msX: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      outOfRangeThresholds: _react.PropTypes.shape({
	        low: _react.PropTypes.number,
	        high: _react.PropTypes.number
	      }),
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired,
	        topMargin: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  numberOffsets: _react.PropTypes.shape({
	    bottom: _react.PropTypes.number.isRequired,
	    horizontal: _react.PropTypes.number.isRequired,
	    top: _react.PropTypes.number.isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react2.default.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired
	};
	
	var _default = FocusedRangeLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FocusedRangeLabels, 'FocusedRangeLabels', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/FocusedRangeLabels.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/FocusedRangeLabels.js');
	})();

	;

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var BG_HIGH = exports.BG_HIGH = 'High';
	var BG_LOW = exports.BG_LOW = 'Low';
	
	var STIFFNESS = 180;
	var DAMPING = 40;
	var PRECISION = 0.1;
	
	var springConfig = exports.springConfig = { stiffness: STIFFNESS, damping: DAMPING, precision: PRECISION };
	
	var MGDL_CLAMP_TOP = exports.MGDL_CLAMP_TOP = 400;
	var MMOLL_CLAMP_TOP = exports.MMOLL_CLAMP_TOP = 22.5;
	
	var MGDL_UNITS = exports.MGDL_UNITS = 'mg/dL';
	var MMOLL_UNITS = exports.MMOLL_UNITS = 'mmol/L';
	
	var ONE_WEEK = 7;
	var TWO_WEEKS = 14;
	var FOUR_WEEKS = 28;
	
	var trends = exports.trends = { extentSizes: { ONE_WEEK: ONE_WEEK, TWO_WEEKS: TWO_WEEKS, FOUR_WEEKS: FOUR_WEEKS } };
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BG_HIGH, 'BG_HIGH', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(BG_LOW, 'BG_LOW', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(STIFFNESS, 'STIFFNESS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(DAMPING, 'DAMPING', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(PRECISION, 'PRECISION', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(springConfig, 'springConfig', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MGDL_CLAMP_TOP, 'MGDL_CLAMP_TOP', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MMOLL_CLAMP_TOP, 'MMOLL_CLAMP_TOP', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MGDL_UNITS, 'MGDL_UNITS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(MMOLL_UNITS, 'MMOLL_UNITS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(ONE_WEEK, 'ONE_WEEK', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(TWO_WEEKS, 'TWO_WEEKS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(FOUR_WEEKS, 'FOUR_WEEKS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	
	  __REACT_HOT_LOADER__.register(trends, 'trends', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js');
	})();

	;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatBgValue = formatBgValue;
	exports.formatDecimalNumber = formatDecimalNumber;
	exports.formatPercentage = formatPercentage;
	exports.removeTrailingZeroes = removeTrailingZeroes;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Format = __webpack_require__(18);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _constants = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * formatBgValue
	 * @param {Number} val - integer or float blood glucose value in either mg/dL or mmol/L
	 * @param {Object} bgPrefs - object containing bgUnits String and bgBounds Object
	 * @param {Object} [outOfRangeThresholds] - optional thresholds for `low` and `high` values;
	 *                                          derived from annotations in PwD's data, so may not exist
	 *
	 * @return {String} formatted blood glucose value
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/*
	 * Guidelines for these utilities:
	 *
	 * 1. Only "workhorse" functions used in 2+ places should be here.
	 * 1a. A function used in multiple components for one view should live
	 * in view-specific utils: src/utils/[view]/format.js
	 * 1b. A function used in only one component should just be part of that component,
	 * potentially as a named export if tests are deemed important to have.
	 * 1c. This set of utilities is ONLY for NON-datetime related formatting. Any functions
	 * used for formatting dates and/or times should go in src/utils/datetime.js
	 *
	 * 2. Function naming scheme: the main verb here is `format`. Start all function names with that.
	 *
	 * 3. Function organizational scheme in this file and tests file: alphabetical plz
	 *
	 * 4. Try to be consistent in how params are used:
	 * (e.g., always pass in `bgPrefs`) rather than some (subset) of bgUnits and/or bgBounds
	 * and try to copy & paste JSDoc @param descriptions for common params.
	 *
	 */
	
	function formatBgValue(val, bgPrefs, outOfRangeThresholds) {
	  var units = _lodash2.default.get(bgPrefs, 'bgUnits', '');
	  if (!_lodash2.default.isEmpty(outOfRangeThresholds)) {
	    var lowThreshold = outOfRangeThresholds.low;
	    var highThreshold = outOfRangeThresholds.high;
	    if (units === _constants.MMOLL_UNITS) {
	      if (lowThreshold) {
	        lowThreshold = (0, _bloodglucose.convertToMmolL)(lowThreshold);
	      }
	      if (highThreshold) {
	        highThreshold = (0, _bloodglucose.convertToMmolL)(highThreshold);
	      }
	    }
	    if (lowThreshold && val < lowThreshold) {
	      return _constants.BG_LOW;
	    }
	    if (highThreshold && val > highThreshold) {
	      return _constants.BG_HIGH;
	    }
	  }
	  if (units === _constants.MMOLL_UNITS) {
	    return (0, _d3Format.format)('.1f')(val);
	  }
	  return (0, _d3Format.format)('d')(val);
	}
	
	/**
	 * formatDecimalNumber
	 * @param {Number} val - numeric value to format
	 * @param {Number} [places] - optional number of decimal places to display;
	 *                            if not provided, will display as integer (0 decimal places)
	 *
	 * @return {String} numeric value rounded to the desired number of decimal places
	 */
	function formatDecimalNumber(val, places) {
	  if (places === null || places === undefined) {
	    return (0, _d3Format.format)('d')(val);
	  }
	  return (0, _d3Format.format)('.' + places + 'f')(val);
	}
	
	/**
	 * formatPercentage
	 * @param {Number} val - raw decimal proportion, range of 0.0 to 1.0
	 *
	 * @return {String} percentage
	 */
	function formatPercentage(val) {
	  if (Number.isNaN(val)) {
	    return '--%';
	  }
	  return (0, _d3Format.format)('.0%')(val);
	}
	
	/**
	 * removeTrailingZeroes
	 * @param {String} - formatted decimal value, may have trailing zeroes
	 *
	 * @return {String} - formatted decimal value w/o trailing zero-indexes
	 */
	function removeTrailingZeroes(val) {
	  return val.replace(/\.0+$/, '');
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(formatBgValue, 'formatBgValue', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(formatDecimalNumber, 'formatDecimalNumber', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(formatPercentage, 'formatPercentage', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js');
	
	  __REACT_HOT_LOADER__.register(removeTrailingZeroes, 'removeTrailingZeroes', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js');
	})();

	;

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = require("d3-format");

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.classifyBgValue = classifyBgValue;
	exports.calcBgPercentInCategories = calcBgPercentInCategories;
	exports.convertToMmolL = convertToMmolL;
	exports.reshapeBgClassesToBgBounds = reshapeBgClassesToBgBounds;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * classifyBgValue
	 * @param {Object} bgBounds - object describing boundaries for blood glucose categories
	 * @param {Number} bgValue - integer or float blood glucose value in either mg/dL or mmol/L
	 * @param {String} classificationType - 'threeWay' or 'fiveWay'
	 *
	 * @return {String} bgClassification - low, target, high
	 */
	function classifyBgValue(bgBounds, bgValue) {
	  var classificationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'threeWay';
	
	  if (_lodash2.default.isEmpty(bgBounds) || !_lodash2.default.isNumber(_lodash2.default.get(bgBounds, 'targetLowerBound')) || !_lodash2.default.isNumber(_lodash2.default.get(bgBounds, 'targetUpperBound'))) {
	    throw new Error('You must provide a `bgBounds` object with a `targetLowerBound` and a `targetUpperBound`!');
	  }
	  if (!_lodash2.default.isNumber(bgValue) || !_lodash2.default.gt(bgValue, 0)) {
	    throw new Error('You must provide a positive, numerical blood glucose value to categorize!');
	  }
	  var veryLowThreshold = bgBounds.veryLowThreshold,
	      targetLowerBound = bgBounds.targetLowerBound,
	      targetUpperBound = bgBounds.targetUpperBound,
	      veryHighThreshold = bgBounds.veryHighThreshold;
	
	  if (classificationType === 'fiveWay') {
	    if (bgValue < veryLowThreshold) {
	      return 'veryLow';
	    } else if (bgValue >= veryLowThreshold && bgValue < targetLowerBound) {
	      return 'low';
	    } else if (bgValue > targetUpperBound && bgValue <= veryHighThreshold) {
	      return 'high';
	    } else if (bgValue > veryHighThreshold) {
	      return 'veryHigh';
	    }
	    return 'target';
	  }
	  if (bgValue < targetLowerBound) {
	    return 'low';
	  } else if (bgValue > targetUpperBound) {
	    return 'high';
	  }
	  return 'target';
	}
	
	/**
	 * calcBgPercentInCategories
	 * @param {Array} data - Array of Tidepool cbg or smbg data
	 * @param {Object} bgBounds - object describing boundaries for blood glucose categories
	 *
	 * @return {Object} bgPercentInCategories - object w/keys veryLow, low, target, high, veryHigh
	 *                  and 0.0 to 1.0 percentage values
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function calcBgPercentInCategories(data, bgBounds) {
	  var bgPercentInCategories = {};
	  var grouped = _lodash2.default.groupBy(data, function (d) {
	    return classifyBgValue(bgBounds, d.value, 'fiveWay');
	  });
	  _lodash2.default.each(['veryLow', 'low', 'target', 'high', 'veryHigh'], function (key) {
	    bgPercentInCategories[key] = (grouped[key] && grouped[key].length || 0) / data.length;
	  });
	  return bgPercentInCategories;
	}
	
	/**
	 * convertToMmolL
	 * @param {Number} bgVal - blood glucose value in mg/dL
	 *
	 * @return {Number} convertedBgVal - blood glucose value in mmol/L, unrounded
	 */
	function convertToMmolL(val) {
	  return val / 18.01559;
	}
	
	/**
	 * reshapeBgClassesToBgBounds
	 * @param {Object} bgPrefs - bgPrefs object from blip containing tideline-style bgClasses
	 *
	 * @return {Object} bgBounds - @tidepool/viz-style bgBounds
	 */
	function reshapeBgClassesToBgBounds(bgPrefs) {
	  var bgClasses = bgPrefs.bgClasses;
	
	  var bgBounds = {
	    veryHighThreshold: bgClasses.high.boundary,
	    targetUpperBound: bgClasses.target.boundary,
	    targetLowerBound: bgClasses.low.boundary,
	    veryLowThreshold: bgClasses['very-low'].boundary
	  };
	
	  return bgBounds;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(classifyBgValue, 'classifyBgValue', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(calcBgPercentInCategories, 'calcBgPercentInCategories', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(convertToMmolL, 'convertToMmolL', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js');
	
	  __REACT_HOT_LOADER__.register(reshapeBgClassesToBgBounds, 'reshapeBgClassesToBgBounds', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js');
	})();

	;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TWENTY_FOUR_HRS = exports.THREE_HRS = exports.ONE_HR = exports.THIRTY_MINS = undefined;
	exports.getTimezoneFromTimePrefs = getTimezoneFromTimePrefs;
	exports.formatBirthdate = formatBirthdate;
	exports.formatClocktimeFromMsPer24 = formatClocktimeFromMsPer24;
	exports.formatCurrentDate = formatCurrentDate;
	exports.formatDiagnosisDate = formatDiagnosisDate;
	exports.formatDuration = formatDuration;
	exports.formatLocalizedFromUTC = formatLocalizedFromUTC;
	exports.getHammertimeFromDatumWithTimePrefs = getHammertimeFromDatumWithTimePrefs;
	exports.getLocalizedCeiling = getLocalizedCeiling;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3TimeFormat = __webpack_require__(10);
	
	var _momentTimezone = __webpack_require__(21);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// using d3-time-format because time is time of data access in
	// user’s browser time, not PwD’s configured timezone
	var THIRTY_MINS = exports.THIRTY_MINS = 1800000; /*
	                                                  * == BSD2 LICENSE ==
	                                                  * Copyright (c) 2016, Tidepool Project
	                                                  *
	                                                  * This program is free software; you can redistribute it and/or modify it under
	                                                  * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                  * License as published by the Open Source Initiative at opensource.org.
	                                                  *
	                                                  * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                  * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                  * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                  *
	                                                  * You should have received a copy of the License along with this program; if
	                                                  * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                  * == BSD2 LICENSE ==
	                                                  */
	
	/*
	 * Guidelines for these utilities:
	 *
	 * 1. Only "workhorse" functions used in 2+ places should be here.
	 * 1a. A function used in multiple components for one view should live
	 * in view-specific utils: src/utils/[view]/datetime.js
	 * 1b. A function used in only one component should just be part of that component,
	 * potentially as a named export if tests are deemed important to have.
	 *
	 * 2. Function naming scheme: the two main verbs here are `get` and `format`.
	 * 2a. If the function returns any kind of datetime (JavaScript Date, hammertime, ISO 8601 String),
	 * then the function name should start with `get`.
	 * 2b. If the function returns a _formatted_ String that will be **surfaced to the end user**,
	 * then the function name should start with `format`.
	 *
	 * 3. Function organizational scheme in this file and tests file: alphabetical plz, unless ESLint
	 * complains about an undefined (e.g., getTimezoneFromTimePrefs must be at the top).
	 *
	 * 4. Try to be consistent in how params are used:
	 * (e.g., always pass in `timePrefs`) rather than a named timezone
	 * and try to copy & paste JSDoc @param descriptions for common params.
	 *
	 */
	
	var ONE_HR = exports.ONE_HR = 3600000;
	var THREE_HRS = exports.THREE_HRS = 10800000;
	var TWENTY_FOUR_HRS = exports.TWENTY_FOUR_HRS = 86400000;
	
	/**
	 * getTimezoneFromTimePrefs
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {String} timezoneName
	 */
	function getTimezoneFromTimePrefs(timePrefs) {
	  var timezoneAware = timePrefs.timezoneAware,
	      timezoneName = timePrefs.timezoneName;
	
	  var timezone = 'UTC';
	  if (timezoneAware) {
	    timezone = timezoneName || 'UTC';
	  }
	  return timezone;
	}
	
	/**
	 * formatBirthdate
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} formatted birthdate, e.g., 'Jul 4, 1975'; empty String if none found
	 */
	function formatBirthdate(patient) {
	  var bday = _lodash2.default.get(patient, ['profile', 'patient', 'birthday'], '');
	  if (bday) {
	    return (0, _d3TimeFormat.utcFormat)('%b %-d, %Y')(Date.parse(bday));
	  }
	  return '';
	}
	
	/**
	 * formatClocktimeFromMsPer24
	 * @param {Number} duration - positive integer representing a time of day
	 *                            in milliseconds within a 24-hr day
	 * @param {String} [format] - optional moment display format string; default is 'h:mm a'
	 *
	 * @return {String} formatted clocktime, e.g., '12:05 pm'
	 */
	function formatClocktimeFromMsPer24(milliseconds) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'h:mm a';
	
	  if (_lodash2.default.isNull(milliseconds) || _lodash2.default.isUndefined(milliseconds) || milliseconds < 0 || milliseconds > TWENTY_FOUR_HRS || milliseconds instanceof Date) {
	    throw new Error('First argument must be a value in milliseconds per twenty-four hour day!');
	  }
	  return _momentTimezone2.default.utc(milliseconds).format(format);
	}
	
	/**
	 * formatCurrentDate
	 * @return {String} formatted current date, e.g., 'Jul 4, 2017';
	 */
	function formatCurrentDate() {
	  return (0, _d3TimeFormat.timeFormat)('%b %-d, %Y')(new Date());
	}
	
	/**
	 * formatDiagnosisDate
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} formatted diagnosis date, e.g., 'Jul 4, 1975'; empty String if none found
	 */
	function formatDiagnosisDate(patient) {
	  var diagnosis = _lodash2.default.get(patient, ['profile', 'patient', 'diagnosisDate'], '');
	  if (diagnosis) {
	    return (0, _d3TimeFormat.utcFormat)('%b %-d, %Y')(Date.parse(diagnosis));
	  }
	  return '';
	}
	
	/**
	 * formatDuration
	 * @param {Number} duration - positive integer duration in milliseconds
	 *
	 * @return {String} formatted duration, e.g., '1¼ hr'
	 */
	function formatDuration(duration) {
	  var momentDuration = _momentTimezone2.default.duration(duration);
	  var QUARTER = '¼';
	  var THIRD = '⅓';
	  var HALF = '½';
	  var TWO_THIRDS = '⅔';
	  var THREE_QUARTERS = '¾';
	  var hours = momentDuration.hours();
	  var minutes = momentDuration.minutes();
	
	  if (hours !== 0) {
	    var suffix = hours === 1 ? 'hr' : 'hrs';
	    switch (minutes) {
	      case 0:
	        return hours + ' ' + suffix;
	      case 15:
	        return '' + hours + QUARTER + ' ' + suffix;
	      case 20:
	        return '' + hours + THIRD + ' ' + suffix;
	      case 30:
	        return '' + hours + HALF + ' ' + suffix;
	      case 40:
	        return '' + hours + TWO_THIRDS + ' ' + suffix;
	      case 45:
	        return '' + hours + THREE_QUARTERS + ' ' + suffix;
	      default:
	        return hours + ' ' + suffix + ' ' + minutes + ' min';
	    }
	  } else {
	    return minutes + ' min';
	  }
	}
	
	/**
	 * formatLocalizedFromUTC
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 * @param  {String} [format] - optional moment display format string; default is 'dddd, MMMM D'
	 *
	 * @return {String} formatted datetime, e.g., 'Sunday, January 1'
	 */
	function formatLocalizedFromUTC(utc, timePrefs) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dddd, MMMM D';
	
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = getTimezoneFromTimePrefs(timePrefs);
	  return _momentTimezone2.default.utc(utc).tz(timezone).format(format);
	}
	
	/**
	 * getHammertimeFromDatumWithTimePrefs
	 * @param {Object} datum - a Tidepool datum with a time (required) and deviceTime (optional)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Number} Integer hammertime (i.e., UTC time in milliseconds)
	 */
	function getHammertimeFromDatumWithTimePrefs(datum, timePrefs) {
	  var hammertime = void 0;
	  if (timePrefs.timezoneAware) {
	    if (!_lodash2.default.isUndefined(datum.time)) {
	      hammertime = Date.parse(datum.time);
	    } else {
	      hammertime = null;
	    }
	  } else {
	    if (!_lodash2.default.isUndefined(datum.deviceTime)) {
	      hammertime = Date.parse(datum.deviceTime);
	    } else {
	      hammertime = null;
	    }
	  }
	  if (_lodash2.default.isNaN(hammertime)) {
	    throw new Error('Check your input datum; could not parse `time` or `deviceTime` with Date.parse.');
	  }
	  return hammertime;
	}
	
	/**
	 * getLocalizedCeiling
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Object} a JavaScript Date, the closest (future) midnight according to timePrefs;
	 *                  if utc is already local midnight, returns utc
	 */
	function getLocalizedCeiling(utc, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = getTimezoneFromTimePrefs(timePrefs);
	  var startOfDay = _momentTimezone2.default.utc(utc).tz(timezone).startOf('day');
	
	  var utcHammertime = typeof utc === 'string' ? Date.parse(utc) : utc;
	  if (startOfDay.valueOf() === utcHammertime) {
	    return startOfDay.toDate();
	  }
	  return startOfDay.add(1, 'day').toDate();
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(THIRTY_MINS, 'THIRTY_MINS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(ONE_HR, 'ONE_HR', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(THREE_HRS, 'THREE_HRS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(TWENTY_FOUR_HRS, 'TWENTY_FOUR_HRS', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getTimezoneFromTimePrefs, 'getTimezoneFromTimePrefs', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatBirthdate, 'formatBirthdate', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatClocktimeFromMsPer24, 'formatClocktimeFromMsPer24', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatCurrentDate, 'formatCurrentDate', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatDiagnosisDate, 'formatDiagnosisDate', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatDuration, 'formatDuration', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(formatLocalizedFromUTC, 'formatLocalizedFromUTC', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getHammertimeFromDatumWithTimePrefs, 'getHammertimeFromDatumWithTimePrefs', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedCeiling, 'getLocalizedCeiling', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js');
	})();

	;

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = require("moment-timezone");

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(23);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedRangeLabels.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedRangeLabels.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(14), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".FocusedRangeLabels--container--3xGNN{top:0}.FocusedRangeLabels--explainerText--LaA5m{display:block}", ""]);
	
	// exports
	exports.locals = {
		"container": "FocusedRangeLabels--container--3xGNN " + __webpack_require__(14).locals["absolute"] + " " + __webpack_require__(14).locals["smallHorizontalPadding"] + "",
		"number": "FocusedRangeLabels--number--2kw_y " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " " + __webpack_require__(8).locals["largeSize"] + "",
		"explainerText": "FocusedRangeLabels--explainerText--LaA5m " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + "",
		"timeLabel": "FocusedRangeLabels--timeLabel--1DqNJ " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " " + __webpack_require__(8).locals["defaultSize"] + ""
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Tooltip = __webpack_require__(3);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _constants = __webpack_require__(16);
	
	var _format = __webpack_require__(17);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	var _FocusedSMBGPointLabel = __webpack_require__(27);
	
	var _FocusedSMBGPointLabel2 = _interopRequireDefault(_FocusedSMBGPointLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	// tooltip offsets
	var SIMPLE_VALUE_TOP_OFFSET = 10;
	var SIMPLE_DAY_TOP_OFFSET = 10;
	var SIMPLE_DAY_HORIZ_OFFSET = 30;
	var DETAILED_DAY_HORIZ_OFFSET = 10;
	
	var FocusedSMBGPointLabel = function FocusedSMBGPointLabel(props) {
	  var focusedPoint = props.focusedPoint;
	
	  if (!focusedPoint) {
	    return null;
	  }
	
	  function getOutOfRangeThreshold(smbg) {
	    var outOfRangeAnnotation = _lodash2.default.find(smbg.annotations || [], function (annotation) {
	      return annotation.code === 'bg/out-of-range';
	    });
	    return outOfRangeAnnotation ? _defineProperty({}, outOfRangeAnnotation.value, outOfRangeAnnotation.threshold) : null;
	  }
	
	  var bgPrefs = props.bgPrefs,
	      _props$focusedPoint = props.focusedPoint,
	      datum = _props$focusedPoint.datum,
	      position = _props$focusedPoint.position,
	      allSmbgsOnDate = _props$focusedPoint.allSmbgsOnDate,
	      allPositions = _props$focusedPoint.allPositions,
	      timePrefs = props.timePrefs,
	      lines = props.lines;
	
	
	  var hammertime = (0, _datetime.getHammertimeFromDatumWithTimePrefs)(datum, timePrefs);
	  var lineDate = (0, _datetime.formatLocalizedFromUTC)(hammertime, timePrefs);
	  var shortDate = (0, _datetime.formatLocalizedFromUTC)(hammertime, timePrefs, 'MMM D');
	  var side = position.tooltipLeft ? 'left' : 'right';
	  if (!lines) {
	    var focusedPointIndex = _lodash2.default.indexOf(allSmbgsOnDate, datum);
	    _lodash2.default.pullAt(allSmbgsOnDate, focusedPointIndex);
	    _lodash2.default.pullAt(allPositions, focusedPointIndex);
	  }
	  var pointTooltips = _lodash2.default.map(allSmbgsOnDate, function (smbg, i) {
	    return _react2.default.createElement(_Tooltip2.default, {
	      key: i,
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.number },
	        (0, _format.formatBgValue)(smbg.value, bgPrefs, getOutOfRangeThreshold(smbg))
	      ),
	      position: allPositions[i],
	      side: 'bottom',
	      tail: false,
	      offset: { top: SIMPLE_VALUE_TOP_OFFSET, left: 0 }
	    });
	  });
	  var focusedTooltip = void 0;
	  if (lines) {
	    focusedTooltip = _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.explainerText },
	        lineDate
	      ),
	      position: position,
	      side: side,
	      offset: {
	        top: SIMPLE_DAY_TOP_OFFSET,
	        horizontal: SIMPLE_DAY_HORIZ_OFFSET
	      }
	    });
	  } else {
	    focusedTooltip = _react2.default.createElement(_Tooltip2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.tipWrapper },
	        _react2.default.createElement(
	          'span',
	          { className: _FocusedSMBGPointLabel2.default.shortDate },
	          shortDate
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _FocusedSMBGPointLabel2.default.shortTime },
	          (0, _datetime.formatClocktimeFromMsPer24)(datum.msPer24)
	        )
	      ),
	      content: _react2.default.createElement(
	        'span',
	        { className: _FocusedSMBGPointLabel2.default.tipWrapper },
	        _react2.default.createElement(
	          'span',
	          { className: _FocusedSMBGPointLabel2.default.detailNumber },
	          (0, _format.formatBgValue)(datum.value, bgPrefs, getOutOfRangeThreshold(datum))
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _FocusedSMBGPointLabel2.default.subType },
	          (0, _data.categorizeSmbgSubtype)(datum)
	        )
	      ),
	      position: position,
	      side: side,
	      offset: {
	        top: 0,
	        horizontal: DETAILED_DAY_HORIZ_OFFSET
	      }
	    });
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: _FocusedSMBGPointLabel2.default.container },
	    pointTooltips,
	    focusedTooltip
	  );
	};
	
	FocusedSMBGPointLabel.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  focusedPoint: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      deviceTime: _react.PropTypes.string,
	      msPer24: _react.PropTypes.number.isRequired,
	      subType: _react.PropTypes.string,
	      time: _react.PropTypes.string,
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  grouped: _react2.default.PropTypes.bool.isRequired,
	  lines: _react2.default.PropTypes.bool.isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react2.default.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired
	};
	
	var _default = FocusedSMBGPointLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SIMPLE_VALUE_TOP_OFFSET, 'SIMPLE_VALUE_TOP_OFFSET', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(SIMPLE_DAY_TOP_OFFSET, 'SIMPLE_DAY_TOP_OFFSET', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(SIMPLE_DAY_HORIZ_OFFSET, 'SIMPLE_DAY_HORIZ_OFFSET', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(DETAILED_DAY_HORIZ_OFFSET, 'DETAILED_DAY_HORIZ_OFFSET', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(FocusedSMBGPointLabel, 'FocusedSMBGPointLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/FocusedSMBGPointLabel.js');
	})();

	;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.determineRangeBoundaries = determineRangeBoundaries;
	exports.findBinForTimeOfDay = findBinForTimeOfDay;
	exports.findDatesIntersectingWithCbgSliceSegment = findDatesIntersectingWithCbgSliceSegment;
	exports.findOutOfRangeAnnotations = findOutOfRangeAnnotations;
	exports.calculateCbgStatsForBin = calculateCbgStatsForBin;
	exports.calculateSmbgStatsForBin = calculateSmbgStatsForBin;
	exports.categorizeSmbgSubtype = categorizeSmbgSubtype;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(26);
	
	var _datetime = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * determineRangeBoundaries
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} highAndLowThresholds - Object with high and low keys
	 */
	function determineRangeBoundaries(outOfRange) {
	  var lowThresholds = _lodash2.default.filter(outOfRange, { value: 'low' });
	  var highThresholds = _lodash2.default.filter(outOfRange, { value: 'high' });
	  var boundaries = {};
	  if (!_lodash2.default.isEmpty(lowThresholds)) {
	    // if there is data from multiple devices present with different thresholds
	    // we want to use the more conservative (= higher) threshold for lows
	    boundaries.low = (0, _d3Array.max)(lowThresholds, function (d) {
	      return d.threshold;
	    });
	  }
	  if (!_lodash2.default.isEmpty(highThresholds)) {
	    // if there is data from multiple devices present with different thresholds
	    // we want to use the more conservative (= lower) threshold for highs
	    boundaries.high = (0, _d3Array.min)(highThresholds, function (d) {
	      return d.threshold;
	    });
	  }
	  return boundaries;
	}
	
	/**
	 * findBinForTimeOfDay
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Number} msPer24 - natural number milliseconds into a twenty-four hour day
	 *
	 * @return {Number} bin
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function findBinForTimeOfDay(binSize, msPer24) {
	  if (msPer24 < 0 || msPer24 >= _datetime.TWENTY_FOUR_HRS) {
	    throw new Error('`msPer24` < 0 or >= 86400000 is invalid!');
	  }
	
	  return Math.floor(msPer24 / binSize) * binSize + binSize / 2;
	}
	/**
	 * findDatesIntersectingWithCbgSliceSegment
	 * @param {Array} cbgData - Array of Tidepool cbg events
	 * @param {Object} focusedSlice - the current focused cbg slice/segment
	 * @param {Array} focusedSliceKeys - Array of 2 keys representing
	 *                                   the top & bottom of focused slice segment
	 *
	 * @return {Array} dates - Array of String dates in YYYY-MM-DD format
	 */
	function findDatesIntersectingWithCbgSliceSegment(cbgData, focusedSlice, focusedSliceKeys) {
	  var data = focusedSlice.data;
	
	  return _lodash2.default.uniq(_lodash2.default.pluck(_lodash2.default.filter(cbgData, function (d) {
	    if (d.msPer24 >= data.msFrom && d.msPer24 < data.msTo) {
	      return d.value >= data[focusedSliceKeys[0]] && d.value <= data[focusedSliceKeys[1]];
	    }
	    return false;
	  }), 'localDate')).sort();
	}
	
	/**
	 * findOutOfRangeAnnotations
	 * @param {Array} data - Array of `cbg` or `smbg` events
	 *
	 * @return {Array} thresholds - Array of objects with unique `threshold`
	 *                              (and `value` of 'low' or 'high')
	 */
	function findOutOfRangeAnnotations(data) {
	  var isOutOfRangeAnnotation = function isOutOfRangeAnnotation(annotation) {
	    return annotation.code === 'bg/out-of-range';
	  };
	  var eventsAnnotatedAsOutOfRange = _lodash2.default.filter(data, function (d) {
	    return _lodash2.default.some(d.annotations || [], isOutOfRangeAnnotation);
	  });
	  var annotations = _lodash2.default.map(eventsAnnotatedAsOutOfRange, function (d) {
	    return _lodash2.default.pick(_lodash2.default.find(d.annotations || [], isOutOfRangeAnnotation), ['threshold', 'value']);
	  });
	  // the numerical `threshold` is our determiner of uniqueness
	  return _lodash2.default.uniq(annotations, function (d) {
	    return d.threshold;
	  });
	}
	
	/**
	 * calculateCbgStatsForBin
	 * @param {String} binKey - String of natural number milliseconds bin
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Array} data - Array of cbg values in mg/dL or mmol/L
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} calculatedCbgStats
	 */
	function calculateCbgStatsForBin(binKey, binSize, data, outOfRange) {
	  var sorted = _lodash2.default.sortBy(data, function (d) {
	    return d;
	  });
	  var centerOfBinMs = parseInt(binKey, 10);
	  var stats = {
	    id: binKey,
	    min: (0, _d3Array.min)(sorted),
	    tenthQuantile: (0, _d3Array.quantile)(sorted, 0.1),
	    firstQuartile: (0, _d3Array.quantile)(sorted, 0.25),
	    median: (0, _d3Array.median)(sorted),
	    thirdQuartile: (0, _d3Array.quantile)(sorted, 0.75),
	    ninetiethQuantile: (0, _d3Array.quantile)(sorted, 0.9),
	    max: (0, _d3Array.max)(sorted),
	    msX: centerOfBinMs,
	    msFrom: centerOfBinMs - binSize / 2,
	    msTo: centerOfBinMs + binSize / 2
	  };
	  if (!_lodash2.default.isEmpty(outOfRange)) {
	    var thresholds = determineRangeBoundaries(outOfRange);
	    stats.outOfRangeThresholds = thresholds;
	  }
	  return stats;
	}
	
	/**
	 * calculateSmbgStatsForBin
	 * @param {String} binKey - String of natural number milliseconds bin
	 * @param {Number} binSize - natural number duration in milliseconds
	 * @param {Array} data - Array of smbg values in mg/dL or mmol/L
	 * @param {Array} outOfRange - Array of out-of-range objects w/threshold and value
	 *
	 * @return {Object} calculatedSmbgStats
	 */
	function calculateSmbgStatsForBin(binKey, binSize, data, outOfRange) {
	  var centerOfBinMs = parseInt(binKey, 10);
	  var stats = {
	    id: binKey,
	    min: (0, _d3Array.min)(data),
	    mean: (0, _d3Array.mean)(data),
	    max: (0, _d3Array.max)(data),
	    msX: centerOfBinMs,
	    msFrom: centerOfBinMs - binSize / 2,
	    msTo: centerOfBinMs + binSize / 2
	  };
	  if (!_lodash2.default.isEmpty(outOfRange)) {
	    var thresholds = determineRangeBoundaries(outOfRange);
	    stats.outOfRangeThresholds = thresholds;
	  }
	  return stats;
	}
	
	/**
	 * Returns a category based on SMBG subType
	 * @param  {Object} data smbg
	 * @return {String}      category name for subType
	 */
	function categorizeSmbgSubtype(data) {
	  var category = void 0;
	  if (data.subType && data.subType === 'manual') {
	    category = data.subType;
	  } else {
	    category = 'meter';
	  }
	  return category;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(determineRangeBoundaries, 'determineRangeBoundaries', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findBinForTimeOfDay, 'findBinForTimeOfDay', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findDatesIntersectingWithCbgSliceSegment, 'findDatesIntersectingWithCbgSliceSegment', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(findOutOfRangeAnnotations, 'findOutOfRangeAnnotations', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(calculateCbgStatsForBin, 'calculateCbgStatsForBin', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(calculateSmbgStatsForBin, 'calculateSmbgStatsForBin', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	
	  __REACT_HOT_LOADER__.register(categorizeSmbgSubtype, 'categorizeSmbgSubtype', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/trends/data.js');
	})();

	;

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = require("d3-array");

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(28);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedSMBGPointLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedSMBGPointLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(14), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".FocusedSMBGPointLabel--container--tKvDB{top:0}.FocusedSMBGPointLabel--explainerText--I3VOk{display:block;padding:5px}.FocusedSMBGPointLabel--detailNumber--1s0C_{text-align:center}.FocusedSMBGPointLabel--subType--3c9Mz{font-style:italic}.FocusedSMBGPointLabel--tipWrapper--3Im_f{display:flex;justify-content:space-around;flex-wrap:nowrap}", ""]);
	
	// exports
	exports.locals = {
		"container": "FocusedSMBGPointLabel--container--tKvDB " + __webpack_require__(14).locals["absolute"] + " " + __webpack_require__(14).locals["smallHorizontalPadding"] + "",
		"number": "FocusedSMBGPointLabel--number--W173a " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " " + __webpack_require__(8).locals["largeSize"] + "",
		"explainerText": "FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + "",
		"detailNumber": "FocusedSMBGPointLabel--detailNumber--1s0C_ FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " FocusedSMBGPointLabel--number--W173a " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + " " + __webpack_require__(8).locals["largeSize"] + "",
		"shortDate": "FocusedSMBGPointLabel--shortDate--3moKf FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + "",
		"shortTime": "FocusedSMBGPointLabel--shortTime--Zk-rJ FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + "",
		"subType": "FocusedSMBGPointLabel--subType--3c9Mz FocusedSMBGPointLabel--explainerText--I3VOk " + __webpack_require__(8).locals["highContrastText"] + " " + __webpack_require__(8).locals["noWrap"] + "",
		"tipWrapper": "FocusedSMBGPointLabel--tipWrapper--3Im_f"
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RangeSelect = undefined;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _actions = __webpack_require__(32);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _LabeledCheckbox = __webpack_require__(38);
	
	var _LabeledCheckbox2 = _interopRequireDefault(_LabeledCheckbox);
	
	var _RangeSelect = __webpack_require__(41);
	
	var _RangeSelect2 = _interopRequireDefault(_RangeSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RangeSelect = exports.RangeSelect = function RangeSelect(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _RangeSelect2.default.container },
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg100Enabled,
	      name: 'hundred',
	      label: '100% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '100'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '100')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg80Enabled,
	      name: 'eighty',
	      label: '80% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '80'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '80')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbg50Enabled,
	      name: 'fifty',
	      label: '50% of Readings',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, '50'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, '50')
	    }),
	    _react2.default.createElement(_LabeledCheckbox2.default, {
	      checked: props.displayFlags.cbgMedianEnabled,
	      name: 'median',
	      label: 'Median',
	      onFn: _lodash2.default.partial(props.turnOnCbgRange, 'median'),
	      offFn: _lodash2.default.partial(props.turnOffCbgRange, 'median')
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	RangeSelect.propTypes = {
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  turnOnCbgRange: _react.PropTypes.func.isRequired,
	  turnOffCbgRange: _react.PropTypes.func.isRequired,
	  currentPatientInViewId: _react.PropTypes.string.isRequired
	};
	
	function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    turnOnCbgRange: _lodash2.default.partial(actions.turnOnCbgRange, ownProps.currentPatientInViewId),
	    turnOffCbgRange: _lodash2.default.partial(actions.turnOffCbgRange, ownProps.currentPatientInViewId)
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(RangeSelect);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RangeSelect, 'RangeSelect', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/RangeSelect.js');
	})();

	;

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = require("react-redux");

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = require("redux");

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _thunks = __webpack_require__(33);
	
	Object.keys(_thunks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _thunks[key];
	    }
	  });
	});
	
	var _trends = __webpack_require__(34);
	
	Object.keys(_trends).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _trends[key];
	    }
	  });
	});
	
	var _settings = __webpack_require__(36);
	
	Object.keys(_settings).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _settings[key];
	    }
	  });
	});
	
	var _worker = __webpack_require__(37);
	
	Object.keys(_worker).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _worker[key];
	    }
	  });
	});
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */

	;

	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	})();

	;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.delayShowCbgTracesOnFocus = delayShowCbgTracesOnFocus;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _trends = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function delayShowCbgTracesOnFocus(userId, sliceData, slicePosition, focusedKeys) {
	  return function (dispatch, getState) {
	    dispatch((0, _trends.focusTrendsCbgSlice)(userId, sliceData, slicePosition, focusedKeys));
	    setTimeout(function () {
	      var currentTrendsStateForUser = _lodash2.default.get(getState(), ['viz', 'trends', userId], {});
	      var currentFocusedSlice = currentTrendsStateForUser.focusedCbgSlice,
	          currentFocusedKeys = currentTrendsStateForUser.focusedCbgSliceKeys;
	      var sliceId = sliceData.id;
	
	      if (sliceId === _lodash2.default.get(currentFocusedSlice, ['data', 'id']) && _lodash2.default.isEqual(focusedKeys, currentFocusedKeys)) {
	        dispatch((0, _trends.showCbgDateTraces)(userId));
	      }
	    }, 250);
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(delayShowCbgTracesOnFocus, 'delayShowCbgTracesOnFocus', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/thunks.js');
	})();

	;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusTrendsCbgDateTrace = focusTrendsCbgDateTrace;
	exports.focusTrendsCbgSlice = focusTrendsCbgSlice;
	exports.focusTrendsSmbg = focusTrendsSmbg;
	exports.focusTrendsSmbgRangeAvg = focusTrendsSmbgRangeAvg;
	exports.markTrendsViewed = markTrendsViewed;
	exports.showCbgDateTraces = showCbgDateTraces;
	exports.turnOffCbgRange = turnOffCbgRange;
	exports.turnOnCbgRange = turnOnCbgRange;
	exports.unfocusTrendsCbgDateTrace = unfocusTrendsCbgDateTrace;
	exports.unfocusTrendsCbgSlice = unfocusTrendsCbgSlice;
	exports.unfocusTrendsSmbg = unfocusTrendsSmbg;
	exports.unfocusTrendsSmbgRangeAvg = unfocusTrendsSmbgRangeAvg;
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function focusTrendsCbgDateTrace(userId, cbgDatum, cbgPosition) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_CBG_DATE_TRACE,
	    payload: { userId: userId, cbgDatum: cbgDatum, cbgPosition: cbgPosition }
	  };
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2016, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	function focusTrendsCbgSlice(userId, sliceData, slicePosition, focusedKeys) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_CBG_SLICE,
	    payload: { focusedKeys: focusedKeys, sliceData: sliceData, slicePosition: slicePosition, userId: userId }
	  };
	}
	
	function focusTrendsSmbg(userId, smbgDatum, smbgPosition, allSmbgsOnDate, allPositions, date) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_SMBG,
	    payload: { userId: userId, smbgDatum: smbgDatum, smbgPosition: smbgPosition, allSmbgsOnDate: allSmbgsOnDate, allPositions: allPositions, date: date }
	  };
	}
	
	function focusTrendsSmbgRangeAvg(userId, rangeAvgData, rangeAvgPosition) {
	  return {
	    type: actionTypes.FOCUS_TRENDS_SMBG_RANGE_AVG,
	    payload: { rangeAvgData: rangeAvgData, rangeAvgPosition: rangeAvgPosition, userId: userId }
	  };
	}
	
	function markTrendsViewed(userId) {
	  return {
	    type: actionTypes.MARK_TRENDS_VIEWED,
	    payload: { userId: userId }
	  };
	}
	
	function showCbgDateTraces(userId) {
	  return {
	    type: actionTypes.SHOW_CBG_DATE_TRACES,
	    payload: { userId: userId }
	  };
	}
	
	function turnOffCbgRange(userId, range) {
	  return {
	    type: actionTypes.TURN_OFF_CBG_RANGE,
	    payload: { userId: userId, range: range }
	  };
	}
	
	function turnOnCbgRange(userId, range) {
	  return {
	    type: actionTypes.TURN_ON_CBG_RANGE,
	    payload: { userId: userId, range: range }
	  };
	}
	
	function unfocusTrendsCbgDateTrace(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_CBG_DATE_TRACE,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsCbgSlice(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_CBG_SLICE,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsSmbg(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_SMBG,
	    payload: { userId: userId }
	  };
	}
	
	function unfocusTrendsSmbgRangeAvg(userId) {
	  return {
	    type: actionTypes.UNFOCUS_TRENDS_SMBG_RANGE_AVG,
	    payload: { userId: userId }
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(focusTrendsCbgDateTrace, 'focusTrendsCbgDateTrace', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsCbgSlice, 'focusTrendsCbgSlice', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsSmbg, 'focusTrendsSmbg', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(focusTrendsSmbgRangeAvg, 'focusTrendsSmbgRangeAvg', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(markTrendsViewed, 'markTrendsViewed', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(showCbgDateTraces, 'showCbgDateTraces', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(turnOffCbgRange, 'turnOffCbgRange', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(turnOnCbgRange, 'turnOnCbgRange', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsCbgDateTrace, 'unfocusTrendsCbgDateTrace', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsCbgSlice, 'unfocusTrendsCbgSlice', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsSmbg, 'unfocusTrendsSmbg', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	
	  __REACT_HOT_LOADER__.register(unfocusTrendsSmbgRangeAvg, 'unfocusTrendsSmbgRangeAvg', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/trends.js');
	})();

	;

/***/ },
/* 35 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FOCUS_TRENDS_CBG_DATE_TRACE = exports.FOCUS_TRENDS_CBG_DATE_TRACE = 'FOCUS_TRENDS_CBG_DATE_TRACE';
	var FOCUS_TRENDS_CBG_SLICE = exports.FOCUS_TRENDS_CBG_SLICE = 'FOCUS_TRENDS_CBG_SLICE';
	var FOCUS_TRENDS_SMBG = exports.FOCUS_TRENDS_SMBG = 'FOCUS_TRENDS_SMBG';
	var FOCUS_TRENDS_SMBG_RANGE_AVG = exports.FOCUS_TRENDS_SMBG_RANGE_AVG = 'FOCUS_TRENDS_SMBG_RANGE_AVG';
	
	var MARK_SETTINGS_VIEWED = exports.MARK_SETTINGS_VIEWED = 'MARK_SETTINGS_VIEWED';
	var MARK_TRENDS_VIEWED = exports.MARK_TRENDS_VIEWED = 'MARK_TRENDS_VIEWED';
	
	var SHOW_CBG_DATE_TRACES = exports.SHOW_CBG_DATE_TRACES = 'SHOW_CBG_DATE_TRACES';
	
	var TOGGLE_SETTINGS_SECTION = exports.TOGGLE_SETTINGS_SECTION = 'TOGGLE_SETTINGS_SECTION';
	
	var TURN_OFF_CBG_RANGE = exports.TURN_OFF_CBG_RANGE = 'TURN_OFF_CBG_RANGE';
	var TURN_ON_CBG_RANGE = exports.TURN_ON_CBG_RANGE = 'TURN_ON_CBG_RANGE';
	
	var UNFOCUS_TRENDS_CBG_DATE_TRACE = exports.UNFOCUS_TRENDS_CBG_DATE_TRACE = 'UNFOCUS_TRENDS_CBG_DATE_TRACE';
	var UNFOCUS_TRENDS_CBG_SLICE = exports.UNFOCUS_TRENDS_CBG_SLICE = 'UNFOCUS_TRENDS_CBG_SLICE';
	var UNFOCUS_TRENDS_SMBG = exports.UNFOCUS_TRENDS_SMBG = 'UNFOCUS_TRENDS_SMBG';
	var UNFOCUS_TRENDS_SMBG_RANGE_AVG = exports.UNFOCUS_TRENDS_SMBG_RANGE_AVG = 'UNFOCUS_TRENDS_SMBG_RANGE_AVG';
	
	// from blip's redux implementation
	// TODO: how could we DRY this out??
	
	var FETCH_PATIENT_DATA_SUCCESS = exports.FETCH_PATIENT_DATA_SUCCESS = 'FETCH_PATIENT_DATA_SUCCESS';
	var LOGOUT_REQUEST = exports.LOGOUT_REQUEST = 'LOGOUT_REQUEST';
	
	/**
	 * Web Worker action types
	 */
	
	// pdf generation
	var GENERATE_PDF_REQUEST = exports.GENERATE_PDF_REQUEST = 'GENERATE_PDF_REQUEST';
	var GENERATE_PDF_SUCCESS = exports.GENERATE_PDF_SUCCESS = 'GENERATE_PDF_SUCCESS';
	var GENERATE_PDF_FAILURE = exports.GENERATE_PDF_FAILURE = 'GENERATE_PDF_FAILURE';
	
	var REMOVE_GENERATED_PDFS = exports.REMOVE_GENERATED_PDFS = 'REMOVE_GENERATED_PDFS';
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_CBG_DATE_TRACE, 'FOCUS_TRENDS_CBG_DATE_TRACE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_CBG_SLICE, 'FOCUS_TRENDS_CBG_SLICE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_SMBG, 'FOCUS_TRENDS_SMBG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FOCUS_TRENDS_SMBG_RANGE_AVG, 'FOCUS_TRENDS_SMBG_RANGE_AVG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(MARK_SETTINGS_VIEWED, 'MARK_SETTINGS_VIEWED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(MARK_TRENDS_VIEWED, 'MARK_TRENDS_VIEWED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_CBG_DATE_TRACES, 'SHOW_CBG_DATE_TRACES', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TOGGLE_SETTINGS_SECTION, 'TOGGLE_SETTINGS_SECTION', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TURN_OFF_CBG_RANGE, 'TURN_OFF_CBG_RANGE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(TURN_ON_CBG_RANGE, 'TURN_ON_CBG_RANGE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_CBG_DATE_TRACE, 'UNFOCUS_TRENDS_CBG_DATE_TRACE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_CBG_SLICE, 'UNFOCUS_TRENDS_CBG_SLICE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_SMBG, 'UNFOCUS_TRENDS_SMBG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UNFOCUS_TRENDS_SMBG_RANGE_AVG, 'UNFOCUS_TRENDS_SMBG_RANGE_AVG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PATIENT_DATA_SUCCESS, 'FETCH_PATIENT_DATA_SUCCESS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGOUT_REQUEST, 'LOGOUT_REQUEST', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GENERATE_PDF_REQUEST, 'GENERATE_PDF_REQUEST', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GENERATE_PDF_SUCCESS, 'GENERATE_PDF_SUCCESS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GENERATE_PDF_FAILURE, 'GENERATE_PDF_FAILURE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REMOVE_GENERATED_PDFS, 'REMOVE_GENERATED_PDFS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js');
	})();

	;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markSettingsViewed = markSettingsViewed;
	exports.toggleSettingsSection = toggleSettingsSection;
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function markSettingsViewed(userId) {
	  return {
	    type: actionTypes.MARK_SETTINGS_VIEWED,
	    payload: { userId: userId }
	  };
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2016, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	function toggleSettingsSection(userId, deviceKey, scheduleOrProfileKey) {
	  return {
	    type: actionTypes.TOGGLE_SETTINGS_SECTION,
	    payload: { deviceKey: deviceKey, scheduleOrProfileKey: scheduleOrProfileKey, userId: userId }
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(markSettingsViewed, 'markSettingsViewed', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/settings.js');
	
	  __REACT_HOT_LOADER__.register(toggleSettingsSection, 'toggleSettingsSection', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/settings.js');
	})();

	;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePDFRequest = generatePDFRequest;
	exports.generatePDFSuccess = generatePDFSuccess;
	exports.generatePDFFailure = generatePDFFailure;
	exports.removeGeneratedPDFS = removeGeneratedPDFS;
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function generatePDFRequest(type, mostRecent, groupedData, opts) {
	  return {
	    type: actionTypes.GENERATE_PDF_REQUEST,
	    meta: { WebWorker: true, origin: document.location.origin },
	    payload: {
	      type: type,
	      mostRecent: mostRecent,
	      groupedData: groupedData,
	      opts: opts
	    }
	  };
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2017, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	function generatePDFSuccess(pdf) {
	  return {
	    type: actionTypes.GENERATE_PDF_SUCCESS,
	    payload: { pdf: pdf }
	  };
	}
	
	function generatePDFFailure(error) {
	  return {
	    type: actionTypes.GENERATE_PDF_FAILURE,
	    error: error
	  };
	}
	
	function removeGeneratedPDFS() {
	  return {
	    type: actionTypes.REMOVE_GENERATED_PDFS
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(generatePDFRequest, 'generatePDFRequest', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js');
	
	  __REACT_HOT_LOADER__.register(generatePDFSuccess, 'generatePDFSuccess', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js');
	
	  __REACT_HOT_LOADER__.register(generatePDFFailure, 'generatePDFFailure', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js');
	
	  __REACT_HOT_LOADER__.register(removeGeneratedPDFS, 'removeGeneratedPDFS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js');
	})();

	;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LabeledCheckbox = __webpack_require__(39);
	
	var _LabeledCheckbox2 = _interopRequireDefault(_LabeledCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var LabeledCheckbox = function LabeledCheckbox(props) {
	  var name = props.name,
	      checked = props.checked,
	      onFn = props.onFn,
	      offFn = props.offFn,
	      label = props.label;
	
	  var handleChange = function handleChange() {
	    if (checked) {
	      offFn();
	    } else {
	      onFn();
	    }
	  };
	
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: name, className: _LabeledCheckbox2.default.label },
	    _react2.default.createElement('input', {
	      type: 'checkbox', name: name, id: name,
	      checked: checked,
	      onChange: handleChange
	    }),
	    ' ',
	    label
	  );
	};
	
	LabeledCheckbox.propTypes = {
	  checked: _react.PropTypes.bool.isRequired,
	  onFn: _react.PropTypes.func.isRequired,
	  offFn: _react.PropTypes.func.isRequired,
	  label: _react.PropTypes.node.isRequired,
	  name: _react.PropTypes.string.isRequired
	};
	
	var _default = LabeledCheckbox;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LabeledCheckbox, 'LabeledCheckbox', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/controls/LabeledCheckbox.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/controls/LabeledCheckbox.js');
	})();

	;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(40);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./LabeledCheckbox.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./LabeledCheckbox.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".LabeledCheckbox--label--8KYrB{padding-right:12px}", ""]);
	
	// exports
	exports.locals = {
		"label": "LabeledCheckbox--label--8KYrB " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["largeSize"] + ""
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(42);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./RangeSelect.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./RangeSelect.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".RangeSelect--container--wOEXa{display:flex;flex-direction:row;padding-top:15px}", ""]);
	
	// exports
	exports.locals = {
		"container": "RangeSelect--container--wOEXa " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["defaultSize"] + ""
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toggle = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TwoOptionToggle = __webpack_require__(44);
	
	var _TwoOptionToggle2 = _interopRequireDefault(_TwoOptionToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var TwoOptionToggle = function TwoOptionToggle(props) {
	  var disabled = props.disabled,
	      left = props.left,
	      right = props.right,
	      toggleFn = props.toggleFn;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _TwoOptionToggle2.default.container },
	    _react2.default.createElement(
	      'span',
	      { className: _TwoOptionToggle2.default.label },
	      left.label
	    ),
	    _react2.default.createElement(Toggle, { disabled: disabled, leftOptionActive: left.state, toggleFn: toggleFn }),
	    _react2.default.createElement(
	      'span',
	      { className: _TwoOptionToggle2.default.label },
	      right.label
	    )
	  );
	};
	
	TwoOptionToggle.defaultProps = {
	  disabled: false
	};
	
	TwoOptionToggle.propTypes = {
	  disabled: _react.PropTypes.bool.isRequired,
	  left: _react.PropTypes.shape({
	    label: _react.PropTypes.string.isRequired,
	    state: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  right: _react.PropTypes.shape({
	    label: _react.PropTypes.string.isRequired,
	    state: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  toggleFn: _react.PropTypes.func.isRequired
	};
	
	var Toggle = exports.Toggle = function Toggle(props) {
	  var disabled = props.disabled,
	      leftOptionActive = props.leftOptionActive,
	      toggleFn = props.toggleFn;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: disabled ? _TwoOptionToggle2.default.disabled : _TwoOptionToggle2.default.toggle,
	      onClick: disabled ? function () {} : toggleFn
	    },
	    _react2.default.createElement('div', { className: _TwoOptionToggle2.default.track }),
	    _react2.default.createElement('div', { className: leftOptionActive ? _TwoOptionToggle2.default.leftThumb : _TwoOptionToggle2.default.rightThumb })
	  );
	};
	
	Toggle.propTypes = {
	  disabled: _react.PropTypes.bool.isRequired,
	  leftOptionActive: _react.PropTypes.bool.isRequired,
	  toggleFn: _react.PropTypes.func.isRequired
	};
	
	var _default = TwoOptionToggle;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TwoOptionToggle, 'TwoOptionToggle', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	
	  __REACT_HOT_LOADER__.register(Toggle, 'Toggle', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/controls/TwoOptionToggle.js');
	})();

	;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(45);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoOptionToggle.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoOptionToggle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".TwoOptionToggle--container--1zUwx{display:flex;justify-content:center;align-items:center}.TwoOptionToggle--label--2EJ_a{padding:4px}.TwoOptionToggle--toggle--1xSoR{display:inline-block;position:relative;background-color:transparent;border:0;cursor:pointer;padding:0;user-select:none}.TwoOptionToggle--disabled--ucm9-{cursor:not-allowed;opacity:.5;transition:opacity .25s}.TwoOptionToggle--track--276ia{width:50px;height:24px;background-color:var(--chrome);border-radius:30px;padding:0;transition:all .2s ease}.TwoOptionToggle--thumb--3MohE{position:absolute;top:1px;width:22px;height:22px;background-color:#fff;border:1px solid var(--chrome);border-radius:50%;box-sizing:border-box;transition:all .25s ease}.TwoOptionToggle--leftThumb--sj1OH{left:1px}.TwoOptionToggle--rightThumb--3rMQE{left:27px}", ""]);
	
	// exports
	exports.locals = {
		"container": "TwoOptionToggle--container--1zUwx",
		"label": "TwoOptionToggle--label--2EJ_a " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["smallSize"] + "",
		"toggle": "TwoOptionToggle--toggle--1xSoR",
		"disabled": "TwoOptionToggle--disabled--ucm9- TwoOptionToggle--toggle--1xSoR",
		"track": "TwoOptionToggle--track--276ia",
		"thumb": "TwoOptionToggle--thumb--3MohE",
		"leftThumb": "TwoOptionToggle--leftThumb--sj1OH TwoOptionToggle--thumb--3MohE",
		"rightThumb": "TwoOptionToggle--rightThumb--3rMQE TwoOptionToggle--thumb--3MohE"
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PumpSettingsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _actions = __webpack_require__(32);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _constants = __webpack_require__(16);
	
	var _NonTandem = __webpack_require__(47);
	
	var _NonTandem2 = _interopRequireDefault(_NonTandem);
	
	var _Tandem = __webpack_require__(87);
	
	var _Tandem2 = _interopRequireDefault(_Tandem);
	
	var _constants2 = __webpack_require__(84);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var PumpSettingsContainer = exports.PumpSettingsContainer = function (_PureComponent) {
	  _inherits(PumpSettingsContainer, _PureComponent);
	
	  function PumpSettingsContainer() {
	    _classCallCheck(this, PumpSettingsContainer);
	
	    return _possibleConstructorReturn(this, (PumpSettingsContainer.__proto__ || Object.getPrototypeOf(PumpSettingsContainer)).apply(this, arguments));
	  }
	
	  _createClass(PumpSettingsContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var markSettingsViewed = this.props.markSettingsViewed;
	      var _props = this.props,
	          manufacturerKey = _props.manufacturerKey,
	          activeSchedule = _props.pumpSettings.activeSchedule,
	          toggleSettingsSection = _props.toggleSettingsSection;
	      var touched = this.props.settingsState.touched;
	
	      if (!touched) {
	        markSettingsViewed();
	        toggleSettingsSection(manufacturerKey, activeSchedule);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          settingsState = _props2.settingsState,
	          user = _props2.user;
	
	      if (_lodash2.default.isEmpty(settingsState)) {
	        return null;
	      }
	      var _props3 = this.props,
	          bgUnits = _props3.bgUnits,
	          copySettingsClicked = _props3.copySettingsClicked,
	          manufacturerKey = _props3.manufacturerKey,
	          pumpSettings = _props3.pumpSettings,
	          timePrefs = _props3.timePrefs,
	          toggleSettingsSection = _props3.toggleSettingsSection,
	          view = _props3.view;
	
	      var supportedNonTandemPumps = ['animas', 'carelink', 'insulet', 'medtronic'];
	      var toggleFn = _lodash2.default.partial(toggleSettingsSection, manufacturerKey);
	
	      if (manufacturerKey === 'tandem') {
	        return _react2.default.createElement(_Tandem2.default, {
	          bgUnits: bgUnits,
	          copySettingsClicked: copySettingsClicked,
	          deviceKey: manufacturerKey,
	          openedSections: settingsState[manufacturerKey],
	          pumpSettings: pumpSettings,
	          timePrefs: timePrefs,
	          toggleProfileExpansion: toggleFn,
	          user: user,
	          view: view
	        });
	      } else if (_lodash2.default.includes(supportedNonTandemPumps, manufacturerKey)) {
	        return _react2.default.createElement(_NonTandem2.default, {
	          bgUnits: bgUnits,
	          copySettingsClicked: copySettingsClicked,
	          deviceKey: manufacturerKey,
	          openedSections: settingsState[manufacturerKey],
	          pumpSettings: pumpSettings,
	          timePrefs: timePrefs,
	          toggleBasalScheduleExpansion: toggleFn,
	          user: user,
	          view: view
	        });
	      }
	      // eslint-disable-next-line no-console
	      console.warn('Unknown manufacturer key: [' + manufacturerKey + ']!');
	      return null;
	    }
	  }]);
	
	  return PumpSettingsContainer;
	}(_react.PureComponent);
	
	PumpSettingsContainer.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  manufacturerKey: _react.PropTypes.oneOf(['animas', 'carelink', 'insulet', 'medtronic', 'tandem']).isRequired,
	  markSettingsViewed: _react.PropTypes.func.isRequired,
	  // see more specific schema in NonTandem and Tandem components!
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.string.isRequired
	  }).isRequired,
	  settingsState: _react.PropTypes.object.isRequired,
	  toggleSettingsSection: _react.PropTypes.func.isRequired,
	  view: _react.PropTypes.oneOf([_constants2.DISPLAY_VIEW, _constants2.PRINT_VIEW]).isRequired
	};
	function mapStateToProps(state, ownProps) {
	  var userId = _lodash2.default.get(ownProps, 'currentPatientInViewId');
	  var user = _lodash2.default.get(state.blip.allUsersMap, userId, {});
	  return {
	    settingsState: _lodash2.default.get(state, ['viz', 'settings', userId], {}),
	    user: user
	  };
	}
	
	function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    markSettingsViewed: _lodash2.default.partial(actions.markSettingsViewed, ownProps.currentPatientInViewId),
	    toggleSettingsSection: _lodash2.default.partial(actions.toggleSettingsSection, ownProps.currentPatientInViewId)
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PumpSettingsContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PumpSettingsContainer, 'PumpSettingsContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/PumpSettingsContainer.js');
	})();

	;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactClipboard = __webpack_require__(48);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _Header = __webpack_require__(57);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Table = __webpack_require__(60);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _CollapsibleContainer = __webpack_require__(65);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	var _constants = __webpack_require__(16);
	
	var _nonTandemData = __webpack_require__(78);
	
	var nonTandemData = _interopRequireWildcard(_nonTandemData);
	
	var _textData = __webpack_require__(80);
	
	var _constants2 = __webpack_require__(84);
	
	var _NonTandem = __webpack_require__(85);
	
	var _NonTandem2 = _interopRequireDefault(_NonTandem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NonTandem = function NonTandem(props) {
	  var bgUnits = props.bgUnits,
	      copySettingsClicked = props.copySettingsClicked,
	      deviceKey = props.deviceKey,
	      openedSections = props.openedSections,
	      pumpSettings = props.pumpSettings,
	      timePrefs = props.timePrefs,
	      toggleBasalScheduleExpansion = props.toggleBasalScheduleExpansion,
	      user = props.user,
	      view = props.view;
	
	
	  var lookupKey = deviceKey;
	
	  if (deviceKey === 'carelink') {
	    lookupKey = 'medtronic';
	  }
	
	  function buildTable(rows, columns, title, tableStyle) {
	    return _react2.default.createElement(_Table2.default, {
	      title: title,
	      rows: rows,
	      columns: columns,
	      tableStyle: tableStyle
	    });
	  }
	
	  function renderBreathingSpace() {
	    if (view === _constants2.PRINT_VIEW) {
	      return _react2.default.createElement(
	        'div',
	        { className: _NonTandem2.default.printNotes },
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement('hr', null)
	      );
	    }
	    return null;
	  }
	
	  function openSection(sectionName) {
	    if (view === _constants2.PRINT_VIEW) {
	      return true;
	    }
	    return _lodash2.default.get(openedSections, sectionName, false);
	  }
	
	  function renderBasalsData() {
	    return _lodash2.default.map(nonTandemData.basalSchedules(pumpSettings), function (schedule) {
	      var basal = nonTandemData.basal(schedule, pumpSettings, deviceKey);
	      var toggleFn = _lodash2.default.partial(toggleBasalScheduleExpansion, basal.scheduleName);
	
	      var labelClass = _NonTandem2.default.singleLineBasalScheduleHeader;
	      if (basal.activeAtUpload) {
	        labelClass = _NonTandem2.default.twoLineBasalScheduleHeader;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _NonTandem2.default.categoryContainer, key: schedule },
	        _react2.default.createElement(
	          _CollapsibleContainer2.default,
	          {
	            label: basal.title,
	            labelClass: labelClass,
	            opened: openSection(basal.scheduleName),
	            toggleExpansion: toggleFn,
	            twoLineLabel: true
	          },
	          buildTable(basal.rows, basal.columns, null, _NonTandem2.default.basalTable)
	        ),
	        renderBreathingSpace()
	      );
	    });
	  }
	
	  function renderSensitivityData() {
	    var sensitivity = nonTandemData.sensitivity(pumpSettings, lookupKey, bgUnits);
	    var title = {
	      label: {
	        main: sensitivity.title,
	        secondary: bgUnits + '/U'
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(sensitivity.rows, sensitivity.columns, title, _NonTandem2.default.settingsTable),
	      renderBreathingSpace()
	    );
	  }
	
	  function renderRatioData() {
	    var ratio = nonTandemData.ratio(pumpSettings, lookupKey);
	    var title = {
	      label: {
	        main: ratio.title,
	        secondary: 'g/U'
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(ratio.rows, ratio.columns, title, _NonTandem2.default.settingsTable),
	      renderBreathingSpace()
	    );
	  }
	
	  function renderTargetData() {
	    var target = nonTandemData.target(pumpSettings, lookupKey);
	    var title = {
	      label: {
	        main: target.title,
	        secondary: bgUnits
	      },
	      className: _NonTandem2.default.bolusSettingsHeader
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.categoryContainer },
	      buildTable(target.rows, target.columns, title, _NonTandem2.default.settingsTable),
	      renderBreathingSpace()
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactClipboard2.default,
	      {
	        className: _NonTandem2.default.copyButton,
	        'button-title': 'For email or notes',
	        'data-clipboard-target': '#copySettingsText',
	        onSuccess: copySettingsClicked
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Copy as text'
	      )
	    ),
	    _react2.default.createElement(_Header2.default, {
	      deviceDisplayName: nonTandemData.deviceName(lookupKey),
	      deviceMeta: nonTandemData.deviceMeta(pumpSettings, timePrefs),
	      printView: view === _constants2.PRINT_VIEW
	    }),
	    renderBreathingSpace(),
	    _react2.default.createElement(
	      'div',
	      { className: _NonTandem2.default.settingsContainer },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _NonTandem2.default.basalSettingsContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _NonTandem2.default.categoryTitle },
	            'Basal Rates'
	          ),
	          renderBasalsData()
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _NonTandem2.default.bolusSettingsContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _NonTandem2.default.categoryTitle },
	          nonTandemData.bolusTitle(lookupKey)
	        ),
	        renderSensitivityData(),
	        renderTargetData(),
	        renderRatioData()
	      )
	    ),
	    _react2.default.createElement(
	      'pre',
	      { className: _NonTandem2.default.copyText, id: 'copySettingsText' },
	      (0, _textData.nonTandemText)(user, pumpSettings, bgUnits, lookupKey)
	    )
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	NonTandem.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MMOLL_UNITS, _constants.MGDL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  deviceKey: _react.PropTypes.oneOf(['animas', 'carelink', 'insulet', 'medtronic']).isRequired,
	  openedSections: _react.PropTypes.object.isRequired,
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.object.isRequired,
	    deviceId: _react.PropTypes.string.isRequired,
	    basalSchedules: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      name: _react.PropTypes.string.isRequired,
	      value: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        start: _react.PropTypes.number.isRequired,
	        rate: _react.PropTypes.number.isRequired
	      }))
	    })).isRequired,
	    bgTarget: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      target: _react.PropTypes.number,
	      range: _react.PropTypes.number
	    })).isRequired,
	    carbRatio: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired,
	    insulinSensitivity: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.oneOfType([_react.PropTypes.string, null])
	  }).isRequired,
	  toggleBasalScheduleExpansion: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  view: _react.PropTypes.oneOf([_constants2.DISPLAY_VIEW, _constants2.PRINT_VIEW]).isRequired
	};
	
	NonTandem.defaultProps = {
	  view: _constants2.DISPLAY_VIEW
	};
	
	var _default = NonTandem;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NonTandem, 'NonTandem', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/NonTandem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/NonTandem.js');
	})();

	;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(49));
		else if(typeof define === 'function' && define.amd)
			define(["react", "clipboard"], factory);
		else if(typeof exports === 'object')
			exports["ReactClipboard"] = factory(require("react"), require("clipboard"));
		else
			root["ReactClipboard"] = factory(root["React"], root["Clipboard"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_41__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _get = __webpack_require__(1)['default'];
	
		var _inherits = __webpack_require__(17)['default'];
	
		var _createClass = __webpack_require__(26)['default'];
	
		var _classCallCheck = __webpack_require__(29)['default'];
	
		var _extends = __webpack_require__(30)['default'];
	
		var _Object$keys = __webpack_require__(36)['default'];
	
		var _interopRequireDefault = __webpack_require__(39)['default'];
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _react = __webpack_require__(40);
	
		var _react2 = _interopRequireDefault(_react);
	
		var ClipboardButton = (function (_React$Component) {
		  _inherits(ClipboardButton, _React$Component);
	
		  function ClipboardButton() {
		    _classCallCheck(this, ClipboardButton);
	
		    _get(Object.getPrototypeOf(ClipboardButton.prototype), 'constructor', this).apply(this, arguments);
		  }
	
		  _createClass(ClipboardButton, [{
		    key: 'propsWith',
	
		    /* Returns a object with all props that fulfill a certain naming pattern
		     *
		     * @param {RegExp} regexp - Regular expression representing which pattern
		     *                          you'll be searching for.
		     * @param {Boolean} remove - Determines if the regular expression should be
		     *                           removed when transmitting the key from the props
		     *                           to the new object.
		     *
		     * e.g:
		     *
		     * // Considering:
		     * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
		     *
		     * // *RegExps not using // so that this comment doesn't break up
		     * this.propsWith(option-*, true); // returns {foo: 1}
		     * this.propsWith(on*, true); // returns {Bar: 2}
		     * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
		     */
		    value: function propsWith(regexp) {
		      var remove = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		      var object = {};
	
		      _Object$keys(this.props).forEach(function (key) {
		        if (key.search(regexp) !== -1) {
		          var objectKey = remove ? key.replace(regexp, '') : key;
		          object[objectKey] = this.props[key];
		        }
		      }, this);
	
		      return object;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.clipboard && this.clipboard.destroy();
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Support old API by trying to assign this.props.options first;
		      var options = this.props.options || this.propsWith(/^option-/, true);
		      var element = _react2['default'].version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.refs.element;
		      var Clipboard = __webpack_require__(41);
		      this.clipboard = new Clipboard(element, options);
	
		      var callbacks = this.propsWith(/^on/, true);
		      _Object$keys(callbacks).forEach(function (callback) {
		        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
		      }, this);
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var attributes = _extends({
		        type: this.getType(),
		        className: this.props.className || '',
		        style: this.props.style || {},
		        ref: 'element',
		        onClick: this.props.onClick
		      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
	
		      return _react2['default'].createElement(this.getComponent(), attributes, this.props.children);
		    }
		  }, {
		    key: 'getType',
		    value: function getType() {
		      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
		        return this.props.type || 'button';
		      } else {
		        return undefined;
		      }
		    }
		  }, {
		    key: 'getComponent',
		    value: function getComponent() {
		      return this.props.component || 'button';
		    }
		  }], [{
		    key: 'propTypes',
		    value: {
		      options: _react2['default'].PropTypes.object,
		      type: _react2['default'].PropTypes.string,
		      className: _react2['default'].PropTypes.string,
		      style: _react2['default'].PropTypes.object,
		      component: _react2['default'].PropTypes.string,
		      children: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.element, _react2['default'].PropTypes.string, _react2['default'].PropTypes.number, _react2['default'].PropTypes.object])
		    },
		    enumerable: true
		  }, {
		    key: 'defaultProps',
		    value: {
		      onClick: function onClick() {}
		    },
		    enumerable: true
		  }]);
	
		  return ClipboardButton;
		})(_react2['default'].Component);
	
		exports['default'] = ClipboardButton;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$getOwnPropertyDescriptor = __webpack_require__(2)["default"];
	
		exports["default"] = function get(_x, _x2, _x3) {
		  var _again = true;
	
		  _function: while (_again) {
		    var object = _x,
		        property = _x2,
		        receiver = _x3;
		    _again = false;
		    if (object === null) object = Function.prototype;
	
		    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
		    if (desc === undefined) {
		      var parent = Object.getPrototypeOf(object);
	
		      if (parent === null) {
		        return undefined;
		      } else {
		        _x = parent;
		        _x2 = property;
		        _x3 = receiver;
		        _again = true;
		        desc = parent = undefined;
		        continue _function;
		      }
		    } else if ("value" in desc) {
		      return desc.value;
		    } else {
		      var getter = desc.get;
	
		      if (getter === undefined) {
		        return undefined;
		      }
	
		      return getter.call(receiver);
		    }
		  }
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(3), __esModule: true };
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		__webpack_require__(5);
		module.exports = function getOwnPropertyDescriptor(it, key){
		  return $.getDesc(it, key);
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		var $Object = Object;
		module.exports = {
		  create:     $Object.create,
		  getProto:   $Object.getPrototypeOf,
		  isEnum:     {}.propertyIsEnumerable,
		  getDesc:    $Object.getOwnPropertyDescriptor,
		  setDesc:    $Object.defineProperty,
		  setDescs:   $Object.defineProperties,
		  getKeys:    $Object.keys,
		  getNames:   $Object.getOwnPropertyNames,
		  getSymbols: $Object.getOwnPropertySymbols,
		  each:       [].forEach
		};
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		var toIObject = __webpack_require__(6);
	
		__webpack_require__(10)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
		  return function getOwnPropertyDescriptor(it, key){
		    return $getOwnPropertyDescriptor(toIObject(it), key);
		  };
		});
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(7)
		  , defined = __webpack_require__(9);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(8);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(11)
		  , core    = __webpack_require__(13)
		  , fails   = __webpack_require__(16);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(12)
		  , core      = __webpack_require__(13)
		  , ctx       = __webpack_require__(14)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && key in target;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(param){
		        return this instanceof C ? new C(param) : C(param);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
		  }
		};
		// type bitmap
		$export.F = 1;  // forced
		$export.G = 2;  // global
		$export.S = 4;  // static
		$export.P = 8;  // proto
		$export.B = 16; // bind
		$export.W = 32; // wrap
		module.exports = $export;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		var core = module.exports = {version: '1.2.6'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(15);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$create = __webpack_require__(18)["default"];
	
		var _Object$setPrototypeOf = __webpack_require__(20)["default"];
	
		exports["default"] = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		  }
	
		  subClass.prototype = _Object$create(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(19), __esModule: true };
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		module.exports = function create(P, D){
		  return $.create(P, D);
		};
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(21), __esModule: true };
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(22);
		module.exports = __webpack_require__(13).Object.setPrototypeOf;
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.19 Object.setPrototypeOf(O, proto)
		var $export = __webpack_require__(11);
		$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(23).set});
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Works with __proto__ only. Old v8 can't work with null proto objects.
		/* eslint-disable no-proto */
		var getDesc  = __webpack_require__(4).getDesc
		  , isObject = __webpack_require__(24)
		  , anObject = __webpack_require__(25);
		var check = function(O, proto){
		  anObject(O);
		  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
		};
		module.exports = {
		  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
		    function(test, buggy, set){
		      try {
		        set = __webpack_require__(14)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
		        set(test, []);
		        buggy = !(test instanceof Array);
		      } catch(e){ buggy = true; }
		      return function setPrototypeOf(O, proto){
		        check(O, proto);
		        if(buggy)O.__proto__ = proto;
		        else set(O, proto);
		        return O;
		      };
		    }({}, false) : undefined),
		  check: check
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(24);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$defineProperty = __webpack_require__(27)["default"];
	
		exports["default"] = (function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];
		      descriptor.enumerable = descriptor.enumerable || false;
		      descriptor.configurable = true;
		      if ("value" in descriptor) descriptor.writable = true;
	
		      _Object$defineProperty(target, descriptor.key, descriptor);
		    }
		  }
	
		  return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);
		    if (staticProps) defineProperties(Constructor, staticProps);
		    return Constructor;
		  };
		})();
	
		exports.__esModule = true;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(28), __esModule: true };
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(4);
		module.exports = function defineProperty(it, key, desc){
		  return $.setDesc(it, key, desc);
		};
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports["default"] = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _Object$assign = __webpack_require__(31)["default"];
	
		exports["default"] = _Object$assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];
	
		    for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  return target;
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(32), __esModule: true };
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(33);
		module.exports = __webpack_require__(13).Object.assign;
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.1 Object.assign(target, source)
		var $export = __webpack_require__(11);
	
		$export($export.S + $export.F, 'Object', {assign: __webpack_require__(34)});
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.1 Object.assign(target, source, ...)
		var $        = __webpack_require__(4)
		  , toObject = __webpack_require__(35)
		  , IObject  = __webpack_require__(7);
	
		// should work with symbols and should have deterministic property order (V8 bug)
		module.exports = __webpack_require__(16)(function(){
		  var a = Object.assign
		    , A = {}
		    , B = {}
		    , S = Symbol()
		    , K = 'abcdefghijklmnopqrst';
		  A[S] = 7;
		  K.split('').forEach(function(k){ B[k] = k; });
		  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
		}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
		  var T     = toObject(target)
		    , $$    = arguments
		    , $$len = $$.length
		    , index = 1
		    , getKeys    = $.getKeys
		    , getSymbols = $.getSymbols
		    , isEnum     = $.isEnum;
		  while($$len > index){
		    var S      = IObject($$[index++])
		      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
		      , length = keys.length
		      , j      = 0
		      , key;
		    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
		  }
		  return T;
		} : Object.assign;
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(9);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(37), __esModule: true };
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(38);
		module.exports = __webpack_require__(13).Object.keys;
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(35);
	
		__webpack_require__(10)('keys', function($keys){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports["default"] = function (obj) {
		  return obj && obj.__esModule ? obj : {
		    "default": obj
		  };
		};
	
		exports.__esModule = true;
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_40__;
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_41__;
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(50), __webpack_require__(52), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
	
	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;
	
	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });
	
	                return support;
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                document.body.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    document.body.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    document.body.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.target) {
	                    this.target.blur();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ },
/* 51 */
/***/ function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ },
/* 52 */
/***/ function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var is = __webpack_require__(54);
	var delegate = __webpack_require__(55);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(56);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ },
/* 56 */
/***/ function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (element.matches(selector)) return element;
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(58);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Header = function (_PureComponent) {
	  _inherits(Header, _PureComponent);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = { serialNumberExpanded: _this.props.printView };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ serialNumberExpanded: !this.state.serialNumberExpanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headerClass = this.state.serialNumberExpanded ? _Header2.default.headerExpanded : _Header2.default.headerClosed;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: _Header2.default.header + ' ' + headerClass, onClick: this.handleClick },
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              this.props.deviceDisplayName
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              'Uploaded on ',
	              this.props.deviceMeta.uploaded
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _Header2.default.headerOuter },
	            _react2.default.createElement(
	              'span',
	              { className: _Header2.default.headerInner },
	              'Serial Number: ',
	              this.props.deviceMeta.serial
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.PureComponent);
	
	Header.propTypes = {
	  deviceDisplayName: _react.PropTypes.string.isRequired,
	  deviceMeta: _react.PropTypes.object.isRequired,
	  printView: _react.PropTypes.bool.isRequired
	};
	
	var _default = Header;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Header, 'Header', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/Header.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/Header.js');
	})();

	;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Header.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Header.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".Header--header--3ozrH{position:relative;display:table;padding-left:0;margin-bottom:5px;cursor:pointer}.Header--header--3ozrH:hover{color:var(--text-hover)}.Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{transition-property:width;transition-duration:.25s;overflow:hidden}.Header--headerClosed--15eLm .Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{width:0}.Header--headerExpanded--r2xtw .Header--headerOuter--3sTjy:last-of-type .Header--headerInner--3SX7m{width:100%}.Header--headerOuter--3sTjy{display:inline-block;font-weight:300;overflow:hidden}.Header--headerInner--3SX7m{display:block;margin:5px 5px 5px 0;white-space:nowrap}.Header--headerOuter--3sTjy:first-of-type{cursor:pointer;font-weight:600}.Header--headerOuter--3sTjy:nth-last-of-type(2){padding-right:10px}.Header--headerClosed--15eLm .Header--headerOuter--3sTjy:nth-last-of-type(2):after{content:\"\\203A\";font-size:15px;font-weight:700;position:absolute;right:5px;top:45%;transform:translateY(-50%)}.Header--headerExpanded--r2xtw .Header--headerOuter--3sTjy:nth-last-of-type(2):after{content:\"\\203A\";font-size:15px;font-weight:700;position:absolute;right:5px;top:55%;transform:rotate(180deg) translateY(50%)}@media print{.Header--headerOuter--3sTjy{color:var(--text-black)}.Header--headerOuter--3sTjy:first-of-type{color:var(--text-black);font-weight:400;font-size:16px}}", ""]);
	
	// exports
	exports.locals = {
		"header": "Header--header--3ozrH",
		"headerOuter": "Header--headerOuter--3sTjy Header--header--3ozrH " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(8).locals["largeSize"] + "",
		"headerInner": "Header--headerInner--3SX7m Header--header--3ozrH",
		"headerClosed": "Header--headerClosed--15eLm",
		"headerExpanded": "Header--headerExpanded--r2xtw"
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Table = __webpack_require__(61);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Table = function (_PureComponent) {
	  _inherits(Table, _PureComponent);
	
	  function Table() {
	    _classCallCheck(this, Table);
	
	    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	  }
	
	  _createClass(Table, [{
	    key: 'getItemField',
	    value: function getItemField(item, field) {
	      return item[field];
	    }
	  }, {
	    key: 'normalizeColumns',
	    value: function normalizeColumns() {
	      var getItemField = this.getItemField;
	      var columns = this.props.columns;
	
	
	      return _lodash2.default.map(columns, function (column) {
	        return {
	          cell: getItemField,
	          className: column.className,
	          key: column.key,
	          label: column.label
	        };
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(normalizedColumns) {
	      var cells = _lodash2.default.map(normalizedColumns, function (column, key) {
	        var label = column.label;
	
	        if ((typeof label === 'undefined' ? 'undefined' : _typeof(label)) === 'object' && _lodash2.default.isEqual(_lodash2.default.keys(label), ['main', 'secondary'])) {
	          return _react2.default.createElement(
	            'th',
	            { key: key, className: column.className },
	            label.main,
	            _react2.default.createElement(
	              'span',
	              { className: _Table2.default.secondaryLabelWithMain },
	              label.secondary
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'th',
	          { key: key, className: _Table2.default.secondaryLabelAlone },
	          label
	        );
	      });
	      return _react2.default.createElement(
	        'thead',
	        { key: 'thead_' + cells.length },
	        _react2.default.createElement(
	          'tr',
	          null,
	          cells
	        )
	      );
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(normalizedColumns, rowKey, rowData) {
	      var cells = _lodash2.default.map(normalizedColumns, function (column) {
	        return _react2.default.createElement(
	          'td',
	          { key: column.key },
	          column.cell(rowData, column.key)
	        );
	      });
	      return _react2.default.createElement(
	        'tr',
	        { key: rowKey },
	        cells
	      );
	    }
	  }, {
	    key: 'renderRows',
	    value: function renderRows(normalizedColumns) {
	      var _this2 = this;
	
	      var rowData = _lodash2.default.map(this.props.rows, function (row, key) {
	        return _this2.renderRow(normalizedColumns, key, row);
	      });
	      return _react2.default.createElement(
	        'tbody',
	        { key: 'tbody_' + rowData.length },
	        rowData
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var normalizedColumns = this.normalizeColumns();
	
	      var tableContents = [];
	
	      if (!_lodash2.default.isEmpty(this.props.title)) {
	        var _props$title = this.props.title,
	            className = _props$title.className,
	            _props$title$label = _props$title.label,
	            main = _props$title$label.main,
	            secondary = _props$title$label.secondary;
	
	        var title = _react2.default.createElement(
	          'caption',
	          {
	            key: main,
	            className: className
	          },
	          main,
	          _react2.default.createElement(
	            'span',
	            { className: _Table2.default.secondaryLabelWithMain },
	            secondary
	          )
	        );
	        tableContents = [title, this.renderHeader(normalizedColumns), this.renderRows(normalizedColumns)];
	      } else {
	        tableContents = [this.renderHeader(normalizedColumns), this.renderRows(normalizedColumns)];
	      }
	
	      return _react2.default.createElement(
	        'table',
	        { className: this.props.tableStyle },
	        tableContents
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.PureComponent);
	
	Table.propTypes = {
	  title: _react2.default.PropTypes.shape({
	    className: _react2.default.PropTypes.string.isRequired,
	    label: _react2.default.PropTypes.object.isRequired
	  }),
	  rows: _react.PropTypes.array.isRequired,
	  columns: _react.PropTypes.array.isRequired,
	  tableStyle: _react.PropTypes.string.isRequired
	};
	
	var _default = Table;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Table, 'Table', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/Table.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/Table.js');
	})();

	;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(62);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Table.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(63), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".Table--secondaryLabelAlone--36Ivn{font-weight:400}@media print{.Table--secondaryLabelWithMain--1n5o2{color:var(--text-black)}}", ""]);
	
	// exports
	exports.locals = {
		"secondaryLabelAlone": "Table--secondaryLabelAlone--36Ivn " + __webpack_require__(63).locals["secondaryLeftPadding"] + "",
		"secondaryLabelWithMain": "Table--secondaryLabelWithMain--1n5o2 " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(63).locals["secondaryLeftPadding"] + " " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(8).locals["largeSize"] + " " + __webpack_require__(63).locals["secondaryLeftPadding"] + ""
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(64), "");
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".settings--copyButton--IE7mR{float:right;line-height:0;padding:5px;border-radius:0;cursor:pointer;color:var(--text-high-contrast);background-color:#f7fafa;border:1px solid #dbdee0;outline:none}.settings--copyButton--IE7mR:active,.settings--copyButton--IE7mR:hover{background-image:none;color:var(--white);background-color:#627cff}.settings--copyButton--IE7mR:active{opacity:.62}.settings--copyText--pjGPI{position:absolute;left:-5000px;top:10px}.settings--settingsTable--LO8hw{min-width:250px;width:100%;border-spacing:1px 0;border-collapse:separate}.settings--settingsTable--LO8hw td,.settings--settingsTable--LO8hw th{padding:10px;text-align:right}.settings--settingsTable--LO8hw td:first-of-type,.settings--settingsTable--LO8hw th:first-of-type{text-align:left}.settings--settingsTable--LO8hw tbody tr:nth-child(odd){background-color:var(--table-stripe--dark)}.settings--settingsTable--LO8hw tbody tr:nth-child(2n),.settings--settingsTable--LO8hw thead tr{background-color:var(--table-stripe--light)}.settings--basalTable--1Xos0 tbody tr:last-of-type{font-weight:700}.settings--basalHeaderBackground--3wVSO{background-image:linear-gradient(90deg,var(--basal) 0,var(--basal) 14px,#d7f1fb 0,#d7f1fb)}.settings--bolusHeaderBackground--92Bay{background-image:linear-gradient(90deg,var(--bolus) 0,var(--bolus) 14px,#d7f1fb 0,#d7f1fb)}.settings--settingsHeaderDecoration--2gABz{border-bottom:1px solid var(--table-stripe--dark)}.settings--settingsHeaderHeight--2gxe8{height:40px;line-height:40px}.settings--settingsHeaderLayout--2Qhvq{min-width:160px;padding-left:28px;text-align:left}.settings--secondaryLeftPadding--xxaRk,.settings--secondaryText--4CniZ{padding-left:8px}@media print{.settings--copyButton--IE7mR{display:none}.settings--printNotes--2o2Cu hr{padding-top:30px;border:none}.settings--settingsTable--LO8hw{min-width:250px;width:100%;border:1px solid #000;border-collapse:collapse;padding-bottom:0}.settings--settingsTable--LO8hw tbody tr,.settings--settingsTable--LO8hw tbody tr:nth-child(odd),.settings--settingsTable--LO8hw thead{background-color:var(--bkgrnd-white);border-bottom:1px solid #cbcbcb;font-weight:700;color:var(--text-black)}.settings--settingsTable--LO8hw tbody tr:last-of-type,.settings--settingsTable--LO8hw thead tr:last-of-type{border-bottom:none}.settings--basalTable--1Xos0 tbody tr:last-of-type{font-weight:400}.settings--mainHeaderText--N-PpB{color:var(--text-black);font-weight:400}.settings--basalHeaderBackground--3wVSO,.settings--bolusHeaderBackground--92Bay{background-image:none;color:var(--text-black);font-weight:400;padding-left:0}.settings--secondaryText--4CniZ{color:var(--text-black);padding-left:8px}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "settings--copyButton--IE7mR " + __webpack_require__(8).locals["defaultSize"] + "",
		"copyText": "settings--copyText--pjGPI",
		"settingsTable": "settings--settingsTable--LO8hw " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"basalTable": "settings--basalTable--1Xos0 settings--settingsTable--LO8hw " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " settings--settingsTable--LO8hw " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"basalHeaderBackground": "settings--basalHeaderBackground--3wVSO settings--mainHeaderText--N-PpB " + __webpack_require__(8).locals["largeSize"] + "",
		"bolusHeaderBackground": "settings--bolusHeaderBackground--92Bay settings--mainHeaderText--N-PpB " + __webpack_require__(8).locals["largeSize"] + "",
		"settingsHeaderDecoration": "settings--settingsHeaderDecoration--2gABz",
		"settingsHeaderHeight": "settings--settingsHeaderHeight--2gxe8",
		"settingsHeaderLayout": "settings--settingsHeaderLayout--2Qhvq",
		"settingsHeaderText": "settings--settingsHeaderText--3qpFf " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"settingsHeader": "settings--settingsHeader--OTqrr settings--settingsHeaderDecoration--2gABz settings--settingsHeaderHeight--2gxe8 settings--settingsHeaderLayout--2Qhvq settings--settingsHeaderText--3qpFf " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["boldText"] + "",
		"secondaryLeftPadding": "settings--secondaryLeftPadding--xxaRk",
		"secondaryText": "settings--secondaryText--4CniZ " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(8).locals["largeSize"] + "",
		"printNotes": "settings--printNotes--2o2Cu",
		"mainHeaderText": "settings--mainHeaderText--N-PpB " + __webpack_require__(8).locals["largeSize"] + ""
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--basal:#19a0d7;--bolus:#7cd0f0;--bolus--interrupted:#ff8b7c;--bolus--ride:#107ea8;--bolus--undelivered:#bcecfa;--carbs:#ffd382;--collapsible--border:#ededed;--table-stripe--light:#f7f7f7;--table-stripe--dark:#ececec;--trends--light:#d0d0d0;--trends--light--faded:#f0f0f0;--trends--dark:#bcbcbc;--trends--dark--faded:#e3e3e3;--axis-tick:#e7e7e7;--bkgrnd:#f8f8f8;--bkgrnd-lines:#e7e7e7;--bkgrnd-white:#fff;--tooltip-title-bg:#eaeaee;--chrome:#989897;--text-medium-contrast:#727375;--text-high-contrast:#281946;--text-black:#000;--bg-low:#ff8b7c;--bg-target:#76d3a6;--bg-high:#bb9ae7;--text-hover:#00d3d9;--blue-green-light:#12d3d8;--gray-dark:#989897;--white:#fff}", ""]);
	
	// exports
	exports.locals = {
		"basal": "#19A0D7",
		"low": "#FF8B7C",
		"target": "#76D3A6",
		"high": "#BB9AE7"
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapse = __webpack_require__(66);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _SingleLineCollapsibleContainerLabel = __webpack_require__(67);
	
	var _SingleLineCollapsibleContainerLabel2 = _interopRequireDefault(_SingleLineCollapsibleContainerLabel);
	
	var _TwoLineCollapsibleContainerLabel = __webpack_require__(73);
	
	var _TwoLineCollapsibleContainerLabel2 = _interopRequireDefault(_TwoLineCollapsibleContainerLabel);
	
	var _CollapsibleContainer = __webpack_require__(76);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CollapsibleContainer = function CollapsibleContainer(props) {
	  var label = props.label,
	      labelClass = props.labelClass,
	      opened = props.opened,
	      toggleExpansion = props.toggleExpansion;
	
	  var renderedLabel = _react2.default.createElement(_SingleLineCollapsibleContainerLabel2.default, {
	    className: labelClass,
	    isOpened: opened,
	    label: label,
	    onClick: toggleExpansion
	  });
	  var twoLineLabel = props.twoLineLabel,
	      secondary = props.label.secondary;
	
	  if (twoLineLabel && !_lodash2.default.isEmpty(secondary)) {
	    renderedLabel = _react2.default.createElement(_TwoLineCollapsibleContainerLabel2.default, {
	      className: labelClass,
	      isOpened: opened,
	      label: label,
	      onClick: toggleExpansion
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    renderedLabel,
	    _react2.default.createElement(
	      _reactCollapse2.default,
	      {
	        className: _CollapsibleContainer2.default.collapsibleContainer,
	        isOpened: opened,
	        springConfig: { stiffness: 120, damping: 20 }
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        props.children
	      )
	    )
	  );
	};
	
	CollapsibleContainer.defaultProps = {
	  twoLineLabel: true
	};
	
	CollapsibleContainer.propTypes = {
	  children: _react.PropTypes.element.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string.isRequired
	  }).isRequired,
	  labelClass: _react.PropTypes.string.isRequired,
	  opened: _react.PropTypes.bool.isRequired,
	  toggleExpansion: _react.PropTypes.func.isRequired,
	  twoLineLabel: _react.PropTypes.bool
	};
	
	var _default = CollapsibleContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CollapsibleContainer, 'CollapsibleContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/CollapsibleContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/CollapsibleContainer.js');
	})();

	;

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = require("react-collapse");

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _norgie = __webpack_require__(69);
	
	var _norgie2 = _interopRequireDefault(_norgie);
	
	var _SingleLineCollapsibleContainerLabel = __webpack_require__(71);
	
	var _SingleLineCollapsibleContainerLabel2 = _interopRequireDefault(_SingleLineCollapsibleContainerLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var SingleLineCollapsibleContainerLabel = function SingleLineCollapsibleContainerLabel(props) {
	  var _cx;
	
	  var className = props.className,
	      isOpened = props.isOpened,
	      _props$label = props.label,
	      main = _props$label.main,
	      secondary = _props$label.secondary,
	      units = _props$label.units,
	      onClick = props.onClick;
	
	  var containerClasses = (0, _classnames2.default)((_cx = {
	    label: true }, _defineProperty(_cx, _SingleLineCollapsibleContainerLabel2.default.collapsibleLabel, !Boolean(className)), _defineProperty(_cx, _SingleLineCollapsibleContainerLabel2.default.labelContainer, true), _defineProperty(_cx, className, Boolean(className)), _defineProperty(_cx, _norgie2.default.opened, isOpened), _cx));
	  return _react2.default.createElement(
	    'div',
	    { className: containerClasses, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.mainText },
	        main
	      ),
	      _lodash2.default.isEmpty(secondary) ? null : _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.secondaryText },
	        secondary
	      ),
	      _lodash2.default.isEmpty(units) ? null : _react2.default.createElement(
	        'span',
	        { className: _SingleLineCollapsibleContainerLabel2.default.secondaryText },
	        units
	      )
	    )
	  );
	};
	
	SingleLineCollapsibleContainerLabel.propTypes = {
	  className: _react.PropTypes.string,
	  isOpened: _react.PropTypes.bool.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string
	  }).isRequired,
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var _default = SingleLineCollapsibleContainerLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SingleLineCollapsibleContainerLabel, 'SingleLineCollapsibleContainerLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/SingleLineCollapsibleContainerLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/SingleLineCollapsibleContainerLabel.js');
	})();

	;

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = require("classnames");

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./norgie.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./norgie.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".norgie--norgie--2Xwz0:after{content:\"\\203A\";font-size:15px;font-weight:700;padding-left:8px;margin-right:16px;transform:rotate(0deg);transition-duration:.25s;transition-property:rotate,transform}.norgie--opened--2KlAx:after{transform:rotate(90deg) translate(-20%,-15%)}@media print{.norgie--norgie--2Xwz0:after{content:\"\"}}", ""]);
	
	// exports
	exports.locals = {
		"norgie": "norgie--norgie--2Xwz0",
		"opened": "norgie--opened--2KlAx"
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(72);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SingleLineCollapsibleContainerLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SingleLineCollapsibleContainerLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(63), undefined);
	exports.i(__webpack_require__(8), undefined);
	exports.i(__webpack_require__(70), undefined);
	
	// module
	exports.push([module.id, ".SingleLineCollapsibleContainerLabel--labelContainer--2kj_E{cursor:pointer;display:flex;align-items:baseline}.SingleLineCollapsibleContainerLabel--labelContainer--2kj_E:hover{color:var(--text-hover)}@media print{.SingleLineCollapsibleContainerLabel--labelContainer--2kj_E{align-items:flex-end}}", ""]);
	
	// exports
	exports.locals = {
		"collapsibleLabel": "SingleLineCollapsibleContainerLabel--collapsibleLabel--p_77K " + __webpack_require__(63).locals["settingsHeader"] + "",
		"labelContainer": "SingleLineCollapsibleContainerLabel--labelContainer--2kj_E " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(70).locals["norgie"] + "",
		"mainText": "SingleLineCollapsibleContainerLabel--mainText--3i5PV " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(63).locals["mainHeaderText"] + "",
		"secondaryText": "SingleLineCollapsibleContainerLabel--secondaryText--2DG4E " + __webpack_require__(63).locals["secondaryText"] + " " + __webpack_require__(63).locals["secondaryText"] + ""
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _norgie = __webpack_require__(69);
	
	var _norgie2 = _interopRequireDefault(_norgie);
	
	var _TwoLineCollapsibleContainerLabel = __webpack_require__(74);
	
	var _TwoLineCollapsibleContainerLabel2 = _interopRequireDefault(_TwoLineCollapsibleContainerLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var TwoLineCollapsibleContainerLabel = function TwoLineCollapsibleContainerLabel(props) {
	  var _cx, _cx2;
	
	  var className = props.className,
	      isOpened = props.isOpened,
	      _props$label = props.label,
	      main = _props$label.main,
	      secondary = _props$label.secondary,
	      units = _props$label.units,
	      onClick = props.onClick;
	
	  var containerClasses = (0, _classnames2.default)((_cx = {
	    label: true }, _defineProperty(_cx, _TwoLineCollapsibleContainerLabel2.default.collapsibleLabel, !Boolean(className)), _defineProperty(_cx, _TwoLineCollapsibleContainerLabel2.default.labelContainer, true), _defineProperty(_cx, className, Boolean(className)), _cx));
	  var norgieContainerClasses = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _TwoLineCollapsibleContainerLabel2.default.norgieLabelContainer, true), _defineProperty(_cx2, _norgie2.default.opened, isOpened), _cx2));
	  return _react2.default.createElement(
	    'div',
	    { className: containerClasses, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { className: _TwoLineCollapsibleContainerLabel2.default.secondaryLabel },
	      secondary
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: norgieContainerClasses },
	      _react2.default.createElement(
	        'div',
	        null,
	        main,
	        _react2.default.createElement(
	          'span',
	          { className: _TwoLineCollapsibleContainerLabel2.default.secondaryText },
	          units
	        )
	      )
	    )
	  );
	};
	
	TwoLineCollapsibleContainerLabel.propTypes = {
	  className: _react.PropTypes.string,
	  isOpened: _react.PropTypes.bool.isRequired,
	  label: _react.PropTypes.shape({
	    main: _react.PropTypes.string.isRequired,
	    secondary: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.string.isRequired
	  }),
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var _default = TwoLineCollapsibleContainerLabel;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TwoLineCollapsibleContainerLabel, 'TwoLineCollapsibleContainerLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/TwoLineCollapsibleContainerLabel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/common/TwoLineCollapsibleContainerLabel.js');
	})();

	;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoLineCollapsibleContainerLabel.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TwoLineCollapsibleContainerLabel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(63), undefined);
	exports.i(__webpack_require__(8), undefined);
	exports.i(__webpack_require__(70), undefined);
	
	// module
	exports.push([module.id, ".TwoLineCollapsibleContainerLabel--labelContainer--2DwW3{cursor:pointer;box-sizing:border-box;display:flex;flex-direction:column;justify-content:space-between;height:66px;min-width:240px;padding-top:10px;padding-bottom:10px}.TwoLineCollapsibleContainerLabel--labelContainer--2DwW3:hover{color:var(--text-hover)}.TwoLineCollapsibleContainerLabel--norgieLabelContainer--3dhbH{display:flex;justify-content:space-between;align-items:baseline}@media print{.TwoLineCollapsibleContainerLabel--labelContainer--2DwW3{cursor:pointer;box-sizing:border-box;display:flex;flex-direction:row-reverse;text-overflow:ellipsis;max-width:280px;min-width:200px;padding-top:10px;padding-bottom:10px;height:auto}}", ""]);
	
	// exports
	exports.locals = {
		"collapsibleLabel": "TwoLineCollapsibleContainerLabel--collapsibleLabel--1TCr9 " + __webpack_require__(63).locals["settingsHeaderDecoration"] + " " + __webpack_require__(63).locals["settingsHeaderLayout"] + " " + __webpack_require__(63).locals["settingsHeaderText"] + "",
		"labelContainer": "TwoLineCollapsibleContainerLabel--labelContainer--2DwW3 " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"norgieLabelContainer": "TwoLineCollapsibleContainerLabel--norgieLabelContainer--3dhbH " + __webpack_require__(70).locals["norgie"] + "",
		"mainText": "TwoLineCollapsibleContainerLabel--mainText--1yQud " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(63).locals["mainHeaderText"] + "",
		"secondaryText": "TwoLineCollapsibleContainerLabel--secondaryText--3xarQ " + __webpack_require__(63).locals["secondaryText"] + " " + __webpack_require__(63).locals["secondaryText"] + "",
		"secondaryLabel": "TwoLineCollapsibleContainerLabel--secondaryLabel--275jJ " + __webpack_require__(8).locals["lightText"] + " " + __webpack_require__(63).locals["secondaryText"] + ""
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CollapsibleContainer.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CollapsibleContainer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(63), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"secondaryLabel": "CollapsibleContainer--secondaryLabel--25FMD " + __webpack_require__(63).locals["secondaryText"] + ""
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.basalSchedules = basalSchedules;
	exports.deviceMeta = deviceMeta;
	exports.bolusTitle = bolusTitle;
	exports.deviceName = deviceName;
	exports.basal = basal;
	exports.sensitivity = sensitivity;
	exports.ratio = ratio;
	exports.target = target;
	
	var _data = __webpack_require__(79);
	
	var data = _interopRequireWildcard(_data);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * basalSchedules
	 * @param  {Object} settings    object with basal schedule properties
	 *
	 * @return {Array}              array of basal schedule names
	 */
	function basalSchedules(settings) {
	  return data.getScheduleNames(settings.basalSchedules);
	}
	
	/**
	 * deviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	function deviceMeta(settings, timePrefs) {
	  return data.getDeviceMeta(settings, timePrefs);
	}
	
	/**
	 * bolusTitle
	 * @param  {String} manufacturer one of: animas, carelink, insulet, medtronic
	 *
	 * @return {String}              bolus title for given manufacturer
	 */
	function bolusTitle(manufacturer) {
	  var BOLUS_SETTINGS_LABEL_BY_MANUFACTURER = {
	    animas: 'ezCarb ezBG',
	    insulet: 'Bolus Calculator',
	    medtronic: 'Bolus Wizard'
	  };
	  return BOLUS_SETTINGS_LABEL_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * deviceName
	 * @param  {String} manufacturer one of: animas, insulet, medtronic
	 *
	 * @return {String}              name for given manufacturer
	 */
	function deviceName(manufacturer) {
	  var DEVICE_DISPLAY_NAME_BY_MANUFACTURER = {
	    animas: 'Animas',
	    insulet: 'OmniPod',
	    medtronic: 'Medtronic'
	  };
	  return DEVICE_DISPLAY_NAME_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * scheduleLabel
	 * @private
	 */
	function scheduleLabel(scheduleName, activeScheduleName, manufacturer) {
	  return data.getScheduleLabel(scheduleName, activeScheduleName, manufacturer, false);
	}
	
	/**
	 * basalRows
	 * @private
	 */
	function basalRows(schedule, settings) {
	  return data.processBasalRateData(settings.basalSchedules[schedule]);
	}
	
	/**
	 * basalColumns
	 * @private
	 */
	function basalColumns() {
	  return data.startTimeAndValue('rate');
	}
	
	/**
	 * basal
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @return {Object}                object with basal title, columns and rows
	 */
	function basal(schedule, settings, manufacturer) {
	  var name = settings.basalSchedules[schedule].name;
	  return {
	    scheduleName: name,
	    activeAtUpload: name === settings.activeSchedule,
	    title: scheduleLabel(name, settings.activeSchedule, manufacturer),
	    columns: basalColumns(),
	    rows: basalRows(schedule, settings)
	  };
	}
	
	/**
	 * sensitivityTitle
	 * @private
	 */
	function sensitivityTitle(manufacturer) {
	  var ISF_BY_MANUFACTURER = {
	    animas: 'ISF',
	    insulet: 'Correction factor',
	    medtronic: 'Sensitivity'
	  };
	  return ISF_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * sensitivityColumns
	 * @private
	 */
	function sensitivityColumns() {
	  return data.startTimeAndValue('amount');
	}
	
	/**
	 * sensitivityRows
	 * @private
	 */
	function sensitivityRows(settings, units) {
	  return data.processSensitivityData(settings.insulinSensitivity, units);
	}
	
	/**
	 * sensitivity
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @return {Object}                object with sensitivity title, columns and rows
	 */
	function sensitivity(settings, manufacturer, units) {
	  return {
	    title: sensitivityTitle(manufacturer),
	    columns: sensitivityColumns(),
	    rows: sensitivityRows(settings, units)
	  };
	}
	
	/**
	 * ratioTitle
	 * @private
	 */
	function ratioTitle(manufacturer) {
	  var CARB_RATIO_BY_MANUFACTURER = {
	    animas: 'I:C Ratio',
	    insulet: 'IC ratio',
	    medtronic: 'Carb Ratios'
	  };
	  return CARB_RATIO_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * ratioColumns
	 * @private
	 */
	function ratioColumns() {
	  return data.startTimeAndValue('amount');
	}
	
	/**
	 * ratioRows
	 * @private
	 */
	function ratioRows(settings) {
	  return data.processCarbRatioData(settings.carbRatio);
	}
	
	/**
	 * ratio
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @return {Object}                object with ratio title, columns and rows
	 */
	function ratio(settings, manufacturer) {
	  return {
	    title: ratioTitle(manufacturer),
	    columns: ratioColumns(),
	    rows: ratioRows(settings)
	  };
	}
	
	/**
	 * targetTitle
	 * @private
	 */
	function targetTitle(manufacturer) {
	  var BG_TARGET_BY_MANUFACTURER = {
	    animas: 'BG Target',
	    insulet: 'Target BG',
	    medtronic: 'BG Target'
	  };
	  return BG_TARGET_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * targetColumns
	 * @private
	 */
	function targetColumns(manufacturer) {
	  var BG_TARGET_COLS_BY_MANUFACTURER = {
	    animas: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Target' }, { key: 'columnThree', label: 'Range' }],
	    insulet: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Target' }, { key: 'columnThree', label: 'Correct Above' }],
	    medtronic: [{ key: 'start', label: 'Start time' }, { key: 'columnTwo', label: 'Low' }, { key: 'columnThree', label: 'High' }]
	  };
	  return BG_TARGET_COLS_BY_MANUFACTURER[manufacturer];
	}
	
	/**
	 * targetRows
	 * @private
	 */
	function targetRows(settings, units, manufacturer) {
	  var BG_TARGET_ACCESSORS_BY_MANUFACTURER = {
	    animas: { columnTwo: 'target', columnThree: 'range' },
	    insulet: { columnTwo: 'target', columnThree: 'high' },
	    medtronic: { columnTwo: 'low', columnThree: 'high' }
	  };
	  return data.processBgTargetData(settings.bgTarget, units, BG_TARGET_ACCESSORS_BY_MANUFACTURER[manufacturer]);
	}
	
	/**
	 * target
	 *
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} manufacturer   one of: animas, carelink, insulet, medtronic
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @return {Object}                object with target title, columns and rows
	 */
	function target(settings, manufacturer, units) {
	  return {
	    title: targetTitle(manufacturer),
	    columns: targetColumns(manufacturer),
	    rows: targetRows(settings, units, manufacturer)
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(basalSchedules, 'basalSchedules', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(deviceMeta, 'deviceMeta', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(bolusTitle, 'bolusTitle', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(deviceName, 'deviceName', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(scheduleLabel, 'scheduleLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalRows, 'basalRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalColumns, 'basalColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(basal, 'basal', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityTitle, 'sensitivityTitle', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityColumns, 'sensitivityColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivityRows, 'sensitivityRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(sensitivity, 'sensitivity', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioTitle, 'ratioTitle', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioColumns, 'ratioColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratioRows, 'ratioRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(ratio, 'ratio', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetTitle, 'targetTitle', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetColumns, 'targetColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(targetRows, 'targetRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	
	  __REACT_HOT_LOADER__.register(target, 'target', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/nonTandemData.js');
	})();

	;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noData = noData;
	exports.getTotalBasalRates = getTotalBasalRates;
	exports.getScheduleLabel = getScheduleLabel;
	exports.getScheduleNames = getScheduleNames;
	exports.getTimedSchedules = getTimedSchedules;
	exports.getDeviceMeta = getDeviceMeta;
	exports.processBasalRateData = processBasalRateData;
	exports.processBgTargetData = processBgTargetData;
	exports.processCarbRatioData = processCarbRatioData;
	exports.processSensitivityData = processSensitivityData;
	exports.processTimedSettings = processTimedSettings;
	exports.startTimeAndValue = startTimeAndValue;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datetime = __webpack_require__(20);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _format = __webpack_require__(17);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISPLAY_PRECISION_PLACES = 3;
	
	/**
	 * noData
	 * @param  {ANY} val value to check
	 *
	 * @return {Boolean}     true if value is defined, not null, not empty string, false otherwise
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function noData(val) {
	  return val == null || typeof val === 'string' && _lodash2.default.isEmpty(val);
	}
	
	/**
	 * getBasalRate
	 * @private
	 * @param  {Array} scheduleData  basal schedule
	 * @param  {Number} startTime    milliseconds from start of day
	 * @return {String}              formatted basal rate
	 */
	function getBasalRate(scheduleData, startTime) {
	  var rate = _lodash2.default.find(scheduleData, function (schedule) {
	    return schedule.start === startTime;
	  }).rate;
	
	  if (noData(rate)) {
	    return '';
	  }
	  return format.formatDecimalNumber(rate, DISPLAY_PRECISION_PLACES);
	}
	
	/**
	 * getValue
	 * @private
	 * @param  {Array} scheduleData  scheduleData
	 * @param  {String} fieldName    field to search for
	 * @param  {Number} startTime    milliseconds from start of day
	 *
	 * @return {String}              value of field for startTime
	 */
	function getValue(scheduleData, fieldName, startTime) {
	  var val = _lodash2.default.find(scheduleData, function (schedule) {
	    return schedule.start === startTime;
	  })[fieldName];
	
	  if (noData(val)) {
	    return '';
	  }
	  return val;
	}
	
	/**
	 * getBloodGlucoseValue
	 * @private
	 * @param  {Array} scheduleData  scheduleData
	 * @param  {String} fieldName    field to search format
	 * @param  {Number} startTime    milliseconds from start of day
	 * @param  {String} units        MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {String}              formatted blood glucose value
	 */
	function getBloodGlucoseValue(scheduleData, fieldName, startTime, units) {
	  var bgValue = getValue(scheduleData, fieldName, startTime);
	  if (noData(bgValue)) {
	    return '';
	  }
	  return format.formatBgValue(bgValue, { bgUnits: units });
	}
	
	/**
	 * getStarts
	 * @private
	 * @param  {Array} timedData array with time based data
	 *
	 * @return {Array}           array of start times in milliseconds
	 */
	function getStarts(timedData) {
	  return _lodash2.default.map(timedData, 'start');
	}
	
	/**
	 * getTotalBasalRates
	 * @param  {Array} scheduleData  basal schedule data
	 *
	 * @return {String}              formatted total of basal rates
	 */
	function getTotalBasalRates(scheduleData) {
	  var HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
	  var DAY_IN_MILLISECONDS = 86400000;
	
	  var total = 0;
	  for (var i = scheduleData.length - 1; i >= 0; i--) {
	    var start = scheduleData[i].start;
	    var finish = DAY_IN_MILLISECONDS;
	    var next = i + 1;
	    if (next < scheduleData.length) {
	      finish = scheduleData[next].start;
	    }
	    var hrs = (finish - start) / HOUR_IN_MILLISECONDS;
	    var amount = parseFloat(scheduleData[i].rate.toFixed(DISPLAY_PRECISION_PLACES)) * hrs;
	    total += parseFloat(amount.toFixed(DISPLAY_PRECISION_PLACES));
	  }
	  return format.formatDecimalNumber(total, DISPLAY_PRECISION_PLACES);
	}
	
	/**
	 * getScheduleLabel
	 * @param  {String} scheduleName  basal schedule name
	 * @param  {String} activeName    name of active basal schedule at time of upload
	 * @param  {String} deviceKey    one of: animas, carelink, insulet, medtronic, tandem
	 * @param  {Boolean} noUnits      whether units should be included in label object
	 *
	 * @return {Object}              object representing basal schedule label
	 */
	function getScheduleLabel(scheduleName, activeName, deviceKey, noUnits) {
	  var CAPITALIZED = ['carelink', 'medtronic'];
	  var displayName = scheduleName;
	  if (_lodash2.default.includes(CAPITALIZED, deviceKey)) {
	    displayName = _lodash2.default.map(scheduleName.split(' '), function (part) {
	      return _lodash2.default.capitalize(part);
	    }).join(' ');
	  }
	  return {
	    main: displayName,
	    secondary: scheduleName === activeName ? 'Active at upload' : '',
	    units: noUnits ? '' : 'U/hr'
	  };
	}
	
	/**
	 * getScheduleNames
	 * @param  {Object} settingsData object with basal schedule properties
	 *
	 * @return {Array}               array of basal schedule names
	 */
	function getScheduleNames(settingsData) {
	  return _lodash2.default.keysIn(settingsData);
	}
	
	/**
	 * getTimedSchedules
	 * @param  {Array} settingsData array of basal schedules
	 *
	 * @return {Array}              array of {name, position} basal objects
	 */
	function getTimedSchedules(settingsData) {
	  var names = _lodash2.default.map(settingsData, 'name');
	  var schedules = [];
	  for (var i = names.length - 1; i >= 0; i--) {
	    schedules.push({ name: names[i], position: i });
	  }
	  return schedules;
	}
	
	/**
	 * getDeviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	function getDeviceMeta(settingsData, timePrefs) {
	  var utc = datetime.getHammertimeFromDatumWithTimePrefs(settingsData, timePrefs);
	  var uploadedTime = utc ? datetime.formatLocalizedFromUTC(utc, timePrefs, 'MMM D, YYYY') : false;
	  return {
	    schedule: settingsData.activeSchedule || 'unknown',
	    uploaded: uploadedTime || 'unknown',
	    serial: settingsData.deviceSerialNumber || 'unknown'
	  };
	}
	
	/**
	 * processBasalRateData
	 * @param  {Object} scheduleData basal schedule object
	 *
	 * @return {Array}               array of formatted schedule entries
	 */
	function processBasalRateData(scheduleData) {
	  var starts = getStarts(scheduleData.value);
	  var noRateData = [{ start: '-', rate: '-' }];
	
	  if (starts.length === 0) {
	    return noRateData;
	  } else if (starts.length === 1) {
	    if (Number(getBasalRate(scheduleData.value, starts[0])) === 0) {
	      return noRateData;
	    }
	  }
	
	  var data = _lodash2.default.map(starts, function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      rate: getBasalRate(scheduleData.value, startTime)
	    };
	  });
	
	  data.push({
	    start: 'Total',
	    rate: getTotalBasalRates(scheduleData.value)
	  });
	  return data;
	}
	
	/**
	 * processBgTargetData
	 * @param  {Array} targetsData  array of blood glucose targets
	 * @param  {String} bgUnits     MGDL_UNITS or MMOLL_UNITS
	 * @param  {Object} keys        key names as {columnTwo, columnThree}
	 *
	 * @return {Array}              formatted bloog glucose target data
	 */
	function processBgTargetData(targetsData, bgUnits, keys) {
	  return _lodash2.default.map(getStarts(targetsData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      columnTwo: getBloodGlucoseValue(targetsData, keys.columnTwo, startTime, bgUnits),
	      columnThree: getBloodGlucoseValue(targetsData, keys.columnThree, startTime, bgUnits)
	    };
	  });
	}
	
	/**
	 * processCarbRatioData
	 * @param  {Array} carbRatioData  array of carb ratio data
	 *
	 * @return {Array}                array of formatted carb ratio objects
	 */
	function processCarbRatioData(carbRatioData) {
	  return _lodash2.default.map(getStarts(carbRatioData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      amount: getValue(carbRatioData, 'amount', startTime)
	    };
	  });
	}
	
	/**
	 * processSensitivityData
	 * @param  {Array} sensitivityData  array of sensitivity data
	 * @param  {String} bgUnits         MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {Array}                  array of formatted sensitivity objects
	 */
	function processSensitivityData(sensitivityData, bgUnits) {
	  return _lodash2.default.map(getStarts(sensitivityData), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      amount: getBloodGlucoseValue(sensitivityData, 'amount', startTime, bgUnits)
	    };
	  });
	}
	
	/**
	 * processTimedSettings
	 * @param  {Object} pumpSettings entire pump settings object
	 * @param  {Object} schedule     {name, position} schedule object
	 * @param  {String} bgUnits      MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {Array}               array of formatted objects with
	 *                                 {start, rate, bgTarget, carbRatio, insulinSensitivity}
	 */
	function processTimedSettings(pumpSettings, schedule, bgUnits) {
	  var data = _lodash2.default.map(getStarts(pumpSettings.bgTargets[schedule.name]), function (startTime) {
	    return {
	      start: datetime.formatClocktimeFromMsPer24(startTime),
	      rate: getBasalRate(pumpSettings.basalSchedules[schedule.position].value, startTime),
	      bgTarget: getBloodGlucoseValue(pumpSettings.bgTargets[schedule.name], 'target', startTime, bgUnits),
	      carbRatio: getValue(pumpSettings.carbRatios[schedule.name], 'amount', startTime),
	      insulinSensitivity: getBloodGlucoseValue(pumpSettings.insulinSensitivities[schedule.name], 'amount', startTime, bgUnits)
	    };
	  });
	
	  data.push({
	    start: 'Total',
	    rate: getTotalBasalRates(pumpSettings.basalSchedules[schedule.position].value),
	    bgTarget: '',
	    carbRatio: '',
	    insulinSensitivity: ''
	  });
	  return data;
	}
	
	/**
	 * startTimeAndValue
	 * @param {TYPE} accessor key for value displayed in this column
	 *
	 * @return {Array} array of objects describing table columns
	 */
	function startTimeAndValue(valueKey) {
	  return [{ key: 'start', label: 'Start time' }, { key: valueKey, label: 'Value' }];
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DISPLAY_PRECISION_PLACES, 'DISPLAY_PRECISION_PLACES', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(noData, 'noData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getBasalRate, 'getBasalRate', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getValue, 'getValue', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getBloodGlucoseValue, 'getBloodGlucoseValue', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getStarts, 'getStarts', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getTotalBasalRates, 'getTotalBasalRates', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getScheduleLabel, 'getScheduleLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getScheduleNames, 'getScheduleNames', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getTimedSchedules, 'getTimedSchedules', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(getDeviceMeta, 'getDeviceMeta', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processBasalRateData, 'processBasalRateData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processBgTargetData, 'processBgTargetData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processCarbRatioData, 'processCarbRatioData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processSensitivityData, 'processSensitivityData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(processTimedSettings, 'processTimedSettings', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	
	  __REACT_HOT_LOADER__.register(startTimeAndValue, 'startTimeAndValue', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/data.js');
	})();

	;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                               * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                               * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                               * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                               * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                               * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                               * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                               * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                               */
	
	exports.nonTandemText = nonTandemText;
	exports.tandemText = tandemText;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _textTable = __webpack_require__(81);
	
	var _textTable2 = _interopRequireDefault(_textTable);
	
	var _tandemData = __webpack_require__(82);
	
	var tandemData = _interopRequireWildcard(_tandemData);
	
	var _nonTandemData = __webpack_require__(78);
	
	var nonTandemData = _interopRequireWildcard(_nonTandemData);
	
	var _datetime = __webpack_require__(20);
	
	var _misc = __webpack_require__(83);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * getItemField
	 * @private
	 */
	function getItemField(item, field) {
	  return item[field];
	}
	
	/**
	 * normalizeColumns
	 * @private
	 */
	function normalizeColumns(columns) {
	  return _lodash2.default.map(columns, function (column) {
	    return {
	      cell: getItemField,
	      key: column.key,
	      label: column.label
	    };
	  });
	}
	
	/**
	 * getRow
	 * @private
	 */
	function getRow(normalizedColumns, rowKey, rowData) {
	  return _lodash2.default.map(normalizedColumns, function (column) {
	    return column.cell(rowData, column.key);
	  });
	}
	
	/**
	 * getHeader
	 * @private
	 */
	function getHeader(normalizedColumns) {
	  return _lodash2.default.map(normalizedColumns, function (column) {
	    if (_typeof(column.label) === 'object') {
	      return column.label.main + ' ' + column.label.secondary;
	    }
	    return column.label;
	  });
	}
	
	/**
	 * getRows
	 * @private
	 */
	function getRows(rows, columns) {
	  return _lodash2.default.map(rows, function (row, key) {
	    return getRow(normalizeColumns(columns), key, row);
	  });
	}
	
	/**
	 * toTextTable
	 * @private
	 */
	function toTextTable(rows, columns) {
	  var header = [getHeader(normalizeColumns(columns))];
	  var content = getRows(rows, columns);
	  return (0, _textTable2.default)(header.concat(content));
	}
	
	/**
	 * buildTextTable
	 * @private
	 */
	function buildTextTable(name, rows, columns) {
	  return '\n' + name + '\n' + toTextTable(rows, columns) + '\n';
	}
	
	/**
	 * formatTitle
	 * @private
	 */
	function formatTitle(patient) {
	  var exported = 'Exported from Tidepool: ' + (0, _datetime.formatCurrentDate)();
	  var bday = 'Date of birth: ' + (0, _datetime.formatBirthdate)(patient);
	  var diagnosis = 'Date of diagnosis: ' + (0, _datetime.formatDiagnosisDate)(patient);
	  var fullname = (0, _misc.getPatientFullName)(patient);
	  return fullname + '\n' + bday + '\n' + diagnosis + '\n' + exported + '\n';
	}
	
	/**
	 * nonTandemText
	 * @param  {Object} patient     the patient object that contains the profile
	 * @param  {String} units         MGDL_UNITS or MMOLL_UNITS
	 * @param  {String} manufacturer  one of: animas, carelink, insulet, medtronic
	 *
	 * @return {String}               non tandem settings as a string table
	 */
	function nonTandemText(patient, settings, units, manufacturer) {
	  var tablesString = formatTitle(patient);
	  _lodash2.default.map(nonTandemData.basalSchedules(settings), function (schedule) {
	    var basal = nonTandemData.basal(schedule, settings, manufacturer);
	    tablesString += buildTextTable(basal.scheduleName, basal.rows, basal.columns);
	  });
	
	  var sensitivity = nonTandemData.sensitivity(settings, manufacturer, units);
	  tablesString += buildTextTable(sensitivity.title + ' ' + units + '/U', sensitivity.rows, sensitivity.columns);
	
	  var target = nonTandemData.target(settings, manufacturer);
	  tablesString += buildTextTable(target.title + ' ' + units, target.rows, target.columns);
	
	  var ratio = nonTandemData.ratio(settings, manufacturer);
	  tablesString += buildTextTable(ratio.title + ' g/U', ratio.rows, ratio.columns);
	
	  return tablesString;
	}
	
	/**
	 * tandemText
	 * @param  {Object} patient     the patient object that contains the profile
	 * @param  {Object} settings    all settings data
	 * @param  {String} units       MGDL_UNITS or MMOLL_UNITS
	 *
	 * @return {String}             tandem settings as a string table
	 */
	function tandemText(patient, settings, units) {
	  var styles = {
	    bolusSettingsHeader: '',
	    basalScheduleHeader: ''
	  };
	
	  var tablesString = formatTitle(patient);
	  _lodash2.default.map(tandemData.basalSchedules(settings), function (schedule) {
	    var basal = tandemData.basal(schedule, settings, units, styles);
	    tablesString += buildTextTable(basal.scheduleName, basal.rows, basal.columns);
	  });
	  return tablesString;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getItemField, 'getItemField', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(normalizeColumns, 'normalizeColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getRow, 'getRow', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getHeader, 'getHeader', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(getRows, 'getRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(toTextTable, 'toTextTable', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(buildTextTable, 'buildTextTable', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(formatTitle, 'formatTitle', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(nonTandemText, 'nonTandemText', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	
	  __REACT_HOT_LOADER__.register(tandemText, 'tandemText', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/textData.js');
	})();

	;

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = function (rows_, opts) {
	    if (!opts) opts = {};
	    var hsep = opts.hsep === undefined ? '  ' : opts.hsep;
	    var align = opts.align || [];
	    var stringLength = opts.stringLength
	        || function (s) { return String(s).length; }
	    ;
	    
	    var dotsizes = reduce(rows_, function (acc, row) {
	        forEach(row, function (c, ix) {
	            var n = dotindex(c);
	            if (!acc[ix] || n > acc[ix]) acc[ix] = n;
	        });
	        return acc;
	    }, []);
	    
	    var rows = map(rows_, function (row) {
	        return map(row, function (c_, ix) {
	            var c = String(c_);
	            if (align[ix] === '.') {
	                var index = dotindex(c);
	                var size = dotsizes[ix] + (/\./.test(c) ? 1 : 2)
	                    - (stringLength(c) - index)
	                ;
	                return c + Array(size).join(' ');
	            }
	            else return c;
	        });
	    });
	    
	    var sizes = reduce(rows, function (acc, row) {
	        forEach(row, function (c, ix) {
	            var n = stringLength(c);
	            if (!acc[ix] || n > acc[ix]) acc[ix] = n;
	        });
	        return acc;
	    }, []);
	    
	    return map(rows, function (row) {
	        return map(row, function (c, ix) {
	            var n = (sizes[ix] - stringLength(c)) || 0;
	            var s = Array(Math.max(n + 1, 1)).join(' ');
	            if (align[ix] === 'r' || align[ix] === '.') {
	                return s + c;
	            }
	            if (align[ix] === 'c') {
	                return Array(Math.ceil(n / 2 + 1)).join(' ')
	                    + c + Array(Math.floor(n / 2 + 1)).join(' ')
	                ;
	            }
	            
	            return c + s;
	        }).join(hsep).replace(/\s+$/, '');
	    }).join('\n');
	};
	
	function dotindex (c) {
	    var m = /\.[^.]*$/.exec(c);
	    return m ? m.index + 1 : c.length;
	}
	
	function reduce (xs, f, init) {
	    if (xs.reduce) return xs.reduce(f, init);
	    var i = 0;
	    var acc = arguments.length >= 3 ? init : xs[i++];
	    for (; i < xs.length; i++) {
	        f(acc, xs[i], i);
	    }
	    return acc;
	}
	
	function forEach (xs, f) {
	    if (xs.forEach) return xs.forEach(f);
	    for (var i = 0; i < xs.length; i++) {
	        f.call(xs, xs[i], i);
	    }
	}
	
	function map (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        res.push(f.call(xs, xs[i], i));
	    }
	    return res;
	}


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.basalSchedules = basalSchedules;
	exports.deviceMeta = deviceMeta;
	exports.basal = basal;
	
	var _data = __webpack_require__(79);
	
	var data = _interopRequireWildcard(_data);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * basalSchedules
	 * @param  {Object} settings    object with basal schedule properties
	 *
	 * @return {Array}              array of basal schedule names
	 */
	function basalSchedules(settings) {
	  return data.getTimedSchedules(settings.basalSchedules);
	}
	
	/**
	 * deviceMeta
	 * @param  {Object} settingsData all settings data
	 * @param  {Object} timePrefs    timezone preferences object
	 *
	 * @return {Object}              filtered meta data
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	function deviceMeta(settings, timePrefs) {
	  return data.getDeviceMeta(settings, timePrefs);
	}
	
	/**
	 * scheduleLabel
	 * @private
	 */
	function scheduleLabel(scheduleName, activeScheduleName) {
	  return data.getScheduleLabel(scheduleName, activeScheduleName, 'tandem', true);
	}
	
	/**
	 * basalRows
	 * @private
	 */
	function basalRows(schedule, settings, units) {
	  return data.processTimedSettings(settings, schedule, units);
	}
	
	/**
	 * basalColumns
	 * @private
	 */
	function basalColumns(styles, units) {
	  return [{ key: 'start',
	    label: 'Start time' }, { key: 'rate',
	    label: {
	      main: 'Basal Rates',
	      secondary: 'U/hr'
	    },
	    className: styles.basalScheduleHeader }, { key: 'bgTarget',
	    label: {
	      main: 'Target BG',
	      secondary: units
	    },
	    className: styles.bolusSettingsHeader }, { key: 'carbRatio',
	    label: {
	      main: 'Carb Ratio',
	      secondary: 'g/U'
	    },
	    className: styles.bolusSettingsHeader }, { key: 'insulinSensitivity',
	    label: {
	      main: 'Correction Factor',
	      secondary: units + '/U'
	    },
	    className: styles.bolusSettingsHeader }];
	}
	
	/**
	 * basal
	 *
	 * @param  {Object} schedule       object schedule to build basal data from
	 * @param  {Object} settings       object with pump settings data
	 * @param  {String} units          MGDL_UNITS or MMOLL_UNITS
	 * @param  {String} styles         object with applicable styles
	 * @return {Object}                object with basal title, columns and rows
	 */
	function basal(schedule, settings, units, styles) {
	  return {
	    scheduleName: schedule.name,
	    activeAtUpload: schedule.name === settings.activeSchedule,
	    title: scheduleLabel(schedule.name, settings.activeSchedule),
	    columns: basalColumns(styles, units),
	    rows: basalRows(schedule, settings, units)
	  };
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(basalSchedules, 'basalSchedules', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(deviceMeta, 'deviceMeta', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(scheduleLabel, 'scheduleLabel', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalRows, 'basalRows', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basalColumns, 'basalColumns', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	
	  __REACT_HOT_LOADER__.register(basal, 'basal', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/settings/tandemData.js');
	})();

	;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPatientFullName = getPatientFullName;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * getPatientFullName
	 * @param {Object} patient - Tidepool patient object containing profile
	 *
	 * @return {String} PwD's full name (first & last)
	 */
	function getPatientFullName(patient) {
	  var profile = _lodash2.default.get(patient, ['profile'], {});
	  var patientInfo = profile.patient || {};
	
	  if (patientInfo.isOtherPerson) {
	    return patientInfo.fullName;
	  }
	  return profile.fullName;
	} /*
	   * == BSD2 LICENSE ==
	   * Copyright (c) 2017, Tidepool Project
	   *
	   * This program is free software; you can redistribute it and/or modify it under
	   * the terms of the associated License, which is identical to the BSD 2-Clause
	   * License as published by the Open Source Initiative at opensource.org.
	   *
	   * This program is distributed in the hope that it will be useful, but WITHOUT
	   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	   * FOR A PARTICULAR PURPOSE. See the License for more details.
	   *
	   * You should have received a copy of the License along with this program; if
	   * not, you can obtain one from Tidepool Project at tidepool.org.
	   * == BSD2 LICENSE ==
	   */
	
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getPatientFullName, 'getPatientFullName', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/misc.js');
	})();

	;

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var DISPLAY_VIEW = exports.DISPLAY_VIEW = 'display';
	var PRINT_VIEW = exports.PRINT_VIEW = 'print';
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DISPLAY_VIEW, 'DISPLAY_VIEW', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/constants.js');
	
	  __REACT_HOT_LOADER__.register(PRINT_VIEW, 'PRINT_VIEW', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/constants.js');
	})();

	;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./NonTandem.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./NonTandem.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(63), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".NonTandem--settingsContainer--2fKe2{align-items:flex-start;display:flex;justify-content:flex-start}.NonTandem--basalSettingsContainer--1Gj53{margin-right:10px}.NonTandem--bolusSettingsContainer--1o-pm{display:flex;flex-wrap:wrap}.NonTandem--categoryTitle--2pdui{width:100%;padding-bottom:10px}.NonTandem--categoryContainer--3Q1L4{max-width:300px;min-width:240px;margin-bottom:10px;margin-right:10px}.NonTandem--basalTable--HXb6D td:first-child,.NonTandem--basalTable--HXb6D th:first-child{padding-left:28px}.NonTandem--settingsTable--12bkW td:first-child,.NonTandem--settingsTable--12bkW th:first-child{padding-left:28px}.NonTandem--singleLineBasalScheduleHeader--1Q1_w{justify-content:space-between}@media print{.NonTandem--categoryContainer--3Q1L4{max-width:280px;min-width:250px;width:100%;margin-bottom:10px;margin-right:10px}.NonTandem--settingsContainer--2fKe2{display:block}.NonTandem--basalSettingsContainer--1Gj53{display:flex;flex-flow:row wrap;justify-content:flex-start;page-break-after:auto}.NonTandem--bolusSettingsContainer--1o-pm{display:flex;flex-flow:row wrap;justify-content:flex-start;page-break-inside:avoid}.NonTandem--categoryTitle--2pdui{font-weight:400;font-size:20px;color:var(--text-black);width:100%;padding-bottom:10px}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "NonTandem--copyButton--1rRY7 " + __webpack_require__(63).locals["copyButton"] + " " + __webpack_require__(63).locals["copyButton"] + "",
		"copyText": "NonTandem--copyText--3Ez6d " + __webpack_require__(63).locals["copyText"] + "",
		"settingsContainer": "NonTandem--settingsContainer--2fKe2",
		"basalSettingsContainer": "NonTandem--basalSettingsContainer--1Gj53",
		"bolusSettingsContainer": "NonTandem--bolusSettingsContainer--1o-pm",
		"categoryTitle": "NonTandem--categoryTitle--2pdui " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"categoryContainer": "NonTandem--categoryContainer--3Q1L4",
		"basalTable": "NonTandem--basalTable--HXb6D " + __webpack_require__(63).locals["basalTable"] + "",
		"settingsTable": "NonTandem--settingsTable--12bkW " + __webpack_require__(63).locals["settingsTable"] + "",
		"singleLineBasalScheduleHeader": "NonTandem--singleLineBasalScheduleHeader--1Q1_w " + __webpack_require__(63).locals["basalHeaderBackground"] + " " + __webpack_require__(63).locals["settingsHeader"] + "",
		"twoLineBasalScheduleHeader": "NonTandem--twoLineBasalScheduleHeader--1JyRt " + __webpack_require__(63).locals["basalHeaderBackground"] + " " + __webpack_require__(63).locals["settingsHeaderDecoration"] + " " + __webpack_require__(63).locals["settingsHeaderLayout"] + " " + __webpack_require__(63).locals["settingsHeaderText"] + "",
		"bolusSettingsHeader": "NonTandem--bolusSettingsHeader--YxGSG " + __webpack_require__(63).locals["bolusHeaderBackground"] + " " + __webpack_require__(63).locals["settingsHeader"] + "",
		"printNotes": "NonTandem--printNotes--3adsF " + __webpack_require__(63).locals["printNotes"] + ""
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactClipboard = __webpack_require__(48);
	
	var _reactClipboard2 = _interopRequireDefault(_reactClipboard);
	
	var _Tandem = __webpack_require__(88);
	
	var _Tandem2 = _interopRequireDefault(_Tandem);
	
	var _Header = __webpack_require__(57);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Table = __webpack_require__(60);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _CollapsibleContainer = __webpack_require__(65);
	
	var _CollapsibleContainer2 = _interopRequireDefault(_CollapsibleContainer);
	
	var _constants = __webpack_require__(16);
	
	var _tandemData = __webpack_require__(82);
	
	var tandemData = _interopRequireWildcard(_tandemData);
	
	var _textData = __webpack_require__(80);
	
	var _constants2 = __webpack_require__(84);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tandem = function Tandem(props) {
	  var bgUnits = props.bgUnits,
	      copySettingsClicked = props.copySettingsClicked,
	      openedSections = props.openedSections,
	      pumpSettings = props.pumpSettings,
	      timePrefs = props.timePrefs,
	      toggleProfileExpansion = props.toggleProfileExpansion,
	      user = props.user,
	      view = props.view;
	
	
	  function renderBreathingSpace() {
	    if (view === _constants2.PRINT_VIEW) {
	      return _react2.default.createElement(
	        'div',
	        { className: _Tandem2.default.printNotes },
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement('hr', null)
	      );
	    }
	    return null;
	  }
	
	  function openSection(sectionName) {
	    if (view === _constants2.PRINT_VIEW) {
	      return true;
	    }
	    return _lodash2.default.get(openedSections, sectionName, false);
	  }
	
	  var tables = _lodash2.default.map(tandemData.basalSchedules(pumpSettings), function (schedule) {
	    var basal = tandemData.basal(schedule, pumpSettings, bgUnits, _Tandem2.default);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'settings-table-container', key: basal.scheduleName },
	      _react2.default.createElement(
	        _CollapsibleContainer2.default,
	        {
	          label: basal.title,
	          labelClass: _Tandem2.default.collapsibleLabel,
	          opened: openSection(basal.scheduleName),
	          toggleExpansion: _lodash2.default.partial(toggleProfileExpansion, basal.scheduleName),
	          twoLineLabel: false
	        },
	        _react2.default.createElement(_Table2.default, {
	          rows: basal.rows,
	          columns: basal.columns,
	          tableStyle: _Tandem2.default.profileTable
	        })
	      ),
	      renderBreathingSpace()
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactClipboard2.default,
	      {
	        className: _Tandem2.default.copyButton,
	        'button-title': 'For email or notes',
	        'data-clipboard-target': '#copySettingsText',
	        onSuccess: copySettingsClicked
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Copy as text'
	      )
	    ),
	    _react2.default.createElement(_Header2.default, {
	      deviceDisplayName: 'Tandem',
	      deviceMeta: tandemData.deviceMeta(pumpSettings, timePrefs),
	      printView: view === _constants2.PRINT_VIEW
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _Tandem2.default.title },
	        'Profile Settings'
	      ),
	      tables
	    ),
	    _react2.default.createElement(
	      'pre',
	      { className: _Tandem2.default.copyText, id: 'copySettingsText' },
	      (0, _textData.tandemText)(user, pumpSettings, bgUnits)
	    )
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	Tandem.propTypes = {
	  bgUnits: _react.PropTypes.oneOf([_constants.MMOLL_UNITS, _constants.MGDL_UNITS]).isRequired,
	  copySettingsClicked: _react.PropTypes.func.isRequired,
	  deviceKey: _react.PropTypes.oneOf(['tandem']).isRequired,
	  openedSections: _react.PropTypes.object.isRequired,
	  pumpSettings: _react.PropTypes.shape({
	    activeSchedule: _react.PropTypes.string.isRequired,
	    units: _react.PropTypes.object.isRequired,
	    deviceId: _react.PropTypes.string.isRequired,
	    basalSchedules: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      name: _react.PropTypes.string.isRequired,
	      value: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        start: _react.PropTypes.number.isRequired,
	        rate: _react.PropTypes.number.isRequired
	      }))
	    }).isRequired).isRequired,
	    bgTargets: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      target: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired,
	    carbRatios: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired,
	    insulinSensitivities: _react.PropTypes.objectOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
	      start: _react.PropTypes.number.isRequired,
	      amount: _react.PropTypes.number.isRequired
	    })).isRequired).isRequired
	  }).isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react.PropTypes.oneOfType([_react.PropTypes.string, null])
	  }).isRequired,
	  toggleProfileExpansion: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  view: _react.PropTypes.oneOf([_constants2.DISPLAY_VIEW, _constants2.PRINT_VIEW]).isRequired
	};
	
	Tandem.defaultProps = {
	  deviceDisplayName: 'Tandem',
	  deviceKey: 'tandem',
	  view: _constants2.DISPLAY_VIEW
	};
	
	var _default = Tandem;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Tandem, 'Tandem', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/Tandem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/settings/Tandem.js');
	})();

	;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./Tandem.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../node_modules/postcss-loader/index.js!./Tandem.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(64), "");
	exports.i(__webpack_require__(63), undefined);
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".Tandem--headerCommon--jh5e1{line-height:20px}.Tandem--collapsibleLabel--11wnp{border-top:1px solid var(--collapsible--border);justify-content:flex-start;line-height:40px;margin-left:20px;padding-left:1em}.Tandem--profileTable--zPo8g{padding-bottom:1em;margin-left:40px;width:800px}.Tandem--profileTable--zPo8g td,.Tandem--profileTable--zPo8g th{font-size:14px;text-align:center}.Tandem--profileTable--zPo8g th:first-of-type{font-weight:700}.Tandem--title--3io-V{display:inline-block;padding-bottom:10px}@media print{.Tandem--title--3io-V{font-weight:400;font-size:20px;color:var(--text-black);display:inline-block;padding-bottom:10px}.Tandem--profileTable--zPo8g th{font-weight:400;color:#000}.Tandem--profileTable--zPo8g th:first-of-type{font-weight:400}.Tandem--printNotes--2fvlw{margin-left:40px}}", ""]);
	
	// exports
	exports.locals = {
		"copyButton": "Tandem--copyButton--aSN26 " + __webpack_require__(63).locals["copyButton"] + " " + __webpack_require__(63).locals["copyButton"] + "",
		"copyText": "Tandem--copyText--1UIV1 " + __webpack_require__(63).locals["copyText"] + "",
		"headerCommon": "Tandem--headerCommon--jh5e1",
		"basalScheduleHeader": "Tandem--basalScheduleHeader--2FrXF " + __webpack_require__(63).locals["basalHeaderBackground"] + " " + __webpack_require__(63).locals["settingsHeaderText"] + " Tandem--headerCommon--jh5e1",
		"bolusSettingsHeader": "Tandem--bolusSettingsHeader--2LSvh " + __webpack_require__(63).locals["bolusHeaderBackground"] + " " + __webpack_require__(63).locals["settingsHeaderText"] + " Tandem--headerCommon--jh5e1",
		"collapsibleLabel": "Tandem--collapsibleLabel--11wnp",
		"profileTable": "Tandem--profileTable--zPo8g " + __webpack_require__(63).locals["basalTable"] + "",
		"title": "Tandem--title--3io-V " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["defaultSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + "",
		"printNotes": "Tandem--printNotes--2fvlw " + __webpack_require__(63).locals["printNotes"] + ""
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TrendsContainer = undefined;
	
	var _PropTypes$shape, _yScaleClampTop;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getAllDatesInRange = getAllDatesInRange;
	exports.getLocalizedNoonBeforeUTC = getLocalizedNoonBeforeUTC;
	exports.getLocalizedOffset = getLocalizedOffset;
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bows = __webpack_require__(91);
	
	var _bows2 = _interopRequireDefault(_bows);
	
	var _d3Array = __webpack_require__(26);
	
	var _d3Scale = __webpack_require__(94);
	
	var _d3Time = __webpack_require__(11);
	
	var _momentTimezone = __webpack_require__(21);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _actions = __webpack_require__(32);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _TrendsSVGContainer = __webpack_require__(95);
	
	var _TrendsSVGContainer2 = _interopRequireDefault(_TrendsSVGContainer);
	
	var _constants = __webpack_require__(16);
	
	var _datetime = __webpack_require__(20);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CBG_READINGS_ONE_DAY = 86400000 / (1000 * 60 * 5);
	
	var _trends$extentSizes = _constants.trends.extentSizes,
	    ONE_WEEK = _trends$extentSizes.ONE_WEEK,
	    TWO_WEEKS = _trends$extentSizes.TWO_WEEKS,
	    FOUR_WEEKS = _trends$extentSizes.FOUR_WEEKS;
	
	
	/**
	 * getAllDatesInRange
	 * @param {String} start - Zulu timestamp (Integer hammertime also OK)
	 * @param {String} end - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {Array} dates - array of YYYY-MM-DD String dates
	 */
	function getAllDatesInRange(start, end, timePrefs) {
	  var timezoneName = datetime.getTimezoneFromTimePrefs(timePrefs);
	  var dates = [];
	  var current = _momentTimezone2.default.utc(start).tz(timezoneName);
	  var excludedBoundary = _momentTimezone2.default.utc(end);
	  while (current.isBefore(excludedBoundary)) {
	    dates.push(current.format('YYYY-MM-DD'));
	    current.add(1, 'day');
	  }
	  return dates;
	}
	
	/**
	 * getLocalizedNoonBeforeUTC
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {JavaScript Date} the closet noon before the input datetime in the given timezone
	 */
	function getLocalizedNoonBeforeUTC(utc, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	  var ceil = datetime.getLocalizedCeiling(utc, timePrefs);
	  return _momentTimezone2.default.utc(ceil.valueOf()).tz(timezone).subtract(1, 'day').hours(12).toDate();
	}
	
	/**
	 * getLocalizedOffset
	 * @param {String} utc - Zulu timestamp (Integer hammertime also OK)
	 * @param {Object} offset - { amount: integer (+/-), units: 'hour', 'day', &c }
	 * @param {Object} timePrefs - object containing timezoneAware Boolean and timezoneName String
	 *
	 * @return {JavaScript Date} datetime at the specified +/- offset from the input datetime
	 *                           inspired by d3-time's offset function: https://github.com/d3/d3-time#interval_offset
	 *                           but able to work with an arbitrary timezone
	 */
	function getLocalizedOffset(utc, offset, timePrefs) {
	  if (utc instanceof Date) {
	    throw new Error('`utc` must be a ISO-formatted String timestamp or integer hammertime!');
	  }
	  var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	  return _momentTimezone2.default.utc(utc).tz(timezone).add(offset.amount, offset.units).toDate();
	}
	
	var TrendsContainer = exports.TrendsContainer = function (_PureComponent) {
	  _inherits(TrendsContainer, _PureComponent);
	
	  function TrendsContainer(props) {
	    _classCallCheck(this, TrendsContainer);
	
	    var _this = _possibleConstructorReturn(this, (TrendsContainer.__proto__ || Object.getPrototypeOf(TrendsContainer)).call(this, props));
	
	    _this.log = (0, _bows2.default)('TrendsContainer');
	    _this.state = {
	      currentCbgData: [],
	      currentSmbgData: [],
	      dateDomain: null,
	      mostRecent: null,
	      previousDateDomain: null,
	      xScale: null,
	      yScale: null
	    };
	
	    _this.selectDate = _this.selectDate.bind(_this);
	    return _this;
	  }
	
	  _createClass(TrendsContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // find BG domain (for yScale construction)
	      var _props = this.props,
	          cbgByDate = _props.cbgByDate,
	          cbgByDayOfWeek = _props.cbgByDayOfWeek,
	          smbgByDate = _props.smbgByDate,
	          smbgByDayOfWeek = _props.smbgByDayOfWeek;
	
	      var allBg = cbgByDate.filterAll().top(Infinity).concat(smbgByDate.filterAll().top(Infinity));
	      var bgDomain = (0, _d3Array.extent)(allBg, function (d) {
	        return d.value;
	      });
	
	      var _props2 = this.props,
	          _props2$bgPrefs = _props2.bgPrefs,
	          bgBounds = _props2$bgPrefs.bgBounds,
	          bgUnits = _props2$bgPrefs.bgUnits,
	          yScaleClampTop = _props2.yScaleClampTop;
	
	      var upperBound = yScaleClampTop[bgUnits];
	      var yScaleDomain = [bgDomain[0], upperBound];
	      if (bgDomain[0] > bgBounds.targetLowerBound) {
	        yScaleDomain[0] = bgBounds.targetLowerBound;
	      }
	      var yScale = (0, _d3Scale.scaleLinear)().domain(yScaleDomain).clamp(true);
	
	      // find initial date domain (based on initialDatetimeLocation or current time)
	      var _props3 = this.props,
	          extentSize = _props3.extentSize,
	          initialDatetimeLocation = _props3.initialDatetimeLocation,
	          timePrefs = _props3.timePrefs;
	
	      var timezone = datetime.getTimezoneFromTimePrefs(timePrefs);
	      var mostRecent = datetime.getLocalizedCeiling(new Date().valueOf(), timezone);
	      var end = initialDatetimeLocation ? datetime.getLocalizedCeiling(initialDatetimeLocation, timezone) : mostRecent;
	      var start = _d3Time.utcDay.offset(end, -extentSize);
	      var dateDomain = [start.toISOString(), end.toISOString()];
	
	      // filter data according to current activeDays and dateDomain
	      this.initialFiltering(cbgByDate, cbgByDayOfWeek, dateDomain);
	      this.initialFiltering(smbgByDate, smbgByDayOfWeek, dateDomain);
	      this.setState({
	        bgDomain: { lo: bgDomain[0], hi: bgDomain[1] },
	        currentCbgData: cbgByDate.top(Infinity).reverse(),
	        currentSmbgData: smbgByDate.top(Infinity).reverse(),
	        dateDomain: { start: dateDomain[0], end: dateDomain[1] },
	        mostRecent: mostRecent.toISOString(),
	        xScale: (0, _d3Scale.scaleLinear)().domain([0, 864e5]),
	        yScale: yScale
	      }, this.determineDataToShow);
	      this.props.onDatetimeLocationChange(dateDomain, end === mostRecent);
	    }
	
	    /*
	     * NB: we don't do as much here as one might expect
	     * because we're using the "expose component functions"
	     * strategy of communicating between components
	     * (https://facebook.github.io/react/tips/expose-component-functions.html)
	     * this is the legacy of blip's interface with the d3.chart-architected
	     * smbg version of trends view and thus only remains
	     * as a temporary compatibility interface
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(nextProps.activeDays, this.props.activeDays)) {
	        var cbgByDayOfWeek = nextProps.cbgByDayOfWeek,
	            smbgByDayOfWeek = nextProps.smbgByDayOfWeek,
	            smbgByDate = nextProps.smbgByDate,
	            cbgByDate = nextProps.cbgByDate;
	
	        this.refilterByDayOfWeek(cbgByDayOfWeek, nextProps.activeDays);
	        this.refilterByDayOfWeek(smbgByDayOfWeek, nextProps.activeDays);
	        this.setState({
	          currentCbgData: cbgByDate.top(Infinity).reverse(),
	          currentSmbgData: smbgByDate.top(Infinity).reverse()
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props4 = this.props,
	          currentPatientInViewId = _props4.currentPatientInViewId,
	          trendsState = _props4.trendsState,
	          unfocusCbgSlice = _props4.unfocusCbgSlice,
	          unfocusSmbg = _props4.unfocusSmbg,
	          unfocusSmbgRangeAvg = _props4.unfocusSmbgRangeAvg;
	
	      if (_lodash2.default.get(trendsState, 'focusedCbgSlice') !== null) {
	        unfocusCbgSlice(currentPatientInViewId);
	      }
	      if (_lodash2.default.get(trendsState, 'focusedSmbg') !== null) {
	        unfocusSmbg(currentPatientInViewId);
	      }
	      if (_lodash2.default.get(trendsState, 'focusedSmbgRangeAvg') !== null) {
	        unfocusSmbgRangeAvg(currentPatientInViewId);
	      }
	    }
	  }, {
	    key: 'getCurrentDay',
	    value: function getCurrentDay() {
	      var end = this.state.dateDomain.end;
	
	      return getLocalizedNoonBeforeUTC(end, this.props.timePrefs).toISOString();
	    }
	  }, {
	    key: 'setExtent',
	    value: function setExtent(newDomain, oldDomain) {
	      var _props5 = this.props,
	          cbgByDate = _props5.cbgByDate,
	          smbgByDate = _props5.smbgByDate;
	      var mostRecent = this.state.mostRecent;
	
	      this.refilterByDate(cbgByDate, newDomain);
	      this.refilterByDate(smbgByDate, newDomain);
	      this.setState({
	        currentCbgData: cbgByDate.top(Infinity).reverse(),
	        currentSmbgData: smbgByDate.top(Infinity).reverse(),
	        dateDomain: { start: newDomain[0], end: newDomain[1] },
	        previousDateDomain: oldDomain ? { start: oldDomain[0], end: oldDomain[1] } : null
	      });
	      this.props.onDatetimeLocationChange(newDomain, newDomain[1] >= mostRecent);
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate() {
	      var _this2 = this;
	
	      var timePrefs = this.props.timePrefs;
	
	      return function (date) {
	        var noonOnDate = _momentTimezone2.default.tz(date, datetime.getTimezoneFromTimePrefs(timePrefs)).startOf('day').add(12, 'hours').toISOString();
	        _this2.props.onSelectDate(noonOnDate);
	      };
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      var oldDomain = _lodash2.default.clone(this.state.dateDomain);
	      var newEnd = this.state.dateDomain.start;
	
	      var start = getLocalizedOffset(newEnd, {
	        // negative because we are moving backward in time
	        amount: -this.props.extentSize,
	        units: 'days'
	      }, this.props.timePrefs).toISOString();
	      var newDomain = [start, newEnd];
	      this.setExtent(newDomain, [oldDomain.start, oldDomain.end]);
	    }
	  }, {
	    key: 'goForward',
	    value: function goForward() {
	      var oldDomain = _lodash2.default.clone(this.state.dateDomain);
	      var newStart = this.state.dateDomain.end;
	
	      var end = _d3Time.utcDay.offset(new Date(newStart), this.props.extentSize).toISOString();
	      var newDomain = [newStart, end];
	      this.setExtent(newDomain, [oldDomain.start, oldDomain.end]);
	    }
	  }, {
	    key: 'goToMostRecent',
	    value: function goToMostRecent() {
	      var end = this.state.mostRecent;
	
	      var start = _d3Time.utcDay.offset(new Date(end), -this.props.extentSize).toISOString();
	      var newDomain = [start, end];
	      this.setExtent(newDomain);
	    }
	  }, {
	    key: 'refilterByDate',
	    value: function refilterByDate(dataByDate, dateDomain) {
	      // eslint-disable-next-line lodash/prefer-lodash-method
	      dataByDate.filter(dateDomain);
	    }
	  }, {
	    key: 'refilterByDayOfWeek',
	    value: function refilterByDayOfWeek(dataByDayOfWeek, activeDays) {
	      dataByDayOfWeek.filterFunction(this.filterActiveDaysFn(activeDays));
	    }
	  }, {
	    key: 'initialFiltering',
	    value: function initialFiltering(dataByDate, dataByDayOfWeek, dateDomain) {
	      var activeDays = this.props.activeDays;
	      // clear old filters
	
	      dataByDayOfWeek.filterAll();
	
	      // filter by day of week (Monday, Tuesday, etc.)
	      dataByDayOfWeek.filterFunction(this.filterActiveDaysFn(activeDays));
	
	      // filter within date domain
	      // eslint-disable-next-line lodash/prefer-lodash-method
	      dataByDate.filter(dateDomain);
	    }
	  }, {
	    key: 'filterActiveDaysFn',
	    value: function filterActiveDaysFn(activeDays) {
	      return function (d) {
	        return activeDays[d];
	      };
	    }
	  }, {
	    key: 'determineDataToShow',
	    value: function determineDataToShow() {
	      var _props6 = this.props,
	          currentPatientInViewId = _props6.currentPatientInViewId,
	          touched = _props6.trendsState.touched;
	
	      if (touched) {
	        return;
	      }
	      var currentCbgData = this.state.currentCbgData;
	      var _props7 = this.props,
	          extentSize = _props7.extentSize,
	          showingCbg = _props7.showingCbg;
	
	      var minimumCbgs = extentSize * CBG_READINGS_ONE_DAY / 2;
	      if (showingCbg && currentCbgData.length < minimumCbgs) {
	        this.props.onSwitchBgDataSource();
	      }
	      this.props.markTrendsViewed(currentPatientInViewId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dateDomain = this.state.dateDomain,
	          currentStart = _state$dateDomain.start,
	          currentEnd = _state$dateDomain.end;
	
	      var prevStart = _lodash2.default.get(this.state, ['previousDateDomain', 'start']);
	      var prevEnd = _lodash2.default.get(this.state, ['previousDateDomain', 'end']);
	      var start = currentStart;
	      var end = currentEnd;
	      if (prevStart && prevEnd) {
	        if (currentStart < prevStart) {
	          end = prevEnd;
	        } else if (prevStart < currentStart) {
	          start = prevStart;
	        }
	      }
	      return _react2.default.createElement(_TrendsSVGContainer2.default, {
	        activeDays: this.props.activeDays,
	        bgPrefs: this.props.bgPrefs,
	        smbgData: this.state.currentSmbgData,
	        cbgData: this.state.currentCbgData,
	        dates: getAllDatesInRange(start, end, this.props.timePrefs),
	        focusedSlice: this.props.trendsState.focusedCbgSlice,
	        focusedSliceKeys: this.props.trendsState.focusedCbgSliceKeys,
	        focusedSmbgRangeAvgKey: _lodash2.default.get(this.props, ['trendsState', 'focusedSmbgRangeAvg', 'data', 'id'], null),
	        focusedSmbg: this.props.trendsState.focusedSmbg,
	        displayFlags: this.props.trendsState.cbgFlags,
	        showingCbg: this.props.showingCbg,
	        showingCbgDateTraces: _lodash2.default.get(this.props, ['trendsState', 'showingCbgDateTraces'], false),
	        showingSmbg: this.props.showingSmbg,
	        smbgGrouped: this.props.smbgGrouped,
	        smbgLines: this.props.smbgLines,
	        smbgRangeOverlay: this.props.smbgRangeOverlay,
	        onSelectDate: this.selectDate(),
	        xScale: this.state.xScale,
	        yScale: this.state.yScale
	      });
	    }
	  }]);
	
	  return TrendsContainer;
	}(_react.PureComponent);
	
	TrendsContainer.propTypes = {
	  activeDays: _react.PropTypes.shape({
	    monday: _react.PropTypes.bool.isRequired,
	    tuesday: _react.PropTypes.bool.isRequired,
	    wednesday: _react.PropTypes.bool.isRequired,
	    thursday: _react.PropTypes.bool.isRequired,
	    friday: _react.PropTypes.bool.isRequired,
	    saturday: _react.PropTypes.bool.isRequired,
	    sunday: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }).isRequired,
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  currentPatientInViewId: _react.PropTypes.string.isRequired,
	  extentSize: _react.PropTypes.oneOf([ONE_WEEK, TWO_WEEKS, FOUR_WEEKS]).isRequired,
	  initialDatetimeLocation: _react.PropTypes.string,
	  showingSmbg: _react.PropTypes.bool.isRequired,
	  showingCbg: _react.PropTypes.bool.isRequired,
	  smbgRangeOverlay: _react.PropTypes.bool.isRequired,
	  smbgGrouped: _react.PropTypes.bool.isRequired,
	  smbgLines: _react.PropTypes.bool.isRequired,
	  timePrefs: _react.PropTypes.shape({
	    timezoneAware: _react.PropTypes.bool.isRequired,
	    timezoneName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, null])
	  }).isRequired,
	  yScaleClampTop: _react.PropTypes.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, _constants.MGDL_UNITS, _react.PropTypes.number.isRequired), _defineProperty(_PropTypes$shape, _constants.MMOLL_UNITS, _react.PropTypes.number.isRequired), _PropTypes$shape)).isRequired,
	  // data (crossfilter dimensions)
	  cbgByDate: _react.PropTypes.object.isRequired,
	  cbgByDayOfWeek: _react.PropTypes.object.isRequired,
	  smbgByDate: _react.PropTypes.object.isRequired,
	  smbgByDayOfWeek: _react.PropTypes.object.isRequired,
	  // handlers
	  markTrendsViewed: _react.PropTypes.func.isRequired,
	  onDatetimeLocationChange: _react.PropTypes.func.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  onSwitchBgDataSource: _react.PropTypes.func.isRequired,
	  // viz state
	  trendsState: _react.PropTypes.shape({
	    cbgFlags: _react.PropTypes.shape({
	      cbg100Enabled: _react.PropTypes.bool.isRequired,
	      cbg80Enabled: _react.PropTypes.bool.isRequired,
	      cbg50Enabled: _react.PropTypes.bool.isRequired,
	      cbgMedianEnabled: _react.PropTypes.bool.isRequired
	    }).isRequired,
	    focusedCbgSlice: _react.PropTypes.shape({
	      data: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        id: _react.PropTypes.string.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        msFrom: _react.PropTypes.number.isRequired,
	        msTo: _react.PropTypes.number.isRequired,
	        msX: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }),
	      position: _react.PropTypes.shape({
	        left: _react.PropTypes.number.isRequired,
	        tooltipLeft: _react.PropTypes.bool.isRequired,
	        topOptions: _react.PropTypes.shape({
	          firstQuartile: _react.PropTypes.number.isRequired,
	          max: _react.PropTypes.number.isRequired,
	          median: _react.PropTypes.number.isRequired,
	          min: _react.PropTypes.number.isRequired,
	          ninetiethQuantile: _react.PropTypes.number.isRequired,
	          tenthQuantile: _react.PropTypes.number.isRequired,
	          thirdQuartile: _react.PropTypes.number.isRequired
	        })
	      })
	    }),
	    focusedCbgSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	    focusedSmbg: _react.PropTypes.shape({
	      allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        left: _react.PropTypes.number.isRequired
	      })),
	      allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        value: _react.PropTypes.number.isRequired
	      })),
	      date: _react.PropTypes.string.isRequired,
	      datum: _react.PropTypes.shape({
	        value: _react.PropTypes.number.isRequired
	      }),
	      position: _react.PropTypes.shape({
	        top: _react.PropTypes.number.isRequired,
	        left: _react.PropTypes.number.isRequired
	      })
	    }),
	    focusedSmbgRangeAvg: _react.PropTypes.shape({
	      data: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        mean: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        msX: _react.PropTypes.number.isRequired,
	        msFrom: _react.PropTypes.number.isRequired,
	        msTo: _react.PropTypes.number.isRequired
	      }).isRequired,
	      position: _react.PropTypes.shape({
	        left: _react.PropTypes.number.isRequired,
	        tooltipLeft: _react.PropTypes.bool.isRequired,
	        yPositions: _react.PropTypes.shape({
	          max: _react.PropTypes.number.isRequired,
	          mean: _react.PropTypes.number.isRequired,
	          min: _react.PropTypes.number.isRequired
	        }).isRequired
	      }).isRequired
	    }),
	    touched: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  unfocusCbgSlice: _react.PropTypes.func.isRequired,
	  unfocusSmbg: _react.PropTypes.func.isRequired,
	  unfocusSmbgRangeAvg: _react.PropTypes.func.isRequired
	};
	TrendsContainer.defaultProps = {
	  yScaleClampTop: (_yScaleClampTop = {}, _defineProperty(_yScaleClampTop, _constants.MGDL_UNITS, _constants.MGDL_CLAMP_TOP), _defineProperty(_yScaleClampTop, _constants.MMOLL_UNITS, _constants.MMOLL_CLAMP_TOP), _yScaleClampTop)
	};
	function mapStateToProps(state, ownProps) {
	  var userId = _lodash2.default.get(ownProps, 'currentPatientInViewId');
	  return {
	    trendsState: _lodash2.default.get(state, ['viz', 'trends', userId], {})
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    markTrendsViewed: actions.markTrendsViewed,
	    unfocusCbgSlice: actions.unfocusTrendsCbgSlice,
	    unfocusSmbg: actions.unfocusTrendsSmbg,
	    unfocusSmbgRangeAvg: actions.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, function (stateProps, dispatchProps, ownProps) {
	  return _lodash2.default.assign({}, ownProps, stateProps, dispatchProps);
	}, { withRef: true })(TrendsContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBG_READINGS_ONE_DAY, 'CBG_READINGS_ONE_DAY', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(ONE_WEEK, 'ONE_WEEK', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(TWO_WEEKS, 'TWO_WEEKS', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(FOUR_WEEKS, 'FOUR_WEEKS', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getAllDatesInRange, 'getAllDatesInRange', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedNoonBeforeUTC, 'getLocalizedNoonBeforeUTC', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(getLocalizedOffset, 'getLocalizedOffset', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(TrendsContainer, 'TrendsContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsContainer.js');
	})();

	;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {(function() {
	  function checkColorSupport() {
	    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
	      return false;
	    }
	
	    var chrome = !!window.chrome,
	        firefox = /firefox/i.test(navigator.userAgent),
	        firefoxVersion,
	        electron = process && process.versions && process.versions.electron;
	
	    if (firefox) {
	        var match = navigator.userAgent.match(/Firefox\/(\d+\.\d+)/);
	        if (match && match[1] && Number(match[1])) {
	            firefoxVersion = Number(match[1]);
	        }
	    }
	    return chrome || firefoxVersion >= 31.0 || electron;
	  }
	
	  var yieldColor = function() {
	    var goldenRatio = 0.618033988749895;
	    hue += goldenRatio;
	    hue = hue % 1;
	    return hue * 360;
	  };
	
	  var inNode = typeof window === 'undefined',
	      ls = !inNode && window.localStorage,
	      debugKey = ls.andlogKey || 'debug',
	      debug = ls[debugKey],
	      logger = __webpack_require__(93),
	      bind = Function.prototype.bind,
	      hue = 0,
	      padLength = 15,
	      noop = function() {},
	      // if ls.debugColors is set, use that, otherwise check for support
	      colorsSupported = ls.debugColors ? (ls.debugColors !== "false") : checkColorSupport(),
	      bows = null,
	      debugRegex = null,
	      invertRegex = false,
	      moduleColorsMap = {};
	
	  if (debug && debug[0] === '!' && debug[1] === '/') {
	    invertRegex = true;
	    debug = debug.slice(1);
	  }
	  debugRegex = debug && debug[0]==='/' && new RegExp(debug.substring(1,debug.length-1));
	
	  var logLevels = ['log', 'debug', 'warn', 'error', 'info'];
	
	  //Noop should noop
	  for (var i = 0, ii = logLevels.length; i < ii; i++) {
	      noop[ logLevels[i] ] = noop;
	  }
	
	  bows = function(str) {
	    var msg, colorString, logfn;
	    msg = (str.slice(0, padLength));
	    msg += Array(padLength + 3 - msg.length).join(' ') + '|';
	
	    if (debugRegex) {
	        var matches = str.match(debugRegex);
	        if (
	            (!invertRegex && !matches) ||
	            (invertRegex && matches)
	        ) return noop;
	    }
	
	    if (!bind) return noop;
	
	    var logArgs = [logger];
	    if (colorsSupported) {
	      if(!moduleColorsMap[str]){
	        moduleColorsMap[str]= yieldColor();
	      }
	      var color = moduleColorsMap[str];
	      msg = "%c" + msg;
	      colorString = "color: hsl(" + (color) + ",99%,40%); font-weight: bold";
	
	      logArgs.push(msg, colorString);
	    }else{
	      logArgs.push(msg);
	    }
	
	    if(arguments.length>1){
	        var args = Array.prototype.slice.call(arguments, 1);
	        logArgs = logArgs.concat(args);
	    }
	
	    logfn = bind.apply(logger.log, logArgs);
	
	    logLevels.forEach(function (f) {
	      logfn[f] = bind.apply(logger[f] || logfn, logArgs);
	    });
	    return logfn;
	  };
	
	  bows.config = function(config) {
	    if (config.padLength) {
	      padLength = config.padLength;
	    }
	  };
	
	  if (true) {
	    module.exports = bows;
	  } else {
	    window.bows = bows;
	  }
	}).call();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 92 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// follow @HenrikJoreteg and @andyet if you like this ;)
	(function () {
	    var inNode = typeof window === 'undefined',
	        ls = !inNode && window.localStorage,
	        out = {};
	
	    if (inNode) {
	        module.exports = console;
	        return;
	    }
	
	    var andlogKey = ls.andlogKey || 'debug'
	    if (ls && ls[andlogKey] && window.console) {
	        out = window.console;
	    } else {
	        var methods = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),
	            l = methods.length,
	            fn = function () {};
	
	        while (l--) {
	            out[methods[l]] = fn;
	        }
	    }
	    if (true) {
	        module.exports = out;
	    } else {
	        window.console = out;
	    }
	})();


/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = require("d3-scale");

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TrendsSVGContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDimensions = __webpack_require__(96);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(16);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	var _Background = __webpack_require__(97);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _CBGDateTracesAnimationContainer = __webpack_require__(100);
	
	var _CBGDateTracesAnimationContainer2 = _interopRequireDefault(_CBGDateTracesAnimationContainer);
	
	var _CBGSlicesContainer = __webpack_require__(123);
	
	var _CBGSlicesContainer2 = _interopRequireDefault(_CBGSlicesContainer);
	
	var _FocusedCBGSliceSegment = __webpack_require__(133);
	
	var _FocusedCBGSliceSegment2 = _interopRequireDefault(_FocusedCBGSliceSegment);
	
	var _SMBGsByDateContainer = __webpack_require__(136);
	
	var _SMBGsByDateContainer2 = _interopRequireDefault(_SMBGsByDateContainer);
	
	var _SMBGRangeAvgContainer = __webpack_require__(144);
	
	var _SMBGRangeAvgContainer2 = _interopRequireDefault(_SMBGRangeAvgContainer);
	
	var _SMBGRangeAnimated = __webpack_require__(145);
	
	var _SMBGRangeAnimated2 = _interopRequireDefault(_SMBGRangeAnimated);
	
	var _SMBGMeanAnimated = __webpack_require__(149);
	
	var _SMBGMeanAnimated2 = _interopRequireDefault(_SMBGMeanAnimated);
	
	var _NoData = __webpack_require__(153);
	
	var _NoData2 = _interopRequireDefault(_NoData);
	
	var _TargetRangeLines = __webpack_require__(156);
	
	var _TargetRangeLines2 = _interopRequireDefault(_TargetRangeLines);
	
	var _XAxisLabels = __webpack_require__(159);
	
	var _XAxisLabels2 = _interopRequireDefault(_XAxisLabels);
	
	var _XAxisTicks = __webpack_require__(162);
	
	var _XAxisTicks2 = _interopRequireDefault(_XAxisTicks);
	
	var _YAxisLabelsAndTicks = __webpack_require__(165);
	
	var _YAxisLabelsAndTicks2 = _interopRequireDefault(_YAxisLabelsAndTicks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	/*
	 * TODO: DISCUSS
	 * Is this how we want to approach defaults/constants in the Reactified viz components?
	 * Here, the approach is to use global constants. Then, the options that are required
	 * in child components as well are assigned to default props, but those that are only used
	 * in this parent/container component are just used directly as constants.
	 */
	var BUMPERS = {
	  top: 50,
	  bottom: 30
	};
	
	var MARGINS = {
	  top: 30,
	  right: 10,
	  bottom: 10,
	  left: 40
	};
	
	var SMBG_OPTS = {
	  maxR: 7.5,
	  r: 6
	};
	
	var TrendsSVGContainer = exports.TrendsSVGContainer = function (_PureComponent) {
	  _inherits(TrendsSVGContainer, _PureComponent);
	
	  function TrendsSVGContainer(props) {
	    _classCallCheck(this, TrendsSVGContainer);
	
	    var _this = _possibleConstructorReturn(this, (TrendsSVGContainer.__proto__ || Object.getPrototypeOf(TrendsSVGContainer)).call(this, props));
	
	    _this.state = {
	      focusedSegmentDataGroupedByDate: null
	    };
	    return _this;
	  }
	
	  _createClass(TrendsSVGContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          height = _props.containerHeight,
	          width = _props.containerWidth;
	      var _props2 = this.props,
	          margins = _props2.margins,
	          smbgOpts = _props2.smbgOpts,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	      xScale.range([margins.left + Math.round(smbgOpts.maxR), width - margins.right - Math.round(smbgOpts.maxR)]);
	      yScale.range([height - margins.bottom - BUMPERS.bottom, margins.top + BUMPERS.top]);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var showingCbgDateTraces = nextProps.showingCbgDateTraces;
	
	      if (!showingCbgDateTraces) {
	        // if we just flipped the showingCbgDateTraces flag from true to false
	        // then we need to reset the focusedSegmentDataGroupedByDate to `null`
	        if (this.props.showingCbgDateTraces) {
	          this.setState({
	            focusedSegmentDataGroupedByDate: null
	          });
	        }
	        return;
	      }
	      var cbgData = nextProps.cbgData,
	          focusedSlice = nextProps.focusedSlice,
	          focusedSliceKeys = nextProps.focusedSliceKeys;
	
	      if (focusedSlice) {
	        var intersectingDates = (0, _data.findDatesIntersectingWithCbgSliceSegment)(cbgData, focusedSlice, focusedSliceKeys);
	        var focusedSegmentDataGroupedByDate = _lodash2.default.groupBy(_lodash2.default.filter(cbgData, function (d) {
	          return _lodash2.default.includes(intersectingDates, d.localDate);
	        }), function (d) {
	          return d.localDate;
	        });
	        this.setState({
	          focusedSegmentDataGroupedByDate: focusedSegmentDataGroupedByDate
	        });
	      } else {
	        // only reset focusedSegmentDataGroupedByDate to null if previous props had a focused slice
	        // but nextProps do not! (i.e., you've just rolled off a segment and not onto another one)
	        if (this.props.focusedSlice) {
	          this.setState({
	            focusedSegmentDataGroupedByDate: null
	          });
	        }
	      }
	    }
	  }, {
	    key: 'renderNoDataMessage',
	    value: function renderNoDataMessage(dataType) {
	      var _props3 = this.props,
	          activeDays = _props3.activeDays,
	          height = _props3.containerHeight,
	          width = _props3.containerWidth,
	          margins = _props3.margins;
	
	      var xPos = width / 2 + margins.right;
	      var yPos = height / 2 + margins.bottom;
	      var messagePosition = { x: xPos, y: yPos };
	      var unselectedAll = _lodash2.default.every(activeDays, function (flag) {
	        return !flag;
	      });
	      if (this.props.showingCbg && _lodash2.default.isEmpty(this.props.cbgData) || this.props.showingSmbg && _lodash2.default.isEmpty(this.props.smbgData)) {
	        return _react2.default.createElement(_NoData2.default, {
	          dataType: dataType,
	          position: messagePosition,
	          unselectedAllData: unselectedAll
	        });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay(smbgComponent, componentKey) {
	      var data = this.props.smbgRangeOverlay ? this.props.smbgData : [];
	      return _react2.default.createElement(_SMBGRangeAvgContainer2.default, {
	        bgBounds: this.props.bgPrefs.bgBounds,
	        data: data,
	        key: componentKey,
	        smbgComponent: smbgComponent,
	        someSmbgDataIsFocused: this.props.focusedSmbg !== null,
	        tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	        xScale: this.props.xScale,
	        yScale: this.props.yScale
	      });
	    }
	  }, {
	    key: 'renderCbg',
	    value: function renderCbg() {
	      if (this.props.showingCbg) {
	        var slices = _react2.default.createElement(_CBGSlicesContainer2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.cbgData,
	          displayFlags: this.props.displayFlags,
	          showingCbgDateTraces: this.props.showingCbgDateTraces,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          topMargin: this.props.margins.top,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	
	        var focusedSegmentDataGroupedByDate = this.state.focusedSegmentDataGroupedByDate;
	
	        var dateTraces = _react2.default.createElement(_CBGDateTracesAnimationContainer2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: focusedSegmentDataGroupedByDate,
	          dates: _lodash2.default.keys(focusedSegmentDataGroupedByDate) || [],
	          onSelectDate: this.props.onSelectDate,
	          topMargin: this.props.margins.top,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	
	        var focused = null;
	        var _props4 = this.props,
	            focusedSlice = _props4.focusedSlice,
	            focusedSliceKeys = _props4.focusedSliceKeys;
	
	        if (!_lodash2.default.isEmpty(focusedSlice) && !_lodash2.default.isEmpty(focusedSliceKeys)) {
	          focused = _react2.default.createElement(_FocusedCBGSliceSegment2.default, {
	            focusedSlice: focusedSlice,
	            focusedSliceKeys: focusedSliceKeys
	          });
	        }
	
	        return _react2.default.createElement(
	          'g',
	          { id: 'cbgTrends' },
	          slices,
	          dateTraces,
	          focused
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderSmbg',
	    value: function renderSmbg() {
	      if (this.props.showingSmbg) {
	        var allSmbgsByDate = _react2.default.createElement(_SMBGsByDateContainer2.default, {
	          anSmbgRangeAvgIsFocused: this.props.focusedSmbgRangeAvgKey !== null,
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.smbgData,
	          dates: this.props.dates,
	          grouped: this.props.smbgGrouped,
	          key: 'smbgDaysContainer',
	          lines: this.props.smbgLines,
	          onSelectDate: this.props.onSelectDate,
	          smbgOpts: this.props.smbgOpts,
	          someSmbgDataIsFocused: this.props.focusedSmbg !== null,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        });
	        // Focused date will be rendered last, on top of everything else but flagged
	        // as nonInteractive to allow mouse events to be handled exclusively by normally
	        // rendered points and lines
	        var focusedSmbgDate = this.props.focusedSmbg ? _react2.default.createElement(_SMBGsByDateContainer2.default, {
	          anSmbgRangeAvgIsFocused: false,
	          bgBounds: this.props.bgPrefs.bgBounds,
	          data: this.props.focusedSmbg.allSmbgsOnDate,
	          dates: [this.props.focusedSmbg.date],
	          focusedSmbg: this.props.focusedSmbg,
	          grouped: this.props.smbgGrouped,
	          key: 'focusedSmbgDayContainer',
	          lines: this.props.smbgLines,
	          nonInteractive: true,
	          onSelectDate: this.props.onSelectDate,
	          smbgOpts: this.props.smbgOpts,
	          someSmbgDataIsFocused: false,
	          tooltipLeftThreshold: this.props.tooltipLeftThreshold,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        }) : null;
	
	        return _react2.default.createElement(
	          'g',
	          { id: 'smbgTrends' },
	          this.renderOverlay(_SMBGRangeAnimated2.default, 'SMBGRangeContainer'),
	          allSmbgsByDate,
	          this.renderOverlay(_SMBGMeanAnimated2.default, 'SMBGMeanContainer'),
	          focusedSmbgDate
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          height = _props5.containerHeight,
	          width = _props5.containerWidth;
	
	      return _react2.default.createElement(
	        'svg',
	        { height: height, width: width },
	        _react2.default.createElement(_Background2.default, {
	          linesAtThreeHrs: true,
	          margins: this.props.margins,
	          smbgOpts: this.props.smbgOpts,
	          svgDimensions: { height: height, width: width },
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_XAxisLabels2.default, {
	          margins: this.props.margins,
	          useRangeLabels: false,
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_XAxisTicks2.default, {
	          margins: this.props.margins,
	          xScale: this.props.xScale
	        }),
	        _react2.default.createElement(_YAxisLabelsAndTicks2.default, {
	          bgPrefs: this.props.bgPrefs,
	          bgUnits: this.props.bgUnits,
	          margins: this.props.margins,
	          yScale: this.props.yScale
	        }),
	        this.renderCbg(),
	        this.renderSmbg(),
	        _react2.default.createElement(_TargetRangeLines2.default, {
	          bgBounds: this.props.bgPrefs.bgBounds,
	          smbgOpts: this.props.smbgOpts,
	          xScale: this.props.xScale,
	          yScale: this.props.yScale
	        }),
	        this.renderNoDataMessage(this.props.showingCbg ? 'cbg' : 'smbg')
	      );
	    }
	  }]);
	
	  return TrendsSVGContainer;
	}(_react.PureComponent);
	
	TrendsSVGContainer.defaultProps = {
	  margins: MARGINS,
	  smbgOpts: SMBG_OPTS,
	  // for time values after 6 p.m. (1800), float the tooltips left instead of right
	  tooltipLeftThreshold: 6 * _datetime.THREE_HRS
	};
	
	TrendsSVGContainer.propTypes = {
	  activeDays: _react.PropTypes.shape({
	    monday: _react.PropTypes.bool.isRequired,
	    tuesday: _react.PropTypes.bool.isRequired,
	    wednesday: _react.PropTypes.bool.isRequired,
	    thursday: _react.PropTypes.bool.isRequired,
	    friday: _react.PropTypes.bool.isRequired,
	    saturday: _react.PropTypes.bool.isRequired,
	    sunday: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }).isRequired,
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }).isRequired,
	  containerHeight: _react.PropTypes.number.isRequired,
	  containerWidth: _react.PropTypes.number.isRequired,
	  smbgData: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  cbgData: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  focusedSmbg: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  focusedSmbgRangeAvgKey: _react.PropTypes.string,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  showingCbg: _react.PropTypes.bool.isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  showingSmbg: _react.PropTypes.bool.isRequired,
	  smbgGrouped: _react.PropTypes.bool.isRequired,
	  smbgLines: _react.PropTypes.bool.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  smbgRangeOverlay: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _reactDimensions2.default)()(TrendsSVGContainer);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BUMPERS, 'BUMPERS', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(MARGINS, 'MARGINS', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(SMBG_OPTS, 'SMBG_OPTS', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(TrendsSVGContainer, 'TrendsSVGContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TrendsSVGContainer.js');
	})();

	;

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = require("react-dimensions");

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(26);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(20);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _Background = __webpack_require__(98);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Background = function Background(props) {
	  var data = props.data,
	      margins = props.margins,
	      svgDimensions = props.svgDimensions,
	      xScale = props.xScale;
	
	
	  var width = svgDimensions.width - margins.left - margins.right;
	  var height = svgDimensions.height - margins.top - margins.bottom;
	
	  var lines = props.linesAtThreeHrs ? _lodash2.default.map(data, function (val, i) {
	    return _react2.default.createElement('line', {
	      className: _Background2.default.threeHrLine,
	      key: 'threeHrLine-' + i,
	      x1: xScale(val),
	      x2: xScale(val),
	      y1: margins.top,
	      y2: svgDimensions.height - margins.bottom
	    });
	  }) : null;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'background' },
	    _react2.default.createElement('rect', {
	      className: _Background2.default.background,
	      x: margins.left,
	      y: margins.top,
	      width: width,
	      height: height
	    }),
	    lines
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	Background.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(1, 8), function (i) {
	    return i * datetime.THREE_HRS;
	  }),
	  linesAtThreeHrs: false
	};
	
	Background.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  linesAtThreeHrs: _react.PropTypes.bool.isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  svgDimensions: _react.PropTypes.shape({
	    width: _react.PropTypes.number.isRequired,
	    height: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xScale: _react.PropTypes.func.isRequired
	};
	
	var _default = Background;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Background, 'Background', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/Background.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/Background.js');
	})();

	;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Background.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./Background.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".Background--background--3QmVr{fill:var(--bkgrnd)}.Background--background--3QmVr,.Background--threeHrLine--3tNeU{stroke:var(--bkgrnd-lines);stroke-width:1px}", ""]);
	
	// exports
	exports.locals = {
		"background": "Background--background--3QmVr",
		"threeHrLine": "Background--threeHrLine--3tNeU"
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroupPlus = __webpack_require__(101);
	
	var _reactTransitionGroupPlus2 = _interopRequireDefault(_reactTransitionGroupPlus);
	
	var _CBGDateTraceAnimated = __webpack_require__(116);
	
	var _CBGDateTraceAnimated2 = _interopRequireDefault(_CBGDateTraceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var CBGDateTracesAnimationContainer = function CBGDateTracesAnimationContainer(props) {
	  var bgBounds = props.bgBounds,
	      data = props.data,
	      dates = props.dates,
	      topMargin = props.topMargin,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	  return _react2.default.createElement(
	    _reactTransitionGroupPlus2.default,
	    { component: 'g', id: 'cbgDateTraces', transitionMode: 'simultaneous' },
	    _lodash2.default.map(dates, function (localDate) {
	      return _react2.default.createElement(_CBGDateTraceAnimated2.default, {
	        bgBounds: bgBounds,
	        data: data[localDate],
	        date: localDate,
	        key: localDate,
	        onSelectDate: props.onSelectDate,
	        topMargin: topMargin,
	        xScale: xScale,
	        yScale: yScale
	      });
	    })
	  );
	};
	
	CBGDateTracesAnimationContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.object,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  onSelectDate: _react.PropTypes.func.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = CBGDateTracesAnimationContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTracesAnimationContainer, 'CBGDateTracesAnimationContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTracesAnimationContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTracesAnimationContainer.js');
	})();

	;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var difference = __webpack_require__(102);
	var ReactTransitionChildMapping = __webpack_require__(103);
	
	var assign = __webpack_require__(115);
	
	var ReactTransitionGroupPlus = React.createClass({
	  displayName: 'ReactTransitionGroupPlus',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func,
	    transitionMode: React.PropTypes.oneOf(['in-out', 'out-in', 'simultaneous']),
	    deferLeavingComponentRemoval: React.PropTypes.bool,
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: function (arg) {
	        return arg;
	      },
	      transitionMode: 'simultaneous',
	      deferLeavingComponentRemoval: false,
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children),
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyEnteringOrEnteredKeys = {};
	    this.currentlyEnteringKeys = {};
	    this.currentlyEnteringPromises = {};
	    this.currentlyLeavingKeys = {};
	    this.currentlyLeavingPromises = {};
	    this.pendingEnterCallbacks = {};
	    this.pendingLeaveCallbacks = {};
	    this.deferredLeaveRemovalCallbacks = [];
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    this.cancel = null;
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      ),
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && ( !hasPrev || this.currentlyLeavingKeys[key])) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext ) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    if (this.props.transitionMode === 'out-in') {
	      this.keysToEnter = difference(this.keysToEnter, this.keysToLeave);
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    var keysToLeave = this.keysToLeave;
	
	    switch (this.props.transitionMode) {
	      case 'out-in':
	        this.keysToLeave = [];
	        if (keysToLeave.length) {
	          keysToLeave.forEach(this.performLeave)
	        } else {
	          this.keysToEnter = [];
	          keysToEnter.forEach(this.performEnter)
	        }
	        break;
	      case 'in-out':
	        this.keysToEnter = [];
	        this.keysToLeave = [];
	
	        if (keysToEnter.length) {
	          Promise.all(keysToEnter.map(this.performEnter))
	            .then(function () {
	              keysToLeave.forEach(this.performLeave)
	            }.bind(this))
	        } else {
	          keysToLeave.forEach(this.performLeave)
	        }
	        break;
	      default:
	        this.keysToEnter = [];
	        this.keysToLeave = [];
	        keysToEnter.forEach(this.performEnter);
	        keysToLeave.forEach(this.performLeave);
	        break;
	    }
	  },
	
	  performAppear: function(key) {
	    this.currentlyEnteringOrEnteredKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	
	    if (this.currentlyEnteringKeys[key]) {
	      return this.currentlyEnteringPromises[key];
	    }
	
	    this.cancelPendingLeave(key);
	
	
	    var component = this.refs[key];
	
	    if (!component) {
	      return Promise.resolve();
	    }
	
	    this.currentlyEnteringOrEnteredKeys[key] = true;
	    this.currentlyEnteringKeys[key] = true;
	
	    var callback = this._handleDoneEntering.bind(this, key);
	    this.pendingEnterCallbacks[key] = callback;
	
	    var enterPromise = new Promise(function (resolve) {
	      if (component.componentWillEnter) {
	        component.componentWillEnter(resolve);
	      } else {
	        resolve();
	      }
	    }).then(callback);
	
	    this.currentlyEnteringPromises[key] = enterPromise;
	
	    return enterPromise;
	  },
	
	  _handleDoneEntering: function(key) {
	    delete this.pendingEnterCallbacks[key];
	    delete this.currentlyEnteringPromises[key];
	    delete this.currentlyEnteringKeys[key];
	
	    this.deferredLeaveRemovalCallbacks.forEach(function(fn) { fn(); });
	    this.deferredLeaveRemovalCallbacks = [];
	
	    var component = this.refs[key];
	    if (component && component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key) && this.currentlyEnteringOrEnteredKeys[key]) {
	      // This was removed before it had fully entered. Remove it.
	
	      if (this.props.transitionMode !== 'in-out') {
	        this.performLeave(key);
	      }
	    }
	  },
	
	  performLeave: function(key) {
	    if (this.currentlyLeavingKeys[key]) {
	      //already leaving, let it finish
	      return this.currentlyLeavingPromises[key];
	    }
	
	    this.cancelPendingEnter(key);
	
	    var component = this.refs[key];
	
	    if (!component) {
	      return Promise.resolve();
	    }
	
	    this.currentlyLeavingKeys[key] = true;
	
	    var callback = this._handleDoneLeaving.bind(this, key);
	    this.pendingLeaveCallbacks[key] = callback;
	
	    var leavePromise = new Promise(function (resolve) {
	      if (component.componentWillLeave) {
	        component.componentWillLeave(resolve);
	      } else {
	        resolve();
	      }
	    })
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      .then(callback);
	
	    this.currentlyLeavingPromises[key] = leavePromise;
	    return leavePromise;
	  },
	
	  _handleDoneLeaving: function(key) {
	    delete this.pendingLeaveCallbacks[key];
	    delete this.currentlyLeavingKeys[key];
	    delete this.currentlyLeavingPromises[key];
	
	    var component = this.refs[key];
	
	    if (component && component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    var updateChildren = function updateChildren () {
	      this.setState(function(state) {
	        var newChildren = assign({}, state.children);
	        delete newChildren[key];
	        return {children: newChildren};
	      });
	    }.bind(this);
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      // but only perform enter if currently animating out, not already animated out
	      if (this.props.transitionMode !== 'in-out') {
	        this.performEnter(key);
	      }
	    } else {
	      delete this.currentlyEnteringOrEnteredKeys[key];
	
	      if (this.props.deferLeavingComponentRemoval && this.props.transitionMode !== 'in-out') {
	        this.deferredLeaveRemovalCallbacks.push(updateChildren);
	        this.forceUpdate();
	      } else {
	        updateChildren();
	      }
	    }
	  },
	
	  cancelPendingLeave: function (key) {
	    if (this.pendingLeaveCallbacks[key]) {
	      this.pendingLeaveCallbacks[key]();
	      delete this.pendingLeaveCallbacks[key];
	    }
	  },
	
	  cancelPendingEnter: function (key) {
	    if (this.pendingEnterCallbacks[key]) {
	      this.pendingEnterCallbacks[key]();
	      delete this.pendingEnterCallbacks[key];
	    }
	  },
	
	  cleanProps: function(props) {
	    delete props.component;
	    delete props.transitionMode;
	    delete props.childFactory;
	    delete props.deferLeavingComponentRemoval;
	    return props;
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.cleanProps(assign({},this.props)),
	      childrenToRender
	    );
	  },
	});
	
	module.exports = ReactTransitionGroupPlus;


/***/ },
/* 102 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order of result values is determined by the
	 * order they occur in the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = difference;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(104);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(105);
	var traverseAllChildren = __webpack_require__(106);
	var warning = __webpack_require__(112);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(114);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (process.env.NODE_ENV !== 'production') {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = __webpack_require__(114);
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (process.env.NODE_ENV !== 'production') {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(107);
	
	var ReactCurrentOwner = __webpack_require__(108);
	var REACT_ELEMENT_TYPE = __webpack_require__(109);
	
	var getIteratorFn = __webpack_require__(110);
	var invariant = __webpack_require__(111);
	var KeyEscapeUtils = __webpack_require__(105);
	var warning = __webpack_require__(112);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(113);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 113 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(107);
	
	var ReactCurrentOwner = __webpack_require__(108);
	
	var invariant = __webpack_require__(111);
	var warning = __webpack_require__(112);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ },
/* 115 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGDateTraceAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gsap = __webpack_require__(117);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _connectWithTransitionGroup = __webpack_require__(119);
	
	var _connectWithTransitionGroup2 = _interopRequireDefault(_connectWithTransitionGroup);
	
	var _trends = __webpack_require__(34);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _CBGDateTraceAnimated = __webpack_require__(120);
	
	var _CBGDateTraceAnimated2 = _interopRequireDefault(_CBGDateTraceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGDateTraceAnimated = exports.CBGDateTraceAnimated = function (_PureComponent) {
	  _inherits(CBGDateTraceAnimated, _PureComponent);
	
	  function CBGDateTraceAnimated(props) {
	    _classCallCheck(this, CBGDateTraceAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGDateTraceAnimated.__proto__ || Object.getPrototypeOf(CBGDateTraceAnimated)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGDateTraceAnimated, [{
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      var _props = this.props,
	          animationDuration = _props.animationDuration,
	          data = _props.data;
	
	      var targets = _lodash2.default.map(data, function (d) {
	        return _this2[d.id];
	      });
	      _gsap.TweenMax.staggerTo(targets, animationDuration, { opacity: 1, onComplete: cb }, animationDuration / targets.length);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          animationDuration = _props2.animationDuration,
	          data = _props2.data;
	
	      var targets = _lodash2.default.map(data, function (d) {
	        return _this3[d.id];
	      });
	      _gsap.TweenMax.staggerTo(targets, animationDuration, { opacity: 0, onComplete: cb }, animationDuration / targets.length);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props3 = this.props,
	          date = _props3.date,
	          onSelectDate = _props3.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props4 = this.props,
	          unfocusDateTrace = _props4.unfocusDateTrace,
	          userId = _props4.userId;
	
	      unfocusDateTrace(userId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props5 = this.props,
	          bgBounds = _props5.bgBounds,
	          cbgRadius = _props5.cbgRadius,
	          data = _props5.data,
	          date = _props5.date,
	          topMargin = _props5.topMargin,
	          userId = _props5.userId,
	          xScale = _props5.xScale,
	          yScale = _props5.yScale;
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'cbgDateTrace-' + date },
	        _lodash2.default.map(data, function (d) {
	          return _react2.default.createElement('circle', {
	            className: _CBGDateTraceAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, d.value)],
	            cx: xScale(d.msPer24),
	            cy: yScale(d.value),
	            id: 'cbgCircle-' + d.id,
	            key: d.id,
	            onClick: _this4.handleClick,
	            onMouseOver: function onMouseOver() {
	              _this4.props.focusDateTrace(userId, d, {
	                left: xScale(d.msPer24),
	                yPositions: {
	                  top: yScale(d.value),
	                  topMargin: topMargin
	                }
	              });
	            },
	            onMouseOut: _this4.handleMouseOut,
	            opacity: 0,
	            r: cbgRadius,
	            ref: function ref(node) {
	              _this4[d.id] = node;
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return CBGDateTraceAnimated;
	}(_react.PureComponent);
	
	CBGDateTraceAnimated.defaultProps = {
	  animationDuration: 0.2,
	  cbgRadius: 2.5
	};
	CBGDateTraceAnimated.propTypes = {
	  animationDuration: _react.PropTypes.number.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  cbgRadius: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusDateTrace: _react.PropTypes.func.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  unfocusDateTrace: _react.PropTypes.func.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusDateTrace: _trends.focusTrendsCbgDateTrace,
	    unfocusDateTrace: _trends.unfocusTrendsCbgDateTrace
	  }, dispatch);
	}
	
	var _default = (0, _connectWithTransitionGroup2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(CBGDateTraceAnimated));
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGDateTraceAnimated, 'CBGDateTraceAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGDateTraceAnimated.js');
	})();

	;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.19.0
	 * DATE: 2016-07-14
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._dirty = true; //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.19.0";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
	
					if (this._easeType) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val.call(targets[i], i) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.19.0";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						tl.add(tween, tween._startTime - tween._delay);
					}
					tween = next;
				}
				root.add(tl, 0);
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > last._startTime + last._totalDuration / last._timeScale) {
					this._time = this.duration();
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - this.duration() : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = this.duration() + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : this.duration();
				} else if (timeOrLabel == null) {
					timeOrLabel = this.duration();
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this.add(tween, tween._startTime - tween._delay);
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function() {
				return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.19.0";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration()) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale );
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						t._callback("onStart");
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTime = this._time,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[(l < -1) ? 0 : 1][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.7",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.19.0";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_doc = document,
				_createElement = function(type) {
					return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = navigator.userAgent,
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || Number(_agent.substr(i+8, 1)) > 3));
					_isSafariLT6 = (_isSafari && (Number(_agent.substr(_agent.indexOf("Version/")+8, 1)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (window.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getBBox && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(v[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = colors.length ? "" : s,
						i, color, temp;
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = Math.round(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = r; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i];
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra((hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra((hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = _isSafari || _isFirefox; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = window.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement,
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !window.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_canGetBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (e) {}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getBBox && e.getCTM && _canGetBBox(e) && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (isDefault && _transformProp && ((none = (_getComputedStyle(e).display === "none")) || !e.parentNode)) {
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none".
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getBBox && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							if (m.indexOf("matrix") !== -1) { //just in case there's a "transform" value specified as an attribute instead of CSS style. Accept either a matrix() or simple translate() value though.
								s = m;
								isDefault = 0;
							} else if (m.indexOf("translate") !== -1) {
								s = "matrix(1,0,0,1," + m.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")";
								isDefault = 0;
							}
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getBBox && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
	
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								a11 = a11*cos+a12*sin;
								t2 = a21*cos+a22*sin;
								a22 = a21*-sin+a22*cos;
								a32 = a31*-sin+a32*cos;
								a21 = t2;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a23 * a23) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a32 * a32 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							if (tm.rotationX || tm.rotationY) {
								tm.skewX = 0;
							} else {
								tm.skewX = (a12 || a22) ? Math.atan2(a12, a22) * _RAD2DEG + tm.rotation : tm.skewX || 0;
								if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
									if (invX) {
										tm.scaleX *= -1;
										tm.skewX += (tm.rotation <= 0) ? 180 : -180;
										tm.rotation += (tm.rotation <= 0) ? 180 : -180;
									} else {
										tm.scaleY *= -1;
										tm.skewX += (tm.skewX <= 0) ? 180 : -180;
									}
								}
							}
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
								if (invX) {
									scaleX *= -1;
									skewX += (rotation <= 0) ? 180 : -180;
									rotation += (rotation <= 0) ? 180 : -180;
								} else {
									scaleY *= -1;
									skewX += (skewX <= 0) ? 180 : -180;
								}
							}
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t1, t2, transform, comma, zero, skew, rnd;
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || t.skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = t.skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - t.skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || t.skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (t.skewX) {
							angle -= t.skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((t.skewX - t.skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation - m1.skewY, m1.rotation - m1.skewY, "rotation", endRotations); //see notes below about skewY for why we subtract it from rotation here
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX - m1.skewY); //see notes below about skewY and why we subtract it from skewX here
	
					//note: for performance reasons, we combine all skewing into the skewX and rotation values, ignoring skewY but we must still record it so that we can discern how much of the overall skew is attributed to skewX vs. skewY. Otherwise, if the skewY would always act relative (tween skewY to 10deg, for example, multiple times and if we always combine things into skewX, we can't remember that skewY was 10 from last time). Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of -10 degrees.
					if ((m2.skewY = _parseAngle(v.skewY, m1.skewY))) {
						m2.skewX += m2.skewY;
						m2.rotation += m2.skewY;
					}
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = _useSVGTransformAttr ? null : "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
	
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
	
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = Math.round(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = Math.round(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
						pt.r = 1;
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.6.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_roundLinkedList = function(node) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
					i = rp.length,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					prop, pt, next;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
				i = rp.length;
				while (--i > -1) {
					prop = rp[i];
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === prop) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT);
							} else {
								this._add(pt.t, prop, pt.s, pt.c);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[prop] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c) {
				this._addTween(target, p, s, s + c, p, Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.0",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.0",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? 1 - (p = (p - this._p3) / this._p1) * p : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p);
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + 1;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return ((this._p2 * p) >> 0) * this._p1;
			};
			p.config = SteppedEase.config = function(steps) {
				return new SteppedEase(steps);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl, hasModule;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								hasModule = (typeof(module) !== "undefined" && module.exports);
								if (!hasModule && "function" === "function" && __webpack_require__(118)){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								} else if (hasModule){ //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				_blankArray = [],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && document.visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000) {
						_ticker.wake();
					}
					setTimeout(_checkTimeout, 2000);
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime()) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					var pauseTime = this._pauseTime,
						t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				return this._uncache(false);
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.19.0";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				return (typeof(document) === "undefined") ? e : (document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m(val, this._target || pt.t);
						} else if (val < min) if (val > -min) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [start, end],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var s = (start === "get") ? target[prop] : start,
						type = typeof(target[prop]),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob, getterName;
					if (type !== "number") {
						if (type === "function" && start === "get") {
							getterName = ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3));
							pt.s = s = funcParam ? target[getterName](funcParam) : target[getterName]();
						}
						if (typeof(s) === "string" && (funcParam || isNaN(s))) {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, end, stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t:blob, p:"setRatio", s:0, c:1, f:2, pg:0, n:overwriteProp || prop, pr:0, m:0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else if (!isRelative) {
							pt.s = parseFloat(s);
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					this._startAt = TweenLite.to(this.target, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a;
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 118 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = connectWithTransitionGroup;
	/**
	 * Copied from https://github.com/esayemm/connect-with-transition-group (ISC license)
	 * Cannot use dist from npm because `const` is not available yet under node v0.12.x
	 */
	
	/* eslint-disable func-names, lodash/prefer-lodash-method, no-param-reassign */
	
	/**
	 * Must have called react-redux/connect with the 'withRef' flag
	 * ex:
	 * connectWithTransitionGroup(connect(mapStateToProps, null, null, {
	 *   withRef: true,
	 * }));
	 *
	 * @param {*} connect - return from react-redux/connect
	 * @returns {*} component monkey patched with special lifecycle functions
	 */
	function connectWithTransitionGroup(connect) {
	  var willFunctions = ['componentWillAppear', 'componentWillEnter', 'componentWillLeave'];
	
	  var didFunctions = ['componentDidAppear', 'componentDidEnter', 'componentDidLeave'];
	
	  willFunctions.forEach(function (key) {
	    connect.prototype[key] = function (cb) {
	      if (this.refs.wrappedInstance[key]) {
	        this.refs.wrappedInstance[key](cb);
	      } else {
	        cb();
	      }
	    };
	  });
	
	  didFunctions.forEach(function (key) {
	    connect.prototype[key] = function () {
	      if (this.refs.wrappedInstance[key]) {
	        this.refs.wrappedInstance[key]();
	      }
	    };
	  });
	
	  return connect;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(connectWithTransitionGroup, 'connectWithTransitionGroup', '/Users/clintbeacock/Sites/tidepool/viz/src/components/common/connectWithTransitionGroup.js');
	})();

	;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(121);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGDateTraceAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(122), undefined);
	
	// module
	exports.push([module.id, ".CBGDateTraceAnimated--border--3Kyho{stroke:#fff;stroke-width:.5px}", ""]);
	
	// exports
	exports.locals = {
		"border": "CBGDateTraceAnimated--border--3Kyho",
		"low": "CBGDateTraceAnimated--low--2Tj8C CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(122).locals["bgLow"] + "",
		"target": "CBGDateTraceAnimated--target--Az1fN CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(122).locals["bgTarget"] + "",
		"high": "CBGDateTraceAnimated--high--38Sss CBGDateTraceAnimated--border--3Kyho " + __webpack_require__(122).locals["bgHigh"] + ""
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ":root{--bolus-stroke:1}.diabetes--basalScheduledFill--1fJlr{fill:var(--basal);fill-opacity:.4}.diabetes--basalTempFill--3zEDj{fill:var(--basal);fill-opacity:.2}.diabetes--basalScheduledPath--1iW1-{stroke:var(--basal)}.diabetes--basalUndeliveredPath--2V6wR{stroke-dasharray:1.5,3}.diabetes--bgLow---sH-f{color:var(--bg-low);fill:var(--bg-low)}.diabetes--bgTarget--3eoZO{color:var(--bg-target);fill:var(--bg-target)}.diabetes--bgHigh--33Mni{color:var(--bg-high);fill:var(--bg-high)}.diabetes--bolusDelivered--3czCX{color:var(--bolus);fill:var(--bolus)}.diabetes--bolusInterrupted--165Yp{color:var(--bolus--interrupted);fill:var(--bolus--interrupted)}.diabetes--bolusProgrammed--1f3B_{fill:none;stroke:var(--bolus);stroke-dasharray:3,2;stroke-width:var(--bolus-stroke)}.diabetes--bolusRideTriangle--11jMx{fill:var(--bolus--ride)}.diabetes--bolusUndelivered--3KfBW,.diabetes--bolusUnderride--h-R0D{color:var(--bolus--undelivered);fill:var(--bolus--undelivered)}.diabetes--carbs--3fKj2{color:var(--carbs);fill:var(--carbs)}", ""]);
	
	// exports
	exports.locals = {
		"basalScheduledFill": "diabetes--basalScheduledFill--1fJlr",
		"basalTempFill": "diabetes--basalTempFill--3zEDj",
		"basalScheduledPath": "diabetes--basalScheduledPath--1iW1-",
		"basalUndeliveredPath": "diabetes--basalUndeliveredPath--2V6wR diabetes--basalScheduledPath--1iW1-",
		"bgLow": "diabetes--bgLow---sH-f",
		"bgTarget": "diabetes--bgTarget--3eoZO",
		"bgHigh": "diabetes--bgHigh--33Mni",
		"bolusDelivered": "diabetes--bolusDelivered--3czCX",
		"bolusInterrupted": "diabetes--bolusInterrupted--165Yp",
		"bolusProgrammed": "diabetes--bolusProgrammed--1f3B_",
		"bolusRideTriangle": "diabetes--bolusRideTriangle--11jMx",
		"bolusUndelivered": "diabetes--bolusUndelivered--3KfBW",
		"bolusUnderride": "diabetes--bolusUnderride--h-R0D",
		"carbs": "diabetes--carbs--3fKj2"
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(26);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	var _CBGMedianAnimated = __webpack_require__(124);
	
	var _CBGMedianAnimated2 = _interopRequireDefault(_CBGMedianAnimated);
	
	var _CBGSliceAnimated = __webpack_require__(129);
	
	var _CBGSliceAnimated2 = _interopRequireDefault(_CBGSliceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSlicesContainer = function (_PureComponent) {
	  _inherits(CBGSlicesContainer, _PureComponent);
	
	  function CBGSlicesContainer(props) {
	    _classCallCheck(this, CBGSlicesContainer);
	
	    var _this = _possibleConstructorReturn(this, (CBGSlicesContainer.__proto__ || Object.getPrototypeOf(CBGSlicesContainer)).call(this, props));
	
	    _this.state = {
	      mungedData: []
	    };
	    return _this;
	  }
	
	  _createClass(CBGSlicesContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          binSize = _props.binSize,
	          data = _props.data;
	
	      this.setState({ mungedData: this.mungeData(binSize, data) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var binSize = nextProps.binSize,
	          data = nextProps.data;
	
	      if (binSize !== this.props.binSize || data !== this.props.data) {
	        this.setState({ mungedData: this.mungeData(binSize, data) });
	      }
	    }
	  }, {
	    key: 'mungeData',
	    value: function mungeData(binSize, data) {
	      var binned = _lodash2.default.groupBy(data, function (d) {
	        return (0, _data.findBinForTimeOfDay)(binSize, d.msPer24);
	      });
	      var outOfRanges = (0, _data.findOutOfRangeAnnotations)(data);
	      // we need *all* possible keys for TransitionMotion to work on enter/exit
	      // and the range starts with binSize/2 because the keys are centered in each bin
	      var binKeys = _lodash2.default.map((0, _d3Array.range)(binSize / 2, _datetime.TWENTY_FOUR_HRS, binSize), function (d) {
	        return String(d);
	      });
	
	      var valueExtractor = function valueExtractor(d) {
	        return d.value;
	      };
	      var mungedData = [];
	      for (var i = 0; i < binKeys.length; ++i) {
	        var values = _lodash2.default.map(_lodash2.default.get(binned, binKeys[i], []), valueExtractor);
	        mungedData.push((0, _data.calculateCbgStatsForBin)(binKeys[i], binSize, values, outOfRanges));
	      }
	      return mungedData;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mungedData = this.state.mungedData;
	      var _props2 = this.props,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'cbgSlices' },
	        _lodash2.default.map(mungedData, function (bin) {
	          return _react2.default.createElement(
	            'g',
	            { id: 'cbgBin-' + bin.id, key: bin.id },
	            _react2.default.createElement(_CBGSliceAnimated2.default, {
	              bgBounds: _this2.props.bgBounds,
	              datum: bin,
	              displayFlags: _this2.props.displayFlags,
	              focusSlice: _this2.props.focusSlice,
	              showingCbgDateTraces: _this2.props.showingCbgDateTraces,
	              tooltipLeftThreshold: _this2.props.tooltipLeftThreshold,
	              topMargin: _this2.props.topMargin,
	              unfocusSlice: _this2.props.unfocusSlice,
	              xScale: xScale,
	              yScale: yScale
	            }),
	            _react2.default.createElement(_CBGMedianAnimated2.default, {
	              bgBounds: _this2.props.bgBounds,
	              datum: bin,
	              displayingMedian: _this2.props.displayFlags.cbgMedianEnabled,
	              showingCbgDateTraces: _this2.props.showingCbgDateTraces,
	              xScale: xScale,
	              yScale: yScale
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return CBGSlicesContainer;
	}(_react.PureComponent);
	
	CBGSlicesContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  binSize: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	CBGSlicesContainer.defaultProps = {
	  binSize: _datetime.THIRTY_MINS
	};
	var _default = CBGSlicesContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSlicesContainer, 'CBGSlicesContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSlicesContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSlicesContainer.js');
	})();

	;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGMedianAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(125);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _constants = __webpack_require__(16);
	
	var _withDefaultYPosition = __webpack_require__(126);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _CBGMedianAnimated = __webpack_require__(127);
	
	var _CBGMedianAnimated2 = _interopRequireDefault(_CBGMedianAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGMedianAnimated = exports.CBGMedianAnimated = function (_PureComponent) {
	  _inherits(CBGMedianAnimated, _PureComponent);
	
	  function CBGMedianAnimated(props) {
	    _classCallCheck(this, CBGMedianAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGMedianAnimated.__proto__ || Object.getPrototypeOf(CBGMedianAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGMedianAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	
	      return {
	        height: 0,
	        median: defaultY,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        height: shrinkOut,
	        median: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx, _cx2;
	
	      var _props = this.props,
	          bgBounds = _props.bgBounds,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          displayingMedian = _props.displayingMedian,
	          medianHeight = _props.medianHeight,
	          medianWidth = _props.medianWidth,
	          showingCbgDateTraces = _props.showingCbgDateTraces,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var medianClasses = datum.median ? (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _CBGMedianAnimated2.default.median, true), _defineProperty(_cx, _CBGMedianAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.median) + 'FadeIn'], !showingCbgDateTraces), _defineProperty(_cx, _CBGMedianAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.median) + 'FadeOut'], showingCbgDateTraces), _cx)) : (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _CBGMedianAnimated2.default.median, true), _defineProperty(_cx2, _CBGMedianAnimated2.default.transparent, true), _cx2));
	
	      var binLeftX = xScale(datum.msX) - medianWidth / 2 + _CBGMedianAnimated2.default.stroke / 2;
	      var width = medianWidth - _CBGMedianAnimated2.default.stroke;
	
	      var shouldRender = displayingMedian && _lodash2.default.get(datum, 'median') !== undefined;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: shouldRender ? [{
	            key: 'median',
	            style: {
	              height: 0,
	              median: defaultY,
	              opacity: 0
	            }
	          }] : [],
	          styles: shouldRender ? [{
	            key: 'median',
	            style: {
	              height: (0, _reactMotion.spring)(medianHeight, _constants.springConfig),
	              median: (0, _reactMotion.spring)(yScale(datum.median) - medianHeight / 2, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          var _interpolateds$ = interpolateds[0],
	              key = _interpolateds$.key,
	              style = _interpolateds$.style;
	
	          return _react2.default.createElement('rect', {
	            className: medianClasses,
	            id: 'cbgMedian-' + key,
	            width: width,
	            height: style.height,
	            x: binLeftX,
	            y: style.median,
	            opacity: style.opacity
	          });
	        }
	      );
	    }
	  }]);
	
	  return CBGMedianAnimated;
	}(_react.PureComponent);
	
	CBGMedianAnimated.defaultProps = {
	  medianHeight: 10,
	  medianWidth: 14
	};
	CBGMedianAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    firstQuartile: _react.PropTypes.number,
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    median: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired,
	    msX: _react.PropTypes.number.isRequired,
	    ninetiethQuantile: _react.PropTypes.number,
	    tenthQuantile: _react.PropTypes.number,
	    thirdQuartile: _react.PropTypes.number
	  }).isRequired,
	  defaultY: _react.PropTypes.number.isRequired,
	  displayingMedian: _react.PropTypes.bool.isRequired,
	  medianHeight: _react.PropTypes.number.isRequired,
	  medianWidth: _react.PropTypes.number.isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(CBGMedianAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGMedianAnimated, 'CBGMedianAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGMedianAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGMedianAnimated.js');
	})();

	;

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports = require("react-motion");

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                   * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withDefaultYPosition = function withDefaultYPosition(WrappedComponent) {
	  var WithDefault = function WithDefault(props) {
	    var _props$bgBounds = props.bgBounds,
	        targetLowerBound = _props$bgBounds.targetLowerBound,
	        targetUpperBound = _props$bgBounds.targetUpperBound,
	        yScale = props.yScale;
	
	    // default Y position is the center of the target range
	    // i.e., 100 mg/dL if target range is 80-120 mg/dL
	
	    var defaultY = yScale(targetUpperBound - (targetUpperBound - targetLowerBound) / 2);
	
	    return _react2.default.createElement(WrappedComponent, _extends({ defaultY: defaultY }, props));
	  };
	
	  WithDefault.propTypes = {
	    bgBounds: _react.PropTypes.shape({
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired
	    }).isRequired,
	    yScale: _react.PropTypes.func.isRequired
	  };
	
	  return WithDefault;
	};
	
	var _default = withDefaultYPosition;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(withDefaultYPosition, 'withDefaultYPosition', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/withDefaultYPosition.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/withDefaultYPosition.js');
	})();

	;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGMedianAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGMedianAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(122), undefined);
	
	// module
	exports.push([module.id, ".CBGMedianAnimated--thickStroke--1kNsm{stroke-width:2}.CBGMedianAnimated--median--9lVxT{stroke:#fff;pointer-events:none}.CBGMedianAnimated--transparent--3FBcm{fill:transparent}@keyframes CBGMedianAnimated--fadein--2SSo3{0%{fill-opacity:0}to{fill-opacity:1}}@keyframes CBGMedianAnimated--fadeout--2O0kI{0%{fill-opacity:1}to{fill-opacity:0}}.CBGMedianAnimated--fadeinAnimation--1_d7J{animation:CBGMedianAnimated--fadein--2SSo3 .25s forwards ease-in-out}.CBGMedianAnimated--fadeoutAnimation--3N5Z1{animation:CBGMedianAnimated--fadeout--2O0kI .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"thickStroke": "CBGMedianAnimated--thickStroke--1kNsm",
		"median": "CBGMedianAnimated--median--9lVxT CBGMedianAnimated--thickStroke--1kNsm",
		"transparent": "CBGMedianAnimated--transparent--3FBcm",
		"fadeinAnimation": "CBGMedianAnimated--fadeinAnimation--1_d7J",
		"fadein": "CBGMedianAnimated--fadein--2SSo3",
		"fadeoutAnimation": "CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"fadeout": "CBGMedianAnimated--fadeout--2O0kI",
		"lowFadeIn": "CBGMedianAnimated--lowFadeIn--1OV-G " + __webpack_require__(122).locals["bgLow"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"lowFadeOut": "CBGMedianAnimated--lowFadeOut--26emZ " + __webpack_require__(122).locals["bgLow"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"targetFadeIn": "CBGMedianAnimated--targetFadeIn--2AHgv " + __webpack_require__(122).locals["bgTarget"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"targetFadeOut": "CBGMedianAnimated--targetFadeOut--18g51 " + __webpack_require__(122).locals["bgTarget"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1",
		"highFadeIn": "CBGMedianAnimated--highFadeIn--r3_uQ " + __webpack_require__(122).locals["bgHigh"] + " CBGMedianAnimated--fadeinAnimation--1_d7J",
		"highFadeOut": "CBGMedianAnimated--highFadeOut--3fum2 " + __webpack_require__(122).locals["bgHigh"] + " CBGMedianAnimated--fadeoutAnimation--3N5Z1"
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGSliceAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(125);
	
	var _constants = __webpack_require__(16);
	
	var _withDefaultYPosition = __webpack_require__(126);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _CBGSliceSegment = __webpack_require__(130);
	
	var _CBGSliceSegment2 = _interopRequireDefault(_CBGSliceSegment);
	
	var _CBGSliceAnimated = __webpack_require__(131);
	
	var _CBGSliceAnimated2 = _interopRequireDefault(_CBGSliceAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSliceAnimated = exports.CBGSliceAnimated = function (_PureComponent) {
	  _inherits(CBGSliceAnimated, _PureComponent);
	
	  function CBGSliceAnimated(props) {
	    _classCallCheck(this, CBGSliceAnimated);
	
	    var _this = _possibleConstructorReturn(this, (CBGSliceAnimated.__proto__ || Object.getPrototypeOf(CBGSliceAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGSliceAnimated, [{
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var style = entered.style;
	      var defaultY = this.props.defaultY;
	
	
	      return _lodash2.default.mapValues(style, function (val, key) {
	        if (key === 'opacity') {
	          return 0;
	        } else if (key.search('Height') !== -1) {
	          return 0;
	        }
	        return defaultY;
	      });
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var style = exited.style;
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return _lodash2.default.mapValues(style, function (val, key) {
	        if (key === 'opacity') {
	          return shrinkOut;
	        } else if (key.search('Height') !== -1) {
	          return shrinkOut;
	        }
	        return (0, _reactMotion.spring)(defaultY, _constants.springConfig);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          displayFlags = _props.displayFlags,
	          sliceWidth = _props.sliceWidth,
	          showingCbgDateTraces = _props.showingCbgDateTraces,
	          tooltipLeftThreshold = _props.tooltipLeftThreshold,
	          topMargin = _props.topMargin,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var renderPieces = {
	        top10: {
	          classKey: 'rangeSegment',
	          displayFlag: 'cbg100Enabled',
	          height: 'top10Height',
	          heightKeys: ['ninetiethQuantile', 'max'],
	          key: 'top10',
	          y: 'max'
	        },
	        bottom10: {
	          classKey: 'rangeSegment',
	          displayFlag: 'cbg100Enabled',
	          height: 'bottom10Height',
	          heightKeys: ['min', 'tenthQuantile'],
	          key: 'bottom10',
	          y: 'tenthQuantile'
	        },
	        upper15: {
	          classKey: 'outerSegment',
	          displayFlag: 'cbg80Enabled',
	          height: 'upper15Height',
	          heightKeys: ['thirdQuartile', 'ninetiethQuantile'],
	          key: 'upper15',
	          y: 'ninetiethQuantile'
	        },
	        lower15: {
	          classKey: 'outerSegment',
	          displayFlag: 'cbg80Enabled',
	          height: 'lower15Height',
	          heightKeys: ['tenthQuantile', 'firstQuartile'],
	          key: 'lower15',
	          y: 'firstQuartile'
	        },
	        innerQuartiles: {
	          classKey: 'innerQuartilesSegment',
	          displayFlag: 'cbg50Enabled',
	          height: 'innerQuartilesHeight',
	          heightKeys: ['firstQuartile', 'thirdQuartile'],
	          key: 'innerQuartiles',
	          y: 'thirdQuartile'
	        }
	      };
	      var toRender = _lodash2.default.filter(renderPieces, function (piece) {
	        return displayFlags[piece.displayFlag];
	      });
	      var yPositions = {
	        firstQuartile: yScale(datum.firstQuartile),
	        max: yScale(datum.max),
	        median: yScale(datum.median),
	        min: yScale(datum.min),
	        ninetiethQuantile: yScale(datum.ninetiethQuantile),
	        tenthQuantile: yScale(datum.tenthQuantile),
	        thirdQuartile: yScale(datum.thirdQuartile),
	        topMargin: topMargin
	      };
	
	      var binLeftX = xScale(datum.msX) - sliceWidth / 2 + _CBGSliceAnimated2.default.stroke / 2;
	      var width = sliceWidth - _CBGSliceAnimated2.default.stroke;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: _lodash2.default.get(datum, 'min') !== undefined ? _lodash2.default.map(toRender, function (segment) {
	            var _style;
	
	            return {
	              key: segment.key,
	              style: (_style = {}, _defineProperty(_style, segment.y, defaultY), _defineProperty(_style, segment.height, 0), _defineProperty(_style, 'opacity', 0), _style)
	            };
	          }) : [],
	          styles: _lodash2.default.get(datum, 'min') !== undefined ? _lodash2.default.map(toRender, function (segment) {
	            var _style2;
	
	            return {
	              key: segment.key,
	              style: (_style2 = {}, _defineProperty(_style2, segment.y, (0, _reactMotion.spring)(yScale(datum[segment.y]), _constants.springConfig)), _defineProperty(_style2, segment.height, (0, _reactMotion.spring)(yScale(datum[segment.heightKeys[0]]) - yScale(datum[segment.heightKeys[1]]), _constants.springConfig)), _defineProperty(_style2, 'opacity', (0, _reactMotion.spring)(1.0, _constants.springConfig)), _style2)
	            };
	          }) : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'g',
	            { id: 'cbgSlice-' + datum.id },
	            _lodash2.default.map(interpolateds, function (interpolated) {
	              var _cx;
	
	              var segment = renderPieces[interpolated.key];
	              var classes = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _CBGSliceAnimated2.default.segment, true), _defineProperty(_cx, _CBGSliceAnimated2.default[segment.classKey], !showingCbgDateTraces), _defineProperty(_cx, _CBGSliceAnimated2.default[segment.classKey + 'Faded'], showingCbgDateTraces), _cx));
	              return _react2.default.createElement(_CBGSliceSegment2.default, {
	                classes: classes,
	                datum: datum,
	                interpolated: interpolated,
	                key: interpolated.key,
	                positionData: {
	                  left: xScale(datum.msX),
	                  tooltipLeft: datum.msX > tooltipLeftThreshold,
	                  yPositions: yPositions
	                },
	                segment: segment,
	                width: width,
	                x: binLeftX
	              });
	            })
	          );
	        }
	      );
	    }
	  }]);
	
	  return CBGSliceAnimated;
	}(_react.PureComponent);
	
	CBGSliceAnimated.defaultProps = {
	  sliceWidth: 16
	};
	CBGSliceAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    firstQuartile: _react.PropTypes.number,
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    median: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired,
	    msX: _react.PropTypes.number.isRequired,
	    ninetiethQuantile: _react.PropTypes.number,
	    tenthQuantile: _react.PropTypes.number,
	    thirdQuartile: _react.PropTypes.number
	  }).isRequired,
	  defaultY: _react.PropTypes.number.isRequired,
	  displayFlags: _react.PropTypes.shape({
	    cbg100Enabled: _react.PropTypes.bool.isRequired,
	    cbg80Enabled: _react.PropTypes.bool.isRequired,
	    cbg50Enabled: _react.PropTypes.bool.isRequired,
	    cbgMedianEnabled: _react.PropTypes.bool.isRequired
	  }).isRequired,
	  showingCbgDateTraces: _react.PropTypes.bool.isRequired,
	  sliceWidth: _react.PropTypes.number.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  topMargin: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(CBGSliceAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSliceAnimated, 'CBGSliceAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceAnimated.js');
	})();

	;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CBGSliceSegment = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _thunks = __webpack_require__(33);
	
	var _trends = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CBGSliceSegment = exports.CBGSliceSegment = function (_PureComponent) {
	  _inherits(CBGSliceSegment, _PureComponent);
	
	  function CBGSliceSegment(props) {
	    _classCallCheck(this, CBGSliceSegment);
	
	    var _this = _possibleConstructorReturn(this, (CBGSliceSegment.__proto__ || Object.getPrototypeOf(CBGSliceSegment)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(CBGSliceSegment, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut(e) {
	      // we don't want to unfocus the slice if the user just rolled over a cbg inside it
	      if (e.relatedTarget && e.relatedTarget.id.search('cbgCircle') !== -1) {
	        return;
	      }
	      this.props.unfocusSlice(this.props.userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props = this.props,
	          datum = _props.datum,
	          focusSlice = _props.focusSlice,
	          positionData = _props.positionData,
	          focusedKeys = _props.segment.heightKeys,
	          userId = _props.userId;
	
	
	      focusSlice(userId, datum, positionData, focusedKeys);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          classes = _props2.classes,
	          datum = _props2.datum,
	          _props2$interpolated = _props2.interpolated,
	          key = _props2$interpolated.key,
	          style = _props2$interpolated.style,
	          segment = _props2.segment,
	          width = _props2.width,
	          x = _props2.x;
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        key: key,
	        id: 'cbgSlice-' + datum.id + '-' + key,
	        width: width,
	        height: style[segment.height],
	        x: x,
	        y: style[segment.y],
	        opacity: style.opacity,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      });
	    }
	  }]);
	
	  return CBGSliceSegment;
	}(_react.PureComponent);
	
	CBGSliceSegment.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired
	  }),
	  focusSlice: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.object.isRequired
	  }),
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired,
	      topMargin: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  segment: _react.PropTypes.shape({
	    height: _react.PropTypes.string.isRequired,
	    heightKeys: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	    y: _react.PropTypes.string.isRequired
	  }),
	  unfocusSlice: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  x: _react.PropTypes.number.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusSlice: _thunks.delayShowCbgTracesOnFocus,
	    unfocusSlice: _trends.unfocusTrendsCbgSlice
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CBGSliceSegment);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBGSliceSegment, 'CBGSliceSegment', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/CBGSliceSegment.js');
	})();

	;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGSliceAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./CBGSliceAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".CBGSliceAnimated--segment--R3_GL{stroke-width:2;pointer-events:all}@keyframes CBGSliceAnimated--fadeRangeOut--3koNl{0%{stroke:var(--trends--light)}to{stroke:var(--trends--light--faded)}}@keyframes CBGSliceAnimated--fadeRangeIn--1Tg9W{0%{stroke:var(--trends--light--faded)}to{stroke:var(--trends--light)}}.CBGSliceAnimated--rangeSegment--hC3rL{animation:CBGSliceAnimated--fadeRangeIn--1Tg9W .25s forwards ease-in-out;fill:transparent}.CBGSliceAnimated--rangeSegmentFaded--2MJRj{animation:CBGSliceAnimated--fadeRangeOut--3koNl .25s forwards ease-in-out;fill:transparent}.CBGSliceAnimated--rangeSegment--hC3rL:hover,.CBGSliceAnimated--rangeSegmentFaded--2MJRj:hover{opacity:0}@keyframes CBGSliceAnimated--fadeOuterOut--awtzV{0%{fill:var(--trends--light);stroke:var(--trends--light)}to{fill:var(--trends--light--faded);stroke:var(--trends--light--faded)}}@keyframes CBGSliceAnimated--fadeOuterIn--g2T_t{0%{fill:var(--trends--light--faded);stroke:var(--trends--light--faded)}to{fill:var(--trends--light);stroke:var(--trends--light)}}.CBGSliceAnimated--outerSegment--23iy1{animation:CBGSliceAnimated--fadeOuterIn--g2T_t .25s forwards ease-in-out}.CBGSliceAnimated--outerSegmentFaded--1CrLu{animation:CBGSliceAnimated--fadeOuterOut--awtzV .25s forwards ease-in-out}.CBGSliceAnimated--outerSegment--23iy1:hover,.CBGSliceAnimated--outerSegmentFaded--1CrLu:hover{opacity:0}@keyframes CBGSliceAnimated--fadeInnerOut--1uLrJ{0%{fill:var(--trends--dark);stroke:var(--trends--dark)}to{fill:var(--trends--dark--faded);stroke:var(--trends--dark--faded)}}@keyframes CBGSliceAnimated--fadeInnerIn--2yMaD{0%{fill:var(--trends--dark--faded);stroke:var(--trends--dark--faded)}to{fill:var(--trends--dark);stroke:var(--trends--dark)}}.CBGSliceAnimated--innerQuartilesSegment--3C9dQ{animation:CBGSliceAnimated--fadeInnerIn--2yMaD .25s forwards ease-in-out}.CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA{animation:CBGSliceAnimated--fadeInnerOut--1uLrJ .25s forwards ease-in-out}.CBGSliceAnimated--innerQuartilesSegment--3C9dQ:hover,.CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA:hover{opacity:0}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"segment": "CBGSliceAnimated--segment--R3_GL",
		"rangeSegment": "CBGSliceAnimated--rangeSegment--hC3rL",
		"fadeRangeIn": "CBGSliceAnimated--fadeRangeIn--1Tg9W",
		"rangeSegmentFaded": "CBGSliceAnimated--rangeSegmentFaded--2MJRj",
		"fadeRangeOut": "CBGSliceAnimated--fadeRangeOut--3koNl",
		"outerSegment": "CBGSliceAnimated--outerSegment--23iy1",
		"fadeOuterIn": "CBGSliceAnimated--fadeOuterIn--g2T_t",
		"outerSegmentFaded": "CBGSliceAnimated--outerSegmentFaded--1CrLu",
		"fadeOuterOut": "CBGSliceAnimated--fadeOuterOut--awtzV",
		"innerQuartilesSegment": "CBGSliceAnimated--innerQuartilesSegment--3C9dQ",
		"fadeInnerIn": "CBGSliceAnimated--fadeInnerIn--2yMaD",
		"innerQuartilesSegmentFaded": "CBGSliceAnimated--innerQuartilesSegmentFaded--3bXPA",
		"fadeInnerOut": "CBGSliceAnimated--fadeInnerOut--1uLrJ"
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FocusedCBGSliceSegment = __webpack_require__(134);
	
	var _FocusedCBGSliceSegment2 = _interopRequireDefault(_FocusedCBGSliceSegment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var FocusedCBGSliceSegment = function FocusedCBGSliceSegment(props) {
	  if (!props.focusedSlice || !props.focusedSliceKeys) {
	    return null;
	  }
	  var position = props.focusedSlice.position,
	      focusedSliceKeys = props.focusedSliceKeys,
	      sliceWidth = props.sliceWidth;
	
	  return _react2.default.createElement('rect', {
	    className: _FocusedCBGSliceSegment2.default.segment,
	    x: position.left - sliceWidth / 2 + _FocusedCBGSliceSegment2.default.stroke / 2,
	    y: position.yPositions[focusedSliceKeys[1]],
	    width: sliceWidth - _FocusedCBGSliceSegment2.default.stroke,
	    height: position.yPositions[focusedSliceKeys[0]] - position.yPositions[focusedSliceKeys[1]]
	  });
	};
	
	FocusedCBGSliceSegment.defaultProps = {
	  sliceWidth: 16
	};
	
	FocusedCBGSliceSegment.propTypes = {
	  focusedSlice: _react.PropTypes.shape({
	    data: _react.PropTypes.shape({
	      firstQuartile: _react.PropTypes.number.isRequired,
	      max: _react.PropTypes.number.isRequired,
	      median: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired,
	      ninetiethQuantile: _react.PropTypes.number.isRequired,
	      tenthQuantile: _react.PropTypes.number.isRequired,
	      thirdQuartile: _react.PropTypes.number.isRequired
	    }).isRequired,
	    position: _react.PropTypes.shape({
	      left: _react.PropTypes.number.isRequired,
	      tooltipLeft: _react.PropTypes.bool.isRequired,
	      yPositions: _react.PropTypes.shape({
	        firstQuartile: _react.PropTypes.number.isRequired,
	        max: _react.PropTypes.number.isRequired,
	        median: _react.PropTypes.number.isRequired,
	        min: _react.PropTypes.number.isRequired,
	        ninetiethQuantile: _react.PropTypes.number.isRequired,
	        tenthQuantile: _react.PropTypes.number.isRequired,
	        thirdQuartile: _react.PropTypes.number.isRequired
	      }).isRequired
	    }).isRequired
	  }),
	  focusedSliceKeys: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['firstQuartile', 'max', 'median', 'min', 'ninetiethQuantile', 'tenthQuantile', 'thirdQuartile'])),
	  sliceWidth: _react.PropTypes.number.isRequired
	};
	
	var _default = FocusedCBGSliceSegment;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FocusedCBGSliceSegment, 'FocusedCBGSliceSegment', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/FocusedCBGSliceSegment.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/cbg/FocusedCBGSliceSegment.js');
	})();

	;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedCBGSliceSegment.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./FocusedCBGSliceSegment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".FocusedCBGSliceSegment--segment--3hWTM{stroke:#000;stroke-width:2;pointer-events:none;fill:transparent}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"segment": "FocusedCBGSliceSegment--segment--3hWTM"
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SMBGDatePointsAnimated = __webpack_require__(137);
	
	var _SMBGDatePointsAnimated2 = _interopRequireDefault(_SMBGDatePointsAnimated);
	
	var _SMBGDateLineAnimated = __webpack_require__(140);
	
	var _SMBGDateLineAnimated2 = _interopRequireDefault(_SMBGDateLineAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var SMBGsByDateContainer = function SMBGsByDateContainer(props) {
	  var data = props.data;
	
	  if (!data) {
	    return null;
	  }
	
	  var anSmbgRangeAvgIsFocused = props.anSmbgRangeAvgIsFocused,
	      bgBounds = props.bgBounds,
	      dates = props.dates,
	      focusedSmbg = props.focusedSmbg,
	      grouped = props.grouped,
	      lines = props.lines,
	      nonInteractive = props.nonInteractive,
	      onSelectDate = props.onSelectDate,
	      smbgOpts = props.smbgOpts,
	      someSmbgDataIsFocused = props.someSmbgDataIsFocused,
	      tooltipLeftThreshold = props.tooltipLeftThreshold,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	
	  var focusedDay = focusedSmbg ? focusedSmbg.date : '';
	  var smbgsByDate = _lodash2.default.groupBy(data, 'localDate');
	  _lodash2.default.each(dates, function (date) {
	    if (!smbgsByDate[date]) {
	      smbgsByDate[date] = [];
	    }
	  });
	
	  function getLines() {
	    var allDateLines = [];
	    _lodash2.default.each(smbgsByDate, function (smbgs, date) {
	      var dateData = lines ? smbgs : [];
	      allDateLines.push(_react2.default.createElement(_SMBGDateLineAnimated2.default, {
	        bgBounds: bgBounds,
	        data: dateData,
	        date: date,
	        focusedDay: focusedDay,
	        grouped: grouped,
	        key: date,
	        onSelectDate: onSelectDate,
	        nonInteractive: nonInteractive,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      }));
	    });
	    if (focusedDay) {
	      allDateLines.push(_react2.default.createElement(_SMBGDateLineAnimated2.default, {
	        bgBounds: bgBounds,
	        data: focusedSmbg.allSmbgsOnDate,
	        date: focusedDay,
	        key: focusedDay + '-focused',
	        focusedDay: focusedDay,
	        grouped: grouped,
	        onSelectDate: onSelectDate,
	        nonInteractive: nonInteractive,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      }));
	    }
	    return allDateLines;
	  }
	
	  function getPoints() {
	    return _lodash2.default.map(smbgsByDate, function (smbgs, date) {
	      return _react2.default.createElement(_SMBGDatePointsAnimated2.default, {
	        anSmbgRangeAvgIsFocused: anSmbgRangeAvgIsFocused,
	        bgBounds: bgBounds,
	        data: smbgs,
	        date: date,
	        grouped: grouped,
	        isFocused: focusedDay === date,
	        key: date,
	        nonInteractive: nonInteractive,
	        onSelectDate: onSelectDate,
	        smbgOpts: smbgOpts,
	        someSmbgDataIsFocused: someSmbgDataIsFocused,
	        tooltipLeftThreshold: tooltipLeftThreshold,
	        xScale: xScale,
	        yScale: yScale
	      });
	    });
	  }
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'smbgsByDateContainer' },
	    getLines(),
	    getPoints()
	  );
	};
	
	SMBGsByDateContainer.propTypes = {
	  anSmbgRangeAvgIsFocused: _react.PropTypes.bool.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    localDate: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  dates: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  focusedSmbg: _react.PropTypes.shape({
	    allPositions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })),
	    allSmbgsOnDate: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    })),
	    date: _react.PropTypes.string.isRequired,
	    datum: _react.PropTypes.shape({
	      value: _react.PropTypes.number.isRequired
	    }),
	    position: _react.PropTypes.shape({
	      top: _react.PropTypes.number.isRequired,
	      left: _react.PropTypes.number.isRequired
	    })
	  }),
	  grouped: _react.PropTypes.bool.isRequired,
	  lines: _react.PropTypes.bool.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = SMBGsByDateContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGsByDateContainer, 'SMBGsByDateContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGsByDateContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGsByDateContainer.js');
	})();

	;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGDatePointsAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _reactMotion = __webpack_require__(125);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _constants = __webpack_require__(16);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	var _trends = __webpack_require__(34);
	
	var _SMBGDatePointsAnimated = __webpack_require__(138);
	
	var _SMBGDatePointsAnimated2 = _interopRequireDefault(_SMBGDatePointsAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGDatePointsAnimated = exports.SMBGDatePointsAnimated = function (_PureComponent) {
	  _inherits(SMBGDatePointsAnimated, _PureComponent);
	
	  function SMBGDatePointsAnimated(props) {
	    _classCallCheck(this, SMBGDatePointsAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGDatePointsAnimated.__proto__ || Object.getPrototypeOf(SMBGDatePointsAnimated)).call(this, props));
	
	    _this.getPositions = _this.getPositions.bind(_this);
	    _this.getXPosition = _this.getXPosition.bind(_this);
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGDatePointsAnimated, [{
	    key: 'getPositions',
	    value: function getPositions() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          tooltipLeftThreshold = _props.tooltipLeftThreshold,
	          yScale = _props.yScale;
	
	      return _lodash2.default.map(data, function (d) {
	        return {
	          left: _this2.getXPosition(d.msPer24),
	          top: yScale(d.value),
	          tooltipLeft: d.msPer24 > tooltipLeftThreshold
	        };
	      });
	    }
	  }, {
	    key: 'getXPosition',
	    value: function getXPosition(msPer24) {
	      var _props2 = this.props,
	          grouped = _props2.grouped,
	          xScale = _props2.xScale;
	
	      if (grouped) {
	        return xScale((0, _data.findBinForTimeOfDay)(_datetime.THREE_HRS, msPer24));
	      }
	      return xScale(msPer24);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props3 = this.props,
	          date = _props3.date,
	          onSelectDate = _props3.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props4 = this.props,
	          unfocusSmbg = _props4.unfocusSmbg,
	          userId = _props4.userId;
	
	      unfocusSmbg(userId);
	    }
	  }, {
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var data = entered.data;
	      var xScale = this.props.xScale;
	
	      return {
	        cx: xScale(data.smbg.msPer24),
	        opacity: 0.5,
	        r: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var data = exited.data;
	      var _props5 = this.props,
	          anSmbgRangeAvgIsFocused = _props5.anSmbgRangeAvgIsFocused,
	          someSmbgDataIsFocused = _props5.someSmbgDataIsFocused,
	          xScale = _props5.xScale;
	
	      return {
	        cx: (0, _reactMotion.spring)(xScale(data.smbg.msPer24), _constants.springConfig),
	        opacity: anSmbgRangeAvgIsFocused || someSmbgDataIsFocused ? (0, _reactMotion.spring)(0.35, _constants.springConfig) : (0, _reactMotion.spring)(0.8, _constants.springConfig),
	        r: (0, _reactMotion.spring)(0, _constants.springConfig)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          anSmbgRangeAvgIsFocused = _props6.anSmbgRangeAvgIsFocused,
	          bgBounds = _props6.bgBounds,
	          data = _props6.data,
	          date = _props6.date,
	          focusSmbg = _props6.focusSmbg,
	          isFocused = _props6.isFocused,
	          nonInteractive = _props6.nonInteractive,
	          smbgOpts = _props6.smbgOpts,
	          someSmbgDataIsFocused = _props6.someSmbgDataIsFocused,
	          userId = _props6.userId;
	
	      var radius = isFocused ? smbgOpts.maxR : smbgOpts.r;
	      var positions = this.getPositions();
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: data.length || !nonInteractive ? _lodash2.default.map(data, function (smbg, i) {
	            var position = positions[i];
	            return {
	              key: smbg.id,
	              style: {
	                cx: position.left,
	                opacity: 0.5,
	                r: 0
	              }
	            };
	          }) : [],
	          styles: data.length ? _lodash2.default.map(data, function (smbg, i) {
	            var position = positions[i];
	            return {
	              key: smbg.id,
	              data: {
	                classes: _SMBGDatePointsAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, smbg.value)],
	                position: position,
	                smbg: smbg
	              },
	              style: {
	                cx: (0, _reactMotion.spring)(position.left, _constants.springConfig),
	                opacity: anSmbgRangeAvgIsFocused || someSmbgDataIsFocused ? (0, _reactMotion.spring)(0.35, _constants.springConfig) : (0, _reactMotion.spring)(0.8, _constants.springConfig),
	                r: (0, _reactMotion.spring)(radius, _constants.springConfig)
	              }
	            };
	          }) : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolateds) {
	          if (interpolateds.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'g',
	            { id: 'smbgDatePoints-' + date },
	            _lodash2.default.map(interpolateds, function (smbg) {
	              var key = smbg.key,
	                  style = smbg.style;
	
	              return _react2.default.createElement('circle', {
	                className: smbg.data.classes,
	                id: 'smbg-' + key,
	                key: key,
	                onMouseOver: function onMouseOver() {
	                  return focusSmbg(userId, smbg.data.smbg, smbg.data.position, data, positions, date);
	                },
	                onMouseOut: _this3.handleMouseOut,
	                onClick: _this3.handleClick,
	                cx: style.cx,
	                cy: smbg.data.position.top,
	                r: style.r,
	                fillOpacity: style.opacity,
	                pointerEvents: nonInteractive ? 'none' : 'all'
	              });
	            })
	          );
	        }
	      );
	    }
	  }]);
	
	  return SMBGDatePointsAnimated;
	}(_react.PureComponent);
	
	SMBGDatePointsAnimated.propTypes = {
	  anSmbgRangeAvgIsFocused: _react.PropTypes.bool.isRequired,
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusSmbg: _react.PropTypes.func.isRequired,
	  grouped: _react.PropTypes.bool.isRequired,
	  isFocused: _react.PropTypes.bool.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  unfocusSmbg: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusSmbg: _trends.focusTrendsSmbg,
	    unfocusSmbg: _trends.unfocusTrendsSmbg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGDatePointsAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGDatePointsAnimated, 'SMBGDatePointsAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDatePointsAnimated.js');
	})();

	;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(139);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDatePointsAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDatePointsAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(122), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"low": "SMBGDatePointsAnimated--low--2QXpz " + __webpack_require__(122).locals["bgLow"] + "",
		"target": "SMBGDatePointsAnimated--target--1a27- " + __webpack_require__(122).locals["bgTarget"] + "",
		"high": "SMBGDatePointsAnimated--high--1tgZk " + __webpack_require__(122).locals["bgHigh"] + ""
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGDateLineAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _reactMotion = __webpack_require__(125);
	
	var _d3Shape = __webpack_require__(141);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(16);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	var _trends = __webpack_require__(34);
	
	var _SMBGDateLineAnimated = __webpack_require__(142);
	
	var _SMBGDateLineAnimated2 = _interopRequireDefault(_SMBGDateLineAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// this component renders a line connecting the smbgs from a single date
	// it has two or three potential states:
	// - grouping on: the y-position of each point on the line segment
	//   is the average of all the smbgs in the group
	//   NB: when grouping is on, no line hover interaction
	// - grouping off: just connect the dots!
	//   but also include a 2nd, fatter invisible line with onMouseOver & onMouseOut handlers
	//   for the line to "focus" the whole date
	//   (there seems to be a regression on prod re: the rendering of the fatter invisible lines)
	// - date is focused (through hover) fatter & solid line connecting the dots
	//   this style also applies when a single smbg is focused
	
	var SMBGDateLineAnimated = exports.SMBGDateLineAnimated = function (_PureComponent) {
	  _inherits(SMBGDateLineAnimated, _PureComponent);
	
	  function SMBGDateLineAnimated(props) {
	    _classCallCheck(this, SMBGDateLineAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGDateLineAnimated.__proto__ || Object.getPrototypeOf(SMBGDateLineAnimated)).call(this, props));
	
	    _this.getDefaultPoints = _this.getDefaultPoints.bind(_this);
	    _this.getPoints = _this.getPoints.bind(_this);
	
	    _this.getPositions = _this.getPositions.bind(_this);
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGDateLineAnimated, [{
	    key: 'getDefaultPoints',
	    value: function getDefaultPoints() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          grouped = _props.grouped,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	      var points = [];
	      _lodash2.default.map(data, function (d) {
	        points.push({
	          key: d.id,
	          style: {
	            opacity: 0,
	            x: xScale(_this2.getXPosition(d.msPer24, grouped)),
	            y: yScale(d.value)
	          } });
	      });
	      return points;
	    }
	  }, {
	    key: 'getPoints',
	    value: function getPoints() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          grouped = _props2.grouped,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	      var points = [];
	      _lodash2.default.map(data, function (d) {
	        points.push({
	          key: d.id,
	          style: {
	            opacity: (0, _reactMotion.spring)(1, _constants.springConfig),
	            x: (0, _reactMotion.spring)(xScale(_this3.getXPosition(d.msPer24, grouped)), _constants.springConfig),
	            // basically a no-op animation but the data reshaping below for the d3 line() fn
	            // seems to require us to animate all properties we want to reshape there
	            y: (0, _reactMotion.spring)(yScale(d.value), _constants.springConfig)
	          } });
	      });
	      return points;
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          grouped = _props3.grouped,
	          tooltipLeftThreshold = _props3.tooltipLeftThreshold,
	          xScale = _props3.xScale,
	          yScale = _props3.yScale;
	
	      return _lodash2.default.map(data, function (d) {
	        return {
	          tooltipLeft: d.msPer24 > tooltipLeftThreshold,
	          left: xScale(_this4.getXPosition(d.msPer24, grouped)),
	          top: yScale(d.value)
	        };
	      });
	    }
	  }, {
	    key: 'getXPosition',
	    value: function getXPosition(msPer24, grouped) {
	      if (grouped) {
	        return (0, _data.findBinForTimeOfDay)(_datetime.THREE_HRS, msPer24);
	      }
	      return msPer24;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props4 = this.props,
	          date = _props4.date,
	          onSelectDate = _props4.onSelectDate;
	
	      onSelectDate(date);
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props5 = this.props,
	          unfocusLine = _props5.unfocusLine,
	          userId = _props5.userId;
	
	      unfocusLine(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props6 = this.props,
	          data = _props6.data,
	          date = _props6.date,
	          focusLine = _props6.focusLine,
	          userId = _props6.userId;
	
	      var positions = this.getPositions();
	      focusLine(userId, data[0], positions[0], data, positions, date);
	    }
	  }, {
	    key: 'willEnter',
	    value: function willEnter(entered) {
	      var style = entered.style;
	
	      return {
	        opacity: 0,
	        x: _lodash2.default.get(style, ['x', 'val'], style.x),
	        y: _lodash2.default.get(style, ['y', 'val'], style.y)
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave(exited) {
	      var style = exited.style;
	
	      return {
	        opacity: (0, _reactMotion.spring)(0, _constants.springConfig),
	        x: (0, _reactMotion.spring)(_lodash2.default.get(style, ['x', 'val'], style.x), _constants.springConfig),
	        y: (0, _reactMotion.spring)(_lodash2.default.get(style, ['y', 'val'], style.y), _constants.springConfig)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _this5 = this;
	
	      var _props7 = this.props,
	          data = _props7.data,
	          date = _props7.date,
	          focusedDay = _props7.focusedDay,
	          nonInteractive = _props7.nonInteractive;
	
	
	      var classes = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGDateLineAnimated2.default.smbgPath, true), _defineProperty(_cx, _SMBGDateLineAnimated2.default.highlightPath, focusedDay === date), _cx));
	
	      return _react2.default.createElement(
	        'g',
	        { id: 'smbgDateLine-' + date },
	        _react2.default.createElement(
	          _reactMotion.TransitionMotion,
	          {
	            defaultStyles: this.getDefaultPoints(data),
	            styles: this.getPoints(data),
	            willEnter: this.willEnter,
	            willLeave: this.willLeave
	          },
	          function (interpolated) {
	            if (interpolated.length === 0) {
	              return null;
	            }
	            return _react2.default.createElement('path', {
	              // d3 line() expects an array of 2-member arrays of x, y coordinates
	              d: (0, _d3Shape.line)()(_lodash2.default.map(_lodash2.default.pluck(interpolated, 'style'), function (style) {
	                return [_lodash2.default.get(style, ['x', 'val'], style.x), _lodash2.default.get(style, ['y', 'val'], style.y)];
	              })),
	              className: classes,
	              onMouseOver: _this5.handleMouseOver,
	              onMouseOut: _this5.handleMouseOut,
	              onClick: _this5.handleClick,
	              pointerEvents: nonInteractive ? 'none' : 'stroke',
	              strokeOpacity: _lodash2.default.get(interpolated[0], ['style', 'opacity'])
	            });
	          }
	        )
	      );
	    }
	  }]);
	
	  return SMBGDateLineAnimated;
	}(_react.PureComponent);
	
	SMBGDateLineAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  date: _react.PropTypes.string.isRequired,
	  focusedDay: _react.PropTypes.string.isRequired,
	  focusLine: _react.PropTypes.func.isRequired,
	  grouped: _react.PropTypes.bool.isRequired,
	  onSelectDate: _react.PropTypes.func.isRequired,
	  nonInteractive: _react.PropTypes.bool,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  unfocusLine: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusLine: _trends.focusTrendsSmbg,
	    unfocusLine: _trends.unfocusTrendsSmbg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGDateLineAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGDateLineAnimated, 'SMBGDateLineAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGDateLineAnimated.js');
	})();

	;

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = require("d3-shape");

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(143);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDateLineAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGDateLineAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".SMBGDateLineAnimated--smbgPath--W8OdK{fill:none;stroke:var(--trends--dark);stroke-dasharray:4,4}.SMBGDateLineAnimated--highlightPath--1aPEd{stroke-width:2px;stroke-dasharray:4,0}", ""]);
	
	// exports
	exports.locals = {
		"smbgPath": "SMBGDateLineAnimated--smbgPath--W8OdK",
		"highlightPath": "SMBGDateLineAnimated--highlightPath--1aPEd"
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Array = __webpack_require__(26);
	
	var _datetime = __webpack_require__(20);
	
	var _data = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRangeAvgContainer = function (_PureComponent) {
	  _inherits(SMBGRangeAvgContainer, _PureComponent);
	
	  function SMBGRangeAvgContainer() {
	    _classCallCheck(this, SMBGRangeAvgContainer);
	
	    return _possibleConstructorReturn(this, (SMBGRangeAvgContainer.__proto__ || Object.getPrototypeOf(SMBGRangeAvgContainer)).apply(this, arguments));
	  }
	
	  _createClass(SMBGRangeAvgContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          binSize = _props.binSize,
	          data = _props.data;
	
	      this.setState({ mungedData: this.mungeData(binSize, data) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var binSize = nextProps.binSize,
	          data = nextProps.data;
	
	      if (binSize !== this.props.binSize || data !== this.props.data) {
	        this.setState({ mungedData: this.mungeData(binSize, data) });
	      }
	    }
	  }, {
	    key: 'mungeData',
	    value: function mungeData(binSize, data) {
	      var binned = _lodash2.default.groupBy(data, function (d) {
	        return (0, _data.findBinForTimeOfDay)(binSize, d.msPer24);
	      });
	      var outOfRanges = (0, _data.findOutOfRangeAnnotations)(data);
	      // we need *all* possible keys for TransitionMotion to work on enter/exit
	      // and the range starts with binSize/2 because the keys are centered in each bin
	      var binKeys = _lodash2.default.map((0, _d3Array.range)(binSize / 2, _datetime.TWENTY_FOUR_HRS, binSize), function (d) {
	        return String(d);
	      });
	
	      var valueExtractor = function valueExtractor(d) {
	        return d.value;
	      };
	      var mungedData = [];
	      for (var i = 0; i < binKeys.length; ++i) {
	        var values = _lodash2.default.map(binned[binKeys[i]], valueExtractor);
	        mungedData.push((0, _data.calculateSmbgStatsForBin)(binKeys[i], binSize, values, outOfRanges));
	      }
	      return mungedData;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var mungedData = this.state.mungedData;
	      var SMBGComponent = this.props.smbgComponent;
	
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'smbgAggContainer' },
	        _lodash2.default.map(mungedData, function (datum) {
	          return _react2.default.createElement(SMBGComponent, {
	            bgBounds: _this2.props.bgBounds,
	            datum: datum,
	            key: datum.id,
	            someSmbgDataIsFocused: _this2.props.someSmbgDataIsFocused,
	            tooltipLeftThreshold: _this2.props.tooltipLeftThreshold,
	            xScale: _this2.props.xScale,
	            yScale: _this2.props.yScale
	          });
	        })
	      );
	    }
	  }]);
	
	  return SMBGRangeAvgContainer;
	}(_react.PureComponent);
	
	SMBGRangeAvgContainer.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  binSize: _react.PropTypes.number.isRequired,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    // here only documenting the properties we actually use rather than the *whole* data model!
	    id: _react.PropTypes.string.isRequired,
	    msPer24: _react.PropTypes.number.isRequired,
	    value: _react.PropTypes.number.isRequired
	  })).isRequired,
	  smbgComponent: _react.PropTypes.func.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	SMBGRangeAvgContainer.defaultProps = {
	  binSize: _datetime.THREE_HRS
	};
	var _default = SMBGRangeAvgContainer;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRangeAvgContainer, 'SMBGRangeAvgContainer', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRangeAvgContainer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRangeAvgContainer.js');
	})();

	;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGRangeAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(125);
	
	var _constants = __webpack_require__(16);
	
	var _withDefaultYPosition = __webpack_require__(126);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _SMBGRange = __webpack_require__(146);
	
	var _SMBGRange2 = _interopRequireDefault(_SMBGRange);
	
	var _SMBGRangeAnimated = __webpack_require__(147);
	
	var _SMBGRangeAnimated2 = _interopRequireDefault(_SMBGRangeAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRangeAnimated = exports.SMBGRangeAnimated = function (_PureComponent) {
	  _inherits(SMBGRangeAnimated, _PureComponent);
	
	  function SMBGRangeAnimated(props) {
	    _classCallCheck(this, SMBGRangeAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGRangeAnimated.__proto__ || Object.getPrototypeOf(SMBGRangeAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGRangeAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	      return {
	        y: defaultY,
	        height: 0,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var defaultY = this.props.defaultY;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        y: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        height: shrinkOut,
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _this2 = this;
	
	      var _props = this.props,
	          datum = _props.datum,
	          defaultY = _props.defaultY,
	          someSmbgDataIsFocused = _props.someSmbgDataIsFocused,
	          xScale = _props.xScale,
	          yScale = _props.yScale;
	
	
	      var xPos = xScale(datum.msX);
	      var yPositions = {
	        min: yScale(datum.min),
	        mean: yScale(datum.mean),
	        max: yScale(datum.max)
	      };
	
	      var rangeClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGRangeAnimated2.default.smbgRange, true), _defineProperty(_cx, _SMBGRangeAnimated2.default.fadeIn, !someSmbgDataIsFocused), _defineProperty(_cx, _SMBGRangeAnimated2.default.fadeOut, someSmbgDataIsFocused), _cx));
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: [{
	            key: datum.id,
	            style: {
	              y: defaultY,
	              height: 0,
	              opacity: 0
	            }
	          }],
	          styles: datum.min ? [{
	            key: datum.id,
	            style: {
	              y: (0, _reactMotion.spring)(yPositions.max, _constants.springConfig),
	              height: (0, _reactMotion.spring)(yPositions.min - yPositions.max, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolated) {
	          if (interpolated.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(_SMBGRange2.default, {
	            classes: rangeClasses,
	            datum: datum,
	            interpolated: interpolated[0],
	            positionData: {
	              left: xPos,
	              tooltipLeft: datum.msX > _this2.props.tooltipLeftThreshold,
	              yPositions: yPositions
	            }
	          });
	        }
	      );
	    }
	  }]);
	
	  return SMBGRangeAnimated;
	}(_react.PureComponent);
	
	SMBGRangeAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  defaultY: _react.PropTypes.number.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(SMBGRangeAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRangeAnimated, 'SMBGRangeAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRangeAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRangeAnimated.js');
	})();

	;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGRange = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _trends = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGRange = exports.SMBGRange = function (_PureComponent) {
	  _inherits(SMBGRange, _PureComponent);
	
	  function SMBGRange(props) {
	    _classCallCheck(this, SMBGRange);
	
	    var _this = _possibleConstructorReturn(this, (SMBGRange.__proto__ || Object.getPrototypeOf(SMBGRange)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGRange, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props = this.props,
	          unfocusRange = _props.unfocusRange,
	          userId = _props.userId;
	
	      unfocusRange(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props2 = this.props,
	          datum = _props2.datum,
	          focusRange = _props2.focusRange,
	          positionData = _props2.positionData,
	          userId = _props2.userId;
	
	      focusRange(userId, datum, positionData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          classes = _props3.classes,
	          _props3$interpolated = _props3.interpolated,
	          key = _props3$interpolated.key,
	          style = _props3$interpolated.style,
	          positionData = _props3.positionData,
	          rectWidth = _props3.rectWidth;
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        id: 'smbgRange-' + key,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        x: positionData.left - rectWidth / 2,
	        y: style.y,
	        width: rectWidth,
	        height: style.height,
	        opacity: style.opacity
	      });
	    }
	  }]);
	
	  return SMBGRange;
	}(_react.PureComponent);
	
	SMBGRange.defaultProps = {
	  rectWidth: 108
	};
	SMBGRange.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  focusRange: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.shape({
	      height: _react.PropTypes.number.isRequired,
	      opacity: _react.PropTypes.number.isRequired,
	      y: _react.PropTypes.number.isRequired
	    }).isRequired
	  }).isRequired,
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  rectWidth: _react.PropTypes.number.isRequired,
	  unfocusRange: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusRange: _trends.focusTrendsSmbgRangeAvg,
	    unfocusRange: _trends.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGRange);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGRange, 'SMBGRange', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGRange.js');
	})();

	;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGRangeAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGRangeAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes SMBGRangeAnimated--fadein--1Nr5V{0%{fill-opacity:.3}to{fill-opacity:.4}}@keyframes SMBGRangeAnimated--fadeout--2huim{0%{fill-opacity:.4}to{fill-opacity:.3}}.SMBGRangeAnimated--smbgRange--14DpS{fill:var(--trends--light);stroke:none}.SMBGRangeAnimated--fadeIn--3XbzN{animation:SMBGRangeAnimated--fadein--1Nr5V .25s forwards ease-in-out}.SMBGRangeAnimated--fadeOut--2Evdt{animation:SMBGRangeAnimated--fadeout--2huim .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"smbgRange": "SMBGRangeAnimated--smbgRange--14DpS",
		"fadeIn": "SMBGRangeAnimated--fadeIn--3XbzN",
		"fadein": "SMBGRangeAnimated--fadein--1Nr5V",
		"fadeOut": "SMBGRangeAnimated--fadeOut--2Evdt",
		"fadeout": "SMBGRangeAnimated--fadeout--2huim"
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGMeanAnimated = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(68);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(125);
	
	var _bloodglucose = __webpack_require__(19);
	
	var _constants = __webpack_require__(16);
	
	var _withDefaultYPosition = __webpack_require__(126);
	
	var _withDefaultYPosition2 = _interopRequireDefault(_withDefaultYPosition);
	
	var _SMBGMean = __webpack_require__(150);
	
	var _SMBGMean2 = _interopRequireDefault(_SMBGMean);
	
	var _SMBGMeanAnimated = __webpack_require__(151);
	
	var _SMBGMeanAnimated2 = _interopRequireDefault(_SMBGMeanAnimated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGMeanAnimated = exports.SMBGMeanAnimated = function (_PureComponent) {
	  _inherits(SMBGMeanAnimated, _PureComponent);
	
	  function SMBGMeanAnimated(props) {
	    _classCallCheck(this, SMBGMeanAnimated);
	
	    var _this = _possibleConstructorReturn(this, (SMBGMeanAnimated.__proto__ || Object.getPrototypeOf(SMBGMeanAnimated)).call(this, props));
	
	    _this.willEnter = _this.willEnter.bind(_this);
	    _this.willLeave = _this.willLeave.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGMeanAnimated, [{
	    key: 'willEnter',
	    value: function willEnter() {
	      var defaultY = this.props.defaultY;
	
	      return {
	        y: defaultY,
	        height: 0,
	        opacity: 0
	      };
	    }
	  }, {
	    key: 'willLeave',
	    value: function willLeave() {
	      var _props = this.props,
	          defaultY = _props.defaultY,
	          meanHeight = _props.meanHeight;
	
	      var shrinkOut = (0, _reactMotion.spring)(0, _constants.springConfig);
	      return {
	        y: (0, _reactMotion.spring)(defaultY, _constants.springConfig),
	        height: (0, _reactMotion.spring)(meanHeight, _constants.springConfig),
	        opacity: shrinkOut
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx,
	          _cx2,
	          _this2 = this;
	
	      var _props2 = this.props,
	          bgBounds = _props2.bgBounds,
	          datum = _props2.datum,
	          defaultY = _props2.defaultY,
	          meanHeight = _props2.meanHeight,
	          meanWidth = _props2.meanWidth,
	          someSmbgDataIsFocused = _props2.someSmbgDataIsFocused,
	          xScale = _props2.xScale,
	          yScale = _props2.yScale;
	
	
	      var xPos = xScale(datum.msX);
	      var yPositions = {
	        min: yScale(datum.min),
	        mean: yScale(datum.mean),
	        max: yScale(datum.max)
	      };
	
	      var meanClasses = datum.mean ? (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _SMBGMeanAnimated2.default.smbgMean, true), _defineProperty(_cx, _SMBGMeanAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.mean) + 'FadeIn'], !someSmbgDataIsFocused), _defineProperty(_cx, _SMBGMeanAnimated2.default[(0, _bloodglucose.classifyBgValue)(bgBounds, datum.mean) + 'FadeOut'], someSmbgDataIsFocused), _cx)) : (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _SMBGMeanAnimated2.default.smbgMean, true), _defineProperty(_cx2, _SMBGMeanAnimated2.default.transparent, true), _cx2));
	
	      var binLeftX = xScale(datum.msX) - meanWidth / 2 + _SMBGMeanAnimated2.default.stroke / 2;
	      var width = meanWidth - _SMBGMeanAnimated2.default.stroke;
	
	      return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	          defaultStyles: [{
	            key: datum.id,
	            style: {
	              y: defaultY,
	              height: 0,
	              opacity: 0
	            }
	          }],
	          styles: datum.min ? [{
	            key: datum.id,
	            style: {
	              y: (0, _reactMotion.spring)(yPositions.mean - meanHeight / 2, _constants.springConfig),
	              height: (0, _reactMotion.spring)(meanHeight, _constants.springConfig),
	              opacity: (0, _reactMotion.spring)(1.0, _constants.springConfig)
	            }
	          }] : [],
	          willEnter: this.willEnter,
	          willLeave: this.willLeave
	        },
	        function (interpolated) {
	          if (interpolated.length === 0) {
	            return null;
	          }
	          return _react2.default.createElement(_SMBGMean2.default, {
	            classes: meanClasses,
	            datum: datum,
	            interpolated: interpolated[0],
	            positionData: {
	              left: xPos,
	              tooltipLeft: datum.msX > _this2.props.tooltipLeftThreshold,
	              yPositions: yPositions
	            },
	            width: width,
	            x: binLeftX
	          });
	        }
	      );
	    }
	  }]);
	
	  return SMBGMeanAnimated;
	}(_react.PureComponent);
	
	SMBGMeanAnimated.defaultProps = {
	  meanHeight: 10,
	  meanWidth: 108
	};
	SMBGMeanAnimated.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }).isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  defaultY: _react.PropTypes.number.isRequired,
	  meanHeight: _react.PropTypes.number.isRequired,
	  meanWidth: _react.PropTypes.number.isRequired,
	  someSmbgDataIsFocused: _react.PropTypes.bool.isRequired,
	  tooltipLeftThreshold: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = (0, _withDefaultYPosition2.default)(SMBGMeanAnimated);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGMeanAnimated, 'SMBGMeanAnimated', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMeanAnimated.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMeanAnimated.js');
	})();

	;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SMBGMean = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapStateToProps = mapStateToProps;
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(30);
	
	var _redux = __webpack_require__(31);
	
	var _trends = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Tidepool Project
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * == BSD2 LICENSE ==
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SMBGMean = exports.SMBGMean = function (_PureComponent) {
	  _inherits(SMBGMean, _PureComponent);
	
	  function SMBGMean(props) {
	    _classCallCheck(this, SMBGMean);
	
	    var _this = _possibleConstructorReturn(this, (SMBGMean.__proto__ || Object.getPrototypeOf(SMBGMean)).call(this, props));
	
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(SMBGMean, [{
	    key: 'handleMouseOut',
	    value: function handleMouseOut() {
	      var _props = this.props,
	          unfocusRange = _props.unfocusRange,
	          userId = _props.userId;
	
	      unfocusRange(userId);
	    }
	  }, {
	    key: 'handleMouseOver',
	    value: function handleMouseOver() {
	      var _props2 = this.props,
	          datum = _props2.datum,
	          focusRange = _props2.focusRange,
	          positionData = _props2.positionData,
	          userId = _props2.userId;
	
	      focusRange(userId, datum, positionData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          classes = _props3.classes,
	          _props3$interpolated = _props3.interpolated,
	          key = _props3$interpolated.key,
	          style = _props3$interpolated.style,
	          width = _props3.width,
	          x = _props3.x;
	
	
	      return _react2.default.createElement('rect', {
	        className: classes,
	        id: 'smbgRange-' + key,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        x: x,
	        y: style.y,
	        width: width,
	        height: style.height,
	        opacity: style.opacity
	      });
	    }
	  }]);
	
	  return SMBGMean;
	}(_react.PureComponent);
	
	SMBGMean.propTypes = {
	  classes: _react.PropTypes.string.isRequired,
	  datum: _react.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    max: _react.PropTypes.number,
	    mean: _react.PropTypes.number,
	    min: _react.PropTypes.number,
	    msX: _react.PropTypes.number.isRequired,
	    msFrom: _react.PropTypes.number.isRequired,
	    msTo: _react.PropTypes.number.isRequired
	  }),
	  focusRange: _react.PropTypes.func.isRequired,
	  interpolated: _react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    style: _react.PropTypes.shape({
	      height: _react.PropTypes.number.isRequired,
	      opacity: _react.PropTypes.number.isRequired,
	      y: _react.PropTypes.number.isRequired
	    }).isRequired
	  }).isRequired,
	  positionData: _react.PropTypes.shape({
	    left: _react.PropTypes.number.isRequired,
	    tooltipLeft: _react.PropTypes.bool.isRequired,
	    yPositions: _react.PropTypes.shape({
	      max: _react.PropTypes.number.isRequired,
	      mean: _react.PropTypes.number.isRequired,
	      min: _react.PropTypes.number.isRequired
	    }).isRequired
	  }),
	  unfocusRange: _react.PropTypes.func.isRequired,
	  userId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  x: _react.PropTypes.number.isRequired
	};
	function mapStateToProps(state) {
	  var currentPatientInViewId = state.blip.currentPatientInViewId;
	
	  return {
	    userId: currentPatientInViewId
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    focusRange: _trends.focusTrendsSmbgRangeAvg,
	    unfocusRange: _trends.unfocusTrendsSmbgRangeAvg
	  }, dispatch);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SMBGMean);
	
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SMBGMean, 'SMBGMean', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/smbg/SMBGMean.js');
	})();

	;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(152);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGMeanAnimated.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./SMBGMeanAnimated.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(122), undefined);
	
	// module
	exports.push([module.id, ".SMBGMeanAnimated--thickStroke--34Vjn{stroke-width:2}.SMBGMeanAnimated--smbgMean--3F9uQ{stroke:#fff;pointer-events:all}.SMBGMeanAnimated--transparent--1DUTa{fill:transparent}@keyframes SMBGMeanAnimated--fadein--3QUQa{0%{fill-opacity:0}to{fill-opacity:1}}@keyframes SMBGMeanAnimated--fadeout--3R_-Y{0%{fill-opacity:1}to{fill-opacity:0}}.SMBGMeanAnimated--fadeinAnimation--1M4bj{animation:SMBGMeanAnimated--fadein--3QUQa .25s forwards ease-in-out}.SMBGMeanAnimated--fadeoutAnimation--3Y-QY{animation:SMBGMeanAnimated--fadeout--3R_-Y .25s forwards ease-in-out}", ""]);
	
	// exports
	exports.locals = {
		"stroke": "2",
		"thickStroke": "SMBGMeanAnimated--thickStroke--34Vjn",
		"smbgMean": "SMBGMeanAnimated--smbgMean--3F9uQ SMBGMeanAnimated--thickStroke--34Vjn",
		"transparent": "SMBGMeanAnimated--transparent--1DUTa",
		"fadeinAnimation": "SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"fadein": "SMBGMeanAnimated--fadein--3QUQa",
		"fadeoutAnimation": "SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"fadeout": "SMBGMeanAnimated--fadeout--3R_-Y",
		"lowFadeIn": "SMBGMeanAnimated--lowFadeIn--2s5jp " + __webpack_require__(122).locals["bgLow"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"lowFadeOut": "SMBGMeanAnimated--lowFadeOut--zZ69H " + __webpack_require__(122).locals["bgLow"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"targetFadeIn": "SMBGMeanAnimated--targetFadeIn--2p_H9 " + __webpack_require__(122).locals["bgTarget"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"targetFadeOut": "SMBGMeanAnimated--targetFadeOut--36SuY " + __webpack_require__(122).locals["bgTarget"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY",
		"highFadeIn": "SMBGMeanAnimated--highFadeIn--3oq9e " + __webpack_require__(122).locals["bgHigh"] + " SMBGMeanAnimated--fadeinAnimation--1M4bj",
		"highFadeOut": "SMBGMeanAnimated--highFadeOut--15_FM " + __webpack_require__(122).locals["bgHigh"] + " SMBGMeanAnimated--fadeoutAnimation--3Y-QY"
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _NoData = __webpack_require__(154);
	
	var _NoData2 = _interopRequireDefault(_NoData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoData = function NoData(props) {
	  var dataType = props.dataType,
	      displayTypes = props.displayTypes,
	      messageString = props.messageString,
	      position = props.position,
	      unselectedAllData = props.unselectedAllData,
	      unselectedAllDataString = props.unselectedAllDataString;
	
	  var noDataMessage = _lodash2.default.template(unselectedAllData ? unselectedAllDataString : messageString);
	
	  if (!position) {
	    return null;
	  }
	
	  var displayType = '';
	  if (dataType) {
	    displayType = displayTypes[dataType];
	  }
	
	  return _react2.default.createElement(
	    'text',
	    { className: _NoData2.default.noDataMsg, id: 'noDataMsg', x: position.x, y: position.y },
	    noDataMessage({ displayType: displayType })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	NoData.defaultProps = {
	  displayTypes: { cbg: 'CGM', smbg: 'fingerstick' },
	  messageString: 'There is no <%= displayType %> data for this time period :(',
	  unselectedAllDataString: 'Hang on there, skippy! You unselected all of the data!'
	};
	
	NoData.propTypes = {
	  messageString: _react.PropTypes.string.isRequired,
	  dataType: _react2.default.PropTypes.oneOf(['cbg', 'smbg']).isRequired,
	  displayTypes: _react.PropTypes.object.isRequired,
	  position: _react.PropTypes.shape({
	    x: _react.PropTypes.number.isRequired,
	    y: _react.PropTypes.number.isRequired
	  }).isRequired,
	  unselectedAllData: _react.PropTypes.bool.isRequired,
	  unselectedAllDataString: _react.PropTypes.string.isRequired
	};
	
	var _default = NoData;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NoData, 'NoData', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/NoData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/NoData.js');
	})();

	;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(155);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./NoData.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./NoData.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"noDataMsg": "NoData--noDataMsg--1dln7 " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["svgMiddleAnchored"] + ""
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TargetRangeLines = __webpack_require__(157);
	
	var _TargetRangeLines2 = _interopRequireDefault(_TargetRangeLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var TargetRangeLines = function TargetRangeLines(props) {
	  var bgBounds = props.bgBounds,
	      smbgOpts = props.smbgOpts,
	      xScale = props.xScale,
	      yScale = props.yScale;
	
	  var x1 = xScale.range()[0] - smbgOpts.maxR;
	  var x2 = xScale.range()[1] + smbgOpts.maxR;
	  return _react2.default.createElement(
	    'g',
	    { id: 'targetRange' },
	    _react2.default.createElement('line', {
	      id: 'highThreshold',
	      className: _TargetRangeLines2.default.targetRangeLine,
	      x1: x1,
	      x2: x2,
	      y1: yScale(bgBounds.targetUpperBound),
	      y2: yScale(bgBounds.targetUpperBound)
	    }),
	    _react2.default.createElement('line', {
	      id: 'lowThreshold',
	      className: _TargetRangeLines2.default.targetRangeLine,
	      x1: x1,
	      x2: x2,
	      y1: yScale(bgBounds.targetLowerBound),
	      y2: yScale(bgBounds.targetLowerBound)
	    })
	  );
	};
	
	TargetRangeLines.propTypes = {
	  bgBounds: _react.PropTypes.shape({
	    veryHighThreshold: _react.PropTypes.number.isRequired,
	    targetUpperBound: _react.PropTypes.number.isRequired,
	    targetLowerBound: _react.PropTypes.number.isRequired,
	    veryLowThreshold: _react.PropTypes.number.isRequired
	  }),
	  smbgOpts: _react.PropTypes.shape({
	    maxR: _react.PropTypes.number.isRequired,
	    r: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = TargetRangeLines;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TargetRangeLines, 'TargetRangeLines', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TargetRangeLines.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/TargetRangeLines.js');
	})();

	;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(158);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TargetRangeLines.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./TargetRangeLines.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".TargetRangeLines--targetRangeLine--3kXJD{pointer-events:none;stroke:#fff;stroke-dasharray:9,9;stroke-width:2px}", ""]);
	
	// exports
	exports.locals = {
		"targetRangeLine": "TargetRangeLines--targetRangeLine--3kXJD"
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(26);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(20);
	
	var _XAxisLabels = __webpack_require__(160);
	
	var _XAxisLabels2 = _interopRequireDefault(_XAxisLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XAxisLabels = function XAxisLabels(props) {
	  var data = props.data,
	      margins = props.margins,
	      xOffset = props.xOffset,
	      xScale = props.xScale,
	      yOffset = props.yOffset;
	
	  var yPos = margins.top - yOffset;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'xAxisLabels' },
	    _lodash2.default.map(data, function (msInDay) {
	      var displayTime = (0, _datetime.formatClocktimeFromMsPer24)(msInDay, 'h a');
	      return _react2.default.createElement(
	        'text',
	        {
	          className: _XAxisLabels2.default.text,
	          key: msInDay,
	          x: xScale(msInDay) + xOffset,
	          y: yPos
	        },
	        displayTime
	      );
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	XAxisLabels.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(0, 8), function (i) {
	    return i * _datetime.THREE_HRS;
	  }),
	  xOffset: 5,
	  yOffset: 5
	};
	
	XAxisLabels.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  xOffset: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired,
	  yOffset: _react.PropTypes.number.isRequired
	};
	
	var _default = XAxisLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(XAxisLabels, 'XAxisLabels', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/XAxisLabels.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/XAxisLabels.js');
	})();

	;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(161);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisLabels.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisLabels.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports
	exports.locals = {
		"text": "XAxisLabels--text--3kSBO " + __webpack_require__(8).locals["axisSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["svgStartAnchored"] + "",
		"focusedRange": "XAxisLabels--focusedRange--181Td " + __webpack_require__(8).locals["axisSize"] + " " + __webpack_require__(8).locals["boldText"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["svgStartAnchored"] + ""
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _d3Array = __webpack_require__(26);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _datetime = __webpack_require__(20);
	
	var datetime = _interopRequireWildcard(_datetime);
	
	var _XAxisTicks = __webpack_require__(163);
	
	var _XAxisTicks2 = _interopRequireDefault(_XAxisTicks);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var XAxisTicks = function XAxisTicks(props) {
	  var data = props.data,
	      margins = props.margins,
	      tickLength = props.tickLength,
	      xScale = props.xScale;
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'xAxisTicks' },
	    _lodash2.default.map(data, function (msInDay) {
	      return _react2.default.createElement('line', {
	        className: _XAxisTicks2.default.tick,
	        key: msInDay,
	        x1: xScale(msInDay),
	        x2: xScale(msInDay),
	        y1: margins.top,
	        y2: margins.top - tickLength
	      });
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	XAxisTicks.defaultProps = {
	  data: _lodash2.default.map((0, _d3Array.range)(0, 9), function (i) {
	    return i * datetime.THREE_HRS;
	  }),
	  tickLength: 15
	};
	
	XAxisTicks.propTypes = {
	  data: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired,
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  tickLength: _react.PropTypes.number.isRequired,
	  xScale: _react.PropTypes.func.isRequired
	};
	
	var _default = XAxisTicks;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(XAxisTicks, 'XAxisTicks', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/XAxisTicks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/XAxisTicks.js');
	})();

	;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(164);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisTicks.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./XAxisTicks.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".XAxisTicks--tick--OEdi5{stroke:var(--axis-tick)}", ""]);
	
	// exports
	exports.locals = {
		"tick": "XAxisTicks--tick--OEdi5"
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(16);
	
	var _format = __webpack_require__(17);
	
	var _YAxisLabelsAndTicks = __webpack_require__(166);
	
	var _YAxisLabelsAndTicks2 = _interopRequireDefault(_YAxisLabelsAndTicks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YAxisLabels = function YAxisLabels(props) {
	  var bgPrefs = props.bgPrefs,
	      margins = props.margins,
	      textToTickGap = props.textToTickGap,
	      tickWidth = props.tickWidth,
	      yScale = props.yScale;
	  var bgBounds = bgPrefs.bgBounds;
	
	
	  return _react2.default.createElement(
	    'g',
	    { id: 'yAxisLabels' },
	    _lodash2.default.map(['targetLowerBound', 'targetUpperBound', 'veryHighThreshold', 'veryLowThreshold'], function (boundKey) {
	      return _react2.default.createElement(
	        'g',
	        { id: 'yAxisLabel', key: boundKey },
	        _react2.default.createElement(
	          'text',
	          {
	            className: _YAxisLabelsAndTicks2.default.text,
	            x: margins.left - tickWidth - textToTickGap,
	            y: yScale(bgBounds[boundKey])
	          },
	          (0, _format.formatBgValue)(bgBounds[boundKey], bgPrefs)
	        ),
	        _react2.default.createElement('line', {
	          className: _YAxisLabelsAndTicks2.default.tick,
	          x1: margins.left - tickWidth,
	          x2: margins.left,
	          y1: yScale(bgBounds[boundKey]),
	          y2: yScale(bgBounds[boundKey])
	        })
	      );
	    })
	  );
	}; /*
	    * == BSD2 LICENSE ==
	    * Copyright (c) 2016, Tidepool Project
	    *
	    * This program is free software; you can redistribute it and/or modify it under
	    * the terms of the associated License, which is identical to the BSD 2-Clause
	    * License as published by the Open Source Initiative at opensource.org.
	    *
	    * This program is distributed in the hope that it will be useful, but WITHOUT
	    * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	    * FOR A PARTICULAR PURPOSE. See the License for more details.
	    *
	    * You should have received a copy of the License along with this program; if
	    * not, you can obtain one from Tidepool Project at tidepool.org.
	    * == BSD2 LICENSE ==
	    */
	
	YAxisLabels.defaultProps = {
	  textToTickGap: 2,
	  tickWidth: 8
	};
	
	YAxisLabels.propTypes = {
	  bgPrefs: _react.PropTypes.shape({
	    bgBounds: _react.PropTypes.shape({
	      veryHighThreshold: _react.PropTypes.number.isRequired,
	      targetUpperBound: _react.PropTypes.number.isRequired,
	      targetLowerBound: _react.PropTypes.number.isRequired,
	      veryLowThreshold: _react.PropTypes.number.isRequired
	    }),
	    bgUnits: _react.PropTypes.oneOf([_constants.MGDL_UNITS, _constants.MMOLL_UNITS]).isRequired
	  }),
	  margins: _react.PropTypes.shape({
	    top: _react.PropTypes.number.isRequired,
	    right: _react.PropTypes.number.isRequired,
	    bottom: _react.PropTypes.number.isRequired,
	    left: _react.PropTypes.number.isRequired
	  }).isRequired,
	  textToTickGap: _react.PropTypes.number.isRequired,
	  tickWidth: _react.PropTypes.number.isRequired,
	  yScale: _react.PropTypes.func.isRequired
	};
	
	var _default = YAxisLabels;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(YAxisLabels, 'YAxisLabels', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/YAxisLabelsAndTicks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/components/trends/common/YAxisLabelsAndTicks.js');
	})();

	;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(167);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./YAxisLabelsAndTicks.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!./YAxisLabelsAndTicks.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	exports.i(__webpack_require__(8), undefined);
	
	// module
	exports.push([module.id, ".YAxisLabelsAndTicks--tick--2lY4A{stroke:var(--axis-tick)}", ""]);
	
	// exports
	exports.locals = {
		"text": "YAxisLabelsAndTicks--text--1KdFh " + __webpack_require__(8).locals["axisSize"] + " " + __webpack_require__(8).locals["mediumContrastText"] + " " + __webpack_require__(8).locals["svgRightAnchored"] + " " + __webpack_require__(8).locals["svgVerticalCentered"] + "",
		"tick": "YAxisLabelsAndTicks--tick--2lY4A"
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(31);
	
	var _trendsStateByUser = __webpack_require__(169);
	
	var _trendsStateByUser2 = _interopRequireDefault(_trendsStateByUser);
	
	var _settingsStateByUser = __webpack_require__(171);
	
	var _settingsStateByUser2 = _interopRequireDefault(_settingsStateByUser);
	
	var _pdf = __webpack_require__(172);
	
	var _pdf2 = _interopRequireDefault(_pdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2016, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var _default = (0, _redux.combineReducers)({ settings: _settingsStateByUser2.default, trends: _trendsStateByUser2.default, pdf: _pdf2.default });
	
	exports.default = _default;
	;

	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/index.js');
	})();

	;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CBG_FLAGS, _initialState;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactAddonsUpdate = __webpack_require__(170);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var CBG_FLAGS = 'cbgFlags';
	var CBG_100_ENABLED = 'cbg100Enabled';
	var CBG_80_ENABLED = 'cbg80Enabled';
	var CBG_50_ENABLED = 'cbg50Enabled';
	var CBG_MEDIAN_ENABLED = 'cbgMedianEnabled';
	var FOCUSED_CBG_DATE_TRACE = 'focusedCbgDateTrace';
	var FOCUSED_CBG_SLICE = 'focusedCbgSlice';
	var FOCUSED_CBG_KEYS = 'focusedCbgSliceKeys';
	var FOCUSED_SMBG = 'focusedSmbg';
	var FOCUSED_SMBG_RANGE_AVG = 'focusedSmbgRangeAvg';
	var SHOW_CBG_DATE_TRACES = 'showingCbgDateTraces';
	var TOUCHED = 'touched';
	
	var CBG_FLAG_MAP = {
	  100: CBG_100_ENABLED,
	  80: CBG_80_ENABLED,
	  50: CBG_50_ENABLED,
	  median: CBG_MEDIAN_ENABLED
	};
	
	var initialState = (_initialState = {}, _defineProperty(_initialState, CBG_FLAGS, (_CBG_FLAGS = {}, _defineProperty(_CBG_FLAGS, CBG_100_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_80_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_50_ENABLED, true), _defineProperty(_CBG_FLAGS, CBG_MEDIAN_ENABLED, true), _CBG_FLAGS)), _defineProperty(_initialState, FOCUSED_CBG_DATE_TRACE, null), _defineProperty(_initialState, FOCUSED_CBG_SLICE, null), _defineProperty(_initialState, FOCUSED_CBG_KEYS, null), _defineProperty(_initialState, FOCUSED_SMBG, null), _defineProperty(_initialState, FOCUSED_SMBG_RANGE_AVG, null), _defineProperty(_initialState, SHOW_CBG_DATE_TRACES, false), _defineProperty(_initialState, TOUCHED, false), _initialState);
	
	var trendsStateByUser = function trendsStateByUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.FETCH_PATIENT_DATA_SUCCESS:
	      {
	        var userId = action.payload.patientId;
	
	        if (state[userId]) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, userId, { $set: _lodash2.default.assign({}, initialState) }));
	      }
	    case actionTypes.FOCUS_TRENDS_CBG_DATE_TRACE:
	      {
	        var _action$payload = action.payload,
	            _userId = _action$payload.userId,
	            data = _action$payload.cbgDatum,
	            position = _action$payload.cbgPosition;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId, _defineProperty({}, FOCUSED_CBG_DATE_TRACE, { $set: { data: data, position: position } })));
	      }
	    case actionTypes.FOCUS_TRENDS_CBG_SLICE:
	      {
	        var _userId4;
	
	        var _action$payload2 = action.payload,
	            focusedKeys = _action$payload2.focusedKeys,
	            _data = _action$payload2.sliceData,
	            _position = _action$payload2.slicePosition,
	            _userId3 = _action$payload2.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId3, (_userId4 = {}, _defineProperty(_userId4, FOCUSED_CBG_SLICE, { $set: { data: _data, position: _position } }), _defineProperty(_userId4, FOCUSED_CBG_KEYS, { $set: focusedKeys }), _userId4)));
	      }
	    case actionTypes.FOCUS_TRENDS_SMBG:
	      {
	        var _action$payload3 = action.payload,
	            datum = _action$payload3.smbgDatum,
	            _position2 = _action$payload3.smbgPosition,
	            _userId5 = _action$payload3.userId,
	            allSmbgsOnDate = _action$payload3.allSmbgsOnDate,
	            allPositions = _action$payload3.allPositions,
	            date = _action$payload3.date;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId5, _defineProperty({}, FOCUSED_SMBG, { $set: { datum: datum, position: _position2, allSmbgsOnDate: allSmbgsOnDate, allPositions: allPositions, date: date } })));
	      }
	    case actionTypes.FOCUS_TRENDS_SMBG_RANGE_AVG:
	      {
	        var _action$payload4 = action.payload,
	            _data2 = _action$payload4.rangeAvgData,
	            _position3 = _action$payload4.rangeAvgPosition,
	            _userId7 = _action$payload4.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId7, _defineProperty({}, FOCUSED_SMBG_RANGE_AVG, { $set: { data: _data2, position: _position3 } })));
	      }
	    case actionTypes.LOGOUT_REQUEST:
	      return {};
	    case actionTypes.MARK_TRENDS_VIEWED:
	      {
	        var _userId9 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId9, _defineProperty({}, TOUCHED, { $set: true })));
	      }
	    case actionTypes.SHOW_CBG_DATE_TRACES:
	      {
	        var _userId11 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId11, _defineProperty({}, SHOW_CBG_DATE_TRACES, { $set: true })));
	      }
	    case actionTypes.TURN_OFF_CBG_RANGE:
	      {
	        var _action$payload5 = action.payload,
	            _userId13 = _action$payload5.userId,
	            range = _action$payload5.range;
	
	        var key = _lodash2.default.get(CBG_FLAG_MAP, range);
	        if (!key) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId13, _defineProperty({}, CBG_FLAGS, _defineProperty({}, key, { $set: false }))));
	      }
	    case actionTypes.TURN_ON_CBG_RANGE:
	      {
	        var _action$payload6 = action.payload,
	            _userId15 = _action$payload6.userId,
	            _range = _action$payload6.range;
	
	        var _key = _lodash2.default.get(CBG_FLAG_MAP, _range);
	        if (!_key) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId15, _defineProperty({}, CBG_FLAGS, _defineProperty({}, _key, { $set: true }))));
	      }
	    case actionTypes.UNFOCUS_TRENDS_CBG_DATE_TRACE:
	      {
	        var _userId17 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId17, _defineProperty({}, FOCUSED_CBG_DATE_TRACE, { $set: null })));
	      }
	    case actionTypes.UNFOCUS_TRENDS_CBG_SLICE:
	      {
	        var _userId20;
	
	        var _userId19 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId19, (_userId20 = {}, _defineProperty(_userId20, FOCUSED_CBG_DATE_TRACE, { $set: null }), _defineProperty(_userId20, FOCUSED_CBG_SLICE, { $set: null }), _defineProperty(_userId20, FOCUSED_CBG_KEYS, { $set: null }), _defineProperty(_userId20, SHOW_CBG_DATE_TRACES, { $set: false }), _userId20)));
	      }
	    case actionTypes.UNFOCUS_TRENDS_SMBG:
	      {
	        var _userId21 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId21, _defineProperty({}, FOCUSED_SMBG, { $set: null })));
	      }
	    case actionTypes.UNFOCUS_TRENDS_SMBG_RANGE_AVG:
	      {
	        var _userId23 = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId23, _defineProperty({}, FOCUSED_SMBG_RANGE_AVG, { $set: null })));
	      }
	    default:
	      return state;
	  }
	};
	
	var _default = trendsStateByUser;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CBG_FLAGS, 'CBG_FLAGS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_100_ENABLED, 'CBG_100_ENABLED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_80_ENABLED, 'CBG_80_ENABLED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_50_ENABLED, 'CBG_50_ENABLED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_MEDIAN_ENABLED, 'CBG_MEDIAN_ENABLED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_DATE_TRACE, 'FOCUSED_CBG_DATE_TRACE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_SLICE, 'FOCUSED_CBG_SLICE', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_CBG_KEYS, 'FOCUSED_CBG_KEYS', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_SMBG, 'FOCUSED_SMBG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(FOCUSED_SMBG_RANGE_AVG, 'FOCUSED_SMBG_RANGE_AVG', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_CBG_DATE_TRACES, 'SHOW_CBG_DATE_TRACES', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(TOUCHED, 'TOUCHED', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(CBG_FLAG_MAP, 'CBG_FLAG_MAP', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(trendsStateByUser, 'trendsStateByUser', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/trendsStateByUser.js');
	})();

	;

/***/ },
/* 170 */
/***/ function(module, exports) {

	module.exports = require("react-addons-update");

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddonsUpdate = __webpack_require__(170);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   * Copyright (c) 2016, Tidepool Project
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is free software; you can redistribute it and/or modify it under
	                                                                                                                                                                                                                   * the terms of the associated License, which is identical to the BSD 2-Clause
	                                                                                                                                                                                                                   * License as published by the Open Source Initiative at opensource.org.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * This program is distributed in the hope that it will be useful, but WITHOUT
	                                                                                                                                                                                                                   * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	                                                                                                                                                                                                                   * FOR A PARTICULAR PURPOSE. See the License for more details.
	                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                   * You should have received a copy of the License along with this program; if
	                                                                                                                                                                                                                   * not, you can obtain one from Tidepool Project at tidepool.org.
	                                                                                                                                                                                                                   * == BSD2 LICENSE ==
	                                                                                                                                                                                                                   */
	
	var settingsStateByUser = function settingsStateByUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.FETCH_PATIENT_DATA_SUCCESS:
	      {
	        var userId = action.payload.patientId;
	
	        if (state[userId]) {
	          return state;
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, userId, { $set: {} }));
	      }
	    case actionTypes.LOGOUT_REQUEST:
	      return {};
	    case actionTypes.MARK_SETTINGS_VIEWED:
	      {
	        var _userId = action.payload.userId;
	
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId, { touched: { $set: true } }));
	      }
	    case actionTypes.TOGGLE_SETTINGS_SECTION:
	      {
	        var _action$payload = action.payload,
	            deviceKey = _action$payload.deviceKey,
	            _userId2 = _action$payload.userId,
	            scheduleOrProfileKey = _action$payload.scheduleOrProfileKey;
	
	        if (!state[_userId2][deviceKey]) {
	          return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId2, { $merge: _defineProperty({}, deviceKey, _defineProperty({}, scheduleOrProfileKey, true)) }));
	        }
	        return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, _userId2, _defineProperty({}, deviceKey, _defineProperty({}, scheduleOrProfileKey, {
	          $apply: function $apply(val) {
	            return !val;
	          }
	        }))));
	      }
	    default:
	      return state;
	  }
	};
	
	var _default = settingsStateByUser;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(settingsStateByUser, 'settingsStateByUser', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/settingsStateByUser.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/settingsStateByUser.js');
	})();

	;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddonsUpdate = __webpack_require__(170);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _actionTypes = __webpack_require__(35);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	var pdf = function pdf() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actionTypes.GENERATE_PDF_SUCCESS:
	      return (0, _reactAddonsUpdate2.default)(state, { $merge: action.payload.pdf });
	
	    case actionTypes.REMOVE_GENERATED_PDFS:
	      return (0, _reactAddonsUpdate2.default)(state, { $set: {} });
	
	    default:
	      return state;
	  }
	};
	
	var _default = pdf;
	exports.default = _default;
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(pdf, 'pdf', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/pdf.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/clintbeacock/Sites/tidepool/viz/src/redux/reducers/pdf.js');
	})();

	;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return __webpack_require__(174)("!function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p=\"\",t(0)}([function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}var a=n(1),i=r(a),o=new i[\"default\"];onmessage=function(e){o.handleMessage(e,postMessage)},function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&__REACT_HOT_LOADER__.register(o,\"worker\",\"/Users/clintbeacock/Sites/tidepool/viz/src/worker/index.js\")}()},function(e,t,n){\"use strict\";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t[\"default\"]=e,t}function a(e){return e&&e.__esModule?e:{\"default\":e}}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),u=a(s),d=n(5),l=r(d),M=n(6),_=r(M),f=n(7),p=a(f),h=function(){function e(t,n){o(this,e),this.log=(0,u[\"default\"])(\"PDFWorker\"),this.log(\"PDFWorker constructed!\"),this.importer=t,this.renderer=n}return c(e,[{key:\"handleMessage\",value:function(e,t){var n=e.data;switch(n.type){case _.GENERATE_PDF_REQUEST:var r=n.payload,a=r.type,o=r.mostRecent,c=r.groupedData,s=r.opts,u=n.meta.origin,d=\"undefined\"!=typeof this.importer?this.importer:importScripts,M=\"undefined\"!=typeof this.renderer?this.renderer:p[\"default\"];d(u+\"/pdfkit.js\",u+\"/blob-stream.js\"),M(o,c,s).then(function(e){return t(l.generatePDFSuccess(i({},a,e)))})[\"catch\"](function(e){return t(l.generatePDFFailure(e))});break;default:throw new Error(\"Unhandled action type [\"+n.type+\"] passed to Web Worker!\")}}}]),e}(),m=h;t[\"default\"]=m,function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(h,\"PDFWorker\",\"/Users/clintbeacock/Sites/tidepool/viz/src/worker/PDFWorker.js\"),__REACT_HOT_LOADER__.register(m,\"default\",\"/Users/clintbeacock/Sites/tidepool/viz/src/worker/PDFWorker.js\"))}()},function(e,t,n){(function(t){(function(){function r(){if(\"undefined\"==typeof window||\"undefined\"==typeof navigator)return!1;var e,n=!!window.chrome,r=/firefox/i.test(navigator.userAgent),a=t&&t.versions&&t.versions.electron;if(r){var i=navigator.userAgent.match(/Firefox\\/(\\d+\\.\\d+)/);i&&i[1]&&Number(i[1])&&(e=Number(i[1]))}return n||e>=31||a}var a=function(){var e=.618033988749895;return l+=e,l%=1,360*l},i=\"undefined\"==typeof window,o=!i&&window.localStorage,c=o.andlogKey||\"debug\",s=o[c],u=n(4),d=Function.prototype.bind,l=0,M=15,_=function(){},f=o.debugColors?\"false\"!==o.debugColors:r(),p=null,h=null,m=!1,b={};s&&\"!\"===s[0]&&\"/\"===s[1]&&(m=!0,s=s.slice(1)),h=s&&\"/\"===s[0]&&new RegExp(s.substring(1,s.length-1));for(var L=[\"log\",\"debug\",\"warn\",\"error\",\"info\"],A=0,y=L.length;A<y;A++)_[L[A]]=_;p=function(e){var t,n,r;if(t=e.slice(0,M),t+=Array(M+3-t.length).join(\" \")+\"|\",h){var i=e.match(h);if(!m&&!i||m&&i)return _}if(!d)return _;var o=[u];if(f){b[e]||(b[e]=a());var c=b[e];t=\"%c\"+t,n=\"color: hsl(\"+c+\",99%,40%); font-weight: bold\",o.push(t,n)}else o.push(t);if(arguments.length>1){var s=Array.prototype.slice.call(arguments,1);o=o.concat(s)}return r=d.apply(u.log,o),L.forEach(function(e){r[e]=d.apply(u[e]||r,o)}),r},p.config=function(e){e.padLength&&(M=e.padLength)},e.exports=p}).call()}).call(t,n(3))},function(e,t){function n(){throw new Error(\"setTimeout has not been defined\")}function r(){throw new Error(\"clearTimeout has not been defined\")}function a(e){if(d===setTimeout)return setTimeout(e,0);if((d===n||!d)&&setTimeout)return d=setTimeout,setTimeout(e,0);try{return d(e,0)}catch(t){try{return d.call(null,e,0)}catch(t){return d.call(this,e,0)}}}function i(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function o(){p&&_&&(p=!1,_.length?f=_.concat(f):h=-1,f.length&&c())}function c(){if(!p){var e=a(o);p=!0;for(var t=f.length;t;){for(_=f,f=[];++h<t;)_&&_[h].run();h=-1,t=f.length}_=null,p=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var d,l,M=e.exports={};!function(){try{d=\"function\"==typeof setTimeout?setTimeout:n}catch(e){d=n}try{l=\"function\"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var _,f=[],p=!1,h=-1;M.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];f.push(new s(e,t)),1!==f.length||p||a(c)},s.prototype.run=function(){this.fun.apply(null,this.array)},M.title=\"browser\",M.browser=!0,M.env={},M.argv=[],M.version=\"\",M.versions={},M.on=u,M.addListener=u,M.once=u,M.off=u,M.removeListener=u,M.removeAllListeners=u,M.emit=u,M.prependListener=u,M.prependOnceListener=u,M.listeners=function(e){return[]},M.binding=function(e){throw new Error(\"process.binding is not supported\")},M.cwd=function(){return\"/\"},M.chdir=function(e){throw new Error(\"process.chdir is not supported\")},M.umask=function(){return 0}},function(e,t,n){!function(){var t=\"undefined\"==typeof window,n=!t&&window.localStorage,r={};if(t)return void(e.exports=console);var a=n.andlogKey||\"debug\";if(n&&n[a]&&window.console)r=window.console;else for(var i=\"assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn\".split(\",\"),o=i.length,c=function(){};o--;)r[i[o]]=c;e.exports=r}()},function(e,t,n){\"use strict\";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t[\"default\"]=e,t}function a(e,t,n,r){return{type:u.GENERATE_PDF_REQUEST,meta:{WebWorker:!0,origin:document.location.origin},payload:{type:e,mostRecent:t,groupedData:n,opts:r}}}function i(e){return{type:u.GENERATE_PDF_SUCCESS,payload:{pdf:e}}}function o(e){return{type:u.GENERATE_PDF_FAILURE,error:e}}function c(){return{type:u.REMOVE_GENERATED_PDFS}}Object.defineProperty(t,\"__esModule\",{value:!0}),t.generatePDFRequest=a,t.generatePDFSuccess=i,t.generatePDFFailure=o,t.removeGeneratedPDFS=c;var s=n(6),u=r(s);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"generatePDFRequest\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js\"),__REACT_HOT_LOADER__.register(i,\"generatePDFSuccess\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js\"),__REACT_HOT_LOADER__.register(o,\"generatePDFFailure\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js\"),__REACT_HOT_LOADER__.register(c,\"removeGeneratedPDFS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/actions/worker.js\"))}()},function(e,t){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0});var n=t.FOCUS_TRENDS_CBG_DATE_TRACE=\"FOCUS_TRENDS_CBG_DATE_TRACE\",r=t.FOCUS_TRENDS_CBG_SLICE=\"FOCUS_TRENDS_CBG_SLICE\",a=t.FOCUS_TRENDS_SMBG=\"FOCUS_TRENDS_SMBG\",i=t.FOCUS_TRENDS_SMBG_RANGE_AVG=\"FOCUS_TRENDS_SMBG_RANGE_AVG\",o=t.MARK_SETTINGS_VIEWED=\"MARK_SETTINGS_VIEWED\",c=t.MARK_TRENDS_VIEWED=\"MARK_TRENDS_VIEWED\",s=t.SHOW_CBG_DATE_TRACES=\"SHOW_CBG_DATE_TRACES\",u=t.TOGGLE_SETTINGS_SECTION=\"TOGGLE_SETTINGS_SECTION\",d=t.TURN_OFF_CBG_RANGE=\"TURN_OFF_CBG_RANGE\",l=t.TURN_ON_CBG_RANGE=\"TURN_ON_CBG_RANGE\",M=t.UNFOCUS_TRENDS_CBG_DATE_TRACE=\"UNFOCUS_TRENDS_CBG_DATE_TRACE\",_=t.UNFOCUS_TRENDS_CBG_SLICE=\"UNFOCUS_TRENDS_CBG_SLICE\",f=t.UNFOCUS_TRENDS_SMBG=\"UNFOCUS_TRENDS_SMBG\",p=t.UNFOCUS_TRENDS_SMBG_RANGE_AVG=\"UNFOCUS_TRENDS_SMBG_RANGE_AVG\",h=t.FETCH_PATIENT_DATA_SUCCESS=\"FETCH_PATIENT_DATA_SUCCESS\",m=t.LOGOUT_REQUEST=\"LOGOUT_REQUEST\",b=t.GENERATE_PDF_REQUEST=\"GENERATE_PDF_REQUEST\",L=t.GENERATE_PDF_SUCCESS=\"GENERATE_PDF_SUCCESS\",A=t.GENERATE_PDF_FAILURE=\"GENERATE_PDF_FAILURE\",y=t.REMOVE_GENERATED_PDFS=\"REMOVE_GENERATED_PDFS\";!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(n,\"FOCUS_TRENDS_CBG_DATE_TRACE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(r,\"FOCUS_TRENDS_CBG_SLICE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(a,\"FOCUS_TRENDS_SMBG\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(i,\"FOCUS_TRENDS_SMBG_RANGE_AVG\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(o,\"MARK_SETTINGS_VIEWED\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(c,\"MARK_TRENDS_VIEWED\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(s,\"SHOW_CBG_DATE_TRACES\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(u,\"TOGGLE_SETTINGS_SECTION\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(d,\"TURN_OFF_CBG_RANGE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(l,\"TURN_ON_CBG_RANGE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(M,\"UNFOCUS_TRENDS_CBG_DATE_TRACE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(_,\"UNFOCUS_TRENDS_CBG_SLICE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(f,\"UNFOCUS_TRENDS_SMBG\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(p,\"UNFOCUS_TRENDS_SMBG_RANGE_AVG\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(h,\"FETCH_PATIENT_DATA_SUCCESS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(m,\"LOGOUT_REQUEST\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(b,\"GENERATE_PDF_REQUEST\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(L,\"GENERATE_PDF_SUCCESS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(A,\"GENERATE_PDF_FAILURE\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"),__REACT_HOT_LOADER__.register(y,\"REMOVE_GENERATED_PDFS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/redux/constants/actionTypes.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}function i(e,t,n,r,a,i){var o=3;return new _.DailyPrintView(e,t,{bgPrefs:n,chartsPerPage:o,debug:!1,defaultFontSize:8,dpi:f,footerFontSize:8,headerFontSize:14,height:11*f-2*p,margins:{left:p,top:p,right:p,bottom:p},numDays:a,patient:i,summaryHeaderFontSize:10,summaryWidthAsPercentage:.18,timePrefs:r,width:8.5*f-2*p})}function o(e,t,n){var r=n.bgPrefs,a=n.numDays,o=n.patient,c=n.timePrefs;return new s[\"default\"](function(n,s){var u=_.reshapeBgClassesToBgBounds(r),d=_.selectDailyViewData(e,t,a,c),l=\"undefined\"!=typeof PDFDocument?PDFDocument:_.PDFDocument,M=\"undefined\"!=typeof blobStream?blobStream:_.blobStream,f=new l({autoFirstPage:!1,bufferPages:!0,margin:p}),h=f.pipe(M()),m=i(f,d,{bgBounds:u,bgUnits:r.bgUnits},c,a,o);m.render(),f.end(),h.on(\"finish\",function(){var e={blob:h.toBlob(),url:h.toBlobURL(\"application/pdf\")};return n(e)}),h.on(\"error\",function(e){return h.end(),s(e)})})}Object.defineProperty(t,\"__esModule\",{value:!0}),t.utils=void 0,t.createDailyPrintView=i,t.createPrintPDFPackage=o;var c=n(8),s=r(c),u=n(45),d=r(u),l=n(180),M=n(186),_=t.utils={reshapeBgClassesToBgBounds:l.reshapeBgClassesToBgBounds,selectDailyViewData:M.selectDailyViewData,PDFDocument:function m(){a(this,m)},blobStream:function(){},DailyPrintView:d[\"default\"]},f=72,p=f/2,h=o;t[\"default\"]=h,function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(_,\"utils\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"),__REACT_HOT_LOADER__.register(f,\"DPI\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"),__REACT_HOT_LOADER__.register(p,\"MARGIN\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"),__REACT_HOT_LOADER__.register(i,\"createDailyPrintView\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"),__REACT_HOT_LOADER__.register(o,\"createPrintPDFPackage\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"),__REACT_HOT_LOADER__.register(h,\"default\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/index.js\"))}()},function(e,t,n){\"use strict\";function r(){try{Promise===i&&(Promise=a)}catch(e){}return i}var a;\"undefined\"!=typeof Promise&&(a=Promise);var i=n(9)();i.noConflict=r,e.exports=i},function(e,t,n){(function(t){\"use strict\";e.exports=function(){function r(){}function a(e,t){if(null==e||e.constructor!==i)throw new L(\"the promise constructor cannot be invoked directly\\n\\n    See http://goo.gl/MqrFmX\\n\");if(\"function\"!=typeof t)throw new L(\"expecting a function but got \"+f.classString(t))}function i(e){e!==y&&a(this,e),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(e),this._promiseCreated(),this._fireEvent(\"promiseCreated\",this)}function o(e){this.promise._resolveCallback(e)}function c(e){this.promise._rejectCallback(e,!1)}function s(e){var t=new i(y);t._fulfillmentHandler0=e,t._rejectionHandler0=e,t._promise0=e,t._receiver0=e}var u,d=function(){return new L(\"circular promise resolution chain\\n\\n    See http://goo.gl/MqrFmX\\n\")},l=function(){return new i.PromiseInspection(this._target())},M=function(e){return i.reject(new L(e))},_={},f=n(10);u=f.isNode?function(){var e=t.domain;return void 0===e&&(e=null),e}:function(){return null},f.notEnumerableProp(i,\"_getDomain\",u);var p=n(11),h=n(12),m=new h;p.defineProperty(i,\"_async\",{value:m});var b=n(16),L=i.TypeError=b.TypeError;i.RangeError=b.RangeError;var A=i.CancellationError=b.CancellationError;i.TimeoutError=b.TimeoutError,i.OperationalError=b.OperationalError,i.RejectionError=b.OperationalError,i.AggregateError=b.AggregateError;var y=function(){},z={},T={},g=n(17)(i,y),v=n(18)(i,y,g,M,r),O=n(19)(i),D=O.create,k=n(20)(i,O),Y=(k.CapturedTrace,n(21)(i,g,T)),S=n(22)(T),N=n(23),w=f.errorObj,W=f.tryCatch;return i.prototype.toString=function(){return\"[object Promise]\"},i.prototype.caught=i.prototype[\"catch\"]=function(e){var t=arguments.length;if(t>1){var n,r=new Array(t-1),a=0;for(n=0;n<t-1;++n){var i=arguments[n];if(!f.isObject(i))return M(\"Catch statement predicate: expecting an object but got \"+f.classString(i));r[a++]=i}return r.length=a,e=arguments[n],this.then(void 0,S(r,e,this))}return this.then(void 0,e)},i.prototype.reflect=function(){return this._then(l,l,void 0,this,void 0)},i.prototype.then=function(e,t){if(k.warnings()&&arguments.length>0&&\"function\"!=typeof e&&\"function\"!=typeof t){var n=\".then() only accepts functions but was passed: \"+f.classString(e);arguments.length>1&&(n+=\", \"+f.classString(t)),this._warn(n)}return this._then(e,t,void 0,void 0,void 0)},i.prototype.done=function(e,t){var n=this._then(e,t,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(e){return\"function\"!=typeof e?M(\"expecting a function but got \"+f.classString(e)):this.all()._then(e,void 0,void 0,z,void 0)},i.prototype.toJSON=function(){var e={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(e.fulfillmentValue=this.value(),e.isFulfilled=!0):this.isRejected()&&(e.rejectionReason=this.reason(),e.isRejected=!0),e},i.prototype.all=function(){return arguments.length>0&&this._warn(\".all() was passed arguments but it does not take any\"),new v(this).promise()},i.prototype.error=function(e){return this.caught(f.originatesFromRejection,e)},i.getNewLibraryCopy=e.exports,i.is=function(e){return e instanceof i},i.fromNode=i.fromCallback=function(e){var t=new i(y);t._captureStackTrace();var n=arguments.length>1&&!!Object(arguments[1]).multiArgs,r=W(e)(N(t,n));return r===w&&t._rejectCallback(r.e,!0),t._isFateSealed()||t._setAsyncGuaranteed(),t},i.all=function(e){return new v(e).promise()},i.cast=function(e){var t=g(e);return t instanceof i||(t=new i(y),t._captureStackTrace(),t._setFulfilled(),t._rejectionHandler0=e),t},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(e){var t=new i(y);return t._captureStackTrace(),t._rejectCallback(e,!0),t},i.setScheduler=function(e){if(\"function\"!=typeof e)throw new L(\"expecting a function but got \"+f.classString(e));return m.setScheduler(e)},i.prototype._then=function(e,t,n,r,a){var o=void 0!==a,c=o?a:new i(y),s=this._target(),d=s._bitField;o||(c._propagateFrom(this,3),c._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&d)?this._boundValue():s===this?void 0:this._boundTo),this._fireEvent(\"promiseChained\",this,c));var l=u();if(0!==(50397184&d)){var M,_,p=s._settlePromiseCtx;0!==(33554432&d)?(_=s._rejectionHandler0,M=e):0!==(16777216&d)?(_=s._fulfillmentHandler0,M=t,s._unsetRejectionIsUnhandled()):(p=s._settlePromiseLateCancellationObserver,_=new A(\"late cancellation observer\"),s._attachExtraTrace(_),M=t),m.invoke(p,s,{handler:null===l?M:\"function\"==typeof M&&f.domainBind(l,M),promise:c,receiver:r,value:_})}else s._addCallbacks(e,t,c,r,l);return c},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(e){this._bitField=this._bitField&-65536|65535&e},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent(\"promiseFulfilled\",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent(\"promiseRejected\",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent(\"promiseResolved\",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=this._bitField&-65537},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent(\"promiseCancelled\",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){m.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(e){var t=0===e?this._receiver0:this[4*e-4+3];if(t!==_)return void 0===t&&this._isBound()?this._boundValue():t},i.prototype._promiseAt=function(e){return this[4*e-4+2]},i.prototype._fulfillmentHandlerAt=function(e){return this[4*e-4+0]},i.prototype._rejectionHandlerAt=function(e){return this[4*e-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(e){var t=(e._bitField,e._fulfillmentHandler0),n=e._rejectionHandler0,r=e._promise0,a=e._receiverAt(0);void 0===a&&(a=_),this._addCallbacks(t,n,r,a,null)},i.prototype._migrateCallbackAt=function(e,t){var n=e._fulfillmentHandlerAt(t),r=e._rejectionHandlerAt(t),a=e._promiseAt(t),i=e._receiverAt(t);void 0===i&&(i=_),this._addCallbacks(n,r,a,i,null)},i.prototype._addCallbacks=function(e,t,n,r,a){var i=this._length();if(i>=65531&&(i=0,this._setLength(0)),0===i)this._promise0=n,this._receiver0=r,\"function\"==typeof e&&(this._fulfillmentHandler0=null===a?e:f.domainBind(a,e)),\"function\"==typeof t&&(this._rejectionHandler0=null===a?t:f.domainBind(a,t));else{var o=4*i-4;this[o+2]=n,this[o+3]=r,\"function\"==typeof e&&(this[o+0]=null===a?e:f.domainBind(a,e)),\"function\"==typeof t&&(this[o+1]=null===a?t:f.domainBind(a,t))}return this._setLength(i+1),i},i.prototype._proxy=function(e,t){this._addCallbacks(void 0,void 0,t,e,null)},i.prototype._resolveCallback=function(e,t){if(0===(117506048&this._bitField)){if(e===this)return this._rejectCallback(d(),!1);var n=g(e,this);if(!(n instanceof i))return this._fulfill(e);t&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(d());var a=r._bitField;if(0===(50397184&a)){var o=this._length();o>0&&r._migrateCallback0(this);for(var c=1;c<o;++c)r._migrateCallbackAt(this,c);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&a))this._fulfill(r._value());else if(0!==(16777216&a))this._reject(r._reason());else{var s=new A(\"late cancellation observer\");r._attachExtraTrace(s),this._reject(s)}}},i.prototype._rejectCallback=function(e,t,n){var r=f.ensureErrorObject(e),a=r===e;if(!a&&!n&&k.warnings()){var i=\"a promise was rejected with a non-error: \"+f.classString(e);this._warn(i,!0)}this._attachExtraTrace(r,!!t&&a),this._reject(e)},i.prototype._resolveFromExecutor=function(e){if(e!==y){var t=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(e,function(e){t._resolveCallback(e)},function(e){t._rejectCallback(e,n)});n=!1,this._popContext(),void 0!==r&&t._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(e,t,n,r){var a=r._bitField;if(0===(65536&a)){r._pushContext();var i;t===z?n&&\"number\"==typeof n.length?i=W(e).apply(this._boundValue(),n):(i=w,i.e=new L(\"cannot .spread() a non-array: \"+f.classString(n))):i=W(e).call(t,n);var o=r._popContext();a=r._bitField,0===(65536&a)&&(i===T?r._reject(n):i===w?r._rejectCallback(i.e,!1):(k.checkForgottenReturns(i,o,\"\",r,this),r._resolveCallback(i)))}},i.prototype._target=function(){for(var e=this;e._isFollowing();)e=e._followee();return e},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(e){this._rejectionHandler0=e},i.prototype._settlePromise=function(e,t,n,a){var o=e instanceof i,c=this._bitField,s=0!==(134217728&c);0!==(65536&c)?(o&&e._invokeInternalOnCancel(),n instanceof Y&&n.isFinallyHandler()?(n.cancelPromise=e,W(t).call(n,a)===w&&e._reject(w.e)):t===l?e._fulfill(l.call(n)):n instanceof r?n._promiseCancelled(e):o||e instanceof v?e._cancel():n.cancel()):\"function\"==typeof t?o?(s&&e._setAsyncGuaranteed(),this._settlePromiseFromHandler(t,n,a,e)):t.call(n,a,e):n instanceof r?n._isResolved()||(0!==(33554432&c)?n._promiseFulfilled(a,e):n._promiseRejected(a,e)):o&&(s&&e._setAsyncGuaranteed(),0!==(33554432&c)?e._fulfill(a):e._reject(a))},i.prototype._settlePromiseLateCancellationObserver=function(e){var t=e.handler,n=e.promise,r=e.receiver,a=e.value;\"function\"==typeof t?n instanceof i?this._settlePromiseFromHandler(t,r,a,n):t.call(r,a,n):n instanceof i&&n._reject(a)},i.prototype._settlePromiseCtx=function(e){this._settlePromise(e.promise,e.handler,e.receiver,e.value)},i.prototype._settlePromise0=function(e,t,n){var r=this._promise0,a=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,e,a,t)},i.prototype._clearCallbackDataAtIndex=function(e){var t=4*e-4;this[t+2]=this[t+3]=this[t+0]=this[t+1]=void 0},i.prototype._fulfill=function(e){var t=this._bitField;if(!((117506048&t)>>>16)){if(e===this){var n=d();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=e,(65535&t)>0&&(0!==(134217728&t)?this._settlePromises():m.settlePromises(this))}},i.prototype._reject=function(e){var t=this._bitField;if(!((117506048&t)>>>16))return this._setRejected(),this._fulfillmentHandler0=e,this._isFinal()?m.fatalError(e,f.isNode):void((65535&t)>0?m.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(e,t){for(var n=1;n<e;n++){var r=this._fulfillmentHandlerAt(n),a=this._promiseAt(n),i=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(a,r,i,t)}},i.prototype._rejectPromises=function(e,t){for(var n=1;n<e;n++){var r=this._rejectionHandlerAt(n),a=this._promiseAt(n),i=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(a,r,i,t)}},i.prototype._settlePromises=function(){var e=this._bitField,t=65535&e;if(t>0){if(0!==(16842752&e)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,e),this._rejectPromises(t,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,e),this._fulfillPromises(t,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var e=this._bitField;return 0!==(33554432&e)?this._rejectionHandler0:0!==(16777216&e)?this._fulfillmentHandler0:void 0},i.defer=i.pending=function(){k.deprecated(\"Promise.defer\",\"new Promise\");var e=new i(y);return{promise:e,resolve:o,reject:c}},f.notEnumerableProp(i,\"_makeSelfResolutionError\",d),n(24)(i,y,g,M,k),n(25)(i,y,g,k),n(26)(i,v,M,k),n(27)(i),n(28)(i),n(29)(i,v,g,y,m,u),i.Promise=i,i.version=\"3.5.0\",n(30)(i,v,M,g,y,k),n(31)(i),n(32)(i,M,g,D,y,k),n(33)(i,y,k),n(34)(i,M,y,g,r,k),n(35)(i),n(36)(i,y),n(37)(i,v,g,M),n(38)(i,y,g,M),n(39)(i,v,M,g,y,k),n(40)(i,v,k),n(41)(i,v,M),n(42)(i,y),n(43)(i,y),n(44)(i),f.toFastProperties(i),f.toFastProperties(i.prototype),s({a:1}),s({b:2}),s({c:3}),s(1),s(function(){}),s(void 0),s(!1),s(new i(y)),k.setBounds(h.firstLineError,f.lastLineError),i}}).call(t,n(3))},function(e,t,n){(function(t,r){\"use strict\";function a(){try{var e=S;return S=null,e.apply(this,arguments)}catch(t){return Y.e=t,Y}}function i(e){return S=e,a}function o(e){return null==e||e===!0||e===!1||\"string\"==typeof e||\"number\"==typeof e}function c(e){return\"function\"==typeof e||\"object\"==typeof e&&null!==e}function s(e){return o(e)?new Error(m(e)):e}function u(e,t){var n,r=e.length,a=new Array(r+1);for(n=0;n<r;++n)a[n]=e[n];return a[n]=t,a}function d(e,t,n){if(!D.isES5)return{}.hasOwnProperty.call(e,t)?e[t]:void 0;var r=Object.getOwnPropertyDescriptor(e,t);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function l(e,t,n){if(o(e))return e;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return D.defineProperty(e,t,r),e}function M(e){throw e}function _(e){try{if(\"function\"==typeof e){var t=D.names(e.prototype),n=D.isES5&&t.length>1,r=t.length>0&&!(1===t.length&&\"constructor\"===t[0]),a=q.test(e+\"\")&&D.names(e).length>0;if(n||r||a)return!0}return!1}catch(i){return!1}}function f(e){function t(){}t.prototype=e;for(var n=8;n--;)new t;return e}function p(e){return E.test(e)}function h(e,t,n){for(var r=new Array(e),a=0;a<e;++a)r[a]=t+a+n;return r}function m(e){try{return e+\"\"}catch(t){return\"[no string representation]\"}}function b(e){return null!==e&&\"object\"==typeof e&&\"string\"==typeof e.message&&\"string\"==typeof e.name}function L(e){try{l(e,\"isOperational\",!0)}catch(t){}}function A(e){return null!=e&&(e instanceof Error.__BluebirdErrorTypes__.OperationalError||e.isOperational===!0)}function y(e){return b(e)&&D.propertyIsWritable(e,\"stack\")}function z(e){return{}.toString.call(e)}function T(e,t,n){for(var r=D.names(e),a=0;a<r.length;++a){var i=r[a];if(n(i))try{D.defineProperty(t,i,D.getDescriptor(e,i))}catch(o){}}}function g(e){return H?r.env[e]:void 0}function v(){if(\"function\"==typeof Promise)try{var e=new Promise(function(){});if(\"[object Promise]\"==={}.toString.call(e))return Promise}catch(t){}}function O(e,t){return e.bind(t)}var D=n(11),k=\"undefined\"==typeof navigator,Y={e:{}},S,N=\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:\"undefined\"!=typeof t?t:void 0!==this?this:null,w=function(e,t){function n(){this.constructor=e,this.constructor$=t;for(var n in t.prototype)r.call(t.prototype,n)&&\"$\"!==n.charAt(n.length-1)&&(this[n+\"$\"]=t.prototype[n])}var r={}.hasOwnProperty;return n.prototype=t.prototype,e.prototype=new n,e.prototype},W=function(){var e=[Array.prototype,Object.prototype,Function.prototype],t=function(t){for(var n=0;n<e.length;++n)if(e[n]===t)return!0;return!1};if(D.isES5){var n=Object.getOwnPropertyNames;return function(e){for(var r=[],a=Object.create(null);null!=e&&!t(e);){var i;try{i=n(e)}catch(o){return r}for(var c=0;c<i.length;++c){var s=i[c];if(!a[s]){a[s]=!0;var u=Object.getOwnPropertyDescriptor(e,s);null!=u&&null==u.get&&null==u.set&&r.push(s)}}e=D.getPrototypeOf(e)}return r}}var r={}.hasOwnProperty;return function(n){if(t(n))return[];var a=[];e:for(var i in n)if(r.call(n,i))a.push(i);else{for(var o=0;o<e.length;++o)if(r.call(e[o],i))continue e;a.push(i)}return a}}(),q=/this\\s*\\.\\s*\\S+\\s*=/,E=/^[a-z$_][a-z$_0-9]*$/i,B=function(){return\"stack\"in new Error?function(e){return y(e)?e:new Error(m(e))}:function(e){if(y(e))return e;try{throw new Error(m(e))}catch(t){return t}}}(),C=function(e){return D.isArray(e)?e:null};if(\"undefined\"!=typeof Symbol&&Symbol.iterator){var X=\"function\"==typeof Array.from?function(e){return Array.from(e)}:function(e){for(var t,n=[],r=e[Symbol.iterator]();!(t=r.next()).done;)n.push(t.value);return n};C=function(e){return D.isArray(e)?e:null!=e&&\"function\"==typeof e[Symbol.iterator]?X(e):null}}var R=\"undefined\"!=typeof r&&\"[object process]\"===z(r).toLowerCase(),H=\"undefined\"!=typeof r&&\"undefined\"!=typeof r.env,x={isClass:_,isIdentifier:p,inheritedDataKeys:W,getDataPropertyOrDefault:d,thrower:M,isArray:D.isArray,asArray:C,notEnumerableProp:l,isPrimitive:o,isObject:c,isError:b,canEvaluate:k,errorObj:Y,tryCatch:i,inherits:w,withAppended:u,maybeWrapAsError:s,toFastProperties:f,filledRange:h,toString:m,canAttachTrace:y,ensureErrorObject:B,originatesFromRejection:A,markAsOriginatingFromRejection:L,classString:z,copyDescriptors:T,hasDevTools:\"undefined\"!=typeof chrome&&chrome&&\"function\"==typeof chrome.loadTimes,isNode:R,hasEnvVariables:H,env:g,global:N,getNativePromise:v,domainBind:O};x.isRecentNode=x.isNode&&function(){var e=r.versions.node.split(\".\").map(Number);return 0===e[0]&&e[1]>10||e[0]>0}(),x.isNode&&x.toFastProperties(r);try{throw new Error}catch(j){x.lastLineError=j}e.exports=x}).call(t,function(){return this}(),n(3))},function(e,t){var n=function(){\"use strict\";return void 0===this}();if(n)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:n,propertyIsWritable:function(e,t){var n=Object.getOwnPropertyDescriptor(e,t);return!(n&&!n.writable&&!n.set)}};else{var r={}.hasOwnProperty,a={}.toString,i={}.constructor.prototype,o=function(e){var t=[];for(var n in e)r.call(e,n)&&t.push(n);return t},c=function(e,t){return{value:e[t]}},s=function(e,t,n){return e[t]=n.value,e},u=function(e){return e},d=function(e){try{return Object(e).constructor.prototype}catch(t){return i}},l=function(e){try{return\"[object Array]\"===a.call(e)}catch(t){return!1}};e.exports={isArray:l,keys:o,names:o,defineProperty:s,getDescriptor:c,freeze:u,getPrototypeOf:d,isES5:n,propertyIsWritable:function(){return!0}}}},function(e,t,n){(function(t){\"use strict\";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new d(16),this._normalQueue=new d(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var e=this;this.drainQueues=function(){e._drainQueues()},this._schedule=u}function a(e,t,n){this._lateQueue.push(e,t,n),this._queueTick()}function i(e,t,n){this._normalQueue.push(e,t,n),this._queueTick()}function o(e){this._normalQueue._pushOne(e),this._queueTick()}var c;try{throw new Error}catch(s){c=s}var u=n(13),d=n(15),l=n(10);r.prototype.setScheduler=function(e){var t=this._schedule;return this._schedule=e,this._customScheduler=!0,t},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){l.hasDevTools&&(this._trampolineEnabled=!1);\n},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(e,n){n?(t.stderr.write(\"Fatal \"+(e instanceof Error?e.stack:e)+\"\\n\"),t.exit(2)):this.throwLater(e)},r.prototype.throwLater=function(e,t){if(1===arguments.length&&(t=e,e=function(){throw t}),\"undefined\"!=typeof setTimeout)setTimeout(function(){e(t)},0);else try{this._schedule(function(){e(t)})}catch(n){throw new Error(\"No async scheduler available\\n\\n    See http://goo.gl/MqrFmX\\n\")}},l.hasDevTools?(r.prototype.invokeLater=function(e,t,n){this._trampolineEnabled?a.call(this,e,t,n):this._schedule(function(){setTimeout(function(){e.call(t,n)},100)})},r.prototype.invoke=function(e,t,n){this._trampolineEnabled?i.call(this,e,t,n):this._schedule(function(){e.call(t,n)})},r.prototype.settlePromises=function(e){this._trampolineEnabled?o.call(this,e):this._schedule(function(){e._settlePromises()})}):(r.prototype.invokeLater=a,r.prototype.invoke=i,r.prototype.settlePromises=o),r.prototype._drainQueue=function(e){for(;e.length()>0;){var t=e.shift();if(\"function\"==typeof t){var n=e.shift(),r=e.shift();t.call(n,r)}else t._settlePromises()}},r.prototype._drainQueues=function(){this._drainQueue(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,this._drainQueue(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=c}).call(t,n(3))},function(e,t,n){(function(t,r,a){\"use strict\";var i,o=n(10),c=function(){throw new Error(\"No async scheduler available\\n\\n    See http://goo.gl/MqrFmX\\n\")},s=o.getNativePromise();if(o.isNode&&\"undefined\"==typeof MutationObserver){var u=t.setImmediate,d=r.nextTick;i=o.isRecentNode?function(e){u.call(t,e)}:function(e){d.call(r,e)}}else if(\"function\"==typeof s&&\"function\"==typeof s.resolve){var l=s.resolve();i=function(e){l.then(e)}}else i=\"undefined\"==typeof MutationObserver||\"undefined\"!=typeof window&&window.navigator&&(window.navigator.standalone||window.cordova)?\"undefined\"!=typeof a?function(e){a(e)}:\"undefined\"!=typeof setTimeout?function(e){setTimeout(e,0)}:c:function(){var e=document.createElement(\"div\"),t={attributes:!0},n=!1,r=document.createElement(\"div\"),a=new MutationObserver(function(){e.classList.toggle(\"foo\"),n=!1});a.observe(r,t);var i=function(){n||(n=!0,r.classList.toggle(\"foo\"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(e,t),i()}}();e.exports=i}).call(t,function(){return this}(),n(3),n(14).setImmediate)},function(e,t,n){(function(e,r){function a(e,t){this._id=e,this._clearFn=t}var i=n(3).nextTick,o=Function.prototype.apply,c=Array.prototype.slice,s={},u=0;t.setTimeout=function(){return new a(o.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new a(o.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e.close()},a.prototype.unref=a.prototype.ref=function(){},a.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},t.setImmediate=\"function\"==typeof e?e:function(e){var n=u++,r=!(arguments.length<2)&&c.call(arguments,1);return s[n]=!0,i(function(){s[n]&&(r?e.apply(null,r):e.call(null),t.clearImmediate(n))}),n},t.clearImmediate=\"function\"==typeof r?r:function(e){delete s[e]}}).call(t,n(14).setImmediate,n(14).clearImmediate)},function(e,t){\"use strict\";function n(e,t,n,r,a){for(var i=0;i<a;++i)n[i+r]=e[i+t],e[i+t]=void 0}function r(e){this._capacity=e,this._length=0,this._front=0}r.prototype._willBeOverCapacity=function(e){return this._capacity<e},r.prototype._pushOne=function(e){var t=this.length();this._checkCapacity(t+1);var n=this._front+t&this._capacity-1;this[n]=e,this._length=t+1},r.prototype.push=function(e,t,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(e),this._pushOne(t),void this._pushOne(n);var a=this._front+r-3;this._checkCapacity(r);var i=this._capacity-1;this[a+0&i]=e,this[a+1&i]=t,this[a+2&i]=n,this._length=r},r.prototype.shift=function(){var e=this._front,t=this[e];return this[e]=void 0,this._front=e+1&this._capacity-1,this._length--,t},r.prototype.length=function(){return this._length},r.prototype._checkCapacity=function(e){this._capacity<e&&this._resizeTo(this._capacity<<1)},r.prototype._resizeTo=function(e){var t=this._capacity;this._capacity=e;var r=this._front,a=this._length,i=r+a&t-1;n(this,0,this,t,i)},e.exports=r},function(e,t,n){\"use strict\";function r(e,t){function n(r){return this instanceof n?(l(this,\"message\",\"string\"==typeof r?r:t),l(this,\"name\",e),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return d(n,Error),n}function a(e){return this instanceof a?(l(this,\"name\",\"OperationalError\"),l(this,\"message\",e),this.cause=e,this.isOperational=!0,void(e instanceof Error?(l(this,\"message\",e.message),l(this,\"stack\",e.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new a(e)}var i,o,c=n(11),s=c.freeze,u=n(10),d=u.inherits,l=u.notEnumerableProp,M=r(\"Warning\",\"warning\"),_=r(\"CancellationError\",\"cancellation error\"),f=r(\"TimeoutError\",\"timeout error\"),p=r(\"AggregateError\",\"aggregate error\");try{i=TypeError,o=RangeError}catch(h){i=r(\"TypeError\",\"type error\"),o=r(\"RangeError\",\"range error\")}for(var m=\"join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse\".split(\" \"),b=0;b<m.length;++b)\"function\"==typeof Array.prototype[m[b]]&&(p.prototype[m[b]]=Array.prototype[m[b]]);c.defineProperty(p.prototype,\"length\",{value:0,configurable:!1,writable:!0,enumerable:!0}),p.prototype.isOperational=!0;var L=0;p.prototype.toString=function(){var e=Array(4*L+1).join(\" \"),t=\"\\n\"+e+\"AggregateError of:\\n\";L++,e=Array(4*L+1).join(\" \");for(var n=0;n<this.length;++n){for(var r=this[n]===this?\"[Circular AggregateError]\":this[n]+\"\",a=r.split(\"\\n\"),i=0;i<a.length;++i)a[i]=e+a[i];r=a.join(\"\\n\"),t+=r+\"\\n\"}return L--,t},d(a,Error);var A=Error.__BluebirdErrorTypes__;A||(A=s({CancellationError:_,TimeoutError:f,OperationalError:a,RejectionError:a,AggregateError:p}),c.defineProperty(Error,\"__BluebirdErrorTypes__\",{value:A,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:i,RangeError:o,CancellationError:A.CancellationError,OperationalError:A.OperationalError,TimeoutError:A.TimeoutError,AggregateError:A.AggregateError,Warning:M}},function(e,t,n){\"use strict\";e.exports=function(e,t){function r(n,r){if(d(n)){if(n instanceof e)return n;var a=i(n);if(a===u){r&&r._pushContext();var s=e.reject(a.e);return r&&r._popContext(),s}if(\"function\"==typeof a){if(o(n)){var s=new e(t);return n._then(s._fulfill,s._reject,void 0,s,null),s}return c(n,a,r)}}return n}function a(e){return e.then}function i(e){try{return a(e)}catch(t){return u.e=t,u}}function o(e){try{return l.call(e,\"_promise0\")}catch(t){return!1}}function c(n,r,a){function i(e){c&&(c._resolveCallback(e),c=null)}function o(e){c&&(c._rejectCallback(e,l,!0),c=null)}var c=new e(t),d=c;a&&a._pushContext(),c._captureStackTrace(),a&&a._popContext();var l=!0,M=s.tryCatch(r).call(n,i,o);return l=!1,c&&M===u&&(c._rejectCallback(M.e,!0,!0),c=null),d}var s=n(10),u=s.errorObj,d=s.isObject,l={}.hasOwnProperty;return r}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i){function o(e){switch(e){case-2:return[];case-3:return{};case-6:return new Map}}function c(n){var r=this._promise=new e(t);n instanceof e&&r._propagateFrom(n,3),r._setOnCancel(this),this._values=n,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var s=n(10);s.isArray;return s.inherits(c,i),c.prototype.length=function(){return this._length},c.prototype.promise=function(){return this._promise},c.prototype._init=function u(t,n){var i=r(this._values,this._promise);if(i instanceof e){i=i._target();var c=i._bitField;if(this._values=i,0===(50397184&c))return this._promise._setAsyncGuaranteed(),i._then(u,this._reject,void 0,this,n);if(0===(33554432&c))return 0!==(16777216&c)?this._reject(i._reason()):this._cancel();i=i._value()}if(i=s.asArray(i),null===i){var d=a(\"expecting an array or an iterable object but got \"+s.classString(i)).reason();return void this._promise._rejectCallback(d,!1)}return 0===i.length?void(n===-5?this._resolveEmptyArray():this._resolve(o(n))):void this._iterate(i)},c.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var a=this._promise,i=!1,o=null,c=0;c<n;++c){var s=r(t[c],a);s instanceof e?(s=s._target(),o=s._bitField):o=null,i?null!==o&&s.suppressUnhandledRejections():null!==o?0===(50397184&o)?(s._proxy(this,c),this._values[c]=s):i=0!==(33554432&o)?this._promiseFulfilled(s._value(),c):0!==(16777216&o)?this._promiseRejected(s._reason(),c):this._promiseCancelled(c):i=this._promiseFulfilled(s,c)}i||a._setAsyncGuaranteed()},c.prototype._isResolved=function(){return null===this._values},c.prototype._resolve=function(e){this._values=null,this._promise._fulfill(e)},c.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},c.prototype._reject=function(e){this._values=null,this._promise._rejectCallback(e,!1)},c.prototype._promiseFulfilled=function(e,t){this._values[t]=e;var n=++this._totalResolved;return n>=this._length&&(this._resolve(this._values),!0)},c.prototype._promiseCancelled=function(){return this._cancel(),!0},c.prototype._promiseRejected=function(e){return this._totalResolved++,this._reject(e),!0},c.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},c.prototype.shouldCopyValues=function(){return!0},c.prototype.getActualLength=function(e){return e},c}},function(e,t){\"use strict\";e.exports=function(e){function t(){this._trace=new t.CapturedTrace(r())}function n(){if(a)return new t}function r(){var e=i.length-1;if(e>=0)return i[e]}var a=!1,i=[];return e.prototype._promiseCreated=function(){},e.prototype._pushContext=function(){},e.prototype._popContext=function(){return null},e._peekContext=e.prototype._peekContext=function(){},t.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,i.push(this._trace))},t.prototype._popContext=function(){if(void 0!==this._trace){var e=i.pop(),t=e._promiseCreated;return e._promiseCreated=null,t}return null},t.CapturedTrace=null,t.create=n,t.deactivateLongStackTraces=function(){},t.activateLongStackTraces=function(){var n=e.prototype._pushContext,i=e.prototype._popContext,o=e._peekContext,c=e.prototype._peekContext,s=e.prototype._promiseCreated;t.deactivateLongStackTraces=function(){e.prototype._pushContext=n,e.prototype._popContext=i,e._peekContext=o,e.prototype._peekContext=c,e.prototype._promiseCreated=s,a=!1},a=!0,e.prototype._pushContext=t.prototype._pushContext,e.prototype._popContext=t.prototype._popContext,e._peekContext=e.prototype._peekContext=r,e.prototype._promiseCreated=function(){var e=this._peekContext();e&&null==e._promiseCreated&&(e._promiseCreated=this)}},t}},function(e,t,n){(function(t){\"use strict\";e.exports=function(e,r){function a(e,t){return{promise:t}}function i(){return!1}function o(e,t,n){var r=this;try{e(t,n,function(e){if(\"function\"!=typeof e)throw new TypeError(\"onCancel must be a function, got: \"+R.toString(e));r._attachCancellationCallback(e)})}catch(a){return a}}function c(e){if(!this._isCancellable())return this;var t=this._onCancel();void 0!==t?R.isArray(t)?t.push(e):this._setOnCancel([t,e]):this._setOnCancel(e)}function s(){return this._onCancelField}function u(e){this._onCancelField=e}function d(){this._cancellationParent=void 0,this._onCancelField=void 0}function l(e,t){if(0!==(1&t)){this._cancellationParent=e;var n=e._branchesRemainingToCancel;void 0===n&&(n=0),e._branchesRemainingToCancel=n+1}0!==(2&t)&&e._isBound()&&this._setBoundTo(e._boundTo)}function M(e,t){0!==(2&t)&&e._isBound()&&this._setBoundTo(e._boundTo)}function _(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new w(this._peekContext())}function p(e,t){if(H(e)){var n=this._trace;if(void 0!==n&&t&&(n=n._parent),void 0!==n)n.attachExtraTrace(e);else if(!e.__stackCleaned__){var r=g(e);R.notEnumerableProp(e,\"stack\",r.message+\"\\n\"+r.stack.join(\"\\n\")),R.notEnumerableProp(e,\"__stackCleaned__\",!0)}}}function h(e,t,n,r,a){if(void 0===e&&null!==t&&K){if(void 0!==a&&a._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=\" \");var i=\"\",o=\"\";if(t._trace){for(var c=t._trace.stack.split(\"\\n\"),s=z(c),u=s.length-1;u>=0;--u){var d=s[u];if(!j.test(d)){var l=d.match(P);l&&(i=\"at \"+l[1]+\":\"+l[2]+\":\"+l[3]+\" \");break}}if(s.length>0)for(var M=s[0],u=0;u<c.length;++u)if(c[u]===M){u>0&&(o=\"\\n\"+c[u-1]);break}}var _=\"a promise was created in a \"+n+\"handler \"+i+\"but was not returned from it, see http://goo.gl/rRqMUw\"+o;r._warn(_,!0,t)}}function m(e,t){var n=e+\" is deprecated and will be removed in a future version.\";return t&&(n+=\" Use \"+t+\" instead.\"),b(n)}function b(t,n,r){if(oe.warnings){var a,i=new X(t);if(n)r._attachExtraTrace(i);else if(oe.longStackTraces&&(a=e._peekContext()))a.attachExtraTrace(i);else{var o=g(i);i.stack=o.message+\"\\n\"+o.stack.join(\"\\n\")}te(\"warning\",i)||v(i,\"\",!0)}}function L(e,t){for(var n=0;n<t.length-1;++n)t[n].push(\"From previous event:\"),t[n]=t[n].join(\"\\n\");return n<t.length&&(t[n]=t[n].join(\"\\n\")),e+\"\\n\"+t.join(\"\\n\")}function A(e){for(var t=0;t<e.length;++t)(0===e[t].length||t+1<e.length&&e[t][0]===e[t+1][0])&&(e.splice(t,1),t--)}function y(e){for(var t=e[0],n=1;n<e.length;++n){for(var r=e[n],a=t.length-1,i=t[a],o=-1,c=r.length-1;c>=0;--c)if(r[c]===i){o=c;break}for(var c=o;c>=0;--c){var s=r[c];if(t[a]!==s)break;t.pop(),a--}t=r}}function z(e){for(var t=[],n=0;n<e.length;++n){var r=e[n],a=\"    (No stack trace)\"===r||F.test(r),i=a&&re(r);a&&!i&&(I&&\" \"!==r.charAt(0)&&(r=\"    \"+r),t.push(r))}return t}function T(e){for(var t=e.stack.replace(/\\s+$/g,\"\").split(\"\\n\"),n=0;n<t.length;++n){var r=t[n];if(\"    (No stack trace)\"===r||F.test(r))break}return n>0&&\"SyntaxError\"!=e.name&&(t=t.slice(n)),t}function g(e){var t=e.stack,n=e.toString();return t=\"string\"==typeof t&&t.length>0?T(e):[\"    (No stack trace)\"],{message:n,stack:\"SyntaxError\"==e.name?t:z(t)}}function v(e,t,n){if(\"undefined\"!=typeof console){var r;if(R.isObject(e)){var a=e.stack;r=t+U(a,e)}else r=t+String(e);\"function\"==typeof E?E(r,n):\"function\"!=typeof console.log&&\"object\"!=typeof console.log||console.log(r)}}function O(e,t,n,r){var a=!1;try{\"function\"==typeof t&&(a=!0,\"rejectionHandled\"===e?t(r):t(n,r))}catch(i){C.throwLater(i)}\"unhandledRejection\"===e?te(e,n,r)||a||v(n,\"Unhandled rejection \"):te(e,r)}function D(e){var t;if(\"function\"==typeof e)t=\"[function \"+(e.name||\"anonymous\")+\"]\";else{t=e&&\"function\"==typeof e.toString?e.toString():R.toString(e);var n=/\\[object [a-zA-Z0-9$_]+\\]/;if(n.test(t))try{var r=JSON.stringify(e);t=r}catch(a){}0===t.length&&(t=\"(empty array)\")}return\"(<\"+k(t)+\">, no stack trace)\"}function k(e){var t=41;return e.length<t?e:e.substr(0,t-3)+\"...\"}function Y(){return\"function\"==typeof ie}function S(e){var t=e.match(ae);if(t)return{fileName:t[1],line:parseInt(t[2],10)}}function N(e,t){if(Y()){for(var n,r,a=e.stack.split(\"\\n\"),i=t.stack.split(\"\\n\"),o=-1,c=-1,s=0;s<a.length;++s){var u=S(a[s]);if(u){n=u.fileName,o=u.line;break}}for(var s=0;s<i.length;++s){var u=S(i[s]);if(u){r=u.fileName,c=u.line;break}}o<0||c<0||!n||!r||n!==r||o>=c||(re=function(e){if(x.test(e))return!0;var t=S(e);return!!(t&&t.fileName===n&&o<=t.line&&t.line<=c)})}}function w(e){this._parent=e,this._promisesCreated=0;var t=this._length=1+(void 0===e?0:e._length);ie(this,w),t>32&&this.uncycle()}var W,q,E,B=e._getDomain,C=e._async,X=n(16).Warning,R=n(10),H=R.canAttachTrace,x=/[\\\\\\/]bluebird[\\\\\\/]js[\\\\\\/](release|debug|instrumented)/,j=/\\((?:timers\\.js):\\d+:\\d+\\)/,P=/[\\/<\\(](.+?):(\\d+):(\\d+)\\)?\\s*$/,F=null,U=null,I=!1,G=!(0==R.env(\"BLUEBIRD_DEBUG\")||!R.env(\"BLUEBIRD_DEBUG\")&&\"development\"!==R.env(\"NODE_ENV\")),J=!(0==R.env(\"BLUEBIRD_WARNINGS\")||!G&&!R.env(\"BLUEBIRD_WARNINGS\")),V=!(0==R.env(\"BLUEBIRD_LONG_STACK_TRACES\")||!G&&!R.env(\"BLUEBIRD_LONG_STACK_TRACES\")),K=0!=R.env(\"BLUEBIRD_W_FORGOTTEN_RETURN\")&&(J||!!R.env(\"BLUEBIRD_W_FORGOTTEN_RETURN\"));e.prototype.suppressUnhandledRejections=function(){var e=this._target();e._bitField=e._bitField&-1048577|524288},e.prototype._ensurePossibleRejectionHandled=function(){0===(524288&this._bitField)&&(this._setRejectionIsUnhandled(),C.invokeLater(this._notifyUnhandledRejection,this,void 0))},e.prototype._notifyUnhandledRejectionIsHandled=function(){O(\"rejectionHandled\",W,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var e=this._settledValue();this._setUnhandledRejectionIsNotified(),O(\"unhandledRejection\",q,e,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=this._bitField&-262145},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=this._bitField&-1048577,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(e,t,n){return b(e,t,n||this)},e.onPossiblyUnhandledRejection=function(e){var t=B();q=\"function\"==typeof e?null===t?e:R.domainBind(t,e):void 0},e.onUnhandledRejectionHandled=function(e){var t=B();W=\"function\"==typeof e?null===t?e:R.domainBind(t,e):void 0};var Q=function(){};e.longStackTraces=function(){if(C.haveItemsQueued()&&!oe.longStackTraces)throw new Error(\"cannot enable long stack traces after promises have been created\\n\\n    See http://goo.gl/MqrFmX\\n\");if(!oe.longStackTraces&&Y()){var t=e.prototype._captureStackTrace,n=e.prototype._attachExtraTrace;oe.longStackTraces=!0,Q=function(){if(C.haveItemsQueued()&&!oe.longStackTraces)throw new Error(\"cannot enable long stack traces after promises have been created\\n\\n    See http://goo.gl/MqrFmX\\n\");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=n,r.deactivateLongStackTraces(),C.enableTrampoline(),oe.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=p,r.activateLongStackTraces(),C.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return oe.longStackTraces&&Y()};var Z=function(){try{if(\"function\"==typeof CustomEvent){var e=new CustomEvent(\"CustomEvent\");return R.global.dispatchEvent(e),function(e,t){var n=new CustomEvent(e.toLowerCase(),{detail:t,cancelable:!0});return!R.global.dispatchEvent(n)}}if(\"function\"==typeof Event){var e=new Event(\"CustomEvent\");return R.global.dispatchEvent(e),function(e,t){var n=new Event(e.toLowerCase(),{cancelable:!0});return n.detail=t,!R.global.dispatchEvent(n)}}var e=document.createEvent(\"CustomEvent\");return e.initCustomEvent(\"testingtheevent\",!1,!0,{}),R.global.dispatchEvent(e),function(e,t){var n=document.createEvent(\"CustomEvent\");return n.initCustomEvent(e.toLowerCase(),!1,!0,t),!R.global.dispatchEvent(n)}}catch(t){}return function(){return!1}}(),$=function(){return R.isNode?function(){return t.emit.apply(t,arguments)}:R.global?function(e){var t=\"on\"+e.toLowerCase(),n=R.global[t];return!!n&&(n.apply(R.global,[].slice.call(arguments,1)),!0)}:function(){return!1}}(),ee={promiseCreated:a,promiseFulfilled:a,promiseRejected:a,promiseResolved:a,promiseCancelled:a,promiseChained:function(e,t,n){return{promise:t,child:n}},warning:function(e,t){return{warning:t}},unhandledRejection:function(e,t,n){return{reason:t,promise:n}},rejectionHandled:a},te=function(e){var t=!1;try{t=$.apply(null,arguments)}catch(n){C.throwLater(n),t=!0}var r=!1;try{r=Z(e,ee[e].apply(null,arguments))}catch(n){C.throwLater(n),r=!0}return r||t};e.config=function(t){if(t=Object(t),\"longStackTraces\"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Q()),\"warnings\"in t){var n=t.warnings;oe.warnings=!!n,K=oe.warnings,R.isObject(n)&&\"wForgottenReturn\"in n&&(K=!!n.wForgottenReturn)}if(\"cancellation\"in t&&t.cancellation&&!oe.cancellation){if(C.haveItemsQueued())throw new Error(\"cannot enable cancellation after promises are in use\");e.prototype._clearCancellationData=d,e.prototype._propagateFrom=l,e.prototype._onCancel=s,e.prototype._setOnCancel=u,e.prototype._attachCancellationCallback=c,e.prototype._execute=o,ne=l,oe.cancellation=!0}return\"monitoring\"in t&&(t.monitoring&&!oe.monitoring?(oe.monitoring=!0,e.prototype._fireEvent=te):!t.monitoring&&oe.monitoring&&(oe.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(e,t,n){try{e(t,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(e){},e.prototype._attachCancellationCallback=function(e){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(e,t){};var ne=M,re=function(){return!1},ae=/[\\/<\\(]([^:\\/]+):(\\d+):(?:\\d+)\\)?\\s*$/;R.inherits(w,Error),r.CapturedTrace=w,w.prototype.uncycle=function(){var e=this._length;if(!(e<2)){for(var t=[],n={},r=0,a=this;void 0!==a;++r)t.push(a),a=a._parent;e=this._length=r;for(var r=e-1;r>=0;--r){var i=t[r].stack;void 0===n[i]&&(n[i]=r)}for(var r=0;r<e;++r){var o=t[r].stack,c=n[o];if(void 0!==c&&c!==r){c>0&&(t[c-1]._parent=void 0,t[c-1]._length=1),t[r]._parent=void 0,t[r]._length=1;var s=r>0?t[r-1]:this;c<e-1?(s._parent=t[c+1],s._parent.uncycle(),s._length=s._parent._length+1):(s._parent=void 0,s._length=1);for(var u=s._length+1,d=r-2;d>=0;--d)t[d]._length=u,u++;return}}}},w.prototype.attachExtraTrace=function(e){if(!e.__stackCleaned__){this.uncycle();for(var t=g(e),n=t.message,r=[t.stack],a=this;void 0!==a;)r.push(z(a.stack.split(\"\\n\"))),a=a._parent;y(r),A(r),R.notEnumerableProp(e,\"stack\",L(n,r)),R.notEnumerableProp(e,\"__stackCleaned__\",!0)}};var ie=function(){var e=/^\\s*at\\s*/,t=function(e,t){return\"string\"==typeof e?e:void 0!==t.name&&void 0!==t.message?t.toString():D(t)};if(\"number\"==typeof Error.stackTraceLimit&&\"function\"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,F=e,U=t;var n=Error.captureStackTrace;return re=function(e){return x.test(e)},function(e,t){Error.stackTraceLimit+=6,n(e,t),Error.stackTraceLimit-=6}}var r=new Error;if(\"string\"==typeof r.stack&&r.stack.split(\"\\n\")[0].indexOf(\"stackDetection@\")>=0)return F=/@/,U=t,I=!0,function(e){e.stack=(new Error).stack};var a;try{throw new Error}catch(i){a=\"stack\"in i}return\"stack\"in r||!a||\"number\"!=typeof Error.stackTraceLimit?(U=function(e,t){return\"string\"==typeof e?e:\"object\"!=typeof t&&\"function\"!=typeof t||void 0===t.name||void 0===t.message?D(t):t.toString()},null):(F=e,U=t,function(e){Error.stackTraceLimit+=6;try{throw new Error}catch(t){e.stack=t.stack}Error.stackTraceLimit-=6})}([]);\"undefined\"!=typeof console&&\"undefined\"!=typeof console.warn&&(E=function(e){console.warn(e)},R.isNode&&t.stderr.isTTY?E=function(e,t){var n=t?\"\u001b[33m\":\"\u001b[31m\";console.warn(n+e+\"\u001b[0m\\n\")}:R.isNode||\"string\"!=typeof(new Error).stack||(E=function(e,t){console.warn(\"%c\"+e,t?\"color: darkorange\":\"color: red\")}));var oe={warnings:J,longStackTraces:!1,cancellation:!1,monitoring:!1};return V&&e.longStackTraces(),{longStackTraces:function(){return oe.longStackTraces},warnings:function(){return oe.warnings},cancellation:function(){return oe.cancellation},monitoring:function(){return oe.monitoring},propagateFromFunction:function(){return ne},boundValueFunction:function(){return _},checkForgottenReturns:h,setBounds:N,warn:b,deprecated:m,CapturedTrace:w,fireDomEvent:Z,fireGlobalEvent:$}}}).call(t,n(3))},function(e,t,n){\"use strict\";e.exports=function(e,t,r){function a(e,t,n){this.promise=e,this.type=t,this.handler=n,this.called=!1,this.cancelPromise=null}function i(e){this.finallyHandler=e}function o(e,t){return null!=e.cancelPromise&&(arguments.length>1?e.cancelPromise._reject(t):e.cancelPromise._cancel(),e.cancelPromise=null,!0)}function c(){return u.call(this,this.promise._target()._settledValue())}function s(e){if(!o(this,e))return M.e=e,M}function u(n){var a=this.promise,u=this.handler;if(!this.called){this.called=!0;var d=this.isFinallyHandler()?u.call(a._boundValue()):u.call(a._boundValue(),n);if(d===r)return d;if(void 0!==d){a._setReturnedNonUndefined();var _=t(d,a);if(_ instanceof e){if(null!=this.cancelPromise){if(_._isCancelled()){var f=new l(\"late cancellation observer\");return a._attachExtraTrace(f),M.e=f,M}_.isPending()&&_._attachCancellationCallback(new i(this))}return _._then(c,s,void 0,this,void 0)}}}return a.isRejected()?(o(this),M.e=n,M):(o(this),n)}var d=n(10),l=e.CancellationError,M=d.errorObj,_=n(22)(r);return a.prototype.isFinallyHandler=function(){return 0===this.type},i.prototype._resultCancelled=function(){o(this.finallyHandler)},e.prototype._passThrough=function(e,t,n,r){return\"function\"!=typeof e?this.then():this._then(n,r,void 0,new a(this,t,e),void 0)},e.prototype.lastly=e.prototype[\"finally\"]=function(e){return this._passThrough(e,0,u,u)},e.prototype.tap=function(e){return this._passThrough(e,1,u)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,u);var r,a=new Array(n-1),i=0;for(r=0;r<n-1;++r){var o=arguments[r];if(!d.isObject(o))return e.reject(new TypeError(\"tapCatch statement predicate: expecting an object but got \"+d.classString(o)));a[i++]=o}a.length=i;var c=arguments[r];return this._passThrough(_(a,c,this),1,void 0,u)},a}},function(e,t,n){\"use strict\";e.exports=function(e){function t(t,n,c){return function(s){var u=c._boundValue();e:for(var d=0;d<t.length;++d){var l=t[d];if(l===Error||null!=l&&l.prototype instanceof Error){if(s instanceof l)return i(n).call(u,s)}else if(\"function\"==typeof l){var M=i(l).call(u,s);if(M===o)return M;if(M)return i(n).call(u,s)}else if(r.isObject(s)){for(var _=a(l),f=0;f<_.length;++f){var p=_[f];if(l[p]!=s[p])continue e}return i(n).call(u,s)}}return e}}var r=n(10),a=n(11).keys,i=r.tryCatch,o=r.errorObj;return t}},function(e,t,n){\"use strict\";function r(e){return e instanceof Error&&d.getPrototypeOf(e)===Error.prototype}function a(e){var t;if(r(e)){t=new u(e),t.name=e.name,t.message=e.message,t.stack=e.stack;for(var n=d.keys(e),a=0;a<n.length;++a){var i=n[a];l.test(i)||(t[i]=e[i])}return t}return o.markAsOriginatingFromRejection(e),e}function i(e,t){return function(n,r){if(null!==e){if(n){var i=a(c(n));e._attachExtraTrace(i),e._reject(i)}else if(t){for(var o=arguments.length,s=new Array(Math.max(o-1,0)),u=1;u<o;++u)s[u-1]=arguments[u];e._fulfill(s)}else e._fulfill(r);e=null}}}var o=n(10),c=o.maybeWrapAsError,s=n(16),u=s.OperationalError,d=n(11),l=/^(?:name|message|stack|cause)$/;e.exports=i},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i){var o=n(10),c=o.tryCatch;e.method=function(n){if(\"function\"!=typeof n)throw new e.TypeError(\"expecting a function but got \"+o.classString(n));return function(){var r=new e(t);r._captureStackTrace(),r._pushContext();var a=c(n).apply(this,arguments),o=r._popContext();return i.checkForgottenReturns(a,o,\"Promise.method\",r),r._resolveFromSyncValue(a),r}},e.attempt=e[\"try\"]=function(n){if(\"function\"!=typeof n)return a(\"expecting a function but got \"+o.classString(n));var r=new e(t);r._captureStackTrace(),r._pushContext();var s;if(arguments.length>1){i.deprecated(\"calling Promise.try with more than 1 argument\");var u=arguments[1],d=arguments[2];s=o.isArray(u)?c(n).apply(d,u):c(n).call(d,u)}else s=c(n)();var l=r._popContext();return i.checkForgottenReturns(s,l,\"Promise.try\",r),r._resolveFromSyncValue(s),r},e.prototype._resolveFromSyncValue=function(e){e===o.errorObj?this._rejectCallback(e.e,!1):this._resolveCallback(e,!0)}}},function(e,t){\"use strict\";e.exports=function(e,t,n,r){var a=!1,i=function(e,t){this._reject(t)},o=function(e,t){t.promiseRejectionQueued=!0,t.bindingPromise._then(i,i,null,this,e)},c=function(e,t){0===(50397184&this._bitField)&&this._resolveCallback(t.target)},s=function(e,t){t.promiseRejectionQueued||this._reject(e)};e.prototype.bind=function(i){a||(a=!0,e.prototype._propagateFrom=r.propagateFromFunction(),e.prototype._boundValue=r.boundValueFunction());var u=n(i),d=new e(t);d._propagateFrom(this,1);var l=this._target();if(d._setBoundTo(u),u instanceof e){var M={promiseRejectionQueued:!1,promise:d,target:l,bindingPromise:u};l._then(t,o,void 0,d,M),u._then(c,s,void 0,d,M),d._setOnCancel(u)}else d._resolveCallback(l);return d},e.prototype._setBoundTo=function(e){void 0!==e?(this._bitField=2097152|this._bitField,this._boundTo=e):this._bitField=this._bitField&-2097153},e.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},e.bind=function(t,n){return e.resolve(n).bind(t)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a){var i=n(10),o=i.tryCatch,c=i.errorObj,s=e._async;e.prototype[\"break\"]=e.prototype.cancel=function(){if(!a.cancellation())return this._warn(\"cancellation is disabled\");for(var e=this,t=e;e._isCancellable();){if(!e._cancelBy(t)){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}var n=e._cancellationParent;if(null==n||!n._isCancellable()){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}e._isFollowing()&&e._followee().cancel(),e._setWillBeCancelled(),t=e,e=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(e){return e===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),!!this._enoughBranchesHaveCancelled()&&(this._invokeOnCancel(),!0))},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),s.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(e,t){if(i.isArray(e))for(var n=0;n<e.length;++n)this._doInvokeOnCancel(e[n],t);else if(void 0!==e)if(\"function\"==typeof e){if(!t){var r=o(e).call(this._boundValue());r===c&&(this._attachExtraTrace(r.e),s.throwLater(r.e))}}else e._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var e=this._onCancel();this._unsetOnCancel(),s.invoke(this._doInvokeOnCancel,this,e)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},function(e,t){\"use strict\";e.exports=function(e){function t(){return this.value}function n(){throw this.reason}e.prototype[\"return\"]=e.prototype.thenReturn=function(n){return n instanceof e&&n.suppressUnhandledRejections(),this._then(t,void 0,void 0,{value:n},void 0)},e.prototype[\"throw\"]=e.prototype.thenThrow=function(e){\nreturn this._then(n,void 0,void 0,{reason:e},void 0)},e.prototype.catchThrow=function(e){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:e},void 0);var t=arguments[1],r=function(){throw t};return this.caught(e,r)},e.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof e&&n.suppressUnhandledRejections(),this._then(void 0,t,void 0,{value:n},void 0);var r=arguments[1];r instanceof e&&r.suppressUnhandledRejections();var a=function(){return r};return this.caught(n,a)}}},function(e,t){\"use strict\";e.exports=function(e){function t(e){void 0!==e?(e=e._target(),this._bitField=e._bitField,this._settledValueField=e._isFateSealed()?e._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}t.prototype._settledValue=function(){return this._settledValueField};var n=t.prototype.value=function(){if(!this.isFulfilled())throw new TypeError(\"cannot get fulfillment value of a non-fulfilled promise\\n\\n    See http://goo.gl/MqrFmX\\n\");return this._settledValue()},r=t.prototype.error=t.prototype.reason=function(){if(!this.isRejected())throw new TypeError(\"cannot get rejection reason of a non-rejected promise\\n\\n    See http://goo.gl/MqrFmX\\n\");return this._settledValue()},a=t.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},i=t.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},o=t.prototype.isPending=function(){return 0===(50397184&this._bitField)},c=t.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};t.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},e.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},e.prototype._isCancelled=function(){return this._target().__isCancelled()},e.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},e.prototype.isPending=function(){return o.call(this._target())},e.prototype.isRejected=function(){return i.call(this._target())},e.prototype.isFulfilled=function(){return a.call(this._target())},e.prototype.isResolved=function(){return c.call(this._target())},e.prototype.value=function(){return n.call(this._target())},e.prototype.reason=function(){var e=this._target();return e._unsetRejectionIsUnhandled(),r.call(e)},e.prototype._value=function(){return this._settledValue()},e.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},e.PromiseInspection=t}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i,o){var c,s=n(10),u=s.canEvaluate,d=s.tryCatch,l=s.errorObj;if(u){for(var M=function(e){return new Function(\"value\",\"holder\",\"                             \\n\\t            'use strict';                                                    \\n\\t            holder.pIndex = value;                                           \\n\\t            holder.checkFulfillment(this);                                   \\n\\t            \".replace(/Index/g,e))},_=function(e){return new Function(\"promise\",\"holder\",\"                           \\n\\t            'use strict';                                                    \\n\\t            holder.pIndex = promise;                                         \\n\\t            \".replace(/Index/g,e))},f=function(t){for(var n=new Array(t),r=0;r<n.length;++r)n[r]=\"this.p\"+(r+1);var a=n.join(\" = \")+\" = null;\",o=\"var promise;\\n\"+n.map(function(e){return\"                                                         \\n\\t                promise = \"+e+\";                                      \\n\\t                if (promise instanceof Promise) {                            \\n\\t                    promise.cancel();                                        \\n\\t                }                                                            \\n\\t            \"}).join(\"\\n\"),c=n.join(\", \"),s=\"Holder$\"+t,u=\"return function(tryCatch, errorObj, Promise, async) {    \\n\\t            'use strict';                                                    \\n\\t            function [TheName](fn) {                                         \\n\\t                [TheProperties]                                              \\n\\t                this.fn = fn;                                                \\n\\t                this.asyncNeeded = true;                                     \\n\\t                this.now = 0;                                                \\n\\t            }                                                                \\n\\t                                                                             \\n\\t            [TheName].prototype._callFunction = function(promise) {          \\n\\t                promise._pushContext();                                      \\n\\t                var ret = tryCatch(this.fn)([ThePassedArguments]);           \\n\\t                promise._popContext();                                       \\n\\t                if (ret === errorObj) {                                      \\n\\t                    promise._rejectCallback(ret.e, false);                   \\n\\t                } else {                                                     \\n\\t                    promise._resolveCallback(ret);                           \\n\\t                }                                                            \\n\\t            };                                                               \\n\\t                                                                             \\n\\t            [TheName].prototype.checkFulfillment = function(promise) {       \\n\\t                var now = ++this.now;                                        \\n\\t                if (now === [TheTotal]) {                                    \\n\\t                    if (this.asyncNeeded) {                                  \\n\\t                        async.invoke(this._callFunction, this, promise);     \\n\\t                    } else {                                                 \\n\\t                        this._callFunction(promise);                         \\n\\t                    }                                                        \\n\\t                                                                             \\n\\t                }                                                            \\n\\t            };                                                               \\n\\t                                                                             \\n\\t            [TheName].prototype._resultCancelled = function() {              \\n\\t                [CancellationCode]                                           \\n\\t            };                                                               \\n\\t                                                                             \\n\\t            return [TheName];                                                \\n\\t        }(tryCatch, errorObj, Promise, async);                               \\n\\t        \";return u=u.replace(/\\[TheName\\]/g,s).replace(/\\[TheTotal\\]/g,t).replace(/\\[ThePassedArguments\\]/g,c).replace(/\\[TheProperties\\]/g,a).replace(/\\[CancellationCode\\]/g,o),new Function(\"tryCatch\",\"errorObj\",\"Promise\",\"async\",u)(d,l,e,i)},p=[],h=[],m=[],b=0;b<8;++b)p.push(f(b+1)),h.push(M(b+1)),m.push(_(b+1));c=function(e){this._reject(e)}}e.join=function(){var n,i=arguments.length-1;if(i>0&&\"function\"==typeof arguments[i]&&(n=arguments[i],i<=8&&u)){var d=new e(a);d._captureStackTrace();for(var l=p[i-1],M=new l(n),_=h,f=0;f<i;++f){var b=r(arguments[f],d);if(b instanceof e){b=b._target();var L=b._bitField;0===(50397184&L)?(b._then(_[f],c,void 0,d,M),m[f](b,M),M.asyncNeeded=!1):0!==(33554432&L)?_[f].call(d,b._value(),M):0!==(16777216&L)?d._reject(b._reason()):d._cancel()}else _[f].call(d,b,M)}if(!d._isFateSealed()){if(M.asyncNeeded){var A=o();null!==A&&(M.fn=s.domainBind(A,M.fn))}d._setAsyncGuaranteed(),d._setOnCancel(M)}return d}for(var y=arguments.length,z=new Array(y),T=0;T<y;++T)z[T]=arguments[T];n&&z.pop();var d=new t(z).promise();return void 0!==n?d.spread(n):d}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i,o){function c(e,t,n,r){this.constructor$(e),this._promise._captureStackTrace();var a=u();this._callback=null===a?t:d.domainBind(a,t),this._preservedValues=r===i?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],_.invoke(this._asyncInit,this,void 0)}function s(t,n,a,i){if(\"function\"!=typeof n)return r(\"expecting a function but got \"+d.classString(n));var o=0;if(void 0!==a){if(\"object\"!=typeof a||null===a)return e.reject(new TypeError(\"options argument must be an object but it is \"+d.classString(a)));if(\"number\"!=typeof a.concurrency)return e.reject(new TypeError(\"'concurrency' must be a number but it is \"+d.classString(a.concurrency)));o=a.concurrency}return o=\"number\"==typeof o&&isFinite(o)&&o>=1?o:0,new c(t,n,o,i).promise()}var u=e._getDomain,d=n(10),l=d.tryCatch,M=d.errorObj,_=e._async;d.inherits(c,t),c.prototype._asyncInit=function(){this._init$(void 0,-2)},c.prototype._init=function(){},c.prototype._promiseFulfilled=function(t,n){var r=this._values,i=this.length(),c=this._preservedValues,s=this._limit;if(n<0){if(n=n*-1-1,r[n]=t,s>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(s>=1&&this._inFlight>=s)return r[n]=t,this._queue.push(n),!1;null!==c&&(c[n]=t);var u=this._promise,d=this._callback,_=u._boundValue();u._pushContext();var f=l(d).call(_,t,n,i),p=u._popContext();if(o.checkForgottenReturns(f,p,null!==c?\"Promise.filter\":\"Promise.map\",u),f===M)return this._reject(f.e),!0;var h=a(f,this._promise);if(h instanceof e){h=h._target();var m=h._bitField;if(0===(50397184&m))return s>=1&&this._inFlight++,r[n]=h,h._proxy(this,(n+1)*-1),!1;if(0===(33554432&m))return 0!==(16777216&m)?(this._reject(h._reason()),!0):(this._cancel(),!0);f=h._value()}r[n]=f}var b=++this._totalResolved;return b>=i&&(null!==c?this._filter(r,c):this._resolve(r),!0)},c.prototype._drainQueue=function(){for(var e=this._queue,t=this._limit,n=this._values;e.length>0&&this._inFlight<t;){if(this._isResolved())return;var r=e.pop();this._promiseFulfilled(n[r],r)}},c.prototype._filter=function(e,t){for(var n=t.length,r=new Array(n),a=0,i=0;i<n;++i)e[i]&&(r[a++]=t[i]);r.length=a,this._resolve(r)},c.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(e,t){return s(this,e,t,null)},e.map=function(e,t,n,r){return s(e,t,n,r)}}},function(e,t,n){\"use strict\";var r=Object.create;if(r){var a=r(null),i=r(null);a[\" size\"]=i[\" size\"]=0}e.exports=function(e){function t(t,n){var r;if(null!=t&&(r=t[n]),\"function\"!=typeof r){var a=\"Object \"+d.classString(t)+\" has no method '\"+d.toString(n)+\"'\";throw new e.TypeError(a)}return r}function r(e){var n=this.pop(),r=t(e,n);return r.apply(e,this)}function o(e){return e[this]}function c(e){var t=+this;return t<0&&(t=Math.max(0,t+e.length)),e[t]}var s,u,d=n(10),l=d.canEvaluate,M=d.isIdentifier,_=function(e){return new Function(\"ensureMethod\",\"                                    \\n\\t        return function(obj) {                                               \\n\\t            'use strict'                                                     \\n\\t            var len = this.length;                                           \\n\\t            ensureMethod(obj, 'methodName');                                 \\n\\t            switch(len) {                                                    \\n\\t                case 1: return obj.methodName(this[0]);                      \\n\\t                case 2: return obj.methodName(this[0], this[1]);             \\n\\t                case 3: return obj.methodName(this[0], this[1], this[2]);    \\n\\t                case 0: return obj.methodName();                             \\n\\t                default:                                                     \\n\\t                    return obj.methodName.apply(obj, this);                  \\n\\t            }                                                                \\n\\t        };                                                                   \\n\\t        \".replace(/methodName/g,e))(t)},f=function(e){return new Function(\"obj\",\"                                             \\n\\t        'use strict';                                                        \\n\\t        return obj.propertyName;                                             \\n\\t        \".replace(\"propertyName\",e))},p=function(e,t,n){var r=n[e];if(\"function\"!=typeof r){if(!M(e))return null;if(r=t(e),n[e]=r,n[\" size\"]++,n[\" size\"]>512){for(var a=Object.keys(n),i=0;i<256;++i)delete n[a[i]];n[\" size\"]=a.length-256}}return r};s=function(e){return p(e,_,a)},u=function(e){return p(e,f,i)},e.prototype.call=function(e){for(var t=arguments.length,n=new Array(Math.max(t-1,0)),a=1;a<t;++a)n[a-1]=arguments[a];if(l){var i=s(e);if(null!==i)return this._then(i,void 0,void 0,n,void 0)}return n.push(e),this._then(r,void 0,void 0,n,void 0)},e.prototype.get=function(e){var t,n=\"number\"==typeof e;if(n)t=c;else if(l){var r=u(e);t=null!==r?r:o}else t=o;return this._then(t,void 0,void 0,e,void 0)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i,o){function c(e){setTimeout(function(){throw e},0)}function s(e){var t=r(e);return t!==e&&\"function\"==typeof e._isDisposable&&\"function\"==typeof e._getDisposer&&e._isDisposable()&&t._setDisposable(e._getDisposer()),t}function u(t,n){function a(){if(o>=u)return d._fulfill();var i=s(t[o++]);if(i instanceof e&&i._isDisposable()){try{i=r(i._getDisposer().tryDispose(n),t.promise)}catch(l){return c(l)}if(i instanceof e)return i._then(a,c,null,null,null)}a()}var o=0,u=t.length,d=new e(i);return a(),d}function d(e,t,n){this._data=e,this._promise=t,this._context=n}function l(e,t,n){this.constructor$(e,t,n)}function M(e){return d.isDisposer(e)?(this.resources[this.index]._setDisposable(e),e.promise()):e}function _(e){this.length=e,this.promise=null,this[e-1]=null}var f=n(10),p=n(16).TypeError,h=n(10).inherits,m=f.errorObj,b=f.tryCatch,L={};d.prototype.data=function(){return this._data},d.prototype.promise=function(){return this._promise},d.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():L},d.prototype.tryDispose=function(e){var t=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=t!==L?this.doDispose(t,e):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},d.isDisposer=function(e){return null!=e&&\"function\"==typeof e.resource&&\"function\"==typeof e.tryDispose},h(l,d),l.prototype.doDispose=function(e,t){var n=this.data();return n.call(e,e,t)},_.prototype._resultCancelled=function(){for(var t=this.length,n=0;n<t;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var n=arguments.length;if(n<2)return t(\"you must pass at least 2 arguments to Promise.using\");var a=arguments[n-1];if(\"function\"!=typeof a)return t(\"expecting a function but got \"+f.classString(a));var i,c=!0;2===n&&Array.isArray(arguments[0])?(i=arguments[0],n=i.length,c=!1):(i=arguments,n--);for(var s=new _(n),l=0;l<n;++l){var p=i[l];if(d.isDisposer(p)){var h=p;p=p.promise(),p._setDisposable(h)}else{var L=r(p);L instanceof e&&(p=L._then(M,null,null,{resources:s,index:l},void 0))}s[l]=p}for(var A=new Array(s.length),l=0;l<A.length;++l)A[l]=e.resolve(s[l]).reflect();var y=e.all(A).then(function(e){for(var t=0;t<e.length;++t){var n=e[t];if(n.isRejected())return m.e=n.error(),m;if(!n.isFulfilled())return void y.cancel();e[t]=n.value()}z._pushContext(),a=b(a);var r=c?a.apply(void 0,e):a(e),i=z._popContext();return o.checkForgottenReturns(r,i,\"Promise.using\",z),r}),z=y.lastly(function(){var t=new e.PromiseInspection(y);return u(s,t)});return s.promise=z,z._setOnCancel(s),z},e.prototype._setDisposable=function(e){this._bitField=131072|this._bitField,this._disposer=e},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=this._bitField&-131073,this._disposer=void 0},e.prototype.disposer=function(e){if(\"function\"==typeof e)return new l(e,this,a());throw new p}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r){function a(e){this.handle=e}function i(e){return clearTimeout(this.handle),e}function o(e){throw clearTimeout(this.handle),e}var c=n(10),s=e.TimeoutError;a.prototype._resultCancelled=function(){clearTimeout(this.handle)};var u=function(e){return d(+this).thenReturn(e)},d=e.delay=function(n,i){var o,c;return void 0!==i?(o=e.resolve(i)._then(u,null,null,n,void 0),r.cancellation()&&i instanceof e&&o._setOnCancel(i)):(o=new e(t),c=setTimeout(function(){o._fulfill()},+n),r.cancellation()&&o._setOnCancel(new a(c)),o._captureStackTrace()),o._setAsyncGuaranteed(),o};e.prototype.delay=function(e){return d(e,this)};var l=function(e,t,n){var r;r=\"string\"!=typeof t?t instanceof Error?t:new s(\"operation timed out\"):new s(t),c.markAsOriginatingFromRejection(r),e._attachExtraTrace(r),e._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(e,t){e=+e;var n,c,s=new a(setTimeout(function(){n.isPending()&&l(n,t,c)},e));return r.cancellation()?(c=this.then(),n=c._then(i,o,void 0,s,void 0),n._setOnCancel(s)):n=this._then(i,o,void 0,s,void 0),n}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i,o){function c(t,n,r){for(var i=0;i<n.length;++i){r._pushContext();var o=_(n[i])(t);if(r._popContext(),o===M){r._pushContext();var c=e.reject(M.e);return r._popContext(),c}var s=a(o,r);if(s instanceof e)return s}return null}function s(t,n,a,i){if(o.cancellation()){var c=new e(r),s=this._finallyPromise=new e(r);this._promise=c.lastly(function(){return s}),c._captureStackTrace(),c._setOnCancel(this)}else{var u=this._promise=new e(r);u._captureStackTrace()}this._stack=i,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers=\"function\"==typeof a?[a].concat(f):f,this._yieldedPromise=null,this._cancellationPhase=!1}var u=n(16),d=u.TypeError,l=n(10),M=l.errorObj,_=l.tryCatch,f=[];l.inherits(s,i),s.prototype._isResolved=function(){return null===this._promise},s.prototype._cleanup=function(){this._promise=this._generator=null,o.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},s.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n=\"undefined\"!=typeof this._generator[\"return\"];if(n)this._promise._pushContext(),t=_(this._generator[\"return\"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError(\"generator .return() sentinel\");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=_(this._generator[\"throw\"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},s.prototype._promiseFulfilled=function(e){this._yieldedPromise=null,this._promise._pushContext();var t=_(this._generator.next).call(this._generator,e);this._promise._popContext(),this._continue(t)},s.prototype._promiseRejected=function(e){this._yieldedPromise=null,this._promise._attachExtraTrace(e),this._promise._pushContext();var t=_(this._generator[\"throw\"]).call(this._generator,e);this._promise._popContext(),this._continue(t)},s.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},s.prototype.promise=function(){return this._promise},s.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},s.prototype._continue=function(t){var n=this._promise;if(t===M)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var i=a(r,this._promise);if(!(i instanceof e)&&(i=c(i,this._yieldHandlers,this._promise),null===i))return void this._promiseRejected(new d(\"A value %s was yielded that could not be treated as a promise\\n\\n    See http://goo.gl/MqrFmX\\n\\n\".replace(\"%s\",String(r))+\"From coroutine:\\n\"+this._stack.split(\"\\n\").slice(1,-7).join(\"\\n\")));i=i._target();var o=i._bitField;0===(50397184&o)?(this._yieldedPromise=i,i._proxy(this,null)):0!==(33554432&o)?e._async.invoke(this._promiseFulfilled,this,i._value()):0!==(16777216&o)?e._async.invoke(this._promiseRejected,this,i._reason()):this._promiseCancelled()},e.coroutine=function(e,t){if(\"function\"!=typeof e)throw new d(\"generatorFunction must be a function\\n\\n    See http://goo.gl/MqrFmX\\n\");var n=Object(t).yieldHandler,r=s,a=(new Error).stack;return function(){var t=e.apply(this,arguments),i=new r((void 0),(void 0),n,a),o=i.promise();return i._generator=t,i._promiseFulfilled(void 0),o}},e.coroutine.addYieldHandler=function(e){if(\"function\"!=typeof e)throw new d(\"expecting a function but got \"+l.classString(e));f.push(e)},e.spawn=function(n){if(o.deprecated(\"Promise.spawn()\",\"Promise.coroutine()\"),\"function\"!=typeof n)return t(\"generatorFunction must be a function\\n\\n    See http://goo.gl/MqrFmX\\n\");var r=new s(n,this),a=r.promise();return r._run(e.spawn),a}}},function(e,t,n){\"use strict\";e.exports=function(e){function t(e,t){var n=this;if(!i.isArray(e))return r.call(n,e,t);var a=c(t).apply(n._boundValue(),[null].concat(e));a===s&&o.throwLater(a.e)}function r(e,t){var n=this,r=n._boundValue(),a=void 0===e?c(t).call(r,null):c(t).call(r,null,e);a===s&&o.throwLater(a.e)}function a(e,t){var n=this;if(!e){var r=new Error(e+\"\");r.cause=e,e=r}var a=c(t).call(n._boundValue(),e);a===s&&o.throwLater(a.e)}var i=n(10),o=e._async,c=i.tryCatch,s=i.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(e,n){if(\"function\"==typeof e){var i=r;void 0!==n&&Object(n).spread&&(i=t),this._then(i,a,void 0,this,e)}return this}}},function(e,t,n){\"use strict\";e.exports=function(e,t){function r(e){return!z.test(e)}function a(e){try{return e.__isPromisified__===!0}catch(t){return!1}}function i(e,t,n){var r=_.getDataPropertyOrDefault(e,t+n,A);return!!r&&a(r)}function o(e,t,n){for(var r=0;r<e.length;r+=2){var a=e[r];if(n.test(a))for(var i=a.replace(n,\"\"),o=0;o<e.length;o+=2)if(e[o]===i)throw new b(\"Cannot promisify an API that has normal methods with '%s'-suffix\\n\\n    See http://goo.gl/MqrFmX\\n\".replace(\"%s\",t))}}function c(e,t,n,r){for(var c=_.inheritedDataKeys(e),s=[],u=0;u<c.length;++u){var d=c[u],l=e[d],M=r===T||T(d,l,e);\"function\"!=typeof l||a(l)||i(e,d,t)||!r(d,l,e,M)||s.push(d,l)}return o(s,t,n),s}function s(n,r,a,i,o,c){function s(){var a=r;r===M&&(a=this);var i=new e(t);i._captureStackTrace();var o=\"string\"==typeof d&&this!==u?this[d]:n,s=f(i,c);try{o.apply(a,p(arguments,s))}catch(l){i._rejectCallback(h(l),!0,!0)}return i._isFateSealed()||i._setAsyncGuaranteed(),i}var u=function(){return this}(),d=n;return\"string\"==typeof d&&(n=i),_.notEnumerableProp(s,\"__isPromisified__\",!0),s}function u(e,t,n,r,a){for(var i=new RegExp(g(t)+\"$\"),o=c(e,t,i,n),s=0,u=o.length;s<u;s+=2){var d=o[s],l=o[s+1],f=d+t;if(r===Y)e[f]=Y(d,M,d,l,t,a);else{var p=r(l,function(){return Y(d,M,d,l,t,a)});_.notEnumerableProp(p,\"__isPromisified__\",!0),e[f]=p}}return _.toFastProperties(e),e}function d(e,t,n){return Y(e,t,void 0,e,null,n)}var l,M={},_=n(10),f=n(23),p=_.withAppended,h=_.maybeWrapAsError,m=_.canEvaluate,b=n(16).TypeError,L=\"Async\",A={__isPromisified__:!0},y=[\"arity\",\"length\",\"name\",\"arguments\",\"caller\",\"callee\",\"prototype\",\"__isPromisified__\"],z=new RegExp(\"^(?:\"+y.join(\"|\")+\")$\"),T=function(e){return _.isIdentifier(e)&&\"_\"!==e.charAt(0)&&\"constructor\"!==e},g=function(e){return e.replace(/([$])/,\"\\\\$\")},v=function(e){for(var t=[e],n=Math.max(0,e-1-3),r=e-1;r>=n;--r)t.push(r);for(var r=e+1;r<=3;++r)t.push(r);return t},O=function(e){return _.filledRange(e,\"_arg\",\"\")},D=function(e){return _.filledRange(Math.max(e,3),\"_arg\",\"\")},k=function(e){return\"number\"==typeof e.length?Math.max(Math.min(e.length,1024),0):0};l=function(n,r,a,i,o,c){function s(e){var t,n=O(e).join(\", \"),a=e>0?\", \":\"\";return t=m?\"ret = callback.call(this, {{args}}, nodeback); break;\\n\":void 0===r?\"ret = callback({{args}}, nodeback); break;\\n\":\"ret = callback.call(receiver, {{args}}, nodeback); break;\\n\",t.replace(\"{{args}}\",n).replace(\", \",a)}function u(){for(var e=\"\",t=0;t<l.length;++t)e+=\"case \"+l[t]+\":\"+s(l[t]);return e+=\"                                                             \\n\\t        default:                                                             \\n\\t            var args = new Array(len + 1);                                   \\n\\t            var i = 0;                                                       \\n\\t            for (var i = 0; i < len; ++i) {                                  \\n\\t               args[i] = arguments[i];                                       \\n\\t            }                                                                \\n\\t            args[i] = nodeback;                                              \\n\\t            [CodeForCall]                                                    \\n\\t            break;                                                           \\n\\t        \".replace(\"[CodeForCall]\",m?\"ret = callback.apply(this, args);\\n\":\"ret = callback.apply(receiver, args);\\n\")}var d=Math.max(0,k(i)-1),l=v(d),m=\"string\"==typeof n||r===M,b=\"string\"==typeof n?\"this != null ? this['\"+n+\"'] : fn\":\"fn\",L=\"'use strict';                                                \\n\\t        var ret = function (Parameters) {                                    \\n\\t            'use strict';                                                    \\n\\t            var len = arguments.length;                                      \\n\\t            var promise = new Promise(INTERNAL);                             \\n\\t            promise._captureStackTrace();                                    \\n\\t            var nodeback = nodebackForPromise(promise, \"+c+\");   \\n\\t            var ret;                                                         \\n\\t            var callback = tryCatch([GetFunctionCode]);                      \\n\\t            switch(len) {                                                    \\n\\t                [CodeForSwitchCase]                                          \\n\\t            }                                                                \\n\\t            if (ret === errorObj) {                                          \\n\\t                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\\n\\t            }                                                                \\n\\t            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \\n\\t            return promise;                                                  \\n\\t        };                                                                   \\n\\t        notEnumerableProp(ret, '__isPromisified__', true);                   \\n\\t        return ret;                                                          \\n\\t    \".replace(\"[CodeForSwitchCase]\",u()).replace(\"[GetFunctionCode]\",b);return L=L.replace(\"Parameters\",D(d)),new Function(\"Promise\",\"fn\",\"receiver\",\"withAppended\",\"maybeWrapAsError\",\"nodebackForPromise\",\"tryCatch\",\"errorObj\",\"notEnumerableProp\",\"INTERNAL\",L)(e,i,r,p,h,f,_.tryCatch,_.errorObj,_.notEnumerableProp,t)};var Y=m?l:s;e.promisify=function(e,t){if(\"function\"!=typeof e)throw new b(\"expecting a function but got \"+_.classString(e));if(a(e))return e;t=Object(t);var n=void 0===t.context?M:t.context,i=!!t.multiArgs,o=d(e,n,i);return _.copyDescriptors(e,o,r),o},e.promisifyAll=function(e,t){if(\"function\"!=typeof e&&\"object\"!=typeof e)throw new b(\"the target of promisifyAll must be an object or a function\\n\\n    See http://goo.gl/MqrFmX\\n\");t=Object(t);var n=!!t.multiArgs,r=t.suffix;\"string\"!=typeof r&&(r=L);var a=t.filter;\"function\"!=typeof a&&(a=T);var i=t.promisifier;if(\"function\"!=typeof i&&(i=Y),!_.isIdentifier(r))throw new RangeError(\"suffix must be a valid identifier\\n\\n    See http://goo.gl/MqrFmX\\n\");for(var o=_.inheritedDataKeys(e),c=0;c<o.length;++c){var s=e[o[c]];\"constructor\"!==o[c]&&_.isClass(s)&&(u(s.prototype,r,a,i,n),u(s,r,a,i,n))}return u(e,r,a,i,n)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a){function i(e){var t,n=!1;if(void 0!==c&&e instanceof c)t=l(e),n=!0;else{var r=d.keys(e),a=r.length;t=new Array(2*a);for(var i=0;i<a;++i){var o=r[i];t[i]=e[o],t[i+a]=o}}this.constructor$(t),this._isMap=n,this._init$(void 0,n?-6:-3)}function o(t){var n,o=r(t);return u(o)?(n=o instanceof e?o._then(e.props,void 0,void 0,void 0,void 0):new i(o).promise(),o instanceof e&&n._propagateFrom(o,2),n):a(\"cannot await properties of a non-object\\n\\n    See http://goo.gl/MqrFmX\\n\")}var c,s=n(10),u=s.isObject,d=n(11);\"function\"==typeof Map&&(c=Map);var l=function(){function e(e,r){this[t]=e,this[t+n]=r,t++}var t=0,n=0;return function(r){n=r.size,t=0;var a=new Array(2*r.size);return r.forEach(e,a),a}}(),M=function(e){for(var t=new c,n=e.length/2|0,r=0;r<n;++r){var a=e[n+r],i=e[r];t.set(a,i)}return t};s.inherits(i,t),i.prototype._init=function(){},i.prototype._promiseFulfilled=function(e,t){this._values[t]=e;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=M(this._values);else{r={};for(var a=this.length(),i=0,o=this.length();i<o;++i)r[this._values[i+a]]=this._values[i]}return this._resolve(r),!0}return!1},i.prototype.shouldCopyValues=function(){return!1},i.prototype.getActualLength=function(e){return e>>1},e.prototype.props=function(){return o(this)},e.props=function(e){return o(e)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a){function i(n,i){var s=r(n);if(s instanceof e)return c(s);if(n=o.asArray(n),null===n)return a(\"expecting an array or an iterable object but got \"+o.classString(n));var u=new e(t);void 0!==i&&u._propagateFrom(i,3);for(var d=u._fulfill,l=u._reject,M=0,_=n.length;M<_;++M){var f=n[M];(void 0!==f||M in n)&&e.cast(f)._then(d,l,void 0,u,null)}return u}var o=n(10),c=function(e){return e.then(function(t){return i(t,e)})};e.race=function(e){return i(e,void 0)},e.prototype.race=function(){return i(this,void 0)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r,a,i,o){function c(t,n,r,a){this.constructor$(t);var o=M();this._fn=null===o?n:_.domainBind(o,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,a===i?this._eachValues=Array(this._length):0===a?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function s(e,t){this.isFulfilled()?t._resolve(e):t._reject(e)}function u(e,t,n,a){if(\"function\"!=typeof t)return r(\"expecting a function but got \"+_.classString(t));var i=new c(e,t,n,a);return i.promise()}function d(t){this.accum=t,this.array._gotAccum(t);var n=a(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(l,void 0,void 0,this,void 0)):l.call(this,n)}function l(t){var n=this.array,r=n._promise,a=f(n._fn);r._pushContext();var i;i=void 0!==n._eachValues?a.call(r._boundValue(),t,this.index,this.length):a.call(r._boundValue(),this.accum,t,this.index,this.length),i instanceof e&&(n._currentCancellable=i);var c=r._popContext();return o.checkForgottenReturns(i,c,void 0!==n._eachValues?\"Promise.each\":\"Promise.reduce\",r),i}var M=e._getDomain,_=n(10),f=_.tryCatch;_.inherits(c,t),c.prototype._gotAccum=function(e){void 0!==this._eachValues&&null!==this._eachValues&&e!==i&&this._eachValues.push(e)},c.prototype._eachComplete=function(e){return null!==this._eachValues&&this._eachValues.push(e),this._eachValues},c.prototype._init=function(){},c.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},c.prototype.shouldCopyValues=function(){return!1},c.prototype._resolve=function(e){this._promise._resolveCallback(e),this._values=null},c.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()));\n},c.prototype._iterate=function(t){this._values=t;var n,r,a=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;r<a;++r){var i={accum:null,value:t[r],index:r,length:a,array:this};n=n._then(d,void 0,void 0,i,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(s,s,void 0,n,this)},e.prototype.reduce=function(e,t){return u(this,e,t,null)},e.reduce=function(e,t,n,r){return u(e,t,n,r)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r){function a(e){this.constructor$(e)}var i=e.PromiseInspection,o=n(10);o.inherits(a,t),a.prototype._promiseResolved=function(e,t){this._values[e]=t;var n=++this._totalResolved;return n>=this._length&&(this._resolve(this._values),!0)},a.prototype._promiseFulfilled=function(e,t){var n=new i;return n._bitField=33554432,n._settledValueField=e,this._promiseResolved(t,n)},a.prototype._promiseRejected=function(e,t){var n=new i;return n._bitField=16777216,n._settledValueField=e,this._promiseResolved(t,n)},e.settle=function(e){return r.deprecated(\".settle()\",\".reflect()\"),new a(e).promise()},e.prototype.settle=function(){return e.settle(this)}}},function(e,t,n){\"use strict\";e.exports=function(e,t,r){function a(e){this.constructor$(e),this._howMany=0,this._unwrap=!1,this._initialized=!1}function i(e,t){if((0|t)!==t||t<0)return r(\"expecting a positive integer\\n\\n    See http://goo.gl/MqrFmX\\n\");var n=new a(e),i=n.promise();return n.setHowMany(t),n.init(),i}var o=n(10),c=n(16).RangeError,s=n(16).AggregateError,u=o.isArray,d={};o.inherits(a,t),a.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var e=u(this._values);!this._isResolved()&&e&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},a.prototype.init=function(){this._initialized=!0,this._init()},a.prototype.setUnwrap=function(){this._unwrap=!0},a.prototype.howMany=function(){return this._howMany},a.prototype.setHowMany=function(e){this._howMany=e},a.prototype._promiseFulfilled=function(e){return this._addFulfilled(e),this._fulfilled()===this.howMany()&&(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0)},a.prototype._promiseRejected=function(e){return this._addRejected(e),this._checkOutcome()},a.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(d),this._checkOutcome())},a.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var e=new s,t=this.length();t<this._values.length;++t)this._values[t]!==d&&e.push(this._values[t]);return e.length>0?this._reject(e):this._cancel(),!0}return!1},a.prototype._fulfilled=function(){return this._totalResolved},a.prototype._rejected=function(){return this._values.length-this.length()},a.prototype._addRejected=function(e){this._values.push(e)},a.prototype._addFulfilled=function(e){this._values[this._totalResolved++]=e},a.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},a.prototype._getRangeError=function(e){var t=\"Input array must contain at least \"+this._howMany+\" items but contains only \"+e+\" items\";return new c(t)},a.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(e,t){return i(e,t)},e.prototype.some=function(e){return i(this,e)},e._SomePromiseArray=a}},function(e,t){\"use strict\";e.exports=function(e,t){var n=e.map;e.prototype.filter=function(e,r){return n(this,e,r,t)},e.filter=function(e,r,a){return n(e,r,a,t)}}},function(e,t){\"use strict\";e.exports=function(e,t){function n(){return i(this)}function r(e,n){return a(e,n,t,t)}var a=e.reduce,i=e.all;e.prototype.each=function(e){return a(this,e,t,0)._then(n,void 0,void 0,this,void 0)},e.prototype.mapSeries=function(e){return a(this,e,t,t)},e.each=function(e,r){return a(e,r,t,0)._then(n,void 0,void 0,e,void 0)},e.mapSeries=r}},function(e,t){\"use strict\";e.exports=function(e){function t(e){var t=new n(e),r=t.promise();return t.setHowMany(1),t.setUnwrap(),t.init(),r}var n=e._SomePromiseArray;e.any=function(e){return t(e)},e.prototype.any=function(){return t(this)}}},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e,t){if(!(e instanceof t))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(t,\"__esModule\",{value:!0});var i=function(){function e(e,t){var n=[],r=!0,a=!1,i=void 0;try{for(var o,c=e[Symbol.iterator]();!(r=(o=c.next()).done)&&(n.push(o.value),!t||n.length!==t);r=!0);}catch(s){a=!0,i=s}finally{try{!r&&c[\"return\"]&&c[\"return\"]()}finally{if(a)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(46),u=r(s),d=n(48),l=n(49),M=n(56),_=r(M),f=n(176),p=n(177),h=r(p),m=n(182),b=n(180),L=n(178),A=n(183),y=n(179),z=n(184),T=n(185),g=function(){function e(t,n,r){var i=this;a(this,e),this.doc=t,this.debug=r.debug||!1,this.data=n,this.dpi=r.dpi,this.margins=r.margins,this.font=\"Helvetica\",this.boldFont=\"Helvetica-Bold\",this.bgAxisFontSize=5,this.carbsFontSize=5.5,this.defaultFontSize=r.defaultFontSize,this.footerFontSize=r.footerFontSize,this.headerFontSize=r.headerFontSize,this.summaryHeaderFontSize=r.summaryHeaderFontSize,this.bgPrefs=r.bgPrefs,this.bgUnits=r.bgPrefs.bgUnits,this.bgBounds=r.bgPrefs.bgBounds,this.timePrefs=r.timePrefs,this.timezone=(0,A.getTimezoneFromTimePrefs)(r.timePrefs),this.width=r.width,this.height=r.height,this.chartsPerPage=r.chartsPerPage,this.numDays=r.numDays,this.patient=r.patient,this.patientInfoBox={width:0,height:0},this.bolusWidth=3,this.carbRadius=4.25,this.cbgRadius=1,this.extendedLineThickness=.75,this.interruptedLineThickness=.5,this.smbgRadius=3,this.triangleHeight=1.25;var c=\"#B2B2B2\";this.colors={axes:\"#858585\",bolus:{delivered:\"black\",extendedPath:\"black\",extendedExpectationPath:c,extendedTriangle:\"black\",extendedTriangleInterrupted:c,interrupted:\"white\",overrideTriangle:\"white\",programmed:\"black\",undelivered:c,underride:c,underrideTriangle:\"white\"},carbs:\"#CFCFCF\",lightDividers:\"#D8D8D8\",low:\"#FF8B7C\",target:\"#76D3A6\",basal:\"#19A0D7\",high:\"#BB9AE7\"},this.rightEdge=this.margins.left+this.width,this.bottomEdge=this.margins.top+this.height,this.gapBtwnSummaryAndChartAsPercentage=.04,this.chartArea={bottomEdge:r.margins.top+r.height,leftEdge:r.margins.left+(r.summaryWidthAsPercentage+this.gapBtwnSummaryAndChartAsPercentage)*this.width,topEdge:r.margins.top},this.chartArea.width=this.rightEdge-this.chartArea.leftEdge,this.initialChartArea=u[\"default\"].clone(this.chartArea),this.summaryArea={rightEdge:r.margins.left+r.summaryWidthAsPercentage*this.width},this.summaryArea.width=this.summaryArea.rightEdge-this.margins.left;var s=u[\"default\"].keys(n.dataByDate);this.chartsByDate={},this.initialChartsByDate={},u[\"default\"].each(s,function(e){var t=n.dataByDate[e];i.chartsByDate[e]=o({},t),i.initialChartsByDate[e]=o({},t)}),this.startingPageIndex=r.startingPageIndex||0,this.totalPages=this.initialTotalPages=0,this.chartsPlaced=this.initialChartsPlaced=0,this.chartIndex=this.initialChartIndex=0,this.setHeaderSize().setFooterSize().calculateChartMinimums(this.chartArea),this.newPage=this.newPage.bind(this),this.doc.on(\"pageAdded\",this.newPage);for(var d=0;d<this.numDays;++d){var l=n.dataByDate[s[d]];this.calculateDateChartHeight(l)}for(;this.chartsPlaced<this.numDays;)this.placeChartsOnPage(this.totalPages);u[\"default\"].each(this.chartsByDate,function(e){i.makeScales(e)})}return c(e,[{key:\"calculateChartMinimums\",value:function(e){this.doc.fontSize(10);var t=e.topEdge,n=e.bottomEdge,r=n-t,a=r/3.25;return this.chartMinimums={notesEtc:.15*a,bgEtcChart:.45*a,bolusDetails:.2*a,basalChart:.15*a,belowBasal:.05*a,paddingBelow:r*(1/13)/3,total:a},this}},{key:\"calculateDateChartHeight\",value:function(e){var t=e.data,n=e.date;this.doc.fontSize(this.defaultFontSize);var r=1.25*this.doc.currentLineHeight(),a=u[\"default\"].groupBy(t.bolus,function(e){var t=(0,L.getBolusFromInsulinEvent)(e);return t.threeHrBin}),i=u[\"default\"].max(u[\"default\"].map(u[\"default\"].keys(a),function(e){var t=u[\"default\"].reduce(a[e],function(e,t){var n=(0,L.getBolusFromInsulinEvent)(t);return n.extended||n.expectedExtended?e+2:e+1},0);return t})),o=this.chartMinimums,c=o.notesEtc,s=o.bgEtcChart,d=o.basalChart,l=o.belowBasal,M=o.total,_=r*i,f=_+c+s+d+l,p=this.chartMinimums.bolusDetails;return this.chartsByDate[n].bolusDetailsHeight=u[\"default\"].max([p,_]),this.chartsByDate[n].chartHeight=u[\"default\"].max([M,f]),this}},{key:\"makeScales\",value:function(e){var t=this.chartMinimums,n=t.notesEtc,r=t.bgEtcChart,a=t.basalChart,i=t.belowBasal;return e.bgScale=(0,l.scaleLinear)().domain([0,u[\"default\"].min([this.bgBounds.veryHighThreshold,this.data.bgRange[1]])]).range([e.topEdge+n+r+this.cbgRadius,e.topEdge+n-this.cbgRadius]),e.bolusScale=(0,l.scaleLinear)().domain([0,this.data.bolusRange[1]]).range([e.topEdge+n+r,e.topEdge+n+r/3]),e.basalScale=(0,l.scaleLinear)().domain([0,this.data.basalRange[1]]).range([e.bottomEdge-i,e.bottomEdge-i-a]),e.xScale=(0,l.scaleLinear)().domain([e.bounds[0],e.bounds[1]]).range([this.chartArea.leftEdge+this.cbgRadius,this.rightEdge-this.cbgRadius]),this}},{key:\"newPage\",value:function(){this.debug&&this.renderDebugGrid(),this.renderHeader().renderFooter()}},{key:\"placeChartsOnPage\",value:function(e){this.doc.addPage();for(var t=this.chartArea,n=t.topEdge,r=t.bottomEdge,a=0,i=u[\"default\"].keys(this.chartsByDate),o=this.chartIndex,c=0,s=u[\"default\"].min([i.length,o+this.chartsPerPage]),d=o;d<s;++d){var l=this.chartsByDate[i[d]].chartHeight,M=a+l+this.chartMinimums.paddingBelow;if(M>r-n){this.chartIndex=d;break}this.chartIndex=d+1,a+=l+this.chartMinimums.paddingBelow,c+=1,this.chartsPlaced+=1}for(var _=o;_<o+c;++_){var f=this.chartsByDate[i[_]];f.page=e,_===o?(f.topEdge=this.chartArea.topEdge,f.bottomEdge=this.chartArea.topEdge+f.chartHeight):(f.topEdge=this.chartsByDate[i[_-1]].bottomEdge+this.chartMinimums.paddingBelow,f.bottomEdge=f.topEdge+f.chartHeight),this.debug&&this.doc.fillColor(\"blue\",.1).rect(this.chartArea.leftEdge,f.topEdge,this.chartArea.width,f.chartHeight).fill()}return this.totalPages+=1,this}},{key:\"renderEventPath\",value:function(e){\"programmed\"===e.type?this.doc.path(e.d).lineWidth(.5).dash(.5,{space:1}).stroke(this.colors.bolus[e.type]):this.doc.path(e.d).fill(this.colors.bolus[e.type])}},{key:\"render\",value:function(){var e=this;u[\"default\"].each(u[\"default\"].uniq(u[\"default\"].pluck(this.chartsByDate,\"page\")),function(t){e.doc.switchToPage(t),e.renderPageNumber(t+1)}),u[\"default\"].each(this.chartsByDate,function(t){e.doc.switchToPage(t.page),e.renderSummary(t).renderXAxes(t).renderYAxes(t).renderCbgs(t).renderSmbgs(t).renderInsulinEvents(t).renderBolusDetails(t).renderBasalPaths(t)})}},{key:\"renderPageNumber\",value:function(e){this.doc.fontSize(this.defaultFontSize);var t=this.bottomEdge-1.5*this.doc.currentLineHeight();this.doc.text(\"page \"+e+\" of \"+this.totalPages,this.margins.left,t,{align:\"right\"})}},{key:\"renderPatientInfo\",value:function(){var e=(0,z.getPatientFullName)(this.patient),t=(0,A.formatBirthdate)(this.patient),n=this.margins.left,r=this.margins.top;this.doc.lineWidth(1).fontSize(10).text(e,n,r,{lineGap:2});var a=this.patientInfoBox.width=this.doc.widthOfString(e);this.doc.fontSize(10).text(t);var i=this.doc.widthOfString(t);this.patientInfoBox.height=this.doc.y,a<i&&(this.patientInfoBox.width=i);var o=10;this.doc.moveTo(this.margins.left+this.patientInfoBox.width+o,this.margins.top).lineTo(this.margins.left+this.patientInfoBox.width+o,this.patientInfoBox.height).stroke(\"black\"),this.dividerWidth=2*o+1}},{key:\"renderTitle\",value:function(){var e=\"Daily View\",t=this.doc.fontSize(14).currentLineHeight(),n=this.margins.left+this.patientInfoBox.width+21,r=this.margins.top+((this.patientInfoBox.height-this.margins.top)/2-t/2);this.doc.text(e,n,r),this.titleWidth=this.doc.widthOfString(e)}},{key:\"renderPrintDate\",value:function(){var e=this.doc.fontSize(14).currentLineHeight(),t=this.doc.page.width-u[\"default\"].reduce([this.patientInfoBox.width,this.dividerWidth,this.titleWidth,this.logoWidth,this.margins.left,this.margins.right],function(e,t){return e+t},0),n=this.margins.left+this.patientInfoBox.width+this.dividerWidth+this.titleWidth,r=this.margins.top+((this.patientInfoBox.height-this.margins.top)/2-e/2);this.doc.fontSize(10).text(\"Printed from Tidepool: \"+(0,A.formatCurrentDate)(),n,r+4,{width:t,align:\"center\"})}},{key:\"renderLogo\",value:function(){this.logoWidth=100;var e=this.doc.page.width-this.logoWidth-this.margins.right,t=this.margins.top+6;this.doc.image(T,e,t,{width:this.logoWidth})}},{key:\"renderSummary\",value:function(e){var t=e.data,n=e.date,r=e.topEdge,a=this.margins.left+4,i=8,o=this.summaryArea.width-i,c=!0,s=(0,m.getTotalBasal)(t.basal),l=(0,L.getTotalBolus)(t.bolus),M=s+l;this.doc.fillColor(\"black\").fillOpacity(1).font(this.boldFont).fontSize(this.summaryHeaderFontSize).text((0,_[\"default\"])(n,\"YYYY-MM-DD\").format(\"dddd M/D\"),this.margins.left,r);var f=function(e){var t=r+1.5*e.currentLineHeight();return{current:function(){return t},small:function(){return t+=.75*e.currentLineHeight()},update:function(){return t+=1.25*e.currentLineHeight()}}}(this.doc);if(this.doc.moveTo(this.margins.left,f.current()).lineTo(this.summaryArea.rightEdge,f.current()).lineWidth(.5).stroke(this.colors.lightDividers),!u[\"default\"].isEmpty(t.cbg)){c=!1,this.doc.fontSize(this.defaultFontSize).lineGap(.25*this.doc.currentLineHeight()).text(\"Time in Target\",a,f.update()),f.update();var p=this.bgBounds,h=p.targetUpperBound,A=p.targetLowerBound,z=p.veryLowThreshold,T=(0,b.calcBgPercentInCategories)(t.cbg,this.bgBounds);this.doc.font(this.font).text(A+\" - \"+h,{indent:i,continued:!0,width:o}).text(\"\"+(0,y.formatPercentage)(T.target),{align:\"right\"}),f.update(),this.doc.text(\"Below \"+z,{indent:i,continued:!0,width:o}).text(\"\"+(0,y.formatPercentage)(T.veryLow),{align:\"right\"}),f.update()}if(!u[\"default\"].isEmpty(t.basal)){c?c=!1:this.doc.moveTo(this.margins.left,f.update()).lineTo(this.summaryArea.rightEdge,f.current()).stroke(this.colors.lightDividers),this.doc.fontSize(this.defaultFontSize).font(this.boldFont).text(\"Basal:Bolus Ratio\",a,f.update()),f.update();var g=(0,y.formatPercentage)(s/M),v=(0,y.formatPercentage)(l/M);this.doc.font(this.font).text(\"Basal\",{indent:i,continued:!0,width:o}).text(g+\", ~\"+(0,y.formatDecimalNumber)(s,0)+\" U\",{align:\"right\"}),f.update(),this.doc.font(this.font).text(\"Bolus\",{indent:i,continued:!0,width:o}).text(v+\", ~\"+(0,y.formatDecimalNumber)(l,0)+\" U\",{align:\"right\"}),f.update()}return u[\"default\"].isEmpty(t.cbg)?u[\"default\"].isEmpty(t.smbg)||(c?c=!1:this.doc.moveTo(this.margins.left,f.update()).lineTo(this.summaryArea.rightEdge,f.current()).stroke(this.colors.lightDividers),this.doc.fontSize(this.defaultFontSize).font(this.boldFont).text(\"Average BG\",a,f.update(),{continued:!0,width:o}).font(this.font).text((0,y.formatDecimalNumber)((0,d.mean)(t.smbg,function(e){return e.value}),0)+\" \"+this.bgUnits,{align:\"right\"}),f.small()):(c?c=!1:this.doc.moveTo(this.margins.left,f.update()).lineTo(this.summaryArea.rightEdge,f.current()).stroke(this.colors.lightDividers),this.doc.fontSize(this.defaultFontSize).font(this.boldFont).text(\"Average BG\",a,f.update(),{continued:!0,width:o}).font(this.font).text((0,y.formatDecimalNumber)((0,d.mean)(t.cbg,function(e){return e.value}),0)+\" \"+this.bgUnits,{align:\"right\"}),f.small()),u[\"default\"].isEmpty(t.basal)||(c?c=!1:this.doc.moveTo(this.margins.left,f.update()).lineTo(this.summaryArea.rightEdge,f.current()).stroke(this.colors.lightDividers),this.doc.fontSize(this.defaultFontSize).font(this.boldFont).text(\"Total Insulin\",a,f.update(),{continued:!0,width:o}).font(this.font).text((0,y.formatDecimalNumber)(M,0)+\" U\",{align:\"right\"}),f.small()),u[\"default\"].isEmpty(t.bolus)||(c?c=!1:this.doc.moveTo(this.margins.left,f.update()).lineTo(this.summaryArea.rightEdge,f.current()).stroke(this.colors.lightDividers),this.doc.fontSize(this.defaultFontSize).font(this.boldFont).text(\"Total Carbs\",a,f.update(),{continued:!0,width:o}).font(this.font).text((0,y.formatDecimalNumber)((0,L.getTotalCarbs)(t.bolus),0)+\" g\",{align:\"right\"})),this}},{key:\"renderXAxes\",value:function(e){var t=e.bolusDetailsHeight,n=e.topEdge,r=this.chartMinimums,a=r.notesEtc,i=r.bgEtcChart,o=r.basalChart;this.doc.lineWidth(.25);var c=n+a+i;this.doc.moveTo(this.chartArea.leftEdge,c).lineTo(this.rightEdge,c).stroke(this.colors.axes);var s=c+t;this.doc.moveTo(this.chartArea.leftEdge,s).lineTo(this.rightEdge,s).stroke(this.colors.axes);var u=s+o;return this.doc.moveTo(this.chartArea.leftEdge,u).lineTo(this.rightEdge,u).stroke(this.colors.axes),this}},{key:\"renderYAxes\",value:function(e){for(var t=this,n=e.bgScale,r=e.bottomEdge,a=e.bounds,i=e.date,o=e.topEdge,c=e.xScale,s=a[1],d=a[0],l=[d];d<s;)d=_[\"default\"].utc(d).add(3,\"h\").valueOf(),l.push(d);var M=this.chartsByDate[i];M.bolusDetailPositions=Array(8),M.bolusDetailWidths=Array(8),u[\"default\"].each(l,function(e,n){var a=c(e);0===n&&(a=t.chartArea.leftEdge),8===n&&(a=t.rightEdge),n>0&&(M.bolusDetailWidths[n-1]=a-M.bolusDetailPositions[n-1]),n<8&&(M.bolusDetailPositions[n]=a,t.doc.font(t.font).fontSize(t.defaultFontSize).text((0,A.formatLocalizedFromUTC)(e,t.timePrefs,\"ha\").slice(0,-1),a,o,{indent:3})),t.doc.moveTo(a,o).lineTo(a,r).lineWidth(.25).stroke(t.colors.axes)});var f={align:\"right\",width:this.chartArea.leftEdge-this.summaryArea.rightEdge-3};return u[\"default\"].each(this.bgBounds,function(e){t.doc.font(t.font).fontSize(t.bgAxisFontSize).fillColor(t.colors.axis).text(\"\"+e,t.summaryArea.rightEdge,n(e)-t.doc.currentLineHeight()/2,f)}),this}},{key:\"renderCbgs\",value:function(e){var t=this,n=e.bgScale,r=e.data.cbg,a=e.xScale;return u[\"default\"].each(r,function(e){t.doc.circle(a(e.utc),n(e.value),1).fill(t.colors[(0,b.classifyBgValue)(t.bgBounds,e.value)])}),this}},{key:\"renderSmbgs\",value:function(e){var t=this,n=e.bgScale,r=e.data.smbg,a=e.xScale;return u[\"default\"].each(r,function(e){var r=a(e.utc),i=n(e.value),o=(0,y.formatBgValue)(e.value,t.bgPrefs),c=t.doc.widthOfString(o),s=c/2,u=r-s,d=u+c;t.doc.circle(r,i,t.smbgRadius).fill(t.colors[(0,b.classifyBgValue)(t.bgBounds,e.value)]),u<=t.chartArea.leftEdge&&(u=u+(t.chartArea.leftEdge-u)+1),d>=t.rightEdge&&(u=u-(d-t.rightEdge)-1),t.doc.font(t.boldFont).fontSize(t.defaultFontSize).fillColor(\"black\").text(o,u,i-12.5,{lineBreak:!1})}),this}},{key:\"renderInsulinEvents\",value:function(e){var t=this,n=e.bolusScale,r=e.data.bolus,a=e.xScale;return u[\"default\"].each(r,function(e){var r=(0,h[\"default\"])(e,a,n,{bolusWidth:t.bolusWidth,extendedLineThickness:t.extendedLineThickness,interruptedLineThickness:t.interruptedLineThickness,triangleHeight:t.triangleHeight});u[\"default\"].each(r,function(e){t.renderEventPath(e)});var i=(0,L.getCarbs)(e),o=1,c=1.75;if(i){var s=a((0,L.getBolusFromInsulinEvent)(e).utc),d=n((0,L.getMaxValue)(e))-t.carbRadius-o;t.doc.circle(s,d,t.carbRadius).fill(t.colors.carbs),t.doc.font(t.font).fontSize(t.carbsFontSize).fillColor(\"black\").text(i,s-t.carbRadius,d-c,{align:\"center\",width:2*t.carbRadius})}}),this}},{key:\"renderBolusDetails\",value:function(e){var t=this,n=e.bolusDetailPositions,r=e.bolusDetailWidths,a=e.bolusScale,i=e.data.bolus;this.doc.font(this.font).fontSize(this.defaultFontSize).fillColor(\"black\");var o=a.range()[0]+2,c=u[\"default\"].groupBy(u[\"default\"].map(i,function(e){return(0,L.getBolusFromInsulinEvent)(e)}),function(e){return e.threeHrBin/3});return u[\"default\"].each(c,function(e,a){var i=r[a]-2,c=n[a],s=function(e){var t=o;return{current:function(){return t},update:function(){return t+=1.2*e.currentLineHeight()}}}(t.doc);u[\"default\"].each(u[\"default\"].sortBy(e,\"utc\"),function(e){var n=(0,A.formatLocalizedFromUTC)(e.utc,t.timePrefs,\"h:mma\").slice(0,-1);if(t.doc.text(n,c,s.current(),{continued:!0,indent:2,width:i}).text((0,y.removeTrailingZeroes)((0,y.formatDecimalNumber)((0,L.getDelivered)(e),2)),{align:\"right\"}),null!=e.extended){var r=(0,L.getNormalPercentage)(e),a=(0,L.getExtendedPercentage)(e),o=\"\"+(0,A.formatDuration)((0,L.getMaxDuration)(e)),u=Number.isNaN(r)?\"over \"+o:a+\" \"+o;t.doc.text(u,c,s.update(),{indent:2,width:i})}s.update()})}),this}},{key:\"renderBasalPaths\",value:function(e){var t=this,n=e.basalScale,r=e.data,a=r.basal,i=r.basalSequences,o=e.xScale;u[\"default\"].each(i,function(e){if(u[\"default\"].filter(e).length){var r=(0,f.getBasalSequencePaths)(e,o,n);u[\"default\"].each(r,function(e){var n=\"scheduled\"===e.basalType?.4:.2;\"fill\"===e.renderType?t.doc.path(e.d).fillColor(t.colors.basal).fillOpacity(n).fill():\"stroke\"===e.renderType&&t.doc.path(e.d).lineWidth(.5).dash(1,{space:2}).stroke(t.colors.basal)})}});var c=(0,f.calculateBasalPath)(a,o,n,{endAtZero:!1,flushBottomOffset:-.25,isFilled:!1,startAtZero:!1});return this.doc.path(c).lineWidth(.5).undash().stroke(this.colors.basal),this}},{key:\"renderDebugGrid\",value:function(){for(var e=\"#B8B8B8\",t=5,n=this.margins.top;n<=this.bottomEdge;){if(this.doc.moveTo(this.margins.left,n).lineTo(this.rightEdge,n).lineWidth(.25).stroke(\"red\"),n!==this.bottomEdge)for(var r=1;r<t+1;++r){var a=n+this.dpi*(r/(t+1));this.doc.moveTo(this.margins.left,a).lineTo(this.rightEdge,a).lineWidth(.05).stroke(e)}n+=this.dpi}for(var i=this.margins.left;i<=this.rightEdge;){this.doc.moveTo(i,this.margins.top).lineTo(i,this.bottomEdge).lineWidth(.25).stroke(\"red\");for(var o=1;o<t+1;++o){var c=i+this.dpi*(o/(t+1));c<=this.rightEdge&&this.doc.moveTo(c,this.margins.top).lineTo(c,this.bottomEdge).lineWidth(.05).stroke(e)}i+=this.dpi}return this}},{key:\"renderHeader\",value:function(){this.renderPatientInfo(),this.renderTitle(),this.renderLogo(),this.renderPrintDate(),this.doc.moveDown();var e=this.doc.fontSize(14).currentLineHeight(),t=2.25*e+this.margins.top;return this.doc.moveTo(this.margins.left,t).lineTo(this.margins.left+this.width,t).stroke(\"black\"),this.debug&&this.doc.fillColor(\"#E8E8E8\",.3333333333).rect(this.margins.left,this.margins.top,this.width,4*e).fill(),this}},{key:\"renderFooter\",value:function(){var e=this;this.doc.fontSize(9);var t=this.doc.currentLineHeight();this.doc.fillColor(\"black\").fillOpacity(1).text(\"Legend\",this.margins.left,this.bottomEdge-8*t);var n=4*t,r=this.bottomEdge-6*t;this.doc.lineWidth(1).rect(this.margins.left,r,this.width,n).stroke(\"black\"),this.doc.fontSize(this.defaultFontSize);var a=r+2*t,o=a-this.doc.currentLineHeight()/2,c=9,s=6,M=this.margins.left+c;u[\"default\"].each(u[\"default\"].map((0,d.range)(0,16,2),function(e){return[e,e-8]}),function(t){var n=i(t,2),r=n[0],o=n[1],c=void 0;c=r<4?\"high\":r<12?\"target\":\"low\",e.doc.circle(M+r,a+o,e.cbgRadius).fill(e.colors[c])}),M+=16+s,this.doc.fillColor(\"black\").text(\"CGM\",M,o),M+=this.doc.widthOfString(\"CGM\")+2*c;var _={target:[M,a],high:[M+2*this.smbgRadius,a-2*this.smbgRadius],low:[M+2*this.smbgRadius,a+2*this.smbgRadius]};this.doc.circle(M,a,this.smbgRadius).fill(this.colors.target),this.doc.circle(_.high[0],_.high[1],this.smbgRadius).fill(this.colors.high),this.doc.circle(_.low[0],_.low[1],this.smbgRadius).fill(this.colors.low),M+=3*this.smbgRadius+s,this.doc.fillColor(\"black\").text(\"BGM\",M,o),M+=this.doc.widthOfString(\"BGM\")+2*c;var f={bolusWidth:this.bolusWidth,extendedLineThickness:this.extendedLineThickness,interruptedLineThickness:this.interruptedLineThickness,triangleHeight:this.triangleHeight},p=(0,l.scaleLinear)().domain([0,10]).range([r+n-n/4,r+n/4]),m=(0,l.scaleLinear)().domain([0,10]).range([M,M+10]),b=(0,h[\"default\"])({normal:10,utc:0},m,p,f);u[\"default\"].each(b,function(t){e.renderEventPath(t)}),M+=this.bolusWidth+s,this.doc.fillColor(\"black\").text(\"Bolus\",M,o),M+=this.doc.widthOfString(\"Bolus\")+2*c;var L=(0,l.scaleLinear)().domain([0,10]).range([M,M+10]),A=(0,h[\"default\"])({type:\"wizard\",recommended:{net:8,carb:8,correction:0},bolus:{normal:10,utc:0}},L,p,f);u[\"default\"].each(A,function(t){e.renderEventPath(t)});var y=(0,h[\"default\"])({type:\"wizard\",recommended:{net:10,carb:8,correction:2},bolus:{normal:5,utc:5}},L,p,f);u[\"default\"].each(y,function(t){e.renderEventPath(t)}),M+=3*this.bolusWidth+s,this.doc.fillColor(\"black\").text(\"Override up & down\",M,o),M+=this.doc.widthOfString(\"Override up & down\")+2*c;var z=(0,l.scaleLinear)().domain([0,10]).range([M,M+10]),T=(0,h[\"default\"])({normal:6,expectedNormal:10,utc:0},z,p,f);u[\"default\"].each(T,function(t){e.renderEventPath(t)}),M+=this.bolusWidth+s,this.doc.fillColor(\"black\").text(\"Interrupted\",M,o),M+=this.doc.widthOfString(\"Interrupted\")+2*c;var g=(0,l.scaleLinear)().domain([0,10]).range([M,M+10]),v=(0,h[\"default\"])({normal:5,extended:5,duration:10,utc:0},g,p,f);u[\"default\"].each(v,function(t){e.renderEventPath(t)}),M+=this.bolusWidth/2+10+s,this.doc.fillColor(\"black\").text(\"Combo\",M,o),M+=this.doc.widthOfString(\"Combo\")+2*c,this.doc.circle(M,a,this.carbRadius).fill(this.colors.carbs),this.doc.fillColor(\"black\").fontSize(this.carbsFontSize).text(\"25\",M-this.carbRadius,a-this.carbRadius/2,{align:\"center\",width:2*this.carbRadius}),this.doc.fontSize(this.defaultFontSize),M+=this.carbRadius+s,this.doc.fillColor(\"black\").text(\"Carbs\",M,o),M+=this.doc.widthOfString(\"Carbs\")+2*c;var O=(0,l.scaleLinear)().domain([0,2]).range([r+n-n/4,r+n/4]),D=(0,l.scaleLinear)().domain([0,10]).range([M,M+50]),k={subType:\"scheduled\",rate:1.5,duration:2,utc:0},Y={subType:\"temp\",rate:.5,duration:2.5,utc:2,suppressed:{rate:1.5}},S={subType:\"scheduled\",rate:1.75,duration:1.5,utc:4.5},N={subType:\"temp\",rate:2,duration:2,utc:6,suppressed:{rate:1.75}},w={subType:\"suspend\",rate:0,duration:2,utc:8,suppressed:{rate:1.75}},W={basal:[k,Y,S,N,w],basalSequences:[[k],[Y],[S],[N],[w]]};return this.renderBasalPaths({basalScale:O,data:W,xScale:D}),M+=50+s,this.doc.fillColor(\"black\").text(\"Basals\",M,o),this.debug&&this.doc.fillColor(\"#E8E8E8\",.3333333333).rect(this.margins.left,this.bottomEdge-9*t,this.width,9*t).fill(),this}},{key:\"setFooterSize\",value:function(){this.doc.fontSize(this.footerFontSize);var e=this.doc.currentLineHeight();return this.chartArea.bottomEdge=this.chartArea.bottomEdge-9*e,this}},{key:\"setHeaderSize\",value:function(){this.doc.fontSize(this.headerFontSize);var e=this.doc.currentLineHeight();return this.chartArea.topEdge=this.chartArea.topEdge+4*e,this}}]),e}(),v=g;t[\"default\"]=v,function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(g,\"DailyPrintView\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/DailyPrintView.js\"),__REACT_HOT_LOADER__.register(v,\"default\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/print/DailyPrintView.js\"))}()},function(e,t,n){var r;(function(e,a){(function(){function i(e,t){if(e!==t){var n=null===e,r=e===D,a=e===e,i=null===t,o=t===D,c=t===t;if(e>t&&!i||!a||n&&!o&&c||r&&c)return 1;if(e<t&&!n||!c||i&&!r&&a||o&&a)return-1}return 0}function o(e,t,n){for(var r=e.length,a=n?r:-1;n?a--:++a<r;)if(t(e[a],a,e))return a;return-1}function c(e,t,n){if(t!==t)return b(e,n);for(var r=n-1,a=e.length;++r<a;)if(e[r]===t)return r;return-1}function s(e){return\"function\"==typeof e||!1}function u(e){return null==e?\"\":e+\"\"}function d(e,t){for(var n=-1,r=e.length;++n<r&&t.indexOf(e.charAt(n))>-1;);return n}function l(e,t){for(var n=e.length;n--&&t.indexOf(e.charAt(n))>-1;);return n}function M(e,t){return i(e.criteria,t.criteria)||e.index-t.index}function _(e,t,n){for(var r=-1,a=e.criteria,o=t.criteria,c=a.length,s=n.length;++r<c;){var u=i(a[r],o[r]);if(u){if(r>=s)return u;var d=n[r];return u*(\"asc\"===d||d===!0?1:-1)}}return e.index-t.index}function f(e){return Ie[e]}function p(e){return Ge[e]}function h(e,t,n){return t?e=Ke[e]:n&&(e=Qe[e]),\"\\\\\"+e}function m(e){return\"\\\\\"+Qe[e]}function b(e,t,n){for(var r=e.length,a=t+(n?0:-1);n?a--:++a<r;){var i=e[a];if(i!==i)return a}return-1}function L(e){return!!e&&\"object\"==typeof e}function A(e){return e<=160&&e>=9&&e<=13||32==e||160==e||5760==e||6158==e||e>=8192&&(e<=8202||8232==e||8233==e||8239==e||8287==e||12288==e||65279==e)}function y(e,t){for(var n=-1,r=e.length,a=-1,i=[];++n<r;)e[n]===t&&(e[n]=I,i[++a]=n);return i}function z(e,t){for(var n,r=-1,a=e.length,i=-1,o=[];++r<a;){var c=e[r],s=t?t(c,r,e):c;r&&n===s||(n=s,o[++i]=c)}return o}function T(e){for(var t=-1,n=e.length;++t<n&&A(e.charCodeAt(t)););return t}function g(e){for(var t=e.length;t--&&A(e.charCodeAt(t)););return t}function v(e){return Je[e]}function O(e){function t(e){if(L(e)&&!Yc(e)&&!(e instanceof a)){if(e instanceof r)return e;if(eo.call(e,\"__chain__\")&&eo.call(e,\"__wrapped__\"))return _r(e)}return new r(e)}function n(){}function r(e,t,n){this.__wrapped__=e,this.__actions__=n||[],this.__chain__=!!t}function a(e){this.__wrapped__=e,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=ko,this.__views__=[]}function A(){var e=new a(this.__wrapped__);return e.__actions__=et(this.__actions__),e.__dir__=this.__dir__,e.__filtered__=this.__filtered__,e.__iteratees__=et(this.__iteratees__),e.__takeCount__=this.__takeCount__,e.__views__=et(this.__views__),e}function $(){if(this.__filtered__){var e=new a(this);e.__dir__=-1,e.__filtered__=!0}else e=this.clone(),e.__dir__*=-1;return e}function re(){var e=this.__wrapped__.value(),t=this.__dir__,n=Yc(e),r=t<0,a=n?e.length:0,i=In(0,a,this.__views__),o=i.start,c=i.end,s=c-o,u=r?c:o-1,d=this.__iteratees__,l=d.length,M=0,_=To(s,this.__takeCount__);if(!n||a<j||a==s&&_==s)return nn(r&&n?e.reverse():e,this.__actions__);var f=[];e:for(;s--&&M<_;){u+=t;for(var p=-1,h=e[u];++p<l;){var m=d[p],b=m.iteratee,L=m.type,A=b(h);if(L==F)h=A;else if(!A){if(L==P)continue e;break e}}f[M++]=h}return f}function ie(){this.__data__={}}function Ie(e){return this.has(e)&&delete this.__data__[e]}function Ge(e){return\"__proto__\"==e?D:this.__data__[e]}function Je(e){return\"__proto__\"!=e&&eo.call(this.__data__,e)}function Ve(e,t){return\"__proto__\"!=e&&(this.__data__[e]=t),this}function Ke(e){var t=e?e.length:0;for(this.data={hash:mo(null),set:new lo};t--;)this.push(e[t])}function Qe(e,t){var n=e.data,r=\"string\"==typeof t||qa(t)?n.set.has(t):n.hash[t];return r?0:-1}function Ze(e){var t=this.data;\"string\"==typeof e||qa(e)?t.set.add(e):t.hash[e]=!0}function $e(e,t){for(var n=-1,r=e.length,a=-1,i=t.length,o=Hi(r+i);++n<r;)o[n]=e[n];for(;++a<i;)o[n++]=t[a];return o}function et(e,t){var n=-1,r=e.length;for(t||(t=Hi(r));++n<r;)t[n]=e[n];return t}function tt(e,t){for(var n=-1,r=e.length;++n<r&&t(e[n],n,e)!==!1;);return e}function nt(e,t){for(var n=e.length;n--&&t(e[n],n,e)!==!1;);return e}function it(e,t){for(var n=-1,r=e.length;++n<r;)if(!t(e[n],n,e))return!1;return!0}function ot(e,t,n,r){for(var a=-1,i=e.length,o=r,c=o;++a<i;){var s=e[a],u=+t(s);n(u,o)&&(o=u,c=s)}return c}function ct(e,t){for(var n=-1,r=e.length,a=-1,i=[];++n<r;){var o=e[n];t(o,n,e)&&(i[++a]=o)}return i}function st(e,t){for(var n=-1,r=e.length,a=Hi(r);++n<r;)a[n]=t(e[n],n,e);return a}function ut(e,t){for(var n=-1,r=t.length,a=e.length;++n<r;)e[a+n]=t[n];return e}function dt(e,t,n,r){var a=-1,i=e.length;for(r&&i&&(n=e[++a]);++a<i;)n=t(n,e[a],a,e);return n}function lt(e,t,n,r){var a=e.length;for(r&&a&&(n=e[--a]);a--;)n=t(n,e[a],a,e);return n}function Mt(e,t){for(var n=-1,r=e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}function _t(e,t){for(var n=e.length,r=0;n--;)r+=+t(e[n])||0;return r}function ft(e,t){return e===D?t:e}function pt(e,t,n,r){return e!==D&&eo.call(r,n)?e:t}function ht(e,t,n){for(var r=-1,a=Hc(t),i=a.length;++r<i;){var o=a[r],c=e[o],s=n(c,t[o],o,e,t);(s===s?s===c:c!==c)&&(c!==D||o in e)||(e[o]=s)}return e;\n}function mt(e,t){return null==t?e:Lt(t,Hc(t),e)}function bt(e,t){for(var n=-1,r=null==e,a=!r&&Qn(e),i=a?e.length:0,o=t.length,c=Hi(o);++n<o;){var s=t[n];a?c[n]=Zn(s,i)?e[s]:D:c[n]=r?D:e[s]}return c}function Lt(e,t,n){n||(n={});for(var r=-1,a=t.length;++r<a;){var i=t[r];n[i]=e[i]}return n}function At(e,t,n){var r=typeof e;return\"function\"==r?t===D?e:on(e,t,n):null==e?Di:\"object\"==r?Rt(e):t===D?Wi(e):Ht(e,t)}function yt(e,t,n,r,a,i,o){var c;if(n&&(c=a?n(e,r,a):n(e)),c!==D)return c;if(!qa(e))return e;var s=Yc(e);if(s){if(c=Gn(e),!t)return et(e,c)}else{var u=no.call(e),d=u==Z;if(u!=te&&u!=G&&(!d||a))return Ue[u]?Vn(e,u,t):a?e:{};if(c=Jn(d?{}:e),!t)return mt(c,e)}i||(i=[]),o||(o=[]);for(var l=i.length;l--;)if(i[l]==e)return o[l];return i.push(e),o.push(c),(s?tt:Nt)(e,function(r,a){c[a]=yt(r,t,n,a,e,i,o)}),c}function zt(e,t,n){if(\"function\"!=typeof e)throw new Vi(U);return Mo(function(){e.apply(D,n)},t)}function Tt(e,t){var n=e?e.length:0,r=[];if(!n)return r;var a=-1,i=Pn(),o=i==c,s=o&&t.length>=j?pn(t):null,u=t.length;s&&(i=Qe,o=!1,t=s);e:for(;++a<n;){var d=e[a];if(o&&d===d){for(var l=u;l--;)if(t[l]===d)continue e;r.push(d)}else i(t,d,0)<0&&r.push(d)}return r}function gt(e,t){var n=!0;return Bo(e,function(e,r,a){return n=!!t(e,r,a)}),n}function vt(e,t,n,r){var a=r,i=a;return Bo(e,function(e,o,c){var s=+t(e,o,c);(n(s,a)||s===r&&s===i)&&(a=s,i=e)}),i}function Ot(e,t,n,r){var a=e.length;for(n=null==n?0:+n||0,n<0&&(n=-n>a?0:a+n),r=r===D||r>a?a:+r||0,r<0&&(r+=a),a=n>r?0:r>>>0,n>>>=0;n<a;)e[n++]=t;return e}function Dt(e,t){var n=[];return Bo(e,function(e,r,a){t(e,r,a)&&n.push(e)}),n}function kt(e,t,n,r){var a;return n(e,function(e,n,i){if(t(e,n,i))return a=r?n:e,!1}),a}function Yt(e,t,n,r){r||(r=[]);for(var a=-1,i=e.length;++a<i;){var o=e[a];L(o)&&Qn(o)&&(n||Yc(o)||va(o))?t?Yt(o,t,n,r):ut(r,o):n||(r[r.length]=o)}return r}function St(e,t){return Xo(e,t,ei)}function Nt(e,t){return Xo(e,t,Hc)}function wt(e,t){return Ro(e,t,Hc)}function Wt(e,t){for(var n=-1,r=t.length,a=-1,i=[];++n<r;){var o=t[n];Wa(e[o])&&(i[++a]=o)}return i}function qt(e,t,n){if(null!=e){n!==D&&n in lr(e)&&(t=[n]);for(var r=0,a=t.length;null!=e&&r<a;)e=e[t[r++]];return r&&r==a?e:D}}function Et(e,t,n,r,a,i){return e===t||(null==e||null==t||!qa(e)&&!L(t)?e!==e&&t!==t:Bt(e,t,Et,n,r,a,i))}function Bt(e,t,n,r,a,i,o){var c=Yc(e),s=Yc(t),u=J,d=J;c||(u=no.call(e),u==G?u=te:u!=te&&(c=Pa(e))),s||(d=no.call(t),d==G?d=te:d!=te&&(s=Pa(t)));var l=u==te,M=d==te,_=u==d;if(_&&!c&&!l)return Rn(e,t,u);if(!a){var f=l&&eo.call(e,\"__wrapped__\"),p=M&&eo.call(t,\"__wrapped__\");if(f||p)return n(f?e.value():e,p?t.value():t,r,a,i,o)}if(!_)return!1;i||(i=[]),o||(o=[]);for(var h=i.length;h--;)if(i[h]==e)return o[h]==t;i.push(e),o.push(t);var m=(c?Xn:Hn)(e,t,n,r,a,i,o);return i.pop(),o.pop(),m}function Ct(e,t,n){var r=t.length,a=r,i=!n;if(null==e)return!a;for(e=lr(e);r--;){var o=t[r];if(i&&o[2]?o[1]!==e[o[0]]:!(o[0]in e))return!1}for(;++r<a;){o=t[r];var c=o[0],s=e[c],u=o[1];if(i&&o[2]){if(s===D&&!(c in e))return!1}else{var d=n?n(s,u,c):D;if(!(d===D?Et(u,s,n,!0):d))return!1}}return!0}function Xt(e,t){var n=-1,r=Qn(e)?Hi(e.length):[];return Bo(e,function(e,a,i){r[++n]=t(e,a,i)}),r}function Rt(e){var t=Fn(e);if(1==t.length&&t[0][2]){var n=t[0][0],r=t[0][1];return function(e){return null!=e&&(e[n]===r&&(r!==D||n in lr(e)))}}return function(e){return Ct(e,t)}}function Ht(e,t){var n=Yc(e),r=er(e)&&rr(t),a=e+\"\";return e=Mr(e),function(i){if(null==i)return!1;var o=a;if(i=lr(i),(n||!r)&&!(o in i)){if(i=1==e.length?i:qt(i,Jt(e,0,-1)),null==i)return!1;o=Or(e),i=lr(i)}return i[o]===t?t!==D||o in i:Et(t,i[o],D,!0)}}function xt(e,t,n,r,a){if(!qa(e))return e;var i=Qn(t)&&(Yc(t)||Pa(t)),o=i?D:Hc(t);return tt(o||t,function(c,s){if(o&&(s=c,c=t[s]),L(c))r||(r=[]),a||(a=[]),jt(e,t,s,xt,n,r,a);else{var u=e[s],d=n?n(u,c,s,e,t):D,l=d===D;l&&(d=c),d===D&&(!i||s in e)||!l&&(d===d?d===u:u!==u)||(e[s]=d)}}),e}function jt(e,t,n,r,a,i,o){for(var c=i.length,s=t[n];c--;)if(i[c]==s)return void(e[n]=o[c]);var u=e[n],d=a?a(u,s,n,e,t):D,l=d===D;l&&(d=s,Qn(s)&&(Yc(s)||Pa(s))?d=Yc(u)?u:Qn(u)?et(u):[]:Ha(s)||va(s)?d=va(u)?Ja(u):Ha(u)?u:{}:l=!1),i.push(s),o.push(d),l?e[n]=r(d,s,a,i,o):(d===d?d!==u:u===u)&&(e[n]=d)}function Pt(e){return function(t){return null==t?D:t[e]}}function Ft(e){var t=e+\"\";return e=Mr(e),function(n){return qt(n,e,t)}}function Ut(e,t){for(var n=e?t.length:0;n--;){var r=t[n];if(r!=a&&Zn(r)){var a=r;_o.call(e,r,1)}}return e}function It(e,t){return e+bo(Oo()*(t-e+1))}function Gt(e,t,n,r,a){return a(e,function(e,a,i){n=r?(r=!1,e):t(n,e,a,i)}),n}function Jt(e,t,n){var r=-1,a=e.length;t=null==t?0:+t||0,t<0&&(t=-t>a?0:a+t),n=n===D||n>a?a:+n||0,n<0&&(n+=a),a=t>n?0:n-t>>>0,t>>>=0;for(var i=Hi(a);++r<a;)i[r]=e[r+t];return i}function Vt(e,t){var n;return Bo(e,function(e,r,a){return n=t(e,r,a),!n}),!!n}function Kt(e,t){var n=e.length;for(e.sort(t);n--;)e[n]=e[n].value;return e}function Qt(e,t,n){var r=xn(),a=-1;t=st(t,function(e){return r(e)});var i=Xt(e,function(e){var n=st(t,function(t){return t(e)});return{criteria:n,index:++a,value:e}});return Kt(i,function(e,t){return _(e,t,n)})}function Zt(e,t){var n=0;return Bo(e,function(e,r,a){n+=+t(e,r,a)||0}),n}function $t(e,t){var n=-1,r=Pn(),a=e.length,i=r==c,o=i&&a>=j,s=o?pn():null,u=[];s?(r=Qe,i=!1):(o=!1,s=t?[]:u);e:for(;++n<a;){var d=e[n],l=t?t(d,n,e):d;if(i&&d===d){for(var M=s.length;M--;)if(s[M]===l)continue e;t&&s.push(l),u.push(d)}else r(s,l,0)<0&&((t||o)&&s.push(l),u.push(d))}return u}function en(e,t){for(var n=-1,r=t.length,a=Hi(r);++n<r;)a[n]=e[t[n]];return a}function tn(e,t,n,r){for(var a=e.length,i=r?a:-1;(r?i--:++i<a)&&t(e[i],i,e););return n?Jt(e,r?0:i,r?i+1:a):Jt(e,r?i+1:0,r?a:i)}function nn(e,t){var n=e;n instanceof a&&(n=n.value());for(var r=-1,i=t.length;++r<i;){var o=t[r];n=o.func.apply(o.thisArg,ut([n],o.args))}return n}function rn(e,t,n){var r=0,a=e?e.length:r;if(\"number\"==typeof t&&t===t&&a<=No){for(;r<a;){var i=r+a>>>1,o=e[i];(n?o<=t:o<t)&&null!==o?r=i+1:a=i}return a}return an(e,t,Di,n)}function an(e,t,n,r){t=n(t);for(var a=0,i=e?e.length:0,o=t!==t,c=null===t,s=t===D;a<i;){var u=bo((a+i)/2),d=n(e[u]),l=d!==D,M=d===d;if(o)var _=M||r;else _=c?M&&l&&(r||null!=d):s?M&&(r||l):null!=d&&(r?d<=t:d<t);_?a=u+1:i=u}return To(i,So)}function on(e,t,n){if(\"function\"!=typeof e)return Di;if(t===D)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 3:return function(n,r,a){return e.call(t,n,r,a)};case 4:return function(n,r,a,i){return e.call(t,n,r,a,i)};case 5:return function(n,r,a,i,o){return e.call(t,n,r,a,i,o)}}return function(){return e.apply(t,arguments)}}function cn(e){var t=new io(e.byteLength),n=new fo(t);return n.set(new fo(e)),t}function sn(e,t,n){for(var r=n.length,a=-1,i=zo(e.length-r,0),o=-1,c=t.length,s=Hi(c+i);++o<c;)s[o]=t[o];for(;++a<r;)s[n[a]]=e[a];for(;i--;)s[o++]=e[a++];return s}function un(e,t,n){for(var r=-1,a=n.length,i=-1,o=zo(e.length-a,0),c=-1,s=t.length,u=Hi(o+s);++i<o;)u[i]=e[i];for(var d=i;++c<s;)u[d+c]=t[c];for(;++r<a;)u[d+n[r]]=e[i++];return u}function dn(e,t){return function(n,r,a){var i=t?t():{};if(r=xn(r,a,3),Yc(n))for(var o=-1,c=n.length;++o<c;){var s=n[o];e(i,s,r(s,o,n),n)}else Bo(n,function(t,n,a){e(i,t,r(t,n,a),a)});return i}}function ln(e){return ma(function(t,n){var r=-1,a=null==t?0:n.length,i=a>2?n[a-2]:D,o=a>2?n[2]:D,c=a>1?n[a-1]:D;for(\"function\"==typeof i?(i=on(i,c,5),a-=2):(i=\"function\"==typeof c?c:D,a-=i?1:0),o&&$n(n[0],n[1],o)&&(i=a<3?D:i,a=1);++r<a;){var s=n[r];s&&e(t,s,i)}return t})}function Mn(e,t){return function(n,r){var a=n?jo(n):0;if(!nr(a))return e(n,r);for(var i=t?a:-1,o=lr(n);(t?i--:++i<a)&&r(o[i],i,o)!==!1;);return n}}function _n(e){return function(t,n,r){for(var a=lr(t),i=r(t),o=i.length,c=e?o:-1;e?c--:++c<o;){var s=i[c];if(n(a[s],s,a)===!1)break}return t}}function fn(e,t){function n(){var a=this&&this!==rt&&this instanceof n?r:e;return a.apply(t,arguments)}var r=mn(e);return n}function pn(e){return mo&&lo?new Ke(e):null}function hn(e){return function(t){for(var n=-1,r=gi(di(t)),a=r.length,i=\"\";++n<a;)i=e(i,r[n],n);return i}}function mn(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=Eo(e.prototype),r=e.apply(n,t);return qa(r)?r:n}}function bn(e){function t(n,r,a){a&&$n(n,r,a)&&(r=D);var i=Cn(n,e,D,D,D,D,D,r);return i.placeholder=t.placeholder,i}return t}function Ln(e,t){return ma(function(n){var r=n[0];return null==r?r:(n.push(t),e.apply(D,n))})}function An(e,t){return function(n,r,a){if(a&&$n(n,r,a)&&(r=D),r=xn(r,a,3),1==r.length){n=Yc(n)?n:dr(n);var i=ot(n,r,e,t);if(!n.length||i!==t)return i}return vt(n,r,e,t)}}function yn(e,t){return function(n,r,a){if(r=xn(r,a,3),Yc(n)){var i=o(n,r,t);return i>-1?n[i]:D}return kt(n,r,e)}}function zn(e){return function(t,n,r){return t&&t.length?(n=xn(n,r,3),o(t,n,e)):-1}}function Tn(e){return function(t,n,r){return n=xn(n,r,3),kt(t,n,e,!0)}}function gn(e){return function(){for(var t,n=arguments.length,a=e?n:-1,i=0,o=Hi(n);e?a--:++a<n;){var c=o[i++]=arguments[a];if(\"function\"!=typeof c)throw new Vi(U);!t&&r.prototype.thru&&\"wrapper\"==jn(c)&&(t=new r([],(!0)))}for(a=t?-1:n;++a<n;){c=o[a];var s=jn(c),u=\"wrapper\"==s?xo(c):D;t=u&&tr(u[0])&&u[1]==(B|w|q|C)&&!u[4].length&&1==u[9]?t[jn(u[0])].apply(t,u[3]):1==c.length&&tr(c)?t[s]():t.thru(c)}return function(){var e=arguments,r=e[0];if(t&&1==e.length&&Yc(r)&&r.length>=j)return t.plant(r).value();for(var a=0,i=n?o[a].apply(this,e):r;++a<n;)i=o[a].call(this,i);return i}}}function vn(e,t){return function(n,r,a){return\"function\"==typeof r&&a===D&&Yc(n)?e(n,r):t(n,on(r,a,3))}}function On(e){return function(t,n,r){return\"function\"==typeof n&&r===D||(n=on(n,r,3)),e(t,n,ei)}}function Dn(e){return function(t,n,r){return\"function\"==typeof n&&r===D||(n=on(n,r,3)),e(t,n)}}function kn(e){return function(t,n,r){var a={};return n=xn(n,r,3),Nt(t,function(t,r,i){var o=n(t,r,i);r=e?o:r,t=e?t:o,a[r]=t}),a}}function Yn(e){return function(t,n,r){return t=u(t),(e?t:\"\")+Wn(t,n,r)+(e?\"\":t)}}function Sn(e){var t=ma(function(n,r){var a=y(r,t.placeholder);return Cn(n,e,D,r,a)});return t}function Nn(e,t){return function(n,r,a,i){var o=arguments.length<3;return\"function\"==typeof r&&i===D&&Yc(n)?e(n,r,a,o):Gt(n,xn(r,i,4),a,o,t)}}function wn(e,t,n,r,a,i,o,c,s,u){function d(){for(var b=arguments.length,L=b,A=Hi(b);L--;)A[L]=arguments[L];if(r&&(A=sn(A,r,a)),i&&(A=un(A,i,o)),f||h){var z=d.placeholder,T=y(A,z);if(b-=T.length,b<u){var g=c?et(c):D,v=zo(u-b,0),O=f?T:D,k=f?D:T,N=f?A:D,w=f?D:A;t|=f?q:E,t&=~(f?E:q),p||(t&=~(Y|S));var W=[e,t,n,N,O,w,k,g,s,v],B=wn.apply(D,W);return tr(e)&&Po(B,W),B.placeholder=z,B}}var C=M?n:this,X=_?C[e]:e;return c&&(A=sr(A,c)),l&&s<A.length&&(A.length=s),this&&this!==rt&&this instanceof d&&(X=m||mn(e)),X.apply(C,A)}var l=t&B,M=t&Y,_=t&S,f=t&w,p=t&N,h=t&W,m=_?D:mn(e);return d}function Wn(e,t,n){var r=e.length;if(t=+t,r>=t||!Ao(t))return\"\";var a=t-r;return n=null==n?\" \":n+\"\",hi(n,ho(a/n.length)).slice(0,a)}function qn(e,t,n,r){function a(){for(var t=-1,c=arguments.length,s=-1,u=r.length,d=Hi(u+c);++s<u;)d[s]=r[s];for(;c--;)d[s++]=arguments[++t];var l=this&&this!==rt&&this instanceof a?o:e;return l.apply(i?n:this,d)}var i=t&Y,o=mn(e);return a}function En(e){var t=Fi[e];return function(e,n){return n=n===D?0:+n||0,n?(n=so(10,n),t(e*n)/n):t(e)}}function Bn(e){return function(t,n,r,a){var i=xn(r);return null==r&&i===At?rn(t,n,e):an(t,n,i(r,a,1),e)}}function Cn(e,t,n,r,a,i,o,c){var s=t&S;if(!s&&\"function\"!=typeof e)throw new Vi(U);var u=r?r.length:0;if(u||(t&=~(q|E),r=a=D),u-=a?a.length:0,t&E){var d=r,l=a;r=a=D}var M=s?D:xo(e),_=[e,t,n,r,a,d,l,i,o,c];if(M&&(ar(_,M),t=_[1],c=_[9]),_[9]=null==c?s?0:e.length:zo(c-u,0)||0,t==Y)var f=fn(_[0],_[2]);else f=t!=q&&t!=(Y|q)||_[4].length?wn.apply(D,_):qn.apply(D,_);var p=M?Ho:Po;return p(f,_)}function Xn(e,t,n,r,a,i,o){var c=-1,s=e.length,u=t.length;if(s!=u&&!(a&&u>s))return!1;for(;++c<s;){var d=e[c],l=t[c],M=r?r(a?l:d,a?d:l,c):D;if(M!==D){if(M)continue;return!1}if(a){if(!Mt(t,function(e){return d===e||n(d,e,r,a,i,o)}))return!1}else if(d!==l&&!n(d,l,r,a,i,o))return!1}return!0}function Rn(e,t,n){switch(n){case V:case K:return+e==+t;case Q:return e.name==t.name&&e.message==t.message;case ee:return e!=+e?t!=+t:e==+t;case ne:case ae:return e==t+\"\"}return!1}function Hn(e,t,n,r,a,i,o){var c=Hc(e),s=c.length,u=Hc(t),d=u.length;if(s!=d&&!a)return!1;for(var l=s;l--;){var M=c[l];if(!(a?M in t:eo.call(t,M)))return!1}for(var _=a;++l<s;){M=c[l];var f=e[M],p=t[M],h=r?r(a?p:f,a?f:p,M):D;if(!(h===D?n(f,p,r,a,i,o):h))return!1;_||(_=\"constructor\"==M)}if(!_){var m=e.constructor,b=t.constructor;if(m!=b&&\"constructor\"in e&&\"constructor\"in t&&!(\"function\"==typeof m&&m instanceof m&&\"function\"==typeof b&&b instanceof b))return!1}return!0}function xn(e,n,r){var a=t.callback||vi;return a=a===vi?At:a,r?a(e,n,r):a}function jn(e){for(var t=e.name,n=qo[t],r=n?n.length:0;r--;){var a=n[r],i=a.func;if(null==i||i==e)return a.name}return t}function Pn(e,n,r){var a=t.indexOf||gr;return a=a===gr?c:a,e?a(e,n,r):a}function Fn(e){for(var t=ti(e),n=t.length;n--;)t[n][2]=rr(t[n][1]);return t}function Un(e,t){var n=null==e?D:e[t];return Ca(n)?n:D}function In(e,t,n){for(var r=-1,a=n.length;++r<a;){var i=n[r],o=i.size;switch(i.type){case\"drop\":e+=o;break;case\"dropRight\":t-=o;break;case\"take\":t=To(t,e+o);break;case\"takeRight\":e=zo(e,t-o)}}return{start:e,end:t}}function Gn(e){var t=e.length,n=new e.constructor(t);return t&&\"string\"==typeof e[0]&&eo.call(e,\"index\")&&(n.index=e.index,n.input=e.input),n}function Jn(e){var t=e.constructor;return\"function\"==typeof t&&t instanceof t||(t=Ii),new t}function Vn(e,t,n){var r=e.constructor;switch(t){case oe:return cn(e);case V:case K:return new r((+e));case ce:case se:case ue:case de:case le:case Me:case _e:case fe:case pe:var a=e.buffer;return new r(n?cn(a):a,e.byteOffset,e.length);case ee:case ae:return new r(e);case ne:var i=new r(e.source,qe.exec(e));i.lastIndex=e.lastIndex}return i}function Kn(e,t,n){null==e||er(t,e)||(t=Mr(t),e=1==t.length?e:qt(e,Jt(t,0,-1)),t=Or(t));var r=null==e?e:e[t];return null==r?D:r.apply(e,n)}function Qn(e){return null!=e&&nr(jo(e))}function Zn(e,t){return e=\"number\"==typeof e||Ce.test(e)?+e:-1,t=null==t?wo:t,e>-1&&e%1==0&&e<t}function $n(e,t,n){if(!qa(n))return!1;var r=typeof t;if(\"number\"==r?Qn(n)&&Zn(t,n.length):\"string\"==r&&t in n){var a=n[t];return e===e?e===a:a!==a}return!1}function er(e,t){var n=typeof e;if(\"string\"==n&&De.test(e)||\"number\"==n)return!0;if(Yc(e))return!1;var r=!Oe.test(e);return r||null!=t&&e in lr(t)}function tr(e){var n=jn(e);if(!(n in a.prototype))return!1;var r=t[n];if(e===r)return!0;var i=xo(r);return!!i&&e===i[0]}function nr(e){return\"number\"==typeof e&&e>-1&&e%1==0&&e<=wo}function rr(e){return e===e&&!qa(e)}function ar(e,t){var n=e[1],r=t[1],a=n|r,i=a<B,o=r==B&&n==w||r==B&&n==C&&e[7].length<=t[8]||r==(B|C)&&n==w;if(!i&&!o)return e;r&Y&&(e[2]=t[2],a|=n&Y?0:N);var c=t[3];if(c){var s=e[3];e[3]=s?sn(s,c,t[4]):et(c),e[4]=s?y(e[3],I):et(t[4])}return c=t[5],c&&(s=e[5],e[5]=s?un(s,c,t[6]):et(c),e[6]=s?y(e[5],I):et(t[6])),c=t[7],c&&(e[7]=et(c)),r&B&&(e[8]=null==e[8]?t[8]:To(e[8],t[8])),null==e[9]&&(e[9]=t[9]),e[0]=t[0],e[1]=a,e}function ir(e,t){return e===D?t:Sc(e,t,ir)}function or(e,t){e=lr(e);for(var n=-1,r=t.length,a={};++n<r;){var i=t[n];i in e&&(a[i]=e[i])}return a}function cr(e,t){var n={};return St(e,function(e,r,a){t(e,r,a)&&(n[r]=e)}),n}function sr(e,t){for(var n=e.length,r=To(t.length,n),a=et(e);r--;){var i=t[r];e[r]=Zn(i,n)?a[i]:D}return e}function ur(e){for(var t=ei(e),n=t.length,r=n&&e.length,a=!!r&&nr(r)&&(Yc(e)||va(e)),i=-1,o=[];++i<n;){var c=t[i];(a&&Zn(c,r)||eo.call(e,c))&&o.push(c)}return o}function dr(e){return null==e?[]:Qn(e)?qa(e)?e:Ii(e):ii(e)}function lr(e){return qa(e)?e:Ii(e)}function Mr(e){if(Yc(e))return e;var t=[];return u(e).replace(ke,function(e,n,r,a){t.push(r?a.replace(we,\"$1\"):n||e)}),t}function _r(e){return e instanceof a?e.clone():new r(e.__wrapped__,e.__chain__,et(e.__actions__))}function fr(e,t,n){t=(n?$n(e,t,n):null==t)?1:zo(bo(t)||1,1);for(var r=0,a=e?e.length:0,i=-1,o=Hi(ho(a/t));r<a;)o[++i]=Jt(e,r,r+=t);return o}function pr(e){for(var t=-1,n=e?e.length:0,r=-1,a=[];++t<n;){var i=e[t];i&&(a[++r]=i)}return a}function hr(e,t,n){var r=e?e.length:0;return r?((n?$n(e,t,n):null==t)&&(t=1),Jt(e,t<0?0:t)):[]}function mr(e,t,n){var r=e?e.length:0;return r?((n?$n(e,t,n):null==t)&&(t=1),t=r-(+t||0),Jt(e,0,t<0?0:t)):[]}function br(e,t,n){return e&&e.length?tn(e,xn(t,n,3),!0,!0):[]}function Lr(e,t,n){return e&&e.length?tn(e,xn(t,n,3),!0):[]}function Ar(e,t,n,r){var a=e?e.length:0;return a?(n&&\"number\"!=typeof n&&$n(e,t,n)&&(n=0,r=a),Ot(e,t,n,r)):[]}function yr(e){return e?e[0]:D}function zr(e,t,n){var r=e?e.length:0;return n&&$n(e,t,n)&&(t=!1),r?Yt(e,t):[]}function Tr(e){var t=e?e.length:0;return t?Yt(e,!0):[]}function gr(e,t,n){var r=e?e.length:0;if(!r)return-1;if(\"number\"==typeof n)n=n<0?zo(r+n,0):n;else if(n){var a=rn(e,t);return a<r&&(t===t?t===e[a]:e[a]!==e[a])?a:-1}return c(e,t,n||0)}function vr(e){return mr(e,1)}function Or(e){var t=e?e.length:0;return t?e[t-1]:D}function Dr(e,t,n){var r=e?e.length:0;if(!r)return-1;var a=r;if(\"number\"==typeof n)a=(n<0?zo(r+n,0):To(n||0,r-1))+1;else if(n){a=rn(e,t,!0)-1;var i=e[a];return(t===t?t===i:i!==i)?a:-1}if(t!==t)return b(e,a,!0);for(;a--;)if(e[a]===t)return a;return-1}function kr(){var e=arguments,t=e[0];if(!t||!t.length)return t;for(var n=0,r=Pn(),a=e.length;++n<a;)for(var i=0,o=e[n];(i=r(t,o,i))>-1;)_o.call(t,i,1);return t}function Yr(e,t,n){var r=[];if(!e||!e.length)return r;var a=-1,i=[],o=e.length;for(t=xn(t,n,3);++a<o;){var c=e[a];t(c,a,e)&&(r.push(c),i.push(a))}return Ut(e,i),r}function Sr(e){return hr(e,1)}function Nr(e,t,n){var r=e?e.length:0;return r?(n&&\"number\"!=typeof n&&$n(e,t,n)&&(t=0,n=r),Jt(e,t,n)):[]}function wr(e,t,n){var r=e?e.length:0;return r?((n?$n(e,t,n):null==t)&&(t=1),Jt(e,0,t<0?0:t)):[]}function Wr(e,t,n){var r=e?e.length:0;return r?((n?$n(e,t,n):null==t)&&(t=1),t=r-(+t||0),Jt(e,t<0?0:t)):[]}function qr(e,t,n){return e&&e.length?tn(e,xn(t,n,3),!1,!0):[]}function Er(e,t,n){return e&&e.length?tn(e,xn(t,n,3)):[]}function Br(e,t,n,r){var a=e?e.length:0;if(!a)return[];null!=t&&\"boolean\"!=typeof t&&(r=n,n=$n(e,t,r)?D:t,t=!1);var i=xn();return null==n&&i===At||(n=i(n,r,3)),t&&Pn()==c?z(e,n):$t(e,n)}function Cr(e){if(!e||!e.length)return[];var t=-1,n=0;e=ct(e,function(e){if(Qn(e))return n=zo(e.length,n),!0});for(var r=Hi(n);++t<n;)r[t]=st(e,Pt(t));return r}function Xr(e,t,n){var r=e?e.length:0;if(!r)return[];var a=Cr(e);return null==t?a:(t=on(t,n,4),st(a,function(e){return dt(e,t,D,!0)}))}function Rr(){for(var e=-1,t=arguments.length;++e<t;){var n=arguments[e];if(Qn(n))var r=r?ut(Tt(r,n),Tt(n,r)):n}return r?$t(r):[]}function Hr(e,t){var n=-1,r=e?e.length:0,a={};for(!r||t||Yc(e[0])||(t=[]);++n<r;){var i=e[n];t?a[i]=t[n]:i&&(a[i[0]]=i[1])}return a}function xr(e){var n=t(e);return n.__chain__=!0,n}function jr(e,t,n){return t.call(n,e),e}function Pr(e,t,n){return t.call(n,e)}function Fr(){return xr(this)}function Ur(){return new r(this.value(),this.__chain__)}function Ir(e){for(var t,r=this;r instanceof n;){var a=_r(r);t?i.__wrapped__=a:t=a;var i=a;r=r.__wrapped__}return i.__wrapped__=e,t}function Gr(){var e=this.__wrapped__,t=function(e){return n&&n.__dir__<0?e:e.reverse()};if(e instanceof a){var n=e;return this.__actions__.length&&(n=new a(this)),n=n.reverse(),n.__actions__.push({func:Pr,args:[t],thisArg:D}),new r(n,this.__chain__)}return this.thru(t)}function Jr(){return this.value()+\"\"}function Vr(){return nn(this.__wrapped__,this.__actions__)}function Kr(e,t,n){var r=Yc(e)?it:gt;return n&&$n(e,t,n)&&(t=D),\"function\"==typeof t&&n===D||(t=xn(t,n,3)),r(e,t)}function Qr(e,t,n){var r=Yc(e)?ct:Dt;return t=xn(t,n,3),r(e,t)}function Zr(e,t){return ac(e,Rt(t))}function $r(e,t,n,r){var a=e?jo(e):0;return nr(a)||(e=ii(e),a=e.length),n=\"number\"!=typeof n||r&&$n(t,n,r)?0:n<0?zo(a+n,0):n||0,\"string\"==typeof e||!Yc(e)&&ja(e)?n<=a&&e.indexOf(t,n)>-1:!!a&&Pn(e,t,n)>-1}function ea(e,t,n){var r=Yc(e)?st:Xt;return t=xn(t,n,3),r(e,t)}function ta(e,t){return ea(e,Wi(t))}function na(e,t,n){var r=Yc(e)?ct:Dt;return t=xn(t,n,3),r(e,function(e,n,r){return!t(e,n,r)})}function ra(e,t,n){if(n?$n(e,t,n):null==t){e=dr(e);var r=e.length;return r>0?e[It(0,r-1)]:D}var a=-1,i=Ga(e),r=i.length,o=r-1;for(t=To(t<0?0:+t||0,r);++a<t;){var c=It(a,o),s=i[c];i[c]=i[a],i[a]=s}return i.length=t,i}function aa(e){return ra(e,ko)}function ia(e){var t=e?jo(e):0;return nr(t)?t:Hc(e).length}function oa(e,t,n){var r=Yc(e)?Mt:Vt;return n&&$n(e,t,n)&&(t=D),\"function\"==typeof t&&n===D||(t=xn(t,n,3)),r(e,t)}function ca(e,t,n){if(null==e)return[];n&&$n(e,t,n)&&(t=D);var r=-1;t=xn(t,n,3);var a=Xt(e,function(e,n,a){return{criteria:t(e,n,a),index:++r,value:e}});return Kt(a,M)}function sa(e,t,n,r){return null==e?[]:(r&&$n(t,n,r)&&(n=D),Yc(t)||(t=null==t?[]:[t]),Yc(n)||(n=null==n?[]:[n]),Qt(e,t,n))}function ua(e,t){return Qr(e,Rt(t))}function da(e,t){if(\"function\"!=typeof t){if(\"function\"!=typeof e)throw new Vi(U);var n=e;e=t,t=n}return e=Ao(e=+e)?e:0,function(){if(--e<1)return t.apply(this,arguments)}}function la(e,t,n){return n&&$n(e,t,n)&&(t=D),t=e&&null==t?e.length:zo(+t||0,0),Cn(e,B,D,D,D,D,t)}function Ma(e,t){var n;if(\"function\"!=typeof t){if(\"function\"!=typeof e)throw new Vi(U);var r=e;e=t,t=r}return function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=D),n}}function _a(e,t,n){function r(){_&&oo(_),u&&oo(u),p=0,u=_=f=D}function a(t,n){n&&oo(n),u=_=f=D,t&&(p=pc(),d=e.apply(M,s),_||u||(s=M=D))}function i(){var e=t-(pc()-l);e<=0||e>t?a(f,u):_=Mo(i,e)}function o(){a(m,_)}function c(){if(s=arguments,l=pc(),M=this,f=m&&(_||!b),h===!1)var n=b&&!_;else{u||b||(p=l);var r=h-(l-p),a=r<=0||r>h;a?(u&&(u=oo(u)),p=l,d=e.apply(M,s)):u||(u=Mo(o,r))}return a&&_?_=oo(_):_||t===h||(_=Mo(i,t)),n&&(a=!0,d=e.apply(M,s)),!a||_||u||(s=M=D),d}var s,u,d,l,M,_,f,p=0,h=!1,m=!0;if(\"function\"!=typeof e)throw new Vi(U);if(t=t<0?0:+t||0,n===!0){var b=!0;m=!1}else qa(n)&&(b=!!n.leading,h=\"maxWait\"in n&&zo(+n.maxWait||0,t),m=\"trailing\"in n?!!n.trailing:m);return c.cancel=r,c}function fa(e,t){if(\"function\"!=typeof e||t&&\"function\"!=typeof t)throw new Vi(U);var n=function(){var r=arguments,a=t?t.apply(this,r):r[0],i=n.cache;if(i.has(a))return i.get(a);var o=e.apply(this,r);return n.cache=i.set(a,o),o};return n.cache=new fa.Cache,n}function pa(e){if(\"function\"!=typeof e)throw new Vi(U);return function(){return!e.apply(this,arguments)}}function ha(e){return Ma(2,e)}function ma(e,t){if(\"function\"!=typeof e)throw new Vi(U);return t=zo(t===D?e.length-1:+t||0,0),function(){for(var n=arguments,r=-1,a=zo(n.length-t,0),i=Hi(a);++r<a;)i[r]=n[t+r];switch(t){case 0:return e.call(this,i);case 1:return e.call(this,n[0],i);case 2:return e.call(this,n[0],n[1],i)}var o=Hi(t+1);for(r=-1;++r<t;)o[r]=n[r];return o[t]=i,e.apply(this,o)}}function ba(e){if(\"function\"!=typeof e)throw new Vi(U);return function(t){return e.apply(this,t)}}function La(e,t,n){var r=!0,a=!0;if(\"function\"!=typeof e)throw new Vi(U);return n===!1?r=!1:qa(n)&&(r=\"leading\"in n?!!n.leading:r,a=\"trailing\"in n?!!n.trailing:a),_a(e,t,{leading:r,maxWait:+t,trailing:a})}function Aa(e,t){return t=null==t?Di:t,Cn(t,q,D,[e],[])}function ya(e,t,n,r){return t&&\"boolean\"!=typeof t&&$n(e,t,n)?t=!1:\"function\"==typeof t&&(r=n,n=t,t=!1),\"function\"==typeof n?yt(e,t,on(n,r,1)):yt(e,t)}function za(e,t,n){return\"function\"==typeof t?yt(e,!0,on(t,n,1)):yt(e,!0)}function Ta(e,t){return e>t}function ga(e,t){return e>=t}function va(e){return L(e)&&Qn(e)&&eo.call(e,\"callee\")&&!uo.call(e,\"callee\")}function Oa(e){return e===!0||e===!1||L(e)&&no.call(e)==V}function Da(e){return L(e)&&no.call(e)==K}function ka(e){return!!e&&1===e.nodeType&&L(e)&&!Ha(e)}function Ya(e){return null==e||(Qn(e)&&(Yc(e)||ja(e)||va(e)||L(e)&&Wa(e.splice))?!e.length:!Hc(e).length)}function Sa(e,t,n,r){n=\"function\"==typeof n?on(n,r,3):D;var a=n?n(e,t):D;return a===D?Et(e,t,n):!!a}function Na(e){return L(e)&&\"string\"==typeof e.message&&no.call(e)==Q}function wa(e){return\"number\"==typeof e&&Ao(e)}function Wa(e){return qa(e)&&no.call(e)==Z}function qa(e){var t=typeof e;return!!e&&(\"object\"==t||\"function\"==t)}function Ea(e,t,n,r){return n=\"function\"==typeof n?on(n,r,3):D,Ct(e,Fn(t),n)}function Ba(e){return Ra(e)&&e!=+e}function Ca(e){return null!=e&&(Wa(e)?ao.test($i.call(e)):L(e)&&Be.test(e))}function Xa(e){return null===e}function Ra(e){return\"number\"==typeof e||L(e)&&no.call(e)==ee}function Ha(e){var t;if(!L(e)||no.call(e)!=te||va(e)||!eo.call(e,\"constructor\")&&(t=e.constructor,\"function\"==typeof t&&!(t instanceof t)))return!1;var n;return St(e,function(e,t){n=t}),n===D||eo.call(e,n)}function xa(e){return qa(e)&&no.call(e)==ne}function ja(e){return\"string\"==typeof e||L(e)&&no.call(e)==ae}function Pa(e){return L(e)&&nr(e.length)&&!!Fe[no.call(e)]}function Fa(e){return e===D}function Ua(e,t){return e<t}function Ia(e,t){return e<=t}function Ga(e){var t=e?jo(e):0;return nr(t)?t?et(e):[]:ii(e)}function Ja(e){return Lt(e,ei(e))}function Va(e,t,n){var r=Eo(e);return n&&$n(e,t,n)&&(t=D),t?mt(r,t):r}function Ka(e){return Wt(e,ei(e))}function Qa(e,t,n){var r=null==e?D:qt(e,Mr(t),t+\"\");return r===D?n:r}function Za(e,t){if(null==e)return!1;var n=eo.call(e,t);if(!n&&!er(t)){if(t=Mr(t),e=1==t.length?e:qt(e,Jt(t,0,-1)),null==e)return!1;t=Or(t),n=eo.call(e,t)}return n||nr(e.length)&&Zn(t,e.length)&&(Yc(e)||va(e))}function $a(e,t,n){n&&$n(e,t,n)&&(t=D);for(var r=-1,a=Hc(e),i=a.length,o={};++r<i;){var c=a[r],s=e[c];t?eo.call(o,s)?o[s].push(c):o[s]=[c]:o[s]=c}return o}function ei(e){if(null==e)return[];qa(e)||(e=Ii(e));var t=e.length;t=t&&nr(t)&&(Yc(e)||va(e))&&t||0;for(var n=e.constructor,r=-1,a=\"function\"==typeof n&&n.prototype===e,i=Hi(t),o=t>0;++r<t;)i[r]=r+\"\";for(var c in e)o&&Zn(c,t)||\"constructor\"==c&&(a||!eo.call(e,c))||i.push(c);return i}function ti(e){e=lr(e);for(var t=-1,n=Hc(e),r=n.length,a=Hi(r);++t<r;){var i=n[t];a[t]=[i,e[i]]}return a}function ni(e,t,n){var r=null==e?D:e[t];return r===D&&(null==e||er(t,e)||(t=Mr(t),e=1==t.length?e:qt(e,Jt(t,0,-1)),r=null==e?D:e[Or(t)]),r=r===D?n:r),Wa(r)?r.call(e):r}function ri(e,t,n){if(null==e)return e;var r=t+\"\";t=null!=e[r]||er(t,e)?[r]:Mr(t);for(var a=-1,i=t.length,o=i-1,c=e;null!=c&&++a<i;){var s=t[a];qa(c)&&(a==o?c[s]=n:null==c[s]&&(c[s]=Zn(t[a+1])?[]:{})),c=c[s]}return e}function ai(e,t,n,r){var a=Yc(e)||Pa(e);if(t=xn(t,r,4),null==n)if(a||qa(e)){var i=e.constructor;n=a?Yc(e)?new i:[]:Eo(Wa(i)?i.prototype:D)}else n={};return(a?tt:Nt)(e,function(e,r,a){return t(n,e,r,a)}),n}function ii(e){return en(e,Hc(e))}function oi(e){return en(e,ei(e))}function ci(e,t,n){return t=+t||0,n===D?(n=t,t=0):n=+n||0,e>=To(t,n)&&e<zo(t,n)}function si(e,t,n){n&&$n(e,t,n)&&(t=n=D);var r=null==e,a=null==t;if(null==n&&(a&&\"boolean\"==typeof e?(n=e,e=1):\"boolean\"==typeof t&&(n=t,a=!0)),r&&a&&(t=1,a=!1),e=+e||0,a?(t=e,e=0):t=+t||0,n||e%1||t%1){var i=Oo();return To(e+i*(t-e+co(\"1e-\"+((i+\"\").length-1))),t)}return It(e,t)}function ui(e){return e=u(e),e&&e.charAt(0).toUpperCase()+e.slice(1)}function di(e){return e=u(e),e&&e.replace(Xe,f).replace(Ne,\"\")}function li(e,t,n){e=u(e),t+=\"\";var r=e.length;return n=n===D?r:To(n<0?0:+n||0,r),n-=t.length,n>=0&&e.indexOf(t,n)==n}function Mi(e){return e=u(e),e&&ze.test(e)?e.replace(Ae,p):e}function _i(e){return e=u(e),e&&Se.test(e)?e.replace(Ye,h):e||\"(?:)\"}function fi(e,t,n){e=u(e),t=+t;var r=e.length;if(r>=t||!Ao(t))return e;var a=(t-r)/2,i=bo(a),o=ho(a);return n=Wn(\"\",o,n),n.slice(0,i)+e+n}function pi(e,t,n){return(n?$n(e,t,n):null==t)?t=0:t&&(t=+t),e=Li(e),vo(e,t||(Ee.test(e)?16:10))}function hi(e,t){var n=\"\";if(e=u(e),t=+t,t<1||!e||!Ao(t))return n;do t%2&&(n+=e),t=bo(t/2),e+=e;while(t);return n}function mi(e,t,n){return e=u(e),n=null==n?0:To(n<0?0:+n||0,e.length),e.lastIndexOf(t,n)==n}function bi(e,n,r){var a=t.templateSettings;r&&$n(e,n,r)&&(n=r=D),e=u(e),n=ht(mt({},r||n),a,pt);var i,o,c=ht(mt({},n.imports),a.imports,pt),s=Hc(c),d=en(c,s),l=0,M=n.interpolate||Re,_=\"__p += '\",f=Gi((n.escape||Re).source+\"|\"+M.source+\"|\"+(M===ve?We:Re).source+\"|\"+(n.evaluate||Re).source+\"|$\",\"g\"),p=\"//# sourceURL=\"+(\"sourceURL\"in n?n.sourceURL:\"lodash.templateSources[\"+ ++Pe+\"]\")+\"\\n\";e.replace(f,function(t,n,r,a,c,s){return r||(r=a),_+=e.slice(l,s).replace(He,m),n&&(i=!0,_+=\"' +\\n__e(\"+n+\") +\\n'\"),c&&(o=!0,_+=\"';\\n\"+c+\";\\n__p += '\"),r&&(_+=\"' +\\n((__t = (\"+r+\")) == null ? '' : __t) +\\n'\"),l=s+t.length,t}),_+=\"';\\n\";var h=n.variable;h||(_=\"with (obj) {\\n\"+_+\"\\n}\\n\"),_=(o?_.replace(he,\"\"):_).replace(me,\"$1\").replace(be,\"$1;\"),_=\"function(\"+(h||\"obj\")+\") {\\n\"+(h?\"\":\"obj || (obj = {});\\n\")+\"var __t, __p = ''\"+(i?\", __e = _.escape\":\"\")+(o?\", __j = Array.prototype.join;\\nfunction print() { __p += __j.call(arguments, '') }\\n\":\";\\n\")+_+\"return __p\\n}\";var b=Qc(function(){return Pi(s,p+\"return \"+_).apply(D,d)});if(b.source=_,Na(b))throw b;return b}function Li(e,t,n){var r=e;return(e=u(e))?(n?$n(r,t,n):null==t)?e.slice(T(e),g(e)+1):(t+=\"\",e.slice(d(e,t),l(e,t)+1)):e}function Ai(e,t,n){var r=e;return e=u(e),e?(n?$n(r,t,n):null==t)?e.slice(T(e)):e.slice(d(e,t+\"\")):e}function yi(e,t,n){var r=e;return e=u(e),e?(n?$n(r,t,n):null==t)?e.slice(0,g(e)+1):e.slice(0,l(e,t+\"\")+1):e}function zi(e,t,n){n&&$n(e,t,n)&&(t=D);var r=X,a=R;if(null!=t)if(qa(t)){var i=\"separator\"in t?t.separator:i;r=\"length\"in t?+t.length||0:r,a=\"omission\"in t?u(t.omission):a}else r=+t||0;if(e=u(e),r>=e.length)return e;var o=r-a.length;if(o<1)return a;var c=e.slice(0,o);if(null==i)return c+a;if(xa(i)){if(e.slice(o).search(i)){var s,d,l=e.slice(0,o);for(i.global||(i=Gi(i.source,(qe.exec(i)||\"\")+\"g\")),i.lastIndex=0;s=i.exec(l);)d=s.index;c=c.slice(0,null==d?o:d)}}else if(e.indexOf(i,o)!=o){var M=c.lastIndexOf(i);M>-1&&(c=c.slice(0,M))}return c+a}function Ti(e){return e=u(e),e&&ye.test(e)?e.replace(Le,v):e}function gi(e,t,n){return n&&$n(e,t,n)&&(t=D),e=u(e),e.match(t||xe)||[]}function vi(e,t,n){return n&&$n(e,t,n)&&(t=D),L(e)?ki(e):At(e,t)}function Oi(e){return function(){return e}}function Di(e){return e}function ki(e){return Rt(yt(e,!0))}function Yi(e,t){return Ht(e,yt(t,!0))}function Si(e,t,n){if(null==n){var r=qa(t),a=r?Hc(t):D,i=a&&a.length?Wt(t,a):D;(i?i.length:r)||(i=!1,n=t,t=e,e=this)}i||(i=Wt(t,Hc(t)));var o=!0,c=-1,s=Wa(e),u=i.length;n===!1?o=!1:qa(n)&&\"chain\"in n&&(o=n.chain);for(;++c<u;){var d=i[c],l=t[d];e[d]=l,s&&(e.prototype[d]=function(t){return function(){var n=this.__chain__;if(o||n){var r=e(this.__wrapped__),a=r.__actions__=et(this.__actions__);return a.push({func:t,args:arguments,thisArg:e}),r.__chain__=n,r}return t.apply(e,ut([this.value()],arguments))}}(l))}return e}function Ni(){return rt._=ro,this}function wi(){}function Wi(e){return er(e)?Pt(e):Ft(e)}function qi(e){return function(t){return qt(e,Mr(t),t+\"\")}}function Ei(e,t,n){n&&$n(e,t,n)&&(t=n=D),e=+e||0,n=null==n?1:+n||0,null==t?(t=e,e=0):t=+t||0;for(var r=-1,a=zo(ho((t-e)/(n||1)),0),i=Hi(a);++r<a;)i[r]=e,e+=n;return i}function Bi(e,t,n){if(e=bo(e),e<1||!Ao(e))return[];var r=-1,a=Hi(To(e,Yo));for(t=on(t,n,1);++r<e;)r<Yo?a[r]=t(r):t(r);return a}function Ci(e){var t=++to;return u(e)+t}function Xi(e,t){return(+e||0)+(+t||0)}function Ri(e,t,n){return n&&$n(e,t,n)&&(t=D),t=xn(t,n,3),1==t.length?_t(Yc(e)?e:dr(e),t):Zt(e,t)}e=e?at.defaults(rt.Object(),e,at.pick(rt,je)):rt;var Hi=e.Array,xi=e.Date,ji=e.Error,Pi=e.Function,Fi=e.Math,Ui=e.Number,Ii=e.Object,Gi=e.RegExp,Ji=e.String,Vi=e.TypeError,Ki=Hi.prototype,Qi=Ii.prototype,Zi=Ji.prototype,$i=Pi.prototype.toString,eo=Qi.hasOwnProperty,to=0,no=Qi.toString,ro=rt._,ao=Gi(\"^\"+$i.call(eo).replace(/[\\\\^$.*+?()[\\]{}|]/g,\"\\\\$&\").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\"),io=e.ArrayBuffer,oo=e.clearTimeout,co=e.parseFloat,so=Fi.pow,uo=Qi.propertyIsEnumerable,lo=Un(e,\"Set\"),Mo=e.setTimeout,_o=Ki.splice,fo=e.Uint8Array,po=Un(e,\"WeakMap\"),ho=Fi.ceil,mo=Un(Ii,\"create\"),bo=Fi.floor,Lo=Un(Hi,\"isArray\"),Ao=e.isFinite,yo=Un(Ii,\"keys\"),zo=Fi.max,To=Fi.min,go=Un(xi,\"now\"),vo=e.parseInt,Oo=Fi.random,Do=Ui.NEGATIVE_INFINITY,ko=Ui.POSITIVE_INFINITY,Yo=4294967295,So=Yo-1,No=Yo>>>1,wo=9007199254740991,Wo=po&&new po,qo={};\nt.support={};t.templateSettings={escape:Te,evaluate:ge,interpolate:ve,variable:\"\",imports:{_:t}};var Eo=function(){function e(){}return function(t){if(qa(t)){e.prototype=t;var n=new e;e.prototype=D}return n||{}}}(),Bo=Mn(Nt),Co=Mn(wt,!0),Xo=_n(),Ro=_n(!0),Ho=Wo?function(e,t){return Wo.set(e,t),e}:Di,xo=Wo?function(e){return Wo.get(e)}:wi,jo=Pt(\"length\"),Po=function(){var e=0,t=0;return function(n,r){var a=pc(),i=x-(a-t);if(t=a,i>0){if(++e>=H)return n}else e=0;return Ho(n,r)}}(),Fo=ma(function(e,t){return L(e)&&Qn(e)?Tt(e,Yt(t,!1,!0)):[]}),Uo=zn(),Io=zn(!0),Go=ma(function(e){for(var t=e.length,n=t,r=Hi(l),a=Pn(),i=a==c,o=[];n--;){var s=e[n]=Qn(s=e[n])?s:[];r[n]=i&&s.length>=120?pn(n&&s):null}var u=e[0],d=-1,l=u?u.length:0,M=r[0];e:for(;++d<l;)if(s=u[d],(M?Qe(M,s):a(o,s,0))<0){for(var n=t;--n;){var _=r[n];if((_?Qe(_,s):a(e[n],s,0))<0)continue e}M&&M.push(s),o.push(s)}return o}),Jo=ma(function(e,t){t=Yt(t);var n=bt(e,t);return Ut(e,t.sort(i)),n}),Vo=Bn(),Ko=Bn(!0),Qo=ma(function(e){return $t(Yt(e,!1,!0))}),Zo=ma(function(e,t){return Qn(e)?Tt(e,t):[]}),$o=ma(Cr),ec=ma(function(e){var t=e.length,n=t>2?e[t-2]:D,r=t>1?e[t-1]:D;return t>2&&\"function\"==typeof n?t-=2:(n=t>1&&\"function\"==typeof r?(--t,r):D,r=D),e.length=t,Xr(e,n,r)}),tc=ma(function(e){return e=Yt(e),this.thru(function(t){return $e(Yc(t)?t:[lr(t)],e)})}),nc=ma(function(e,t){return bt(e,Yt(t))}),rc=dn(function(e,t,n){eo.call(e,n)?++e[n]:e[n]=1}),ac=yn(Bo),ic=yn(Co,!0),oc=vn(tt,Bo),cc=vn(nt,Co),sc=dn(function(e,t,n){eo.call(e,n)?e[n].push(t):e[n]=[t]}),uc=dn(function(e,t,n){e[n]=t}),dc=ma(function(e,t,n){var r=-1,a=\"function\"==typeof t,i=er(t),o=Qn(e)?Hi(e.length):[];return Bo(e,function(e){var c=a?t:i&&null!=e?e[t]:D;o[++r]=c?c.apply(e,n):Kn(e,t,n)}),o}),lc=dn(function(e,t,n){e[n?0:1].push(t)},function(){return[[],[]]}),Mc=Nn(dt,Bo),_c=Nn(lt,Co),fc=ma(function(e,t){if(null==e)return[];var n=t[2];return n&&$n(t[0],t[1],n)&&(t.length=1),Qt(e,Yt(t),[])}),pc=go||function(){return(new xi).getTime()},hc=ma(function(e,t,n){var r=Y;if(n.length){var a=y(n,hc.placeholder);r|=q}return Cn(e,r,t,n,a)}),mc=ma(function(e,t){t=t.length?Yt(t):Ka(e);for(var n=-1,r=t.length;++n<r;){var a=t[n];e[a]=Cn(e[a],Y,e)}return e}),bc=ma(function(e,t,n){var r=Y|S;if(n.length){var a=y(n,bc.placeholder);r|=q}return Cn(t,r,e,n,a)}),Lc=bn(w),Ac=bn(W),yc=ma(function(e,t){return zt(e,1,t)}),zc=ma(function(e,t,n){return zt(e,t,n)}),Tc=gn(),gc=gn(!0),vc=ma(function(e,t){if(t=Yt(t),\"function\"!=typeof e||!it(t,s))throw new Vi(U);var n=t.length;return ma(function(r){for(var a=To(r.length,n);a--;)r[a]=t[a](r[a]);return e.apply(this,r)})}),Oc=Sn(q),Dc=Sn(E),kc=ma(function(e,t){return Cn(e,C,D,D,D,Yt(t))}),Yc=Lo||function(e){return L(e)&&nr(e.length)&&no.call(e)==J},Sc=ln(xt),Nc=ln(function(e,t,n){return n?ht(e,t,n):mt(e,t)}),wc=Ln(Nc,ft),Wc=Ln(Sc,ir),qc=Tn(Nt),Ec=Tn(wt),Bc=On(Xo),Cc=On(Ro),Xc=Dn(Nt),Rc=Dn(wt),Hc=yo?function(e){var t=null==e?D:e.constructor;return\"function\"==typeof t&&t.prototype===e||\"function\"!=typeof e&&Qn(e)?ur(e):qa(e)?yo(e):[]}:ur,xc=kn(!0),jc=kn(),Pc=ma(function(e,t){if(null==e)return{};if(\"function\"!=typeof t[0]){var t=st(Yt(t),Ji);return or(e,Tt(ei(e),t))}var n=on(t[0],t[1],3);return cr(e,function(e,t,r){return!n(e,t,r)})}),Fc=ma(function(e,t){return null==e?{}:\"function\"==typeof t[0]?cr(e,on(t[0],t[1],3)):or(e,Yt(t))}),Uc=hn(function(e,t,n){return t=t.toLowerCase(),e+(n?t.charAt(0).toUpperCase()+t.slice(1):t)}),Ic=hn(function(e,t,n){return e+(n?\"-\":\"\")+t.toLowerCase()}),Gc=Yn(),Jc=Yn(!0),Vc=hn(function(e,t,n){return e+(n?\"_\":\"\")+t.toLowerCase()}),Kc=hn(function(e,t,n){return e+(n?\" \":\"\")+(t.charAt(0).toUpperCase()+t.slice(1))}),Qc=ma(function(e,t){try{return e.apply(D,t)}catch(n){return Na(n)?n:new ji(n)}}),Zc=ma(function(e,t){return function(n){return Kn(n,e,t)}}),$c=ma(function(e,t){return function(n){return Kn(e,n,t)}}),es=En(\"ceil\"),ts=En(\"floor\"),ns=An(Ta,Do),rs=An(Ua,ko),as=En(\"round\");return t.prototype=n.prototype,r.prototype=Eo(n.prototype),r.prototype.constructor=r,a.prototype=Eo(n.prototype),a.prototype.constructor=a,ie.prototype[\"delete\"]=Ie,ie.prototype.get=Ge,ie.prototype.has=Je,ie.prototype.set=Ve,Ke.prototype.push=Ze,fa.Cache=ie,t.after=da,t.ary=la,t.assign=Nc,t.at=nc,t.before=Ma,t.bind=hc,t.bindAll=mc,t.bindKey=bc,t.callback=vi,t.chain=xr,t.chunk=fr,t.compact=pr,t.constant=Oi,t.countBy=rc,t.create=Va,t.curry=Lc,t.curryRight=Ac,t.debounce=_a,t.defaults=wc,t.defaultsDeep=Wc,t.defer=yc,t.delay=zc,t.difference=Fo,t.drop=hr,t.dropRight=mr,t.dropRightWhile=br,t.dropWhile=Lr,t.fill=Ar,t.filter=Qr,t.flatten=zr,t.flattenDeep=Tr,t.flow=Tc,t.flowRight=gc,t.forEach=oc,t.forEachRight=cc,t.forIn=Bc,t.forInRight=Cc,t.forOwn=Xc,t.forOwnRight=Rc,t.functions=Ka,t.groupBy=sc,t.indexBy=uc,t.initial=vr,t.intersection=Go,t.invert=$a,t.invoke=dc,t.keys=Hc,t.keysIn=ei,t.map=ea,t.mapKeys=xc,t.mapValues=jc,t.matches=ki,t.matchesProperty=Yi,t.memoize=fa,t.merge=Sc,t.method=Zc,t.methodOf=$c,t.mixin=Si,t.modArgs=vc,t.negate=pa,t.omit=Pc,t.once=ha,t.pairs=ti,t.partial=Oc,t.partialRight=Dc,t.partition=lc,t.pick=Fc,t.pluck=ta,t.property=Wi,t.propertyOf=qi,t.pull=kr,t.pullAt=Jo,t.range=Ei,t.rearg=kc,t.reject=na,t.remove=Yr,t.rest=Sr,t.restParam=ma,t.set=ri,t.shuffle=aa,t.slice=Nr,t.sortBy=ca,t.sortByAll=fc,t.sortByOrder=sa,t.spread=ba,t.take=wr,t.takeRight=Wr,t.takeRightWhile=qr,t.takeWhile=Er,t.tap=jr,t.throttle=La,t.thru=Pr,t.times=Bi,t.toArray=Ga,t.toPlainObject=Ja,t.transform=ai,t.union=Qo,t.uniq=Br,t.unzip=Cr,t.unzipWith=Xr,t.values=ii,t.valuesIn=oi,t.where=ua,t.without=Zo,t.wrap=Aa,t.xor=Rr,t.zip=$o,t.zipObject=Hr,t.zipWith=ec,t.backflow=gc,t.collect=ea,t.compose=gc,t.each=oc,t.eachRight=cc,t.extend=Nc,t.iteratee=vi,t.methods=Ka,t.object=Hr,t.select=Qr,t.tail=Sr,t.unique=Br,Si(t,t),t.add=Xi,t.attempt=Qc,t.camelCase=Uc,t.capitalize=ui,t.ceil=es,t.clone=ya,t.cloneDeep=za,t.deburr=di,t.endsWith=li,t.escape=Mi,t.escapeRegExp=_i,t.every=Kr,t.find=ac,t.findIndex=Uo,t.findKey=qc,t.findLast=ic,t.findLastIndex=Io,t.findLastKey=Ec,t.findWhere=Zr,t.first=yr,t.floor=ts,t.get=Qa,t.gt=Ta,t.gte=ga,t.has=Za,t.identity=Di,t.includes=$r,t.indexOf=gr,t.inRange=ci,t.isArguments=va,t.isArray=Yc,t.isBoolean=Oa,t.isDate=Da,t.isElement=ka,t.isEmpty=Ya,t.isEqual=Sa,t.isError=Na,t.isFinite=wa,t.isFunction=Wa,t.isMatch=Ea,t.isNaN=Ba,t.isNative=Ca,t.isNull=Xa,t.isNumber=Ra,t.isObject=qa,t.isPlainObject=Ha,t.isRegExp=xa,t.isString=ja,t.isTypedArray=Pa,t.isUndefined=Fa,t.kebabCase=Ic,t.last=Or,t.lastIndexOf=Dr,t.lt=Ua,t.lte=Ia,t.max=ns,t.min=rs,t.noConflict=Ni,t.noop=wi,t.now=pc,t.pad=fi,t.padLeft=Gc,t.padRight=Jc,t.parseInt=pi,t.random=si,t.reduce=Mc,t.reduceRight=_c,t.repeat=hi,t.result=ni,t.round=as,t.runInContext=O,t.size=ia,t.snakeCase=Vc,t.some=oa,t.sortedIndex=Vo,t.sortedLastIndex=Ko,t.startCase=Kc,t.startsWith=mi,t.sum=Ri,t.template=bi,t.trim=Li,t.trimLeft=Ai,t.trimRight=yi,t.trunc=zi,t.unescape=Ti,t.uniqueId=Ci,t.words=gi,t.all=Kr,t.any=oa,t.contains=$r,t.eq=Sa,t.detect=ac,t.foldl=Mc,t.foldr=_c,t.head=yr,t.include=$r,t.inject=Mc,Si(t,function(){var e={};return Nt(t,function(n,r){t.prototype[r]||(e[r]=n)}),e}(),!1),t.sample=ra,t.prototype.sample=function(e){return this.__chain__||null!=e?this.thru(function(t){return ra(t,e)}):ra(this.value())},t.VERSION=k,tt([\"bind\",\"bindKey\",\"curry\",\"curryRight\",\"partial\",\"partialRight\"],function(e){t[e].placeholder=t}),tt([\"drop\",\"take\"],function(e,t){a.prototype[e]=function(n){var r=this.__filtered__;if(r&&!t)return new a(this);n=null==n?1:zo(bo(n)||0,0);var i=this.clone();return r?i.__takeCount__=To(i.__takeCount__,n):i.__views__.push({size:n,type:e+(i.__dir__<0?\"Right\":\"\")}),i},a.prototype[e+\"Right\"]=function(t){return this.reverse()[e](t).reverse()}}),tt([\"filter\",\"map\",\"takeWhile\"],function(e,t){var n=t+1,r=n!=F;a.prototype[e]=function(e,t){var a=this.clone();return a.__iteratees__.push({iteratee:xn(e,t,1),type:n}),a.__filtered__=a.__filtered__||r,a}}),tt([\"first\",\"last\"],function(e,t){var n=\"take\"+(t?\"Right\":\"\");a.prototype[e]=function(){return this[n](1).value()[0]}}),tt([\"initial\",\"rest\"],function(e,t){var n=\"drop\"+(t?\"\":\"Right\");a.prototype[e]=function(){return this.__filtered__?new a(this):this[n](1)}}),tt([\"pluck\",\"where\"],function(e,t){var n=t?\"filter\":\"map\",r=t?Rt:Wi;a.prototype[e]=function(e){return this[n](r(e))}}),a.prototype.compact=function(){return this.filter(Di)},a.prototype.reject=function(e,t){return e=xn(e,t,1),this.filter(function(t){return!e(t)})},a.prototype.slice=function(e,t){e=null==e?0:+e||0;var n=this;return n.__filtered__&&(e>0||t<0)?new a(n):(e<0?n=n.takeRight(-e):e&&(n=n.drop(e)),t!==D&&(t=+t||0,n=t<0?n.dropRight(-t):n.take(t-e)),n)},a.prototype.takeRightWhile=function(e,t){return this.reverse().takeWhile(e,t).reverse()},a.prototype.toArray=function(){return this.take(ko)},Nt(a.prototype,function(e,n){var i=/^(?:filter|map|reject)|While$/.test(n),o=/^(?:first|last)$/.test(n),c=t[o?\"take\"+(\"last\"==n?\"Right\":\"\"):n];c&&(t.prototype[n]=function(){var t=o?[1]:arguments,n=this.__chain__,s=this.__wrapped__,u=!!this.__actions__.length,d=s instanceof a,l=t[0],M=d||Yc(s);M&&i&&\"function\"==typeof l&&1!=l.length&&(d=M=!1);var _=function(e){return o&&n?c(e,1)[0]:c.apply(D,ut([e],t))},f={func:Pr,args:[_],thisArg:D},p=d&&!u;if(o&&!n)return p?(s=s.clone(),s.__actions__.push(f),e.call(s)):c.call(D,this.value())[0];if(!o&&M){s=p?s:new a(this);var h=e.apply(s,t);return h.__actions__.push(f),new r(h,n)}return this.thru(_)})}),tt([\"join\",\"pop\",\"push\",\"replace\",\"shift\",\"sort\",\"splice\",\"split\",\"unshift\"],function(e){var n=(/^(?:replace|split)$/.test(e)?Zi:Ki)[e],r=/^(?:push|sort|unshift)$/.test(e)?\"tap\":\"thru\",a=/^(?:join|pop|replace|shift)$/.test(e);t.prototype[e]=function(){var e=arguments;return a&&!this.__chain__?n.apply(this.value(),e):this[r](function(t){return n.apply(t,e)})}}),Nt(a.prototype,function(e,n){var r=t[n];if(r){var a=r.name,i=qo[a]||(qo[a]=[]);i.push({name:n,func:r})}}),qo[wn(D,S).name]=[{name:\"wrapper\",func:D}],a.prototype.clone=A,a.prototype.reverse=$,a.prototype.value=re,t.prototype.chain=Fr,t.prototype.commit=Ur,t.prototype.concat=tc,t.prototype.plant=Ir,t.prototype.reverse=Gr,t.prototype.toString=Jr,t.prototype.run=t.prototype.toJSON=t.prototype.valueOf=t.prototype.value=Vr,t.prototype.collect=t.prototype.map,t.prototype.head=t.prototype.first,t.prototype.select=t.prototype.filter,t.prototype.tail=t.prototype.rest,t}var D,k=\"3.10.1\",Y=1,S=2,N=4,w=8,W=16,q=32,E=64,B=128,C=256,X=30,R=\"...\",H=150,x=16,j=200,P=1,F=2,U=\"Expected a function\",I=\"__lodash_placeholder__\",G=\"[object Arguments]\",J=\"[object Array]\",V=\"[object Boolean]\",K=\"[object Date]\",Q=\"[object Error]\",Z=\"[object Function]\",$=\"[object Map]\",ee=\"[object Number]\",te=\"[object Object]\",ne=\"[object RegExp]\",re=\"[object Set]\",ae=\"[object String]\",ie=\"[object WeakMap]\",oe=\"[object ArrayBuffer]\",ce=\"[object Float32Array]\",se=\"[object Float64Array]\",ue=\"[object Int8Array]\",de=\"[object Int16Array]\",le=\"[object Int32Array]\",Me=\"[object Uint8Array]\",_e=\"[object Uint8ClampedArray]\",fe=\"[object Uint16Array]\",pe=\"[object Uint32Array]\",he=/\\b__p \\+= '';/g,me=/\\b(__p \\+=) '' \\+/g,be=/(__e\\(.*?\\)|\\b__t\\)) \\+\\n'';/g,Le=/&(?:amp|lt|gt|quot|#39|#96);/g,Ae=/[&<>\"'`]/g,ye=RegExp(Le.source),ze=RegExp(Ae.source),Te=/<%-([\\s\\S]+?)%>/g,ge=/<%([\\s\\S]+?)%>/g,ve=/<%=([\\s\\S]+?)%>/g,Oe=/\\.|\\[(?:[^[\\]]*|([\"'])(?:(?!\\1)[^\\n\\\\]|\\\\.)*?\\1)\\]/,De=/^\\w*$/,ke=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\n\\\\]|\\\\.)*?)\\2)\\]/g,Ye=/^[:!,]|[\\\\^$.*+?()[\\]{}|\\/]|(^[0-9a-fA-Fnrtuvx])|([\\n\\r\\u2028\\u2029])/g,Se=RegExp(Ye.source),Ne=/[\\u0300-\\u036f\\ufe20-\\ufe23]/g,we=/\\\\(\\\\)?/g,We=/\\$\\{([^\\\\}]*(?:\\\\.[^\\\\}]*)*)\\}/g,qe=/\\w*$/,Ee=/^0[xX]/,Be=/^\\[object .+?Constructor\\]$/,Ce=/^\\d+$/,Xe=/[\\xc0-\\xd6\\xd8-\\xde\\xdf-\\xf6\\xf8-\\xff]/g,Re=/($^)/,He=/['\\n\\r\\u2028\\u2029\\\\]/g,xe=function(){var e=\"[A-Z\\\\xc0-\\\\xd6\\\\xd8-\\\\xde]\",t=\"[a-z\\\\xdf-\\\\xf6\\\\xf8-\\\\xff]+\";return RegExp(e+\"+(?=\"+e+t+\")|\"+e+\"?\"+t+\"|\"+e+\"+|[0-9]+\",\"g\")}(),je=[\"Array\",\"ArrayBuffer\",\"Date\",\"Error\",\"Float32Array\",\"Float64Array\",\"Function\",\"Int8Array\",\"Int16Array\",\"Int32Array\",\"Math\",\"Number\",\"Object\",\"RegExp\",\"Set\",\"String\",\"_\",\"clearTimeout\",\"isFinite\",\"parseFloat\",\"parseInt\",\"setTimeout\",\"TypeError\",\"Uint8Array\",\"Uint8ClampedArray\",\"Uint16Array\",\"Uint32Array\",\"WeakMap\"],Pe=-1,Fe={};Fe[ce]=Fe[se]=Fe[ue]=Fe[de]=Fe[le]=Fe[Me]=Fe[_e]=Fe[fe]=Fe[pe]=!0,Fe[G]=Fe[J]=Fe[oe]=Fe[V]=Fe[K]=Fe[Q]=Fe[Z]=Fe[$]=Fe[ee]=Fe[te]=Fe[ne]=Fe[re]=Fe[ae]=Fe[ie]=!1;var Ue={};Ue[G]=Ue[J]=Ue[oe]=Ue[V]=Ue[K]=Ue[ce]=Ue[se]=Ue[ue]=Ue[de]=Ue[le]=Ue[ee]=Ue[te]=Ue[ne]=Ue[ae]=Ue[Me]=Ue[_e]=Ue[fe]=Ue[pe]=!0,Ue[Q]=Ue[Z]=Ue[$]=Ue[re]=Ue[ie]=!1;var Ie={\"À\":\"A\",\"Á\":\"A\",\"Â\":\"A\",\"Ã\":\"A\",\"Ä\":\"A\",\"Å\":\"A\",\"à\":\"a\",\"á\":\"a\",\"â\":\"a\",\"ã\":\"a\",\"ä\":\"a\",\"å\":\"a\",\"Ç\":\"C\",\"ç\":\"c\",\"Ð\":\"D\",\"ð\":\"d\",\"È\":\"E\",\"É\":\"E\",\"Ê\":\"E\",\"Ë\":\"E\",\"è\":\"e\",\"é\":\"e\",\"ê\":\"e\",\"ë\":\"e\",\"Ì\":\"I\",\"Í\":\"I\",\"Î\":\"I\",\"Ï\":\"I\",\"ì\":\"i\",\"í\":\"i\",\"î\":\"i\",\"ï\":\"i\",\"Ñ\":\"N\",\"ñ\":\"n\",\"Ò\":\"O\",\"Ó\":\"O\",\"Ô\":\"O\",\"Õ\":\"O\",\"Ö\":\"O\",\"Ø\":\"O\",\"ò\":\"o\",\"ó\":\"o\",\"ô\":\"o\",\"õ\":\"o\",\"ö\":\"o\",\"ø\":\"o\",\"Ù\":\"U\",\"Ú\":\"U\",\"Û\":\"U\",\"Ü\":\"U\",\"ù\":\"u\",\"ú\":\"u\",\"û\":\"u\",\"ü\":\"u\",\"Ý\":\"Y\",\"ý\":\"y\",\"ÿ\":\"y\",\"Æ\":\"Ae\",\"æ\":\"ae\",\"Þ\":\"Th\",\"þ\":\"th\",\"ß\":\"ss\"},Ge={\"&\":\"&amp;\",\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#39;\",\"`\":\"&#96;\"},Je={\"&amp;\":\"&\",\"&lt;\":\"<\",\"&gt;\":\">\",\"&quot;\":'\"',\"&#39;\":\"'\",\"&#96;\":\"`\"},Ve={\"function\":!0,object:!0},Ke={0:\"x30\",1:\"x31\",2:\"x32\",3:\"x33\",4:\"x34\",5:\"x35\",6:\"x36\",7:\"x37\",8:\"x38\",9:\"x39\",A:\"x41\",B:\"x42\",C:\"x43\",D:\"x44\",E:\"x45\",F:\"x46\",a:\"x61\",b:\"x62\",c:\"x63\",d:\"x64\",e:\"x65\",f:\"x66\",n:\"x6e\",r:\"x72\",t:\"x74\",u:\"x75\",v:\"x76\",x:\"x78\"},Qe={\"\\\\\":\"\\\\\",\"'\":\"'\",\"\\n\":\"n\",\"\\r\":\"r\",\"\\u2028\":\"u2028\",\"\\u2029\":\"u2029\"},Ze=Ve[typeof t]&&t&&!t.nodeType&&t,$e=Ve[typeof e]&&e&&!e.nodeType&&e,et=Ze&&$e&&\"object\"==typeof a&&a&&a.Object&&a,tt=Ve[typeof self]&&self&&self.Object&&self,nt=Ve[typeof window]&&window&&window.Object&&window,rt=($e&&$e.exports===Ze&&Ze,et||nt!==(this&&this.window)&&nt||tt||this),at=O();rt._=at,r=function(){return at}.call(t,n,t,e),!(r!==D&&(e.exports=r))}).call(this)}).call(t,n(47)(e),function(){return this}())},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}},function(e,t,n){!function(e,n){n(t)}(this,function(e){\"use strict\";function t(e,t){return e<t?-1:e>t?1:e>=t?0:NaN}function n(e){return 1===e.length&&(e=r(e)),{left:function(t,n,r,a){for(null==r&&(r=0),null==a&&(a=t.length);r<a;){var i=r+a>>>1;e(t[i],n)<0?r=i+1:a=i}return r},right:function(t,n,r,a){for(null==r&&(r=0),null==a&&(a=t.length);r<a;){var i=r+a>>>1;e(t[i],n)>0?a=i:r=i+1}return r}}}function r(e){return function(n,r){return t(e(n),r)}}function a(e,t){return t<e?-1:t>e?1:t>=e?0:NaN}function i(e){return null===e?NaN:+e}function o(e,t){var n,r,a=e.length,o=0,c=0,s=-1,u=0;if(null==t)for(;++s<a;)isNaN(n=i(e[s]))||(r=n-o,o+=r/++u,c+=r*(n-o));else for(;++s<a;)isNaN(n=i(t(e[s],s,e)))||(r=n-o,o+=r/++u,c+=r*(n-o));if(u>1)return c/(u-1)}function c(e,t){var n=o(e,t);return n?Math.sqrt(n):n}function s(e,t){var n,r,a,i=-1,o=e.length;if(null==t){for(;++i<o;)if(null!=(r=e[i])&&r>=r){n=a=r;break}for(;++i<o;)null!=(r=e[i])&&(n>r&&(n=r),a<r&&(a=r))}else{for(;++i<o;)if(null!=(r=t(e[i],i,e))&&r>=r){n=a=r;break}for(;++i<o;)null!=(r=t(e[i],i,e))&&(n>r&&(n=r),a<r&&(a=r))}return[n,a]}function u(e){return function(){return e}}function d(e){return e}function l(e,t,n){e=+e,t=+t,n=(a=arguments.length)<2?(t=e,e=0,1):a<3?1:+n;for(var r=-1,a=0|Math.max(0,Math.ceil((t-e)/n)),i=new Array(a);++r<a;)i[r]=e+r*n;return i}function M(e,t,n){var r=_(e,t,n);return l(Math.ceil(e/r)*r,Math.floor(t/r)*r+r/2,r)}function _(e,t,n){var r=Math.abs(t-e)/Math.max(0,n),a=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),i=r/a;return i>=X?a*=10:i>=R?a*=5:i>=H&&(a*=2),t<e?-a:a}function f(e){return Math.ceil(Math.log(e.length)/Math.LN2)+1}function p(){function e(e){var a,i,o=e.length,c=new Array(o);for(a=0;a<o;++a)c[a]=t(e[a],a,e);var s=n(c),u=s[0],d=s[1],l=r(c,u,d);Array.isArray(l)||(l=M(u,d,l));for(var _=l.length;l[0]<=u;)l.shift(),--_;for(;l[_-1]>=d;)l.pop(),--_;var f,p=new Array(_+1);for(a=0;a<=_;++a)f=p[a]=[],f.x0=a>0?l[a-1]:u,f.x1=a<_?l[a]:d;for(a=0;a<o;++a)i=c[a],u<=i&&i<=d&&p[W(l,i,0,_)].push(e[a]);return p}var t=d,n=s,r=f;return e.value=function(n){return arguments.length?(t=\"function\"==typeof n?n:u(n),e):t},e.domain=function(t){return arguments.length?(n=\"function\"==typeof t?t:u([t[0],t[1]]),e):n},e.thresholds=function(t){return arguments.length?(r=\"function\"==typeof t?t:u(Array.isArray(t)?B.call(t):t),e):r},e}function h(e,t,n){if(null==n&&(n=i),r=e.length){if((t=+t)<=0||r<2)return+n(e[0],0,e);if(t>=1)return+n(e[r-1],r-1,e);var r,a=(r-1)*t,o=Math.floor(a),c=+n(e[o],o,e),s=+n(e[o+1],o+1,e);return c+(s-c)*(a-o)}}function m(e,n,r){return e=C.call(e,i).sort(t),Math.ceil((r-n)/(2*(h(e,.75)-h(e,.25))*Math.pow(e.length,-1/3)))}function b(e,t,n){return Math.ceil((n-t)/(3.5*c(e)*Math.pow(e.length,-1/3)))}function L(e,t){var n,r,a=-1,i=e.length;if(null==t){for(;++a<i;)if(null!=(r=e[a])&&r>=r){n=r;break}for(;++a<i;)null!=(r=e[a])&&r>n&&(n=r)}else{for(;++a<i;)if(null!=(r=t(e[a],a,e))&&r>=r){n=r;break}for(;++a<i;)null!=(r=t(e[a],a,e))&&r>n&&(n=r)}return n}function A(e,t){var n,r=0,a=e.length,o=-1,c=a;if(null==t)for(;++o<a;)isNaN(n=i(e[o]))?--c:r+=n;else for(;++o<a;)isNaN(n=i(t(e[o],o,e)))?--c:r+=n;if(c)return r/c}function y(e,n){var r,a=[],o=e.length,c=-1;if(null==n)for(;++c<o;)isNaN(r=i(e[c]))||a.push(r);else for(;++c<o;)isNaN(r=i(n(e[c],c,e)))||a.push(r);return h(a.sort(t),.5)}function z(e){for(var t,n,r,a=e.length,i=-1,o=0;++i<a;)o+=e[i].length;for(n=new Array(o);--a>=0;)for(r=e[a],t=r.length;--t>=0;)n[--o]=r[t];return n}function T(e,t){var n,r,a=-1,i=e.length;if(null==t){for(;++a<i;)if(null!=(r=e[a])&&r>=r){n=r;break}for(;++a<i;)null!=(r=e[a])&&n>r&&(n=r)}else{for(;++a<i;)if(null!=(r=t(e[a],a,e))&&r>=r){n=r;break}for(;++a<i;)null!=(r=t(e[a],a,e))&&n>r&&(n=r)}return n}function g(e){for(var t=0,n=e.length-1,r=e[0],a=new Array(n<0?0:n);t<n;)a[t]=[r,r=e[++t]];return a}function v(e,t){for(var n=t.length,r=new Array(n);n--;)r[n]=e[t[n]];return r}function O(e,n){if(r=e.length){var r,a,i=0,o=0,c=e[o];for(n||(n=t);++i<r;)(n(a=e[i],c)<0||0!==n(c,c))&&(c=a,o=i);return 0===n(c,c)?o:void 0}}function D(e,t,n){for(var r,a,i=(null==n?e.length:n)-(t=null==t?0:+t);i;)a=Math.random()*i--|0,r=e[i+t],e[i+t]=e[a+t],e[a+t]=r;return e}function k(e,t){var n,r=0,a=e.length,i=-1;if(null==t)for(;++i<a;)(n=+e[i])&&(r+=n);else for(;++i<a;)(n=+t(e[i],i,e))&&(r+=n);return r}function Y(e){if(!(a=e.length))return[];for(var t=-1,n=T(e,S),r=new Array(n);++t<n;)for(var a,i=-1,o=r[t]=new Array(a);++i<a;)o[i]=e[i][t];return r}function S(e){return e.length}function N(){return Y(arguments)}var w=n(t),W=w.right,q=w.left,E=Array.prototype,B=E.slice,C=E.map,X=Math.sqrt(50),R=Math.sqrt(10),H=Math.sqrt(2);e.bisect=W,e.bisectRight=W,e.bisectLeft=q,e.ascending=t,e.bisector=n,e.descending=a,e.deviation=c,e.extent=s,e.histogram=p,e.thresholdFreedmanDiaconis=m,e.thresholdScott=b,e.thresholdSturges=f,e.max=L,e.mean=A,e.median=y,e.merge=z,e.min=T,e.pairs=g,e.permute=v,e.quantile=h,e.range=l,e.scan=O,e.shuffle=D,e.sum=k,e.ticks=M,e.tickStep=_,e.transpose=Y,e.variance=o,e.zip=N,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,r){r(t,n(48),n(50),n(51),n(53),n(54),n(55),n(52))}(this,function(e,t,n,r,a,i,o,c){\"use strict\";function s(e){function t(t){var n=t+\"\",o=r.get(n);if(!o){if(i!==Q)return i;r.set(n,o=a.push(t))}return e[(o-1)%e.length]}var r=n.map(),a=[],i=Q;return e=null==e?[]:K.call(e),t.domain=function(e){if(!arguments.length)return a.slice();a=[],r=n.map();for(var i,o,c=-1,s=e.length;++c<s;)r.has(o=(i=e[c])+\"\")||r.set(o,a.push(i));return t},t.range=function(n){return arguments.length?(e=K.call(n),t):e.slice()},t.unknown=function(e){return arguments.length?(i=e,t):i},t.copy=function(){return s().domain(a).range(e).unknown(i)},t}function u(){function e(){var e=i().length,a=c[1]<c[0],s=c[a-0],u=c[1-a];n=(u-s)/Math.max(1,e-l+2*M),d&&(n=Math.floor(n)),s+=(u-s-n*(e-l))*_,r=n*(1-l),d&&(s=Math.round(s),r=Math.round(r));var f=t.range(e).map(function(e){return s+n*e});return o(a?f.reverse():f)}var n,r,a=s().unknown(void 0),i=a.domain,o=a.range,c=[0,1],d=!1,l=0,M=0,_=.5;return delete a.unknown,a.domain=function(t){return arguments.length?(i(t),e()):i()},a.range=function(t){return arguments.length?(c=[+t[0],+t[1]],e()):c.slice()},a.rangeRound=function(t){return c=[+t[0],+t[1]],d=!0,e()},a.bandwidth=function(){return r},a.step=function(){return n},a.round=function(t){return arguments.length?(d=!!t,e()):d},a.padding=function(t){return arguments.length?(l=M=Math.max(0,Math.min(1,t)),e()):l},a.paddingInner=function(t){return arguments.length?(l=Math.max(0,Math.min(1,t)),e()):l},a.paddingOuter=function(t){return arguments.length?(M=Math.max(0,Math.min(1,t)),e()):M},a.align=function(t){return arguments.length?(_=Math.max(0,Math.min(1,t)),e()):_},a.copy=function(){return u().domain(i()).range(c).round(d).paddingInner(l).paddingOuter(M).align(_)},e()}function d(e){var t=e.copy;return e.padding=e.paddingOuter,delete e.paddingInner,delete e.paddingOuter,e.copy=function(){return d(t())},e}function l(){return d(u().paddingInner(1))}function M(e){return function(){return e}}function _(e){return+e}function f(e,t){return(t-=e=+e)?function(n){return(n-e)/t}:M(t)}function p(e){return function(t,n){var r=e(t=+t,n=+n);return function(e){return e<=t?0:e>=n?1:r(e)}}}function h(e){return function(t,n){var r=e(t=+t,n=+n);return function(e){return e<=0?t:e>=1?n:r(e)}}}function m(e,t,n,r){var a=e[0],i=e[1],o=t[0],c=t[1];return i<a?(a=n(i,a),o=r(c,o)):(a=n(a,i),o=r(o,c)),function(e){return o(a(e))}}function b(e,n,r,a){var i=Math.min(e.length,n.length)-1,o=new Array(i),c=new Array(i),s=-1;for(e[i]<e[0]&&(e=e.slice().reverse(),n=n.slice().reverse());++s<i;)o[s]=r(e[s],e[s+1]),c[s]=a(n[s],n[s+1]);return function(n){var r=t.bisect(e,n,1,i)-1;return c[r](o[r](n))}}function L(e,t){return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp())}function A(e,t){function n(){return i=Math.min(s.length,u.length)>2?b:m,o=c=null,a}function a(t){return(o||(o=i(s,u,l?p(e):e,d)))(+t)}var i,o,c,s=Z,u=Z,d=r.interpolate,l=!1;return a.invert=function(e){return(c||(c=i(u,s,f,l?h(t):t)))(+e)},a.domain=function(e){return arguments.length?(s=V.call(e,_),n()):s.slice()},a.range=function(e){return arguments.length?(u=K.call(e),n()):u.slice()},a.rangeRound=function(e){return u=K.call(e),d=r.interpolateRound,n()},a.clamp=function(e){return arguments.length?(l=!!e,n()):l},a.interpolate=function(e){return arguments.length?(d=e,n()):d},n()}function y(e,n,r){var i,o=e[0],c=e[e.length-1],s=t.tickStep(o,c,null==n?10:n);switch(r=a.formatSpecifier(null==r?\",f\":r),r.type){case\"s\":var u=Math.max(Math.abs(o),Math.abs(c));return null!=r.precision||isNaN(i=a.precisionPrefix(s,u))||(r.precision=i),a.formatPrefix(r,u);case\"\":case\"e\":case\"g\":case\"p\":case\"r\":null!=r.precision||isNaN(i=a.precisionRound(s,Math.max(Math.abs(o),Math.abs(c))))||(r.precision=i-(\"e\"===r.type));break;case\"f\":case\"%\":null!=r.precision||isNaN(i=a.precisionFixed(s))||(r.precision=i-2*(\"%\"===r.type))}return a.format(r)}function z(e){var n=e.domain;return e.ticks=function(e){var r=n();return t.ticks(r[0],r[r.length-1],null==e?10:e)},e.tickFormat=function(e,t){return y(n(),e,t)},e.nice=function(r){var a=n(),i=a.length-1,o=null==r?10:r,c=a[0],s=a[i],u=t.tickStep(c,s,o);return u&&(u=t.tickStep(Math.floor(c/u)*u,Math.ceil(s/u)*u,o),a[0]=Math.floor(c/u)*u,a[i]=Math.ceil(s/u)*u,n(a)),e},e}function T(){var e=A(f,r.interpolateNumber);return e.copy=function(){return L(e,T())},z(e)}function g(){function e(e){return+e}var t=[0,1];return e.invert=e,e.domain=e.range=function(n){return arguments.length?(t=V.call(n,_),e):t.slice()},e.copy=function(){return g().domain(t)},z(e)}function v(e,t){e=e.slice();var n,r=0,a=e.length-1,i=e[r],o=e[a];return o<i&&(n=r,r=a,a=n,n=i,i=o,o=n),e[r]=t.floor(i),e[a]=t.ceil(o),e}function O(e,t){return(t=Math.log(t/e))?function(n){return Math.log(n/e)/t}:M(t)}function D(e,t){return e<0?function(n){return-Math.pow(-t,n)*Math.pow(-e,1-n)}:function(n){return Math.pow(t,n)*Math.pow(e,1-n)}}function k(e){return isFinite(e)?+(\"1e\"+e):e<0?0:e}function Y(e){return 10===e?k:e===Math.E?Math.exp:function(t){return Math.pow(e,t)}}function S(e){return e===Math.E?Math.log:10===e&&Math.log10||2===e&&Math.log2||(e=Math.log(e),function(t){return Math.log(t)/e})}function N(e){return function(t){return-e(-t)}}function w(){function e(){return o=S(i),c=Y(i),r()[0]<0&&(o=N(o),c=N(c)),n}var n=A(O,D).domain([1,10]),r=n.domain,i=10,o=S(10),c=Y(10);return n.base=function(t){return arguments.length?(i=+t,e()):i},n.domain=function(t){return arguments.length?(r(t),e()):r()},n.ticks=function(e){var n,a=r(),s=a[0],u=a[a.length-1];(n=u<s)&&(_=s,s=u,u=_);var d,l,M,_=o(s),f=o(u),p=null==e?10:+e,h=[];if(!(i%1)&&f-_<p){if(_=Math.round(_)-1,f=Math.round(f)+1,s>0){for(;_<f;++_)for(l=1,d=c(_);l<i;++l)if(M=d*l,!(M<s)){if(M>u)break;h.push(M)}}else for(;_<f;++_)for(l=i-1,d=c(_);l>=1;--l)if(M=d*l,!(M<s)){if(M>u)break;h.push(M)}}else h=t.ticks(_,f,Math.min(f-_,p)).map(c);return n?h.reverse():h},n.tickFormat=function(e,t){if(null==t&&(t=10===i?\".0e\":\",\"),\"function\"!=typeof t&&(t=a.format(t)),e===1/0)return t;null==e&&(e=10);var r=Math.max(1,i*e/n.ticks().length);return function(e){var n=e/c(Math.round(o(e)));return n*i<i-.5&&(n*=i),n<=r?t(e):\"\"}},n.nice=function(){return r(v(r(),{floor:function(e){return c(Math.floor(o(e)))},ceil:function(e){return c(Math.ceil(o(e)))}}))},n.copy=function(){return L(n,w().base(i))},n}function W(e,t){return e<0?-Math.pow(-e,t):Math.pow(e,t)}function q(){function e(e,t){return(t=W(t,n)-(e=W(e,n)))?function(r){return(W(r,n)-e)/t}:M(t)}function t(e,t){return t=W(t,n)-(e=W(e,n)),function(r){return W(e+t*r,1/n)}}var n=1,r=A(e,t),a=r.domain;return r.exponent=function(e){return arguments.length?(n=+e,a(a())):n},r.copy=function(){return L(r,q().exponent(n))},z(r)}function E(){return q().exponent(.5)}function B(){function e(){var e=0,o=Math.max(1,a.length);for(i=new Array(o-1);++e<o;)i[e-1]=t.quantile(r,e/o);return n}function n(e){if(!isNaN(e=+e))return a[t.bisect(i,e)]}var r=[],a=[],i=[];return n.invertExtent=function(e){var t=a.indexOf(e);return t<0?[NaN,NaN]:[t>0?i[t-1]:r[0],t<i.length?i[t]:r[r.length-1]]},n.domain=function(n){if(!arguments.length)return r.slice();r=[];for(var a,i=0,o=n.length;i<o;++i)a=n[i],null==a||isNaN(a=+a)||r.push(a);return r.sort(t.ascending),e()},n.range=function(t){return arguments.length?(a=K.call(t),e()):a.slice()},n.quantiles=function(){return i.slice()},n.copy=function(){return B().domain(r).range(a)},n}function C(){function e(e){if(e<=e)return c[t.bisect(o,e,0,i)]}function n(){var t=-1;for(o=new Array(i);++t<i;)o[t]=((t+1)*a-(t-i)*r)/(i+1);return e}var r=0,a=1,i=1,o=[.5],c=[0,1];return e.domain=function(e){return arguments.length?(r=+e[0],a=+e[1],n()):[r,a]},e.range=function(e){return arguments.length?(i=(c=K.call(e)).length-1,n()):c.slice()},e.invertExtent=function(e){var t=c.indexOf(e);return t<0?[NaN,NaN]:t<1?[r,o[0]]:t>=i?[o[i-1],a]:[o[t-1],o[t]]},e.copy=function(){return C().domain([r,a]).range(c)},z(e)}function X(){function e(e){if(e<=e)return r[t.bisect(n,e,0,a)]}var n=[.5],r=[0,1],a=1;return e.domain=function(t){return arguments.length?(n=K.call(t),a=Math.min(n.length,r.length-1),e):n.slice()},e.range=function(t){return arguments.length?(r=K.call(t),a=Math.min(n.length,r.length-1),e):r.slice()},e.invertExtent=function(e){var t=r.indexOf(e);return[n[t-1],n[t]]},e.copy=function(){return X().domain(n).range(r)},e}function R(e){return new Date(e)}function H(e){return e instanceof Date?+e:+new Date((+e))}function x(e,n,a,i,o,c,s,u,d){function l(t){return(s(t)<t?m:c(t)<t?b:o(t)<t?y:i(t)<t?z:n(t)<t?a(t)<t?T:g:e(t)<t?O:D)(t)}function M(n,r,a,i){if(null==n&&(n=10),\"number\"==typeof n){var o=Math.abs(a-r)/n,c=t.bisector(function(e){return e[2]}).right(k,o);c===k.length?(i=t.tickStep(r/ie,a/ie,n),n=e):c?(c=k[o/k[c-1][2]<k[c][2]/o?c-1:c],i=c[1],n=c[0]):(i=t.tickStep(r,a,n),n=u)}return null==i?n:n.every(i)}var _=A(f,r.interpolateNumber),p=_.invert,h=_.domain,m=d(\".%L\"),b=d(\":%S\"),y=d(\"%I:%M\"),z=d(\"%I %p\"),T=d(\"%a %d\"),g=d(\"%b %d\"),O=d(\"%B\"),D=d(\"%Y\"),k=[[s,1,$],[s,5,5*$],[s,15,15*$],[s,30,30*$],[c,1,ee],[c,5,5*ee],[c,15,15*ee],[c,30,30*ee],[o,1,te],[o,3,3*te],[o,6,6*te],[o,12,12*te],[i,1,ne],[i,2,2*ne],[a,1,re],[n,1,ae],[n,3,3*ae],[e,1,ie]];return _.invert=function(e){return new Date(p(e))},_.domain=function(e){return arguments.length?h(V.call(e,H)):h().map(R)},_.ticks=function(e,t){var n,r=h(),a=r[0],i=r[r.length-1],o=i<a;return o&&(n=a,a=i,i=n),n=M(e,a,i,t),n=n?n.range(a,i+1):[],o?n.reverse():n},_.tickFormat=function(e,t){return null==t?l:d(t)},_.nice=function(e,t){var n=h();return(e=M(e,n[0],n[n.length-1],t))?h(v(n,e)):_},_.copy=function(){return L(_,x(e,n,a,i,o,c,s,u,d))},_}function j(){return x(i.timeYear,i.timeMonth,i.timeWeek,i.timeDay,i.timeHour,i.timeMinute,i.timeSecond,i.timeMillisecond,o.timeFormat).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}function P(){return x(i.utcYear,i.utcMonth,i.utcWeek,i.utcDay,i.utcHour,i.utcMinute,i.utcSecond,i.utcMillisecond,o.utcFormat).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}function F(e){return e.match(/.{6}/g).map(function(e){return\"#\"+e})}function U(e){(e<0||e>1)&&(e-=Math.floor(e));var t=Math.abs(e-.5);return _e.h=360*e-100,_e.s=1.5-1.5*t,_e.l=.8-.9*t,_e+\"\"}function I(e){var t=e.length;return function(n){return e[Math.max(0,Math.min(t-1,Math.floor(n*t)))]}}function G(e){function t(t){var i=(t-n)/(r-n);return e(a?Math.max(0,Math.min(1,i)):i)}var n=0,r=1,a=!1;return t.domain=function(e){return arguments.length?(n=+e[0],r=+e[1],t):[n,r]},t.clamp=function(e){return arguments.length?(a=!!e,t):a},t.interpolator=function(n){return arguments.length?(e=n,t):e},t.copy=function(){return G(e).domain([n,r]).clamp(a)},z(t)}var J=Array.prototype,V=J.map,K=J.slice,Q={name:\"implicit\"},Z=[0,1],$=1e3,ee=60*$,te=60*ee,ne=24*te,re=7*ne,ae=30*ne,ie=365*ne,oe=F(\"1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf\"),ce=F(\"393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6\"),se=F(\"3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9\"),ue=F(\"1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5\"),de=r.interpolateCubehelixLong(c.cubehelix(300,.5,0),c.cubehelix(-240,.5,1)),le=r.interpolateCubehelixLong(c.cubehelix(-100,.75,.35),c.cubehelix(80,1.5,.8)),Me=r.interpolateCubehelixLong(c.cubehelix(260,.75,.35),c.cubehelix(80,1.5,.8)),_e=c.cubehelix(),fe=I(F(\"44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725\")),pe=I(F(\"00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf\")),he=I(F(\"00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4\")),me=I(F(\"0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921\"));\ne.scaleBand=u,e.scalePoint=l,e.scaleIdentity=g,e.scaleLinear=T,e.scaleLog=w,e.scaleOrdinal=s,e.scaleImplicit=Q,e.scalePow=q,e.scaleSqrt=E,e.scaleQuantile=B,e.scaleQuantize=C,e.scaleThreshold=X,e.scaleTime=j,e.scaleUtc=P,e.schemeCategory10=oe,e.schemeCategory20b=ce,e.schemeCategory20c=se,e.schemeCategory20=ue,e.interpolateCubehelixDefault=de,e.interpolateRainbow=U,e.interpolateWarm=le,e.interpolateCool=Me,e.interpolateViridis=fe,e.interpolateMagma=pe,e.interpolateInferno=he,e.interpolatePlasma=me,e.scaleSequential=G,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,n){n(t)}(this,function(e){\"use strict\";function t(){}function n(e,n){var r=new t;if(e instanceof t)e.each(function(e,t){r.set(t,e)});else if(Array.isArray(e)){var a,i=-1,o=e.length;if(null==n)for(;++i<o;)r.set(i,e[i]);else for(;++i<o;)r.set(n(a=e[i],i,e),a)}else if(e)for(var c in e)r.set(c,e[c]);return r}function r(){return{}}function a(e,t,n){e[t]=n}function i(){return n()}function o(e,t,n){e.set(t,n)}function c(){}function s(e,t){var n=new c;if(e instanceof c)e.each(function(e){n.add(e)});else if(e){var r=-1,a=e.length;if(null==t)for(;++r<a;)n.add(e[r]);else for(;++r<a;)n.add(t(e[r],r,e))}return n}var u=\"$\";t.prototype=n.prototype={constructor:t,has:function(e){return u+e in this},get:function(e){return this[u+e]},set:function(e,t){return this[u+e]=t,this},remove:function(e){var t=u+e;return t in this&&delete this[t]},clear:function(){for(var e in this)e[0]===u&&delete this[e]},keys:function(){var e=[];for(var t in this)t[0]===u&&e.push(t.slice(1));return e},values:function(){var e=[];for(var t in this)t[0]===u&&e.push(this[t]);return e},entries:function(){var e=[];for(var t in this)t[0]===u&&e.push({key:t.slice(1),value:this[t]});return e},size:function(){var e=0;for(var t in this)t[0]===u&&++e;return e},empty:function(){for(var e in this)if(e[0]===u)return!1;return!0},each:function(e){for(var t in this)t[0]===u&&e(this[t],t.slice(1),this)}};var d=function(){function e(t,r,a,i){if(r>=d.length)return null!=s?s(t):null!=c?t.sort(c):t;for(var o,u,l,M=-1,_=t.length,f=d[r++],p=n(),h=a();++M<_;)(l=p.get(o=f(u=t[M])+\"\"))?l.push(u):p.set(o,[u]);return p.each(function(t,n){i(h,n,e(t,r,a,i))}),h}function t(e,n){if(++n>d.length)return e;var r,a=l[n-1];return null!=s&&n>=d.length?r=e.entries():(r=[],e.each(function(e,a){r.push({key:a,values:t(e,n)})})),null!=a?r.sort(function(e,t){return a(e.key,t.key)}):r}var c,s,u,d=[],l=[];return u={object:function(t){return e(t,0,r,a)},map:function(t){return e(t,0,i,o)},entries:function(n){return t(e(n,0,i,o),0)},key:function(e){return d.push(e),u},sortKeys:function(e){return l[d.length-1]=e,u},sortValues:function(e){return c=e,u},rollup:function(e){return s=e,u}}},l=n.prototype;c.prototype=s.prototype={constructor:c,has:l.has,add:function(e){return e+=\"\",this[u+e]=e,this},remove:l.remove,clear:l.clear,values:l.keys,size:l.size,empty:l.empty,each:l.each};var M=function(e){var t=[];for(var n in e)t.push(n);return t},_=function(e){var t=[];for(var n in e)t.push(e[n]);return t},f=function(e){var t=[];for(var n in e)t.push({key:n,value:e[n]});return t};e.nest=d,e.set=s,e.map=n,e.keys=M,e.values=_,e.entries=f,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,r){r(t,n(52))}(this,function(e,t){\"use strict\";function n(e,t,n,r,a){var i=e*e,o=i*e;return((1-3*e+3*i-o)*t+(4-6*i+3*o)*n+(1+3*e+3*i-3*o)*r+o*a)/6}function r(e,t){return function(n){return e+n*t}}function a(e,t,n){return e=Math.pow(e,n),t=Math.pow(t,n)-e,n=1/n,function(r){return Math.pow(e+r*t,n)}}function i(e,t){var n=t-e;return n?r(e,n>180||n<-180?n-360*Math.round(n/360):n):D(isNaN(e)?t:e)}function o(e){return 1===(e=+e)?c:function(t,n){return n-t?a(t,n,e):D(isNaN(t)?n:t)}}function c(e,t){var n=t-e;return n?r(e,n):D(isNaN(e)?t:e)}function s(e){return function(n){var r,a,i=n.length,o=new Array(i),c=new Array(i),s=new Array(i);for(r=0;r<i;++r)a=t.rgb(n[r]),o[r]=a.r||0,c[r]=a.g||0,s[r]=a.b||0;return o=e(o),c=e(c),s=e(s),a.opacity=1,function(e){return a.r=o(e),a.g=c(e),a.b=s(e),a+\"\"}}}function u(e){return function(){return e}}function d(e){return function(t){return e(t)+\"\"}}function l(e){return\"none\"===e?x:(y||(y=document.createElement(\"DIV\"),z=document.documentElement,T=document.defaultView),y.style.transform=e,e=T.getComputedStyle(z.appendChild(y),null).getPropertyValue(\"transform\"),z.removeChild(y),e=e.slice(7,-1).split(\",\"),j(+e[0],+e[1],+e[2],+e[3],+e[4],+e[5]))}function M(e){return null==e?x:(g||(g=document.createElementNS(\"http://www.w3.org/2000/svg\",\"g\")),g.setAttribute(\"transform\",e),(e=g.transform.baseVal.consolidate())?(e=e.matrix,j(e.a,e.b,e.c,e.d,e.e,e.f)):x)}function _(e,t,n,r){function a(e){return e.length?e.pop()+\" \":\"\"}function i(e,r,a,i,o,c){if(e!==a||r!==i){var s=o.push(\"translate(\",null,t,null,n);c.push({i:s-4,x:W(e,a)},{i:s-2,x:W(r,i)})}else(a||i)&&o.push(\"translate(\"+a+t+i+n)}function o(e,t,n,i){e!==t?(e-t>180?t+=360:t-e>180&&(e+=360),i.push({i:n.push(a(n)+\"rotate(\",null,r)-2,x:W(e,t)})):t&&n.push(a(n)+\"rotate(\"+t+r)}function c(e,t,n,i){e!==t?i.push({i:n.push(a(n)+\"skewX(\",null,r)-2,x:W(e,t)}):t&&n.push(a(n)+\"skewX(\"+t+r)}function s(e,t,n,r,i,o){if(e!==n||t!==r){var c=i.push(a(i)+\"scale(\",null,\",\",null,\")\");o.push({i:c-4,x:W(e,n)},{i:c-2,x:W(t,r)})}else 1===n&&1===r||i.push(a(i)+\"scale(\"+n+\",\"+r+\")\")}return function(t,n){var r=[],a=[];return t=e(t),n=e(n),i(t.translateX,t.translateY,n.translateX,n.translateY,r,a),o(t.rotate,n.rotate,r,a),c(t.skewX,n.skewX,r,a),s(t.scaleX,t.scaleY,n.scaleX,n.scaleY,r,a),t=n=null,function(e){for(var t,n=-1,i=a.length;++n<i;)r[(t=a[n]).i]=t.x(e);return r.join(\"\")}}}function f(e){return((e=Math.exp(e))+1/e)/2}function p(e){return((e=Math.exp(e))-1/e)/2}function h(e){return((e=Math.exp(2*e))-1)/(e+1)}function m(e){return function(n,r){var a=e((n=t.hsl(n)).h,(r=t.hsl(r)).h),i=c(n.s,r.s),o=c(n.l,r.l),s=c(n.opacity,r.opacity);return function(e){return n.h=a(e),n.s=i(e),n.l=o(e),n.opacity=s(e),n+\"\"}}}function b(e,n){var r=c((e=t.lab(e)).l,(n=t.lab(n)).l),a=c(e.a,n.a),i=c(e.b,n.b),o=c(e.opacity,n.opacity);return function(t){return e.l=r(t),e.a=a(t),e.b=i(t),e.opacity=o(t),e+\"\"}}function L(e){return function(n,r){var a=e((n=t.hcl(n)).h,(r=t.hcl(r)).h),i=c(n.c,r.c),o=c(n.l,r.l),s=c(n.opacity,r.opacity);return function(e){return n.h=a(e),n.c=i(e),n.l=o(e),n.opacity=s(e),n+\"\"}}}function A(e){return function n(r){function a(n,a){var i=e((n=t.cubehelix(n)).h,(a=t.cubehelix(a)).h),o=c(n.s,a.s),s=c(n.l,a.l),u=c(n.opacity,a.opacity);return function(e){return n.h=i(e),n.s=o(e),n.l=s(Math.pow(e,r)),n.opacity=u(e),n+\"\"}}return r=+r,a.gamma=n,a}(1)}var y,z,T,g,v=function(e){var t=e.length-1;return function(r){var a=r<=0?r=0:r>=1?(r=1,t-1):Math.floor(r*t),i=e[a],o=e[a+1],c=a>0?e[a-1]:2*i-o,s=a<t-1?e[a+2]:2*o-i;return n((r-a/t)*t,c,i,o,s)}},O=function(e){var t=e.length;return function(r){var a=Math.floor(((r%=1)<0?++r:r)*t),i=e[(a+t-1)%t],o=e[a%t],c=e[(a+1)%t],s=e[(a+2)%t];return n((r-a/t)*t,i,o,c,s)}},D=function(e){return function(){return e}},k=function re(e){function n(e,n){var a=r((e=t.rgb(e)).r,(n=t.rgb(n)).r),i=r(e.g,n.g),o=r(e.b,n.b),s=c(e.opacity,n.opacity);return function(t){return e.r=a(t),e.g=i(t),e.b=o(t),e.opacity=s(t),e+\"\"}}var r=o(e);return n.gamma=re,n}(1),Y=s(v),S=s(O),N=function(e,t){var n,r=t?t.length:0,a=e?Math.min(r,e.length):0,i=new Array(r),o=new Array(r);for(n=0;n<a;++n)i[n]=X(e[n],t[n]);for(;n<r;++n)o[n]=t[n];return function(e){for(n=0;n<a;++n)o[n]=i[n](e);return o}},w=function(e,t){var n=new Date;return e=+e,t-=e,function(r){return n.setTime(e+t*r),n}},W=function(e,t){return e=+e,t-=e,function(n){return e+t*n}},q=function(e,t){var n,r={},a={};null!==e&&\"object\"==typeof e||(e={}),null!==t&&\"object\"==typeof t||(t={});for(n in t)n in e?r[n]=X(e[n],t[n]):a[n]=t[n];return function(e){for(n in r)a[n]=r[n](e);return a}},E=/[-+]?(?:\\d+\\.?\\d*|\\.?\\d+)(?:[eE][-+]?\\d+)?/g,B=new RegExp(E.source,\"g\"),C=function(e,t){var n,r,a,i=E.lastIndex=B.lastIndex=0,o=-1,c=[],s=[];for(e+=\"\",t+=\"\";(n=E.exec(e))&&(r=B.exec(t));)(a=r.index)>i&&(a=t.slice(i,a),c[o]?c[o]+=a:c[++o]=a),(n=n[0])===(r=r[0])?c[o]?c[o]+=r:c[++o]=r:(c[++o]=null,s.push({i:o,x:W(n,r)})),i=B.lastIndex;return i<t.length&&(a=t.slice(i),c[o]?c[o]+=a:c[++o]=a),c.length<2?s[0]?d(s[0].x):u(t):(t=s.length,function(e){for(var n,r=0;r<t;++r)c[(n=s[r]).i]=n.x(e);return c.join(\"\")})},X=function(e,n){var r,a=typeof n;return null==n||\"boolean\"===a?D(n):(\"number\"===a?W:\"string\"===a?(r=t.color(n))?(n=r,k):C:n instanceof t.color?k:n instanceof Date?w:Array.isArray(n)?N:isNaN(n)?q:W)(e,n)},R=function(e,t){return e=+e,t-=e,function(n){return Math.round(e+t*n)}},H=180/Math.PI,x={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},j=function(e,t,n,r,a,i){var o,c,s;return(o=Math.sqrt(e*e+t*t))&&(e/=o,t/=o),(s=e*n+t*r)&&(n-=e*s,r-=t*s),(c=Math.sqrt(n*n+r*r))&&(n/=c,r/=c,s/=c),e*r<t*n&&(e=-e,t=-t,s=-s,o=-o),{translateX:a,translateY:i,rotate:Math.atan2(t,e)*H,skewX:Math.atan(s)*H,scaleX:o,scaleY:c}},P=_(l,\"px, \",\"px)\",\"deg)\"),F=_(M,\", \",\")\",\")\"),U=Math.SQRT2,I=2,G=4,J=1e-12,V=function(e,t){var n,r,a=e[0],i=e[1],o=e[2],c=t[0],s=t[1],u=t[2],d=c-a,l=s-i,M=d*d+l*l;if(M<J)r=Math.log(u/o)/U,n=function(e){return[a+e*d,i+e*l,o*Math.exp(U*e*r)]};else{var _=Math.sqrt(M),m=(u*u-o*o+G*M)/(2*o*I*_),b=(u*u-o*o-G*M)/(2*u*I*_),L=Math.log(Math.sqrt(m*m+1)-m),A=Math.log(Math.sqrt(b*b+1)-b);r=(A-L)/U,n=function(e){var t=e*r,n=f(L),c=o/(I*_)*(n*h(U*t+L)-p(L));return[a+c*d,i+c*l,o*n/f(U*t+L)]}}return n.duration=1e3*r,n},K=m(i),Q=m(c),Z=L(i),$=L(c),ee=A(i),te=A(c),ne=function(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e(r/(t-1));return n};e.interpolate=X,e.interpolateArray=N,e.interpolateBasis=v,e.interpolateBasisClosed=O,e.interpolateDate=w,e.interpolateNumber=W,e.interpolateObject=q,e.interpolateRound=R,e.interpolateString=C,e.interpolateTransformCss=P,e.interpolateTransformSvg=F,e.interpolateZoom=V,e.interpolateRgb=k,e.interpolateRgbBasis=Y,e.interpolateRgbBasisClosed=S,e.interpolateHsl=K,e.interpolateHslLong=Q,e.interpolateLab=b,e.interpolateHcl=Z,e.interpolateHclLong=$,e.interpolateCubehelix=ee,e.interpolateCubehelixLong=te,e.quantize=ne,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,n){n(t)}(this,function(e){\"use strict\";function t(e,t){var n=Object.create(e.prototype);for(var r in t)n[r]=t[r];return n}function n(){}function r(e){var t;return e=(e+\"\").trim().toLowerCase(),(t=W.exec(e))?(t=parseInt(t[1],16),new s(t>>8&15|t>>4&240,t>>4&15|240&t,(15&t)<<4|15&t,1)):(t=q.exec(e))?a(parseInt(t[1],16)):(t=E.exec(e))?new s(t[1],t[2],t[3],1):(t=B.exec(e))?new s(255*t[1]/100,255*t[2]/100,255*t[3]/100,1):(t=C.exec(e))?i(t[1],t[2],t[3],t[4]):(t=X.exec(e))?i(255*t[1]/100,255*t[2]/100,255*t[3]/100,t[4]):(t=R.exec(e))?u(t[1],t[2]/100,t[3]/100,1):(t=H.exec(e))?u(t[1],t[2]/100,t[3]/100,t[4]):x.hasOwnProperty(e)?a(x[e]):\"transparent\"===e?new s(NaN,NaN,NaN,0):null}function a(e){return new s(e>>16&255,e>>8&255,255&e,1)}function i(e,t,n,r){return r<=0&&(e=t=n=NaN),new s(e,t,n,r)}function o(e){return e instanceof n||(e=r(e)),e?(e=e.rgb(),new s(e.r,e.g,e.b,e.opacity)):new s}function c(e,t,n,r){return 1===arguments.length?o(e):new s(e,t,n,null==r?1:r)}function s(e,t,n,r){this.r=+e,this.g=+t,this.b=+n,this.opacity=+r}function u(e,t,n,r){return r<=0?e=t=n=NaN:n<=0||n>=1?e=t=NaN:t<=0&&(e=NaN),new M(e,t,n,r)}function d(e){if(e instanceof M)return new M(e.h,e.s,e.l,e.opacity);if(e instanceof n||(e=r(e)),!e)return new M;if(e instanceof M)return e;e=e.rgb();var t=e.r/255,a=e.g/255,i=e.b/255,o=Math.min(t,a,i),c=Math.max(t,a,i),s=NaN,u=c-o,d=(c+o)/2;return u?(s=t===c?(a-i)/u+6*(a<i):a===c?(i-t)/u+2:(t-a)/u+4,u/=d<.5?c+o:2-c-o,s*=60):u=d>0&&d<1?0:s,new M(s,u,d,e.opacity)}function l(e,t,n,r){return 1===arguments.length?d(e):new M(e,t,n,null==r?1:r)}function M(e,t,n,r){this.h=+e,this.s=+t,this.l=+n,this.opacity=+r}function _(e,t,n){return 255*(e<60?t+(n-t)*e/60:e<180?n:e<240?t+(n-t)*(240-e)/60:t)}function f(e){if(e instanceof h)return new h(e.l,e.a,e.b,e.opacity);if(e instanceof T){var t=e.h*j;return new h(e.l,Math.cos(t)*e.c,Math.sin(t)*e.c,e.opacity)}e instanceof s||(e=o(e));var n=A(e.r),r=A(e.g),a=A(e.b),i=m((.4124564*n+.3575761*r+.1804375*a)/U),c=m((.2126729*n+.7151522*r+.072175*a)/I),u=m((.0193339*n+.119192*r+.9503041*a)/G);return new h(116*c-16,500*(i-c),200*(c-u),e.opacity)}function p(e,t,n,r){return 1===arguments.length?f(e):new h(e,t,n,null==r?1:r)}function h(e,t,n,r){this.l=+e,this.a=+t,this.b=+n,this.opacity=+r}function m(e){return e>Q?Math.pow(e,1/3):e/K+J}function b(e){return e>V?e*e*e:K*(e-J)}function L(e){return 255*(e<=.0031308?12.92*e:1.055*Math.pow(e,1/2.4)-.055)}function A(e){return(e/=255)<=.04045?e/12.92:Math.pow((e+.055)/1.055,2.4)}function y(e){if(e instanceof T)return new T(e.h,e.c,e.l,e.opacity);e instanceof h||(e=f(e));var t=Math.atan2(e.b,e.a)*P;return new T(t<0?t+360:t,Math.sqrt(e.a*e.a+e.b*e.b),e.l,e.opacity)}function z(e,t,n,r){return 1===arguments.length?y(e):new T(e,t,n,null==r?1:r)}function T(e,t,n,r){this.h=+e,this.c=+t,this.l=+n,this.opacity=+r}function g(e){if(e instanceof O)return new O(e.h,e.s,e.l,e.opacity);e instanceof s||(e=o(e));var t=e.r/255,n=e.g/255,r=e.b/255,a=(ie*r+re*t-ae*n)/(ie+re-ae),i=r-a,c=(ne*(n-a)-ee*i)/te,u=Math.sqrt(c*c+i*i)/(ne*a*(1-a)),d=u?Math.atan2(c,i)*P-120:NaN;return new O(d<0?d+360:d,u,a,e.opacity)}function v(e,t,n,r){return 1===arguments.length?g(e):new O(e,t,n,null==r?1:r)}function O(e,t,n,r){this.h=+e,this.s=+t,this.l=+n,this.opacity=+r}var D=function(e,t,n){e.prototype=t.prototype=n,n.constructor=e},k=.7,Y=1/k,S=\"\\\\s*([+-]?\\\\d+)\\\\s*\",N=\"\\\\s*([+-]?\\\\d*\\\\.?\\\\d+(?:[eE][+-]?\\\\d+)?)\\\\s*\",w=\"\\\\s*([+-]?\\\\d*\\\\.?\\\\d+(?:[eE][+-]?\\\\d+)?)%\\\\s*\",W=/^#([0-9a-f]{3})$/,q=/^#([0-9a-f]{6})$/,E=new RegExp(\"^rgb\\\\(\"+[S,S,S]+\"\\\\)$\"),B=new RegExp(\"^rgb\\\\(\"+[w,w,w]+\"\\\\)$\"),C=new RegExp(\"^rgba\\\\(\"+[S,S,S,N]+\"\\\\)$\"),X=new RegExp(\"^rgba\\\\(\"+[w,w,w,N]+\"\\\\)$\"),R=new RegExp(\"^hsl\\\\(\"+[N,w,w]+\"\\\\)$\"),H=new RegExp(\"^hsla\\\\(\"+[N,w,w,N]+\"\\\\)$\"),x={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};D(n,r,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+\"\"}}),D(s,c,t(n,{brighter:function(e){return e=null==e?Y:Math.pow(Y,e),new s(this.r*e,this.g*e,this.b*e,this.opacity)},darker:function(e){return e=null==e?k:Math.pow(k,e),new s(this.r*e,this.g*e,this.b*e,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var e=this.opacity;return e=isNaN(e)?1:Math.max(0,Math.min(1,e)),(1===e?\"rgb(\":\"rgba(\")+Math.max(0,Math.min(255,Math.round(this.r)||0))+\", \"+Math.max(0,Math.min(255,Math.round(this.g)||0))+\", \"+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===e?\")\":\", \"+e+\")\")}})),D(M,l,t(n,{brighter:function(e){return e=null==e?Y:Math.pow(Y,e),new M(this.h,this.s,this.l*e,this.opacity)},darker:function(e){return e=null==e?k:Math.pow(k,e),new M(this.h,this.s,this.l*e,this.opacity)},rgb:function(){var e=this.h%360+360*(this.h<0),t=isNaN(e)||isNaN(this.s)?0:this.s,n=this.l,r=n+(n<.5?n:1-n)*t,a=2*n-r;return new s(_(e>=240?e-240:e+120,a,r),_(e,a,r),_(e<120?e+240:e-120,a,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}));var j=Math.PI/180,P=180/Math.PI,F=18,U=.95047,I=1,G=1.08883,J=4/29,V=6/29,K=3*V*V,Q=V*V*V;D(h,p,t(n,{brighter:function(e){return new h(this.l+F*(null==e?1:e),this.a,this.b,this.opacity)},darker:function(e){return new h(this.l-F*(null==e?1:e),this.a,this.b,this.opacity)},rgb:function(){var e=(this.l+16)/116,t=isNaN(this.a)?e:e+this.a/500,n=isNaN(this.b)?e:e-this.b/200;return e=I*b(e),t=U*b(t),n=G*b(n),new s(L(3.2404542*t-1.5371385*e-.4985314*n),L(-.969266*t+1.8760108*e+.041556*n),L(.0556434*t-.2040259*e+1.0572252*n),this.opacity)}})),D(T,z,t(n,{brighter:function(e){return new T(this.h,this.c,this.l+F*(null==e?1:e),this.opacity)},darker:function(e){return new T(this.h,this.c,this.l-F*(null==e?1:e),this.opacity)},rgb:function(){return f(this).rgb()}}));var Z=-.14861,$=1.78277,ee=-.29227,te=-.90649,ne=1.97294,re=ne*te,ae=ne*$,ie=$*ee-te*Z;D(O,v,t(n,{brighter:function(e){return e=null==e?Y:Math.pow(Y,e),new O(this.h,this.s,this.l*e,this.opacity)},darker:function(e){return e=null==e?k:Math.pow(k,e),new O(this.h,this.s,this.l*e,this.opacity)},rgb:function(){var e=isNaN(this.h)?0:(this.h+120)*j,t=+this.l,n=isNaN(this.s)?0:this.s*t*(1-t),r=Math.cos(e),a=Math.sin(e);return new s(255*(t+n*(Z*r+$*a)),255*(t+n*(ee*r+te*a)),255*(t+n*(ne*r)),this.opacity)}})),e.color=r,e.rgb=c,e.hsl=l,e.lab=p,e.hcl=z,e.cubehelix=v,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,n){n(t)}(this,function(e){\"use strict\";function t(e,t){if((n=(e=t?e.toExponential(t-1):e.toExponential()).indexOf(\"e\"))<0)return null;var n,r=e.slice(0,n);return[r.length>1?r[0]+r.slice(2):r,+e.slice(n+1)]}function n(e){return e=t(Math.abs(e)),e?e[1]:NaN}function r(e,t){return function(n,r){for(var a=n.length,i=[],o=0,c=e[0],s=0;a>0&&c>0&&(s+c+1>r&&(c=Math.max(1,r-s)),i.push(n.substring(a-=c,a+c)),!((s+=c+1)>r));)c=e[o=(o+1)%e.length];return i.reverse().join(t)}}function a(e,t){e=e.toPrecision(t);e:for(var n,r=e.length,a=1,i=-1;a<r;++a)switch(e[a]){case\".\":i=n=a;break;case\"0\":0===i&&(i=a),n=a;break;case\"e\":break e;default:i>0&&(i=0)}return i>0?e.slice(0,i)+e.slice(n+1):e}function i(e,n){var r=t(e,n);if(!r)return e+\"\";var a=r[0],i=r[1],o=i-(p=3*Math.max(-8,Math.min(8,Math.floor(i/3))))+1,c=a.length;return o===c?a:o>c?a+new Array(o-c+1).join(\"0\"):o>0?a.slice(0,o)+\".\"+a.slice(o):\"0.\"+new Array(1-o).join(\"0\")+t(e,Math.max(0,n+o-1))[0]}function o(e,n){var r=t(e,n);if(!r)return e+\"\";var a=r[0],i=r[1];return i<0?\"0.\"+new Array((-i)).join(\"0\")+a:a.length>i+1?a.slice(0,i+1)+\".\"+a.slice(i+1):a+new Array(i-a.length+2).join(\"0\")}function c(e){return new s(e)}function s(e){if(!(t=m.exec(e)))throw new Error(\"invalid format: \"+e);var t,n=t[1]||\" \",r=t[2]||\">\",a=t[3]||\"-\",i=t[4]||\"\",o=!!t[5],c=t[6]&&+t[6],s=!!t[7],u=t[8]&&+t[8].slice(1),d=t[9]||\"\";\"n\"===d?(s=!0,d=\"g\"):h[d]||(d=\"\"),(o||\"0\"===n&&\"=\"===r)&&(o=!0,n=\"0\",r=\"=\"),this.fill=n,this.align=r,this.sign=a,this.symbol=i,this.zero=o,this.width=c,this.comma=s,this.precision=u,this.type=d}function u(e){return e}function d(e){function t(e){function t(e){var t,o,c,u=m,h=b;if(\"c\"===f)h=A(e)+h,e=\"\";else{e=+e;var z=(e<0||1/e<0)&&(e*=-1,!0);if(e=A(e,_),z)for(t=-1,o=e.length,z=!1;++t<o;)if(c=e.charCodeAt(t),48<c&&c<58||\"x\"===f&&96<c&&c<103||\"X\"===f&&64<c&&c<71){z=!0;break}if(u=(z?\"(\"===a?a:\"-\":\"-\"===a||\"(\"===a?\"\":a)+u,h=h+(\"s\"===f?L[8+p/3]:\"\")+(z&&\"(\"===a?\")\":\"\"),y)for(t=-1,o=e.length;++t<o;)if(c=e.charCodeAt(t),48>c||c>57){h=(46===c?s+e.slice(t+1):e.slice(t))+h,e=e.slice(0,t);break}}M&&!d&&(e=i(e,1/0));var T=u.length+e.length+h.length,g=T<l?new Array(l-T+1).join(n):\"\";switch(M&&d&&(e=i(g+e,g.length?l-h.length:1/0),g=\"\"),r){case\"<\":return u+e+h+g;case\"=\":return u+g+e+h;case\"^\":return g.slice(0,T=g.length>>1)+u+e+h+g.slice(T)}return g+u+e+h}e=c(e);var n=e.fill,r=e.align,a=e.sign,u=e.symbol,d=e.zero,l=e.width,M=e.comma,_=e.precision,f=e.type,m=\"$\"===u?o[0]:\"#\"===u&&/[boxX]/.test(f)?\"0\"+f.toLowerCase():\"\",b=\"$\"===u?o[1]:/[%p]/.test(f)?\"%\":\"\",A=h[f],y=!f||/[defgprs%]/.test(f);return _=null==_?f?6:12:/[gprs]/.test(f)?Math.max(1,Math.min(21,_)):Math.max(0,Math.min(20,_)),t.toString=function(){return e+\"\"},t}function a(e,r){var a=t((e=c(e),e.type=\"f\",e)),i=3*Math.max(-8,Math.min(8,Math.floor(n(r)/3))),o=Math.pow(10,-i),s=L[8+i/3];return function(e){return a(o*e)+s}}var i=e.grouping&&e.thousands?r(e.grouping,e.thousands):u,o=e.currency,s=e.decimal;return{format:t,formatPrefix:a}}function l(t){return b=d(t),e.format=b.format,e.formatPrefix=b.formatPrefix,b}function M(e){return Math.max(0,-n(Math.abs(e)))}function _(e,t){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(n(t)/3)))-n(Math.abs(e)))}function f(e,t){return e=Math.abs(e),t=Math.abs(t)-e,Math.max(0,n(t)-n(e))+1}var p,h={\"\":a,\"%\":function(e,t){return(100*e).toFixed(t)},b:function(e){return Math.round(e).toString(2)},c:function(e){return e+\"\"},d:function(e){return Math.round(e).toString(10)},e:function(e,t){return e.toExponential(t)},f:function(e,t){return e.toFixed(t)},g:function(e,t){return e.toPrecision(t)},o:function(e){return Math.round(e).toString(8)},p:function(e,t){return o(100*e,t)},r:o,s:i,X:function(e){return Math.round(e).toString(16).toUpperCase()},x:function(e){return Math.round(e).toString(16)}},m=/^(?:(.)?([<>=^]))?([+\\-\\( ])?([$#])?(0)?(\\d+)?(,)?(\\.\\d+)?([a-z%])?$/i;s.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?\"0\":\"\")+(null==this.width?\"\":Math.max(1,0|this.width))+(this.comma?\",\":\"\")+(null==this.precision?\"\":\".\"+Math.max(0,0|this.precision))+this.type};var b,L=[\"y\",\"z\",\"a\",\"f\",\"p\",\"n\",\"µ\",\"m\",\"\",\"k\",\"M\",\"G\",\"T\",\"P\",\"E\",\"Z\",\"Y\"];l({decimal:\".\",thousands:\",\",grouping:[3],currency:[\"$\",\"\"]}),e.formatDefaultLocale=l,e.formatLocale=d,e.formatSpecifier=c,e.precisionFixed=M,e.precisionPrefix=_,e.precisionRound=f,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,n){n(t)}(this,function(e){\"use strict\";function t(e,n,r,o){function c(t){return e(t=new Date((+t))),t}return c.floor=c,c.ceil=function(t){return e(t=new Date(t-1)),n(t,1),e(t),t},c.round=function(e){var t=c(e),n=c.ceil(e);return e-t<n-e?t:n},c.offset=function(e,t){return n(e=new Date((+e)),null==t?1:Math.floor(t)),e},c.range=function(t,r,a){var i=[];if(t=c.ceil(t),a=null==a?1:Math.floor(a),!(t<r&&a>0))return i;do i.push(new Date((+t)));while(n(t,a),e(t),t<r);return i},c.filter=function(r){return t(function(t){for(;e(t),!r(t);)t.setTime(t-1)},function(e,t){for(;--t>=0;)for(;n(e,1),!r(e););})},r&&(c.count=function(t,n){return a.setTime(+t),i.setTime(+n),e(a),e(i),Math.floor(r(a,i))},c.every=function(e){return e=Math.floor(e),isFinite(e)&&e>0?e>1?c.filter(o?function(t){return o(t)%e===0}:function(t){return c.count(0,t)%e===0}):c:null}),c}function n(e){return t(function(t){t.setDate(t.getDate()-(t.getDay()+7-e)%7),t.setHours(0,0,0,0)},function(e,t){e.setDate(e.getDate()+7*t)},function(e,t){return(t-e-(t.getTimezoneOffset()-e.getTimezoneOffset())*u)/M})}function r(e){return t(function(t){t.setUTCDate(t.getUTCDate()-(t.getUTCDay()+7-e)%7),t.setUTCHours(0,0,0,0)},function(e,t){e.setUTCDate(e.getUTCDate()+7*t)},function(e,t){return(t-e)/M})}var a=new Date,i=new Date,o=t(function(){},function(e,t){e.setTime(+e+t)},function(e,t){return t-e});o.every=function(e){return e=Math.floor(e),isFinite(e)&&e>0?e>1?t(function(t){t.setTime(Math.floor(t/e)*e)},function(t,n){t.setTime(+t+n*e)},function(t,n){return(n-t)/e}):o:null};var c=o.range,s=1e3,u=6e4,d=36e5,l=864e5,M=6048e5,_=t(function(e){e.setTime(Math.floor(e/s)*s)},function(e,t){e.setTime(+e+t*s)},function(e,t){return(t-e)/s},function(e){return e.getUTCSeconds()}),f=_.range,p=t(function(e){e.setTime(Math.floor(e/u)*u)},function(e,t){e.setTime(+e+t*u)},function(e,t){return(t-e)/u},function(e){return e.getMinutes()}),h=p.range,m=t(function(e){var t=e.getTimezoneOffset()*u%d;t<0&&(t+=d),e.setTime(Math.floor((+e-t)/d)*d+t)},function(e,t){e.setTime(+e+t*d)},function(e,t){return(t-e)/d},function(e){return e.getHours()}),b=m.range,L=t(function(e){e.setHours(0,0,0,0)},function(e,t){e.setDate(e.getDate()+t)},function(e,t){return(t-e-(t.getTimezoneOffset()-e.getTimezoneOffset())*u)/l},function(e){return e.getDate()-1}),A=L.range,y=n(0),z=n(1),T=n(2),g=n(3),v=n(4),O=n(5),D=n(6),k=y.range,Y=z.range,S=T.range,N=g.range,w=v.range,W=O.range,q=D.range,E=t(function(e){e.setDate(1),e.setHours(0,0,0,0)},function(e,t){e.setMonth(e.getMonth()+t)},function(e,t){return t.getMonth()-e.getMonth()+12*(t.getFullYear()-e.getFullYear())},function(e){return e.getMonth()}),B=E.range,C=t(function(e){e.setMonth(0,1),e.setHours(0,0,0,0)},function(e,t){e.setFullYear(e.getFullYear()+t)},function(e,t){return t.getFullYear()-e.getFullYear()},function(e){return e.getFullYear()});C.every=function(e){return isFinite(e=Math.floor(e))&&e>0?t(function(t){t.setFullYear(Math.floor(t.getFullYear()/e)*e),t.setMonth(0,1),t.setHours(0,0,0,0)},function(t,n){t.setFullYear(t.getFullYear()+n*e)}):null};var X=C.range,R=t(function(e){e.setUTCSeconds(0,0)},function(e,t){e.setTime(+e+t*u)},function(e,t){return(t-e)/u},function(e){return e.getUTCMinutes()}),H=R.range,x=t(function(e){e.setUTCMinutes(0,0,0)},function(e,t){e.setTime(+e+t*d)},function(e,t){return(t-e)/d},function(e){return e.getUTCHours()}),j=x.range,P=t(function(e){e.setUTCHours(0,0,0,0)},function(e,t){e.setUTCDate(e.getUTCDate()+t)},function(e,t){return(t-e)/l},function(e){return e.getUTCDate()-1}),F=P.range,U=r(0),I=r(1),G=r(2),J=r(3),V=r(4),K=r(5),Q=r(6),Z=U.range,$=I.range,ee=G.range,te=J.range,ne=V.range,re=K.range,ae=Q.range,ie=t(function(e){e.setUTCDate(1),e.setUTCHours(0,0,0,0)},function(e,t){e.setUTCMonth(e.getUTCMonth()+t)},function(e,t){return t.getUTCMonth()-e.getUTCMonth()+12*(t.getUTCFullYear()-e.getUTCFullYear())},function(e){return e.getUTCMonth()}),oe=ie.range,ce=t(function(e){e.setUTCMonth(0,1),e.setUTCHours(0,0,0,0)},function(e,t){e.setUTCFullYear(e.getUTCFullYear()+t)},function(e,t){return t.getUTCFullYear()-e.getUTCFullYear()},function(e){return e.getUTCFullYear()});ce.every=function(e){return isFinite(e=Math.floor(e))&&e>0?t(function(t){t.setUTCFullYear(Math.floor(t.getUTCFullYear()/e)*e),t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n*e)}):null};var se=ce.range;e.timeInterval=t,e.timeMillisecond=o,e.timeMilliseconds=c,e.utcMillisecond=o,e.utcMilliseconds=c,e.timeSecond=_,e.timeSeconds=f,e.utcSecond=_,e.utcSeconds=f,e.timeMinute=p,e.timeMinutes=h,e.timeHour=m,e.timeHours=b,e.timeDay=L,e.timeDays=A,e.timeWeek=y,e.timeWeeks=k,e.timeSunday=y,e.timeSundays=k,e.timeMonday=z,e.timeMondays=Y,e.timeTuesday=T,e.timeTuesdays=S,e.timeWednesday=g,e.timeWednesdays=N,e.timeThursday=v,e.timeThursdays=w,e.timeFriday=O,e.timeFridays=W,e.timeSaturday=D,e.timeSaturdays=q,e.timeMonth=E,e.timeMonths=B,e.timeYear=C,e.timeYears=X,e.utcMinute=R,e.utcMinutes=H,e.utcHour=x,e.utcHours=j,e.utcDay=P,e.utcDays=F,e.utcWeek=U,e.utcWeeks=Z,e.utcSunday=U,e.utcSundays=Z,e.utcMonday=I,e.utcMondays=$,e.utcTuesday=G,e.utcTuesdays=ee,e.utcWednesday=J,e.utcWednesdays=te,e.utcThursday=V,e.utcThursdays=ne,e.utcFriday=K,e.utcFridays=re,e.utcSaturday=Q,e.utcSaturdays=ae,e.utcMonth=ie,e.utcMonths=oe,e.utcYear=ce,e.utcYears=se,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){!function(e,r){r(t,n(54))}(this,function(e,t){\"use strict\";function n(e){if(0<=e.y&&e.y<100){var t=new Date((-1),e.m,e.d,e.H,e.M,e.S,e.L);return t.setFullYear(e.y),t}return new Date(e.y,e.m,e.d,e.H,e.M,e.S,e.L)}function r(e){if(0<=e.y&&e.y<100){var t=new Date(Date.UTC(-1,e.m,e.d,e.H,e.M,e.S,e.L));return t.setUTCFullYear(e.y),t}return new Date(Date.UTC(e.y,e.m,e.d,e.H,e.M,e.S,e.L))}function a(e){return{y:e,m:0,d:1,H:0,M:0,S:0,L:0}}function i(e){function t(e,t){return function(n){var r,a,i,o=[],c=-1,s=0,u=e.length;for(n instanceof Date||(n=new Date((+n)));++c<u;)37===e.charCodeAt(c)&&(o.push(e.slice(s,c)),null!=(a=re[r=e.charAt(++c)])?r=e.charAt(++c):a=\"e\"===r?\" \":\"0\",(i=t[r])&&(r=i(n,a)),o.push(r),s=c+1);return o.push(e.slice(s,c)),o.join(\"\")}}function i(e,t){return function(n){var i=a(1900),c=o(i,e,n+=\"\",0);if(c!=n.length)return null;if(\"p\"in i&&(i.H=i.H%12+12*i.p),\"W\"in i||\"U\"in i){\"w\"in i||(i.w=\"W\"in i?1:0);var s=\"Z\"in i?r(a(i.y)).getUTCDay():t(a(i.y)).getDay();i.m=0,i.d=\"W\"in i?(i.w+6)%7+7*i.W-(s+5)%7:i.w+7*i.U-(s+6)%7}return\"Z\"in i?(i.H+=i.Z/100|0,i.M+=i.Z%100,r(i)):t(i)}}function o(e,t,n,r){for(var a,i,o=0,c=t.length,s=n.length;o<c;){if(r>=s)return-1;if(a=t.charCodeAt(o++),37===a){if(a=t.charAt(o++),i=Ce[a in re?t.charAt(o++):a],!i||(r=i(e,n,r))<0)return-1}else if(a!=n.charCodeAt(r++))return-1}return r}function c(e,t,n){var r=ve.exec(t.slice(n));return r?(e.p=Oe[r[0].toLowerCase()],n+r[0].length):-1}function $(e,t,n){var r=Ye.exec(t.slice(n));return r?(e.w=Se[r[0].toLowerCase()],n+r[0].length):-1}function ee(e,t,n){var r=De.exec(t.slice(n));return r?(e.w=ke[r[0].toLowerCase()],n+r[0].length):-1}function te(e,t,n){var r=We.exec(t.slice(n));return r?(e.m=qe[r[0].toLowerCase()],n+r[0].length):-1}function ne(e,t,n){var r=Ne.exec(t.slice(n));return r?(e.m=we[r[0].toLowerCase()],n+r[0].length):-1}function ae(e,t,n){return o(e,me,t,n)}function ie(e,t,n){return o(e,be,t,n)}function oe(e,t,n){return o(e,Le,t,n)}function ce(e){return ze[e.getDay()]}function se(e){return ye[e.getDay()]}function ue(e){return ge[e.getMonth()]}function de(e){return Te[e.getMonth()]}function le(e){return Ae[+(e.getHours()>=12)]}function Me(e){return ze[e.getUTCDay()]}function _e(e){return ye[e.getUTCDay()]}function fe(e){return ge[e.getUTCMonth()]}function pe(e){return Te[e.getUTCMonth()]}function he(e){return Ae[+(e.getUTCHours()>=12)]}var me=e.dateTime,be=e.date,Le=e.time,Ae=e.periods,ye=e.days,ze=e.shortDays,Te=e.months,ge=e.shortMonths,ve=s(Ae),Oe=u(Ae),De=s(ye),ke=u(ye),Ye=s(ze),Se=u(ze),Ne=s(Te),we=u(Te),We=s(ge),qe=u(ge),Ee={a:ce,A:se,b:ue,B:de,c:null,d:g,e:g,H:v,I:O,j:D,L:k,m:Y,M:S,p:le,S:N,U:w,w:W,W:q,x:null,X:null,y:E,Y:B,Z:C,\"%\":Z},Be={a:Me,A:_e,b:fe,B:pe,c:null,d:X,e:X,H:R,I:H,j:x,L:j,m:P,M:F,p:he,S:U,U:I,w:G,W:J,x:null,X:null,y:V,Y:K,Z:Q,\"%\":Z},Ce={a:$,A:ee,b:te,B:ne,c:ae,d:m,e:m,H:L,I:L,j:b,L:z,m:h,M:A,p:c,S:y,U:l,w:d,W:M,x:ie,X:oe,y:f,Y:_,Z:p,\"%\":T};return Ee.x=t(be,Ee),Ee.X=t(Le,Ee),\nEe.c=t(me,Ee),Be.x=t(be,Be),Be.X=t(Le,Be),Be.c=t(me,Be),{format:function(e){var n=t(e+=\"\",Ee);return n.toString=function(){return e},n},parse:function(e){var t=i(e+=\"\",n);return t.toString=function(){return e},t},utcFormat:function(e){var n=t(e+=\"\",Be);return n.toString=function(){return e},n},utcParse:function(e){var t=i(e,r);return t.toString=function(){return e},t}}}function o(e,t,n){var r=e<0?\"-\":\"\",a=(r?-e:e)+\"\",i=a.length;return r+(i<n?new Array(n-i+1).join(t)+a:a)}function c(e){return e.replace(oe,\"\\\\$&\")}function s(e){return new RegExp(\"^(?:\"+e.map(c).join(\"|\")+\")\",\"i\")}function u(e){for(var t={},n=-1,r=e.length;++n<r;)t[e[n].toLowerCase()]=n;return t}function d(e,t,n){var r=ae.exec(t.slice(n,n+1));return r?(e.w=+r[0],n+r[0].length):-1}function l(e,t,n){var r=ae.exec(t.slice(n));return r?(e.U=+r[0],n+r[0].length):-1}function M(e,t,n){var r=ae.exec(t.slice(n));return r?(e.W=+r[0],n+r[0].length):-1}function _(e,t,n){var r=ae.exec(t.slice(n,n+4));return r?(e.y=+r[0],n+r[0].length):-1}function f(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.y=+r[0]+(+r[0]>68?1900:2e3),n+r[0].length):-1}function p(e,t,n){var r=/^(Z)|([+-]\\d\\d)(?:\\:?(\\d\\d))?/.exec(t.slice(n,n+6));return r?(e.Z=r[1]?0:-(r[2]+(r[3]||\"00\")),n+r[0].length):-1}function h(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.m=r[0]-1,n+r[0].length):-1}function m(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.d=+r[0],n+r[0].length):-1}function b(e,t,n){var r=ae.exec(t.slice(n,n+3));return r?(e.m=0,e.d=+r[0],n+r[0].length):-1}function L(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.H=+r[0],n+r[0].length):-1}function A(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.M=+r[0],n+r[0].length):-1}function y(e,t,n){var r=ae.exec(t.slice(n,n+2));return r?(e.S=+r[0],n+r[0].length):-1}function z(e,t,n){var r=ae.exec(t.slice(n,n+3));return r?(e.L=+r[0],n+r[0].length):-1}function T(e,t,n){var r=ie.exec(t.slice(n,n+1));return r?n+r[0].length:-1}function g(e,t){return o(e.getDate(),t,2)}function v(e,t){return o(e.getHours(),t,2)}function O(e,t){return o(e.getHours()%12||12,t,2)}function D(e,n){return o(1+t.timeDay.count(t.timeYear(e),e),n,3)}function k(e,t){return o(e.getMilliseconds(),t,3)}function Y(e,t){return o(e.getMonth()+1,t,2)}function S(e,t){return o(e.getMinutes(),t,2)}function N(e,t){return o(e.getSeconds(),t,2)}function w(e,n){return o(t.timeSunday.count(t.timeYear(e),e),n,2)}function W(e){return e.getDay()}function q(e,n){return o(t.timeMonday.count(t.timeYear(e),e),n,2)}function E(e,t){return o(e.getFullYear()%100,t,2)}function B(e,t){return o(e.getFullYear()%1e4,t,4)}function C(e){var t=e.getTimezoneOffset();return(t>0?\"-\":(t*=-1,\"+\"))+o(t/60|0,\"0\",2)+o(t%60,\"0\",2)}function X(e,t){return o(e.getUTCDate(),t,2)}function R(e,t){return o(e.getUTCHours(),t,2)}function H(e,t){return o(e.getUTCHours()%12||12,t,2)}function x(e,n){return o(1+t.utcDay.count(t.utcYear(e),e),n,3)}function j(e,t){return o(e.getUTCMilliseconds(),t,3)}function P(e,t){return o(e.getUTCMonth()+1,t,2)}function F(e,t){return o(e.getUTCMinutes(),t,2)}function U(e,t){return o(e.getUTCSeconds(),t,2)}function I(e,n){return o(t.utcSunday.count(t.utcYear(e),e),n,2)}function G(e){return e.getUTCDay()}function J(e,n){return o(t.utcMonday.count(t.utcYear(e),e),n,2)}function V(e,t){return o(e.getUTCFullYear()%100,t,2)}function K(e,t){return o(e.getUTCFullYear()%1e4,t,4)}function Q(){return\"+0000\"}function Z(){return\"%\"}function $(t){return ne=i(t),e.timeFormat=ne.format,e.timeParse=ne.parse,e.utcFormat=ne.utcFormat,e.utcParse=ne.utcParse,ne}function ee(e){return e.toISOString()}function te(e){var t=new Date(e);return isNaN(t)?null:t}var ne,re={\"-\":\"\",_:\" \",0:\"0\"},ae=/^\\s*\\d+/,ie=/^%/,oe=/[\\\\\\^\\$\\*\\+\\?\\|\\[\\]\\(\\)\\.\\{\\}]/g;$({dateTime:\"%x, %X\",date:\"%-m/%-d/%Y\",time:\"%-I:%M:%S %p\",periods:[\"AM\",\"PM\"],days:[\"Sunday\",\"Monday\",\"Tuesday\",\"Wednesday\",\"Thursday\",\"Friday\",\"Saturday\"],shortDays:[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"],months:[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"],shortMonths:[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"]});var ce=\"%Y-%m-%dT%H:%M:%S.%LZ\",se=Date.prototype.toISOString?ee:e.utcFormat(ce),ue=+new Date(\"2000-01-01T00:00:00.000Z\")?te:e.utcParse(ce);e.timeFormatDefaultLocale=$,e.timeFormatLocale=i,e.isoFormat=se,e.isoParse=ue,Object.defineProperty(e,\"__esModule\",{value:!0})})},function(e,t,n){var r=e.exports=n(57);r.tz.load(n(175))},function(e,t,n){var r,a,i;//! moment-timezone.js\n//! version : 0.5.5\n//! author : Tim Wood\n//! license : MIT\n//! github.com/moment/moment-timezone\n!function(o,c){\"use strict\";a=[n(58)],r=c,i=\"function\"==typeof r?r.apply(t,a):r,!(void 0!==i&&(e.exports=i))}(this,function(e){\"use strict\";function t(e){return e>96?e-87:e>64?e-29:e-48}function n(e){var n,r=0,a=e.split(\".\"),i=a[0],o=a[1]||\"\",c=1,s=0,u=1;for(45===e.charCodeAt(0)&&(r=1,u=-1),r;r<i.length;r++)n=t(i.charCodeAt(r)),s=60*s+n;for(r=0;r<o.length;r++)c/=60,n=t(o.charCodeAt(r)),s+=n*c;return s*u}function r(e){for(var t=0;t<e.length;t++)e[t]=n(e[t])}function a(e,t){for(var n=0;n<t;n++)e[n]=Math.round((e[n-1]||0)+6e4*e[n]);e[t-1]=1/0}function i(e,t){var n,r=[];for(n=0;n<t.length;n++)r[n]=e[t[n]];return r}function o(e){var t=e.split(\"|\"),n=t[2].split(\" \"),o=t[3].split(\"\"),c=t[4].split(\" \");return r(n),r(o),r(c),a(c,o.length),{name:t[0],abbrs:i(t[1].split(\" \"),o),offsets:i(n,o),untils:c,population:0|t[5]}}function c(e){e&&this._set(o(e))}function s(e){var t=e.toTimeString(),n=t.match(/\\([a-z ]+\\)/i);n&&n[0]?(n=n[0].match(/[A-Z]/g),n=n?n.join(\"\"):void 0):(n=t.match(/[A-Z]{3,5}/g),n=n?n[0]:void 0),\"GMT\"===n&&(n=void 0),this.at=+e,this.abbr=n,this.offset=e.getTimezoneOffset()}function u(e){this.zone=e,this.offsetScore=0,this.abbrScore=0}function d(e,t){for(var n,r;r=6e4*((t.at-e.at)/12e4|0);)n=new s(new Date(e.at+r)),n.offset===e.offset?e=n:t=n;return e}function l(){var e,t,n,r=(new Date).getFullYear()-2,a=new s(new Date(r,0,1)),i=[a];for(n=1;n<48;n++)t=new s(new Date(r,n,1)),t.offset!==a.offset&&(e=d(a,t),i.push(e),i.push(new s(new Date(e.at+6e4)))),a=t;for(n=0;n<4;n++)i.push(new s(new Date(r+n,0,1))),i.push(new s(new Date(r+n,6,1)));return i}function M(e,t){return e.offsetScore!==t.offsetScore?e.offsetScore-t.offsetScore:e.abbrScore!==t.abbrScore?e.abbrScore-t.abbrScore:t.zone.population-e.zone.population}function _(e,t){var n,a;for(r(t),n=0;n<t.length;n++)a=t[n],q[a]=q[a]||{},q[a][e]=!0}function f(e){var t,n,r,a=e.length,i={},o=[];for(t=0;t<a;t++){r=q[e[t].offset]||{};for(n in r)r.hasOwnProperty(n)&&(i[n]=!0)}for(t in i)i.hasOwnProperty(t)&&o.push(W[t]);return o}function p(){try{var e=Intl.DateTimeFormat().resolvedOptions().timeZone;if(e){var t=W[m(e)];if(t)return t;v(\"Moment Timezone found \"+e+\" from the Intl api, but did not have that data loaded.\")}}catch(n){}var r,a,i,o=l(),c=o.length,s=f(o),d=[];for(a=0;a<s.length;a++){for(r=new u(L(s[a]),c),i=0;i<c;i++)r.scoreOffsetAt(o[i]);d.push(r)}return d.sort(M),d.length>0?d[0].zone.name:void 0}function h(e){return Y&&!e||(Y=p()),Y}function m(e){return(e||\"\").toLowerCase().replace(/\\//g,\"_\")}function b(e){var t,n,r,a;for(\"string\"==typeof e&&(e=[e]),t=0;t<e.length;t++)r=e[t].split(\"|\"),n=r[0],a=m(n),N[a]=e[t],W[a]=n,r[5]&&_(a,r[2].split(\" \"))}function L(e,t){e=m(e);var n,r=N[e];return r instanceof c?r:\"string\"==typeof r?(r=new c(r),N[e]=r,r):w[e]&&t!==L&&(n=L(w[e],L))?(r=N[e]=new c,r._set(n),r.name=W[e],r):null}function A(){var e,t=[];for(e in W)W.hasOwnProperty(e)&&(N[e]||N[w[e]])&&W[e]&&t.push(W[e]);return t.sort()}function y(e){var t,n,r,a;for(\"string\"==typeof e&&(e=[e]),t=0;t<e.length;t++)n=e[t].split(\"|\"),r=m(n[0]),a=m(n[1]),w[r]=a,W[r]=n[0],w[a]=r,W[a]=n[1]}function z(e){b(e.zones),y(e.links),O.dataVersion=e.version}function T(e){return T.didShowError||(T.didShowError=!0,v(\"moment.tz.zoneExists('\"+e+\"') has been deprecated in favor of !moment.tz.zone('\"+e+\"')\")),!!L(e)}function g(e){return!(!e._a||void 0!==e._tzm)}function v(e){\"undefined\"!=typeof console&&\"function\"==typeof console.error&&console.error(e)}function O(t){var n=Array.prototype.slice.call(arguments,0,-1),r=arguments[arguments.length-1],a=L(r),i=e.utc.apply(null,n);return a&&!e.isMoment(t)&&g(i)&&i.add(a.parse(i),\"minutes\"),i.tz(r),i}function D(e){return function(){return this._z?this._z.abbr(this):e.call(this)}}function k(e){return function(){return this._z=null,e.apply(this,arguments)}}if(void 0!==e.tz)return v(\"Moment Timezone \"+e.tz.version+\" was already loaded \"+(e.tz.dataVersion?\"with data from \":\"without any data\")+e.tz.dataVersion),e;var Y,S=\"0.5.5\",N={},w={},W={},q={},E=e.version.split(\".\"),B=+E[0],C=+E[1];(B<2||2===B&&C<6)&&v(\"Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js \"+e.version+\". See momentjs.com\"),c.prototype={_set:function(e){this.name=e.name,this.abbrs=e.abbrs,this.untils=e.untils,this.offsets=e.offsets,this.population=e.population},_index:function(e){var t,n=+e,r=this.untils;for(t=0;t<r.length;t++)if(n<r[t])return t},parse:function(e){var t,n,r,a,i=+e,o=this.offsets,c=this.untils,s=c.length-1;for(a=0;a<s;a++)if(t=o[a],n=o[a+1],r=o[a?a-1:a],t<n&&O.moveAmbiguousForward?t=n:t>r&&O.moveInvalidForward&&(t=r),i<c[a]-6e4*t)return o[a];return o[s]},abbr:function(e){return this.abbrs[this._index(e)]},offset:function(e){return this.offsets[this._index(e)]}},u.prototype.scoreOffsetAt=function(e){this.offsetScore+=Math.abs(this.zone.offset(e.at)-e.offset),this.zone.abbr(e.at).replace(/[^A-Z]/g,\"\")!==e.abbr&&this.abbrScore++},O.version=S,O.dataVersion=\"\",O._zones=N,O._links=w,O._names=W,O.add=b,O.link=y,O.load=z,O.zone=L,O.zoneExists=T,O.guess=h,O.names=A,O.Zone=c,O.unpack=o,O.unpackBase60=n,O.needsOffset=g,O.moveInvalidForward=!0,O.moveAmbiguousForward=!1;var X=e.fn;e.tz=O,e.defaultZone=null,e.updateOffset=function(t,n){var r,a=e.defaultZone;void 0===t._z&&(a&&g(t)&&!t._isUTC&&(t._d=e.utc(t._a)._d,t.utc().add(a.parse(t),\"minutes\")),t._z=a),t._z&&(r=t._z.offset(t),Math.abs(r)<16&&(r/=60),void 0!==t.utcOffset?t.utcOffset(-r,n):t.zone(r,n))},X.tz=function(t){return t?(this._z=L(t),this._z?e.updateOffset(this):v(\"Moment Timezone has no data for \"+t+\". See http://momentjs.com/timezone/docs/#/data-loading/.\"),this):this._z?this._z.name:void 0},X.zoneName=D(X.zoneName),X.zoneAbbr=D(X.zoneAbbr),X.utc=k(X.utc),e.tz.setDefault=function(t){return(B<2||2===B&&C<9)&&v(\"Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js \"+e.version+\".\"),e.defaultZone=t?L(t):null,e};var R=e.momentProperties;return\"[object Array]\"===Object.prototype.toString.call(R)?(R.push(\"_z\"),R.push(\"_a\")):R&&(R._z=null),e})},function(e,t,n){(function(e){!function(t,n){e.exports=n()}(this,function(){\"use strict\";function t(){return yr.apply(null,arguments)}function r(e){yr=e}function a(e){return e instanceof Array||\"[object Array]\"===Object.prototype.toString.call(e)}function i(e){return null!=e&&\"[object Object]\"===Object.prototype.toString.call(e)}function o(e){var t;for(t in e)return!1;return!0}function c(e){return void 0===e}function s(e){return\"number\"==typeof e||\"[object Number]\"===Object.prototype.toString.call(e)}function u(e){return e instanceof Date||\"[object Date]\"===Object.prototype.toString.call(e)}function d(e,t){var n,r=[];for(n=0;n<e.length;++n)r.push(t(e[n],n));return r}function l(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function M(e,t){for(var n in t)l(t,n)&&(e[n]=t[n]);return l(t,\"toString\")&&(e.toString=t.toString),l(t,\"valueOf\")&&(e.valueOf=t.valueOf),e}function _(e,t,n,r){return At(e,t,n,r,!0).utc()}function f(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}}function p(e){return null==e._pf&&(e._pf=f()),e._pf}function h(e){if(null==e._isValid){var t=p(e),n=Tr.call(t.parsedDateParts,function(e){return null!=e}),r=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidMonth&&!t.invalidWeekday&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n);if(e._strict&&(r=r&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return r;e._isValid=r}return e._isValid}function m(e){var t=_(NaN);return null!=e?M(p(t),e):p(t).userInvalidated=!0,t}function b(e,t){var n,r,a;if(c(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),c(t._i)||(e._i=t._i),c(t._f)||(e._f=t._f),c(t._l)||(e._l=t._l),c(t._strict)||(e._strict=t._strict),c(t._tzm)||(e._tzm=t._tzm),c(t._isUTC)||(e._isUTC=t._isUTC),c(t._offset)||(e._offset=t._offset),c(t._pf)||(e._pf=p(t)),c(t._locale)||(e._locale=t._locale),gr.length>0)for(n=0;n<gr.length;n++)r=gr[n],a=t[r],c(a)||(e[r]=a);return e}function L(e){b(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),vr===!1&&(vr=!0,t.updateOffset(this),vr=!1)}function A(e){return e instanceof L||null!=e&&null!=e._isAMomentObject}function y(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function z(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=y(t)),n}function T(e,t,n){var r,a=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),o=0;for(r=0;r<a;r++)(n&&e[r]!==t[r]||!n&&z(e[r])!==z(t[r]))&&o++;return o+i}function g(e){t.suppressDeprecationWarnings===!1&&\"undefined\"!=typeof console&&console.warn&&console.warn(\"Deprecation warning: \"+e)}function v(e,n){var r=!0;return M(function(){if(null!=t.deprecationHandler&&t.deprecationHandler(null,e),r){for(var a,i=[],o=0;o<arguments.length;o++){if(a=\"\",\"object\"==typeof arguments[o]){a+=\"\\n[\"+o+\"] \";for(var c in arguments[0])a+=c+\": \"+arguments[0][c]+\", \";a=a.slice(0,-2)}else a=arguments[o];i.push(a)}g(e+\"\\nArguments: \"+Array.prototype.slice.call(i).join(\"\")+\"\\n\"+(new Error).stack),r=!1}return n.apply(this,arguments)},n)}function O(e,n){null!=t.deprecationHandler&&t.deprecationHandler(e,n),Or[e]||(g(n),Or[e]=!0)}function D(e){return e instanceof Function||\"[object Function]\"===Object.prototype.toString.call(e)}function k(e){var t,n;for(n in e)t=e[n],D(t)?this[n]=t:this[\"_\"+n]=t;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+\"|\"+/\\d{1,2}/.source)}function Y(e,t){var n,r=M({},e);for(n in t)l(t,n)&&(i(e[n])&&i(t[n])?(r[n]={},M(r[n],e[n]),M(r[n],t[n])):null!=t[n]?r[n]=t[n]:delete r[n]);for(n in e)l(e,n)&&!l(t,n)&&i(e[n])&&(r[n]=M({},r[n]));return r}function S(e){null!=e&&this.set(e)}function N(e,t,n){var r=this._calendar[e]||this._calendar.sameElse;return D(r)?r.call(t,n):r}function w(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])}function W(){return this._invalidDate}function q(e){return this._ordinal.replace(\"%d\",e)}function E(e,t,n,r){var a=this._relativeTime[n];return D(a)?a(e,t,n,r):a.replace(/%d/i,e)}function B(e,t){var n=this._relativeTime[e>0?\"future\":\"past\"];return D(n)?n(t):n.replace(/%s/i,t)}function C(e,t){var n=e.toLowerCase();Br[n]=Br[n+\"s\"]=Br[t]=e}function X(e){return\"string\"==typeof e?Br[e]||Br[e.toLowerCase()]:void 0}function R(e){var t,n,r={};for(n in e)l(e,n)&&(t=X(n),t&&(r[t]=e[n]));return r}function H(e,t){Cr[e]=t}function x(e){var t=[];for(var n in e)t.push({unit:n,priority:Cr[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}function j(e,n){return function(r){return null!=r?(F(this,e,r),t.updateOffset(this,n),this):P(this,e)}}function P(e,t){return e.isValid()?e._d[\"get\"+(e._isUTC?\"UTC\":\"\")+t]():NaN}function F(e,t,n){e.isValid()&&e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+t](n)}function U(e){return e=X(e),D(this[e])?this[e]():this}function I(e,t){if(\"object\"==typeof e){e=R(e);for(var n=x(e),r=0;r<n.length;r++)this[n[r].unit](e[n[r].unit])}else if(e=X(e),D(this[e]))return this[e](t);return this}function G(e,t,n){var r=\"\"+Math.abs(e),a=t-r.length,i=e>=0;return(i?n?\"+\":\"\":\"-\")+Math.pow(10,Math.max(0,a)).toString().substr(1)+r}function J(e,t,n,r){var a=r;\"string\"==typeof r&&(a=function(){return this[r]()}),e&&(xr[e]=a),t&&(xr[t[0]]=function(){return G(a.apply(this,arguments),t[1],t[2])}),n&&(xr[n]=function(){return this.localeData().ordinal(a.apply(this,arguments),e)})}function V(e){return e.match(/\\[[\\s\\S]/)?e.replace(/^\\[|\\]$/g,\"\"):e.replace(/\\\\/g,\"\")}function K(e){var t,n,r=e.match(Xr);for(t=0,n=r.length;t<n;t++)xr[r[t]]?r[t]=xr[r[t]]:r[t]=V(r[t]);return function(t){var a,i=\"\";for(a=0;a<n;a++)i+=D(r[a])?r[a].call(t,e):r[a];return i}}function Q(e,t){return e.isValid()?(t=Z(t,e.localeData()),Hr[t]=Hr[t]||K(t),Hr[t](e)):e.localeData().invalidDate()}function Z(e,t){function n(e){return t.longDateFormat(e)||e}var r=5;for(Rr.lastIndex=0;r>=0&&Rr.test(e);)e=e.replace(Rr,n),Rr.lastIndex=0,r-=1;return e}function $(e,t,n){ia[e]=D(t)?t:function(e,r){return e&&n?n:t}}function ee(e,t){return l(ia,e)?ia[e](t._strict,t._locale):new RegExp(te(e))}function te(e){return ne(e.replace(\"\\\\\",\"\").replace(/\\\\(\\[)|\\\\(\\])|\\[([^\\]\\[]*)\\]|\\\\(.)/g,function(e,t,n,r,a){return t||n||r||a}))}function ne(e){return e.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")}function re(e,t){var n,r=t;for(\"string\"==typeof e&&(e=[e]),s(t)&&(r=function(e,n){n[t]=z(e)}),n=0;n<e.length;n++)oa[e[n]]=r}function ae(e,t){re(e,function(e,n,r,a){r._w=r._w||{},t(e,r._w,r,a)})}function ie(e,t,n){null!=t&&l(oa,e)&&oa[e](t,n._a,n,e)}function oe(e,t){return new Date(Date.UTC(e,t+1,0)).getUTCDate()}function ce(e,t){return e?a(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||ma).test(t)?\"format\":\"standalone\"][e.month()]:a(this._months)?this._months:this._months.standalone}function se(e,t){return e?a(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[ma.test(t)?\"format\":\"standalone\"][e.month()]:a(this._monthsShort)?this._monthsShort:this._monthsShort.standalone}function ue(e,t,n){var r,a,i,o=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],r=0;r<12;++r)i=_([2e3,r]),this._shortMonthsParse[r]=this.monthsShort(i,\"\").toLocaleLowerCase(),this._longMonthsParse[r]=this.months(i,\"\").toLocaleLowerCase();return n?\"MMM\"===t?(a=ha.call(this._shortMonthsParse,o),a!==-1?a:null):(a=ha.call(this._longMonthsParse,o),a!==-1?a:null):\"MMM\"===t?(a=ha.call(this._shortMonthsParse,o),a!==-1?a:(a=ha.call(this._longMonthsParse,o),a!==-1?a:null)):(a=ha.call(this._longMonthsParse,o),a!==-1?a:(a=ha.call(this._shortMonthsParse,o),a!==-1?a:null))}function de(e,t,n){var r,a,i;if(this._monthsParseExact)return ue.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),r=0;r<12;r++){if(a=_([2e3,r]),n&&!this._longMonthsParse[r]&&(this._longMonthsParse[r]=new RegExp(\"^\"+this.months(a,\"\").replace(\".\",\"\")+\"$\",\"i\"),this._shortMonthsParse[r]=new RegExp(\"^\"+this.monthsShort(a,\"\").replace(\".\",\"\")+\"$\",\"i\")),n||this._monthsParse[r]||(i=\"^\"+this.months(a,\"\")+\"|^\"+this.monthsShort(a,\"\"),this._monthsParse[r]=new RegExp(i.replace(\".\",\"\"),\"i\")),n&&\"MMMM\"===t&&this._longMonthsParse[r].test(e))return r;if(n&&\"MMM\"===t&&this._shortMonthsParse[r].test(e))return r;if(!n&&this._monthsParse[r].test(e))return r}}function le(e,t){var n;if(!e.isValid())return e;if(\"string\"==typeof t)if(/^\\d+$/.test(t))t=z(t);else if(t=e.localeData().monthsParse(t),!s(t))return e;return n=Math.min(e.date(),oe(e.year(),t)),e._d[\"set\"+(e._isUTC?\"UTC\":\"\")+\"Month\"](t,n),e}function Me(e){return null!=e?(le(this,e),t.updateOffset(this,!0),this):P(this,\"Month\")}function _e(){return oe(this.year(),this.month())}function fe(e){return this._monthsParseExact?(l(this,\"_monthsRegex\")||he.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,\"_monthsShortRegex\")||(this._monthsShortRegex=Aa),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)}function pe(e){return this._monthsParseExact?(l(this,\"_monthsRegex\")||he.call(this),e?this._monthsStrictRegex:this._monthsRegex):(l(this,\"_monthsRegex\")||(this._monthsRegex=ya),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)}function he(){function e(e,t){return t.length-e.length}var t,n,r=[],a=[],i=[];for(t=0;t<12;t++)n=_([2e3,t]),r.push(this.monthsShort(n,\"\")),a.push(this.months(n,\"\")),i.push(this.months(n,\"\")),i.push(this.monthsShort(n,\"\"));for(r.sort(e),a.sort(e),i.sort(e),t=0;t<12;t++)r[t]=ne(r[t]),a[t]=ne(a[t]);for(t=0;t<24;t++)i[t]=ne(i[t]);this._monthsRegex=new RegExp(\"^(\"+i.join(\"|\")+\")\",\"i\"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp(\"^(\"+a.join(\"|\")+\")\",\"i\"),this._monthsShortStrictRegex=new RegExp(\"^(\"+r.join(\"|\")+\")\",\"i\")}function me(e){return be(e)?366:365}function be(e){return e%4===0&&e%100!==0||e%400===0}function Le(){return be(this.year())}function Ae(e,t,n,r,a,i,o){var c=new Date(e,t,n,r,a,i,o);return e<100&&e>=0&&isFinite(c.getFullYear())&&c.setFullYear(e),c}function ye(e){var t=new Date(Date.UTC.apply(null,arguments));return e<100&&e>=0&&isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e),t}function ze(e,t,n){var r=7+t-n,a=(7+ye(e,0,r).getUTCDay()-t)%7;return-a+r-1}function Te(e,t,n,r,a){var i,o,c=(7+n-r)%7,s=ze(e,r,a),u=1+7*(t-1)+c+s;return u<=0?(i=e-1,o=me(i)+u):u>me(e)?(i=e+1,o=u-me(e)):(i=e,o=u),{year:i,dayOfYear:o}}function ge(e,t,n){var r,a,i=ze(e.year(),t,n),o=Math.floor((e.dayOfYear()-i-1)/7)+1;return o<1?(a=e.year()-1,r=o+ve(a,t,n)):o>ve(e.year(),t,n)?(r=o-ve(e.year(),t,n),a=e.year()+1):(a=e.year(),r=o),{week:r,year:a}}function ve(e,t,n){var r=ze(e,t,n),a=ze(e+1,t,n);return(me(e)-r+a)/7}function Oe(e){return ge(e,this._week.dow,this._week.doy).week}function De(){return this._week.dow}function ke(){return this._week.doy}function Ye(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),\"d\")}function Se(e){var t=ge(this,1,4).week;return null==e?t:this.add(7*(e-t),\"d\")}function Ne(e,t){return\"string\"!=typeof e?e:isNaN(e)?(e=t.weekdaysParse(e),\"number\"==typeof e?e:null):parseInt(e,10)}function we(e,t){return\"string\"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}function We(e,t){return e?a(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(t)?\"format\":\"standalone\"][e.day()]:a(this._weekdays)?this._weekdays:this._weekdays.standalone}function qe(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort}function Ee(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin}function Be(e,t,n){var r,a,i,o=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],r=0;r<7;++r)i=_([2e3,1]).day(r),this._minWeekdaysParse[r]=this.weekdaysMin(i,\"\").toLocaleLowerCase(),this._shortWeekdaysParse[r]=this.weekdaysShort(i,\"\").toLocaleLowerCase(),this._weekdaysParse[r]=this.weekdays(i,\"\").toLocaleLowerCase();return n?\"dddd\"===t?(a=ha.call(this._weekdaysParse,o),a!==-1?a:null):\"ddd\"===t?(a=ha.call(this._shortWeekdaysParse,o),a!==-1?a:null):(a=ha.call(this._minWeekdaysParse,o),a!==-1?a:null):\"dddd\"===t?(a=ha.call(this._weekdaysParse,o),a!==-1?a:(a=ha.call(this._shortWeekdaysParse,o),a!==-1?a:(a=ha.call(this._minWeekdaysParse,o),a!==-1?a:null))):\"ddd\"===t?(a=ha.call(this._shortWeekdaysParse,o),a!==-1?a:(a=ha.call(this._weekdaysParse,o),a!==-1?a:(a=ha.call(this._minWeekdaysParse,o),a!==-1?a:null))):(a=ha.call(this._minWeekdaysParse,o),a!==-1?a:(a=ha.call(this._weekdaysParse,o),a!==-1?a:(a=ha.call(this._shortWeekdaysParse,o),a!==-1?a:null)))}function Ce(e,t,n){var r,a,i;if(this._weekdaysParseExact)return Be.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),r=0;r<7;r++){if(a=_([2e3,1]).day(r),n&&!this._fullWeekdaysParse[r]&&(this._fullWeekdaysParse[r]=new RegExp(\"^\"+this.weekdays(a,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._shortWeekdaysParse[r]=new RegExp(\"^\"+this.weekdaysShort(a,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._minWeekdaysParse[r]=new RegExp(\"^\"+this.weekdaysMin(a,\"\").replace(\".\",\".?\")+\"$\",\"i\")),this._weekdaysParse[r]||(i=\"^\"+this.weekdays(a,\"\")+\"|^\"+this.weekdaysShort(a,\"\")+\"|^\"+this.weekdaysMin(a,\"\"),this._weekdaysParse[r]=new RegExp(i.replace(\".\",\"\"),\"i\")),n&&\"dddd\"===t&&this._fullWeekdaysParse[r].test(e))return r;if(n&&\"ddd\"===t&&this._shortWeekdaysParse[r].test(e))return r;if(n&&\"dd\"===t&&this._minWeekdaysParse[r].test(e))return r;if(!n&&this._weekdaysParse[r].test(e))return r}}function Xe(e){if(!this.isValid())return null!=e?this:NaN;var t=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=Ne(e,this.localeData()),this.add(e-t,\"d\")):t}function Re(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,\"d\")}function He(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=we(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7}function xe(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Fe.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,\"_weekdaysRegex\")||(this._weekdaysRegex=Da),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)}function je(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Fe.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,\"_weekdaysShortRegex\")||(this._weekdaysShortRegex=ka),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Pe(e){return this._weekdaysParseExact?(l(this,\"_weekdaysRegex\")||Fe.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,\"_weekdaysMinRegex\")||(this._weekdaysMinRegex=Ya),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Fe(){function e(e,t){return t.length-e.length}var t,n,r,a,i,o=[],c=[],s=[],u=[];for(t=0;t<7;t++)n=_([2e3,1]).day(t),r=this.weekdaysMin(n,\"\"),a=this.weekdaysShort(n,\"\"),i=this.weekdays(n,\"\"),o.push(r),c.push(a),s.push(i),u.push(r),u.push(a),u.push(i);for(o.sort(e),c.sort(e),s.sort(e),u.sort(e),t=0;t<7;t++)c[t]=ne(c[t]),s[t]=ne(s[t]),u[t]=ne(u[t]);this._weekdaysRegex=new RegExp(\"^(\"+u.join(\"|\")+\")\",\"i\"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp(\"^(\"+s.join(\"|\")+\")\",\"i\"),this._weekdaysShortStrictRegex=new RegExp(\"^(\"+c.join(\"|\")+\")\",\"i\"),this._weekdaysMinStrictRegex=new RegExp(\"^(\"+o.join(\"|\")+\")\",\"i\")}function Ue(){return this.hours()%12||12}function Ie(){return this.hours()||24}function Ge(e,t){J(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function Je(e,t){return t._meridiemParse}function Ve(e){return\"p\"===(e+\"\").toLowerCase().charAt(0)}function Ke(e,t,n){return e>11?n?\"pm\":\"PM\":n?\"am\":\"AM\"}function Qe(e){return e?e.toLowerCase().replace(\"_\",\"-\"):e}function Ze(e){for(var t,n,r,a,i=0;i<e.length;){for(a=Qe(e[i]).split(\"-\"),t=a.length,n=Qe(e[i+1]),n=n?n.split(\"-\"):null;t>0;){if(r=$e(a.slice(0,t).join(\"-\")))return r;if(n&&n.length>=t&&T(a,n,!0)>=t-1)break;t--}i++}return null}function $e(t){var r=null;if(!qa[t]&&\"undefined\"!=typeof e&&e&&e.exports)try{r=Sa._abbr,n(59)(\"./\"+t),et(r)}catch(a){}return qa[t]}function et(e,t){var n;return e&&(n=c(t)?rt(e):tt(e,t),n&&(Sa=n)),Sa._abbr}function tt(e,t){if(null!==t){var n=Wa;if(t.abbr=e,null!=qa[e])O(\"defineLocaleOverride\",\"use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.\"),n=qa[e]._config;else if(null!=t.parentLocale){if(null==qa[t.parentLocale])return Ea[t.parentLocale]||(Ea[t.parentLocale]=[]),Ea[t.parentLocale].push({name:e,config:t}),null;n=qa[t.parentLocale]._config}return qa[e]=new S(Y(n,t)),Ea[e]&&Ea[e].forEach(function(e){tt(e.name,e.config)}),et(e),qa[e]}return delete qa[e],null}function nt(e,t){if(null!=t){var n,r=Wa;null!=qa[e]&&(r=qa[e]._config),t=Y(r,t),n=new S(t),n.parentLocale=qa[e],qa[e]=n,et(e)}else null!=qa[e]&&(null!=qa[e].parentLocale?qa[e]=qa[e].parentLocale:null!=qa[e]&&delete qa[e]);return qa[e]}function rt(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return Sa;if(!a(e)){if(t=$e(e))return t;e=[e]}return Ze(e)}function at(){return Yr(qa)}function it(e){var t,n=e._a;return n&&p(e).overflow===-2&&(t=n[sa]<0||n[sa]>11?sa:n[ua]<1||n[ua]>oe(n[ca],n[sa])?ua:n[da]<0||n[da]>24||24===n[da]&&(0!==n[la]||0!==n[Ma]||0!==n[_a])?da:n[la]<0||n[la]>59?la:n[Ma]<0||n[Ma]>59?Ma:n[_a]<0||n[_a]>999?_a:-1,p(e)._overflowDayOfYear&&(t<ca||t>ua)&&(t=ua),p(e)._overflowWeeks&&t===-1&&(t=fa),p(e)._overflowWeekday&&t===-1&&(t=pa),p(e).overflow=t),e}function ot(e){var t,n,r,a,i,o,c=e._i,s=Ba.exec(c)||Ca.exec(c);if(s){for(p(e).iso=!0,t=0,n=Ra.length;t<n;t++)if(Ra[t][1].exec(s[1])){a=Ra[t][0],r=Ra[t][2]!==!1;break}if(null==a)return void(e._isValid=!1);if(s[3]){for(t=0,n=Ha.length;t<n;t++)if(Ha[t][1].exec(s[3])){i=(s[2]||\" \")+Ha[t][0];break}if(null==i)return void(e._isValid=!1)}if(!r&&null!=i)return void(e._isValid=!1);if(s[4]){if(!Xa.exec(s[4]))return void(e._isValid=!1);o=\"Z\"}e._f=a+(i||\"\")+(o||\"\"),_t(e)}else e._isValid=!1}function ct(e){var t,n,r,a,i,o,c,s,u={\" GMT\":\" +0000\",\" EDT\":\" -0400\",\" EST\":\" -0500\",\" CDT\":\" -0500\",\" CST\":\" -0600\",\" MDT\":\" -0600\",\" MST\":\" -0700\",\" PDT\":\" -0700\",\" PST\":\" -0800\"},d=\"YXWVUTSRQPONZABCDEFGHIKLM\";if(t=e._i.replace(/\\([^\\)]*\\)|[\\n\\t]/g,\" \").replace(/(\\s\\s+)/g,\" \").replace(/^\\s|\\s$/g,\"\"),n=ja.exec(t)){if(r=n[1]?\"ddd\"+(5===n[1].length?\", \":\" \"):\"\",a=\"D MMM \"+(n[2].length>10?\"YYYY \":\"YY \"),i=\"HH:mm\"+(n[4]?\":ss\":\"\"),n[1]){var l=new Date(n[2]),M=[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"][l.getDay()];if(n[1].substr(0,3)!==M)return p(e).weekdayMismatch=!0,void(e._isValid=!1)}switch(n[5].length){case 2:0===s?c=\" +0000\":(s=d.indexOf(n[5][1].toUpperCase())-12,c=(s<0?\" -\":\" +\")+(\"\"+s).replace(/^-?/,\"0\").match(/..$/)[0]+\"00\");break;case 4:c=u[n[5]];break;default:c=u[\" GMT\"]}n[5]=c,e._i=n.splice(1).join(\"\"),o=\" ZZ\",e._f=r+a+i+o,_t(e),p(e).rfc2822=!0}else e._isValid=!1}function st(e){var n=xa.exec(e._i);return null!==n?void(e._d=new Date((+n[1]))):(ot(e),void(e._isValid===!1&&(delete e._isValid,ct(e),e._isValid===!1&&(delete e._isValid,t.createFromInputFallback(e)))))}function ut(e,t,n){return null!=e?e:null!=t?t:n}function dt(e){var n=new Date(t.now());return e._useUTC?[n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()]:[n.getFullYear(),n.getMonth(),n.getDate()]}function lt(e){var t,n,r,a,i=[];if(!e._d){for(r=dt(e),e._w&&null==e._a[ua]&&null==e._a[sa]&&Mt(e),null!=e._dayOfYear&&(a=ut(e._a[ca],r[ca]),(e._dayOfYear>me(a)||0===e._dayOfYear)&&(p(e)._overflowDayOfYear=!0),n=ye(a,0,e._dayOfYear),e._a[sa]=n.getUTCMonth(),e._a[ua]=n.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=i[t]=r[t];for(;t<7;t++)e._a[t]=i[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[da]&&0===e._a[la]&&0===e._a[Ma]&&0===e._a[_a]&&(e._nextDay=!0,e._a[da]=0),e._d=(e._useUTC?ye:Ae).apply(null,i),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[da]=24)}}function Mt(e){var t,n,r,a,i,o,c,s;if(t=e._w,null!=t.GG||null!=t.W||null!=t.E)i=1,o=4,n=ut(t.GG,e._a[ca],ge(yt(),1,4).year),r=ut(t.W,1),a=ut(t.E,1),(a<1||a>7)&&(s=!0);else{i=e._locale._week.dow,o=e._locale._week.doy;var u=ge(yt(),i,o);n=ut(t.gg,e._a[ca],u.year),r=ut(t.w,u.week),null!=t.d?(a=t.d,(a<0||a>6)&&(s=!0)):null!=t.e?(a=t.e+i,(t.e<0||t.e>6)&&(s=!0)):a=i}r<1||r>ve(n,i,o)?p(e)._overflowWeeks=!0:null!=s?p(e)._overflowWeekday=!0:(c=Te(n,r,a,i,o),e._a[ca]=c.year,e._dayOfYear=c.dayOfYear)}function _t(e){if(e._f===t.ISO_8601)return void ot(e);if(e._f===t.RFC_2822)return void ct(e);e._a=[],p(e).empty=!0;var n,r,a,i,o,c=\"\"+e._i,s=c.length,u=0;for(a=Z(e._f,e._locale).match(Xr)||[],n=0;n<a.length;n++)i=a[n],r=(c.match(ee(i,e))||[])[0],r&&(o=c.substr(0,c.indexOf(r)),o.length>0&&p(e).unusedInput.push(o),c=c.slice(c.indexOf(r)+r.length),u+=r.length),xr[i]?(r?p(e).empty=!1:p(e).unusedTokens.push(i),ie(i,r,e)):e._strict&&!r&&p(e).unusedTokens.push(i);p(e).charsLeftOver=s-u,c.length>0&&p(e).unusedInput.push(c),e._a[da]<=12&&p(e).bigHour===!0&&e._a[da]>0&&(p(e).bigHour=void 0),p(e).parsedDateParts=e._a.slice(0),p(e).meridiem=e._meridiem,e._a[da]=ft(e._locale,e._a[da],e._meridiem),lt(e),it(e)}function ft(e,t,n){var r;return null==n?t:null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?(r=e.isPM(n),r&&t<12&&(t+=12),r||12!==t||(t=0),t):t}function pt(e){var t,n,r,a,i;if(0===e._f.length)return p(e).invalidFormat=!0,void(e._d=new Date(NaN));for(a=0;a<e._f.length;a++)i=0,t=b({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[a],_t(t),h(t)&&(i+=p(t).charsLeftOver,i+=10*p(t).unusedTokens.length,p(t).score=i,(null==r||i<r)&&(r=i,n=t));M(e,n||t)}function ht(e){if(!e._d){var t=R(e._i);e._a=d([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),lt(e)}}function mt(e){var t=new L(it(bt(e)));return t._nextDay&&(t.add(1,\"d\"),t._nextDay=void 0),t}function bt(e){var t=e._i,n=e._f;return e._locale=e._locale||rt(e._l),null===t||void 0===n&&\"\"===t?m({nullInput:!0}):(\"string\"==typeof t&&(e._i=t=e._locale.preparse(t)),A(t)?new L(it(t)):(u(t)?e._d=t:a(n)?pt(e):n?_t(e):Lt(e),h(e)||(e._d=null),e))}function Lt(e){var n=e._i;c(n)?e._d=new Date(t.now()):u(n)?e._d=new Date(n.valueOf()):\"string\"==typeof n?st(e):a(n)?(e._a=d(n.slice(0),function(e){return parseInt(e,10)}),lt(e)):i(n)?ht(e):s(n)?e._d=new Date(n):t.createFromInputFallback(e)}function At(e,t,n,r,c){var s={};return n!==!0&&n!==!1||(r=n,n=void 0),(i(e)&&o(e)||a(e)&&0===e.length)&&(e=void 0),s._isAMomentObject=!0,s._useUTC=s._isUTC=c,s._l=n,s._i=e,s._f=t,s._strict=r,mt(s)}function yt(e,t,n,r){return At(e,t,n,r,!1)}function zt(e,t){var n,r;if(1===t.length&&a(t[0])&&(t=t[0]),!t.length)return yt();for(n=t[0],r=1;r<t.length;++r)t[r].isValid()&&!t[r][e](n)||(n=t[r]);return n}function Tt(){var e=[].slice.call(arguments,0);return zt(\"isBefore\",e)}function gt(){var e=[].slice.call(arguments,0);return zt(\"isAfter\",e)}function vt(e){for(var t in e)if(Ia.indexOf(t)===-1||null!=e[t]&&isNaN(e[t]))return!1;for(var n=!1,r=0;r<Ia.length;++r)if(e[Ia[r]]){if(n)return!1;parseFloat(e[Ia[r]])!==z(e[Ia[r]])&&(n=!0)}return!0}function Ot(){return this._isValid}function Dt(){return It(NaN)}function kt(e){var t=R(e),n=t.year||0,r=t.quarter||0,a=t.month||0,i=t.week||0,o=t.day||0,c=t.hour||0,s=t.minute||0,u=t.second||0,d=t.millisecond||0;this._isValid=vt(t),this._milliseconds=+d+1e3*u+6e4*s+1e3*c*60*60,this._days=+o+7*i,this._months=+a+3*r+12*n,this._data={},this._locale=rt(),this._bubble()}function Yt(e){return e instanceof kt}function St(e){return e<0?Math.round(-1*e)*-1:Math.round(e)}function Nt(e,t){J(e,0,0,function(){var e=this.utcOffset(),n=\"+\";return e<0&&(e=-e,n=\"-\"),n+G(~~(e/60),2)+t+G(~~e%60,2)})}function wt(e,t){var n=(t||\"\").match(e);if(null===n)return null;var r=n[n.length-1]||[],a=(r+\"\").match(Ga)||[\"-\",0,0],i=+(60*a[1])+z(a[2]);return 0===i?0:\"+\"===a[0]?i:-i}function Wt(e,n){var r,a;return n._isUTC?(r=n.clone(),a=(A(e)||u(e)?e.valueOf():yt(e).valueOf())-r.valueOf(),r._d.setTime(r._d.valueOf()+a),t.updateOffset(r,!1),r):yt(e).local()}function qt(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Et(e,n,r){var a,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if(\"string\"==typeof e){if(e=wt(na,e),null===e)return this}else Math.abs(e)<16&&!r&&(e=60*e);return!this._isUTC&&n&&(a=qt(this)),this._offset=e,this._isUTC=!0,null!=a&&this.add(a,\"m\"),i!==e&&(!n||this._changeInProgress?Qt(this,It(e-i,\"m\"),1,!1):this._changeInProgress||(this._changeInProgress=!0,t.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?i:qt(this)}function Bt(e,t){return null!=e?(\"string\"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}function Ct(e){return this.utcOffset(0,e)}function Xt(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(qt(this),\"m\")),this}function Rt(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if(\"string\"==typeof this._i){var e=wt(ta,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this}function Ht(e){return!!this.isValid()&&(e=e?yt(e).utcOffset():0,(this.utcOffset()-e)%60===0)}function xt(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function jt(){if(!c(this._isDSTShifted))return this._isDSTShifted;var e={};if(b(e,this),e=bt(e),e._a){var t=e._isUTC?_(e._a):yt(e._a);this._isDSTShifted=this.isValid()&&T(e._a,t.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Pt(){return!!this.isValid()&&!this._isUTC}function Ft(){\nreturn!!this.isValid()&&this._isUTC}function Ut(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}function It(e,t){var n,r,a,i=e,o=null;return Yt(e)?i={ms:e._milliseconds,d:e._days,M:e._months}:s(e)?(i={},t?i[t]=e:i.milliseconds=e):(o=Ja.exec(e))?(n=\"-\"===o[1]?-1:1,i={y:0,d:z(o[ua])*n,h:z(o[da])*n,m:z(o[la])*n,s:z(o[Ma])*n,ms:z(St(1e3*o[_a]))*n}):(o=Va.exec(e))?(n=\"-\"===o[1]?-1:1,i={y:Gt(o[2],n),M:Gt(o[3],n),w:Gt(o[4],n),d:Gt(o[5],n),h:Gt(o[6],n),m:Gt(o[7],n),s:Gt(o[8],n)}):null==i?i={}:\"object\"==typeof i&&(\"from\"in i||\"to\"in i)&&(a=Vt(yt(i.from),yt(i.to)),i={},i.ms=a.milliseconds,i.M=a.months),r=new kt(i),Yt(e)&&l(e,\"_locale\")&&(r._locale=e._locale),r}function Gt(e,t){var n=e&&parseFloat(e.replace(\",\",\".\"));return(isNaN(n)?0:n)*t}function Jt(e,t){var n={milliseconds:0,months:0};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,\"M\").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,\"M\"),n}function Vt(e,t){var n;return e.isValid()&&t.isValid()?(t=Wt(t,e),e.isBefore(t)?n=Jt(e,t):(n=Jt(t,e),n.milliseconds=-n.milliseconds,n.months=-n.months),n):{milliseconds:0,months:0}}function Kt(e,t){return function(n,r){var a,i;return null===r||isNaN(+r)||(O(t,\"moment().\"+t+\"(period, number) is deprecated. Please use moment().\"+t+\"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.\"),i=n,n=r,r=i),n=\"string\"==typeof n?+n:n,a=It(n,r),Qt(this,a,e),this}}function Qt(e,n,r,a){var i=n._milliseconds,o=St(n._days),c=St(n._months);e.isValid()&&(a=null==a||a,i&&e._d.setTime(e._d.valueOf()+i*r),o&&F(e,\"Date\",P(e,\"Date\")+o*r),c&&le(e,P(e,\"Month\")+c*r),a&&t.updateOffset(e,o||c))}function Zt(e,t){var n=e.diff(t,\"days\",!0);return n<-6?\"sameElse\":n<-1?\"lastWeek\":n<0?\"lastDay\":n<1?\"sameDay\":n<2?\"nextDay\":n<7?\"nextWeek\":\"sameElse\"}function $t(e,n){var r=e||yt(),a=Wt(r,this).startOf(\"day\"),i=t.calendarFormat(this,a)||\"sameElse\",o=n&&(D(n[i])?n[i].call(this,r):n[i]);return this.format(o||this.localeData().calendar(i,this,yt(r)))}function en(){return new L(this)}function tn(e,t){var n=A(e)?e:yt(e);return!(!this.isValid()||!n.isValid())&&(t=X(c(t)?\"millisecond\":t),\"millisecond\"===t?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())}function nn(e,t){var n=A(e)?e:yt(e);return!(!this.isValid()||!n.isValid())&&(t=X(c(t)?\"millisecond\":t),\"millisecond\"===t?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())}function rn(e,t,n,r){return r=r||\"()\",(\"(\"===r[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(\")\"===r[1]?this.isBefore(t,n):!this.isAfter(t,n))}function an(e,t){var n,r=A(e)?e:yt(e);return!(!this.isValid()||!r.isValid())&&(t=X(t||\"millisecond\"),\"millisecond\"===t?this.valueOf()===r.valueOf():(n=r.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))}function on(e,t){return this.isSame(e,t)||this.isAfter(e,t)}function cn(e,t){return this.isSame(e,t)||this.isBefore(e,t)}function sn(e,t,n){var r,a,i,o;return this.isValid()?(r=Wt(e,this),r.isValid()?(a=6e4*(r.utcOffset()-this.utcOffset()),t=X(t),\"year\"===t||\"month\"===t||\"quarter\"===t?(o=un(this,r),\"quarter\"===t?o/=3:\"year\"===t&&(o/=12)):(i=this-r,o=\"second\"===t?i/1e3:\"minute\"===t?i/6e4:\"hour\"===t?i/36e5:\"day\"===t?(i-a)/864e5:\"week\"===t?(i-a)/6048e5:i),n?o:y(o)):NaN):NaN}function un(e,t){var n,r,a=12*(t.year()-e.year())+(t.month()-e.month()),i=e.clone().add(a,\"months\");return t-i<0?(n=e.clone().add(a-1,\"months\"),r=(t-i)/(i-n)):(n=e.clone().add(a+1,\"months\"),r=(t-i)/(n-i)),-(a+r)||0}function dn(){return this.clone().locale(\"en\").format(\"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ\")}function ln(){if(!this.isValid())return null;var e=this.clone().utc();return e.year()<0||e.year()>9999?Q(e,\"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]\"):D(Date.prototype.toISOString)?this.toDate().toISOString():Q(e,\"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]\")}function Mn(){if(!this.isValid())return\"moment.invalid(/* \"+this._i+\" */)\";var e=\"moment\",t=\"\";this.isLocal()||(e=0===this.utcOffset()?\"moment.utc\":\"moment.parseZone\",t=\"Z\");var n=\"[\"+e+'(\"]',r=0<=this.year()&&this.year()<=9999?\"YYYY\":\"YYYYYY\",a=\"-MM-DD[T]HH:mm:ss.SSS\",i=t+'[\")]';return this.format(n+r+a+i)}function _n(e){e||(e=this.isUtc()?t.defaultFormatUtc:t.defaultFormat);var n=Q(this,e);return this.localeData().postformat(n)}function fn(e,t){return this.isValid()&&(A(e)&&e.isValid()||yt(e).isValid())?It({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function pn(e){return this.from(yt(),e)}function hn(e,t){return this.isValid()&&(A(e)&&e.isValid()||yt(e).isValid())?It({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function mn(e){return this.to(yt(),e)}function bn(e){var t;return void 0===e?this._locale._abbr:(t=rt(e),null!=t&&(this._locale=t),this)}function Ln(){return this._locale}function An(e){switch(e=X(e)){case\"year\":this.month(0);case\"quarter\":case\"month\":this.date(1);case\"week\":case\"isoWeek\":case\"day\":case\"date\":this.hours(0);case\"hour\":this.minutes(0);case\"minute\":this.seconds(0);case\"second\":this.milliseconds(0)}return\"week\"===e&&this.weekday(0),\"isoWeek\"===e&&this.isoWeekday(1),\"quarter\"===e&&this.month(3*Math.floor(this.month()/3)),this}function yn(e){return e=X(e),void 0===e||\"millisecond\"===e?this:(\"date\"===e&&(e=\"day\"),this.startOf(e).add(1,\"isoWeek\"===e?\"week\":e).subtract(1,\"ms\"))}function zn(){return this._d.valueOf()-6e4*(this._offset||0)}function Tn(){return Math.floor(this.valueOf()/1e3)}function gn(){return new Date(this.valueOf())}function vn(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]}function On(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}}function Dn(){return this.isValid()?this.toISOString():null}function kn(){return h(this)}function Yn(){return M({},p(this))}function Sn(){return p(this).overflow}function Nn(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function wn(e,t){J(0,[e,e.length],0,t)}function Wn(e){return Cn.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function qn(e){return Cn.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)}function En(){return ve(this.year(),1,4)}function Bn(){var e=this.localeData()._week;return ve(this.year(),e.dow,e.doy)}function Cn(e,t,n,r,a){var i;return null==e?ge(this,r,a).year:(i=ve(e,r,a),t>i&&(t=i),Xn.call(this,e,t,n,r,a))}function Xn(e,t,n,r,a){var i=Te(e,t,n,r,a),o=ye(i.year,0,i.dayOfYear);return this.year(o.getUTCFullYear()),this.month(o.getUTCMonth()),this.date(o.getUTCDate()),this}function Rn(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)}function Hn(e){var t=Math.round((this.clone().startOf(\"day\")-this.clone().startOf(\"year\"))/864e5)+1;return null==e?t:this.add(e-t,\"d\")}function xn(e,t){t[_a]=z(1e3*(\"0.\"+e))}function jn(){return this._isUTC?\"UTC\":\"\"}function Pn(){return this._isUTC?\"Coordinated Universal Time\":\"\"}function Fn(e){return yt(1e3*e)}function Un(){return yt.apply(null,arguments).parseZone()}function In(e){return e}function Gn(e,t,n,r){var a=rt(),i=_().set(r,t);return a[n](i,e)}function Jn(e,t,n){if(s(e)&&(t=e,e=void 0),e=e||\"\",null!=t)return Gn(e,t,n,\"month\");var r,a=[];for(r=0;r<12;r++)a[r]=Gn(e,r,n,\"month\");return a}function Vn(e,t,n,r){\"boolean\"==typeof e?(s(t)&&(n=t,t=void 0),t=t||\"\"):(t=e,n=t,e=!1,s(t)&&(n=t,t=void 0),t=t||\"\");var a=rt(),i=e?a._week.dow:0;if(null!=n)return Gn(t,(n+i)%7,r,\"day\");var o,c=[];for(o=0;o<7;o++)c[o]=Gn(t,(o+i)%7,r,\"day\");return c}function Kn(e,t){return Jn(e,t,\"months\")}function Qn(e,t){return Jn(e,t,\"monthsShort\")}function Zn(e,t,n){return Vn(e,t,n,\"weekdays\")}function $n(e,t,n){return Vn(e,t,n,\"weekdaysShort\")}function er(e,t,n){return Vn(e,t,n,\"weekdaysMin\")}function tr(){var e=this._data;return this._milliseconds=oi(this._milliseconds),this._days=oi(this._days),this._months=oi(this._months),e.milliseconds=oi(e.milliseconds),e.seconds=oi(e.seconds),e.minutes=oi(e.minutes),e.hours=oi(e.hours),e.months=oi(e.months),e.years=oi(e.years),this}function nr(e,t,n,r){var a=It(t,n);return e._milliseconds+=r*a._milliseconds,e._days+=r*a._days,e._months+=r*a._months,e._bubble()}function rr(e,t){return nr(this,e,t,1)}function ar(e,t){return nr(this,e,t,-1)}function ir(e){return e<0?Math.floor(e):Math.ceil(e)}function or(){var e,t,n,r,a,i=this._milliseconds,o=this._days,c=this._months,s=this._data;return i>=0&&o>=0&&c>=0||i<=0&&o<=0&&c<=0||(i+=864e5*ir(sr(c)+o),o=0,c=0),s.milliseconds=i%1e3,e=y(i/1e3),s.seconds=e%60,t=y(e/60),s.minutes=t%60,n=y(t/60),s.hours=n%24,o+=y(n/24),a=y(cr(o)),c+=a,o-=ir(sr(a)),r=y(c/12),c%=12,s.days=o,s.months=c,s.years=r,this}function cr(e){return 4800*e/146097}function sr(e){return 146097*e/4800}function ur(e){if(!this.isValid())return NaN;var t,n,r=this._milliseconds;if(e=X(e),\"month\"===e||\"year\"===e)return t=this._days+r/864e5,n=this._months+cr(t),\"month\"===e?n:n/12;switch(t=this._days+Math.round(sr(this._months)),e){case\"week\":return t/7+r/6048e5;case\"day\":return t+r/864e5;case\"hour\":return 24*t+r/36e5;case\"minute\":return 1440*t+r/6e4;case\"second\":return 86400*t+r/1e3;case\"millisecond\":return Math.floor(864e5*t)+r;default:throw new Error(\"Unknown unit \"+e)}}function dr(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*z(this._months/12):NaN}function lr(e){return function(){return this.as(e)}}function Mr(e){return e=X(e),this.isValid()?this[e+\"s\"]():NaN}function _r(e){return function(){return this.isValid()?this._data[e]:NaN}}function fr(){return y(this.days()/7)}function pr(e,t,n,r,a){return a.relativeTime(t||1,!!n,e,r)}function hr(e,t,n){var r=It(e).abs(),a=zi(r.as(\"s\")),i=zi(r.as(\"m\")),o=zi(r.as(\"h\")),c=zi(r.as(\"d\")),s=zi(r.as(\"M\")),u=zi(r.as(\"y\")),d=a<=Ti.ss&&[\"s\",a]||a<Ti.s&&[\"ss\",a]||i<=1&&[\"m\"]||i<Ti.m&&[\"mm\",i]||o<=1&&[\"h\"]||o<Ti.h&&[\"hh\",o]||c<=1&&[\"d\"]||c<Ti.d&&[\"dd\",c]||s<=1&&[\"M\"]||s<Ti.M&&[\"MM\",s]||u<=1&&[\"y\"]||[\"yy\",u];return d[2]=t,d[3]=+e>0,d[4]=n,pr.apply(null,d)}function mr(e){return void 0===e?zi:\"function\"==typeof e&&(zi=e,!0)}function br(e,t){return void 0!==Ti[e]&&(void 0===t?Ti[e]:(Ti[e]=t,\"s\"===e&&(Ti.ss=t-1),!0))}function Lr(e){if(!this.isValid())return this.localeData().invalidDate();var t=this.localeData(),n=hr(this,!e,t);return e&&(n=t.pastFuture(+this,n)),t.postformat(n)}function Ar(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n,r=gi(this._milliseconds)/1e3,a=gi(this._days),i=gi(this._months);e=y(r/60),t=y(e/60),r%=60,e%=60,n=y(i/12),i%=12;var o=n,c=i,s=a,u=t,d=e,l=r,M=this.asSeconds();return M?(M<0?\"-\":\"\")+\"P\"+(o?o+\"Y\":\"\")+(c?c+\"M\":\"\")+(s?s+\"D\":\"\")+(u||d||l?\"T\":\"\")+(u?u+\"H\":\"\")+(d?d+\"M\":\"\")+(l?l+\"S\":\"\"):\"P0D\"}var yr,zr;zr=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,r=0;r<n;r++)if(r in t&&e.call(this,t[r],r,t))return!0;return!1};var Tr=zr,gr=t.momentProperties=[],vr=!1,Or={};t.suppressDeprecationWarnings=!1,t.deprecationHandler=null;var Dr;Dr=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)l(e,t)&&n.push(t);return n};var kr,Yr=Dr,Sr={sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},Nr={LTS:\"h:mm:ss A\",LT:\"h:mm A\",L:\"MM/DD/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},wr=\"Invalid date\",Wr=\"%d\",qr=/\\d{1,2}/,Er={future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",ss:\"%d seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},Br={},Cr={},Xr=/(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Rr=/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Hr={},xr={},jr=/\\d/,Pr=/\\d\\d/,Fr=/\\d{3}/,Ur=/\\d{4}/,Ir=/[+-]?\\d{6}/,Gr=/\\d\\d?/,Jr=/\\d\\d\\d\\d?/,Vr=/\\d\\d\\d\\d\\d\\d?/,Kr=/\\d{1,3}/,Qr=/\\d{1,4}/,Zr=/[+-]?\\d{1,6}/,$r=/\\d+/,ea=/[+-]?\\d+/,ta=/Z|[+-]\\d\\d:?\\d\\d/gi,na=/Z|[+-]\\d\\d(?::?\\d\\d)?/gi,ra=/[+-]?\\d+(\\.\\d{1,3})?/,aa=/[0-9]*['a-z\\u00A0-\\u05FF\\u0700-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]+|[\\u0600-\\u06FF\\/]+(\\s*?[\\u0600-\\u06FF]+){1,2}/i,ia={},oa={},ca=0,sa=1,ua=2,da=3,la=4,Ma=5,_a=6,fa=7,pa=8;kr=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1};var ha=kr;J(\"M\",[\"MM\",2],\"Mo\",function(){return this.month()+1}),J(\"MMM\",0,0,function(e){return this.localeData().monthsShort(this,e)}),J(\"MMMM\",0,0,function(e){return this.localeData().months(this,e)}),C(\"month\",\"M\"),H(\"month\",8),$(\"M\",Gr),$(\"MM\",Gr,Pr),$(\"MMM\",function(e,t){return t.monthsShortRegex(e)}),$(\"MMMM\",function(e,t){return t.monthsRegex(e)}),re([\"M\",\"MM\"],function(e,t){t[sa]=z(e)-1}),re([\"MMM\",\"MMMM\"],function(e,t,n,r){var a=n._locale.monthsParse(e,r,n._strict);null!=a?t[sa]=a:p(n).invalidMonth=e});var ma=/D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?/,ba=\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),La=\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),Aa=aa,ya=aa;J(\"Y\",0,0,function(){var e=this.year();return e<=9999?\"\"+e:\"+\"+e}),J(0,[\"YY\",2],0,function(){return this.year()%100}),J(0,[\"YYYY\",4],0,\"year\"),J(0,[\"YYYYY\",5],0,\"year\"),J(0,[\"YYYYYY\",6,!0],0,\"year\"),C(\"year\",\"y\"),H(\"year\",1),$(\"Y\",ea),$(\"YY\",Gr,Pr),$(\"YYYY\",Qr,Ur),$(\"YYYYY\",Zr,Ir),$(\"YYYYYY\",Zr,Ir),re([\"YYYYY\",\"YYYYYY\"],ca),re(\"YYYY\",function(e,n){n[ca]=2===e.length?t.parseTwoDigitYear(e):z(e)}),re(\"YY\",function(e,n){n[ca]=t.parseTwoDigitYear(e)}),re(\"Y\",function(e,t){t[ca]=parseInt(e,10)}),t.parseTwoDigitYear=function(e){return z(e)+(z(e)>68?1900:2e3)};var za=j(\"FullYear\",!0);J(\"w\",[\"ww\",2],\"wo\",\"week\"),J(\"W\",[\"WW\",2],\"Wo\",\"isoWeek\"),C(\"week\",\"w\"),C(\"isoWeek\",\"W\"),H(\"week\",5),H(\"isoWeek\",5),$(\"w\",Gr),$(\"ww\",Gr,Pr),$(\"W\",Gr),$(\"WW\",Gr,Pr),ae([\"w\",\"ww\",\"W\",\"WW\"],function(e,t,n,r){t[r.substr(0,1)]=z(e)});var Ta={dow:0,doy:6};J(\"d\",0,\"do\",\"day\"),J(\"dd\",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),J(\"ddd\",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),J(\"dddd\",0,0,function(e){return this.localeData().weekdays(this,e)}),J(\"e\",0,0,\"weekday\"),J(\"E\",0,0,\"isoWeekday\"),C(\"day\",\"d\"),C(\"weekday\",\"e\"),C(\"isoWeekday\",\"E\"),H(\"day\",11),H(\"weekday\",11),H(\"isoWeekday\",11),$(\"d\",Gr),$(\"e\",Gr),$(\"E\",Gr),$(\"dd\",function(e,t){return t.weekdaysMinRegex(e)}),$(\"ddd\",function(e,t){return t.weekdaysShortRegex(e)}),$(\"dddd\",function(e,t){return t.weekdaysRegex(e)}),ae([\"dd\",\"ddd\",\"dddd\"],function(e,t,n,r){var a=n._locale.weekdaysParse(e,r,n._strict);null!=a?t.d=a:p(n).invalidWeekday=e}),ae([\"d\",\"e\",\"E\"],function(e,t,n,r){t[r]=z(e)});var ga=\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),va=\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),Oa=\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),Da=aa,ka=aa,Ya=aa;J(\"H\",[\"HH\",2],0,\"hour\"),J(\"h\",[\"hh\",2],0,Ue),J(\"k\",[\"kk\",2],0,Ie),J(\"hmm\",0,0,function(){return\"\"+Ue.apply(this)+G(this.minutes(),2)}),J(\"hmmss\",0,0,function(){return\"\"+Ue.apply(this)+G(this.minutes(),2)+G(this.seconds(),2)}),J(\"Hmm\",0,0,function(){return\"\"+this.hours()+G(this.minutes(),2)}),J(\"Hmmss\",0,0,function(){return\"\"+this.hours()+G(this.minutes(),2)+G(this.seconds(),2)}),Ge(\"a\",!0),Ge(\"A\",!1),C(\"hour\",\"h\"),H(\"hour\",13),$(\"a\",Je),$(\"A\",Je),$(\"H\",Gr),$(\"h\",Gr),$(\"k\",Gr),$(\"HH\",Gr,Pr),$(\"hh\",Gr,Pr),$(\"kk\",Gr,Pr),$(\"hmm\",Jr),$(\"hmmss\",Vr),$(\"Hmm\",Jr),$(\"Hmmss\",Vr),re([\"H\",\"HH\"],da),re([\"k\",\"kk\"],function(e,t,n){var r=z(e);t[da]=24===r?0:r}),re([\"a\",\"A\"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),re([\"h\",\"hh\"],function(e,t,n){t[da]=z(e),p(n).bigHour=!0}),re(\"hmm\",function(e,t,n){var r=e.length-2;t[da]=z(e.substr(0,r)),t[la]=z(e.substr(r)),p(n).bigHour=!0}),re(\"hmmss\",function(e,t,n){var r=e.length-4,a=e.length-2;t[da]=z(e.substr(0,r)),t[la]=z(e.substr(r,2)),t[Ma]=z(e.substr(a)),p(n).bigHour=!0}),re(\"Hmm\",function(e,t,n){var r=e.length-2;t[da]=z(e.substr(0,r)),t[la]=z(e.substr(r))}),re(\"Hmmss\",function(e,t,n){var r=e.length-4,a=e.length-2;t[da]=z(e.substr(0,r)),t[la]=z(e.substr(r,2)),t[Ma]=z(e.substr(a))});var Sa,Na=/[ap]\\.?m?\\.?/i,wa=j(\"Hours\",!0),Wa={calendar:Sr,longDateFormat:Nr,invalidDate:wr,ordinal:Wr,dayOfMonthOrdinalParse:qr,relativeTime:Er,months:ba,monthsShort:La,week:Ta,weekdays:ga,weekdaysMin:Oa,weekdaysShort:va,meridiemParse:Na},qa={},Ea={},Ba=/^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,Ca=/^\\s*((?:[+-]\\d{6}|\\d{4})(?:\\d\\d\\d\\d|W\\d\\d\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?:\\d\\d(?:\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$/,Xa=/Z|[+-]\\d\\d(?::?\\d\\d)?/,Ra=[[\"YYYYYY-MM-DD\",/[+-]\\d{6}-\\d\\d-\\d\\d/],[\"YYYY-MM-DD\",/\\d{4}-\\d\\d-\\d\\d/],[\"GGGG-[W]WW-E\",/\\d{4}-W\\d\\d-\\d/],[\"GGGG-[W]WW\",/\\d{4}-W\\d\\d/,!1],[\"YYYY-DDD\",/\\d{4}-\\d{3}/],[\"YYYY-MM\",/\\d{4}-\\d\\d/,!1],[\"YYYYYYMMDD\",/[+-]\\d{10}/],[\"YYYYMMDD\",/\\d{8}/],[\"GGGG[W]WWE\",/\\d{4}W\\d{3}/],[\"GGGG[W]WW\",/\\d{4}W\\d{2}/,!1],[\"YYYYDDD\",/\\d{7}/]],Ha=[[\"HH:mm:ss.SSSS\",/\\d\\d:\\d\\d:\\d\\d\\.\\d+/],[\"HH:mm:ss,SSSS\",/\\d\\d:\\d\\d:\\d\\d,\\d+/],[\"HH:mm:ss\",/\\d\\d:\\d\\d:\\d\\d/],[\"HH:mm\",/\\d\\d:\\d\\d/],[\"HHmmss.SSSS\",/\\d\\d\\d\\d\\d\\d\\.\\d+/],[\"HHmmss,SSSS\",/\\d\\d\\d\\d\\d\\d,\\d+/],[\"HHmmss\",/\\d\\d\\d\\d\\d\\d/],[\"HHmm\",/\\d\\d\\d\\d/],[\"HH\",/\\d\\d/]],xa=/^\\/?Date\\((\\-?\\d+)/i,ja=/^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\\s)?(\\d?\\d\\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s(?:\\d\\d)?\\d\\d\\s)(\\d\\d:\\d\\d)(\\:\\d\\d)?(\\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\\d{4}))$/;t.createFromInputFallback=v(\"value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.\",function(e){e._d=new Date(e._i+(e._useUTC?\" UTC\":\"\"))}),t.ISO_8601=function(){},t.RFC_2822=function(){};var Pa=v(\"moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=yt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:m()}),Fa=v(\"moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/\",function(){var e=yt.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:m()}),Ua=function(){return Date.now?Date.now():+new Date},Ia=[\"year\",\"quarter\",\"month\",\"week\",\"day\",\"hour\",\"minute\",\"second\",\"millisecond\"];Nt(\"Z\",\":\"),Nt(\"ZZ\",\"\"),$(\"Z\",na),$(\"ZZ\",na),re([\"Z\",\"ZZ\"],function(e,t,n){n._useUTC=!0,n._tzm=wt(na,e)});var Ga=/([\\+\\-]|\\d\\d)/gi;t.updateOffset=function(){};var Ja=/^(\\-)?(?:(\\d*)[. ])?(\\d+)\\:(\\d+)(?:\\:(\\d+)(\\.\\d*)?)?$/,Va=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;It.fn=kt.prototype,It.invalid=Dt;var Ka=Kt(1,\"add\"),Qa=Kt(-1,\"subtract\");t.defaultFormat=\"YYYY-MM-DDTHH:mm:ssZ\",t.defaultFormatUtc=\"YYYY-MM-DDTHH:mm:ss[Z]\";var Za=v(\"moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.\",function(e){return void 0===e?this.localeData():this.locale(e)});J(0,[\"gg\",2],0,function(){return this.weekYear()%100}),J(0,[\"GG\",2],0,function(){return this.isoWeekYear()%100}),wn(\"gggg\",\"weekYear\"),wn(\"ggggg\",\"weekYear\"),wn(\"GGGG\",\"isoWeekYear\"),wn(\"GGGGG\",\"isoWeekYear\"),C(\"weekYear\",\"gg\"),C(\"isoWeekYear\",\"GG\"),H(\"weekYear\",1),H(\"isoWeekYear\",1),$(\"G\",ea),$(\"g\",ea),$(\"GG\",Gr,Pr),$(\"gg\",Gr,Pr),$(\"GGGG\",Qr,Ur),$(\"gggg\",Qr,Ur),$(\"GGGGG\",Zr,Ir),$(\"ggggg\",Zr,Ir),ae([\"gggg\",\"ggggg\",\"GGGG\",\"GGGGG\"],function(e,t,n,r){t[r.substr(0,2)]=z(e)}),ae([\"gg\",\"GG\"],function(e,n,r,a){n[a]=t.parseTwoDigitYear(e)}),J(\"Q\",0,\"Qo\",\"quarter\"),C(\"quarter\",\"Q\"),H(\"quarter\",7),$(\"Q\",jr),re(\"Q\",function(e,t){t[sa]=3*(z(e)-1)}),J(\"D\",[\"DD\",2],\"Do\",\"date\"),C(\"date\",\"D\"),H(\"date\",9),$(\"D\",Gr),$(\"DD\",Gr,Pr),$(\"Do\",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),re([\"D\",\"DD\"],ua),re(\"Do\",function(e,t){t[ua]=z(e.match(Gr)[0],10)});var $a=j(\"Date\",!0);J(\"DDD\",[\"DDDD\",3],\"DDDo\",\"dayOfYear\"),C(\"dayOfYear\",\"DDD\"),H(\"dayOfYear\",4),$(\"DDD\",Kr),$(\"DDDD\",Fr),re([\"DDD\",\"DDDD\"],function(e,t,n){n._dayOfYear=z(e)}),J(\"m\",[\"mm\",2],0,\"minute\"),C(\"minute\",\"m\"),H(\"minute\",14),$(\"m\",Gr),$(\"mm\",Gr,Pr),re([\"m\",\"mm\"],la);var ei=j(\"Minutes\",!1);J(\"s\",[\"ss\",2],0,\"second\"),C(\"second\",\"s\"),H(\"second\",15),$(\"s\",Gr),$(\"ss\",Gr,Pr),re([\"s\",\"ss\"],Ma);var ti=j(\"Seconds\",!1);J(\"S\",0,0,function(){return~~(this.millisecond()/100)}),J(0,[\"SS\",2],0,function(){return~~(this.millisecond()/10)}),J(0,[\"SSS\",3],0,\"millisecond\"),J(0,[\"SSSS\",4],0,function(){return 10*this.millisecond()}),J(0,[\"SSSSS\",5],0,function(){return 100*this.millisecond()}),J(0,[\"SSSSSS\",6],0,function(){return 1e3*this.millisecond()}),J(0,[\"SSSSSSS\",7],0,function(){return 1e4*this.millisecond()}),J(0,[\"SSSSSSSS\",8],0,function(){return 1e5*this.millisecond()}),J(0,[\"SSSSSSSSS\",9],0,function(){return 1e6*this.millisecond()}),C(\"millisecond\",\"ms\"),H(\"millisecond\",16),$(\"S\",Kr,jr),$(\"SS\",Kr,Pr),$(\"SSS\",Kr,Fr);var ni;for(ni=\"SSSS\";ni.length<=9;ni+=\"S\")$(ni,$r);for(ni=\"S\";ni.length<=9;ni+=\"S\")re(ni,xn);var ri=j(\"Milliseconds\",!1);J(\"z\",0,0,\"zoneAbbr\"),J(\"zz\",0,0,\"zoneName\");var ai=L.prototype;ai.add=Ka,ai.calendar=$t,ai.clone=en,ai.diff=sn,ai.endOf=yn,ai.format=_n,ai.from=fn,ai.fromNow=pn,ai.to=hn,ai.toNow=mn,ai.get=U,ai.invalidAt=Sn,ai.isAfter=tn,ai.isBefore=nn,ai.isBetween=rn,ai.isSame=an,ai.isSameOrAfter=on,ai.isSameOrBefore=cn,ai.isValid=kn,ai.lang=Za,ai.locale=bn,ai.localeData=Ln,ai.max=Fa,ai.min=Pa,ai.parsingFlags=Yn,ai.set=I,ai.startOf=An,ai.subtract=Qa,ai.toArray=vn,ai.toObject=On,ai.toDate=gn,ai.toISOString=ln,ai.inspect=Mn,ai.toJSON=Dn,ai.toString=dn,ai.unix=Tn,ai.valueOf=zn,ai.creationData=Nn,ai.year=za,ai.isLeapYear=Le,ai.weekYear=Wn,ai.isoWeekYear=qn,ai.quarter=ai.quarters=Rn,ai.month=Me,ai.daysInMonth=_e,ai.week=ai.weeks=Ye,ai.isoWeek=ai.isoWeeks=Se,ai.weeksInYear=Bn,ai.isoWeeksInYear=En,ai.date=$a,ai.day=ai.days=Xe,ai.weekday=Re,ai.isoWeekday=He,ai.dayOfYear=Hn,ai.hour=ai.hours=wa,ai.minute=ai.minutes=ei,ai.second=ai.seconds=ti,ai.millisecond=ai.milliseconds=ri,ai.utcOffset=Et,ai.utc=Ct,ai.local=Xt,ai.parseZone=Rt,ai.hasAlignedHourOffset=Ht,ai.isDST=xt,ai.isLocal=Pt,ai.isUtcOffset=Ft,ai.isUtc=Ut,ai.isUTC=Ut,ai.zoneAbbr=jn,ai.zoneName=Pn,ai.dates=v(\"dates accessor is deprecated. Use date instead.\",$a),ai.months=v(\"months accessor is deprecated. Use month instead\",Me),ai.years=v(\"years accessor is deprecated. Use year instead\",za),ai.zone=v(\"moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/\",Bt),ai.isDSTShifted=v(\"isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information\",jt);var ii=S.prototype;ii.calendar=N,ii.longDateFormat=w,ii.invalidDate=W,ii.ordinal=q,ii.preparse=In,ii.postformat=In,ii.relativeTime=E,ii.pastFuture=B,ii.set=k,ii.months=ce,ii.monthsShort=se,ii.monthsParse=de,ii.monthsRegex=pe,ii.monthsShortRegex=fe,ii.week=Oe,ii.firstDayOfYear=ke,ii.firstDayOfWeek=De,ii.weekdays=We,ii.weekdaysMin=Ee,ii.weekdaysShort=qe,ii.weekdaysParse=Ce,ii.weekdaysRegex=xe,ii.weekdaysShortRegex=je,ii.weekdaysMinRegex=Pe,ii.isPM=Ve,ii.meridiem=Ke,et(\"en\",{dayOfMonthOrdinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10,n=1===z(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n}}),t.lang=v(\"moment.lang is deprecated. Use moment.locale instead.\",et),t.langData=v(\"moment.langData is deprecated. Use moment.localeData instead.\",rt);var oi=Math.abs,ci=lr(\"ms\"),si=lr(\"s\"),ui=lr(\"m\"),di=lr(\"h\"),li=lr(\"d\"),Mi=lr(\"w\"),_i=lr(\"M\"),fi=lr(\"y\"),pi=_r(\"milliseconds\"),hi=_r(\"seconds\"),mi=_r(\"minutes\"),bi=_r(\"hours\"),Li=_r(\"days\"),Ai=_r(\"months\"),yi=_r(\"years\"),zi=Math.round,Ti={ss:44,s:45,m:45,h:22,d:26,M:11},gi=Math.abs,vi=kt.prototype;return vi.isValid=Ot,vi.abs=tr,vi.add=rr,vi.subtract=ar,vi.as=ur,vi.asMilliseconds=ci,vi.asSeconds=si,vi.asMinutes=ui,vi.asHours=di,vi.asDays=li,vi.asWeeks=Mi,vi.asMonths=_i,vi.asYears=fi,vi.valueOf=dr,vi._bubble=or,vi.get=Mr,vi.milliseconds=pi,vi.seconds=hi,vi.minutes=mi,vi.hours=bi,vi.days=Li,vi.weeks=fr,vi.months=Ai,vi.years=yi,vi.humanize=Lr,vi.toISOString=Ar,vi.toString=Ar,vi.toJSON=Ar,vi.locale=bn,vi.localeData=Ln,vi.toIsoString=v(\"toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)\",Ar),vi.lang=Za,J(\"X\",0,0,\"unix\"),J(\"x\",0,0,\"valueOf\"),$(\"x\",ea),$(\"X\",ra),re(\"X\",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),re(\"x\",function(e,t,n){n._d=new Date(z(e))}),t.version=\"2.18.1\",r(yt),t.fn=ai,t.min=Tt,t.max=gt,t.now=Ua,t.utc=_,t.unix=Fn,t.months=Kn,t.isDate=u,t.locale=et,t.invalid=m,t.duration=It,t.isMoment=A,t.weekdays=Zn,t.parseZone=Un,t.localeData=rt,t.isDuration=Yt,t.monthsShort=Qn,t.weekdaysMin=er,t.defineLocale=tt,t.updateLocale=nt,t.locales=at,t.weekdaysShort=$n,t.normalizeUnits=X,t.relativeTimeRounding=mr,t.relativeTimeThreshold=br,t.calendarFormat=Zt,t.prototype=ai,t})}).call(t,n(47)(e))},function(e,t,n){function r(e){return n(a(e))}function a(e){return i[e]||function(){throw new Error(\"Cannot find module '\"+e+\"'.\")}()}var i={\"./af\":60,\"./af.js\":60,\"./ar\":61,\"./ar-dz\":62,\"./ar-dz.js\":62,\"./ar-kw\":63,\"./ar-kw.js\":63,\"./ar-ly\":64,\"./ar-ly.js\":64,\"./ar-ma\":65,\"./ar-ma.js\":65,\"./ar-sa\":66,\"./ar-sa.js\":66,\"./ar-tn\":67,\"./ar-tn.js\":67,\"./ar.js\":61,\"./az\":68,\"./az.js\":68,\"./be\":69,\"./be.js\":69,\"./bg\":70,\"./bg.js\":70,\"./bn\":71,\"./bn.js\":71,\"./bo\":72,\"./bo.js\":72,\"./br\":73,\"./br.js\":73,\"./bs\":74,\"./bs.js\":74,\"./ca\":75,\"./ca.js\":75,\"./cs\":76,\"./cs.js\":76,\"./cv\":77,\"./cv.js\":77,\"./cy\":78,\"./cy.js\":78,\"./da\":79,\"./da.js\":79,\"./de\":80,\"./de-at\":81,\"./de-at.js\":81,\"./de-ch\":82,\"./de-ch.js\":82,\"./de.js\":80,\"./dv\":83,\"./dv.js\":83,\"./el\":84,\"./el.js\":84,\"./en-au\":85,\"./en-au.js\":85,\"./en-ca\":86,\"./en-ca.js\":86,\"./en-gb\":87,\"./en-gb.js\":87,\"./en-ie\":88,\"./en-ie.js\":88,\"./en-nz\":89,\"./en-nz.js\":89,\"./eo\":90,\"./eo.js\":90,\"./es\":91,\"./es-do\":92,\"./es-do.js\":92,\"./es.js\":91,\"./et\":93,\"./et.js\":93,\"./eu\":94,\"./eu.js\":94,\"./fa\":95,\"./fa.js\":95,\"./fi\":96,\"./fi.js\":96,\"./fo\":97,\"./fo.js\":97,\"./fr\":98,\"./fr-ca\":99,\"./fr-ca.js\":99,\"./fr-ch\":100,\"./fr-ch.js\":100,\"./fr.js\":98,\"./fy\":101,\"./fy.js\":101,\"./gd\":102,\"./gd.js\":102,\"./gl\":103,\"./gl.js\":103,\"./gom-latn\":104,\"./gom-latn.js\":104,\"./he\":105,\"./he.js\":105,\"./hi\":106,\"./hi.js\":106,\"./hr\":107,\"./hr.js\":107,\"./hu\":108,\"./hu.js\":108,\"./hy-am\":109,\"./hy-am.js\":109,\"./id\":110,\"./id.js\":110,\"./is\":111,\"./is.js\":111,\"./it\":112,\"./it.js\":112,\"./ja\":113,\"./ja.js\":113,\"./jv\":114,\"./jv.js\":114,\"./ka\":115,\"./ka.js\":115,\"./kk\":116,\"./kk.js\":116,\"./km\":117,\"./km.js\":117,\"./kn\":118,\"./kn.js\":118,\"./ko\":119,\"./ko.js\":119,\"./ky\":120,\"./ky.js\":120,\"./lb\":121,\"./lb.js\":121,\"./lo\":122,\"./lo.js\":122,\"./lt\":123,\"./lt.js\":123,\"./lv\":124,\"./lv.js\":124,\"./me\":125,\"./me.js\":125,\"./mi\":126,\"./mi.js\":126,\"./mk\":127,\"./mk.js\":127,\"./ml\":128,\"./ml.js\":128,\"./mr\":129,\"./mr.js\":129,\"./ms\":130,\"./ms-my\":131,\"./ms-my.js\":131,\"./ms.js\":130,\"./my\":132,\"./my.js\":132,\"./nb\":133,\"./nb.js\":133,\"./ne\":134,\"./ne.js\":134,\"./nl\":135,\"./nl-be\":136,\"./nl-be.js\":136,\"./nl.js\":135,\"./nn\":137,\"./nn.js\":137,\"./pa-in\":138,\"./pa-in.js\":138,\"./pl\":139,\"./pl.js\":139,\"./pt\":140,\"./pt-br\":141,\"./pt-br.js\":141,\"./pt.js\":140,\"./ro\":142,\"./ro.js\":142,\"./ru\":143,\"./ru.js\":143,\"./sd\":144,\"./sd.js\":144,\"./se\":145,\"./se.js\":145,\"./si\":146,\"./si.js\":146,\"./sk\":147,\"./sk.js\":147,\"./sl\":148,\"./sl.js\":148,\"./sq\":149,\"./sq.js\":149,\"./sr\":150,\"./sr-cyrl\":151,\"./sr-cyrl.js\":151,\"./sr.js\":150,\"./ss\":152,\"./ss.js\":152,\"./sv\":153,\"./sv.js\":153,\"./sw\":154,\"./sw.js\":154,\"./ta\":155,\"./ta.js\":155,\"./te\":156,\"./te.js\":156,\"./tet\":157,\"./tet.js\":157,\"./th\":158,\"./th.js\":158,\"./tl-ph\":159,\"./tl-ph.js\":159,\"./tlh\":160,\"./tlh.js\":160,\"./tr\":161,\"./tr.js\":161,\"./tzl\":162,\"./tzl.js\":162,\"./tzm\":163,\"./tzm-latn\":164,\"./tzm-latn.js\":164,\"./tzm.js\":163,\"./uk\":165,\"./uk.js\":165,\"./ur\":166,\"./ur.js\":166,\"./uz\":167,\"./uz-latn\":168,\"./uz-latn.js\":168,\"./uz.js\":167,\"./vi\":169,\"./vi.js\":169,\"./x-pseudo\":170,\"./x-pseudo.js\":170,\"./yo\":171,\"./yo.js\":171,\"./zh-cn\":172,\"./zh-cn.js\":172,\"./zh-hk\":173,\"./zh-hk.js\":173,\"./zh-tw\":174,\"./zh-tw.js\":174};r.keys=function(){return Object.keys(i)},r.resolve=a,e.exports=r,r.id=59},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"af\",{months:\"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag\".split(\"_\"),weekdaysShort:\"Son_Maa_Din_Woe_Don_Vry_Sat\".split(\"_\"),weekdaysMin:\"So_Ma_Di_Wo_Do_Vr_Sa\".split(\"_\"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,t,n){return e<12?n?\"vm\":\"VM\":n?\"nm\":\"NM\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Vandag om] LT\",nextDay:\"[Môre om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[Gister om] LT\",lastWeek:\"[Laas] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"oor %s\",past:\"%s gelede\",s:\"'n paar sekondes\",m:\"'n minuut\",mm:\"%d minute\",h:\"'n uur\",hh:\"%d ure\",d:\"'n dag\",dd:\"%d dae\",M:\"'n maand\",MM:\"%d maande\",y:\"'n jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"١\",2:\"٢\",3:\"٣\",4:\"٤\",5:\"٥\",6:\"٦\",7:\"٧\",8:\"٨\",9:\"٩\",0:\"٠\"},n={\"١\":\"1\",\"٢\":\"2\",\"٣\":\"3\",\"٤\":\"4\",\"٥\":\"5\",\"٦\":\"6\",\"٧\":\"7\",\"٨\":\"8\",\"٩\":\"9\",\"٠\":\"0\"},r=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},a={s:[\"أقل من ثانية\",\"ثانية واحدة\",[\"ثانيتان\",\"ثانيتين\"],\"%d ثوان\",\"%d ثانية\",\"%d ثانية\"],m:[\"أقل من دقيقة\",\"دقيقة واحدة\",[\"دقيقتان\",\"دقيقتين\"],\"%d دقائق\",\"%d دقيقة\",\"%d دقيقة\"],h:[\"أقل من ساعة\",\"ساعة واحدة\",[\"ساعتان\",\"ساعتين\"],\"%d ساعات\",\"%d ساعة\",\"%d ساعة\"],d:[\"أقل من يوم\",\"يوم واحد\",[\"يومان\",\"يومين\"],\"%d أيام\",\"%d يومًا\",\"%d يوم\"],M:[\"أقل من شهر\",\"شهر واحد\",[\"شهران\",\"شهرين\"],\"%d أشهر\",\"%d شهرا\",\"%d شهر\"],y:[\"أقل من عام\",\"عام واحد\",[\"عامان\",\"عامين\"],\"%d أعوام\",\"%d عامًا\",\"%d عام\"]},i=function(e){return function(t,n,i,o){var c=r(t),s=a[e][r(t)];return 2===c&&(s=s[n?0:1]),s.replace(/%d/i,t)}},o=[\"كانون الثاني يناير\",\"شباط فبراير\",\"آذار مارس\",\"نيسان أبريل\",\"أيار مايو\",\"حزيران يونيو\",\"تموز يوليو\",\"آب أغسطس\",\"أيلول سبتمبر\",\"تشرين الأول أكتوبر\",\"تشرين الثاني نوفمبر\",\"كانون الأول ديسمبر\"],c=e.defineLocale(\"ar\",{months:o,monthsShort:o,weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/‏M/‏YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,t,n){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم عند الساعة] LT\",nextDay:\"[غدًا عند الساعة] LT\",nextWeek:\"dddd [عند الساعة] LT\",lastDay:\"[أمس عند الساعة] LT\",lastWeek:\"dddd [عند الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"بعد %s\",past:\"منذ %s\",s:i(\"s\"),m:i(\"m\"),mm:i(\"m\"),h:i(\"h\"),hh:i(\"h\"),d:i(\"d\"),dd:i(\"d\"),M:i(\"M\"),MM:i(\"M\"),y:i(\"y\"),yy:i(\"y\")},preparse:function(e){return e.replace(/\\u200f/g,\"\").replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]}).replace(/,/g,\"،\")},week:{dow:6,doy:12}});return c})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ar-dz\",{months:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),\nweekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"أح_إث_ثلا_أر_خم_جم_سب\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:0,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ar-kw\",{months:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),weekdays:\"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:0,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"1\",2:\"2\",3:\"3\",4:\"4\",5:\"5\",6:\"6\",7:\"7\",8:\"8\",9:\"9\",0:\"0\"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:[\"أقل من ثانية\",\"ثانية واحدة\",[\"ثانيتان\",\"ثانيتين\"],\"%d ثوان\",\"%d ثانية\",\"%d ثانية\"],m:[\"أقل من دقيقة\",\"دقيقة واحدة\",[\"دقيقتان\",\"دقيقتين\"],\"%d دقائق\",\"%d دقيقة\",\"%d دقيقة\"],h:[\"أقل من ساعة\",\"ساعة واحدة\",[\"ساعتان\",\"ساعتين\"],\"%d ساعات\",\"%d ساعة\",\"%d ساعة\"],d:[\"أقل من يوم\",\"يوم واحد\",[\"يومان\",\"يومين\"],\"%d أيام\",\"%d يومًا\",\"%d يوم\"],M:[\"أقل من شهر\",\"شهر واحد\",[\"شهران\",\"شهرين\"],\"%d أشهر\",\"%d شهرا\",\"%d شهر\"],y:[\"أقل من عام\",\"عام واحد\",[\"عامان\",\"عامين\"],\"%d أعوام\",\"%d عامًا\",\"%d عام\"]},a=function(e){return function(t,a,i,o){var c=n(t),s=r[e][n(t)];return 2===c&&(s=s[a?0:1]),s.replace(/%d/i,t)}},i=[\"يناير\",\"فبراير\",\"مارس\",\"أبريل\",\"مايو\",\"يونيو\",\"يوليو\",\"أغسطس\",\"سبتمبر\",\"أكتوبر\",\"نوفمبر\",\"ديسمبر\"],o=e.defineLocale(\"ar-ly\",{months:i,monthsShort:i,weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/‏M/‏YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,t,n){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم عند الساعة] LT\",nextDay:\"[غدًا عند الساعة] LT\",nextWeek:\"dddd [عند الساعة] LT\",lastDay:\"[أمس عند الساعة] LT\",lastWeek:\"dddd [عند الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"بعد %s\",past:\"منذ %s\",s:a(\"s\"),m:a(\"m\"),mm:a(\"m\"),h:a(\"h\"),hh:a(\"h\"),d:a(\"d\"),dd:a(\"d\"),M:a(\"M\"),MM:a(\"M\"),y:a(\"y\"),yy:a(\"y\")},preparse:function(e){return e.replace(/\\u200f/g,\"\").replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]}).replace(/,/g,\"،\")},week:{dow:6,doy:12}});return o})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ar-ma\",{months:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر\".split(\"_\"),weekdays:\"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"١\",2:\"٢\",3:\"٣\",4:\"٤\",5:\"٥\",6:\"٦\",7:\"٧\",8:\"٨\",9:\"٩\",0:\"٠\"},n={\"١\":\"1\",\"٢\":\"2\",\"٣\":\"3\",\"٤\":\"4\",\"٥\":\"5\",\"٦\":\"6\",\"٧\":\"7\",\"٨\":\"8\",\"٩\":\"9\",\"٠\":\"0\"},r=e.defineLocale(\"ar-sa\",{months:\"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/ص|م/,isPM:function(e){return\"م\"===e},meridiem:function(e,t,n){return e<12?\"ص\":\"م\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]}).replace(/,/g,\"،\")},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ar-tn\",{months:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),monthsShort:\"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر\".split(\"_\"),weekdays:\"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت\".split(\"_\"),weekdaysShort:\"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت\".split(\"_\"),weekdaysMin:\"ح_ن_ث_ر_خ_ج_س\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[اليوم على الساعة] LT\",nextDay:\"[غدا على الساعة] LT\",nextWeek:\"dddd [على الساعة] LT\",lastDay:\"[أمس على الساعة] LT\",lastWeek:\"dddd [على الساعة] LT\",sameElse:\"L\"},relativeTime:{future:\"في %s\",past:\"منذ %s\",s:\"ثوان\",m:\"دقيقة\",mm:\"%d دقائق\",h:\"ساعة\",hh:\"%d ساعات\",d:\"يوم\",dd:\"%d أيام\",M:\"شهر\",MM:\"%d أشهر\",y:\"سنة\",yy:\"%d سنوات\"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"-inci\",5:\"-inci\",8:\"-inci\",70:\"-inci\",80:\"-inci\",2:\"-nci\",7:\"-nci\",20:\"-nci\",50:\"-nci\",3:\"-üncü\",4:\"-üncü\",100:\"-üncü\",6:\"-ncı\",9:\"-uncu\",10:\"-uncu\",30:\"-uncu\",60:\"-ıncı\",90:\"-ıncı\"},n=e.defineLocale(\"az\",{months:\"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr\".split(\"_\"),monthsShort:\"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek\".split(\"_\"),weekdays:\"Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə\".split(\"_\"),weekdaysShort:\"Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən\".split(\"_\"),weekdaysMin:\"Bz_BE_ÇA_Çə_CA_Cü_Şə\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[bugün saat] LT\",nextDay:\"[sabah saat] LT\",nextWeek:\"[gələn həftə] dddd [saat] LT\",lastDay:\"[dünən] LT\",lastWeek:\"[keçən həftə] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s sonra\",past:\"%s əvvəl\",s:\"birneçə saniyyə\",m:\"bir dəqiqə\",mm:\"%d dəqiqə\",h:\"bir saat\",hh:\"%d saat\",d:\"bir gün\",dd:\"%d gün\",M:\"bir ay\",MM:\"%d ay\",y:\"bir il\",yy:\"%d il\"},meridiemParse:/gecə|səhər|gündüz|axşam/,isPM:function(e){return/^(gündüz|axşam)$/.test(e)},meridiem:function(e,t,n){return e<4?\"gecə\":e<12?\"səhər\":e<17?\"gündüz\":\"axşam\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,ordinal:function(e){if(0===e)return e+\"-ıncı\";var n=e%10,r=e%100-n,a=e>=100?100:null;return e+(t[n]||t[r]||t[a])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t){var n=e.split(\"_\");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var a={mm:n?\"хвіліна_хвіліны_хвілін\":\"хвіліну_хвіліны_хвілін\",hh:n?\"гадзіна_гадзіны_гадзін\":\"гадзіну_гадзіны_гадзін\",dd:\"дзень_дні_дзён\",MM:\"месяц_месяцы_месяцаў\",yy:\"год_гады_гадоў\"};return\"m\"===r?n?\"хвіліна\":\"хвіліну\":\"h\"===r?n?\"гадзіна\":\"гадзіну\":e+\" \"+t(a[r],+e)}var r=e.defineLocale(\"be\",{months:{format:\"студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня\".split(\"_\"),standalone:\"студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань\".split(\"_\")},monthsShort:\"студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж\".split(\"_\"),weekdays:{format:\"нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу\".split(\"_\"),standalone:\"нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота\".split(\"_\"),isFormat:/\\[ ?[Вв] ?(?:мінулую|наступную)? ?\\] ?dddd/},weekdaysShort:\"нд_пн_ат_ср_чц_пт_сб\".split(\"_\"),weekdaysMin:\"нд_пн_ат_ср_чц_пт_сб\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY г.\",LLL:\"D MMMM YYYY г., HH:mm\",LLLL:\"dddd, D MMMM YYYY г., HH:mm\"},calendar:{sameDay:\"[Сёння ў] LT\",nextDay:\"[Заўтра ў] LT\",lastDay:\"[Учора ў] LT\",nextWeek:function(){return\"[У] dddd [ў] LT\"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return\"[У мінулую] dddd [ў] LT\";case 1:case 2:case 4:return\"[У мінулы] dddd [ў] LT\"}},sameElse:\"L\"},relativeTime:{future:\"праз %s\",past:\"%s таму\",s:\"некалькі секунд\",m:n,mm:n,h:n,hh:n,d:\"дзень\",dd:n,M:\"месяц\",MM:n,y:\"год\",yy:n},meridiemParse:/ночы|раніцы|дня|вечара/,isPM:function(e){return/^(дня|вечара)$/.test(e)},meridiem:function(e,t,n){return e<4?\"ночы\":e<12?\"раніцы\":e<17?\"дня\":\"вечара\"},dayOfMonthOrdinalParse:/\\d{1,2}-(і|ы|га)/,ordinal:function(e,t){switch(t){case\"M\":case\"d\":case\"DDD\":case\"w\":case\"W\":return e%10!==2&&e%10!==3||e%100===12||e%100===13?e+\"-ы\":e+\"-і\";case\"D\":return e+\"-га\";default:return e}},week:{dow:1,doy:7}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"bg\",{months:\"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември\".split(\"_\"),monthsShort:\"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек\".split(\"_\"),weekdays:\"неделя_понеделник_вторник_сряда_четвъртък_петък_събота\".split(\"_\"),weekdaysShort:\"нед_пон_вто_сря_чет_пет_съб\".split(\"_\"),weekdaysMin:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"D.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[Днес в] LT\",nextDay:\"[Утре в] LT\",nextWeek:\"dddd [в] LT\",lastDay:\"[Вчера в] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return\"[В изминалата] dddd [в] LT\";case 1:case 2:case 4:case 5:return\"[В изминалия] dddd [в] LT\"}},sameElse:\"L\"},relativeTime:{future:\"след %s\",past:\"преди %s\",s:\"няколко секунди\",m:\"минута\",mm:\"%d минути\",h:\"час\",hh:\"%d часа\",d:\"ден\",dd:\"%d дни\",M:\"месец\",MM:\"%d месеца\",y:\"година\",yy:\"%d години\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+\"-ев\":0===n?e+\"-ен\":n>10&&n<20?e+\"-ти\":1===t?e+\"-ви\":2===t?e+\"-ри\":7===t||8===t?e+\"-ми\":e+\"-ти\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"১\",2:\"২\",3:\"৩\",4:\"৪\",5:\"৫\",6:\"৬\",7:\"৭\",8:\"৮\",9:\"৯\",0:\"০\"},n={\"১\":\"1\",\"২\":\"2\",\"৩\":\"3\",\"৪\":\"4\",\"৫\":\"5\",\"৬\":\"6\",\"৭\":\"7\",\"৮\":\"8\",\"৯\":\"9\",\"০\":\"0\"},r=e.defineLocale(\"bn\",{months:\"জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর\".split(\"_\"),monthsShort:\"জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে\".split(\"_\"),weekdays:\"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার\".split(\"_\"),weekdaysShort:\"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি\".split(\"_\"),weekdaysMin:\"রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি\".split(\"_\"),longDateFormat:{LT:\"A h:mm সময়\",LTS:\"A h:mm:ss সময়\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm সময়\",LLLL:\"dddd, D MMMM YYYY, A h:mm সময়\"},calendar:{sameDay:\"[আজ] LT\",nextDay:\"[আগামীকাল] LT\",nextWeek:\"dddd, LT\",lastDay:\"[গতকাল] LT\",lastWeek:\"[গত] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s পরে\",past:\"%s আগে\",s:\"কয়েক সেকেন্ড\",m:\"এক মিনিট\",mm:\"%d মিনিট\",h:\"এক ঘন্টা\",hh:\"%d ঘন্টা\",d:\"এক দিন\",dd:\"%d দিন\",M:\"এক মাস\",MM:\"%d মাস\",y:\"এক বছর\",yy:\"%d বছর\"},preparse:function(e){return e.replace(/[১২৩৪৫৬৭৮৯০]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/রাত|সকাল|দুপুর|বিকাল|রাত/,meridiemHour:function(e,t){return 12===e&&(e=0),\"রাত\"===t&&e>=4||\"দুপুর\"===t&&e<5||\"বিকাল\"===t?e+12:e},meridiem:function(e,t,n){return e<4?\"রাত\":e<10?\"সকাল\":e<17?\"দুপুর\":e<20?\"বিকাল\":\"রাত\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"༡\",2:\"༢\",3:\"༣\",4:\"༤\",5:\"༥\",6:\"༦\",7:\"༧\",8:\"༨\",9:\"༩\",0:\"༠\"},n={\"༡\":\"1\",\"༢\":\"2\",\"༣\":\"3\",\"༤\":\"4\",\"༥\":\"5\",\"༦\":\"6\",\"༧\":\"7\",\"༨\":\"8\",\"༩\":\"9\",\"༠\":\"0\"},r=e.defineLocale(\"bo\",{months:\"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ\".split(\"_\"),monthsShort:\"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ\".split(\"_\"),weekdays:\"གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་\".split(\"_\"),weekdaysShort:\"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་\".split(\"_\"),weekdaysMin:\"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[དི་རིང] LT\",nextDay:\"[སང་ཉིན] LT\",nextWeek:\"[བདུན་ཕྲག་རྗེས་མ], LT\",lastDay:\"[ཁ་སང] LT\",lastWeek:\"[བདུན་ཕྲག་མཐའ་མ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ལ་\",past:\"%s སྔན་ལ\",s:\"ལམ་སང\",m:\"སྐར་མ་གཅིག\",mm:\"%d སྐར་མ\",h:\"ཆུ་ཚོད་གཅིག\",hh:\"%d ཆུ་ཚོད\",d:\"ཉིན་གཅིག\",dd:\"%d ཉིན་\",M:\"ཟླ་བ་གཅིག\",MM:\"%d ཟླ་བ\",y:\"ལོ་གཅིག\",yy:\"%d ལོ\"},preparse:function(e){return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,meridiemHour:function(e,t){return 12===e&&(e=0),\"མཚན་མོ\"===t&&e>=4||\"ཉིན་གུང\"===t&&e<5||\"དགོང་དག\"===t?e+12:e},meridiem:function(e,t,n){return e<4?\"མཚན་མོ\":e<10?\"ཞོགས་ཀས\":e<17?\"ཉིན་གུང\":e<20?\"དགོང་དག\":\"མཚན་མོ\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n){var r={mm:\"munutenn\",MM:\"miz\",dd:\"devezh\"};return e+\" \"+a(r[n],e)}function n(e){switch(r(e)){case 1:case 3:case 4:case 5:case 9:return e+\" bloaz\";default:return e+\" vloaz\"}}function r(e){return e>9?r(e%10):e}function a(e,t){return 2===t?i(e):e}function i(e){var t={m:\"v\",b:\"v\",d:\"z\"};return void 0===t[e.charAt(0)]?e:t[e.charAt(0)]+e.substring(1)}var o=e.defineLocale(\"br\",{months:\"Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu\".split(\"_\"),monthsShort:\"Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker\".split(\"_\"),weekdays:\"Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn\".split(\"_\"),weekdaysShort:\"Sul_Lun_Meu_Mer_Yao_Gwe_Sad\".split(\"_\"),weekdaysMin:\"Su_Lu_Me_Mer_Ya_Gw_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h[e]mm A\",LTS:\"h[e]mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D [a viz] MMMM YYYY\",LLL:\"D [a viz] MMMM YYYY h[e]mm A\",LLLL:\"dddd, D [a viz] MMMM YYYY h[e]mm A\"},calendar:{sameDay:\"[Hiziv da] LT\",nextDay:\"[Warc'hoazh da] LT\",nextWeek:\"dddd [da] LT\",lastDay:\"[Dec'h da] LT\",lastWeek:\"dddd [paset da] LT\",sameElse:\"L\"},relativeTime:{future:\"a-benn %s\",past:\"%s 'zo\",s:\"un nebeud segondennoù\",m:\"ur vunutenn\",mm:t,h:\"un eur\",hh:\"%d eur\",d:\"un devezh\",dd:t,M:\"ur miz\",MM:t,y:\"ur bloaz\",yy:n},dayOfMonthOrdinalParse:/\\d{1,2}(añ|vet)/,ordinal:function(e){var t=1===e?\"añ\":\"vet\";return e+t},week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n){var r=e+\" \";switch(n){case\"m\":return t?\"jedna minuta\":\"jedne minute\";case\"mm\":return r+=1===e?\"minuta\":2===e||3===e||4===e?\"minute\":\"minuta\";case\"h\":return t?\"jedan sat\":\"jednog sata\";case\"hh\":return r+=1===e?\"sat\":2===e||3===e||4===e?\"sata\":\"sati\";case\"dd\":return r+=1===e?\"dan\":\"dana\";case\"MM\":return r+=1===e?\"mjesec\":2===e||3===e||4===e?\"mjeseca\":\"mjeseci\";case\"yy\":return r+=1===e?\"godina\":2===e||3===e||4===e?\"godine\":\"godina\"}}var n=e.defineLocale(\"bs\",{months:\"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[jučer u] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:return\"[prošlu] dddd [u] LT\";case 6:return\"[prošle] [subote] [u] LT\";case 1:case 2:case 4:case 5:return\"[prošli] dddd [u] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"par sekundi\",m:t,mm:t,h:t,hh:t,d:\"dan\",dd:t,M:\"mjesec\",MM:t,y:\"godinu\",yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ca\",{months:{standalone:\"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre\".split(\"_\"),format:\"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre\".split(\"_\"),isFormat:/D[oD]?(\\s)+MMMM/},monthsShort:\"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.\".split(\"_\"),monthsParseExact:!0,weekdays:\"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte\".split(\"_\"),weekdaysShort:\"dg._dl._dt._dc._dj._dv._ds.\".split(\"_\"),weekdaysMin:\"Dg_Dl_Dt_Dc_Dj_Dv_Ds\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"[el] D MMMM [de] YYYY\",ll:\"D MMM YYYY\",LLL:\"[el] D MMMM [de] YYYY [a les] H:mm\",lll:\"D MMM YYYY, H:mm\",LLLL:\"[el] dddd D MMMM [de] YYYY [a les] H:mm\",llll:\"ddd D MMM YYYY, H:mm\"},calendar:{sameDay:function(){return\"[avui a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},nextDay:function(){return\"[demà a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},nextWeek:function(){return\"dddd [a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},lastDay:function(){return\"[ahir a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [passat a \"+(1!==this.hours()?\"les\":\"la\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"d'aquí %s\",past:\"fa %s\",s:\"uns segons\",m:\"un minut\",mm:\"%d minuts\",h:\"una hora\",hh:\"%d hores\",d:\"un dia\",dd:\"%d dies\",M:\"un mes\",MM:\"%d mesos\",y:\"un any\",yy:\"%d anys\"},dayOfMonthOrdinalParse:/\\d{1,2}(r|n|t|è|a)/,ordinal:function(e,t){var n=1===e?\"r\":2===e?\"n\":3===e?\"r\":4===e?\"t\":\"è\";return\"w\"!==t&&\"W\"!==t||(n=\"a\"),e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){return e>1&&e<5&&1!==~~(e/10)}function n(e,n,r,a){var i=e+\" \";switch(r){case\"s\":return n||a?\"pár sekund\":\"pár sekundami\";case\"m\":return n?\"minuta\":a?\"minutu\":\"minutou\";case\"mm\":return n||a?i+(t(e)?\"minuty\":\"minut\"):i+\"minutami\";case\"h\":return n?\"hodina\":a?\"hodinu\":\"hodinou\";case\"hh\":return n||a?i+(t(e)?\"hodiny\":\"hodin\"):i+\"hodinami\";case\"d\":return n||a?\"den\":\"dnem\";case\"dd\":return n||a?i+(t(e)?\"dny\":\"dní\"):i+\"dny\";case\"M\":return n||a?\"měsíc\":\"měsícem\";case\"MM\":return n||a?i+(t(e)?\"měsíce\":\"měsíců\"):i+\"měsíci\";case\"y\":return n||a?\"rok\":\"rokem\";case\"yy\":return n||a?i+(t(e)?\"roky\":\"let\"):i+\"lety\"}}var r=\"leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec\".split(\"_\"),a=\"led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro\".split(\"_\"),i=e.defineLocale(\"cs\",{months:r,monthsShort:a,monthsParse:function(e,t){var n,r=[];for(n=0;n<12;n++)r[n]=new RegExp(\"^\"+e[n]+\"$|^\"+t[n]+\"$\",\"i\");return r}(r,a),shortMonthsParse:function(e){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp(\"^\"+e[t]+\"$\",\"i\");return n}(a),longMonthsParse:function(e){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp(\"^\"+e[t]+\"$\",\"i\");return n}(r),weekdays:\"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota\".split(\"_\"),weekdaysShort:\"ne_po_út_st_čt_pá_so\".split(\"_\"),weekdaysMin:\"ne_po_út_st_čt_pá_so\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd D. MMMM YYYY H:mm\",l:\"D. M. YYYY\"},calendar:{sameDay:\"[dnes v] LT\",nextDay:\"[zítra v] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v neděli v] LT\";case 1:case 2:return\"[v] dddd [v] LT\";case 3:return\"[ve středu v] LT\";case 4:return\"[ve čtvrtek v] LT\";case 5:return\"[v pátek v] LT\";case 6:return\"[v sobotu v] LT\"}},lastDay:\"[včera v] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[minulou neděli v] LT\";case 1:case 2:return\"[minulé] dddd [v] LT\";case 3:return\"[minulou středu v] LT\";case 4:case 5:return\"[minulý] dddd [v] LT\";case 6:return\"[minulou sobotu v] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"před %s\",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"cv\",{months:\"кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав\".split(\"_\"),monthsShort:\"кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш\".split(\"_\"),weekdays:\"вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун\".split(\"_\"),weekdaysShort:\"выр_тун_ытл_юн_кӗҫ_эрн_шӑм\".split(\"_\"),weekdaysMin:\"вр_тн_ыт_юн_кҫ_эр_шм\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]\",LLL:\"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm\",LLLL:\"dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm\"},calendar:{sameDay:\"[Паян] LT [сехетре]\",nextDay:\"[Ыран] LT [сехетре]\",lastDay:\"[Ӗнер] LT [сехетре]\",nextWeek:\"[Ҫитес] dddd LT [сехетре]\",lastWeek:\"[Иртнӗ] dddd LT [сехетре]\",sameElse:\"L\"},relativeTime:{future:function(e){var t=/сехет$/i.exec(e)?\"рен\":/ҫул$/i.exec(e)?\"тан\":\"ран\";return e+t},past:\"%s каялла\",s:\"пӗр-ик ҫеккунт\",m:\"пӗр минут\",mm:\"%d минут\",h:\"пӗр сехет\",hh:\"%d сехет\",d:\"пӗр кун\",dd:\"%d кун\",M:\"пӗр уйӑх\",MM:\"%d уйӑх\",y:\"пӗр ҫул\",yy:\"%d ҫул\"},dayOfMonthOrdinalParse:/\\d{1,2}-мӗш/,ordinal:\"%d-мӗш\",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"cy\",{months:\"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr\".split(\"_\"),monthsShort:\"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag\".split(\"_\"),weekdays:\"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn\".split(\"_\"),weekdaysShort:\"Sul_Llun_Maw_Mer_Iau_Gwe_Sad\".split(\"_\"),weekdaysMin:\"Su_Ll_Ma_Me_Ia_Gw_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Heddiw am] LT\",nextDay:\"[Yfory am] LT\",nextWeek:\"dddd [am] LT\",lastDay:\"[Ddoe am] LT\",lastWeek:\"dddd [diwethaf am] LT\",sameElse:\"L\"},relativeTime:{future:\"mewn %s\",past:\"%s yn ôl\",s:\"ychydig eiliadau\",m:\"munud\",mm:\"%d munud\",h:\"awr\",hh:\"%d awr\",d:\"diwrnod\",dd:\"%d diwrnod\",M:\"mis\",MM:\"%d mis\",y:\"blwyddyn\",yy:\"%d flynedd\"},dayOfMonthOrdinalParse:/\\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var t=e,n=\"\",r=[\"\",\"af\",\"il\",\"ydd\",\"ydd\",\"ed\",\"ed\",\"ed\",\"fed\",\"fed\",\"fed\",\"eg\",\"fed\",\"eg\",\"eg\",\"fed\",\"eg\",\"eg\",\"fed\",\"eg\",\"fed\"];return t>20?n=40===t||50===t||60===t||80===t||100===t?\"fed\":\"ain\":t>0&&(n=r[t]),e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"da\",{months:\"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag\".split(\"_\"),weekdaysShort:\"søn_man_tir_ons_tor_fre_lør\".split(\"_\"),weekdaysMin:\"sø_ma_ti_on_to_fr_lø\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd [d.] D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[i dag kl.] LT\",nextDay:\"[i morgen kl.] LT\",nextWeek:\"på dddd [kl.] LT\",lastDay:\"[i går kl.] LT\",lastWeek:\"[i] dddd[s kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s siden\",s:\"få sekunder\",m:\"et minut\",mm:\"%d minutter\",h:\"en time\",hh:\"%d timer\",d:\"en dag\",dd:\"%d dage\",M:\"en måned\",MM:\"%d måneder\",y:\"et år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return t?a[n][0]:a[n][1]}var n=e.defineLocale(\"de\",{months:\"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So._Mo._Di._Mi._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd, D. MMMM YYYY HH:mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:t,mm:\"%d Minuten\",h:t,hh:\"%d Stunden\",d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return t?a[n][0]:a[n][1]}var n=e.defineLocale(\"de-at\",{months:\"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So._Mo._Di._Mi._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH:mm\",LLLL:\"dddd, D. MMMM YYYY HH:mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:t,mm:\"%d Minuten\",h:t,hh:\"%d Stunden\",d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={m:[\"eine Minute\",\"einer Minute\"],h:[\"eine Stunde\",\"einer Stunde\"],d:[\"ein Tag\",\"einem Tag\"],dd:[e+\" Tage\",e+\" Tagen\"],M:[\"ein Monat\",\"einem Monat\"],MM:[e+\" Monate\",e+\" Monaten\"],y:[\"ein Jahr\",\"einem Jahr\"],yy:[e+\" Jahre\",e+\" Jahren\"]};return t?a[n][0]:a[n][1]}var n=e.defineLocale(\"de-ch\",{months:\"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag\".split(\"_\"),weekdaysShort:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysMin:\"So_Mo_Di_Mi_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY HH.mm\",LLLL:\"dddd, D. MMMM YYYY HH.mm\"},calendar:{sameDay:\"[heute um] LT [Uhr]\",sameElse:\"L\",nextDay:\"[morgen um] LT [Uhr]\",nextWeek:\"dddd [um] LT [Uhr]\",lastDay:\"[gestern um] LT [Uhr]\",lastWeek:\"[letzten] dddd [um] LT [Uhr]\"},relativeTime:{future:\"in %s\",past:\"vor %s\",s:\"ein paar Sekunden\",m:t,mm:\"%d Minuten\",h:t,hh:\"%d Stunden\",d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=[\"ޖެނުއަރީ\",\"ފެބްރުއަރީ\",\"މާރިޗު\",\"އޭޕްރީލު\",\"މޭ\",\"ޖޫން\",\"ޖުލައި\",\"އޯގަސްޓު\",\"ސެޕްޓެމްބަރު\",\"އޮކްޓޯބަރު\",\"ނޮވެމްބަރު\",\"ޑިސެމްބަރު\"],n=[\"އާދިއްތަ\",\"ހޯމަ\",\"އަންގާރަ\",\"ބުދަ\",\"ބުރާސްފަތި\",\"ހުކުރު\",\"ހޮނިހިރު\"],r=e.defineLocale(\"dv\",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:\"އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"D/M/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},meridiemParse:/މކ|މފ/,isPM:function(e){return\"މފ\"===e},meridiem:function(e,t,n){return e<12?\"މކ\":\"މފ\"},calendar:{sameDay:\"[މިއަދު] LT\",nextDay:\"[މާދަމާ] LT\",nextWeek:\"dddd LT\",lastDay:\"[އިއްޔެ] LT\",lastWeek:\"[ފާއިތުވި] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"ތެރޭގައި %s\",past:\"ކުރިން %s\",s:\"ސިކުންތުކޮޅެއް\",m:\"މިނިޓެއް\",mm:\"މިނިޓު %d\",h:\"ގަޑިއިރެއް\",hh:\"ގަޑިއިރު %d\",d:\"ދުވަހެއް\",dd:\"ދުވަސް %d\",M:\"މަހެއް\",MM:\"މަސް %d\",y:\"އަހަރެއް\",yy:\"އަހަރު %d\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:7,doy:12}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){return e instanceof Function||\"[object Function]\"===Object.prototype.toString.call(e)}var n=e.defineLocale(\"el\",{monthsNominativeEl:\"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος\".split(\"_\"),monthsGenitiveEl:\"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου\".split(\"_\"),months:function(e,t){return e?/D/.test(t.substring(0,t.indexOf(\"MMMM\")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:\"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ\".split(\"_\"),weekdays:\"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο\".split(\"_\"),weekdaysShort:\"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ\".split(\"_\"),\nweekdaysMin:\"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα\".split(\"_\"),meridiem:function(e,t,n){return e>11?n?\"μμ\":\"ΜΜ\":n?\"πμ\":\"ΠΜ\"},isPM:function(e){return\"μ\"===(e+\"\").toLowerCase()[0]},meridiemParse:/[ΠΜ]\\.?Μ?\\.?/i,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendarEl:{sameDay:\"[Σήμερα {}] LT\",nextDay:\"[Αύριο {}] LT\",nextWeek:\"dddd [{}] LT\",lastDay:\"[Χθες {}] LT\",lastWeek:function(){switch(this.day()){case 6:return\"[το προηγούμενο] dddd [{}] LT\";default:return\"[την προηγούμενη] dddd [{}] LT\"}},sameElse:\"L\"},calendar:function(e,n){var r=this._calendarEl[e],a=n&&n.hours();return t(r)&&(r=r.apply(n)),r.replace(\"{}\",a%12===1?\"στη\":\"στις\")},relativeTime:{future:\"σε %s\",past:\"%s πριν\",s:\"λίγα δευτερόλεπτα\",m:\"ένα λεπτό\",mm:\"%d λεπτά\",h:\"μία ώρα\",hh:\"%d ώρες\",d:\"μία μέρα\",dd:\"%d μέρες\",M:\"ένας μήνας\",MM:\"%d μήνες\",y:\"ένας χρόνος\",yy:\"%d χρόνια\"},dayOfMonthOrdinalParse:/\\d{1,2}η/,ordinal:\"%dη\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"en-au\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"en-ca\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"YYYY-MM-DD\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"en-gb\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"en-ie\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"en-nz\",{months:\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),weekdays:\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),weekdaysShort:\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),weekdaysMin:\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},relativeTime:{future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"eo\",{months:\"januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec\".split(\"_\"),weekdays:\"dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato\".split(\"_\"),weekdaysShort:\"dim_lun_mard_merk_ĵaŭ_ven_sab\".split(\"_\"),weekdaysMin:\"di_lu_ma_me_ĵa_ve_sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D[-a de] MMMM, YYYY\",LLL:\"D[-a de] MMMM, YYYY HH:mm\",LLLL:\"dddd, [la] D[-a de] MMMM, YYYY HH:mm\"},meridiemParse:/[ap]\\.t\\.m/i,isPM:function(e){return\"p\"===e.charAt(0).toLowerCase()},meridiem:function(e,t,n){return e>11?n?\"p.t.m.\":\"P.T.M.\":n?\"a.t.m.\":\"A.T.M.\"},calendar:{sameDay:\"[Hodiaŭ je] LT\",nextDay:\"[Morgaŭ je] LT\",nextWeek:\"dddd [je] LT\",lastDay:\"[Hieraŭ je] LT\",lastWeek:\"[pasinta] dddd [je] LT\",sameElse:\"L\"},relativeTime:{future:\"post %s\",past:\"antaŭ %s\",s:\"sekundoj\",m:\"minuto\",mm:\"%d minutoj\",h:\"horo\",hh:\"%d horoj\",d:\"tago\",dd:\"%d tagoj\",M:\"monato\",MM:\"%d monatoj\",y:\"jaro\",yy:\"%d jaroj\"},dayOfMonthOrdinalParse:/\\d{1,2}a/,ordinal:\"%da\",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=\"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.\".split(\"_\"),n=\"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic\".split(\"_\"),r=e.defineLocale(\"es\",{months:\"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre\".split(\"_\"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsParseExact:!0,weekdays:\"domingo_lunes_martes_miércoles_jueves_viernes_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mié._jue._vie._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mi_ju_vi_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY H:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY H:mm\"},calendar:{sameDay:function(){return\"[hoy a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextDay:function(){return\"[mañana a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextWeek:function(){return\"dddd [a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastDay:function(){return\"[ayer a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [pasado a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"en %s\",past:\"hace %s\",s:\"unos segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"una hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un año\",yy:\"%d años\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=\"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.\".split(\"_\"),n=\"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic\".split(\"_\"),r=e.defineLocale(\"es-do\",{months:\"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre\".split(\"_\"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsParseExact:!0,weekdays:\"domingo_lunes_martes_miércoles_jueves_viernes_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mié._jue._vie._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mi_ju_vi_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY h:mm A\",LLLL:\"dddd, D [de] MMMM [de] YYYY h:mm A\"},calendar:{sameDay:function(){return\"[hoy a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextDay:function(){return\"[mañana a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},nextWeek:function(){return\"dddd [a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastDay:function(){return\"[ayer a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},lastWeek:function(){return\"[el] dddd [pasado a la\"+(1!==this.hours()?\"s\":\"\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:\"en %s\",past:\"hace %s\",s:\"unos segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"una hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un año\",yy:\"%d años\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={s:[\"mõne sekundi\",\"mõni sekund\",\"paar sekundit\"],m:[\"ühe minuti\",\"üks minut\"],mm:[e+\" minuti\",e+\" minutit\"],h:[\"ühe tunni\",\"tund aega\",\"üks tund\"],hh:[e+\" tunni\",e+\" tundi\"],d:[\"ühe päeva\",\"üks päev\"],M:[\"kuu aja\",\"kuu aega\",\"üks kuu\"],MM:[e+\" kuu\",e+\" kuud\"],y:[\"ühe aasta\",\"aasta\",\"üks aasta\"],yy:[e+\" aasta\",e+\" aastat\"]};return t?a[n][2]?a[n][2]:a[n][1]:r?a[n][0]:a[n][1]}var n=e.defineLocale(\"et\",{months:\"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember\".split(\"_\"),monthsShort:\"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets\".split(\"_\"),weekdays:\"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev\".split(\"_\"),weekdaysShort:\"P_E_T_K_N_R_L\".split(\"_\"),weekdaysMin:\"P_E_T_K_N_R_L\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[Täna,] LT\",nextDay:\"[Homme,] LT\",nextWeek:\"[Järgmine] dddd LT\",lastDay:\"[Eile,] LT\",lastWeek:\"[Eelmine] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"%s pärast\",past:\"%s tagasi\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:\"%d päeva\",M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"eu\",{months:\"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua\".split(\"_\"),monthsShort:\"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.\".split(\"_\"),monthsParseExact:!0,weekdays:\"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata\".split(\"_\"),weekdaysShort:\"ig._al._ar._az._og._ol._lr.\".split(\"_\"),weekdaysMin:\"ig_al_ar_az_og_ol_lr\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"YYYY[ko] MMMM[ren] D[a]\",LLL:\"YYYY[ko] MMMM[ren] D[a] HH:mm\",LLLL:\"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm\",l:\"YYYY-M-D\",ll:\"YYYY[ko] MMM D[a]\",lll:\"YYYY[ko] MMM D[a] HH:mm\",llll:\"ddd, YYYY[ko] MMM D[a] HH:mm\"},calendar:{sameDay:\"[gaur] LT[etan]\",nextDay:\"[bihar] LT[etan]\",nextWeek:\"dddd LT[etan]\",lastDay:\"[atzo] LT[etan]\",lastWeek:\"[aurreko] dddd LT[etan]\",sameElse:\"L\"},relativeTime:{future:\"%s barru\",past:\"duela %s\",s:\"segundo batzuk\",m:\"minutu bat\",mm:\"%d minutu\",h:\"ordu bat\",hh:\"%d ordu\",d:\"egun bat\",dd:\"%d egun\",M:\"hilabete bat\",MM:\"%d hilabete\",y:\"urte bat\",yy:\"%d urte\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"۱\",2:\"۲\",3:\"۳\",4:\"۴\",5:\"۵\",6:\"۶\",7:\"۷\",8:\"۸\",9:\"۹\",0:\"۰\"},n={\"۱\":\"1\",\"۲\":\"2\",\"۳\":\"3\",\"۴\":\"4\",\"۵\":\"5\",\"۶\":\"6\",\"۷\":\"7\",\"۸\":\"8\",\"۹\":\"9\",\"۰\":\"0\"},r=e.defineLocale(\"fa\",{months:\"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر\".split(\"_\"),monthsShort:\"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر\".split(\"_\"),weekdays:\"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه\".split(\"_\"),weekdaysShort:\"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه\".split(\"_\"),weekdaysMin:\"ی_د_س_چ_پ_ج_ش\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,t,n){return e<12?\"قبل از ظهر\":\"بعد از ظهر\"},calendar:{sameDay:\"[امروز ساعت] LT\",nextDay:\"[فردا ساعت] LT\",nextWeek:\"dddd [ساعت] LT\",lastDay:\"[دیروز ساعت] LT\",lastWeek:\"dddd [پیش] [ساعت] LT\",sameElse:\"L\"},relativeTime:{future:\"در %s\",past:\"%s پیش\",s:\"چند ثانیه\",m:\"یک دقیقه\",mm:\"%d دقیقه\",h:\"یک ساعت\",hh:\"%d ساعت\",d:\"یک روز\",dd:\"%d روز\",M:\"یک ماه\",MM:\"%d ماه\",y:\"یک سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return n[e]}).replace(/،/g,\",\")},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]}).replace(/,/g,\"،\")},dayOfMonthOrdinalParse:/\\d{1,2}م/,ordinal:\"%dم\",week:{dow:6,doy:12}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,r,a){var i=\"\";switch(r){case\"s\":return a?\"muutaman sekunnin\":\"muutama sekunti\";case\"m\":return a?\"minuutin\":\"minuutti\";case\"mm\":i=a?\"minuutin\":\"minuuttia\";break;case\"h\":return a?\"tunnin\":\"tunti\";case\"hh\":i=a?\"tunnin\":\"tuntia\";break;case\"d\":return a?\"päivän\":\"päivä\";case\"dd\":i=a?\"päivän\":\"päivää\";break;case\"M\":return a?\"kuukauden\":\"kuukausi\";case\"MM\":i=a?\"kuukauden\":\"kuukautta\";break;case\"y\":return a?\"vuoden\":\"vuosi\";case\"yy\":i=a?\"vuoden\":\"vuotta\"}return i=n(e,a)+\" \"+i}function n(e,t){return e<10?t?a[e]:r[e]:e}var r=\"nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän\".split(\" \"),a=[\"nolla\",\"yhden\",\"kahden\",\"kolmen\",\"neljän\",\"viiden\",\"kuuden\",r[7],r[8],r[9]],i=e.defineLocale(\"fi\",{months:\"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu\".split(\"_\"),monthsShort:\"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu\".split(\"_\"),weekdays:\"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai\".split(\"_\"),weekdaysShort:\"su_ma_ti_ke_to_pe_la\".split(\"_\"),weekdaysMin:\"su_ma_ti_ke_to_pe_la\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"Do MMMM[ta] YYYY\",LLL:\"Do MMMM[ta] YYYY, [klo] HH.mm\",LLLL:\"dddd, Do MMMM[ta] YYYY, [klo] HH.mm\",l:\"D.M.YYYY\",ll:\"Do MMM YYYY\",lll:\"Do MMM YYYY, [klo] HH.mm\",llll:\"ddd, Do MMM YYYY, [klo] HH.mm\"},calendar:{sameDay:\"[tänään] [klo] LT\",nextDay:\"[huomenna] [klo] LT\",nextWeek:\"dddd [klo] LT\",lastDay:\"[eilen] [klo] LT\",lastWeek:\"[viime] dddd[na] [klo] LT\",sameElse:\"L\"},relativeTime:{future:\"%s päästä\",past:\"%s sitten\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"fo\",{months:\"januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\"),weekdays:\"sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur\".split(\"_\"),weekdaysShort:\"sun_mán_týs_mik_hós_frí_ley\".split(\"_\"),weekdaysMin:\"su_má_tý_mi_hó_fr_le\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D. MMMM, YYYY HH:mm\"},calendar:{sameDay:\"[Í dag kl.] LT\",nextDay:\"[Í morgin kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[Í gjár kl.] LT\",lastWeek:\"[síðstu] dddd [kl] LT\",sameElse:\"L\"},relativeTime:{future:\"um %s\",past:\"%s síðani\",s:\"fá sekund\",m:\"ein minutt\",mm:\"%d minuttir\",h:\"ein tími\",hh:\"%d tímar\",d:\"ein dagur\",dd:\"%d dagar\",M:\"ein mánaði\",MM:\"%d mánaðir\",y:\"eitt ár\",yy:\"%d ár\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"fr\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|)/,ordinal:function(e,t){switch(t){case\"D\":return e+(1===e?\"er\":\"\");default:case\"M\":case\"Q\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"fr-ca\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|e)/,ordinal:function(e,t){switch(t){default:case\"M\":case\"Q\":case\"D\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"fr-ch\",{months:\"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre\".split(\"_\"),monthsShort:\"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.\".split(\"_\"),monthsParseExact:!0,weekdays:\"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi\".split(\"_\"),weekdaysShort:\"dim._lun._mar._mer._jeu._ven._sam.\".split(\"_\"),weekdaysMin:\"Di_Lu_Ma_Me_Je_Ve_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Aujourd’hui à] LT\",nextDay:\"[Demain à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[Hier à] LT\",lastWeek:\"dddd [dernier à] LT\",sameElse:\"L\"},relativeTime:{future:\"dans %s\",past:\"il y a %s\",s:\"quelques secondes\",m:\"une minute\",mm:\"%d minutes\",h:\"une heure\",hh:\"%d heures\",d:\"un jour\",dd:\"%d jours\",M:\"un mois\",MM:\"%d mois\",y:\"un an\",yy:\"%d ans\"},dayOfMonthOrdinalParse:/\\d{1,2}(er|e)/,ordinal:function(e,t){switch(t){default:case\"M\":case\"Q\":case\"D\":case\"DDD\":case\"d\":return e+(1===e?\"er\":\"e\");case\"w\":case\"W\":return e+(1===e?\"re\":\"e\")}},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=\"jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.\".split(\"_\"),n=\"jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\"),r=e.defineLocale(\"fy\",{months:\"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber\".split(\"_\"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsParseExact:!0,weekdays:\"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon\".split(\"_\"),weekdaysShort:\"si._mo._ti._wo._to._fr._so.\".split(\"_\"),weekdaysMin:\"Si_Mo_Ti_Wo_To_Fr_So\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[hjoed om] LT\",nextDay:\"[moarn om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[juster om] LT\",lastWeek:\"[ôfrûne] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"oer %s\",past:\"%s lyn\",s:\"in pear sekonden\",m:\"ien minút\",mm:\"%d minuten\",h:\"ien oere\",hh:\"%d oeren\",d:\"ien dei\",dd:\"%d dagen\",M:\"ien moanne\",MM:\"%d moannen\",y:\"ien jier\",yy:\"%d jierren\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=[\"Am Faoilleach\",\"An Gearran\",\"Am Màrt\",\"An Giblean\",\"An Cèitean\",\"An t-Ògmhios\",\"An t-Iuchar\",\"An Lùnastal\",\"An t-Sultain\",\"An Dàmhair\",\"An t-Samhain\",\"An Dùbhlachd\"],n=[\"Faoi\",\"Gear\",\"Màrt\",\"Gibl\",\"Cèit\",\"Ògmh\",\"Iuch\",\"Lùn\",\"Sult\",\"Dàmh\",\"Samh\",\"Dùbh\"],r=[\"Didòmhnaich\",\"Diluain\",\"Dimàirt\",\"Diciadain\",\"Diardaoin\",\"Dihaoine\",\"Disathairne\"],a=[\"Did\",\"Dil\",\"Dim\",\"Dic\",\"Dia\",\"Dih\",\"Dis\"],i=[\"Dò\",\"Lu\",\"Mà\",\"Ci\",\"Ar\",\"Ha\",\"Sa\"],o=e.defineLocale(\"gd\",{months:t,monthsShort:n,monthsParseExact:!0,weekdays:r,weekdaysShort:a,weekdaysMin:i,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[An-diugh aig] LT\",nextDay:\"[A-màireach aig] LT\",nextWeek:\"dddd [aig] LT\",lastDay:\"[An-dè aig] LT\",lastWeek:\"dddd [seo chaidh] [aig] LT\",sameElse:\"L\"},relativeTime:{future:\"ann an %s\",past:\"bho chionn %s\",s:\"beagan diogan\",m:\"mionaid\",mm:\"%d mionaidean\",h:\"uair\",hh:\"%d uairean\",d:\"latha\",dd:\"%d latha\",M:\"mìos\",MM:\"%d mìosan\",y:\"bliadhna\",yy:\"%d bliadhna\"},dayOfMonthOrdinalParse:/\\d{1,2}(d|na|mh)/,ordinal:function(e){var t=1===e?\"d\":e%10===2?\"na\":\"mh\";return e+t},week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"gl\",{months:\"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro\".split(\"_\"),monthsShort:\"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"domingo_luns_martes_mércores_xoves_venres_sábado\".split(\"_\"),weekdaysShort:\"dom._lun._mar._mér._xov._ven._sáb.\".split(\"_\"),weekdaysMin:\"do_lu_ma_mé_xo_ve_sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY H:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY H:mm\"},calendar:{sameDay:function(){return\"[hoxe \"+(1!==this.hours()?\"ás\":\"á\")+\"] LT\"},nextDay:function(){return\"[mañá \"+(1!==this.hours()?\"ás\":\"á\")+\"] LT\"},nextWeek:function(){return\"dddd [\"+(1!==this.hours()?\"ás\":\"a\")+\"] LT\"},lastDay:function(){return\"[onte \"+(1!==this.hours()?\"á\":\"a\")+\"] LT\"},lastWeek:function(){return\"[o] dddd [pasado \"+(1!==this.hours()?\"ás\":\"a\")+\"] LT\"},sameElse:\"L\"},relativeTime:{future:function(e){return 0===e.indexOf(\"un\")?\"n\"+e:\"en \"+e},past:\"hai %s\",s:\"uns segundos\",m:\"un minuto\",mm:\"%d minutos\",h:\"unha hora\",hh:\"%d horas\",d:\"un día\",dd:\"%d días\",M:\"un mes\",MM:\"%d meses\",y:\"un ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={s:[\"thodde secondanim\",\"thodde second\"],m:[\"eka mintan\",\"ek minute\"],mm:[e+\" mintanim\",e+\" mintam\"],h:[\"eka horan\",\"ek hor\"],hh:[e+\" horanim\",e+\" hor\"],d:[\"eka disan\",\"ek dis\"],dd:[e+\" disanim\",e+\" dis\"],M:[\"eka mhoinean\",\"ek mhoino\"],MM:[e+\" mhoineanim\",e+\" mhoine\"],y:[\"eka vorsan\",\"ek voros\"],yy:[e+\" vorsanim\",e+\" vorsam\"]};return t?a[n][0]:a[n][1]}var n=e.defineLocale(\"gom-latn\",{months:\"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr\".split(\"_\"),monthsShort:\"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son'var\".split(\"_\"),weekdaysShort:\"Ait._Som._Mon._Bud._Bre._Suk._Son.\".split(\"_\"),weekdaysMin:\"Ai_Sm_Mo_Bu_Br_Su_Sn\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"A h:mm [vazta]\",LTS:\"A h:mm:ss [vazta]\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY A h:mm [vazta]\",LLLL:\"dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]\",llll:\"ddd, D MMM YYYY, A h:mm [vazta]\"},calendar:{sameDay:\"[Aiz] LT\",nextDay:\"[Faleam] LT\",nextWeek:\"[Ieta to] dddd[,] LT\",lastDay:\"[Kal] LT\",lastWeek:\"[Fatlo] dddd[,] LT\",sameElse:\"L\"},relativeTime:{future:\"%s\",past:\"%s adim\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}(er)/,ordinal:function(e,t){switch(t){case\"D\":return e+\"er\";default:case\"M\":case\"Q\":case\"DDD\":case\"d\":case\"w\":case\"W\":return e}},week:{dow:1,doy:4},meridiemParse:/rati|sokalli|donparam|sanje/,meridiemHour:function(e,t){return 12===e&&(e=0),\"rati\"===t?e<4?e:e+12:\"sokalli\"===t?e:\"donparam\"===t?e>12?e:e+12:\"sanje\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"rati\":e<12?\"sokalli\":e<16?\"donparam\":e<20?\"sanje\":\"rati\"}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"he\",{months:\"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר\".split(\"_\"),monthsShort:\"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳\".split(\"_\"),weekdays:\"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת\".split(\"_\"),weekdaysShort:\"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳\".split(\"_\"),weekdaysMin:\"א_ב_ג_ד_ה_ו_ש\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [ב]MMMM YYYY\",LLL:\"D [ב]MMMM YYYY HH:mm\",LLLL:\"dddd, D [ב]MMMM YYYY HH:mm\",l:\"D/M/YYYY\",ll:\"D MMM YYYY\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd, D MMM YYYY HH:mm\"},calendar:{sameDay:\"[היום ב־]LT\",nextDay:\"[מחר ב־]LT\",nextWeek:\"dddd [בשעה] LT\",lastDay:\"[אתמול ב־]LT\",lastWeek:\"[ביום] dddd [האחרון בשעה] LT\",sameElse:\"L\"},relativeTime:{future:\"בעוד %s\",past:\"לפני %s\",s:\"מספר שניות\",m:\"דקה\",mm:\"%d דקות\",h:\"שעה\",hh:function(e){return 2===e?\"שעתיים\":e+\" שעות\"},d:\"יום\",dd:function(e){return 2===e?\"יומיים\":e+\" ימים\"},M:\"חודש\",MM:function(e){return 2===e?\"חודשיים\":e+\" חודשים\"},y:\"שנה\",yy:function(e){return 2===e?\"שנתיים\":e%10===0&&10!==e?e+\" שנה\":e+\" שנים\"}},meridiemParse:/אחה\"צ|לפנה\"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה\"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,t,n){return e<5?\"לפנות בוקר\":e<10?\"בבוקר\":e<12?n?'לפנה\"צ':\"לפני הצהריים\":e<18?n?'אחה\"צ':\"אחרי הצהריים\":\"בערב\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},n={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"},r=e.defineLocale(\"hi\",{months:\"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर\".split(\"_\"),monthsShort:\"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.\".split(\"_\"),monthsParseExact:!0,weekdays:\"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार\".split(\"_\"),weekdaysShort:\"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि\".split(\"_\"),weekdaysMin:\"र_सो_मं_बु_गु_शु_श\".split(\"_\"),longDateFormat:{LT:\"A h:mm बजे\",LTS:\"A h:mm:ss बजे\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm बजे\",LLLL:\"dddd, D MMMM YYYY, A h:mm बजे\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[कल] LT\",nextWeek:\"dddd, LT\",lastDay:\"[कल] LT\",lastWeek:\"[पिछले] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s में\",past:\"%s पहले\",s:\"कुछ ही क्षण\",m:\"एक मिनट\",mm:\"%d मिनट\",h:\"एक घंटा\",hh:\"%d घंटे\",d:\"एक दिन\",dd:\"%d दिन\",M:\"एक महीने\",MM:\"%d महीने\",y:\"एक वर्ष\",yy:\"%d वर्ष\"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,t){return 12===e&&(e=0),\"रात\"===t?e<4?e:e+12:\"सुबह\"===t?e:\"दोपहर\"===t?e>=10?e:e+12:\"शाम\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"रात\":e<10?\"सुबह\":e<17?\"दोपहर\":e<20?\"शाम\":\"रात\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n){var r=e+\" \";switch(n){case\"m\":return t?\"jedna minuta\":\"jedne minute\";case\"mm\":return r+=1===e?\"minuta\":2===e||3===e||4===e?\"minute\":\"minuta\";case\"h\":return t?\"jedan sat\":\"jednog sata\";case\"hh\":return r+=1===e?\"sat\":2===e||3===e||4===e?\"sata\":\"sati\";case\"dd\":return r+=1===e?\"dan\":\"dana\";case\"MM\":return r+=1===e?\"mjesec\":2===e||3===e||4===e?\"mjeseca\":\"mjeseci\";case\"yy\":return r+=1===e?\"godina\":2===e||3===e||4===e?\"godine\":\"godina\"}}var n=e.defineLocale(\"hr\",{months:{format:\"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca\".split(\"_\"),standalone:\"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac\".split(\"_\")},monthsShort:\"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[jučer u] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:return\"[prošlu] dddd [u] LT\";case 6:return\"[prošle] [subote] [u] LT\";case 1:case 2:case 4:case 5:return\"[prošli] dddd [u] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"par sekundi\",m:t,mm:t,h:t,hh:t,d:\"dan\",dd:t,M:\"mjesec\",MM:t,y:\"godinu\",yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return n;\n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a=e;switch(n){case\"s\":return r||t?\"néhány másodperc\":\"néhány másodperce\";case\"m\":return\"egy\"+(r||t?\" perc\":\" perce\");case\"mm\":return a+(r||t?\" perc\":\" perce\");case\"h\":return\"egy\"+(r||t?\" óra\":\" órája\");case\"hh\":return a+(r||t?\" óra\":\" órája\");case\"d\":return\"egy\"+(r||t?\" nap\":\" napja\");case\"dd\":return a+(r||t?\" nap\":\" napja\");case\"M\":return\"egy\"+(r||t?\" hónap\":\" hónapja\");case\"MM\":return a+(r||t?\" hónap\":\" hónapja\");case\"y\":return\"egy\"+(r||t?\" év\":\" éve\");case\"yy\":return a+(r||t?\" év\":\" éve\")}return\"\"}function n(e){return(e?\"\":\"[múlt] \")+\"[\"+r[this.day()]+\"] LT[-kor]\"}var r=\"vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton\".split(\" \"),a=e.defineLocale(\"hu\",{months:\"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december\".split(\"_\"),monthsShort:\"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec\".split(\"_\"),weekdays:\"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat\".split(\"_\"),weekdaysShort:\"vas_hét_kedd_sze_csüt_pén_szo\".split(\"_\"),weekdaysMin:\"v_h_k_sze_cs_p_szo\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"YYYY.MM.DD.\",LL:\"YYYY. MMMM D.\",LLL:\"YYYY. MMMM D. H:mm\",LLLL:\"YYYY. MMMM D., dddd H:mm\"},meridiemParse:/de|du/i,isPM:function(e){return\"u\"===e.charAt(1).toLowerCase()},meridiem:function(e,t,n){return e<12?n===!0?\"de\":\"DE\":n===!0?\"du\":\"DU\"},calendar:{sameDay:\"[ma] LT[-kor]\",nextDay:\"[holnap] LT[-kor]\",nextWeek:function(){return n.call(this,!0)},lastDay:\"[tegnap] LT[-kor]\",lastWeek:function(){return n.call(this,!1)},sameElse:\"L\"},relativeTime:{future:\"%s múlva\",past:\"%s\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"hy-am\",{months:{format:\"հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի\".split(\"_\"),standalone:\"հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր\".split(\"_\")},monthsShort:\"հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ\".split(\"_\"),weekdays:\"կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ\".split(\"_\"),weekdaysShort:\"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ\".split(\"_\"),weekdaysMin:\"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY թ.\",LLL:\"D MMMM YYYY թ., HH:mm\",LLLL:\"dddd, D MMMM YYYY թ., HH:mm\"},calendar:{sameDay:\"[այսօր] LT\",nextDay:\"[վաղը] LT\",lastDay:\"[երեկ] LT\",nextWeek:function(){return\"dddd [օրը ժամը] LT\"},lastWeek:function(){return\"[անցած] dddd [օրը ժամը] LT\"},sameElse:\"L\"},relativeTime:{future:\"%s հետո\",past:\"%s առաջ\",s:\"մի քանի վայրկյան\",m:\"րոպե\",mm:\"%d րոպե\",h:\"ժամ\",hh:\"%d ժամ\",d:\"օր\",dd:\"%d օր\",M:\"ամիս\",MM:\"%d ամիս\",y:\"տարի\",yy:\"%d տարի\"},meridiemParse:/գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,isPM:function(e){return/^(ցերեկվա|երեկոյան)$/.test(e)},meridiem:function(e){return e<4?\"գիշերվա\":e<12?\"առավոտվա\":e<17?\"ցերեկվա\":\"երեկոյան\"},dayOfMonthOrdinalParse:/\\d{1,2}|\\d{1,2}-(ին|րդ)/,ordinal:function(e,t){switch(t){case\"DDD\":case\"w\":case\"W\":case\"DDDo\":return 1===e?e+\"-ին\":e+\"-րդ\";default:return e}},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"id\",{months:\"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu\".split(\"_\"),weekdaysShort:\"Min_Sen_Sel_Rab_Kam_Jum_Sab\".split(\"_\"),weekdaysMin:\"Mg_Sn_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),\"pagi\"===t?e:\"siang\"===t?e>=11?e:e+12:\"sore\"===t||\"malam\"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?\"pagi\":e<15?\"siang\":e<19?\"sore\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Besok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kemarin pukul] LT\",lastWeek:\"dddd [lalu pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lalu\",s:\"beberapa detik\",m:\"semenit\",mm:\"%d menit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){return e%100===11||e%10!==1}function n(e,n,r,a){var i=e+\" \";switch(r){case\"s\":return n||a?\"nokkrar sekúndur\":\"nokkrum sekúndum\";case\"m\":return n?\"mínúta\":\"mínútu\";case\"mm\":return t(e)?i+(n||a?\"mínútur\":\"mínútum\"):n?i+\"mínúta\":i+\"mínútu\";case\"hh\":return t(e)?i+(n||a?\"klukkustundir\":\"klukkustundum\"):i+\"klukkustund\";case\"d\":return n?\"dagur\":a?\"dag\":\"degi\";case\"dd\":return t(e)?n?i+\"dagar\":i+(a?\"daga\":\"dögum\"):n?i+\"dagur\":i+(a?\"dag\":\"degi\");case\"M\":return n?\"mánuður\":a?\"mánuð\":\"mánuði\";case\"MM\":return t(e)?n?i+\"mánuðir\":i+(a?\"mánuði\":\"mánuðum\"):n?i+\"mánuður\":i+(a?\"mánuð\":\"mánuði\");case\"y\":return n||a?\"ár\":\"ári\";case\"yy\":return t(e)?i+(n||a?\"ár\":\"árum\"):i+(n||a?\"ár\":\"ári\")}}var r=e.defineLocale(\"is\",{months:\"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des\".split(\"_\"),weekdays:\"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur\".split(\"_\"),weekdaysShort:\"sun_mán_þri_mið_fim_fös_lau\".split(\"_\"),weekdaysMin:\"Su_Má_Þr_Mi_Fi_Fö_La\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] H:mm\",LLLL:\"dddd, D. MMMM YYYY [kl.] H:mm\"},calendar:{sameDay:\"[í dag kl.] LT\",nextDay:\"[á morgun kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[í gær kl.] LT\",lastWeek:\"[síðasta] dddd [kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"eftir %s\",past:\"fyrir %s síðan\",s:n,m:n,mm:n,h:\"klukkustund\",hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"it\",{months:\"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre\".split(\"_\"),monthsShort:\"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic\".split(\"_\"),weekdays:\"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato\".split(\"_\"),weekdaysShort:\"dom_lun_mar_mer_gio_ven_sab\".split(\"_\"),weekdaysMin:\"do_lu_ma_me_gi_ve_sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Oggi alle] LT\",nextDay:\"[Domani alle] LT\",nextWeek:\"dddd [alle] LT\",lastDay:\"[Ieri alle] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[la scorsa] dddd [alle] LT\";default:return\"[lo scorso] dddd [alle] LT\"}},sameElse:\"L\"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?\"tra\":\"in\")+\" \"+e},past:\"%s fa\",s:\"alcuni secondi\",m:\"un minuto\",mm:\"%d minuti\",h:\"un'ora\",hh:\"%d ore\",d:\"un giorno\",dd:\"%d giorni\",M:\"un mese\",MM:\"%d mesi\",y:\"un anno\",yy:\"%d anni\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ja\",{months:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日\".split(\"_\"),weekdaysShort:\"日_月_火_水_木_金_土\".split(\"_\"),weekdaysMin:\"日_月_火_水_木_金_土\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY/MM/DD\",LL:\"YYYY年M月D日\",LLL:\"YYYY年M月D日 HH:mm\",LLLL:\"YYYY年M月D日 HH:mm dddd\",l:\"YYYY/MM/DD\",ll:\"YYYY年M月D日\",lll:\"YYYY年M月D日 HH:mm\",llll:\"YYYY年M月D日 HH:mm dddd\"},meridiemParse:/午前|午後/i,isPM:function(e){return\"午後\"===e},meridiem:function(e,t,n){return e<12?\"午前\":\"午後\"},calendar:{sameDay:\"[今日] LT\",nextDay:\"[明日] LT\",nextWeek:\"[来週]dddd LT\",lastDay:\"[昨日] LT\",lastWeek:\"[前週]dddd LT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}日/,ordinal:function(e,t){switch(t){case\"d\":case\"D\":case\"DDD\":return e+\"日\";default:return e}},relativeTime:{future:\"%s後\",past:\"%s前\",s:\"数秒\",m:\"1分\",mm:\"%d分\",h:\"1時間\",hh:\"%d時間\",d:\"1日\",dd:\"%d日\",M:\"1ヶ月\",MM:\"%dヶ月\",y:\"1年\",yy:\"%d年\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"jv\",{months:\"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember\".split(\"_\"),monthsShort:\"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des\".split(\"_\"),weekdays:\"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu\".split(\"_\"),weekdaysShort:\"Min_Sen_Sel_Reb_Kem_Jem_Sep\".split(\"_\"),weekdaysMin:\"Mg_Sn_Sl_Rb_Km_Jm_Sp\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,t){return 12===e&&(e=0),\"enjing\"===t?e:\"siyang\"===t?e>=11?e:e+12:\"sonten\"===t||\"ndalu\"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?\"enjing\":e<15?\"siyang\":e<19?\"sonten\":\"ndalu\"},calendar:{sameDay:\"[Dinten puniko pukul] LT\",nextDay:\"[Mbenjang pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kala wingi pukul] LT\",lastWeek:\"dddd [kepengker pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"wonten ing %s\",past:\"%s ingkang kepengker\",s:\"sawetawis detik\",m:\"setunggal menit\",mm:\"%d menit\",h:\"setunggal jam\",hh:\"%d jam\",d:\"sedinten\",dd:\"%d dinten\",M:\"sewulan\",MM:\"%d wulan\",y:\"setaun\",yy:\"%d taun\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ka\",{months:{standalone:\"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი\".split(\"_\"),format:\"იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს\".split(\"_\")},monthsShort:\"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ\".split(\"_\"),weekdays:{standalone:\"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი\".split(\"_\"),format:\"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს\".split(\"_\"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:\"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ\".split(\"_\"),weekdaysMin:\"კვ_ორ_სა_ოთ_ხუ_პა_შა\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[დღეს] LT[-ზე]\",nextDay:\"[ხვალ] LT[-ზე]\",lastDay:\"[გუშინ] LT[-ზე]\",nextWeek:\"[შემდეგ] dddd LT[-ზე]\",lastWeek:\"[წინა] dddd LT-ზე\",sameElse:\"L\"},relativeTime:{future:function(e){return/(წამი|წუთი|საათი|წელი)/.test(e)?e.replace(/ი$/,\"ში\"):e+\"ში\"},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,\"ის უკან\"):/წელი/.test(e)?e.replace(/წელი$/,\"წლის უკან\"):void 0},s:\"რამდენიმე წამი\",m:\"წუთი\",mm:\"%d წუთი\",h:\"საათი\",hh:\"%d საათი\",d:\"დღე\",dd:\"%d დღე\",M:\"თვე\",MM:\"%d თვე\",y:\"წელი\",yy:\"%d წელი\"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\\d{1,2}|\\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+\"-ლი\":e<20||e<=100&&e%20===0||e%100===0?\"მე-\"+e:e+\"-ე\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={0:\"-ші\",1:\"-ші\",2:\"-ші\",3:\"-ші\",4:\"-ші\",5:\"-ші\",6:\"-шы\",7:\"-ші\",8:\"-ші\",9:\"-шы\",10:\"-шы\",20:\"-шы\",30:\"-шы\",40:\"-шы\",50:\"-ші\",60:\"-шы\",70:\"-ші\",80:\"-ші\",90:\"-шы\",100:\"-ші\"},n=e.defineLocale(\"kk\",{months:\"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан\".split(\"_\"),monthsShort:\"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел\".split(\"_\"),weekdays:\"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі\".split(\"_\"),weekdaysShort:\"жек_дүй_сей_сәр_бей_жұм_сен\".split(\"_\"),weekdaysMin:\"жк_дй_сй_ср_бй_жм_сн\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Бүгін сағат] LT\",nextDay:\"[Ертең сағат] LT\",nextWeek:\"dddd [сағат] LT\",lastDay:\"[Кеше сағат] LT\",lastWeek:\"[Өткен аптаның] dddd [сағат] LT\",sameElse:\"L\"},relativeTime:{future:\"%s ішінде\",past:\"%s бұрын\",s:\"бірнеше секунд\",m:\"бір минут\",mm:\"%d минут\",h:\"бір сағат\",hh:\"%d сағат\",d:\"бір күн\",dd:\"%d күн\",M:\"бір ай\",MM:\"%d ай\",y:\"бір жыл\",yy:\"%d жыл\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ші|шы)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"km\",{months:\"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ\".split(\"_\"),monthsShort:\"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ\".split(\"_\"),weekdays:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),weekdaysShort:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),weekdaysMin:\"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ថ្ងៃនេះ ម៉ោង] LT\",nextDay:\"[ស្អែក ម៉ោង] LT\",nextWeek:\"dddd [ម៉ោង] LT\",lastDay:\"[ម្សិលមិញ ម៉ោង] LT\",lastWeek:\"dddd [សប្តាហ៍មុន] [ម៉ោង] LT\",sameElse:\"L\"},relativeTime:{future:\"%sទៀត\",past:\"%sមុន\",s:\"ប៉ុន្មានវិនាទី\",m:\"មួយនាទី\",mm:\"%d នាទី\",h:\"មួយម៉ោង\",hh:\"%d ម៉ោង\",d:\"មួយថ្ងៃ\",dd:\"%d ថ្ងៃ\",M:\"មួយខែ\",MM:\"%d ខែ\",y:\"មួយឆ្នាំ\",yy:\"%d ឆ្នាំ\"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"೧\",2:\"೨\",3:\"೩\",4:\"೪\",5:\"೫\",6:\"೬\",7:\"೭\",8:\"೮\",9:\"೯\",0:\"೦\"},n={\"೧\":\"1\",\"೨\":\"2\",\"೩\":\"3\",\"೪\":\"4\",\"೫\":\"5\",\"೬\":\"6\",\"೭\":\"7\",\"೮\":\"8\",\"೯\":\"9\",\"೦\":\"0\"},r=e.defineLocale(\"kn\",{months:\"ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್\".split(\"_\"),monthsShort:\"ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ\".split(\"_\"),monthsParseExact:!0,weekdays:\"ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ\".split(\"_\"),weekdaysShort:\"ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ\".split(\"_\"),weekdaysMin:\"ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[ಇಂದು] LT\",nextDay:\"[ನಾಳೆ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ನಿನ್ನೆ] LT\",lastWeek:\"[ಕೊನೆಯ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ನಂತರ\",past:\"%s ಹಿಂದೆ\",s:\"ಕೆಲವು ಕ್ಷಣಗಳು\",m:\"ಒಂದು ನಿಮಿಷ\",mm:\"%d ನಿಮಿಷ\",h:\"ಒಂದು ಗಂಟೆ\",hh:\"%d ಗಂಟೆ\",d:\"ಒಂದು ದಿನ\",dd:\"%d ದಿನ\",M:\"ಒಂದು ತಿಂಗಳು\",MM:\"%d ತಿಂಗಳು\",y:\"ಒಂದು ವರ್ಷ\",yy:\"%d ವರ್ಷ\"},preparse:function(e){return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,meridiemHour:function(e,t){return 12===e&&(e=0),\"ರಾತ್ರಿ\"===t?e<4?e:e+12:\"ಬೆಳಿಗ್ಗೆ\"===t?e:\"ಮಧ್ಯಾಹ್ನ\"===t?e>=10?e:e+12:\"ಸಂಜೆ\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"ರಾತ್ರಿ\":e<10?\"ಬೆಳಿಗ್ಗೆ\":e<17?\"ಮಧ್ಯಾಹ್ನ\":e<20?\"ಸಂಜೆ\":\"ರಾತ್ರಿ\"},dayOfMonthOrdinalParse:/\\d{1,2}(ನೇ)/,ordinal:function(e){return e+\"ನೇ\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ko\",{months:\"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월\".split(\"_\"),monthsShort:\"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월\".split(\"_\"),weekdays:\"일요일_월요일_화요일_수요일_목요일_금요일_토요일\".split(\"_\"),weekdaysShort:\"일_월_화_수_목_금_토\".split(\"_\"),weekdaysMin:\"일_월_화_수_목_금_토\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"YYYY.MM.DD\",LL:\"YYYY년 MMMM D일\",LLL:\"YYYY년 MMMM D일 A h:mm\",LLLL:\"YYYY년 MMMM D일 dddd A h:mm\",l:\"YYYY.MM.DD\",ll:\"YYYY년 MMMM D일\",lll:\"YYYY년 MMMM D일 A h:mm\",llll:\"YYYY년 MMMM D일 dddd A h:mm\"},calendar:{sameDay:\"오늘 LT\",nextDay:\"내일 LT\",nextWeek:\"dddd LT\",lastDay:\"어제 LT\",lastWeek:\"지난주 dddd LT\",sameElse:\"L\"},relativeTime:{future:\"%s 후\",past:\"%s 전\",s:\"몇 초\",ss:\"%d초\",m:\"1분\",mm:\"%d분\",h:\"한 시간\",hh:\"%d시간\",d:\"하루\",dd:\"%d일\",M:\"한 달\",MM:\"%d달\",y:\"일 년\",yy:\"%d년\"},dayOfMonthOrdinalParse:/\\d{1,2}일/,ordinal:\"%d일\",meridiemParse:/오전|오후/,isPM:function(e){return\"오후\"===e},meridiem:function(e,t,n){return e<12?\"오전\":\"오후\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={0:\"-чү\",1:\"-чи\",2:\"-чи\",3:\"-чү\",4:\"-чү\",5:\"-чи\",6:\"-чы\",7:\"-чи\",8:\"-чи\",9:\"-чу\",10:\"-чу\",20:\"-чы\",30:\"-чу\",40:\"-чы\",50:\"-чү\",60:\"-чы\",70:\"-чи\",80:\"-чи\",90:\"-чу\",100:\"-чү\"},n=e.defineLocale(\"ky\",{months:\"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь\".split(\"_\"),monthsShort:\"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек\".split(\"_\"),weekdays:\"Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби\".split(\"_\"),weekdaysShort:\"Жек_Дүй_Шей_Шар_Бей_Жум_Ише\".split(\"_\"),weekdaysMin:\"Жк_Дй_Шй_Шр_Бй_Жм_Иш\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Бүгүн саат] LT\",nextDay:\"[Эртең саат] LT\",nextWeek:\"dddd [саат] LT\",lastDay:\"[Кече саат] LT\",lastWeek:\"[Өткен аптанын] dddd [күнү] [саат] LT\",sameElse:\"L\"},relativeTime:{future:\"%s ичинде\",past:\"%s мурун\",s:\"бирнече секунд\",m:\"бир мүнөт\",mm:\"%d мүнөт\",h:\"бир саат\",hh:\"%d саат\",d:\"бир күн\",dd:\"%d күн\",M:\"бир ай\",MM:\"%d ай\",y:\"бир жыл\",yy:\"%d жыл\"},dayOfMonthOrdinalParse:/\\d{1,2}-(чи|чы|чү|чу)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={m:[\"eng Minutt\",\"enger Minutt\"],h:[\"eng Stonn\",\"enger Stonn\"],d:[\"een Dag\",\"engem Dag\"],M:[\"ee Mount\",\"engem Mount\"],y:[\"ee Joer\",\"engem Joer\"]};return t?a[n][0]:a[n][1]}function n(e){var t=e.substr(0,e.indexOf(\" \"));return a(t)?\"a \"+e:\"an \"+e}function r(e){var t=e.substr(0,e.indexOf(\" \"));return a(t)?\"viru \"+e:\"virun \"+e}function a(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var t=e%10,n=e/10;return a(0===t?n:t)}if(e<1e4){for(;e>=10;)e/=10;return a(e)}return e/=1e3,a(e)}var i=e.defineLocale(\"lb\",{months:\"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember\".split(\"_\"),monthsShort:\"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.\".split(\"_\"),monthsParseExact:!0,weekdays:\"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg\".split(\"_\"),weekdaysShort:\"So._Mé._Dë._Më._Do._Fr._Sa.\".split(\"_\"),weekdaysMin:\"So_Mé_Dë_Më_Do_Fr_Sa\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm [Auer]\",LTS:\"H:mm:ss [Auer]\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm [Auer]\",LLLL:\"dddd, D. MMMM YYYY H:mm [Auer]\"},calendar:{sameDay:\"[Haut um] LT\",sameElse:\"L\",nextDay:\"[Muer um] LT\",nextWeek:\"dddd [um] LT\",lastDay:\"[Gëschter um] LT\",lastWeek:function(){switch(this.day()){case 2:case 4:return\"[Leschten] dddd [um] LT\";default:return\"[Leschte] dddd [um] LT\"}}},relativeTime:{future:n,past:r,s:\"e puer Sekonnen\",m:t,mm:\"%d Minutten\",h:t,hh:\"%d Stonnen\",d:t,dd:\"%d Deeg\",M:t,MM:\"%d Méint\",y:t,yy:\"%d Joer\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"lo\",{months:\"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ\".split(\"_\"),monthsShort:\"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ\".split(\"_\"),weekdays:\"ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ\".split(\"_\"),weekdaysShort:\"ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ\".split(\"_\"),weekdaysMin:\"ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"ວັນdddd D MMMM YYYY HH:mm\"},meridiemParse:/ຕອນເຊົ້າ|ຕອນແລງ/,isPM:function(e){return\"ຕອນແລງ\"===e},meridiem:function(e,t,n){return e<12?\"ຕອນເຊົ້າ\":\"ຕອນແລງ\"},calendar:{sameDay:\"[ມື້ນີ້ເວລາ] LT\",nextDay:\"[ມື້ອື່ນເວລາ] LT\",nextWeek:\"[ວັນ]dddd[ໜ້າເວລາ] LT\",lastDay:\"[ມື້ວານນີ້ເວລາ] LT\",lastWeek:\"[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT\",sameElse:\"L\"},relativeTime:{future:\"ອີກ %s\",past:\"%sຜ່ານມາ\",s:\"ບໍ່ເທົ່າໃດວິນາທີ\",m:\"1 ນາທີ\",mm:\"%d ນາທີ\",h:\"1 ຊົ່ວໂມງ\",hh:\"%d ຊົ່ວໂມງ\",d:\"1 ມື້\",dd:\"%d ມື້\",M:\"1 ເດືອນ\",MM:\"%d ເດືອນ\",y:\"1 ປີ\",yy:\"%d ປີ\"},dayOfMonthOrdinalParse:/(ທີ່)\\d{1,2}/,ordinal:function(e){return\"ທີ່\"+e}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){return t?\"kelios sekundės\":r?\"kelių sekundžių\":\"kelias sekundes\"}function n(e,t,n,r){return t?a(n)[0]:r?a(n)[1]:a(n)[2]}function r(e){return e%10===0||e>10&&e<20}function a(e){return o[e].split(\"_\")}function i(e,t,i,o){var c=e+\" \";return 1===e?c+n(e,t,i[0],o):t?c+(r(e)?a(i)[1]:a(i)[0]):o?c+a(i)[1]:c+(r(e)?a(i)[1]:a(i)[2])}var o={m:\"minutė_minutės_minutę\",mm:\"minutės_minučių_minutes\",h:\"valanda_valandos_valandą\",hh:\"valandos_valandų_valandas\",d:\"diena_dienos_dieną\",dd:\"dienos_dienų_dienas\",M:\"mėnuo_mėnesio_mėnesį\",MM:\"mėnesiai_mėnesių_mėnesius\",y:\"metai_metų_metus\",yy:\"metai_metų_metus\"},c=e.defineLocale(\"lt\",{months:{format:\"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio\".split(\"_\"),standalone:\"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis\".split(\"_\"),isFormat:/D[oD]?(\\[[^\\[\\]]*\\]|\\s)+MMMM?|MMMM?(\\[[^\\[\\]]*\\]|\\s)+D[oD]?/},monthsShort:\"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd\".split(\"_\"),weekdays:{format:\"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį\".split(\"_\"),standalone:\"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis\".split(\"_\"),isFormat:/dddd HH:mm/},weekdaysShort:\"Sek_Pir_Ant_Tre_Ket_Pen_Šeš\".split(\"_\"),weekdaysMin:\"S_P_A_T_K_Pn_Š\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"YYYY [m.] MMMM D [d.]\",LLL:\"YYYY [m.] MMMM D [d.], HH:mm [val.]\",LLLL:\"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]\",l:\"YYYY-MM-DD\",ll:\"YYYY [m.] MMMM D [d.]\",lll:\"YYYY [m.] MMMM D [d.], HH:mm [val.]\",llll:\"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]\"},calendar:{sameDay:\"[Šiandien] LT\",nextDay:\"[Rytoj] LT\",nextWeek:\"dddd LT\",lastDay:\"[Vakar] LT\",lastWeek:\"[Praėjusį] dddd LT\",sameElse:\"L\"},relativeTime:{future:\"po %s\",past:\"prieš %s\",s:t,m:n,mm:i,h:n,hh:i,d:n,dd:i,M:n,MM:i,y:n,yy:i},dayOfMonthOrdinalParse:/\\d{1,2}-oji/,ordinal:function(e){return e+\"-oji\"},week:{dow:1,doy:4}});return c})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n){return n?t%10===1&&t%100!==11?e[2]:e[3]:t%10===1&&t%100!==11?e[0]:e[1]}function n(e,n,r){return e+\" \"+t(i[r],e,n)}function r(e,n,r){return t(i[r],e,n)}function a(e,t){return t?\"dažas sekundes\":\"dažām sekundēm\"}var i={m:\"minūtes_minūtēm_minūte_minūtes\".split(\"_\"),mm:\"minūtes_minūtēm_minūte_minūtes\".split(\"_\"),h:\"stundas_stundām_stunda_stundas\".split(\"_\"),hh:\"stundas_stundām_stunda_stundas\".split(\"_\"),d:\"dienas_dienām_diena_dienas\".split(\"_\"),dd:\"dienas_dienām_diena_dienas\".split(\"_\"),M:\"mēneša_mēnešiem_mēnesis_mēneši\".split(\"_\"),MM:\"mēneša_mēnešiem_mēnesis_mēneši\".split(\"_\"),y:\"gada_gadiem_gads_gadi\".split(\"_\"),yy:\"gada_gadiem_gads_gadi\".split(\"_\")},o=e.defineLocale(\"lv\",{months:\"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena\".split(\"_\"),weekdaysShort:\"Sv_P_O_T_C_Pk_S\".split(\"_\"),weekdaysMin:\"Sv_P_O_T_C_Pk_S\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY.\",LL:\"YYYY. [gada] D. MMMM\",LLL:\"YYYY. [gada] D. MMMM, HH:mm\",LLLL:\"YYYY. [gada] D. MMMM, dddd, HH:mm\"},calendar:{sameDay:\"[Šodien pulksten] LT\",nextDay:\"[Rīt pulksten] LT\",nextWeek:\"dddd [pulksten] LT\",lastDay:\"[Vakar pulksten] LT\",lastWeek:\"[Pagājušā] dddd [pulksten] LT\",sameElse:\"L\"},relativeTime:{future:\"pēc %s\",past:\"pirms %s\",s:a,m:r,mm:n,h:r,hh:n,d:r,dd:n,M:r,MM:n,y:r,yy:n},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={words:{m:[\"jedan minut\",\"jednog minuta\"],mm:[\"minut\",\"minuta\",\"minuta\"],h:[\"jedan sat\",\"jednog sata\"],hh:[\"sat\",\"sata\",\"sati\"],dd:[\"dan\",\"dana\",\"dana\"],MM:[\"mjesec\",\"mjeseca\",\"mjeseci\"],yy:[\"godina\",\"godine\",\"godina\"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var a=t.words[r];return 1===r.length?n?a[0]:a[1]:e+\" \"+t.correctGrammaticalCase(e,a)}},n=e.defineLocale(\"me\",{months:\"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sri._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sjutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedjelju] [u] LT\";case 3:return\"[u] [srijedu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[juče u] LT\",lastWeek:function(){var e=[\"[prošle] [nedjelje] [u] LT\",\"[prošlog] [ponedjeljka] [u] LT\",\"[prošlog] [utorka] [u] LT\",\"[prošle] [srijede] [u] LT\",\"[prošlog] [četvrtka] [u] LT\",\"[prošlog] [petka] [u] LT\",\"[prošle] [subote] [u] LT\"];return e[this.day()]},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"prije %s\",s:\"nekoliko sekundi\",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:\"dan\",dd:t.translate,M:\"mjesec\",MM:t.translate,y:\"godinu\",yy:t.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"mi\",{months:\"Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea\".split(\"_\"),monthsShort:\"Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki\".split(\"_\"),monthsRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsShortRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\\u0101\\u014D\\u016B]+\\-?){1,2}/i,weekdays:\"Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei\".split(\"_\"),weekdaysShort:\"Ta_Ma_Tū_We_Tāi_Pa_Hā\".split(\"_\"),weekdaysMin:\"Ta_Ma_Tū_We_Tāi_Pa_Hā\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [i] HH:mm\",LLLL:\"dddd, D MMMM YYYY [i] HH:mm\"},calendar:{sameDay:\"[i teie mahana, i] LT\",nextDay:\"[apopo i] LT\",nextWeek:\"dddd [i] LT\",lastDay:\"[inanahi i] LT\",lastWeek:\"dddd [whakamutunga i] LT\",sameElse:\"L\"},relativeTime:{future:\"i roto i %s\",past:\"%s i mua\",s:\"te hēkona ruarua\",m:\"he meneti\",mm:\"%d meneti\",h:\"te haora\",hh:\"%d haora\",d:\"he ra\",dd:\"%d ra\",M:\"he marama\",MM:\"%d marama\",y:\"he tau\",yy:\"%d tau\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"mk\",{months:\"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември\".split(\"_\"),monthsShort:\"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек\".split(\"_\"),weekdays:\"недела_понеделник_вторник_среда_четврток_петок_сабота\".split(\"_\"),weekdaysShort:\"нед_пон_вто_сре_чет_пет_саб\".split(\"_\"),weekdaysMin:\"нe_пo_вт_ср_че_пе_сa\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"D.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[Денес во] LT\",nextDay:\"[Утре во] LT\",nextWeek:\"[Во] dddd [во] LT\",lastDay:\"[Вчера во] LT\",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return\"[Изминатата] dddd [во] LT\";case 1:case 2:case 4:case 5:return\"[Изминатиот] dddd [во] LT\"}},sameElse:\"L\"},relativeTime:{future:\"после %s\",past:\"пред %s\",s:\"неколку секунди\",m:\"минута\",mm:\"%d минути\",h:\"час\",hh:\"%d часа\",d:\"ден\",dd:\"%d дена\",M:\"месец\",MM:\"%d месеци\",y:\"година\",yy:\"%d години\"},dayOfMonthOrdinalParse:/\\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+\"-ев\":0===n?e+\"-ен\":n>10&&n<20?e+\"-ти\":1===t?e+\"-ви\":2===t?e+\"-ри\":7===t||8===t?e+\"-ми\":e+\"-ти\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ml\",{months:\"ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ\".split(\"_\"),monthsShort:\"ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.\".split(\"_\"),monthsParseExact:!0,weekdays:\"ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച\".split(\"_\"),weekdaysShort:\"ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി\".split(\"_\"),weekdaysMin:\"ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ\".split(\"_\"),longDateFormat:{LT:\"A h:mm -നു\",LTS:\"A h:mm:ss -നു\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm -നു\",LLLL:\"dddd, D MMMM YYYY, A h:mm -നു\"},calendar:{sameDay:\"[ഇന്ന്] LT\",nextDay:\"[നാളെ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ഇന്നലെ] LT\",lastWeek:\"[കഴിഞ്ഞ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s കഴിഞ്ഞ്\",past:\"%s മുൻപ്\",s:\"അൽപ നിമിഷങ്ങൾ\",m:\"ഒരു മിനിറ്റ്\",mm:\"%d മിനിറ്റ്\",h:\"ഒരു മണിക്കൂർ\",hh:\"%d മണിക്കൂർ\",d:\"ഒരു ദിവസം\",dd:\"%d ദിവസം\",M:\"ഒരു മാസം\",MM:\"%d മാസം\",y:\"ഒരു വർഷം\",yy:\"%d വർഷം\"},meridiemParse:/രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,meridiemHour:function(e,t){return 12===e&&(e=0),\"രാത്രി\"===t&&e>=4||\"ഉച്ച കഴിഞ്ഞ്\"===t||\"വൈകുന്നേരം\"===t?e+12:e},meridiem:function(e,t,n){return e<4?\"രാത്രി\":e<12?\"രാവിലെ\":e<17?\"ഉച്ച കഴിഞ്ഞ്\":e<20?\"വൈകുന്നേരം\":\"രാത്രി\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a=\"\";if(t)switch(n){case\"s\":a=\"काही सेकंद\";break;case\"m\":a=\"एक मिनिट\";break;case\"mm\":a=\"%d मिनिटे\";break;case\"h\":a=\"एक तास\";break;case\"hh\":a=\"%d तास\";break;case\"d\":a=\"एक दिवस\";break;case\"dd\":a=\"%d दिवस\";break;case\"M\":a=\"एक महिना\";break;case\"MM\":a=\"%d महिने\";break;case\"y\":a=\"एक वर्ष\";break;case\"yy\":a=\"%d वर्षे\"}else switch(n){case\"s\":a=\"काही सेकंदां\";break;case\"m\":a=\"एका मिनिटा\";break;case\"mm\":a=\"%d मिनिटां\";break;case\"h\":a=\"एका तासा\";break;case\"hh\":a=\"%d तासां\";break;case\"d\":a=\"एका दिवसा\";break;case\"dd\":a=\"%d दिवसां\";break;case\"M\":a=\"एका महिन्या\";break;case\"MM\":a=\"%d महिन्यां\";break;case\"y\":a=\"एका वर्षा\";break;case\"yy\":a=\"%d वर्षां\"}return a.replace(/%d/i,e)}var n={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},r={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"},a=e.defineLocale(\"mr\",{months:\"जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर\".split(\"_\"),monthsShort:\"जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.\".split(\"_\"),monthsParseExact:!0,weekdays:\"रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार\".split(\"_\"),weekdaysShort:\"रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि\".split(\"_\"),weekdaysMin:\"र_सो_मं_बु_गु_शु_श\".split(\"_\"),longDateFormat:{LT:\"A h:mm वाजता\",LTS:\"A h:mm:ss वाजता\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm वाजता\",LLLL:\"dddd, D MMMM YYYY, A h:mm वाजता\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[उद्या] LT\",nextWeek:\"dddd, LT\",lastDay:\"[काल] LT\",lastWeek:\"[मागील] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%sमध्ये\",past:\"%sपूर्वी\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return r[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return n[e]})},meridiemParse:/रात्री|सकाळी|दुपारी|सायंकाळी/,\nmeridiemHour:function(e,t){return 12===e&&(e=0),\"रात्री\"===t?e<4?e:e+12:\"सकाळी\"===t?e:\"दुपारी\"===t?e>=10?e:e+12:\"सायंकाळी\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"रात्री\":e<10?\"सकाळी\":e<17?\"दुपारी\":e<20?\"सायंकाळी\":\"रात्री\"},week:{dow:0,doy:6}});return a})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ms\",{months:\"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis\".split(\"_\"),weekdays:\"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu\".split(\"_\"),weekdaysShort:\"Ahd_Isn_Sel_Rab_Kha_Jum_Sab\".split(\"_\"),weekdaysMin:\"Ah_Is_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),\"pagi\"===t?e:\"tengahari\"===t?e>=11?e:e+12:\"petang\"===t||\"malam\"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?\"pagi\":e<15?\"tengahari\":e<19?\"petang\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Esok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kelmarin pukul] LT\",lastWeek:\"dddd [lepas pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lepas\",s:\"beberapa saat\",m:\"seminit\",mm:\"%d minit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ms-my\",{months:\"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis\".split(\"_\"),weekdays:\"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu\".split(\"_\"),weekdaysShort:\"Ahd_Isn_Sel_Rab_Kha_Jum_Sab\".split(\"_\"),weekdaysMin:\"Ah_Is_Sl_Rb_Km_Jm_Sb\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [pukul] HH.mm\",LLLL:\"dddd, D MMMM YYYY [pukul] HH.mm\"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),\"pagi\"===t?e:\"tengahari\"===t?e>=11?e:e+12:\"petang\"===t||\"malam\"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?\"pagi\":e<15?\"tengahari\":e<19?\"petang\":\"malam\"},calendar:{sameDay:\"[Hari ini pukul] LT\",nextDay:\"[Esok pukul] LT\",nextWeek:\"dddd [pukul] LT\",lastDay:\"[Kelmarin pukul] LT\",lastWeek:\"dddd [lepas pukul] LT\",sameElse:\"L\"},relativeTime:{future:\"dalam %s\",past:\"%s yang lepas\",s:\"beberapa saat\",m:\"seminit\",mm:\"%d minit\",h:\"sejam\",hh:\"%d jam\",d:\"sehari\",dd:\"%d hari\",M:\"sebulan\",MM:\"%d bulan\",y:\"setahun\",yy:\"%d tahun\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"၁\",2:\"၂\",3:\"၃\",4:\"၄\",5:\"၅\",6:\"၆\",7:\"၇\",8:\"၈\",9:\"၉\",0:\"၀\"},n={\"၁\":\"1\",\"၂\":\"2\",\"၃\":\"3\",\"၄\":\"4\",\"၅\":\"5\",\"၆\":\"6\",\"၇\":\"7\",\"၈\":\"8\",\"၉\":\"9\",\"၀\":\"0\"},r=e.defineLocale(\"my\",{months:\"ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ\".split(\"_\"),monthsShort:\"ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ\".split(\"_\"),weekdays:\"တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ\".split(\"_\"),weekdaysShort:\"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ\".split(\"_\"),weekdaysMin:\"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ယနေ.] LT [မှာ]\",nextDay:\"[မနက်ဖြန်] LT [မှာ]\",nextWeek:\"dddd LT [မှာ]\",lastDay:\"[မနေ.က] LT [မှာ]\",lastWeek:\"[ပြီးခဲ့သော] dddd LT [မှာ]\",sameElse:\"L\"},relativeTime:{future:\"လာမည့် %s မှာ\",past:\"လွန်ခဲ့သော %s က\",s:\"စက္ကန်.အနည်းငယ်\",m:\"တစ်မိနစ်\",mm:\"%d မိနစ်\",h:\"တစ်နာရီ\",hh:\"%d နာရီ\",d:\"တစ်ရက်\",dd:\"%d ရက်\",M:\"တစ်လ\",MM:\"%d လ\",y:\"တစ်နှစ်\",yy:\"%d နှစ်\"},preparse:function(e){return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"nb\",{months:\"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.\".split(\"_\"),monthsParseExact:!0,weekdays:\"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag\".split(\"_\"),weekdaysShort:\"sø._ma._ti._on._to._fr._lø.\".split(\"_\"),weekdaysMin:\"sø_ma_ti_on_to_fr_lø\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] HH:mm\",LLLL:\"dddd D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[i dag kl.] LT\",nextDay:\"[i morgen kl.] LT\",nextWeek:\"dddd [kl.] LT\",lastDay:\"[i går kl.] LT\",lastWeek:\"[forrige] dddd [kl.] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s siden\",s:\"noen sekunder\",m:\"ett minutt\",mm:\"%d minutter\",h:\"en time\",hh:\"%d timer\",d:\"en dag\",dd:\"%d dager\",M:\"en måned\",MM:\"%d måneder\",y:\"ett år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"१\",2:\"२\",3:\"३\",4:\"४\",5:\"५\",6:\"६\",7:\"७\",8:\"८\",9:\"९\",0:\"०\"},n={\"१\":\"1\",\"२\":\"2\",\"३\":\"3\",\"४\":\"4\",\"५\":\"5\",\"६\":\"6\",\"७\":\"7\",\"८\":\"8\",\"९\":\"9\",\"०\":\"0\"},r=e.defineLocale(\"ne\",{months:\"जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर\".split(\"_\"),monthsShort:\"जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.\".split(\"_\"),monthsParseExact:!0,weekdays:\"आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार\".split(\"_\"),weekdaysShort:\"आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.\".split(\"_\"),weekdaysMin:\"आ._सो._मं._बु._बि._शु._श.\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"Aको h:mm बजे\",LTS:\"Aको h:mm:ss बजे\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, Aको h:mm बजे\",LLLL:\"dddd, D MMMM YYYY, Aको h:mm बजे\"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/राति|बिहान|दिउँसो|साँझ/,meridiemHour:function(e,t){return 12===e&&(e=0),\"राति\"===t?e<4?e:e+12:\"बिहान\"===t?e:\"दिउँसो\"===t?e>=10?e:e+12:\"साँझ\"===t?e+12:void 0},meridiem:function(e,t,n){return e<3?\"राति\":e<12?\"बिहान\":e<16?\"दिउँसो\":e<20?\"साँझ\":\"राति\"},calendar:{sameDay:\"[आज] LT\",nextDay:\"[भोलि] LT\",nextWeek:\"[आउँदो] dddd[,] LT\",lastDay:\"[हिजो] LT\",lastWeek:\"[गएको] dddd[,] LT\",sameElse:\"L\"},relativeTime:{future:\"%sमा\",past:\"%s अगाडि\",s:\"केही क्षण\",m:\"एक मिनेट\",mm:\"%d मिनेट\",h:\"एक घण्टा\",hh:\"%d घण्टा\",d:\"एक दिन\",dd:\"%d दिन\",M:\"एक महिना\",MM:\"%d महिना\",y:\"एक बर्ष\",yy:\"%d बर्ष\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=\"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),n=\"jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),r=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],a=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\\.?|feb\\.?|mrt\\.?|apr\\.?|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,i=e.defineLocale(\"nl\",{months:\"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december\".split(\"_\"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\\.?|feb\\.?|mrt\\.?|apr\\.?|mei|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:\"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag\".split(\"_\"),weekdaysShort:\"zo._ma._di._wo._do._vr._za.\".split(\"_\"),weekdaysMin:\"Zo_Ma_Di_Wo_Do_Vr_Za\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD-MM-YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[vandaag om] LT\",nextDay:\"[morgen om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[gisteren om] LT\",lastWeek:\"[afgelopen] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"over %s\",past:\"%s geleden\",s:\"een paar seconden\",m:\"één minuut\",mm:\"%d minuten\",h:\"één uur\",hh:\"%d uur\",d:\"één dag\",dd:\"%d dagen\",M:\"één maand\",MM:\"%d maanden\",y:\"één jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=\"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.\".split(\"_\"),n=\"jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),r=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],a=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\\.?|feb\\.?|mrt\\.?|apr\\.?|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,i=e.defineLocale(\"nl-be\",{months:\"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december\".split(\"_\"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\\.?|feb\\.?|mrt\\.?|apr\\.?|mei|ju[nl]\\.?|aug\\.?|sep\\.?|okt\\.?|nov\\.?|dec\\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:\"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag\".split(\"_\"),weekdaysShort:\"zo._ma._di._wo._do._vr._za.\".split(\"_\"),weekdaysMin:\"Zo_Ma_Di_Wo_Do_Vr_Za\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[vandaag om] LT\",nextDay:\"[morgen om] LT\",nextWeek:\"dddd [om] LT\",lastDay:\"[gisteren om] LT\",lastWeek:\"[afgelopen] dddd [om] LT\",sameElse:\"L\"},relativeTime:{future:\"over %s\",past:\"%s geleden\",s:\"een paar seconden\",m:\"één minuut\",mm:\"%d minuten\",h:\"één uur\",hh:\"%d uur\",d:\"één dag\",dd:\"%d dagen\",M:\"één maand\",MM:\"%d maanden\",y:\"één jaar\",yy:\"%d jaar\"},dayOfMonthOrdinalParse:/\\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?\"ste\":\"de\")},week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"nn\",{months:\"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des\".split(\"_\"),weekdays:\"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag\".split(\"_\"),weekdaysShort:\"sun_mån_tys_ons_tor_fre_lau\".split(\"_\"),weekdaysMin:\"su_må_ty_on_to_fr_lø\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY [kl.] H:mm\",LLLL:\"dddd D. MMMM YYYY [kl.] HH:mm\"},calendar:{sameDay:\"[I dag klokka] LT\",nextDay:\"[I morgon klokka] LT\",nextWeek:\"dddd [klokka] LT\",lastDay:\"[I går klokka] LT\",lastWeek:\"[Føregåande] dddd [klokka] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"%s sidan\",s:\"nokre sekund\",m:\"eit minutt\",mm:\"%d minutt\",h:\"ein time\",hh:\"%d timar\",d:\"ein dag\",dd:\"%d dagar\",M:\"ein månad\",MM:\"%d månader\",y:\"eit år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"੧\",2:\"੨\",3:\"੩\",4:\"੪\",5:\"੫\",6:\"੬\",7:\"੭\",8:\"੮\",9:\"੯\",0:\"੦\"},n={\"੧\":\"1\",\"੨\":\"2\",\"੩\":\"3\",\"੪\":\"4\",\"੫\":\"5\",\"੬\":\"6\",\"੭\":\"7\",\"੮\":\"8\",\"੯\":\"9\",\"੦\":\"0\"},r=e.defineLocale(\"pa-in\",{months:\"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ\".split(\"_\"),monthsShort:\"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ\".split(\"_\"),weekdays:\"ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ\".split(\"_\"),weekdaysShort:\"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ\".split(\"_\"),weekdaysMin:\"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ\".split(\"_\"),longDateFormat:{LT:\"A h:mm ਵਜੇ\",LTS:\"A h:mm:ss ਵਜੇ\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm ਵਜੇ\",LLLL:\"dddd, D MMMM YYYY, A h:mm ਵਜੇ\"},calendar:{sameDay:\"[ਅਜ] LT\",nextDay:\"[ਕਲ] LT\",nextWeek:\"dddd, LT\",lastDay:\"[ਕਲ] LT\",lastWeek:\"[ਪਿਛਲੇ] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s ਵਿੱਚ\",past:\"%s ਪਿਛਲੇ\",s:\"ਕੁਝ ਸਕਿੰਟ\",m:\"ਇਕ ਮਿੰਟ\",mm:\"%d ਮਿੰਟ\",h:\"ਇੱਕ ਘੰਟਾ\",hh:\"%d ਘੰਟੇ\",d:\"ਇੱਕ ਦਿਨ\",dd:\"%d ਦਿਨ\",M:\"ਇੱਕ ਮਹੀਨਾ\",MM:\"%d ਮਹੀਨੇ\",y:\"ਇੱਕ ਸਾਲ\",yy:\"%d ਸਾਲ\"},preparse:function(e){return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,meridiemHour:function(e,t){return 12===e&&(e=0),\"ਰਾਤ\"===t?e<4?e:e+12:\"ਸਵੇਰ\"===t?e:\"ਦੁਪਹਿਰ\"===t?e>=10?e:e+12:\"ਸ਼ਾਮ\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"ਰਾਤ\":e<10?\"ਸਵੇਰ\":e<17?\"ਦੁਪਹਿਰ\":e<20?\"ਸ਼ਾਮ\":\"ਰਾਤ\"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){return e%10<5&&e%10>1&&~~(e/10)%10!==1}function n(e,n,r){var a=e+\" \";switch(r){case\"m\":return n?\"minuta\":\"minutę\";case\"mm\":return a+(t(e)?\"minuty\":\"minut\");case\"h\":return n?\"godzina\":\"godzinę\";case\"hh\":return a+(t(e)?\"godziny\":\"godzin\");case\"MM\":return a+(t(e)?\"miesiące\":\"miesięcy\");case\"yy\":return a+(t(e)?\"lata\":\"lat\")}}var r=\"styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień\".split(\"_\"),a=\"stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia\".split(\"_\"),i=e.defineLocale(\"pl\",{months:function(e,t){return e?\"\"===t?\"(\"+a[e.month()]+\"|\"+r[e.month()]+\")\":/D MMMM/.test(t)?a[e.month()]:r[e.month()]:r},monthsShort:\"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru\".split(\"_\"),weekdays:\"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota\".split(\"_\"),weekdaysShort:\"ndz_pon_wt_śr_czw_pt_sob\".split(\"_\"),weekdaysMin:\"Nd_Pn_Wt_Śr_Cz_Pt_So\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Dziś o] LT\",nextDay:\"[Jutro o] LT\",nextWeek:\"[W] dddd [o] LT\",lastDay:\"[Wczoraj o] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[W zeszłą niedzielę o] LT\";case 3:return\"[W zeszłą środę o] LT\";case 6:return\"[W zeszłą sobotę o] LT\";default:return\"[W zeszły] dddd [o] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"%s temu\",s:\"kilka sekund\",m:n,mm:n,h:n,hh:n,d:\"1 dzień\",dd:\"%d dni\",M:\"miesiąc\",MM:n,y:\"rok\",yy:n},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"pt\",{months:\"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ter_Qua_Qui_Sex_Sáb\".split(\"_\"),weekdaysMin:\"Do_2ª_3ª_4ª_5ª_6ª_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY HH:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY HH:mm\"},calendar:{sameDay:\"[Hoje às] LT\",nextDay:\"[Amanhã às] LT\",nextWeek:\"dddd [às] LT\",lastDay:\"[Ontem às] LT\",lastWeek:function(){return 0===this.day()||6===this.day()?\"[Último] dddd [às] LT\":\"[Última] dddd [às] LT\"},sameElse:\"L\"},relativeTime:{future:\"em %s\",past:\"há %s\",s:\"segundos\",m:\"um minuto\",mm:\"%d minutos\",h:\"uma hora\",hh:\"%d horas\",d:\"um dia\",dd:\"%d dias\",M:\"um mês\",MM:\"%d meses\",y:\"um ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"pt-br\",{months:\"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ter_Qua_Qui_Sex_Sáb\".split(\"_\"),weekdaysMin:\"Do_2ª_3ª_4ª_5ª_6ª_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D [de] MMMM [de] YYYY\",LLL:\"D [de] MMMM [de] YYYY [às] HH:mm\",LLLL:\"dddd, D [de] MMMM [de] YYYY [às] HH:mm\"},calendar:{sameDay:\"[Hoje às] LT\",nextDay:\"[Amanhã às] LT\",nextWeek:\"dddd [às] LT\",lastDay:\"[Ontem às] LT\",lastWeek:function(){return 0===this.day()||6===this.day()?\"[Último] dddd [às] LT\":\"[Última] dddd [às] LT\"},sameElse:\"L\"},relativeTime:{future:\"em %s\",past:\"%s atrás\",s:\"poucos segundos\",m:\"um minuto\",mm:\"%d minutos\",h:\"uma hora\",hh:\"%d horas\",d:\"um dia\",dd:\"%d dias\",M:\"um mês\",MM:\"%d meses\",y:\"um ano\",yy:\"%d anos\"},dayOfMonthOrdinalParse:/\\d{1,2}º/,ordinal:\"%dº\"});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n){var r={mm:\"minute\",hh:\"ore\",dd:\"zile\",MM:\"luni\",yy:\"ani\"},a=\" \";return(e%100>=20||e>=100&&e%100===0)&&(a=\" de \"),e+a+r[n]}var n=e.defineLocale(\"ro\",{months:\"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie\".split(\"_\"),monthsShort:\"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"duminică_luni_marți_miercuri_joi_vineri_sâmbătă\".split(\"_\"),weekdaysShort:\"Dum_Lun_Mar_Mie_Joi_Vin_Sâm\".split(\"_\"),weekdaysMin:\"Du_Lu_Ma_Mi_Jo_Vi_Sâ\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY H:mm\",LLLL:\"dddd, D MMMM YYYY H:mm\"},calendar:{sameDay:\"[azi la] LT\",nextDay:\"[mâine la] LT\",nextWeek:\"dddd [la] LT\",lastDay:\"[ieri la] LT\",lastWeek:\"[fosta] dddd [la] LT\",sameElse:\"L\"},relativeTime:{future:\"peste %s\",past:\"%s în urmă\",s:\"câteva secunde\",m:\"un minut\",mm:t,h:\"o oră\",hh:t,d:\"o zi\",dd:t,M:\"o lună\",MM:t,y:\"un an\",yy:t},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t){var n=e.split(\"_\");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var a={mm:n?\"минута_минуты_минут\":\"минуту_минуты_минут\",hh:\"час_часа_часов\",dd:\"день_дня_дней\",MM:\"месяц_месяца_месяцев\",yy:\"год_года_лет\"};return\"m\"===r?n?\"минута\":\"минуту\":e+\" \"+t(a[r],+e)}var r=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i],a=e.defineLocale(\"ru\",{months:{format:\"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря\".split(\"_\"),standalone:\"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь\".split(\"_\")},monthsShort:{format:\"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.\".split(\"_\"),standalone:\"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.\".split(\"_\")},weekdays:{standalone:\"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота\".split(\"_\"),format:\"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу\".split(\"_\"),isFormat:/\\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\\] ?dddd/},weekdaysShort:\"вс_пн_вт_ср_чт_пт_сб\".split(\"_\"),weekdaysMin:\"вс_пн_вт_ср_чт_пт_сб\".split(\"_\"),monthsParse:r,longMonthsParse:r,shortMonthsParse:r,monthsRegex:/^(январ[ья]|янв\\.?|феврал[ья]|февр?\\.?|марта?|мар\\.?|апрел[ья]|апр\\.?|ма[йя]|июн[ья]|июн\\.?|июл[ья]|июл\\.?|августа?|авг\\.?|сентябр[ья]|сент?\\.?|октябр[ья]|окт\\.?|ноябр[ья]|нояб?\\.?|декабр[ья]|дек\\.?)/i,monthsShortRegex:/^(январ[ья]|янв\\.?|феврал[ья]|февр?\\.?|марта?|мар\\.?|апрел[ья]|апр\\.?|ма[йя]|июн[ья]|июн\\.?|июл[ья]|июл\\.?|августа?|авг\\.?|сентябр[ья]|сент?\\.?|октябр[ья]|окт\\.?|ноябр[ья]|нояб?\\.?|декабр[ья]|дек\\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\\.|февр?\\.|мар[т.]|апр\\.|ма[яй]|июн[ья.]|июл[ья.]|авг\\.|сент?\\.|окт\\.|нояб?\\.|дек\\.)/i,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY г.\",LLL:\"D MMMM YYYY г., HH:mm\",LLLL:\"dddd, D MMMM YYYY г., HH:mm\"},calendar:{sameDay:\"[Сегодня в] LT\",nextDay:\"[Завтра в] LT\",lastDay:\"[Вчера в] LT\",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?\"[Во] dddd [в] LT\":\"[В] dddd [в] LT\";switch(this.day()){case 0:return\"[В следующее] dddd [в] LT\";case 1:case 2:case 4:return\"[В следующий] dddd [в] LT\";case 3:case 5:case 6:return\"[В следующую] dddd [в] LT\"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?\"[Во] dddd [в] LT\":\"[В] dddd [в] LT\";switch(this.day()){case 0:return\"[В прошлое] dddd [в] LT\";case 1:case 2:case 4:return\"[В прошлый] dddd [в] LT\";case 3:case 5:case 6:return\"[В прошлую] dddd [в] LT\"}},sameElse:\"L\"},relativeTime:{future:\"через %s\",past:\"%s назад\",s:\"несколько секунд\",m:n,mm:n,h:\"час\",hh:n,d:\"день\",dd:n,M:\"месяц\",MM:n,y:\"год\",yy:n},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,t,n){return e<4?\"ночи\":e<12?\"утра\":e<17?\"дня\":\"вечера\"},dayOfMonthOrdinalParse:/\\d{1,2}-(й|го|я)/,ordinal:function(e,t){switch(t){case\"M\":case\"d\":case\"DDD\":return e+\"-й\";case\"D\":return e+\"-го\";case\"w\":case\"W\":return e+\"-я\";default:return e}},week:{dow:1,doy:7}});return a})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=[\"جنوري\",\"فيبروري\",\"مارچ\",\"اپريل\",\"مئي\",\"جون\",\"جولاءِ\",\"آگسٽ\",\"سيپٽمبر\",\"آڪٽوبر\",\"نومبر\",\"ڊسمبر\"],n=[\"آچر\",\"سومر\",\"اڱارو\",\"اربع\",\"خميس\",\"جمع\",\"ڇنڇر\"],r=e.defineLocale(\"sd\",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd، D MMMM YYYY HH:mm\"},meridiemParse:/صبح|شام/,isPM:function(e){return\"شام\"===e},meridiem:function(e,t,n){return e<12?\"صبح\":\"شام\"},calendar:{sameDay:\"[اڄ] LT\",nextDay:\"[سڀاڻي] LT\",nextWeek:\"dddd [اڳين هفتي تي] LT\",lastDay:\"[ڪالهه] LT\",lastWeek:\"[گزريل هفتي] dddd [تي] LT\",sameElse:\"L\"},relativeTime:{future:\"%s پوء\",past:\"%s اڳ\",s:\"چند سيڪنڊ\",m:\"هڪ منٽ\",mm:\"%d منٽ\",h:\"هڪ ڪلاڪ\",hh:\"%d ڪلاڪ\",d:\"هڪ ڏينهن\",dd:\"%d ڏينهن\",M:\"هڪ مهينو\",MM:\"%d مهينا\",y:\"هڪ سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"se\",{months:\"ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu\".split(\"_\"),monthsShort:\"ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov\".split(\"_\"),weekdays:\"sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat\".split(\"_\"),weekdaysShort:\"sotn_vuos_maŋ_gask_duor_bear_láv\".split(\"_\"),weekdaysMin:\"s_v_m_g_d_b_L\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"MMMM D. [b.] YYYY\",LLL:\"MMMM D. [b.] YYYY [ti.] HH:mm\",LLLL:\"dddd, MMMM D. [b.] YYYY [ti.] HH:mm\"},calendar:{sameDay:\"[otne ti] LT\",nextDay:\"[ihttin ti] LT\",nextWeek:\"dddd [ti] LT\",lastDay:\"[ikte ti] LT\",lastWeek:\"[ovddit] dddd [ti] LT\",sameElse:\"L\"},relativeTime:{future:\"%s geažes\",past:\"maŋit %s\",s:\"moadde sekunddat\",m:\"okta minuhta\",mm:\"%d minuhtat\",h:\"okta diimmu\",hh:\"%d diimmut\",d:\"okta beaivi\",dd:\"%d beaivvit\",M:\"okta mánnu\",MM:\"%d mánut\",y:\"okta jahki\",yy:\"%d jagit\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"si\",{months:\"ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්\".split(\"_\"),monthsShort:\"ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ\".split(\"_\"),weekdays:\"ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා\".split(\"_\"),weekdaysShort:\"ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන\".split(\"_\"),weekdaysMin:\"ඉ_ස_අ_බ_බ්‍ර_සි_සෙ\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"a h:mm\",LTS:\"a h:mm:ss\",L:\"YYYY/MM/DD\",LL:\"YYYY MMMM D\",LLL:\"YYYY MMMM D, a h:mm\",LLLL:\"YYYY MMMM D [වැනි] dddd, a h:mm:ss\"},calendar:{sameDay:\"[අද] LT[ට]\",nextDay:\"[හෙට] LT[ට]\",nextWeek:\"dddd LT[ට]\",lastDay:\"[ඊයේ] LT[ට]\",lastWeek:\"[පසුගිය] dddd LT[ට]\",sameElse:\"L\"},relativeTime:{future:\"%sකින්\",past:\"%sකට පෙර\",s:\"තත්පර කිහිපය\",m:\"මිනිත්තුව\",mm:\"මිනිත්තු %d\",h:\"පැය\",hh:\"පැය %d\",d:\"දිනය\",dd:\"දින %d\",M:\"මාසය\",MM:\"මාස %d\",y:\"වසර\",yy:\"වසර %d\"},dayOfMonthOrdinalParse:/\\d{1,2} වැනි/,ordinal:function(e){return e+\" වැනි\"},meridiemParse:/පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,isPM:function(e){return\"ප.ව.\"===e||\"පස් වරු\"===e},meridiem:function(e,t,n){return e>11?n?\"ප.ව.\":\"පස් වරු\":n?\"පෙ.ව.\":\"පෙර වරු\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){return e>1&&e<5}function n(e,n,r,a){var i=e+\" \";switch(r){case\"s\":return n||a?\"pár sekúnd\":\"pár sekundami\";case\"m\":return n?\"minúta\":a?\"minútu\":\"minútou\";case\"mm\":return n||a?i+(t(e)?\"minúty\":\"minút\"):i+\"minútami\";case\"h\":return n?\"hodina\":a?\"hodinu\":\"hodinou\";case\"hh\":return n||a?i+(t(e)?\"hodiny\":\"hodín\"):i+\"hodinami\";case\"d\":return n||a?\"deň\":\"dňom\";case\"dd\":return n||a?i+(t(e)?\"dni\":\"dní\"):i+\"dňami\";case\"M\":return n||a?\"mesiac\":\"mesiacom\";case\"MM\":return n||a?i+(t(e)?\"mesiace\":\"mesiacov\"):i+\"mesiacmi\";case\"y\":return n||a?\"rok\":\"rokom\";case\"yy\":return n||a?i+(t(e)?\"roky\":\"rokov\"):i+\"rokmi\"}}var r=\"január_február_marec_apríl_máj_jún_júl_august_september_október_november_december\".split(\"_\"),a=\"jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec\".split(\"_\"),i=e.defineLocale(\"sk\",{months:r,monthsShort:a,weekdays:\"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota\".split(\"_\"),weekdaysShort:\"ne_po_ut_st_št_pi_so\".split(\"_\"),weekdaysMin:\"ne_po_ut_st_št_pi_so\".split(\"_\"),longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[dnes o] LT\",nextDay:\"[zajtra o] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v nedeľu o] LT\";case 1:case 2:return\"[v] dddd [o] LT\";case 3:return\"[v stredu o] LT\";case 4:return\"[vo štvrtok o] LT\";case 5:return\"[v piatok o] LT\";case 6:return\"[v sobotu o] LT\"}},lastDay:\"[včera o] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[minulú nedeľu o] LT\";case 1:case 2:return\"[minulý] dddd [o] LT\";case 3:return\"[minulú stredu o] LT\";case 4:case 5:return\"[minulý] dddd [o] LT\";case 6:return\"[minulú sobotu o] LT\"}},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"pred %s\",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a=e+\" \";switch(n){case\"s\":return t||r?\"nekaj sekund\":\"nekaj sekundami\";case\"m\":return t?\"ena minuta\":\"eno minuto\";case\"mm\":return a+=1===e?t?\"minuta\":\"minuto\":2===e?t||r?\"minuti\":\"minutama\":e<5?t||r?\"minute\":\"minutami\":t||r?\"minut\":\"minutami\";case\"h\":return t?\"ena ura\":\"eno uro\";case\"hh\":return a+=1===e?t?\"ura\":\"uro\":2===e?t||r?\"uri\":\"urama\":e<5?t||r?\"ure\":\"urami\":t||r?\"ur\":\"urami\";case\"d\":return t||r?\"en dan\":\"enim dnem\";case\"dd\":return a+=1===e?t||r?\"dan\":\"dnem\":2===e?t||r?\"dni\":\"dnevoma\":t||r?\"dni\":\"dnevi\";case\"M\":return t||r?\"en mesec\":\"enim mesecem\";case\"MM\":return a+=1===e?t||r?\"mesec\":\"mesecem\":2===e?t||r?\"meseca\":\"mesecema\":e<5?t||r?\"mesece\":\"meseci\":t||r?\"mesecev\":\"meseci\";case\"y\":return t||r?\"eno leto\":\"enim letom\";case\"yy\":return a+=1===e?t||r?\"leto\":\"letom\":2===e?t||r?\"leti\":\"letoma\":e<5?t||r?\"leta\":\"leti\":t||r?\"let\":\"leti\"}}var n=e.defineLocale(\"sl\",{months:\"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota\".split(\"_\"),weekdaysShort:\"ned._pon._tor._sre._čet._pet._sob.\".split(\"_\"),weekdaysMin:\"ne_po_to_sr_če_pe_so\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danes ob] LT\",nextDay:\"[jutri ob] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[v] [nedeljo] [ob] LT\";case 3:return\"[v] [sredo] [ob] LT\";case 6:return\"[v] [soboto] [ob] LT\";case 1:case 2:case 4:case 5:return\"[v] dddd [ob] LT\"}},lastDay:\"[včeraj ob] LT\",lastWeek:function(){switch(this.day()){case 0:return\"[prejšnjo] [nedeljo] [ob] LT\";case 3:return\"[prejšnjo] [sredo] [ob] LT\";case 6:return\"[prejšnjo] [soboto] [ob] LT\";case 1:case 2:case 4:case 5:return\"[prejšnji] dddd [ob] LT\"}},sameElse:\"L\"},relativeTime:{future:\"čez %s\",past:\"pred %s\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"sq\",{months:\"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor\".split(\"_\"),monthsShort:\"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj\".split(\"_\"),weekdays:\"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë\".split(\"_\"),weekdaysShort:\"Die_Hën_Mar_Mër_Enj_Pre_Sht\".split(\"_\"),weekdaysMin:\"D_H_Ma_Më_E_P_Sh\".split(\"_\"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return\"M\"===e.charAt(0)},meridiem:function(e,t,n){return e<12?\"PD\":\"MD\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Sot në] LT\",nextDay:\"[Nesër në] LT\",nextWeek:\"dddd [në] LT\",lastDay:\"[Dje në] LT\",lastWeek:\"dddd [e kaluar në] LT\",sameElse:\"L\"},relativeTime:{future:\"në %s\",past:\"%s më parë\",s:\"disa sekonda\",m:\"një minutë\",mm:\"%d minuta\",h:\"një orë\",hh:\"%d orë\",d:\"një ditë\",dd:\"%d ditë\",M:\"një muaj\",MM:\"%d muaj\",y:\"një vit\",yy:\"%d vite\"},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={words:{m:[\"jedan minut\",\"jedne minute\"],mm:[\"minut\",\"minute\",\"minuta\"],h:[\"jedan sat\",\"jednog sata\"],hh:[\"sat\",\"sata\",\"sati\"],dd:[\"dan\",\"dana\",\"dana\"],MM:[\"mesec\",\"meseca\",\"meseci\"],yy:[\"godina\",\"godine\",\"godina\"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var a=t.words[r];return 1===r.length?n?a[0]:a[1]:e+\" \"+t.correctGrammaticalCase(e,a)}},n=e.defineLocale(\"sr\",{months:\"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar\".split(\"_\"),monthsShort:\"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.\".split(\"_\"),monthsParseExact:!0,weekdays:\"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota\".split(\"_\"),weekdaysShort:\"ned._pon._uto._sre._čet._pet._sub.\".split(\"_\"),weekdaysMin:\"ne_po_ut_sr_če_pe_su\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[danas u] LT\",nextDay:\"[sutra u] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[u] [nedelju] [u] LT\";case 3:return\"[u] [sredu] [u] LT\";case 6:return\"[u] [subotu] [u] LT\";case 1:case 2:case 4:case 5:return\"[u] dddd [u] LT\"}},lastDay:\"[juče u] LT\",lastWeek:function(){var e=[\"[prošle] [nedelje] [u] LT\",\"[prošlog] [ponedeljka] [u] LT\",\"[prošlog] [utorka] [u] LT\",\"[prošle] [srede] [u] LT\",\"[prošlog] [četvrtka] [u] LT\",\"[prošlog] [petka] [u] LT\",\"[prošle] [subote] [u] LT\"];return e[this.day()]},sameElse:\"L\"},relativeTime:{future:\"za %s\",past:\"pre %s\",s:\"nekoliko sekundi\",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:\"dan\",dd:t.translate,M:\"mesec\",MM:t.translate,y:\"godinu\",yy:t.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,\ndoy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={words:{m:[\"један минут\",\"једне минуте\"],mm:[\"минут\",\"минуте\",\"минута\"],h:[\"један сат\",\"једног сата\"],hh:[\"сат\",\"сата\",\"сати\"],dd:[\"дан\",\"дана\",\"дана\"],MM:[\"месец\",\"месеца\",\"месеци\"],yy:[\"година\",\"године\",\"година\"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var a=t.words[r];return 1===r.length?n?a[0]:a[1]:e+\" \"+t.correctGrammaticalCase(e,a)}},n=e.defineLocale(\"sr-cyrl\",{months:\"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар\".split(\"_\"),monthsShort:\"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.\".split(\"_\"),monthsParseExact:!0,weekdays:\"недеља_понедељак_уторак_среда_четвртак_петак_субота\".split(\"_\"),weekdaysShort:\"нед._пон._уто._сре._чет._пет._суб.\".split(\"_\"),weekdaysMin:\"не_по_ут_ср_че_пе_су\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM YYYY\",LLL:\"D. MMMM YYYY H:mm\",LLLL:\"dddd, D. MMMM YYYY H:mm\"},calendar:{sameDay:\"[данас у] LT\",nextDay:\"[сутра у] LT\",nextWeek:function(){switch(this.day()){case 0:return\"[у] [недељу] [у] LT\";case 3:return\"[у] [среду] [у] LT\";case 6:return\"[у] [суботу] [у] LT\";case 1:case 2:case 4:case 5:return\"[у] dddd [у] LT\"}},lastDay:\"[јуче у] LT\",lastWeek:function(){var e=[\"[прошле] [недеље] [у] LT\",\"[прошлог] [понедељка] [у] LT\",\"[прошлог] [уторка] [у] LT\",\"[прошле] [среде] [у] LT\",\"[прошлог] [четвртка] [у] LT\",\"[прошлог] [петка] [у] LT\",\"[прошле] [суботе] [у] LT\"];return e[this.day()]},sameElse:\"L\"},relativeTime:{future:\"за %s\",past:\"пре %s\",s:\"неколико секунди\",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:\"дан\",dd:t.translate,M:\"месец\",MM:t.translate,y:\"годину\",yy:t.translate},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"ss\",{months:\"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni\".split(\"_\"),monthsShort:\"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo\".split(\"_\"),weekdays:\"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo\".split(\"_\"),weekdaysShort:\"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg\".split(\"_\"),weekdaysMin:\"Li_Us_Lb_Lt_Ls_Lh_Ug\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Namuhla nga] LT\",nextDay:\"[Kusasa nga] LT\",nextWeek:\"dddd [nga] LT\",lastDay:\"[Itolo nga] LT\",lastWeek:\"dddd [leliphelile] [nga] LT\",sameElse:\"L\"},relativeTime:{future:\"nga %s\",past:\"wenteka nga %s\",s:\"emizuzwana lomcane\",m:\"umzuzu\",mm:\"%d emizuzu\",h:\"lihora\",hh:\"%d emahora\",d:\"lilanga\",dd:\"%d emalanga\",M:\"inyanga\",MM:\"%d tinyanga\",y:\"umnyaka\",yy:\"%d iminyaka\"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,t,n){return e<11?\"ekuseni\":e<15?\"emini\":e<19?\"entsambama\":\"ebusuku\"},meridiemHour:function(e,t){return 12===e&&(e=0),\"ekuseni\"===t?e:\"emini\"===t?e>=11?e:e+12:\"entsambama\"===t||\"ebusuku\"===t?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:\"%d\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"sv\",{months:\"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december\".split(\"_\"),monthsShort:\"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec\".split(\"_\"),weekdays:\"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag\".split(\"_\"),weekdaysShort:\"sön_mån_tis_ons_tor_fre_lör\".split(\"_\"),weekdaysMin:\"sö_må_ti_on_to_fr_lö\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY-MM-DD\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY [kl.] HH:mm\",LLLL:\"dddd D MMMM YYYY [kl.] HH:mm\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd D MMM YYYY HH:mm\"},calendar:{sameDay:\"[Idag] LT\",nextDay:\"[Imorgon] LT\",lastDay:\"[Igår] LT\",nextWeek:\"[På] dddd LT\",lastWeek:\"[I] dddd[s] LT\",sameElse:\"L\"},relativeTime:{future:\"om %s\",past:\"för %s sedan\",s:\"några sekunder\",m:\"en minut\",mm:\"%d minuter\",h:\"en timme\",hh:\"%d timmar\",d:\"en dag\",dd:\"%d dagar\",M:\"en månad\",MM:\"%d månader\",y:\"ett år\",yy:\"%d år\"},dayOfMonthOrdinalParse:/\\d{1,2}(e|a)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"e\":1===t?\"a\":2===t?\"a\":\"e\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"sw\",{months:\"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba\".split(\"_\"),monthsShort:\"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des\".split(\"_\"),weekdays:\"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi\".split(\"_\"),weekdaysShort:\"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos\".split(\"_\"),weekdaysMin:\"J2_J3_J4_J5_Al_Ij_J1\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[leo saa] LT\",nextDay:\"[kesho saa] LT\",nextWeek:\"[wiki ijayo] dddd [saat] LT\",lastDay:\"[jana] LT\",lastWeek:\"[wiki iliyopita] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s baadaye\",past:\"tokea %s\",s:\"hivi punde\",m:\"dakika moja\",mm:\"dakika %d\",h:\"saa limoja\",hh:\"masaa %d\",d:\"siku moja\",dd:\"masiku %d\",M:\"mwezi mmoja\",MM:\"miezi %d\",y:\"mwaka mmoja\",yy:\"miaka %d\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"௧\",2:\"௨\",3:\"௩\",4:\"௪\",5:\"௫\",6:\"௬\",7:\"௭\",8:\"௮\",9:\"௯\",0:\"௦\"},n={\"௧\":\"1\",\"௨\":\"2\",\"௩\":\"3\",\"௪\":\"4\",\"௫\":\"5\",\"௬\":\"6\",\"௭\":\"7\",\"௮\":\"8\",\"௯\":\"9\",\"௦\":\"0\"},r=e.defineLocale(\"ta\",{months:\"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்\".split(\"_\"),monthsShort:\"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்\".split(\"_\"),weekdays:\"ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை\".split(\"_\"),weekdaysShort:\"ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி\".split(\"_\"),weekdaysMin:\"ஞா_தி_செ_பு_வி_வெ_ச\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, HH:mm\",LLLL:\"dddd, D MMMM YYYY, HH:mm\"},calendar:{sameDay:\"[இன்று] LT\",nextDay:\"[நாளை] LT\",nextWeek:\"dddd, LT\",lastDay:\"[நேற்று] LT\",lastWeek:\"[கடந்த வாரம்] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s இல்\",past:\"%s முன்\",s:\"ஒரு சில விநாடிகள்\",m:\"ஒரு நிமிடம்\",mm:\"%d நிமிடங்கள்\",h:\"ஒரு மணி நேரம்\",hh:\"%d மணி நேரம்\",d:\"ஒரு நாள்\",dd:\"%d நாட்கள்\",M:\"ஒரு மாதம்\",MM:\"%d மாதங்கள்\",y:\"ஒரு வருடம்\",yy:\"%d ஆண்டுகள்\"},dayOfMonthOrdinalParse:/\\d{1,2}வது/,ordinal:function(e){return e+\"வது\"},preparse:function(e){return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\\d/g,function(e){return t[e]})},meridiemParse:/யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,meridiem:function(e,t,n){return e<2?\" யாமம்\":e<6?\" வைகறை\":e<10?\" காலை\":e<14?\" நண்பகல்\":e<18?\" எற்பாடு\":e<22?\" மாலை\":\" யாமம்\"},meridiemHour:function(e,t){return 12===e&&(e=0),\"யாமம்\"===t?e<2?e:e+12:\"வைகறை\"===t||\"காலை\"===t?e:\"நண்பகல்\"===t&&e>=10?e:e+12},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"te\",{months:\"జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్\".split(\"_\"),monthsShort:\"జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.\".split(\"_\"),monthsParseExact:!0,weekdays:\"ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం\".split(\"_\"),weekdaysShort:\"ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని\".split(\"_\"),weekdaysMin:\"ఆ_సో_మం_బు_గు_శు_శ\".split(\"_\"),longDateFormat:{LT:\"A h:mm\",LTS:\"A h:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY, A h:mm\",LLLL:\"dddd, D MMMM YYYY, A h:mm\"},calendar:{sameDay:\"[నేడు] LT\",nextDay:\"[రేపు] LT\",nextWeek:\"dddd, LT\",lastDay:\"[నిన్న] LT\",lastWeek:\"[గత] dddd, LT\",sameElse:\"L\"},relativeTime:{future:\"%s లో\",past:\"%s క్రితం\",s:\"కొన్ని క్షణాలు\",m:\"ఒక నిమిషం\",mm:\"%d నిమిషాలు\",h:\"ఒక గంట\",hh:\"%d గంటలు\",d:\"ఒక రోజు\",dd:\"%d రోజులు\",M:\"ఒక నెల\",MM:\"%d నెలలు\",y:\"ఒక సంవత్సరం\",yy:\"%d సంవత్సరాలు\"},dayOfMonthOrdinalParse:/\\d{1,2}వ/,ordinal:\"%dవ\",meridiemParse:/రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,meridiemHour:function(e,t){return 12===e&&(e=0),\"రాత్రి\"===t?e<4?e:e+12:\"ఉదయం\"===t?e:\"మధ్యాహ్నం\"===t?e>=10?e:e+12:\"సాయంత్రం\"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?\"రాత్రి\":e<10?\"ఉదయం\":e<17?\"మధ్యాహ్నం\":e<20?\"సాయంత్రం\":\"రాత్రి\"},week:{dow:0,doy:6}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"tet\",{months:\"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez\".split(\"_\"),weekdays:\"Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu\".split(\"_\"),weekdaysShort:\"Dom_Seg_Ters_Kua_Kint_Sext_Sab\".split(\"_\"),weekdaysMin:\"Do_Seg_Te_Ku_Ki_Sex_Sa\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[Ohin iha] LT\",nextDay:\"[Aban iha] LT\",nextWeek:\"dddd [iha] LT\",lastDay:\"[Horiseik iha] LT\",lastWeek:\"dddd [semana kotuk] [iha] LT\",sameElse:\"L\"},relativeTime:{future:\"iha %s\",past:\"%s liuba\",s:\"minutu balun\",m:\"minutu ida\",mm:\"minutus %d\",h:\"horas ida\",hh:\"horas %d\",d:\"loron ida\",dd:\"loron %d\",M:\"fulan ida\",MM:\"fulan %d\",y:\"tinan ida\",yy:\"tinan %d\"},dayOfMonthOrdinalParse:/\\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"th\",{months:\"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม\".split(\"_\"),monthsShort:\"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.\".split(\"_\"),monthsParseExact:!0,weekdays:\"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์\".split(\"_\"),weekdaysShort:\"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์\".split(\"_\"),weekdaysMin:\"อา._จ._อ._พ._พฤ._ศ._ส.\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"H:mm\",LTS:\"H:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY เวลา H:mm\",LLLL:\"วันddddที่ D MMMM YYYY เวลา H:mm\"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return\"หลังเที่ยง\"===e},meridiem:function(e,t,n){return e<12?\"ก่อนเที่ยง\":\"หลังเที่ยง\"},calendar:{sameDay:\"[วันนี้ เวลา] LT\",nextDay:\"[พรุ่งนี้ เวลา] LT\",nextWeek:\"dddd[หน้า เวลา] LT\",lastDay:\"[เมื่อวานนี้ เวลา] LT\",lastWeek:\"[วัน]dddd[ที่แล้ว เวลา] LT\",sameElse:\"L\"},relativeTime:{future:\"อีก %s\",past:\"%sที่แล้ว\",s:\"ไม่กี่วินาที\",m:\"1 นาที\",mm:\"%d นาที\",h:\"1 ชั่วโมง\",hh:\"%d ชั่วโมง\",d:\"1 วัน\",dd:\"%d วัน\",M:\"1 เดือน\",MM:\"%d เดือน\",y:\"1 ปี\",yy:\"%d ปี\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"tl-ph\",{months:\"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre\".split(\"_\"),monthsShort:\"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis\".split(\"_\"),weekdays:\"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado\".split(\"_\"),weekdaysShort:\"Lin_Lun_Mar_Miy_Huw_Biy_Sab\".split(\"_\"),weekdaysMin:\"Li_Lu_Ma_Mi_Hu_Bi_Sab\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"MM/D/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY HH:mm\",LLLL:\"dddd, MMMM DD, YYYY HH:mm\"},calendar:{sameDay:\"LT [ngayong araw]\",nextDay:\"[Bukas ng] LT\",nextWeek:\"LT [sa susunod na] dddd\",lastDay:\"LT [kahapon]\",lastWeek:\"LT [noong nakaraang] dddd\",sameElse:\"L\"},relativeTime:{future:\"sa loob ng %s\",past:\"%s ang nakalipas\",s:\"ilang segundo\",m:\"isang minuto\",mm:\"%d minuto\",h:\"isang oras\",hh:\"%d oras\",d:\"isang araw\",dd:\"%d araw\",M:\"isang buwan\",MM:\"%d buwan\",y:\"isang taon\",yy:\"%d taon\"},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e){var t=e;return t=e.indexOf(\"jaj\")!==-1?t.slice(0,-3)+\"leS\":e.indexOf(\"jar\")!==-1?t.slice(0,-3)+\"waQ\":e.indexOf(\"DIS\")!==-1?t.slice(0,-3)+\"nem\":t+\" pIq\"}function n(e){var t=e;return t=e.indexOf(\"jaj\")!==-1?t.slice(0,-3)+\"Hu’\":e.indexOf(\"jar\")!==-1?t.slice(0,-3)+\"wen\":e.indexOf(\"DIS\")!==-1?t.slice(0,-3)+\"ben\":t+\" ret\"}function r(e,t,n,r){var i=a(e);switch(n){case\"mm\":return i+\" tup\";case\"hh\":return i+\" rep\";case\"dd\":return i+\" jaj\";case\"MM\":return i+\" jar\";case\"yy\":return i+\" DIS\"}}function a(e){var t=Math.floor(e%1e3/100),n=Math.floor(e%100/10),r=e%10,a=\"\";return t>0&&(a+=i[t]+\"vatlh\"),n>0&&(a+=(\"\"!==a?\" \":\"\")+i[n]+\"maH\"),r>0&&(a+=(\"\"!==a?\" \":\"\")+i[r]),\"\"===a?\"pagh\":a}var i=\"pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut\".split(\"_\"),o=e.defineLocale(\"tlh\",{months:\"tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’\".split(\"_\"),monthsShort:\"jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’\".split(\"_\"),monthsParseExact:!0,weekdays:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),weekdaysShort:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),weekdaysMin:\"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[DaHjaj] LT\",nextDay:\"[wa’leS] LT\",nextWeek:\"LLL\",lastDay:\"[wa’Hu’] LT\",lastWeek:\"LLL\",sameElse:\"L\"},relativeTime:{future:t,past:n,s:\"puS lup\",m:\"wa’ tup\",mm:r,h:\"wa’ rep\",hh:r,d:\"wa’ jaj\",dd:r,M:\"wa’ jar\",MM:r,y:\"wa’ DIS\",yy:r},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t={1:\"'inci\",5:\"'inci\",8:\"'inci\",70:\"'inci\",80:\"'inci\",2:\"'nci\",7:\"'nci\",20:\"'nci\",50:\"'nci\",3:\"'üncü\",4:\"'üncü\",100:\"'üncü\",6:\"'ncı\",9:\"'uncu\",10:\"'uncu\",30:\"'uncu\",60:\"'ıncı\",90:\"'ıncı\"},n=e.defineLocale(\"tr\",{months:\"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık\".split(\"_\"),monthsShort:\"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara\".split(\"_\"),weekdays:\"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi\".split(\"_\"),weekdaysShort:\"Paz_Pts_Sal_Çar_Per_Cum_Cts\".split(\"_\"),weekdaysMin:\"Pz_Pt_Sa_Ça_Pe_Cu_Ct\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[bugün saat] LT\",nextDay:\"[yarın saat] LT\",nextWeek:\"[haftaya] dddd [saat] LT\",lastDay:\"[dün] LT\",lastWeek:\"[geçen hafta] dddd [saat] LT\",sameElse:\"L\"},relativeTime:{future:\"%s sonra\",past:\"%s önce\",s:\"birkaç saniye\",m:\"bir dakika\",mm:\"%d dakika\",h:\"bir saat\",hh:\"%d saat\",d:\"bir gün\",dd:\"%d gün\",M:\"bir ay\",MM:\"%d ay\",y:\"bir yıl\",yy:\"%d yıl\"},dayOfMonthOrdinalParse:/\\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,ordinal:function(e){if(0===e)return e+\"'ıncı\";var n=e%10,r=e%100-n,a=e>=100?100:null;return e+(t[n]||t[r]||t[a])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t,n,r){var a={s:[\"viensas secunds\",\"'iensas secunds\"],m:[\"'n míut\",\"'iens míut\"],mm:[e+\" míuts\",\"\"+e+\" míuts\"],h:[\"'n þora\",\"'iensa þora\"],hh:[e+\" þoras\",\"\"+e+\" þoras\"],d:[\"'n ziua\",\"'iensa ziua\"],dd:[e+\" ziuas\",\"\"+e+\" ziuas\"],M:[\"'n mes\",\"'iens mes\"],MM:[e+\" mesen\",\"\"+e+\" mesen\"],y:[\"'n ar\",\"'iens ar\"],yy:[e+\" ars\",\"\"+e+\" ars\"]};return r?a[n][0]:t?a[n][0]:a[n][1]}var n=e.defineLocale(\"tzl\",{months:\"Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar\".split(\"_\"),monthsShort:\"Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec\".split(\"_\"),weekdays:\"Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi\".split(\"_\"),weekdaysShort:\"Súl_Lún_Mai_Már_Xhú_Vié_Sát\".split(\"_\"),weekdaysMin:\"Sú_Lú_Ma_Má_Xh_Vi_Sá\".split(\"_\"),longDateFormat:{LT:\"HH.mm\",LTS:\"HH.mm.ss\",L:\"DD.MM.YYYY\",LL:\"D. MMMM [dallas] YYYY\",LLL:\"D. MMMM [dallas] YYYY HH.mm\",LLLL:\"dddd, [li] D. MMMM [dallas] YYYY HH.mm\"},meridiemParse:/d\\'o|d\\'a/i,isPM:function(e){return\"d'o\"===e.toLowerCase()},meridiem:function(e,t,n){return e>11?n?\"d'o\":\"D'O\":n?\"d'a\":\"D'A\"},calendar:{sameDay:\"[oxhi à] LT\",nextDay:\"[demà à] LT\",nextWeek:\"dddd [à] LT\",lastDay:\"[ieiri à] LT\",lastWeek:\"[sür el] dddd [lasteu à] LT\",sameElse:\"L\"},relativeTime:{future:\"osprei %s\",past:\"ja%s\",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\\d{1,2}\\./,ordinal:\"%d.\",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"tzm\",{months:\"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ\".split(\"_\"),monthsShort:\"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ\".split(\"_\"),weekdays:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),weekdaysShort:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),weekdaysMin:\"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[ⴰⵙⴷⵅ ⴴ] LT\",nextDay:\"[ⴰⵙⴽⴰ ⴴ] LT\",nextWeek:\"dddd [ⴴ] LT\",lastDay:\"[ⴰⵚⴰⵏⵜ ⴴ] LT\",lastWeek:\"dddd [ⴴ] LT\",sameElse:\"L\"},relativeTime:{future:\"ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s\",past:\"ⵢⴰⵏ %s\",s:\"ⵉⵎⵉⴽ\",m:\"ⵎⵉⵏⵓⴺ\",mm:\"%d ⵎⵉⵏⵓⴺ\",h:\"ⵙⴰⵄⴰ\",hh:\"%d ⵜⴰⵙⵙⴰⵄⵉⵏ\",d:\"ⴰⵙⵙ\",dd:\"%d oⵙⵙⴰⵏ\",M:\"ⴰⵢoⵓⵔ\",MM:\"%d ⵉⵢⵢⵉⵔⵏ\",y:\"ⴰⵙⴳⴰⵙ\",yy:\"%d ⵉⵙⴳⴰⵙⵏ\"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"tzm-latn\",{months:\"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir\".split(\"_\"),monthsShort:\"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir\".split(\"_\"),weekdays:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),weekdaysShort:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),weekdaysMin:\"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[asdkh g] LT\",nextDay:\"[aska g] LT\",nextWeek:\"dddd [g] LT\",lastDay:\"[assant g] LT\",lastWeek:\"dddd [g] LT\",sameElse:\"L\"},relativeTime:{future:\"dadkh s yan %s\",past:\"yan %s\",s:\"imik\",m:\"minuḍ\",mm:\"%d minuḍ\",h:\"saɛa\",hh:\"%d tassaɛin\",d:\"ass\",dd:\"%d ossan\",M:\"ayowr\",MM:\"%d iyyirn\",y:\"asgas\",yy:\"%d isgasn\"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";function t(e,t){var n=e.split(\"_\");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var a={mm:n?\"хвилина_хвилини_хвилин\":\"хвилину_хвилини_хвилин\",hh:n?\"година_години_годин\":\"годину_години_годин\",dd:\"день_дні_днів\",MM:\"місяць_місяці_місяців\",yy:\"рік_роки_років\"};return\"m\"===r?n?\"хвилина\":\"хвилину\":\"h\"===r?n?\"година\":\"годину\":e+\" \"+t(a[r],+e)}function r(e,t){var n={nominative:\"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота\".split(\"_\"),accusative:\"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу\".split(\"_\"),genitive:\"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи\".split(\"_\")};if(!e)return n.nominative;var r=/(\\[[ВвУу]\\]) ?dddd/.test(t)?\"accusative\":/\\[?(?:минулої|наступної)? ?\\] ?dddd/.test(t)?\"genitive\":\"nominative\";return n[r][e.day()]}function a(e){return function(){return e+\"о\"+(11===this.hours()?\"б\":\"\")+\"] LT\"}}var i=e.defineLocale(\"uk\",{months:{format:\"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня\".split(\"_\"),standalone:\"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень\".split(\"_\")},monthsShort:\"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд\".split(\"_\"),weekdays:r,weekdaysShort:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),weekdaysMin:\"нд_пн_вт_ср_чт_пт_сб\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD.MM.YYYY\",LL:\"D MMMM YYYY р.\",LLL:\"D MMMM YYYY р., HH:mm\",LLLL:\"dddd, D MMMM YYYY р., HH:mm\"},calendar:{sameDay:a(\"[Сьогодні \"),nextDay:a(\"[Завтра \"),lastDay:a(\"[Вчора \"),nextWeek:a(\"[У] dddd [\"),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return a(\"[Минулої] dddd [\").call(this);case 1:case 2:case 4:return a(\"[Минулого] dddd [\").call(this)}},sameElse:\"L\"},relativeTime:{future:\"за %s\",past:\"%s тому\",s:\"декілька секунд\",m:n,mm:n,h:\"годину\",hh:n,d:\"день\",dd:n,M:\"місяць\",MM:n,y:\"рік\",yy:n},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,t,n){return e<4?\"ночі\":e<12?\"ранку\":e<17?\"дня\":\"вечора\"},dayOfMonthOrdinalParse:/\\d{1,2}-(й|го)/,ordinal:function(e,t){switch(t){case\"M\":case\"d\":case\"DDD\":case\"w\":case\"W\":return e+\"-й\";case\"D\":return e+\"-го\";default:return e}},week:{dow:1,doy:7}});return i})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=[\"جنوری\",\"فروری\",\"مارچ\",\"اپریل\",\"مئی\",\"جون\",\"جولائی\",\"اگست\",\"ستمبر\",\"اکتوبر\",\"نومبر\",\"دسمبر\"],n=[\"اتوار\",\"پیر\",\"منگل\",\"بدھ\",\"جمعرات\",\"جمعہ\",\"ہفتہ\"],r=e.defineLocale(\"ur\",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd، D MMMM YYYY HH:mm\"},meridiemParse:/صبح|شام/,isPM:function(e){return\"شام\"===e},meridiem:function(e,t,n){return e<12?\"صبح\":\"شام\"},calendar:{sameDay:\"[آج بوقت] LT\",nextDay:\"[کل بوقت] LT\",nextWeek:\"dddd [بوقت] LT\",lastDay:\"[گذشتہ روز بوقت] LT\",lastWeek:\"[گذشتہ] dddd [بوقت] LT\",sameElse:\"L\"},relativeTime:{future:\"%s بعد\",past:\"%s قبل\",s:\"چند سیکنڈ\",m:\"ایک منٹ\",mm:\"%d منٹ\",h:\"ایک گھنٹہ\",hh:\"%d گھنٹے\",d:\"ایک دن\",dd:\"%d دن\",M:\"ایک ماہ\",MM:\"%d ماہ\",y:\"ایک سال\",yy:\"%d سال\"},preparse:function(e){return e.replace(/،/g,\",\")},postformat:function(e){return e.replace(/,/g,\"،\")},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"uz\",{months:\"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр\".split(\"_\"),monthsShort:\"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек\".split(\"_\"),weekdays:\"Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба\".split(\"_\"),weekdaysShort:\"Якш_Душ_Сеш_Чор_Пай_Жум_Шан\".split(\"_\"),weekdaysMin:\"Як_Ду_Се_Чо_Па_Жу_Ша\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"D MMMM YYYY, dddd HH:mm\"},calendar:{sameDay:\"[Бугун соат] LT [да]\",nextDay:\"[Эртага] LT [да]\",nextWeek:\"dddd [куни соат] LT [да]\",lastDay:\"[Кеча соат] LT [да]\",lastWeek:\"[Утган] dddd [куни соат] LT [да]\",sameElse:\"L\"},relativeTime:{future:\"Якин %s ичида\",past:\"Бир неча %s олдин\",s:\"фурсат\",m:\"бир дакика\",mm:\"%d дакика\",h:\"бир соат\",hh:\"%d соат\",d:\"бир кун\",dd:\"%d кун\",M:\"бир ой\",MM:\"%d ой\",y:\"бир йил\",yy:\"%d йил\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"uz-latn\",{months:\"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr\".split(\"_\"),monthsShort:\"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek\".split(\"_\"),weekdays:\"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba\".split(\"_\"),weekdaysShort:\"Yak_Dush_Sesh_Chor_Pay_Jum_Shan\".split(\"_\"),weekdaysMin:\"Ya_Du_Se_Cho_Pa_Ju_Sha\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"D MMMM YYYY, dddd HH:mm\"},calendar:{sameDay:\"[Bugun soat] LT [da]\",nextDay:\"[Ertaga] LT [da]\",nextWeek:\"dddd [kuni soat] LT [da]\",lastDay:\"[Kecha soat] LT [da]\",lastWeek:\"[O'tgan] dddd [kuni soat] LT [da]\",sameElse:\"L\"},relativeTime:{future:\"Yaqin %s ichida\",past:\"Bir necha %s oldin\",s:\"soniya\",m:\"bir daqiqa\",mm:\"%d daqiqa\",h:\"bir soat\",hh:\"%d soat\",d:\"bir kun\",dd:\"%d kun\",M:\"bir oy\",MM:\"%d oy\",y:\"bir yil\",yy:\"%d yil\"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"vi\",{months:\"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12\".split(\"_\"),monthsShort:\"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12\".split(\"_\"),monthsParseExact:!0,weekdays:\"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy\".split(\"_\"),weekdaysShort:\"CN_T2_T3_T4_T5_T6_T7\".split(\"_\"),weekdaysMin:\"CN_T2_T3_T4_T5_T6_T7\".split(\"_\"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,t,n){return e<12?n?\"sa\":\"SA\":n?\"ch\":\"CH\"},longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"DD/MM/YYYY\",LL:\"D MMMM [năm] YYYY\",LLL:\"D MMMM [năm] YYYY HH:mm\",LLLL:\"dddd, D MMMM [năm] YYYY HH:mm\",l:\"DD/M/YYYY\",ll:\"D MMM YYYY\",lll:\"D MMM YYYY HH:mm\",llll:\"ddd, D MMM YYYY HH:mm\"},calendar:{sameDay:\"[Hôm nay lúc] LT\",nextDay:\"[Ngày mai lúc] LT\",nextWeek:\"dddd [tuần tới lúc] LT\",lastDay:\"[Hôm qua lúc] LT\",lastWeek:\"dddd [tuần rồi lúc] LT\",sameElse:\"L\"},relativeTime:{future:\"%s tới\",past:\"%s trước\",s:\"vài giây\",m:\"một phút\",mm:\"%d phút\",h:\"một giờ\",hh:\"%d giờ\",d:\"một ngày\",dd:\"%d ngày\",M:\"một tháng\",MM:\"%d tháng\",y:\"một năm\",yy:\"%d năm\"},dayOfMonthOrdinalParse:/\\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"x-pseudo\",{months:\"J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér\".split(\"_\"),monthsShort:\"J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc\".split(\"_\"),monthsParseExact:!0,weekdays:\"S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý\".split(\"_\"),weekdaysShort:\"S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát\".split(\"_\"),weekdaysMin:\"S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá\".split(\"_\"),weekdaysParseExact:!0,longDateFormat:{LT:\"HH:mm\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY HH:mm\",LLLL:\"dddd, D MMMM YYYY HH:mm\"},calendar:{sameDay:\"[T~ódá~ý át] LT\",nextDay:\"[T~ómó~rró~w át] LT\",nextWeek:\"dddd [át] LT\",lastDay:\"[Ý~ést~érdá~ý át] LT\",lastWeek:\"[L~ást] dddd [át] LT\",sameElse:\"L\"},relativeTime:{future:\"í~ñ %s\",past:\"%s á~gó\",s:\"á ~féw ~sécó~ñds\",m:\"á ~míñ~úté\",mm:\"%d m~íñú~tés\",h:\"á~ñ hó~úr\",hh:\"%d h~óúrs\",d:\"á ~dáý\",dd:\"%d d~áýs\",M:\"á ~móñ~th\",MM:\"%d m~óñt~hs\",y:\"á ~ýéár\",yy:\"%d ý~éárs\"},dayOfMonthOrdinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?\"th\":1===t?\"st\":2===t?\"nd\":3===t?\"rd\":\"th\";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"yo\",{months:\"Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀\".split(\"_\"),monthsShort:\"Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀\".split(\"_\"),weekdays:\"Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta\".split(\"_\"),weekdaysShort:\"Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá\".split(\"_\"),weekdaysMin:\"Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb\".split(\"_\"),longDateFormat:{LT:\"h:mm A\",LTS:\"h:mm:ss A\",L:\"DD/MM/YYYY\",LL:\"D MMMM YYYY\",LLL:\"D MMMM YYYY h:mm A\",LLLL:\"dddd, D MMMM YYYY h:mm A\"},calendar:{sameDay:\"[Ònì ni] LT\",nextDay:\"[Ọ̀la ni] LT\",nextWeek:\"dddd [Ọsẹ̀ tón'bọ] [ni] LT\",lastDay:\"[Àna ni] LT\",lastWeek:\"dddd [Ọsẹ̀ tólọ́] [ni] LT\",sameElse:\"L\"},relativeTime:{future:\"ní %s\",past:\"%s kọjá\",s:\"ìsẹjú aayá die\",m:\"ìsẹjú kan\",mm:\"ìsẹjú %d\",h:\"wákati kan\",hh:\"wákati %d\",d:\"ọjọ́ kan\",dd:\"ọjọ́ %d\",M:\"osù kan\",MM:\"osù %d\",y:\"ọdún kan\",yy:\"ọdún %d\"},dayOfMonthOrdinalParse:/ọjọ́\\s\\d{1,2}/,ordinal:\"ọjọ́ %d\",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"zh-cn\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"周日_周一_周二_周三_周四_周五_周六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日Ah点mm分\",LLLL:\"YYYY年MMMD日ddddAh点mm分\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),\"凌晨\"===t||\"早上\"===t||\"上午\"===t?e:\"下午\"===t||\"晚上\"===t?e+12:e>=11?e:e+12},meridiem:function(e,t,n){var r=100*e+t;return r<600?\"凌晨\":r<900?\"早上\":r<1130?\"上午\":r<1230?\"中午\":r<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|周)/,ordinal:function(e,t){switch(t){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"周\";default:return e}},relativeTime:{future:\"%s内\",past:\"%s前\",s:\"几秒\",m:\"1 分钟\",mm:\"%d 分钟\",h:\"1 小时\",hh:\"%d 小时\",d:\"1 天\",dd:\"%d 天\",M:\"1 个月\",MM:\"%d 个月\",y:\"1 年\",yy:\"%d 年\"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"zh-hk\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"週日_週一_週二_週三_週四_週五_週六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日 HH:mm\",LLLL:\"YYYY年MMMD日dddd HH:mm\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),\"凌晨\"===t||\"早上\"===t||\"上午\"===t?e:\"中午\"===t?e>=11?e:e+12:\"下午\"===t||\"晚上\"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?\"凌晨\":r<900?\"早上\":r<1130?\"上午\":r<1230?\"中午\":r<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"週\";default:return e}},relativeTime:{future:\"%s內\",past:\"%s前\",s:\"幾秒\",m:\"1 分鐘\",mm:\"%d 分鐘\",h:\"1 小時\",hh:\"%d 小時\",d:\"1 天\",dd:\"%d 天\",M:\"1 個月\",MM:\"%d 個月\",y:\"1 年\",yy:\"%d 年\"}});return t})},function(e,t,n){!function(e,t){t(n(58))}(this,function(e){\"use strict\";var t=e.defineLocale(\"zh-tw\",{months:\"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月\".split(\"_\"),monthsShort:\"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月\".split(\"_\"),weekdays:\"星期日_星期一_星期二_星期三_星期四_星期五_星期六\".split(\"_\"),weekdaysShort:\"週日_週一_週二_週三_週四_週五_週六\".split(\"_\"),weekdaysMin:\"日_一_二_三_四_五_六\".split(\"_\"),longDateFormat:{LT:\"HH:mm\",LTS:\"HH:mm:ss\",L:\"YYYY年MMMD日\",LL:\"YYYY年MMMD日\",LLL:\"YYYY年MMMD日 HH:mm\",LLLL:\"YYYY年MMMD日dddd HH:mm\",l:\"YYYY年MMMD日\",ll:\"YYYY年MMMD日\",lll:\"YYYY年MMMD日 HH:mm\",llll:\"YYYY年MMMD日dddd HH:mm\"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),\"凌晨\"===t||\"早上\"===t||\"上午\"===t?e:\"中午\"===t?e>=11?e:e+12:\"下午\"===t||\"晚上\"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?\"凌晨\":r<900?\"早上\":r<1130?\"上午\":r<1230?\"中午\":r<1800?\"下午\":\"晚上\"},calendar:{sameDay:\"[今天]LT\",nextDay:\"[明天]LT\",nextWeek:\"[下]ddddLT\",lastDay:\"[昨天]LT\",lastWeek:\"[上]ddddLT\",sameElse:\"L\"},dayOfMonthOrdinalParse:/\\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case\"d\":case\"D\":case\"DDD\":return e+\"日\";case\"M\":return e+\"月\";case\"w\":case\"W\":return e+\"週\";default:return e}},relativeTime:{future:\"%s內\",past:\"%s前\",s:\"幾秒\",m:\"1 分鐘\",mm:\"%d 分鐘\",h:\"1 小時\",hh:\"%d 小時\",d:\"1 天\",dd:\"%d 天\",M:\"1 個月\",MM:\"%d 個月\",y:\"1 年\",yy:\"%d 年\"}});return t})},function(e,t){e.exports={version:\"2016f\",zones:[\"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5\",\"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5\",\"Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5\",\"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5\",\"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6\",\"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4\",\"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5\",\"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6\",\"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5\",\"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3\",\"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4\",\"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5\",\"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5\",\"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5\",\"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5\",\"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5\",\"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5\",\"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4\",\"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326\",\"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4\",\"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3\",\"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4\",\"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0\",\"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0\",\"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0\",\"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0\",\"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0\",\"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0\",\"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0\",\"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0\",\"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0\",\"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0\",\"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0\",\"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0\",\"America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4\",\"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5\",\"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2\",\"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5\",\"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3\",\"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4\",\"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5\",\"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3\",\"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2\",\"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2\",\"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5\",\"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4\",\"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2\",\"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4\",\"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4\",\"America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5\",\"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3\",\"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5\",\"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5\",\"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4\",\"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5\",\"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2\",\"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4\",\"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8\",\"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2\",\"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3\",\"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5\",\"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5\",\"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5\",\"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3\",\"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5\",\"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOP0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5\",\"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2\",\"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5\",\"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3\",\"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2\",\"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2\",\"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5\",\"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5\",\"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4\",\"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4\",\"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5\",\"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4\",\"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2\",\"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2\",\"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4\",\"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3\",\"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5\",\"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6\",\"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp0 1Vb0 3dB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6\",\"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4\",\"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5\",\"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5\",\"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4\",\"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4\",\"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4\",\"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2\",\"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5\",\"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6\",\"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2\",\"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3\",\"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5\",\"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5\",\"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5\",\"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4\",\"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\",\"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2\",\"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2\",\"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2\",\"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3\",\"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4\",\"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5\",\"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4\",\"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4\",\"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5\",\"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842\",\"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2\",\"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5\",\"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4\",\"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229\",\"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4\",\"America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5\",\"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5\",\"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6\",\"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452\",\"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2\",\"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3\",\"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5\",\"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656\",\"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3\",\"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4\",\"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642\",\"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"Antarctica/Casey|-00 AWST CAST|0 -80 -b0|012121|-2q00 1DjS0 T90 40P0 KL0|10\",\"Antarctica/Davis|-00 DAVT DAVT|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70\",\"Antarctica/DumontDUrville|-00 PMT DDUT|0 -a0 -a0|0102|-U0o0 cfq0 bFm0|80\",\"Antarctica/Macquarie|AEST AEDT -00 MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1\",\"Antarctica/Mawson|-00 MAWT MAWT|0 -60 -50|012|-CEo0 2fyk0|60\",\"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5\",\"Antarctica/Palmer|-00 ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40\",\"Antarctica/Rothera|-00 ROTT|0 30|01|gOo0|130\",\"Antarctica/Syowa|-00 SYOT|0 -30|01|-vs00|20\",\"Antarctica/Troll|-00 UTC CEST|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40\",\"Antarctica/Vostok|-00 VOST|0 -60|01|-tjA0|25\",\"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4\",\"Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5\",\"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5\",\"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5\",\"Asia/Anadyr|LMT ANAT ANAT ANAST ANAST ANAST ANAT|-bN.U -c0 -d0 -e0 -d0 -c0 -b0|01232414141414141414141561414141414141414141414141414141414141561|-1PcbN.U eUnN.U 23CL0 1db0 1cN0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|13e3\",\"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4\",\"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4\",\"Asia/Ashgabat|LMT ASHT ASHT ASHST ASHST TMT TMT|-3R.w -40 -50 -60 -50 -40 -50|012323232323232323232324156|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 ba0 xC0|41e4\",\"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5\",\"Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4\",\"Asia/Baku|LMT BAKT BAKT BAKST BAKST AZST AZT AZT AZST|-3j.o -30 -40 -50 -40 -40 -30 -40 -50|01232323232323232323232456578787878787878787878787878787878787878787|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 10K0 c30 1cM0 1cM0 8wq0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6\",\"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0\",\"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5\",\"Asia/Bishkek|LMT FRUT FRUT FRUST FRUST KGT KGST KGT|-4W.o -50 -60 -70 -60 -50 -60 -60|01232323232323232323232456565656565656565656565656567|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11c0 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 T8u|87e4\",\"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4\",\"Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6\",\"Asia/Chita|LMT YAKT YAKT YAKST YAKST YAKT IRKT|-7x.Q -80 -90 -a0 -90 -a0 -80|0123232323232323232323241232323232323232323232323232323232323232562|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4\",\"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3\",\"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6\",\"Asia/Colombo|MMT IST IHST IST LKT LKT|-5j.w -5u -60 -6u -6u -60|01231451|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5\",\"Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6\",\"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5\",\"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4\",\"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5\",\"Asia/Dushanbe|LMT DUST DUST DUSST DUSST TJT|-4z.c -50 -60 -70 -60 -50|0123232323232323232323245|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 14N0|76e4\",\"Asia/Gaza|EET EET EEST IST IDT|-20 -30 -30 -20 -30|010101010102020202020202020202023434343434343434343434343430202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|18e5\",\"Asia/Hebron|EET EET EEST IST IDT|-20 -30 -30 -20 -30|01010101010202020202020202020202343434343434343434343434343020202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1ny0 1220 1qm0 1220 1ny0 1220 1ny0 1220 1ny0|25e4\",\"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5\",\"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5\",\"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3\",\"Asia/Irkutsk|IMT IRKT IRKT IRKST IRKST IRKT|-6V.5 -70 -80 -90 -80 -90|012323232323232323232324123232323232323232323232323232323232323252|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Europe/Istanbul|IMT EET EEST TRST TRT|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1df0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e6\",\"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6\",\"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4\",\"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4\",\"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5\",\"Asia/Kamchatka|LMT PETT PETT PETST PETST|-ay.A -b0 -c0 -d0 -c0|01232323232323232323232412323232323232323232323232323232323232412|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|18e4\",\"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6\",\"Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5\",\"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5\",\"Asia/Khandyga|LMT YAKT YAKT YAKST YAKST VLAT VLAST VLAT YAKT|-92.d -80 -90 -a0 -90 -a0 -b0 -b0 -a0|01232323232323232323232412323232323232323232323232565656565656565782|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2\",\"Asia/Krasnoyarsk|LMT KRAT KRAT KRAST KRAST KRAT|-6b.q -60 -70 -80 -70 -80|012323232323232323232324123232323232323232323232323232323232323252|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5\",\"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4\",\"Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4\",\"Asia/Magadan|LMT MAGT MAGT MAGST MAGST MAGT|-a3.c -a0 -b0 -c0 -b0 -c0|0123232323232323232323241232323232323232323232323232323232323232512|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3\",\"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5\",\"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6\",\"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4\",\"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4\",\"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5\",\"Asia/Omsk|LMT OMST OMST OMSST OMSST OMST|-4R.u -50 -60 -70 -60 -70|012323232323232323232324123232323232323232323232323232323232323252|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5\",\"Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4\",\"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4\",\"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5\",\"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4\",\"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5\",\"Asia/Sakhalin|LMT JCST JST SAKT SAKST SAKST SAKT|-9u.M -90 -90 -b0 -c0 -b0 -a0|01234343434343434343434356343434343435656565656565656565656565656363|-2AGVu.M 1iaMu.M je00 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o10 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4\",\"Asia/Samarkand|LMT SAMT SAMT SAMST TAST UZST UZT|-4r.R -40 -50 -60 -60 -60 -50|01234323232323232323232356|-1Pc4r.R eUor.R 23CL0 1db0 1cM0 1dc0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11x0 bf0|36e4\",\"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6\",\"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5\",\"Asia/Srednekolymsk|LMT MAGT MAGT MAGST MAGST MAGT SRET|-ae.Q -a0 -b0 -c0 -b0 -c0 -b0|012323232323232323232324123232323232323232323232323232323232323256|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2\",\"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5\",\"Asia/Tashkent|LMT TAST TAST TASST TASST UZST UZT|-4B.b -50 -60 -70 -60 -60 -50|01232323232323232323232456|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 11y0 bf0|23e5\",\"Asia/Tbilisi|TBMT TBIT TBIT TBIST TBIST GEST GET GET GEST|-2X.b -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565787878787878787878567|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 3y0 19f0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cM0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5\",\"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6\",\"Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3\",\"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6\",\"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5\",\"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5\",\"Asia/Ust-Nera|LMT YAKT YAKT MAGST MAGT MAGST MAGT MAGT VLAT VLAT|-9w.S -80 -90 -c0 -b0 -b0 -a0 -c0 -b0 -a0|0123434343434343434343456434343434343434343434343434343434343434789|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2\",\"Asia/Vladivostok|LMT VLAT VLAT VLAST VLAST VLAT|-8L.v -90 -a0 -b0 -a0 -b0|012323232323232323232324123232323232323232323232323232323232323252|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Asia/Yakutsk|LMT YAKT YAKT YAKST YAKST YAKT|-8C.W -80 -90 -a0 -90 -a0|012323232323232323232324123232323232323232323232323232323232323252|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4\",\"Asia/Yekaterinburg|LMT PMT SVET SVET SVEST SVEST YEKT YEKST YEKT|-42.x -3J.5 -40 -50 -60 -50 -50 -60 -60|0123434343434343434343435267676767676767676767676767676767676767686|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5\",\"Asia/Yerevan|LMT YERT YERT YERST YERST AMST AMT AMT AMST|-2W -30 -40 -50 -40 -40 -30 -40 -50|0123232323232323232323245656565657878787878787878787878787878787|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1am0 2r0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fb0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5\",\"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4\",\"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3\",\"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4\",\"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4\",\"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3\",\"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4\",\"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4\",\"Atlantic/South_Georgia|GST|20|0||30\",\"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2\",\"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5\",\"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5\",\"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5\",\"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3\",\"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746\",\"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4\",\"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368\",\"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4\",\"Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347\",\"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10\",\"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5\",\"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5\",\"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00\",\"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2\",\"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00\",\"EST|EST|50|0|\",\"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5\",\"Etc/GMT+0|GMT|0|0|\",\"Etc/GMT+1|GMT+1|10|0|\",\"Etc/GMT+10|GMT+10|a0|0|\",\"Etc/GMT+11|GMT+11|b0|0|\",\"Etc/GMT+12|GMT+12|c0|0|\",\"Etc/GMT+2|GMT+2|20|0|\",\"Etc/GMT+3|GMT+3|30|0|\",\"Etc/GMT+4|GMT+4|40|0|\",\"Etc/GMT+5|GMT+5|50|0|\",\"Etc/GMT+6|GMT+6|60|0|\",\"Etc/GMT+7|GMT+7|70|0|\",\"Etc/GMT+8|GMT+8|80|0|\",\"Etc/GMT+9|GMT+9|90|0|\",\"Etc/GMT-1|GMT-1|-10|0|\",\"Etc/GMT-10|GMT-10|-a0|0|\",\"Etc/GMT-11|GMT-11|-b0|0|\",\"Etc/GMT-12|GMT-12|-c0|0|\",\"Etc/GMT-13|GMT-13|-d0|0|\",\"Etc/GMT-14|GMT-14|-e0|0|\",\"Etc/GMT-2|GMT-2|-20|0|\",\"Etc/GMT-3|GMT-3|-30|0|\",\"Etc/GMT-4|GMT-4|-40|0|\",\"Etc/GMT-5|GMT-5|-50|0|\",\"Etc/GMT-6|GMT-6|-60|0|\",\"Etc/GMT-7|GMT-7|-70|0|\",\"Etc/GMT-8|GMT-8|-80|0|\",\"Etc/GMT-9|GMT-9|-90|0|\",\"Etc/UCT|UCT|0|0|\",\"Etc/UTC|UTC|0|0|\",\"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5\",\"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3\",\"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0\",\"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5\",\"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6\",\"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5\",\"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5\",\"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5\",\"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5\",\"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5\",\"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4\",\"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4\",\"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5\",\"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3\",\"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5\",\"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET FET|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4\",\"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5\",\"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WNi.M qHai.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4\",\"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5\",\"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4\",\"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5\",\"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 1cM0 1cM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1cp0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4\",\"Europe/Minsk|MMT EET MSK CEST CET MSD EEST FET|-1O -20 -30 -20 -10 -40 -30 -30|012343432525252525252525252616161616161616161616161616161616161616172|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hy0|19e5\",\"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3\",\"Europe/Moscow|MMT MMT MST MDST MSD MSK MSM EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c20 imv.j 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6\",\"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6\",\"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4\",\"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 16K0 1iO0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1C10 Lz0 1zd0 On0 1C10 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5\",\"Europe/Samara|LMT SAMT SAMT KUYT KUYST MSD MSK EEST SAMST SAMST|-3k.k -30 -40 -40 -50 -40 -30 -30 -50 -40|012343434343434343435656712828282828282828282828282828282828282912|-22WNk.k qHak.k bcn0 1Qqo0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cN0 8o0 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qN0 WM0|12e5\",\"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4\",\"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5\",\"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5\",\"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4\",\"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4\",\"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WNd.A qHad.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0\",\"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4\",\"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5\",\"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4\",\"Europe/Volgograd|LMT TSAT STAT STAT VOLT VOLST VOLST VOLT MSD MSK MSK|-2V.E -30 -30 -40 -40 -50 -40 -30 -40 -30 -40|0123454545454545454676767489898989898989898989898989898989898989a9|-21IqV.E cLXV.E cEM0 1gqn0 Lco0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4\",\"HST|HST|a0|0|\",\"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2\",\"Indian/Christmas|CXT|-70|0||21e2\",\"Indian/Cocos|CCT|-6u|0||596\",\"Indian/Kerguelen|-00 TFT|0 -50|01|-MG00|130\",\"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3\",\"Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4\",\"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4\",\"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4\",\"Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3\",\"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00\",\"MST|MST|70|0|\",\"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600\",\"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0\",\"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3\",\"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4\",\"Pacific/Chuuk|CHUT|-a0|0||49e3\",\"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3\",\"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1\",\"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483\",\"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4\",\"Pacific/Funafuti|TVT|-c0|0||45e2\",\"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3\",\"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125\",\"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4\",\"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4\",\"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4\",\"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2\",\"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2\",\"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3\",\"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2\",\"Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2\",\"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3\",\"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2\",\"Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4\",\"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3\",\"Pacific/Palau|PWT|-90|0||21e3\",\"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56\",\"Pacific/Pohnpei|PONT|-b0|0||34e3\",\"Pacific/Port_Moresby|PGT|-a0|0||25e4\",\"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3\",\"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4\",\"Pacific/Tarawa|GILT|-c0|0||29e3\",\"Pacific/Tongatapu|TOT TOT TOST|-ck -d0 -e0|01212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0|75e3\",\"Pacific/Wake|WAKT|-c0|0||16e3\",\"Pacific/Wallis|WFT|-c0|0||94\",\"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00\"],\nlinks:[\"Africa/Abidjan|Africa/Bamako\",\"Africa/Abidjan|Africa/Banjul\",\"Africa/Abidjan|Africa/Conakry\",\"Africa/Abidjan|Africa/Dakar\",\"Africa/Abidjan|Africa/Freetown\",\"Africa/Abidjan|Africa/Lome\",\"Africa/Abidjan|Africa/Nouakchott\",\"Africa/Abidjan|Africa/Ouagadougou\",\"Africa/Abidjan|Africa/Sao_Tome\",\"Africa/Abidjan|Africa/Timbuktu\",\"Africa/Abidjan|Atlantic/St_Helena\",\"Africa/Cairo|Egypt\",\"Africa/Johannesburg|Africa/Maseru\",\"Africa/Johannesburg|Africa/Mbabane\",\"Africa/Khartoum|Africa/Juba\",\"Africa/Lagos|Africa/Bangui\",\"Africa/Lagos|Africa/Brazzaville\",\"Africa/Lagos|Africa/Douala\",\"Africa/Lagos|Africa/Kinshasa\",\"Africa/Lagos|Africa/Libreville\",\"Africa/Lagos|Africa/Luanda\",\"Africa/Lagos|Africa/Malabo\",\"Africa/Lagos|Africa/Niamey\",\"Africa/Lagos|Africa/Porto-Novo\",\"Africa/Maputo|Africa/Blantyre\",\"Africa/Maputo|Africa/Bujumbura\",\"Africa/Maputo|Africa/Gaborone\",\"Africa/Maputo|Africa/Harare\",\"Africa/Maputo|Africa/Kigali\",\"Africa/Maputo|Africa/Lubumbashi\",\"Africa/Maputo|Africa/Lusaka\",\"Africa/Nairobi|Africa/Addis_Ababa\",\"Africa/Nairobi|Africa/Asmara\",\"Africa/Nairobi|Africa/Asmera\",\"Africa/Nairobi|Africa/Dar_es_Salaam\",\"Africa/Nairobi|Africa/Djibouti\",\"Africa/Nairobi|Africa/Kampala\",\"Africa/Nairobi|Africa/Mogadishu\",\"Africa/Nairobi|Indian/Antananarivo\",\"Africa/Nairobi|Indian/Comoro\",\"Africa/Nairobi|Indian/Mayotte\",\"Africa/Tripoli|Libya\",\"America/Adak|America/Atka\",\"America/Adak|US/Aleutian\",\"America/Anchorage|US/Alaska\",\"America/Argentina/Buenos_Aires|America/Buenos_Aires\",\"America/Argentina/Catamarca|America/Argentina/ComodRivadavia\",\"America/Argentina/Catamarca|America/Catamarca\",\"America/Argentina/Cordoba|America/Cordoba\",\"America/Argentina/Cordoba|America/Rosario\",\"America/Argentina/Jujuy|America/Jujuy\",\"America/Argentina/Mendoza|America/Mendoza\",\"America/Atikokan|America/Coral_Harbour\",\"America/Chicago|US/Central\",\"America/Curacao|America/Aruba\",\"America/Curacao|America/Kralendijk\",\"America/Curacao|America/Lower_Princes\",\"America/Denver|America/Shiprock\",\"America/Denver|Navajo\",\"America/Denver|US/Mountain\",\"America/Detroit|US/Michigan\",\"America/Edmonton|Canada/Mountain\",\"America/Fort_Wayne|America/Indiana/Indianapolis\",\"America/Fort_Wayne|America/Indianapolis\",\"America/Fort_Wayne|US/East-Indiana\",\"America/Halifax|Canada/Atlantic\",\"America/Havana|Cuba\",\"America/Indiana/Knox|America/Knox_IN\",\"America/Indiana/Knox|US/Indiana-Starke\",\"America/Jamaica|Jamaica\",\"America/Kentucky/Louisville|America/Louisville\",\"America/Los_Angeles|US/Pacific\",\"America/Los_Angeles|US/Pacific-New\",\"America/Manaus|Brazil/West\",\"America/Mazatlan|Mexico/BajaSur\",\"America/Mexico_City|Mexico/General\",\"America/New_York|US/Eastern\",\"America/Noronha|Brazil/DeNoronha\",\"America/Panama|America/Cayman\",\"America/Phoenix|US/Arizona\",\"America/Port_of_Spain|America/Anguilla\",\"America/Port_of_Spain|America/Antigua\",\"America/Port_of_Spain|America/Dominica\",\"America/Port_of_Spain|America/Grenada\",\"America/Port_of_Spain|America/Guadeloupe\",\"America/Port_of_Spain|America/Marigot\",\"America/Port_of_Spain|America/Montserrat\",\"America/Port_of_Spain|America/St_Barthelemy\",\"America/Port_of_Spain|America/St_Kitts\",\"America/Port_of_Spain|America/St_Lucia\",\"America/Port_of_Spain|America/St_Thomas\",\"America/Port_of_Spain|America/St_Vincent\",\"America/Port_of_Spain|America/Tortola\",\"America/Port_of_Spain|America/Virgin\",\"America/Regina|Canada/East-Saskatchewan\",\"America/Regina|Canada/Saskatchewan\",\"America/Rio_Branco|America/Porto_Acre\",\"America/Rio_Branco|Brazil/Acre\",\"America/Santiago|Chile/Continental\",\"America/Sao_Paulo|Brazil/East\",\"America/St_Johns|Canada/Newfoundland\",\"America/Tijuana|America/Ensenada\",\"America/Tijuana|America/Santa_Isabel\",\"America/Tijuana|Mexico/BajaNorte\",\"America/Toronto|America/Montreal\",\"America/Toronto|Canada/Eastern\",\"America/Vancouver|Canada/Pacific\",\"America/Whitehorse|Canada/Yukon\",\"America/Winnipeg|Canada/Central\",\"Asia/Ashgabat|Asia/Ashkhabad\",\"Asia/Bangkok|Asia/Phnom_Penh\",\"Asia/Bangkok|Asia/Vientiane\",\"Asia/Dhaka|Asia/Dacca\",\"Asia/Dubai|Asia/Muscat\",\"Asia/Ho_Chi_Minh|Asia/Saigon\",\"Asia/Hong_Kong|Hongkong\",\"Asia/Jerusalem|Asia/Tel_Aviv\",\"Asia/Jerusalem|Israel\",\"Asia/Kathmandu|Asia/Katmandu\",\"Asia/Kolkata|Asia/Calcutta\",\"Asia/Macau|Asia/Macao\",\"Asia/Makassar|Asia/Ujung_Pandang\",\"Asia/Nicosia|Europe/Nicosia\",\"Asia/Qatar|Asia/Bahrain\",\"Asia/Riyadh|Asia/Aden\",\"Asia/Riyadh|Asia/Kuwait\",\"Asia/Seoul|ROK\",\"Asia/Shanghai|Asia/Chongqing\",\"Asia/Shanghai|Asia/Chungking\",\"Asia/Shanghai|Asia/Harbin\",\"Asia/Shanghai|PRC\",\"Asia/Singapore|Singapore\",\"Asia/Taipei|ROC\",\"Asia/Tehran|Iran\",\"Asia/Thimphu|Asia/Thimbu\",\"Asia/Tokyo|Japan\",\"Asia/Ulaanbaatar|Asia/Ulan_Bator\",\"Asia/Urumqi|Asia/Kashgar\",\"Atlantic/Faroe|Atlantic/Faeroe\",\"Atlantic/Reykjavik|Iceland\",\"Australia/Adelaide|Australia/South\",\"Australia/Brisbane|Australia/Queensland\",\"Australia/Broken_Hill|Australia/Yancowinna\",\"Australia/Darwin|Australia/North\",\"Australia/Hobart|Australia/Tasmania\",\"Australia/Lord_Howe|Australia/LHI\",\"Australia/Melbourne|Australia/Victoria\",\"Australia/Perth|Australia/West\",\"Australia/Sydney|Australia/ACT\",\"Australia/Sydney|Australia/Canberra\",\"Australia/Sydney|Australia/NSW\",\"Etc/GMT+0|Etc/GMT\",\"Etc/GMT+0|Etc/GMT-0\",\"Etc/GMT+0|Etc/GMT0\",\"Etc/GMT+0|Etc/Greenwich\",\"Etc/GMT+0|GMT\",\"Etc/GMT+0|GMT+0\",\"Etc/GMT+0|GMT-0\",\"Etc/GMT+0|GMT0\",\"Etc/GMT+0|Greenwich\",\"Etc/UCT|UCT\",\"Etc/UTC|Etc/Universal\",\"Etc/UTC|Etc/Zulu\",\"Etc/UTC|UTC\",\"Etc/UTC|Universal\",\"Etc/UTC|Zulu\",\"Europe/Belgrade|Europe/Ljubljana\",\"Europe/Belgrade|Europe/Podgorica\",\"Europe/Belgrade|Europe/Sarajevo\",\"Europe/Belgrade|Europe/Skopje\",\"Europe/Belgrade|Europe/Zagreb\",\"Europe/Chisinau|Europe/Tiraspol\",\"Europe/Dublin|Eire\",\"Europe/Helsinki|Europe/Mariehamn\",\"Europe/Istanbul|Asia/Istanbul\",\"Europe/Istanbul|Turkey\",\"Europe/Lisbon|Portugal\",\"Europe/London|Europe/Belfast\",\"Europe/London|Europe/Guernsey\",\"Europe/London|Europe/Isle_of_Man\",\"Europe/London|Europe/Jersey\",\"Europe/London|GB\",\"Europe/London|GB-Eire\",\"Europe/Moscow|W-SU\",\"Europe/Oslo|Arctic/Longyearbyen\",\"Europe/Oslo|Atlantic/Jan_Mayen\",\"Europe/Prague|Europe/Bratislava\",\"Europe/Rome|Europe/San_Marino\",\"Europe/Rome|Europe/Vatican\",\"Europe/Warsaw|Poland\",\"Europe/Zurich|Europe/Busingen\",\"Europe/Zurich|Europe/Vaduz\",\"Pacific/Auckland|Antarctica/McMurdo\",\"Pacific/Auckland|Antarctica/South_Pole\",\"Pacific/Auckland|NZ\",\"Pacific/Chatham|NZ-CHAT\",\"Pacific/Chuuk|Pacific/Truk\",\"Pacific/Chuuk|Pacific/Yap\",\"Pacific/Easter|Chile/EasterIsland\",\"Pacific/Guam|Pacific/Saipan\",\"Pacific/Honolulu|Pacific/Johnston\",\"Pacific/Honolulu|US/Hawaii\",\"Pacific/Kwajalein|Kwajalein\",\"Pacific/Pago_Pago|Pacific/Midway\",\"Pacific/Pago_Pago|Pacific/Samoa\",\"Pacific/Pago_Pago|US/Samoa\",\"Pacific/Pohnpei|Pacific/Ponape\"]}},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e,t,n,r){function a(e){l+=\"L \"+t(e.utc+e.duration)+\",\"+_+\" \"}function i(e){l+=\"M \"+t(e.utc)+\",\"+_+\" \"}var o=r.endAtZero,s=r.flushBottomOffset,u=r.isFilled,d=r.startAtZero,l=\"\",M=n.range()[0],_=M+s,f=e[0],p=t(f.utc),h=c[\"default\"].every(e,function(e){return 0===e.rate})?_:n(f.rate);l+=d||u?\"M \"+p+\",\"+M+\" L \":\"M \",l+=p+\",\"+h+\"\\n    L \"+t(f.utc+f.duration)+\",\"+h+\" \",!u&&f.discontinuousEnd&&a(f),c[\"default\"].each(e.slice(1),function(e){var r=e.rate>0?n(e.rate):_;!u&&e.discontinuousStart&&i(e),l+=\"L \"+t(e.utc)+\",\"+r+\"\\n      L \"+t(e.utc+e.duration)+\",\"+r+\" \",!u&&e.discontinuousEnd&&a(e)});var m=e[e.length-1],b=t(m.utc+m.duration);return l+=\"L \"+b+\",\"+n(m.rate),(o||u)&&(l+=\" L \"+b+\",\"+M),u&&(l+=\" Z\"),l.replace(/\\n/g,\"\").replace(/\\s\\s+/g,\" \")}function i(e,t,n){var r=e[0],i=e[e.length-1],o=[],s=void 0,u=c[\"default\"].uniq(c[\"default\"].reject(c[\"default\"].pluck(e,\"subType\"),function(e){return!c[\"default\"].isString(e)}));if(0===u.length)throw new Error(\"Cannot determine `subType` of basal sequence!\");if(u.length>1)throw new Error(\"A basal sequence may contain only *one* `subType` of basal event.\");s=u[0],c[\"default\"].some(e,function(e){return e.rate>0})&&o.push({d:a(e,t,n,{endAtZero:i.discontinuousEnd,isFilled:!0,startAtZero:r.discontinuousStart}),basalType:s,key:\"basalFill-\"+r.id,renderType:\"fill\",type:\"fill--\"+s});var d=[];return c[\"default\"].each(e,function(e){e.suppressed&&d.push(c[\"default\"].assign({},e.suppressed,c[\"default\"].pick(e,[\"duration\",\"utc\"])))}),c[\"default\"].isEmpty(d)||o.push({d:a(d,t,n,{endAtZero:!1,isFilled:!1,startAtZero:!1}),basalType:s,key:\"basalPathUndelivered-\"+r.id,renderType:\"stroke\",type:\"border--undelivered\"}),o}Object.defineProperty(t,\"__esModule\",{value:!0}),t.calculateBasalPath=a,t.getBasalSequencePaths=i;var o=n(46),c=r(o);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"calculateBasalPath\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/render/basal.js\"),__REACT_HOT_LOADER__.register(i,\"getBasalSequencePaths\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/render/basal.js\"))}()},function(e,t,n){\"use strict\";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t[\"default\"]=e,t}function a(e){return e&&e.__esModule?e:{\"default\":e}}function i(e){var t=e.left,n=e.right,r=e.top,a=e.bottom;return\"\\n    M \"+t+\",\"+a+\"\\n    L \"+t+\",\"+r+\"\\n    L \"+n+\",\"+r+\"\\n    L \"+n+\",\"+a+\" Z\\n  \"}function o(e,t,n,r){var a=e/2,i=t-a,o=t+a;return{left:i,right:o,top:r,bottom:n}}function c(e,t,n,r){var a=r.bolusWidth,c=r.extendedLineThickness,s=r.interruptedLineThickness,d=r.triangleHeight,M=l.getBolusFromInsulinEvent(e),_=[],f=n.range()[0],p=t(M.utc),h=l.isUnderride(e)&&l.getDelivered(e),m=l.isOverride(e)&&l.getDelivered(e);if(l.isInterruptedBolus(e)){var b=n(l.getMaxValue(e)),L=o(a,p,f,b),A=L.left,y=L.right,z=i(L);_.push({d:z,key:\"undelivered-\"+M.id,type:\"undelivered\"});var T=n(l.getProgrammed(e)),g=n(l.getDelivered(e)),v=.5;_.push({d:\"\\n        M \"+(A+v)+\",\"+g+\"\\n        L \"+(A+v)+\",\"+(T+v)+\"\\n        L \"+(y-v)+\",\"+(T+v)+\"\\n        L \"+(y-v)+\",\"+g+\"\\n      \",key:\"programmed-\"+M.id,type:\"programmed\"})}else if(h){var O=n(l.getRecommended(e)),D=i(o(a,p,f,O));_.push({d:D,key:\"underride-\"+e.id,type:\"underride\"})}if(l.getDelivered(e)||l.getProgrammed(e)){var k=n(l.getDelivered(e)),Y=i(o(a,p,f,k));_.push({d:Y,key:\"delivered-\"+M.id,type:\"delivered\"})}if(l.hasExtended(e)){var S=l.getExtended(e),N=4.5*c,w=N/2,W=t(M.utc+l.getMaxDuration(e))-N,q=n(S)+c/2;S>0&&_.push({d:\"\\n          M \"+p+\",\"+(q+c/2)+\"\\n          L \"+p+\",\"+(q-c/2)+\"\\n          L \"+(W+c)+\",\"+(q-c/2)+\"\\n          L \"+(W+c)+\",\"+(q+c/2)+\" Z\\n        \",key:\"extendedPath-\"+M.id,type:\"extendedPath\"});var E=l.isInterruptedBolus(e)&&S>0;if(E){var B=t(M.utc+l.getDuration(e));_.push({d:\"\\n          M \"+B+\",\"+(q+c/2)+\"\\n          L \"+B+\",\"+(q-c/2)+\"\\n          L \"+(W+c)+\",\"+(q-c/2)+\"\\n          L \"+(W+c)+\",\"+(q+c/2)+\" Z\\n        \",key:\"extendedExpectationPath-\"+M.id,type:\"extendedExpectationPath\"});var C=s/2;_.push({d:\"\\n          M \"+B+\",\"+(q-C)+\"\\n          L \"+(B-2*s)+\",\"+(q-C)+\"\\n          L \"+(B-2*s)+\",\"+(q+C)+\"\\n          L \"+B+\",\"+(q+C)+\" Z\\n        \",key:\"extendedInterrupted-\"+M.id,type:\"extendedInterrupted\"})}S>0&&_.push({d:\"\\n          M \"+(W+N)+\",\"+(q-w)+\"\\n          L \"+(W+N)+\",\"+(q+w)+\"\\n          L \"+W+\",\"+q+\" Z\\n        \",key:\"extendedTriangle-\"+M.id,type:\"extendedTriangle\"+(E?\"Interrupted\":\"\")})}if(h){var X=n(l.getProgrammed(e)),R=o(a,p,f,X),H=R.left,x=R.right;_.push({d:\"\\n        M \"+H+\",\"+X+\"\\n        L \"+(H+a/2)+\",\"+(X+d)+\"\\n        L \"+x+\",\"+X+\" Z\\n      \",key:\"underrideTriangle-\"+e.id,type:\"underrideTriangle\"})}if(m){var j=n(l.getRecommended(e)),P=o(a,p,f,j),F=P.left,U=P.right;_.push({d:\"\\n        M \"+F+\",\"+j+\"\\n        L \"+(F+a/2)+\",\"+(j-d)+\"\\n        L \"+U+\",\"+j+\" Z\\n      \",key:\"overrideTriangle-\"+e.id,type:\"overrideTriangle\"})}if(l.isInterruptedBolus(e)){var I=n(l.getDelivered(e)),G=i(o(a,p,I,I+s));_.push({d:G,key:\"interrupted-\"+M.id,type:\"interrupted\"})}var J=u[\"default\"].forEach(_,function(e){var t=e;return t.d=e.d.replace(/\\n/g,\"\").replace(/\\s\\s+/g,\" \"),t});return J}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getBolusEdges=o,t[\"default\"]=c;var s=n(46),u=a(s),d=n(178),l=r(d);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(i,\"formatBolusRectPath\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/render/bolus.js\"),__REACT_HOT_LOADER__.register(o,\"getBolusEdges\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/render/bolus.js\"),__REACT_HOT_LOADER__.register(c,\"getBolusPaths\",\"/Users/clintbeacock/Sites/tidepool/viz/src/modules/render/bolus.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e){return parseFloat((0,g.formatDecimalNumber)(e,3))}function i(e){var t=e;return e.bolus&&(t=e.bolus),t}function o(e){return\"wizard\"!==e.type?NaN:T[\"default\"].get(e,\"carbInput\",null)}function c(e){var t=e;if(\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e),!t.normal&&!t.extended))return NaN;if(null!=t.extended&&null!=t.expectedExtended)return null!=t.normal?a(null!=t.expectedNormal?t.expectedNormal+t.expectedExtended:t.normal+t.expectedExtended):t.expectedExtended;if(null!=t.extended){if(null!=t.normal){if(null!=t.expectedNormal)throw new Error(\"Combo bolus found with a cancelled `normal` portion and non-cancelled `extended`!\");return a(t.normal+t.extended)}return t.extended}return t.expectedNormal||t.normal}function s(e){if(!e.recommended)return NaN;var t=T[\"default\"].get(e,[\"recommended\",\"net\"],null);if(null!==t)return t;var n=0;return n+=T[\"default\"].get(e,[\"recommended\",\"carb\"],0),n+=T[\"default\"].get(e,[\"recommended\",\"correction\"],0),a(n)}function u(e){var t=e;return\"wizard\"!==T[\"default\"].get(e,\"type\")||(t=i(e),t.normal||t.extended)?null!=t.extended?null!=t.normal?a(t.extended+t.normal):t.extended:t.normal:NaN}function d(e){var t=e;return\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e)),T[\"default\"].inRange(t.duration,1/0)?t.duration:NaN}function l(e){var t=i(e);return T[\"default\"].inRange(t.extended,1/0)?t.extended:NaN}function M(e){var t=e;if(\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e)),!t.normal||!t.extended&&!t.expectedExtended)return NaN;var n=t.expectedExtended||t.extended,r=c(t);return(0,g.formatPercentage)(n/r)}function _(e){var t=e;return\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e)),T[\"default\"].inRange(t.duration,1/0)?t.expectedDuration||t.duration:NaN}function f(e){var t=e;if(\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e),!t.normal&&!t.extended))return NaN;var n=c(t),r=s(e)||0;return r>n?r:n}function p(e){var t=e;if(\"wizard\"===T[\"default\"].get(e,\"type\")&&(t=i(e)),!t.normal&&!t.expectedNormal||!t.extended&&!t.expectedExtended)return NaN;var n=t.expectedNormal||t.normal,r=c(t);return(0,g.formatPercentage)(n/r)}function h(e){return T[\"default\"].reduce(e,function(e,t){return e+u(t)},0)}function m(e){return T[\"default\"].reduce(e,function(e,t){var n=o(t);return e+(T[\"default\"].inRange(n,1/0)?n:0)},0)}function b(e){var t=i(e);return Boolean(t.extended||t.expectedExtended)||!1}function L(e){var t=i(e),n=Boolean(null!=t.normal&&t.expectedNormal&&t.normal!==t.expectedNormal),r=Boolean(null!=t.extended&&t.expectedExtended&&t.extended!==t.expectedExtended);return t.normal?t.extended?n||r:n:r}function A(e){return s(e)<c(e)}function y(e){return s(e)>c(e)}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getBolusFromInsulinEvent=i,t.getCarbs=o,t.getProgrammed=c,t.getRecommended=s,t.getDelivered=u,t.getDuration=d,t.getExtended=l,t.getExtendedPercentage=M,t.getMaxDuration=_,t.getMaxValue=f,t.getNormalPercentage=p,t.getTotalBolus=h,t.getTotalCarbs=m,t.hasExtended=b,t.isInterruptedBolus=L,t.isOverride=A,t.isUnderride=y;var z=n(46),T=r(z),g=n(179);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"fixFloatingPoint\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(i,\"getBolusFromInsulinEvent\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(o,\"getCarbs\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(c,\"getProgrammed\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(s,\"getRecommended\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(u,\"getDelivered\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(d,\"getDuration\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(l,\"getExtended\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(M,\"getExtendedPercentage\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(_,\"getMaxDuration\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(f,\"getMaxValue\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(p,\"getNormalPercentage\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(h,\"getTotalBolus\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(m,\"getTotalCarbs\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(b,\"hasExtended\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(L,\"isInterruptedBolus\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(A,\"isOverride\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"),__REACT_HOT_LOADER__.register(y,\"isUnderride\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bolus.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e,t,n){var r=u[\"default\"].get(t,\"bgUnits\",\"\");if(!u[\"default\"].isEmpty(n)){var a=n.low,i=n.high;if(r===M.MMOLL_UNITS&&(a&&(a=(0,l.convertToMmolL)(a)),i&&(i=(0,l.convertToMmolL)(i))),a&&e<a)return M.BG_LOW;if(i&&e>i)return M.BG_HIGH}return r===M.MMOLL_UNITS?(0,d.format)(\".1f\")(e):(0,d.format)(\"d\")(e)}function i(e,t){return null===t||void 0===t?(0,d.format)(\"d\")(e):(0,d.format)(\".\"+t+\"f\")(e)}function o(e){return Number.isNaN(e)?\"--%\":(0,d.format)(\".0%\")(e)}function c(e){return e.replace(/\\.0+$/,\"\")}Object.defineProperty(t,\"__esModule\",{value:!0}),t.formatBgValue=a,t.formatDecimalNumber=i,t.formatPercentage=o,t.removeTrailingZeroes=c;var s=n(46),u=r(s),d=n(53),l=n(180),M=n(181);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"formatBgValue\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js\"),__REACT_HOT_LOADER__.register(i,\"formatDecimalNumber\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js\"),__REACT_HOT_LOADER__.register(o,\"formatPercentage\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js\"),__REACT_HOT_LOADER__.register(c,\"removeTrailingZeroes\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/format.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:\"threeWay\";if(u[\"default\"].isEmpty(e)||!u[\"default\"].isNumber(u[\"default\"].get(e,\"targetLowerBound\"))||!u[\"default\"].isNumber(u[\"default\"].get(e,\"targetUpperBound\")))throw new Error(\"You must provide a `bgBounds` object with a `targetLowerBound` and a `targetUpperBound`!\");if(!u[\"default\"].isNumber(t)||!u[\"default\"].gt(t,0))throw new Error(\"You must provide a positive, numerical blood glucose value to categorize!\");var r=e.veryLowThreshold,a=e.targetLowerBound,i=e.targetUpperBound,o=e.veryHighThreshold;return\"fiveWay\"===n?t<r?\"veryLow\":t>=r&&t<a?\"low\":t>i&&t<=o?\"high\":t>o?\"veryHigh\":\"target\":t<a?\"low\":t>i?\"high\":\"target\"}function i(e,t){var n={},r=u[\"default\"].groupBy(e,function(e){return a(t,e.value,\"fiveWay\")});return u[\"default\"].each([\"veryLow\",\"low\",\"target\",\"high\",\"veryHigh\"],function(t){n[t]=(r[t]&&r[t].length||0)/e.length}),n}function o(e){return e/18.01559}function c(e){var t=e.bgClasses,n={veryHighThreshold:t.high.boundary,targetUpperBound:t.target.boundary,targetLowerBound:t.low.boundary,veryLowThreshold:t[\"very-low\"].boundary};return n}Object.defineProperty(t,\"__esModule\",{value:!0}),t.classifyBgValue=a,t.calcBgPercentInCategories=i,t.convertToMmolL=o,t.reshapeBgClassesToBgBounds=c;var s=n(46),u=r(s);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"classifyBgValue\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js\"),__REACT_HOT_LOADER__.register(i,\"calcBgPercentInCategories\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js\"),__REACT_HOT_LOADER__.register(o,\"convertToMmolL\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js\"),__REACT_HOT_LOADER__.register(c,\"reshapeBgClassesToBgBounds\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/bloodglucose.js\"))}()},function(e,t){\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0});var n=t.BG_HIGH=\"High\",r=t.BG_LOW=\"Low\",a=180,i=40,o=.1,c=t.springConfig={stiffness:a,damping:i,precision:o},s=t.MGDL_CLAMP_TOP=400,u=t.MMOLL_CLAMP_TOP=22.5,d=t.MGDL_UNITS=\"mg/dL\",l=t.MMOLL_UNITS=\"mmol/L\",M=7,_=14,f=28,p=t.trends={extentSizes:{ONE_WEEK:M,TWO_WEEKS:_,FOUR_WEEKS:f}};!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(n,\"BG_HIGH\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(r,\"BG_LOW\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(a,\"STIFFNESS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(i,\"DAMPING\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(o,\"PRECISION\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(c,\"springConfig\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(s,\"MGDL_CLAMP_TOP\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(u,\"MMOLL_CLAMP_TOP\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(d,\"MGDL_UNITS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(l,\"MMOLL_UNITS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(M,\"ONE_WEEK\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(_,\"TWO_WEEKS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(f,\"FOUR_WEEKS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"),__REACT_HOT_LOADER__.register(p,\"trends\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/constants.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e){for(var t=[],n=e[0],r=[e[0]],a=1;a<=e.length-1;){var i=e[a],o=i.subType!==n.subType;(o||n.discontinuousEnd||0===i.rate)&&(t.push(r),r=[]),r.push(i),n=i,++a}return t.push(r),t}function i(e){return c[\"default\"].reduce(e,function(e,t){return e+t.rate*(t.duration/s.ONE_HR)},0)}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getBasalSequences=a,t.getTotalBasal=i;var o=n(46),c=r(o),s=n(183);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"getBasalSequences\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/basal.js\"),__REACT_HOT_LOADER__.register(i,\"getTotalBasal\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/basal.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e){var t=e.timezoneAware,n=e.timezoneName,r=\"UTC\";return t&&(r=n||\"UTC\"),r}function i(e){var t=f[\"default\"].get(e,[\"profile\",\"patient\",\"birthday\"],\"\");return t?(0,p.utcFormat)(\"%b %-d, %Y\")(Date.parse(t)):\"\"}function o(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:\"h:mm a\";if(f[\"default\"].isNull(e)||f[\"default\"].isUndefined(e)||e<0||e>y||e instanceof Date)throw new Error(\"First argument must be a value in milliseconds per twenty-four hour day!\");return m[\"default\"].utc(e).format(t)}function c(){return(0,p.timeFormat)(\"%b %-d, %Y\")(new Date)}function s(e){var t=f[\"default\"].get(e,[\"profile\",\"patient\",\"diagnosisDate\"],\"\");return t?(0,p.utcFormat)(\"%b %-d, %Y\")(Date.parse(t)):\"\"}function u(e){var t=m[\"default\"].duration(e),n=\"¼\",r=\"⅓\",a=\"½\",i=\"⅔\",o=\"¾\",c=t.hours(),s=t.minutes();if(0===c)return s+\" min\";var u=1===c?\"hr\":\"hrs\";switch(s){case 0:return c+\" \"+u;case 15:return\"\"+c+n+\" \"+u;case 20:return\"\"+c+r+\" \"+u;case 30:return\"\"+c+a+\" \"+u;case 40:return\"\"+c+i+\" \"+u;case 45:return\"\"+c+o+\" \"+u;default:return c+\" \"+u+\" \"+s+\" min\"}}function d(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:\"dddd, MMMM D\";if(e instanceof Date)throw new Error(\"`utc` must be a ISO-formatted String timestamp or integer hammertime!\");var r=a(t);return m[\"default\"].utc(e).tz(r).format(n)}function l(e,t){var n=void 0;if(n=t.timezoneAware?f[\"default\"].isUndefined(e.time)?null:Date.parse(e.time):f[\"default\"].isUndefined(e.deviceTime)?null:Date.parse(e.deviceTime),f[\"default\"].isNaN(n))throw new Error(\"Check your input datum; could not parse `time` or `deviceTime` with Date.parse.\");return n}function M(e,t){if(e instanceof Date)throw new Error(\"`utc` must be a ISO-formatted String timestamp or integer hammertime!\");var n=a(t),r=m[\"default\"].utc(e).tz(n).startOf(\"day\"),i=\"string\"==typeof e?Date.parse(e):e;return r.valueOf()===i?r.toDate():r.add(1,\"day\").toDate()}Object.defineProperty(t,\"__esModule\",{value:!0}),t.TWENTY_FOUR_HRS=t.THREE_HRS=t.ONE_HR=t.THIRTY_MINS=void 0,t.getTimezoneFromTimePrefs=a,t.formatBirthdate=i,t.formatClocktimeFromMsPer24=o,t.formatCurrentDate=c,t.formatDiagnosisDate=s,t.formatDuration=u,t.formatLocalizedFromUTC=d,t.getHammertimeFromDatumWithTimePrefs=l,t.getLocalizedCeiling=M;var _=n(46),f=r(_),p=n(55),h=n(56),m=r(h),b=t.THIRTY_MINS=18e5,L=t.ONE_HR=36e5,A=t.THREE_HRS=108e5,y=t.TWENTY_FOUR_HRS=864e5;!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(b,\"THIRTY_MINS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(L,\"ONE_HR\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(A,\"THREE_HRS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(y,\"TWENTY_FOUR_HRS\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(a,\"getTimezoneFromTimePrefs\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(i,\"formatBirthdate\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(o,\"formatClocktimeFromMsPer24\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(c,\"formatCurrentDate\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(s,\"formatDiagnosisDate\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(u,\"formatDuration\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(d,\"formatLocalizedFromUTC\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(l,\"getHammertimeFromDatumWithTimePrefs\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"),__REACT_HOT_LOADER__.register(M,\"getLocalizedCeiling\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/datetime.js\"))}()},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e){var t=o[\"default\"].get(e,[\"profile\"],{}),n=t.patient||{};return n.isOtherPerson?n.fullName:t.fullName}Object.defineProperty(t,\"__esModule\",{value:!0}),t.getPatientFullName=a;var i=n(46),o=r(i);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&__REACT_HOT_LOADER__.register(a,\"getPatientFullName\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/misc.js\")}()},function(e,t){e.exports=\"data:image/png;base64,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\";\n},function(e,t,n){\"use strict\";function r(e){return e&&e.__esModule?e:{\"default\":e}}function a(e){return u[\"default\"].assign({},u[\"default\"].omit(e,[\"annotations\",\"clockDriftOffset\",\"conversionOffset\",\"createdUserId\",\"deviceId\",\"deviceSerialNumber\",\"deviceTime\",\"displayOffset\",\"guid\",\"localDayOfWeek\",\"localDate\",\"modifiedUserId\",\"normalEnd\",\"normalTime\",\"payload\",\"scheduleName\",\"source\",\"time\",\"timezoneOffset\",\"units\",\"uploadId\"]))}function i(e,t){return function(n){return n.normalTime&&n.normalEnd?n.normalTime===e||(n.normalTime<e&&n.normalEnd>e&&n.normalEnd<=t||n.normalTime>e&&n.normalTime<t):n.normalTime>=e&&n.normalTime<t}}function o(e,t){return function(n){return n.normalTime>=e&&n.normalTime<t}}function c(e,t,n,r){for(var c=(0,f.getTimezoneFromTimePrefs)(r),s=(0,f.getLocalizedCeiling)(e,r),d=void 0,p=[s.toISOString()],h=s,m=0;m<n;++m){var b=l[\"default\"].utc(h).tz(c).subtract(1,\"day\").toDate();p.push(b.toISOString()),h=b}p.reverse();for(var L={dataByDate:{}},A=L.dataByDate,y=function(e){var r=p[e],s=p[e+1],M=l[\"default\"].utc(Date.parse(r)).tz(c).format(\"YYYY-MM-DD\");L.dataByDate[M]={bounds:[Date.parse(r),Date.parse(s)],date:M,data:u[\"default\"].mapValues(t,function(e){if(u[\"default\"].isEmpty(e))return[];var t=u[\"default\"].includes([\"basal\",\"bolus\"],e[0].type)?i(r,s):o(r,s);return u[\"default\"].sortBy(u[\"default\"].map(u[\"default\"].filter(e,t),function(e){var t=a(e);return t.suppressed&&(t.suppressed=a(t.suppressed)),t.utc=Date.parse(e.normalTime),t}),\"utc\")})},e===n-1&&(d=M)},z=0;z<n;++z)y(z);var T=u[\"default\"].reduce(A,function(e,t){return e.concat(u[\"default\"].get(t,[\"data\",\"cbg\"],[])).concat(u[\"default\"].get(t,[\"data\",\"smbg\"],[]))},[]);L.bgRange=(0,M.extent)(T,function(e){return e.value});var g=u[\"default\"].reduce(A,function(e,t){return e.concat(u[\"default\"].get(t,[\"data\",\"bolus\"],[]))},[]);u[\"default\"].each(g,function(e){e.threeHrBin=3*Math.floor(l[\"default\"].utc(e.utc).tz(c).hours()/3)}),L.bolusRange=(0,M.extent)(g,function(e){return e.normal+(e.extended||0)}),u[\"default\"].each(A,function(e){var t=e.data.bolus;A[e.date].data.bolus=u[\"default\"].map(t,function(e){if(e.wizard){var t=a(e.wizard);return t.bolus=u[\"default\"].omit(e,\"wizard\"),t}return e})});var v=u[\"default\"].reduce(A,function(e,t){return e.concat(u[\"default\"].get(t,[\"data\",\"basal\"],[]))},[]),O=(0,M.extent)(v,function(e){return u[\"default\"].max([u[\"default\"].get(e,[\"suppressed\",\"rate\"],0),e.rate])});return L.basalRange=[0,1.1*O[1]],u[\"default\"].each(L.dataByDate,function(e){for(var t=e.bounds,n=e.data.basal,r=0;r<n.length;++r){var a=n[r];a.utc<t[0]&&(a.duration=a.duration-(t[0]-a.utc),a.utc=t[0]),r===n.length-1&&e.date!==d&&(a.duration=t[1]-a.utc);var i=void 0;a.subType=a.deliveryType,delete a.deliveryType,r!==n.length-1&&(i=n[r+1],a.utc+a.duration!==i.utc&&(a.discontinuousEnd=!0,i.discontinuousStart=!0))}e.data.basalSequences=(0,_.getBasalSequences)(n)}),L}Object.defineProperty(t,\"__esModule\",{value:!0}),t.stripDatum=a,t.filterWithDurationFnMaker=i,t.filterPointInTimeFnMaker=o,t.selectDailyViewData=c;var s=n(46),u=r(s),d=n(56),l=r(d),M=n(48),_=n(182),f=n(183);!function(){\"undefined\"!=typeof __REACT_HOT_LOADER__&&(__REACT_HOT_LOADER__.register(a,\"stripDatum\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js\"),__REACT_HOT_LOADER__.register(i,\"filterWithDurationFnMaker\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js\"),__REACT_HOT_LOADER__.register(o,\"filterPointInTimeFnMaker\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js\"),__REACT_HOT_LOADER__.register(c,\"selectDailyViewData\",\"/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js\"))}()}]);\n//# sourceMappingURL=c047da7e2e505f5ff6b5.worker.js.map", __webpack_require__.p + "c047da7e2e505f5ff6b5.worker.js");
	};

/***/ },
/* 174 */
/***/ function(module, exports) {

	// http://stackoverflow.com/questions/10343913/how-to-create-a-web-worker-from-a-string
	
	var URL = window.URL || window.webkitURL;
	module.exports = function(content, url) {
	  try {
	    try {
	      var blob;
	      try { // BlobBuilder = Deprecated, but widely implemented
	        var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	        blob = new BlobBuilder();
	        blob.append(content);
	        blob = blob.getBlob();
	      } catch(e) { // The proposed API
	        blob = new Blob([content]);
	      }
	      return new Worker(URL.createObjectURL(blob));
	    } catch(e) {
	      return new Worker('data:application/javascript,' + encodeURIComponent(content));
	    }
	  } catch(e) {
	    if (!url) {
	      throw Error('Inline worker is not supported');
	    }
	    return new Worker(url);
	  }
	}


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripDatum = stripDatum;
	exports.filterWithDurationFnMaker = filterWithDurationFnMaker;
	exports.filterPointInTimeFnMaker = filterPointInTimeFnMaker;
	exports.selectDailyViewData = selectDailyViewData;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(21);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _d3Array = __webpack_require__(26);
	
	var _basal = __webpack_require__(176);
	
	var _datetime = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * stripDatum
	 * @param {Object} d - a Tidepool datum
	 *
	 * @return {Object} Tidepool datum stripped of all fields not needed client-side
	 */
	function stripDatum(d) {
	  return _lodash2.default.assign({}, _lodash2.default.omit(d, ['annotations', 'clockDriftOffset', 'conversionOffset', 'createdUserId', 'deviceId', 'deviceSerialNumber', 'deviceTime', 'displayOffset', 'guid', 'localDayOfWeek', 'localDate', 'modifiedUserId', 'normalEnd', 'normalTime', 'payload', 'scheduleName', 'source', 'time', 'timezoneOffset', 'units', 'uploadId']));
	}
	
	/**
	 * filterWithDurationFnMaker
	 *
	 * @param {String} dateStart - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {String} dateEnd - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 *
	 * @returns {Function} Function that recieves a Tidepool datum with an extended duration
	 *                     to determine if it falls into the given range
	 */
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function filterWithDurationFnMaker(dateStart, dateEnd) {
	  return function (d) {
	    if (d.normalTime && d.normalEnd) {
	      if (d.normalTime === dateStart) {
	        return true;
	      } else if (d.normalTime < dateStart && d.normalEnd > dateStart && d.normalEnd <= dateEnd) {
	        return true;
	      } else if (d.normalTime > dateStart && d.normalTime < dateEnd) {
	        return true;
	      }
	      return false;
	    }
	    return d.normalTime >= dateStart && d.normalTime < dateEnd;
	  };
	}
	
	/**
	 * filterPointInTimeFnMaker
	 *
	 * @param {String} dateStart - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {String} dateEnd - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 *
	 * @returns {Function} Function that recieves a Tidepool datum to determine if it falls into
	 *                     the given range
	 */
	function filterPointInTimeFnMaker(dateStart, dateEnd) {
	  return function (d) {
	    return d.normalTime >= dateStart && d.normalTime < dateEnd;
	  };
	}
	
	/**
	 * selectDailyViewData
	 * @param {String} mostRecent - an ISO 8601-formatted timestamp of the most recent diabetes datum
	 * @param {Array} groupedData - Object of tideline-preprocessed Tidepool diabetes data & notes;
	 *                              grouped by type
	 * @param {Number} numDays - number of days of data to select
	 * @param {Object} timePrefs - object containing timezoneAware Boolean, timezoneName String or null
	 *
	 * @return {Object} selected data for daily print view
	 */
	function selectDailyViewData(mostRecent, groupedData, numDays, timePrefs) {
	  var timezone = (0, _datetime.getTimezoneFromTimePrefs)(timePrefs);
	  var end = (0, _datetime.getLocalizedCeiling)(mostRecent, timePrefs);
	  var lastDate = void 0;
	
	  var dateBoundaries = [end.toISOString()];
	  var last = end;
	  for (var i = 0; i < numDays; ++i) {
	    var startOfDate = _momentTimezone2.default.utc(last).tz(timezone).subtract(1, 'day').toDate();
	    dateBoundaries.push(startOfDate.toISOString());
	    last = startOfDate;
	  }
	  dateBoundaries.reverse();
	
	  var selected = { dataByDate: {} };
	  var selectedDataByDate = selected.dataByDate;
	
	  var _loop = function _loop(_i) {
	    var thisDateStart = dateBoundaries[_i];
	    var thisDateEnd = dateBoundaries[_i + 1];
	    var date = _momentTimezone2.default.utc(Date.parse(thisDateStart)).tz(timezone).format('YYYY-MM-DD');
	    selected.dataByDate[date] = {
	      bounds: [Date.parse(thisDateStart), Date.parse(thisDateEnd)],
	      date: date,
	      data: _lodash2.default.mapValues(groupedData, function (dataForType) {
	        if (_lodash2.default.isEmpty(dataForType)) {
	          return [];
	        }
	        var filterFn = _lodash2.default.includes(['basal', 'bolus'], dataForType[0].type) ? filterWithDurationFnMaker(thisDateStart, thisDateEnd) : filterPointInTimeFnMaker(thisDateStart, thisDateEnd);
	        return _lodash2.default.sortBy(_lodash2.default.map(_lodash2.default.filter(dataForType, filterFn), function (d) {
	          var reshaped = stripDatum(d);
	          if (reshaped.suppressed) {
	            reshaped.suppressed = stripDatum(reshaped.suppressed);
	          }
	          reshaped.utc = Date.parse(d.normalTime);
	          return reshaped;
	        }), 'utc');
	      })
	    };
	
	    if (_i === numDays - 1) {
	      lastDate = date;
	    }
	    // TODO: select out infusion site changes, calibrations from deviceEvent array
	    // (NB: deviceEvent not being passed through via blip yet!!)
	  };
	
	  for (var _i = 0; _i < numDays; ++_i) {
	    _loop(_i);
	  }
	
	  // TODO: properly factor out into own utility? API needs thinking about
	  var bgs = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'cbg'], [])).concat(_lodash2.default.get(date, ['data', 'smbg'], []));
	  }, []);
	  selected.bgRange = (0, _d3Array.extent)(bgs, function (d) {
	    return d.value;
	  });
	
	  var boluses = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'bolus'], []));
	  }, []);
	  _lodash2.default.each(boluses, function (bolus) {
	    // eslint-disable-next-line no-param-reassign
	    bolus.threeHrBin = Math.floor(_momentTimezone2.default.utc(bolus.utc).tz(timezone).hours() / 3) * 3;
	  });
	  selected.bolusRange = (0, _d3Array.extent)(boluses, function (d) {
	    return d.normal + (d.extended || 0);
	  });
	
	  _lodash2.default.each(selectedDataByDate, function (dateObj) {
	    var bolusesForDate = dateObj.data.bolus;
	
	    selectedDataByDate[dateObj.date].data.bolus = _lodash2.default.map(bolusesForDate, function (bolus) {
	      if (bolus.wizard) {
	        var reversed = stripDatum(bolus.wizard);
	        reversed.bolus = _lodash2.default.omit(bolus, 'wizard');
	        return reversed;
	      }
	      return bolus;
	    });
	  });
	
	  var allBasals = _lodash2.default.reduce(selectedDataByDate, function (all, date) {
	    return all.concat(_lodash2.default.get(date, ['data', 'basal'], []));
	  }, []);
	  var rawBasalRange = (0, _d3Array.extent)(allBasals, function (d) {
	    return _lodash2.default.max([_lodash2.default.get(d, ['suppressed', 'rate'], 0), d.rate]);
	  });
	  // multiply the max rate by 1.1 to add a little buffer so the highest basals
	  // don't sit at the very top of the basal rendering area and bump into boluses
	  selected.basalRange = [0, rawBasalRange[1] * 1.1];
	
	  _lodash2.default.each(selected.dataByDate, function (dateData) {
	    var bounds = dateData.bounds,
	        basals = dateData.data.basal;
	
	    for (var _i2 = 0; _i2 < basals.length; ++_i2) {
	      var basal = basals[_i2];
	      // trim the first and last basals to fit within the date's bounds
	      if (basal.utc < bounds[0]) {
	        basal.duration = basal.duration - (bounds[0] - basal.utc);
	        basal.utc = bounds[0];
	      }
	      if (_i2 === basals.length - 1 && dateData.date !== lastDate) {
	        basal.duration = bounds[1] - basal.utc;
	      }
	      var nextBasal = void 0;
	      basal.subType = basal.deliveryType;
	      delete basal.deliveryType;
	      if (_i2 !== basals.length - 1) {
	        nextBasal = basals[_i2 + 1];
	        if (basal.utc + basal.duration !== nextBasal.utc) {
	          basal.discontinuousEnd = true;
	          nextBasal.discontinuousStart = true;
	        }
	      }
	    }
	    // eslint-disable-next-line no-param-reassign
	    dateData.data.basalSequences = (0, _basal.getBasalSequences)(basals);
	  });
	
	  return selected;
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(stripDatum, 'stripDatum', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(filterWithDurationFnMaker, 'filterWithDurationFnMaker', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(filterPointInTimeFnMaker, 'filterPointInTimeFnMaker', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js');
	
	  __REACT_HOT_LOADER__.register(selectDailyViewData, 'selectDailyViewData', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/print/data.js');
	})();

	;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBasalSequences = getBasalSequences;
	exports.getTotalBasal = getTotalBasal;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datetime = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* getBasalSequences
	* @param {Array} basals - Array of preprocessed Tidepool basal objects
	*
	* @return {Array} Array of Arrays where each component Array is a sequence of basals
	*                 of the same subType to be rendered as a unit
	*/
	/*
	 * == BSD2 LICENSE ==
	 * Copyright (c) 2017, Tidepool Project
	 *
	 * This program is free software; you can redistribute it and/or modify it under
	 * the terms of the associated License, which is identical to the BSD 2-Clause
	 * License as published by the Open Source Initiative at opensource.org.
	 *
	 * This program is distributed in the hope that it will be useful, but WITHOUT
	 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
	 * FOR A PARTICULAR PURPOSE. See the License for more details.
	 *
	 * You should have received a copy of the License along with this program; if
	 * not, you can obtain one from Tidepool Project at tidepool.org.
	 * == BSD2 LICENSE ==
	 */
	
	function getBasalSequences(basals) {
	  var basalSequences = [];
	  var currentBasal = basals[0];
	  var seq = [basals[0]];
	
	  var idx = 1;
	  while (idx <= basals.length - 1) {
	    var nextBasal = basals[idx];
	    var basalTypeChange = nextBasal.subType !== currentBasal.subType;
	
	    if (basalTypeChange || currentBasal.discontinuousEnd || nextBasal.rate === 0) {
	      basalSequences.push(seq);
	      seq = [];
	    }
	
	    seq.push(nextBasal);
	    currentBasal = nextBasal;
	    ++idx;
	  }
	  basalSequences.push(seq);
	
	  return basalSequences;
	}
	
	/**
	 * getTotalBasal
	 * @param {Array} basals - Array of preprocessed Tidepool basal objects
	 *                         trimmed to fit within the timespan the total basal
	 *                         is being calculated over
	 *
	 * @return {Number} total basal insulin in units
	 */
	function getTotalBasal(basals) {
	  return _lodash2.default.reduce(basals, function (result, basal) {
	    return result + basal.rate * (basal.duration / _datetime.ONE_HR);
	  }, 0);
	}
	;
	
	(function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getBasalSequences, 'getBasalSequences', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/basal.js');
	
	  __REACT_HOT_LOADER__.register(getTotalBasal, 'getTotalBasal', '/Users/clintbeacock/Sites/tidepool/viz/src/utils/basal.js');
	})();

	;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(64);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../node_modules/postcss-loader/index.js!./colors.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../node_modules/postcss-loader/index.js!./colors.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** index.js
 **/